(function() {
  'use strict';

  var baseModules = [
      'ngSanitize',
      'ui.router',
      'ngAnimate',
      'ngLocale',
      'ngCookies',
      'ngMaterial',
      'textAngular',
      'Devise',
      'angularFileUpload',
      'underscore',
      'environment',
      'chart.js',
      'permission.ui',
      'ngMessages',
      'ngAria',
      'pascalprecht.translate',
      'dndLists',
      'colorpicker'
    ],
    loadModules = ['asyncLoaderConfig'];

  if (window.Raven && window.Raven.isSetup()) {
    baseModules.push('ngRaven');
    loadModules.push('ngRaven');
  }

  angular.module('quintessenceAngular', baseModules);

  angular.module('asyncLoaderConfig', ['underscore']);

  angular.module('launcherModule', loadModules);
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('HistoryChangesPartnerFeesController', HistoryChangesPartnerFeesController);

  HistoryChangesPartnerFeesController.$inject = [
    '$state',
    '$stateParams',
    'AdminPartnersFeesApi',
    'PartnersFeesHistoryChangesApi',
    '_',
    'outputErrors',
    'moment',
    'toastsApi'
  ];

  function HistoryChangesPartnerFeesController(
    $state,
    $stateParams,
    AdminPartnersFeesApi,
    PartnersFeesHistoryChangesApi,
    _,
    outputErrors,
    moment,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();
    vm.history_item = {};
    vm.startDate = null;
    vm.columns = [];

    PartnersFeesHistoryChangesApi.getItem($stateParams.partnerId, $stateParams.id, $stateParams.merchantId).then(
      function(response) {
        var data = response.data.admin_fee;

        vm.history_item.feeColumn = data.count_from;
        vm.history_item.date = data.date;
        vm.history_item.limit = data.percent;
      },
      function() {
        toastsApi.toastError();
      }
    );

    AdminPartnersFeesApi.getOptions($stateParams.partnerId, $stateParams.merchantId).then(
      function(response) {
        var data = response.data;

        if (data.date) {
          vm.startDate = moment(data.date, 'YYYY-MM-DD')
            .add(1, 'month')
            .toDate();
        }
        vm.columns = data.count_from;
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.saveHistory = function() {
      return PartnersFeesHistoryChangesApi.saveItem(
        $stateParams.partnerId,
        $stateParams.id,
        $stateParams.merchantId,
        vm.history_item
      ).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.back = function() {
      $state.go('partners.settings.fees');
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPartnersFeesController', AdminPartnersFeesController);

  AdminPartnersFeesController.$inject = [
    '$scope',
    '$stateParams',
    'AdminPartnersFeesApi',
    '_',
    'outputErrors',
    'moment',
    'tabsApi',
    'merchantStore',
    'toastsApi'
  ];

  function AdminPartnersFeesController(
    $scope,
    $stateParams,
    AdminPartnersFeesApi,
    _,
    outputErrors,
    moment,
    tabsApi,
    merchantStore,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.params = {limit: null, date: null, feeColumn: ''};
    vm.errors = outputErrors.createNew();
    vm.startDate = null;
    vm.columns = [];
    vm.tabs = tabsApi.getTabsByName('partners_settings');

    vm.optionsChange = {
      typeChanges: 'partner_fees',
      edit_state: 'partners.settings.history_changes_partner_fees',
      params: {
        itemId: $stateParams.partnerId
      },
      permissions: {
        change: 'api2.admin.adminfeescontroller.edit',
        remove: 'api2.admin.adminfeescontroller.delete'
      }
    };

    vm.updateMerchantId = function() {
      vm.optionsChange.params.merchantId = merchantStore.getCurrentMerchantId();
    };

    vm.clearForm = function() {
      vm.params.feeColumn = '';
      vm.params.limit = null;
      vm.params.date = null;
    };

    vm.getFeesParams = function() {
      AdminPartnersFeesApi.getFeesParams($stateParams.partnerId).then(
        function(response) {
          vm.tabs.setTabAdditionalData('fees', {historyList: response.data.list});
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getOptions = function() {
      AdminPartnersFeesApi.getOptions($stateParams.partnerId).then(
        function(response) {
          var data = response.data;

          if (data.date) {
            vm.startDate = moment(data.date, 'YYYY-MM-DD')
              .add(1, 'month')
              .toDate();
          }
          vm.columns = data.count_from;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.saveParams = function() {
      return AdminPartnersFeesApi.createFeesParams($stateParams.partnerId, vm.params).then(
        function() {
          vm.clearForm();
          vm.getFeesParams();
          toastsApi.toastCreateSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.getFeesParams();
    vm.getOptions();
    vm.updateMerchantId();

    vm.tabs.setTabAdditionalData('fees', {optionsChange: vm.optionsChange});
    vm.tabs.setTabSubmitFunction('fees', vm.saveParams);

    $scope.$on('$changeMerchantSuccess', function() {
      vm.getFeesParams();
      vm.getOptions();
      vm.clearForm();
      vm.updateMerchantId();
      vm.tabs.setTabAdditionalData('fees', {historyList: null, optionsChange: vm.optionsChange});
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('PartnerTrackerSettingsController', PartnerTrackerSettingsController);

  PartnerTrackerSettingsController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'PartnerTrackerSettingsApi',
    '_',
    'outputErrors',
    'merchantStore',
    'permissionsManager',
    'toastsApi'
  ];

  function PartnerTrackerSettingsController(
    $scope,
    $state,
    $stateParams,
    PartnerTrackerSettingsApi,
    _,
    outputErrors,
    merchantStore,
    permissionsManager,
    toastsApi
  ) {
    var vm = this,
      today = new Date();

    vm.translate_key = 'AdminPartners';
    vm.current_tracker = {};
    vm.errors = outputErrors.createNew();
    vm.editPermit = permissionsManager.checkPermission('api2.admin.historyoftrackerschangescontroller.edit');

    vm.optionsChange = {
      typeChanges: 'trackers',
      edit_state: 'partners.settings.settings_tracker_conditions.history_changes_trackers',
      params: {},
      permissions: {
        change: 'api2.admin.historyoftrackerschangescontroller.edit',
        remove: 'api2.admin.historyoftrackerschangescontroller.delete'
      }
    };

    vm.back = function() {
      $state.go('partners.settings.trackers');
    };

    vm.updateMerchantId = function() {
      vm.optionsChange.params.merchantId = merchantStore.getCurrentMerchantId();
    };

    vm.saveTracker = function() {
      vm.editTrackerForm.$setSubmitted();

      if (vm.editTrackerForm.$invalid) {
        return;
      }

      var tracker = _.omit(vm.current_tracker, 'history_of_trackers_changes');

      return PartnerTrackerSettingsApi.updateTrackerCondition($stateParams.partnerId, tracker).then(
        function(response) {
          vm.current_tracker.history_of_trackers_changes = response.data.history_of_trackers_changes;
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.getData = function() {
      PartnerTrackerSettingsApi.getTracker($stateParams.partnerId, $stateParams.trackerCode).then(
        function(response) {
          var data = response.data;

          vm.conditions = data.conditions;
          vm.current_tracker = data.tracker;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getData();
    vm.updateMerchantId();

    $scope.$on('trackerConditionHistoryChanged', function() {
      vm.getData();
    });

    $scope.$on('$changeMerchantSuccess', function() {
      vm.getData();
      vm.updateMerchantId();
    });

    vm.minSelectDate = new Date(today.setDate(today.getDate() + 1));
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminPartnersTrackersListController', AdminPartnersTrackersListController);

  AdminPartnersTrackersListController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'PartnerTrackerSettingsApi',
    '$mdDialog',
    '_',
    'outputErrors',
    'tableEngine',
    'tabsApi',
    'toastsApi',
    'permissionsManager',
    'moment'
  ];

  function AdminPartnersTrackersListController(
    $scope,
    $state,
    $stateParams,
    PartnerTrackerSettingsApi,
    $mdDialog,
    _,
    outputErrors,
    tableEngine,
    tabsApi,
    toastsApi,
    permissionsManager,
    moment
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();
    vm.parentTable = tableEngine.getTableByName('partners');
    vm.tabs = tabsApi.getTabsByName('partners_settings');
    vm.editPermit = permissionsManager.checkPermission('api2.admin.historyoftrackerschangescontroller.edit');

    vm.createModal = function(data, ev) {
      return $mdDialog.show({
        controller: 'AdminSaveTrackerModalController',
        controllerAs: '$ctrl',
        templateUrl: 'app/admin/partners/settings/trackers/partials/create_tracker.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: data || {}
      });
    };

    vm.addTracker = function(ev) {
      var params = {
        shortcodePart: 'create_tracker',
        partnerId: $stateParams.partnerId,
        tracker: {}
      };

      vm.createModal(params, ev).then(function() {
        vm.table.pagination();
        vm.parentTable.pagination();
      });
    };

    vm.editDescription = function(tracker, ev) {
      var params = {
        shortcodePart: 'edit_tracker',
        partnerId: $stateParams.partnerId,
        tracker: _.pick(tracker, 'id', 'description', 'tracker_code', 'assigning_at')
      };

      vm.createModal(params, ev).then(function() {
        vm.table.pagination();
      });
    };

    vm.editCondition = function(tracker) {
      $state.go('partners.settings.settings_tracker_conditions', {trackerCode: tracker.id});
    };

    vm.getDate = function(date) {
      return moment(date, 'YYYY-MM-DD')
        .add(1, 'day')
        .toDate();
    };

    vm.openReplacementDealsModal = function(data) {
      $mdDialog.show({
        controller: 'AdminBulkReplacementDealsModalController',
        controllerAs: '$ctrl',
        templateUrl: 'app/admin/partners/settings/trackers/partials/bulk_replacement_deals.html',
        parent: angular.element(document.body),
        targetEvent: null,
        clickOutsideToClose: true,
        bindToController: true,
        locals: data
      });
    };

    vm.bulkReplacementDeals = function(selectedItems, filterId, paginationParams) {
      PartnerTrackerSettingsApi.getConditions($stateParams.partnerId).then(
        function(response) {
          var data = response.data,
            params = {
              allConditions: data.conditions,
              // Earliest selectable date must be inside the current merchant's still-open month, not a
              // hardcoded "1 month back" guess (2026-08-25: that let the picker offer dates the backend
              // silently rejected once the target month had actually closed for this merchant/brand).
              // Falls back to the old 1-month rule only when the merchant has no closed month yet at all.
              boundaryDate: data.last_closed_month
                ? moment(data.last_closed_month, 'YYYY.MM.DD')
                    .add(1, 'month')
                    .startOf('month')
                    .toDate()
                : moment()
                    .subtract(1, 'month')
                    .startOf('month')
                    .toDate(),
              partnerId: $stateParams.partnerId,
              selectedItems: selectedItems,
              filterId: filterId,
              paginationParams: paginationParams,
              format: 'DD.MM.YYYY',
              modelFormat: 'DD.MM.YYYY'
            };

          vm.openReplacementDealsModal(params);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.tableFiliterColumns = [
      {
        name: 'merchant_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'tracker_code',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'assigning_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'description',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'type_of_transaction',
        type: 'checkbox',
        display: true,
        empty: true,
        disable_search: true,
        locales: {
          translate_key: 'AdminConditions',
          shortcode: 'main_params.form.'
        }
      },
      {
        name: 'hotc_condition_title',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'hotc_condition_id',
        type: 'compare',
        display: true,
        empty: true
      }
    ];

    vm.table = tableEngine.getOrCreate({
      api: PartnerTrackerSettingsApi,
      name: 'partner_tracker_list',
      mobile: {
        defaultColumns: ['tracker_code']
      },
      buttons: {
        url: 'app/admin/partners/settings/trackers/partials/table.html',
        methods: {
          editDescription: vm.editDescription,
          editCondition: vm.editCondition
        }
      },
      params: {
        data: {
          additional_options: {
            partnerId: $stateParams.partnerId
          }
        }
      },
      column_checkboxes: {
        enable: true,
        actions: [
          {
            name: 'bulkReplacementDeals',
            action: vm.bulkReplacementDeals,
            display: vm.editPermit,
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'settings_trackers.bulk_replacement_deals'
            }
          }
        ]
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/admin/affiliates/trackers',
        actionForFilter: 'list',
        filterName: 'tracker'
      }
    });

    if (!vm.table.isRendered()) {
      PartnerTrackerSettingsApi.trackers_list($stateParams.partnerId).then(
        function(response) {
          var data = response.data,
            opts = {
              locale_key: data.locale_key,
              columns: data.columns_for_display_data,
              list: data.list,
              total_pages: data.total_pages,
              total_entries: data.total_entries,
              start_row_num: data.start_row_num,
              end_row_num: data.end_row_num
            };

          vm.table.update(opts);
          vm.table.addOptionsToColumn('type_of_transaction', {
            localizied: true,
            locales: {
              translate_key: 'AdminConditions',
              shortcode: 'main_params.form.{{shortcode_part}}',
              shortcode_part_in_value: true
            }
          });
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });

    vm.tabs.setTabSubmitFunction('trackers', vm.addTracker);
    vm.tabs.setUpTable('trackers', vm.table);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminSaveTrackerModalController', AdminSaveTrackerModalController);

  AdminSaveTrackerModalController.$inject = [
    '$mdDialog',
    'PartnerTrackerSettingsApi',
    'outputErrors',
    'toastsApi',
    '_'
  ];

  function AdminSaveTrackerModalController($mdDialog, PartnerTrackerSettingsApi, outputErrors, toastsApi, _) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.hide = function(data) {
      return $mdDialog.hide(data);
    };

    vm.handleErrors = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }
      vm.errors.inputErrors({description: _.flatten(_.values(errors))});
    };

    vm.saveTracker = function() {
      vm.saveTrackerForm.$setSubmitted();

      if (vm.saveTrackerForm.$invalid) {
        return;
      }

      return PartnerTrackerSettingsApi.saveTracker(vm.partnerId, vm.tracker).then(
        function(response) {
          toastsApi.toastCreateSuccess();
          return vm.hide(response.data || {});
        },
        function(response) {
          vm.handleErrors(response.data && response.data.errors);
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('HistoryChangesTrackersController', HistoryChangesTrackersController);

  HistoryChangesTrackersController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'historyChanges',
    '_',
    'outputErrors',
    'toastsApi'
  ];

  function HistoryChangesTrackersController($scope, $state, $stateParams, historyChanges, _, outputErrors, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();

    vm.save_history = function() {
      historyChanges.update_trackers(vm.history_item, $stateParams.merchantId).then(
        function() {
          toastsApi.toastEditSuccess();
          $scope.$emit('trackerConditionHistoryChanged');
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError(toastsApi.prepareErrors(response));
        }
      );
    };

    vm.back = function() {
      $state.go('^');
    };

    historyChanges.edit_trackers($stateParams.id, $stateParams.merchantId).then(
      function(response) {
        vm.conditions = response.data.conditions;
        vm.history_item = response.data.history_of_trackers_change;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminBulkReplacementDealsModalController', AdminBulkReplacementDealsModalController);

  AdminBulkReplacementDealsModalController.$inject = [
    '$scope',
    '$mdDialog',
    'PartnerTrackerSettingsApi',
    'outputErrors',
    'toastsApi',
    '_',
    'tableEngine',
    'moment'
  ];

  function AdminBulkReplacementDealsModalController(
    $scope,
    $mdDialog,
    PartnerTrackerSettingsApi,
    outputErrors,
    toastsApi,
    _,
    tableEngine,
    moment
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('partner_tracker_list');
    vm.params = {};

    // CPA (and hybrid, which carries a CPA component) deals must be effective from the 1st of the month
    // (Eddie 2026-06-29): a mid-month effective date breaks CPA qualification (the monthly qualifying
    // window loses the pre-deal days). So when such a deal is selected we snap the chosen date to the 1st.
    vm.selectedConditionIsCpa = function() {
      var condition = _.find(vm.allConditions, {id: vm.params.condition_id});
      return !!condition && ['cpa', 'hybrid'].indexOf(condition.type_of_transaction) !== -1;
    };

    vm.snapDateForCpa = function() {
      if (!vm.params.date || !vm.selectedConditionIsCpa()) {
        return;
      }
      var format = vm.modelFormat || 'DD.MM.YYYY';
      vm.params.date = moment(vm.params.date, format)
        .startOf('month')
        .format(format);
    };

    // Snap live as soon as either the deal or the date changes (idempotent — converges in one digest).
    $scope.$watch(
      function() {
        return [vm.params.condition_id, vm.params.date].join('|');
      },
      function() {
        vm.snapDateForCpa();
      }
    );

    vm.closeModal = function() {
      $mdDialog.cancel();
    };

    vm.hide = function() {
      $mdDialog.hide();
    };

    vm.isBackdate = function() {
      if (!vm.params.date) {
        return false;
      }
      var format = vm.modelFormat || 'DD.MM.YYYY',
        date = moment(vm.params.date, format, true);
      return date.isValid() && date.isBefore(moment().startOf('day'));
    };

    vm.save = function() {
      vm.snapDateForCpa(); // guarantee the 1st-of-month rule even if the watch hasn't fired yet

      if (!vm.isBackdate()) {
        return vm.applyBulkReplace();
      }

      // Backdating (Eddie 2026-06-29, Q1): warn that this affiliate's scheduled (future-dated) deal changes
      // will be cleared, and require explicit confirmation before proceeding.
      // Without an explicit parent, $mdDialog falls back to $rootElement (#app), which is
      // position:static, so its backdrop renders behind the already-open bulk-replace dialog
      // (which is parented to document.body) instead of on top of it (Eddie 2026-07-07 repro).
      var confirm = $mdDialog
        .confirm()
        .parent(angular.element(document.body))
        .multiple(true)
        .title('Backdate deal')
        .textContent(
          'Backdating will delete the scheduled (future-dated) deal changes for the selected trackers. Continue?'
        )
        .ok('Yes, continue')
        .cancel('Cancel');

      return $mdDialog.show(confirm).then(function() {
        return vm.applyBulkReplace();
      }, angular.noop);
    };

    vm.applyBulkReplace = function() {
      var params = {
        conditionId: vm.params.condition_id,
        date: vm.params.date,
        selectedItems: vm.selectedItems,
        filterId: vm.filterId,
        paginationParams: vm.paginationParams
      };

      return PartnerTrackerSettingsApi.bulkReplaceDeals(vm.partnerId, params).then(
        function() {
          toastsApi.toastSuccess();
          vm.table.pagination();
          vm.hide();
        },
        function(response) {
          var errors = response.data && response.data.errors;

          if (_.isEmpty(errors)) {
            return toastsApi.toastError(_.has(response.data, 'base') ? {locale: _.first(response.data.base)} : null);
          }
          vm.errors.inputErrors(errors);
          toastsApi.toastError({locale: _.first(_.flatten(_.values(errors)))});
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('PartnerSubaffiliateConditionController', PartnerSubaffiliateConditionController);

  PartnerSubaffiliateConditionController.$inject = [
    '$scope',
    '$stateParams',
    'PartnerSubaffiliateConditionApi',
    '_',
    'outputErrors',
    'permissionsManager',
    'tabsApi',
    'merchantStore',
    'toastsApi'
  ];

  function PartnerSubaffiliateConditionController(
    $scope,
    $stateParams,
    PartnerSubaffiliateConditionApi,
    _,
    outputErrors,
    permissionsManager,
    tabsApi,
    merchantStore,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();
    vm.current_history_item = {affiliate_id: $stateParams.partnerId};
    vm.permCreateItem = permissionsManager.checkPermission('api2.admin.historyofsubaffiliateschangescontroller.create');
    vm.tabs = tabsApi.getTabsByName('partners_settings');

    vm.optionsChange = {
      typeChanges: 'subaffiliate_condition',
      edit_state: 'partners.settings.history_changes_subaffiliate_condition',
      params: {},
      permissions: {
        change: 'api2.admin.historyofsubaffiliateschangescontroller.edit',
        remove: 'api2.admin.historyofsubaffiliateschangescontroller.delete'
      }
    };

    vm.updateMerchantId = function() {
      vm.optionsChange.params.merchantId = merchantStore.getCurrentMerchantId();
    };

    vm.saveSubaffiliateCondition = function() {
      return PartnerSubaffiliateConditionApi.createCondition(vm.current_history_item).then(
        function(response) {
          vm.tabs.setTabAdditionalData('subaffiliate_condition', {
            historyList: response.data.history_of_subaffiliates_changes
          });
          toastsApi.toastCreateSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.initialize = function() {
      PartnerSubaffiliateConditionApi.conditionSettings($stateParams.partnerId).then(
        function(response) {
          var data = response.data;

          vm.conditions_list = data.subaffiliate_conditions;
          vm.current_history_item.subaffiliate_condition_id = data.subaffiliate_condition.id;
          vm.tabs.setTabAdditionalData('subaffiliate_condition', {
            historyList: data.subaffiliate_condition.history_of_subaffiliates_change
          });
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.initialize();
    vm.updateMerchantId();

    vm.tabs.setTabAdditionalData('subaffiliate_condition', {optionsChange: vm.optionsChange});

    if (vm.permCreateItem) {
      vm.tabs.setTabSubmitFunction('subaffiliate_condition', vm.saveSubaffiliateCondition);
    }

    $scope.$on('$changeMerchantSuccess', function() {
      vm.initialize();
      vm.updateMerchantId();
      vm.tabs.setTabAdditionalData('subaffiliate_condition', {historyList: null, optionsChange: vm.optionsChange});
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('HistoryChangesConditionController', HistoryChangesConditionController);

  HistoryChangesConditionController.$inject = [
    '$state',
    '$stateParams',
    '_',
    'PartnerSubaffiliateConditionApi',
    'outputErrors',
    'toastsApi'
  ];

  function HistoryChangesConditionController(
    $state,
    $stateParams,
    _,
    PartnerSubaffiliateConditionApi,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();

    PartnerSubaffiliateConditionApi.getCondition($stateParams.id, $stateParams.merchantId).then(
      function(response) {
        var data = response.data;

        vm.history_item = data.history_of_subaffiliates_change;
        vm.conditions_list = data.subaffiliate_conditions;
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.save_history = function() {
      PartnerSubaffiliateConditionApi.updateCondition(vm.history_item, $stateParams.merchantId).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.back = function() {
      $state.go('partners.settings.subaffiliate_condition');
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('PartnerMainDataController', PartnerMainDataController);

  PartnerMainDataController.$inject = [
    '$stateParams',
    'PartnerTrackerSettingsApi',
    'outputErrors',
    'tabsApi',
    'toastsApi'
  ];

  function PartnerMainDataController($stateParams, PartnerTrackerSettingsApi, outputErrors, tabsApi, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();
    vm.tabs = tabsApi.getTabsByName('partners_settings');

    vm.saveMainData = function() {
      PartnerTrackerSettingsApi.common_update(
        $stateParams.partnerId,
        vm.affiliate.max_count_trackers,
        vm.affiliate.condition_id
      ).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('main_data', vm.saveMainData);

    PartnerTrackerSettingsApi.tracker_settings($stateParams.partnerId).then(
      function(response) {
        var data = response.data;

        vm.affiliate = data.affiliate;
        vm.conditions = data.conditions;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('virtualSelect', virtualSelect);

  virtualSelect.$inject = ['$rootScope', '$timeout', '$filter', '$translate', '$mdTranslate', '$interpolate', '_'];

  function virtualSelect($rootScope, $timeout, $filter, $translate, $mdTranslate, $interpolate, _) {
    return {
      restrict: 'E',
      scope: {
        list: '=',
        options: '=?',
        errors: '=?',
        name: '@',
        saveProp: '@',
        showProp: '@',
        ngModel: '=',
        ngChange: '&?',
        ngDisabled: '=?',
        ngRequired: '=?',
        ngReadonly: '=?'
      },
      template: function($element) {
        var label = $element[0].querySelector('label') || {},
          content = $element[0].querySelector('virtual-item-content') || {};

        return [
          '<div class="virtual-select-wrap">',
          '<md-input-container class="md-block">',
          label.outerHTML || '',
          '<input flex input-errors md-no-asterisk type="text" ng-change="select.disableUserInput()" ng-model="select.selected_value" name="{{::name}}" ng-click="select.toggle()" ng-required="ngRequired" ng-readonly="ngReadonly" ng-disabled="ngDisabled" autocomplete="off">',
          '<span class="select-corner" ng-click="select.toggle()" ng-if="!ngReadonly"></span>',
          '<md-error-messages errors="errors" input-name="{{::name}}"></md-error-messages>',
          '</md-input-container>',
          '<div class="virtual-select-content" ng-if="select.isOpen" ng-class="{\'is-opened\': select.isOpen, \'with-search\': select.virtual_repeat.getLength() > 5 || select.search_term}">',
          '<div class="select-header" ng-if="select.virtual_repeat.getLength() > 5 || select.search_term"}">',
          '<md-input-container md-no-float class="md-block">',
          '<md-icon><i class="fa fa-search"></i></md-icon>',
          '<input type="text" placeholder="{{\'search_placeholder\' | mdTranslate: select.translate_key}}" ng-model="select.search_term" ng-change="select.searching()" autocomplete="off">',
          '<md-button ng-if="select.search_term" class="md-icon-button" ng-click="select.clearSearchTerm()"><img src="assets/images/cross.png"></md-button>',
          '</md-input-container>',
          '</div>',
          '<div class="md-content" layout="row">',
          '<md-virtual-repeat-container flex content-height-control class="virtual-select no-custom-scroll" md-top-index="select.selected_index">',
          '<div md-ink-ripple="#1088DE" md-on-demand="true" md-virtual-repeat="item in select.virtual_repeat" class="repeated-item" ng-click="select.select(item)" ng-class="{\'selected\': saveProp ? (item[saveProp] === select.selected_item[saveProp]) : (item === select.selected_item)}">',
          '<span class="md-text">',
          content.outerHTML || '',
          '</span>',
          '</div>',
          '</md-virtual-repeat-container>',
          '<div class="no-matches" ng-if="select.virtual_repeat.noMatches()">',
          '<md-translate key="::select.translate_key" shortcode="\'no_matches\'" translate-values="{search_term: select.search_term}"></md-translate>',
          '</div>',
          '<div class="no-data" ng-if="!select.virtual_repeat.getLength() && !select.search_term">',
          '<md-translate key="::select.translate_key" shortcode="\'no_data\'"></md-translate>',
          '</div>',
          '</div>',
          '</div>',
          '<div class="virtual-select-overlay" ng-click="select.toggle()" ng-if="select.isOpen"></div>',
          '</div>'
        ].join('');
      },
      controllerAs: 'select',
      controller: function($scope) {
        var vm = this,
          opts = {
            search_in_translate: false,
            selective_translate: false,
            translate_key: '',
            shortcode: '',
            translate_namespace: '',
            prop_for_shortcode: '',
            prop_for_value: ''
          },
          translteListener;

        vm.options = _.extend({}, opts, $scope.options || {});
        vm.translate_key = 'SelectWithSearch';
        vm.isOpen = false;
        vm.selected_item = null;
        vm.selected_value = '';
        vm.selected_index = 0;

        vm.toggle = function() {
          if ($scope.ngDisabled || $scope.ngReadonly) {
            return;
          }

          vm.setSelectedIndex();
          vm.isOpen = !vm.isOpen;

          if (!vm.isOpen) {
            vm.clearSearchTerm();
          }
        };

        vm.disableUserInput = function() {
          vm.setShowValue();
        };

        vm.translateViewValue = function() {
          if (!vm.selected_item) {
            return;
          }

          var shortcode_part =
              $scope.showProp && _.isObject(vm.selected_item) ? vm.selected_item[$scope.showProp] : vm.selected_item,
            shortcode = vm.options.shortcode
              ? $interpolate(vm.options.shortcode)({part: shortcode_part})
              : shortcode_part;

          return vm.options.translate_key
            ? $mdTranslate.instant(vm.options.translate_key, shortcode)
            : $translate.instant(vm.options.translate_namespace + shortcode_part);
        };

        vm.setSaveValue = function() {
          $scope.ngModel =
            $scope.saveProp && _.isObject(vm.selected_item) ? vm.selected_item[$scope.saveProp] : vm.selected_item;
        };

        vm.setShowValue = function() {
          var isObj = _.isObject(vm.selected_item),
            ifShowProp = $scope.showProp && isObj ? vm.selected_item[$scope.showProp] : vm.selected_item;

          vm.selected_value = vm.options.search_in_translate ? vm.translateViewValue() : ifShowProp;

          if (isObj && vm.selected_item.locale) {
            vm.selected_value = $translate.instant(vm.selected_item.locale);
          } else if (isObj && vm.selected_item.translate_key && vm.selected_item.shortcode) {
            vm.selected_value = $mdTranslate.instant(vm.selected_item.translate_key, vm.selected_item.shortcode);
          }
        };

        vm.getSelectedItem = function(value) {
          return _.find($scope.list, function(v) {
            // eslint-disable-next-line eqeqeq
            return $scope.saveProp ? v[$scope.saveProp] == value : v === value;
          });
        };

        vm.setSelectedIndex = function() {
          vm.selected_index = _.indexOf($scope.list, vm.selected_item);
        };

        vm.clearSearchTerm = function() {
          vm.search_term = '';
          vm.searching();
        };

        vm.searching = function() {
          vm.virtual_repeat.filtering(vm.search_term);
        };

        vm.select = function(item) {
          vm.selected_item = item;
          vm.setSaveValue();
          vm.toggle();
          vm.ngChange();
        };

        vm.ngChange = function() {
          if ($scope.ngChange) {
            $timeout(function() {
              $scope.ngChange();
            }, 0);
          }
        };

        vm.setValue = function() {
          vm.selected_item = vm.getSelectedItem($scope.ngModel);
          vm.setSelectedIndex();
          vm.setShowValue();
        };

        vm.virtual_repeat = {
          items: $scope.list || [],
          refresh: function(newList) {
            this.items = newList;
          },
          filtering: function(search_text) {
            var query = {};

            if (vm.options.prop_for_value) {
              query[vm.options.prop_for_value] = search_text;
            }

            this.items =
              vm.options.search_in_translate || vm.options.selective_translate
                ? $filter('search')($scope.list || [], search_text, vm.options)
                : $filter('filter')($scope.list || [], vm.options.prop_for_value ? query : search_text);
          },
          getItemAtIndex: function(index) {
            return this.items[index];
          },
          getLength: function() {
            return this.items.length;
          },
          noMatches: function() {
            return !this.getLength() && vm.search_term;
          }
        };

        $scope.$watch('list', function(newValue) {
          if (_.isArray(newValue)) {
            vm.virtual_repeat.refresh(newValue);
            vm.setValue();
          }
        });

        $scope.$watch('ngModel', function() {
          vm.setValue();
        });

        $scope.$watch('options', function(newValue) {
          vm.options = _.extend({}, opts, newValue || {});
        });

        translteListener = $rootScope.$on('$translateChangeEnd', function() {
          $timeout(function() {
            vm.setShowValue();
          }, 0);
        });

        $scope.$on('$destroy', function() {
          translteListener();
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        select_with_search: ['search_placeholder||search_placeholder', 'no_matches||no_matches', 'no_data||no_data']
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('SelectWithSearch', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('contentHeightControl', contentHeightControl);

  contentHeightControl.$inject = [];

  function contentHeightControl() {
    return {
      restrict: 'A',
      require: '^mdVirtualRepeatContainer',
      link: function(scope, element, attr, ctrl) {
        scope.$watch(
          function() {
            return ctrl.scrollSize;
          },
          function(value) {
            element.css('height', value + 'px');
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('uploadFile', uploadFile);

  uploadFile.$inject = ['$mdDialog'];

  function uploadFile($mdDialog) {
    var uploadFile = {};

    uploadFile.openDialog = function(params) {
      var dialog_params = {
        controller: 'UploadFileController',
        controllerAs: 'uploadCtrl',
        templateUrl: 'app/components/shared/upload_file/upload_file.html',
        parent: angular.element(document.body),
        targetEvent: undefined,
        clickOutsideToClose: true,
        bindToController: true,
        locals: {}
      };

      dialog_params = angular.extend(dialog_params, params || {});

      return $mdDialog.show(dialog_params);
    };

    return uploadFile;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('UploadFileController', UploadFileController);

  UploadFileController.$inject = [
    '$scope',
    '$mdDialog',
    'envService',
    'outputErrors',
    'FileUploader',
    '$cookies',
    '$mdTranslate',
    '_',
    'Preloader',
    '$interpolate',
    'localesStorage',
    '$q'
  ];

  function UploadFileController(
    $scope,
    $mdDialog,
    envService,
    outputErrors,
    FileUploader,
    $cookies,
    $mdTranslate,
    _,
    Preloader,
    $interpolate,
    localesStorage,
    $q
  ) {
    var vm = this,
      urlBase = envService.read('apiUrl');

    vm.translate_key = 'UploadFile';
    vm.errors = outputErrors.createNew();
    vm.file_item = null;
    vm.accept_formats = _.pluck(vm.file_formats, 'format').join(', ');
    vm.upload_params = vm.upload_params || {};
    vm.upload_params.url = vm.upload_params.url || '';
    vm.format_for_locale = vm.format_for_locale || '';
    vm.fallbackLanguage = localesStorage.getFallbackLocale();
    vm.inputLocale = $mdTranslate.instant(vm.translate_key, 'upload_file.choose_file', {format: vm.format_for_locale});
    vm.fileUploadDeferred = {};
    vm.errorsData = null;

    if (vm.inputLocale === 'common.upload_file.choose_file') {
      vm.inputLocale = $mdTranslate.instant(
        vm.translate_key,
        'upload_file.choose_file',
        {format: vm.format_for_locale},
        vm.fallbackLanguage
      );
    }

    vm.input_placeholder = $interpolate(vm.inputLocale)({format: vm.format_for_locale});

    vm.getTranslateDefault = function(shortcode, translateKey) {
      return $mdTranslate.instant(translateKey || vm.translate_key, shortcode, null, vm.fallbackLanguage);
    };

    vm._upload_params = {
      queueLimit: 1,
      withCredentials: true,
      // removeAfterUpload:  true,
      formData: [],
      headers: {},
      filters: []
    };

    angular.extend(vm._upload_params, vm.upload_params);

    vm._upload_params.url = urlBase + vm.upload_params.url;
    vm._upload_params.headers['x-xsrf-token'] = $cookies.get('XSRF-TOKEN-X');
    vm._upload_params.filters.push({
      name: 'file_formats',
      fn: function(file) {
        if (vm.fileExtension) {
          return _.last(file.name.split('.')) === vm.fileExtension;
        }
        // if (vm.file_formats) {
        //   if (_.findWhere(vm.file_formats, {type: file.type}))
        //     return true;
        //   else
        //     return false;
        // }

        return true;
      }
    });

    vm.uploader = new FileUploader(vm._upload_params);

    vm.upload = function() {
      if (!vm.uploader.queue.length) {
        return;
      }

      vm.fileUploadDeferred = $q.defer();
      Preloader.openPreloaderForce();
      vm.uploader.uploadAll();

      return vm.fileUploadDeferred.promise;
    };

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.hide = function(data) {
      return $mdDialog.hide(data);
    };

    vm.remove_file = function(file) {
      vm.errors.clearError('file');
      vm.file_item = null;
      file.remove();
    };

    vm.uploader.onErrorItem = function(fileItem, res) {
      vm.file_item = fileItem;

      if (res && res.errors) {
        vm.errorsData = _.flatten(_.values(res.errors));
      }
    };

    vm.uploader.onCompleteAll = function() {
      Preloader.closePreloaderForce();
      vm.fileUploadDeferred.resolve();

      if (vm.file_item) {
        if (!_.isEmpty(vm.errorsData)) {
          vm.errors.inputErrors({file: vm.errorsData});
        } else {
          vm.errors.inputErrors({file: [$mdTranslate.instant(vm.translate_key, 'upload_file.errors_in_file')]});
        }
      } else {
        vm.uploader.clearQueue();
        vm.hide();
      }
    };

    vm.uploader.onAfterAddingFile = function() {
      vm.errors.clearError('file');
    };

    $scope.$on('$destroy', function() {
      vm.uploader.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        upload_file: [
          'title||upload_file.title',
          'choose_file||upload_file.choose_file',
          'cancel||upload_file.cancel',
          'upload||upload_file.upload',
          'errors_in_file||upload_file.errors_in_file'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('UploadFile', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('stopEvent', stopEvent);

  stopEvent.$inject = [];

  function stopEvent() {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        function stop_propagation(ev) {
          ev.stopPropagation();
        }

        element[0].addEventListener(attr.eventName, stop_propagation);

        scope.$on('$destroy', function() {
          element[0].removeEventListener(attr.eventName, stop_propagation);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('selectWithSearch', selectWithSearch);

  selectWithSearch.$inject = ['$timeout', '_'];

  function selectWithSearch($timeout, _) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        list: '=',
        options: '=?',
        errors: '=?',
        name: '@',
        saveProp: '@',
        setKeyAsValue: '=?',
        ngModel: '=',
        ngDisabled: '=?',
        ngChange: '&?',
        ngClass: '=?',
        ngRequired: '=?',
        mdContainerClass: '@'
      },
      templateUrl: 'app/components/shared/select_with_search/select_with_search.html',
      controllerAs: 'select',
      controller: function($scope) {
        var vm = this,
          opts = {
            find_in_key: true,
            search_in_translate: false,
            substitute_key: false,
            key_as_shortcode_part: false,
            translate_key: '',
            translate_namespace: '',
            shortcode: '',
            prop_for_shortcode: '',
            prop_for_value: ''
          };

        vm.options = _.extend({}, opts, $scope.options || {});
        vm.translate_key = 'SelectWithSearch';
        vm.search_term = '';
        vm.mdContainerClass = ($scope.mdContainerClass || '') + ' select-with-search-header';

        vm.ngChange = function() {
          if ($scope.ngChange) {
            $timeout(function() {
              $scope.ngChange();
            }, 0);
          }
        };

        vm.clearSearchTerm = function() {
          vm.search_term = '';
        };

        vm.getLength = function() {
          return _.size($scope.list);
        };

        vm.noMatches = function() {
          return !_.size($scope.filtered_list) && vm.search_term && vm.getLength();
        };

        $scope.$watch('options', function(newValue) {
          vm.options = _.extend({}, opts, newValue || {});
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('mdOptionContent', mdOptionContent);

  mdOptionContent.$inject = [];

  function mdOptionContent() {
    return {
      restrict: 'E',
      scope: {
        options: '=?'
      },
      link: function(scope, element, attr, ctrls, transcludeFn) {
        transcludeFn(scope.$parent, function(clone) {
          element.append(clone);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('rowRestrict', rowRestrict);

  rowRestrict.$inject = [];

  function rowRestrict() {
    return {
      restrict: 'A',
      link: function(scope, elem, attrs) {
        var maxWidth = attrs.maxWidth || '100%',
          minWidth = attrs.minWidth;

        elem[0].style.maxWidth = maxWidth;

        if (minWidth) {
          elem[0].style.minWidth = minWidth;
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').provider('Preloader', Preloader);

  function Preloader() {
    var may_enable = ['anonym/permission/list', 'generate_report', 'download_report'],
      class_preloader = '.preloader-wrapper',
      element = angular.element(document.querySelector(class_preloader)),
      activation_class = 'activate',
      urls_circle = [],
      urls_linear = [],
      Preloader = {};

    Preloader.linear_preloader = {
      enable: false
    };

    Preloader.find = function(url) {
      var arr = [];
      angular.forEach(may_enable, function(v) {
        if (~url.indexOf(v)) {
          arr.push(v);
        }
      });
      return !!arr.length;
    };

    Preloader.openPreloader = function(config) {
      if (Preloader.find(config.url)) {
        urls_circle.push(config.url);
        element.addClass(activation_class);
      } else {
        urls_linear.push(config.url);
        Preloader.linear_preloader.enable = true;
      }
    };

    Preloader.closePreloader = function(config) {
      var index;

      if (Preloader.find(config.url)) {
        index = urls_circle.indexOf(config.url);

        if (~index) {
          urls_circle.splice(index, 1);
        }

        if (!urls_circle.length) {
          element.removeClass(activation_class);
        }
      } else {
        index = urls_linear.indexOf(config.url);

        if (~index) {
          urls_linear.splice(index, 1);
        }

        if (!urls_linear.length) {
          Preloader.linear_preloader.enable = false;
        }
      }
    };

    Preloader.openPreloaderForce = function() {
      element.addClass(activation_class);
    };

    Preloader.closePreloaderForce = function() {
      element.removeClass(activation_class);
    };

    this.$get = function() {
      return Preloader;
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('poweredByQ', poweredByQ);

  poweredByQ.$inject = [];

  function poweredByQ() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/shared/powered_by_q/powered_by_q.html'
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('navigationFactory', navigationFactory);

  navigationFactory.$inject = [];

  function navigationFactory() {
    var navigation = {};

    navigation.adminDashboard = {
      icon: 'fa fa-home',
      state: 'admin',
      shortcode: 'admin.home'
    };

    navigation.affiliateDashboard = {
      icon: 'fa fa-home',
      state: 'affiliate',
      shortcode: 'affiliate.home'
    };

    navigation.affiliateGuide = {
      icon: 'fa fa-book',
      state: 'affiliate_faq',
      shortcode: 'affiliate.affiliate_guide',
      permission: 'api2.affiliate.staticpagescontroller.faq'
    };

    navigation.adminMenu = [
      {
        icon: 'fa fa-users',
        shortcode: 'admin.partners',
        open: false,
        states: [
          {
            state: 'unconfirmed_partners',
            shortcode: 'admin.partners.unconfirmed_partners',
            permission: 'api2.admin.affiliatescontroller.unconfirmed_email'
          },
          {
            state: 'new_partners',
            shortcode: 'admin.partners.new_partners',
            budge: {
              data: 0
            },
            children: [
              'new_partners.partner_view',
              'new_partners.partner_view.main_data',
              'new_partners.partner_view.contact_information',
              'new_partners.partner_view.payment_information',
              'new_partners.partner_view.offer',
              'new_partners.accept_partner'
            ],
            permission: 'api2.admin.affiliatescontroller.pending_affiliates'
          },
          {
            state: 'partners',
            shortcode: 'admin.partners.partners_list',
            children: [
              'partners.profile',
              'partners.profile.main_data',
              'partners.profile.contact_information',
              'partners.profile.payment_information',
              'partners.profile.manual_subaffiliate',
              'partners.settings',
              'partners.settings.main_data',
              'partners.settings.trackers',
              'partners.settings.subaffiliate_condition',
              'partners.settings.fees',
              'partners.webhooks',
              'partners.webhooks.activity',
              'partners.webhooks.registration',
              'partners.webhooks.deposit',
              'partners.webhooks.settings',
              'partners.settings_tracker_conditions',
              'partners.history_changes_partner_fees',
              'partners.history_changes_trackers',
              'partners.history_changes_subaffiliate_condition'
            ],
            permission: 'api2.admin.affiliatescontroller.show'
          },
          {
            state: 'orders',
            shortcode: 'admin.partners.requests_history',
            children: [
              'orders.profile',
              'orders.profile.main_data',
              'orders.profile.contact_information',
              'orders.profile.payment_information',
              'orders.profile.offer'
            ],
            permission: 'api2.admin.affiliatescontroller.show'
          },
          {
            state: 'admin_webhooks_history',
            shortcode: 'admin.partners.admin_webhooks_history',
            children: ['admin_webhooks_history.details'],
            permission: 'api2.admin.requestscontroller.all'
          },
          {
            state: 'bulk_email_v2',
            shortcode: 'admin.partners.bulk_email_v2',
            children: ['bulk_email_v2_create', 'bulk_email_v2_edit'],
            permission: 'api2.admin.bulkemailcampaignscontroller.all'
          },
          {
            state: 'reports',
            shortcode: 'admin.partners.reports',
            permission: 'api2.admin.reportscontroller.generate_report'
          },
          {
            state: 'subaffiliate_reports',
            shortcode: 'admin.partners.subaffiliate_reports',
            permission: 'api2.admin.subaffiliatereportscontroller.generate_report'
          },
          {
            state: 'creative_reports',
            shortcode: 'admin.partners.creative_reports',
            permission: 'api2.admin.creativereportscontroller.generate_report'
          },
          {
            state: 'admin_balance_adjustments_history',
            shortcode: 'admin.partners.admin_balance_adjustments_history',
            permission: 'api2.admin.affiliatecashoutscontroller.admin_balance_adjustments_history_show'
          },
          {
            state: 'admin_withdrawals_history',
            shortcode: 'admin.partners.admin_withdrawals_history',
            children: ['admin_withdrawals_history.view_withdrawal'],
            permission: 'api2.admin.affiliatecashoutscontroller.withdrawals_history_show'
          },
          {
            state: 'admin_pending_withdrawals',
            shortcode: 'admin.partners.pending_withdrawals',
            children: ['admin_pending_withdrawals.view_withdrawal'],
            permission: 'api2.admin.affiliatecashoutscontroller.pending_withdrawals_show'
          },
          {
            state: 'partners_balances',
            shortcode: 'admin.partners.partners_balances',
            children: ['partners_balances.balance_adjustment', 'partners_balances.withdrawal_affiliate_balance'],
            permission: 'api2.admin.affiliatecashoutscontroller.affiliates_balances_show'
          }
        ]
      },
      {
        icon: 'fa fa-trophy',
        shortcode: 'admin.players',
        open: false,
        states: [
          {
            state: 'players',
            shortcode: 'admin.players.players_list',
            children: [
              'players.view_player',
              'players.view_player.main_data',
              'players.view_player.activities_player',
              'players.view_player.tracker_player',
              'players.history_changes_players'
            ],
            permission: 'api2.admin.observingofdailystatisticsplayerscontroller.show'
          },
          {
            state: 'bonuses',
            shortcode: 'admin.players.bonuses',
            children: ['bonuses.add_bonuses', 'bonuses.edit_bonuses'],
            permission: 'api2.admin.bonusescontroller.show'
          },
          {
            state: 'mass_retag',
            shortcode: 'admin.players.mass_retag',
            permission: 'api2.admin.massretagcontroller.retag'
          }
        ]
      },
      {
        icon: 'fa fa-briefcase',
        shortcode: 'admin.partnership',
        open: false,
        states: [
          {
            state: 'trackers',
            shortcode: 'admin.partnership.trackers',
            permission: 'api2.admin.trackerscontroller.show'
          },
          {
            state: 'admin_promo_codes',
            shortcode: 'admin.partnership.promo_codes',
            children: ['admin_promo_codes.create'],
            permission: 'api2.admin.promocodescontroller.show'
          },
          {
            state: 'conditions',
            shortcode: 'admin.partnership.conditions',
            children: ['conditions.settings'],
            permission: 'api2.admin.conditionscontroller.show'
          },
          {
            state: 'subaffiliate_conditions',
            shortcode: 'admin.partnership.subaffiliate_conditions',
            children: ['subaffiliate_conditions.settings'],
            permission: 'api2.admin.subaffiliateconditionscontroller.show'
          },
          {
            state: 'admin_bookkeeping',
            shortcode: 'admin.partnership.bookkeeping',
            children: ['admin_bookkeeping.bookkeeping_month_report', 'deduction'],
            permission: 'api2.admin.bookkeepingscontroller.show'
          },
          {
            state: 'creatives.link',
            shortcode: 'admin.partnership.creatives',
            children: [
              'creatives.edit',
              'creatives.create',
              'creatives.create_bulk',
              'creatives.jpeg',
              'creatives.png',
              'creatives.gif',
              'creatives.bannerflow_gif',
              'creatives.iframe',
              'creatives.flash'
            ],
            permission: 'api2.admin.creativescontroller.show'
          },
          {
            state: 'admin_articles',
            shortcode: 'admin.partnership.articles',
            children: ['admin_articles.view', 'admin_articles.create', 'admin_articles.edit'],
            permission: 'api2.admin.articlescontroller.show'
          }
        ]
      },
      {
        icon: 'fa fa-user',
        shortcode: 'admin.personnel',
        open: false,
        states: [
          {
            state: 'personal',
            shortcode: 'admin.personnel.personnel_list',
            children: ['personal.edit', 'personal.create'],
            permission: 'api2.admin.personalscontroller.show'
          },
          {
            state: 'groups_list',
            shortcode: 'admin.personnel.groups_list',
            children: ['groups_list.edit'],
            permission: 'api2.admin.admingroupscontroller.edit'
          },
          {
            state: 'group_of_managers',
            shortcode: 'admin.personnel.group_of_managers',
            permission: 'api2.admin.admingroupscontroller.show'
          }
        ]
      },
      {
        icon: 'fa fa-wrench',
        shortcode: 'admin.system_settings',
        open: false,
        states: [
          {
            state: 'settings.company',
            shortcode: 'admin.system_settings.settings',
            children: [
              'settings.affiliate_auto_approve',
              'settings.information',
              'settings.emails',
              'settings.bookkeeping',
              'settings.history_changes_percent',
              'settings.admin_fees',
              'settings.history_changes_fees',
              'settings.columns_for_tables',
              'settings.columns_for_tables.settings',
              'settings.click_domains',
              'settings.add_click_domain',
              'settings.columns',
              'settings.view_all_statistics',
              'settings.registration_fields',
              'settings.payment_systems',
              'settings.country_group_settings',
              'settings.upload_logo',
              'settings.notification_header',
              'settings.affiliate_banner'
            ],
            permission: 'api2.admin.projectsettingscontroller.edit'
          },
          {
            state: 'translate_manager',
            shortcode: 'admin.system_settings.translate_manager',
            permission: 'api2.admin.translatemanagercontroller.edit'
          },
          {
            state: 'permissions_manager',
            shortcode: 'admin.system_settings.permissions_manager',
            permission: 'api2.admin.rolescontroller.create'
          },
          {
            state: 'imported_data',
            shortcode: 'admin.system_settings.imported_data',
            permission: 'api2.admin.ftpfilescontroller.show'
          },
          {
            state: 'quints_api',
            shortcode: 'admin.system_settings.quints_api',
            permission: 'api2.admin.profilecontroller.api_tokens'
          }
        ]
      },
      {
        icon: 'fa fa-external-link',
        shortcode: 'admin.mirrors',
        open: false,
        states: [
          {
            state: 'mirrors_list_js',
            shortcode: 'admin.mirrors.mirrors_list_js',
            children: [
              'mirrors_list_js.add_tracking',
              'mirrors_list_js.add_tracking.manual',
              'mirrors_list_js.add_tracking.from_file',
              'mirrors_list_js.edit_tracking'
            ],
            permission: 'api2.admin.mirrorscontroller.show'
          },
          {
            state: 'mirrors_list_no_js',
            shortcode: 'admin.mirrors.mirrors_list_no_js',
            children: [
              'mirrors_list_no_js.add_tracking',
              'mirrors_list_no_js.add_tracking.manual',
              'mirrors_list_no_js.add_tracking.from_file',
              'mirrors_list_no_js.edit_tracking'
            ],
            permission: 'api2.admin.mirrorscontroller.show'
          }
          // {
          //   state: 'mirrors_notifications',
          //   shortcode: 'admin.mirrors.mirrors_notifications',
          //   permission: 'api2.admin.projectsettingscontroller.redirector_notifications'
          // }
        ]
      },
      {
        icon: 'fa fa-download',
        shortcode: 'admin.export',
        open: false,
        states: [
          {
            state: 'admin_export_data',
            shortcode: 'admin.export.export_data',
            permission: 'api2.admin.csvreportscontroller.create'
          },
          {
            state: 'admin_download_csv',
            shortcode: 'admin.export.download_csv',
            permission: 'api2.admin.backgroundreportscontroller.show'
          }
        ]
      }
    ];

    navigation.affiliateMenu = [
      {
        icon: 'fa fa-link',
        shortcode: 'affiliate.tracking_links',
        open: false,
        states: [
          {
            state: 'affiliate_trackers',
            shortcode: 'affiliate.tracking_links.trackers',
            children: ['affiliate_trackers.creatives'],
            permission: 'api2.affiliate.trackerscontroller.show'
          },
          {
            state: 'affiliate_ref_link',
            shortcode: 'affiliate.tracking_links.get_creatives_link',
            children: ['affiliate_ref_link.list'],
            permission: 'api2.affiliate.getcreativelinkscontroller.get_link'
          },
          {
            state: 'webhooks.registration',
            shortcode: 'affiliate.tracking_links.webhooks',
            children: ['webhooks.registration', 'webhooks.activity', 'webhooks.deposit', 'webhooks.settings'],
            permission: 'api2.affiliate.webhookscontroller.all'
          },
          {
            state: 'webhooks_history',
            shortcode: 'affiliate.tracking_links.webhooks_history',
            children: ['webhooks_history.details'],
            permission: 'api2.affiliate.requestscontroller.show'
          },
          {
            state: 'affiliate_reference',
            shortcode: 'affiliate.tracking_links.registration_reference',
            permission: 'api2.affiliate.settingscontroller.referrals_token'
          },
          {
            state: 'affiliate_api',
            shortcode: 'affiliate.tracking_links.affiliate_api',
            permission: 'api2.affiliate.settingscontroller.api_stats'
          }
        ]
      },
      {
        icon: 'fa fa-sticky-note-o',
        shortcode: 'affiliate.reports',
        open: false,
        states: [
          {
            state: 'affiliate_reports',
            shortcode: 'affiliate.reports.reports',
            permission: 'api2.affiliate.reportscontroller.generate_report'
          },
          {
            state: 'affiliate_subaffiliate_reports',
            shortcode: 'affiliate.reports.subaffiliate_reports',
            permission: 'api2.affiliate.subaffiliatereportscontroller.generate_report'
          },
          {
            state: 'affiliate_creative_reports',
            shortcode: 'affiliate.reports.creative_reports',
            permission: 'api2.affiliate.creativereportscontroller.generate_report'
          },
          {
            state: 'affiliate_bookkeeping',
            shortcode: 'affiliate.reports.bookkeeping',
            children: ['affiliate_bookkeeping.bookkeeping_month_report'],
            permission: 'api2.affiliate.bookkeepingscontroller.show'
          },
          {
            state: 'affiliate_balance',
            shortcode: 'affiliate.reports.affiliate_balance',
            children: ['affiliate_balance.withdrawal'],
            permission: 'api2.affiliate.cashoutscontroller.list'
          }
        ]
      },
      {
        icon: 'fa fa-briefcase',
        shortcode: 'affiliate.partnership',
        open: false,
        states: [
          {
            state: 'affiliate_terms',
            shortcode: 'affiliate.partnership.terms',
            permission: 'api2.affiliate.staticpagescontroller.terms'
          },
          {
            state: 'affiliate_privacy',
            shortcode: 'affiliate.partnership.privacy',
            permission: 'api2.affiliate.staticpagescontroller.privacy'
          },
          {
            state: 'affiliate_static_page_1',
            shortcode: 'affiliate.partnership.static_page_1',
            permission: 'api2.affiliate.staticpagescontroller.static_page_1'
          },
          {
            state: 'affiliate_static_page_2',
            shortcode: 'affiliate.partnership.static_page_2',
            permission: 'api2.affiliate.staticpagescontroller.static_page_2'
          },
          {
            state: 'affiliate_static_page_3',
            shortcode: 'affiliate.partnership.static_page_3',
            permission: 'api2.affiliate.staticpagescontroller.static_page_3'
          },
          {
            state: 'affiliate_static_page_4',
            shortcode: 'affiliate.partnership.static_page_4',
            permission: 'api2.affiliate.staticpagescontroller.static_page_4'
          },
          {
            state: 'affiliate_static_page_5',
            shortcode: 'affiliate.partnership.static_page_5',
            permission: 'api2.affiliate.staticpagescontroller.static_page_5'
          },
          {
            state: 'affiliate_articles',
            shortcode: 'affiliate.partnership.articles',
            permission: 'api2.affiliate.articlescontroller.show',
            children: ['affiliate_articles.view']
          }
        ]
      },
      {
        icon: 'fa fa-download',
        shortcode: 'affiliate.export',
        open: false,
        states: [
          {
            state: 'affiliate_download_csv',
            shortcode: 'affiliate.export.download_csv',
            permission: 'api2.affiliate.backgroundreportscontroller.show'
          }
        ]
      }
    ];

    return navigation;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('navigation', navigation);

  navigation.$inject = [
    '$state',
    'navigationFactory',
    'newPartnersApi',
    '_',
    'permissionsManager',
    'User',
    '$mdTranslate',
    'localesStorage'
  ];

  function navigation(
    $state,
    navigationFactory,
    newPartnersApi,
    _,
    permissionsManager,
    User,
    $mdTranslate,
    localesStorage
  ) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/shared/navigation/navigation.html',
      controllerAs: '$ctrl',
      controller: function($scope) {
        var vm = this;

        vm.translate_key = 'Navigation';
        vm.menu = [];
        vm.dashboard = {};
        vm.affiliateGuide = null;

        vm.getTranslateDefault = function(item) {
          return $mdTranslate.instant(vm.translate_key, item.shortcode, null, localesStorage.getFallbackLocale());
        };

        vm.goToDashboard = function() {
          $state.go(User.getUserProperty('namespace'));
        };

        vm.isActiveDashboard = function() {
          return $state.includes(vm.dashboard.state);
        };

        vm.goToAffiliateGuide = function() {
          $state.go(vm.affiliateGuide.state);
        };

        vm.isActiveAffiliateGuide = function() {
          return vm.affiliateGuide && $state.includes(vm.affiliateGuide.state);
        };

        vm.toggle = function(item) {
          item.open = !item.open;
        };

        vm.openCurrentStateGroup = function() {
          _.each(vm.menu, function(group) {
            group.open = vm.checkSubStates(group.states);
          });
        };

        vm.checkSubStates = function(list) {
          return _.some(_.map(list, vm.updateActiveItem));
        };

        vm.updateActiveItem = function(item) {
          return (item.active = vm.isStateIncludes(item));
        };

        vm.isStateIncludes = function(item) {
          return $state.includes(item.state) || _.includes(item.children, $state.current.name);
        };

        vm.updateActiveItems = function() {
          _.each(vm.getAllStates(), vm.updateActiveItem);
        };

        vm.getAllStates = function() {
          return _.flatten(_.pluck(vm.menu, 'states'));
        };

        vm.setStateData = function(name, data) {
          _.each(vm.getAllStates(), function(item) {
            if (item.budge && item.state === name) {
              item.budge.data = data;
            }
          });
        };

        vm.isNewPartnersPermitted = function() {
          return (
            permissionsManager.checkPermission('api2.admin.affiliatescontroller.pending_affiliates') && User.isAdmin()
          );
        };

        vm.getNewPartners = function() {
          if (!vm.isNewPartnersPermitted()) {
            return;
          }

          newPartnersApi.set_count_new_partners().then(function(response) {
            vm.setStateData('new_partners', response.data.count > 99 ? '99+' : response.data.count);
          });
        };

        vm.init = function() {
          vm.menu = User.isAdmin() ? navigationFactory.adminMenu : navigationFactory.affiliateMenu;
          vm.dashboard = User.isAdmin() ? navigationFactory.adminDashboard : navigationFactory.affiliateDashboard;
          vm.affiliateGuide = User.isAdmin() ? null : navigationFactory.affiliateGuide;
        };

        $scope.$on('$stateChangeSuccess', function() {
          vm.updateActiveItems();
        });
        $scope.$on('set_count_new_partners', function() {
          vm.getNewPartners();
        });
        $scope.$on('change_menu', function() {
          vm.init();
        });

        vm.init();
        vm.openCurrentStateGroup();
        vm.getNewPartners();
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        menu: {
          admin_menu: [
            'home||admin.home',
            {
              partners: [
                'group_header||admin.partners',
                'unconfirmed_partners||admin.partners.unconfirmed_partners',
                'new_partners||admin.partners.new_partners',
                'partners_list||admin.partners.partners_list',
                'requests_history||admin.partners.requests_history',
                'admin_webhooks_history||admin.partners.admin_webhooks_history',
                'bulk_email_v2||admin.partners.bulk_email_v2',
                'reports||admin.partners.reports',
                'subaffiliate_reports||admin.partners.subaffiliate_reports',
                'creative_reports||admin.partners.creative_reports',
                'admin_balance_adjustments_history||admin.partners.admin_balance_adjustments_history',
                'withdrawals_history||admin.partners.admin_withdrawals_history',
                'pending_withdrawals||admin.partners.pending_withdrawals',
                'partners_balances||admin.partners.partners_balances'
              ],
              players: [
                'group_header||admin.players',
                'players_list||admin.players.players_list',
                'bonuses||admin.players.bonuses',
                'mass_retag||admin.players.mass_retag'
              ],
              partnership: [
                'group_header||admin.partnership',
                'trackers||admin.partnership.trackers',
                'promo_codes||admin.partnership.promo_codes',
                'conditions||admin.partnership.conditions',
                'subaffiliate_conditions||admin.partnership.subaffiliate_conditions',
                'bookkeeping||admin.partnership.bookkeeping',
                'creatives||admin.partnership.creatives',
                // 'tracking_mirrors||admin.partnership.tracking_mirrors',
                'articles||admin.partnership.articles'
              ],
              personnel: [
                'group_header||admin.personnel',
                'personnel_list||admin.personnel.personnel_list',
                'groups_list||admin.personnel.groups_list',
                'group_of_managers||admin.personnel.group_of_managers'
              ],
              system_settings: [
                'group_header||admin.system_settings',
                'settings||admin.system_settings.settings',
                'translate_manager||admin.system_settings.translate_manager',
                'permissions_manager||admin.system_settings.permissions_manager',
                'imported_data||||admin.system_settings.imported_data',
                'quints_api||||admin.system_settings.quints_api'
              ],
              mirrors: [
                'group_header||admin.mirrors',
                'mirrors_list_js||admin.mirrors.mirrors_list_js',
                'mirrors_list_no_js||admin.mirrors.mirrors_list_no_js',
                'mirrors_notifications||admin.mirrors.mirrors_notifications'
              ],
              export: [
                'group_header||admin.export',
                'export_data||admin.export.export_data',
                'download_csv||admin.export.download_csv'
              ]
            }
          ],
          affiliate_menu: [
            'home||affiliate.home',
            'affiliate_guide||affiliate.affiliate_guide',
            {
              tracking_links: [
                'group_header||affiliate.tracking_links',
                'trackers||affiliate.tracking_links.trackers',
                'get_creatives_link||affiliate.tracking_links.get_creatives_link',
                'webhooks||affiliate.tracking_links.webhooks',
                'webhooks_history||affiliate.tracking_links.webhooks_history',
                'registration_reference||affiliate.tracking_links.registration_reference',
                'affiliate_api||affiliate.tracking_links.affiliate_api'
              ],
              reports: [
                'group_header||affiliate.reports',
                'reports||affiliate.reports.reports',
                'subaffiliate_reports||affiliate.reports.subaffiliate_reports',
                'creative_reports||affiliate.reports.creative_reports',
                'bookkeeping||affiliate.reports.bookkeeping',
                'affiliate_balance||affiliate.reports.affiliate_balance'
              ],
              partnership: [
                'group_header||affiliate.partnership',
                'terms||affiliate.partnership.terms',
                'privacy||affiliate.partnership.privacy',
                'static_page_1||affiliate.partnership.static_page_1',
                'static_page_2||affiliate.partnership.static_page_2',
                'static_page_3||affiliate.partnership.static_page_3',
                'static_page_4||affiliate.partnership.static_page_4',
                'static_page_5||affiliate.partnership.static_page_5',
                'articles||affiliate.partnership.articles'
              ],
              export: ['group_header||affiliate.export', 'download_csv||affiliate.export.download_csv']
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('Navigation', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('itemLabel', itemLabel);

  itemLabel.$inject = [];

  function itemLabel() {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        translateKey: '=',
        getTranslateDefault: '&'
      },
      templateUrl: 'app/components/shared/navigation/item_label.html'
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('outputErrors', outputErrors);

  outputErrors.$inject = ['$rootScope', '$mdDialog', '$translate', '_', '$mdTranslate'];

  function outputErrors($rootScope, $mdDialog, $translate, _, $mdTranslate) {
    var outputErrors = {},
      translate_key = 'OutputErrors';

    function Errors() {
      this.errors = {};
    }

    Errors.prototype.clearError = function(errorName) {
      delete this.errors[errorName];
    };

    Errors.prototype.setFieldErrors = function(errorName, messages) {
      if (messages && messages.length) {
        this.errors[errorName] = messages;
      } else {
        delete this.errors[errorName];
      }

      $rootScope.$broadcast('$errors', this.errors);
    };

    Errors.prototype.inputErrors = function(errors) {
      this.errors = angular.merge({}, errors);
      $rootScope.$broadcast('$errors', this.errors);
    };

    Errors.prototype.translate_messages = function(errors) {
      var message = [];

      _.each(errors, function(value) {
        if (_.isArray(value)) {
          message = message.concat(
            _.map(value, function(item) {
              return $translate.instant(item);
            })
          );
        } else {
          message.push($translate.instant(value));
        }
      });

      return message;
    };

    Errors.prototype.show_dialog = function(content, title, cancel) {
      return $mdDialog.show(
        $mdDialog
          .alert()
          .clickOutsideToClose(true)
          .title(title)
          .textContent(content)
          .ok(cancel)
      );
    };

    Errors.prototype.alertDialog = function(errors, title, cancel) {
      var _title = title || $mdTranslate.instant(translate_key, 'errors.modal.title') || 'Error!',
        _cancel = cancel || $mdTranslate.instant(translate_key, 'errors.modal.cancel') || 'Cancel',
        ifArray = _.isArray(errors) ? errors : [$translate.instant(errors)],
        message = errors
          ? ifArray
          : $mdTranslate.instant(translate_key, 'errors.modal.message') || 'Sorry, something went wrong.',
        result = '';

      if (_.isObject(errors) && !_.isArray(errors)) {
        message = this.translate_messages(errors);
      }

      result = _.isArray(message) ? message.join('; ') : message;

      return this.show_dialog(result, _title, _cancel);
    };

    outputErrors.createNew = function() {
      return new Errors();
    };

    return outputErrors;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        errors: {
          form: ['required||errors.required'],
          modal: ['title||errors.modal.title', 'message||errors.modal.message', 'cancel||errors.modal.cancel']
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('OutputErrors', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('inputErrors', inputErrors);

  inputErrors.$inject = ['$timeout', '_'];

  function inputErrors($timeout, _) {
    return {
      restrict: 'A',
      require: ['?ngModel', '^?form'],
      link: function(scope, element, attrs, ctrls) {
        var form = ctrls[1],
          input_name,
          ngModel;

        if (!form) {
          return;
        }

        input_name = attrs.serverErrorName || attrs.name;
        ngModel = ctrls[0] || form[input_name];

        if (attrs.modelDelay) {
          $timeout(function() {
            ngModel = ctrls[0] || form[input_name];
            scope.addModelValidators();
          }, 0);
        }

        scope.addModelValidators = function() {
          if (!ngModel) {
            return;
          }

          ngModel.$validators[input_name] = function() {
            return true;
          };
        };

        scope.addModelValidators();

        scope.$on('$errors', function(ev, errors) {
          if (!ngModel) {
            return;
          }

          var has_property = _.has(errors, input_name);

          ngModel.$setValidity(input_name, !has_property);

          if (has_property) {
            ngModel.$setTouched();
          }
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('mdErrorMessages', mdErrorMessages);

  mdErrorMessages.$inject = [];

  function mdErrorMessages() {
    return {
      restrict: 'E',
      require: '^?form',
      scope: {
        errors: '=',
        inputName: '@',
        variables: '=?'
      },
      templateUrl: 'app/components/shared/output_errors/messages.html',
      link: function(scope, elem, attrs, form) {
        scope.form = form;

        scope.variables_list = function() {
          return scope.variables ? scope.variables.join(', ') : '';
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('merchantToggle', merchantToggle);

  merchantToggle.$inject = ['$rootScope', '$location', 'merchantStore', '_'];

  function merchantToggle($rootScope, $location, merchantStore, _) {
    return {
      restrict: 'E',
      scope: {},
      bindToController: true,
      controllerAs: '$ctrl',
      templateUrl: 'app/components/shared/merchant_toggle/merchant_toggle.html',
      controller: function() {
        var vm = this;

        vm.merchantList = merchantStore.getMerchantList();
        vm.currentMerchantId = merchantStore.getCurrentMerchantId();
        vm.currentMerchant = _.findWhere(vm.merchantList, {id: vm.currentMerchantId}) || {};

        vm.openList = function($mdMenu, ev) {
          if (vm.merchantList.length > 1) {
            $mdMenu.open(ev);
          }
        };

        vm.chooseMerchant = function(merchant) {
          vm.currentMerchant = merchant;
          merchantStore.setCurrentMerchant(merchant);
          $location.search('merchant', merchant.value);
          $rootScope.$broadcast('$changeMerchantSuccess', {merchant_id: merchant.id, merchant_name: merchant.value});
        };

        vm.filterMerchants = function(merchantId) {
          return vm.currentMerchant.id !== merchantId;
        };

        vm.isSelected = function(merchantId) {
          return vm.currentMerchant.id === merchantId;
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('mdSelectLabelTranslate', mdSelectLabelTranslate);

  mdSelectLabelTranslate.$inject = ['$rootScope', '$timeout'];

  function mdSelectLabelTranslate($rootScope, $timeout) {
    return {
      restrict: 'A',
      scope: {},
      link: function(scope, element) {
        var translateListener = $rootScope.$on('$translateChangeSuccess', function() {
          scope.update_value();
        });

        scope.update_value = function() {
          $timeout(function() {
            var ngModel = element.controller('ngModel');
            if (ngModel) {
              ngModel.$render();
            }
          }, 0);
        };

        scope.update_value();

        scope.$on('$destroy', translateListener);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('linearPreloader', linearPreloader);

  linearPreloader.$inject = ['Preloader', '$interpolate', '_'];

  function linearPreloader(Preloader, $interpolate, _) {
    return {
      restrict: 'E',
      scope: {
        headerColor: '='
      },
      bindToController: true,
      template:
        '<div class="linear-preloader-wrap"><span class="bar"><span class="sub-bar"></span><span class="first-bg-bar"></span></span></div>',
      controllerAs: '$ctrl',
      controller: function($scope, $element) {
        var vm = this,
          bar = $element[0].querySelector('.bar'),
          subBar = $element[0].querySelector('.sub-bar');

        vm.preloader = Preloader.linear_preloader;
        vm.startRulesIdx = document.styleSheets[0].cssRules.length;

        vm.animationsStorage = {
          'substrate-bg': [
            '0%   { background-color: {{$4}} }',
            '25%  { background-color: {{$1}} }',
            '50%  { background-color: {{$2}} }',
            '75%  { background-color: {{$3}} }',
            '100% { background-color: {{$0}} }'
          ].join(''),

          'bar-bg': [
            '0%   { background-color: {{$1}} }',
            '25%  { background-color: {{$2}} }',
            '50%  { background-color: {{$3}} }',
            '75%  { background-color: {{$4}} }',
            '100% { background-color: {{$1}} }'
          ].join(''),

          'first-bg': [
            '0%   { background-color: {{$0}} }',
            '25%  { background-color: transparent }',
            '50%  { background-color: transparent }',
            '75%  { background-color: transparent }',
            '100% { background-color: transparent }'
          ].join('')
        };

        vm.startPreloader = function() {
          $element.addClass('start');
        };

        vm.closePreloader = function() {
          $element.removeClass('start');
        };

        vm.animationListener = function(e) {
          if (e.animationName === 'bar-width' && !vm.preloader.enable) {
            vm.closePreloader();
          }
        };

        vm.interpolateBody = function(animationBody, params) {
          return $interpolate(animationBody)(params);
        };

        vm.setUpColors = function(mainColor) {
          var color = mainColor || vm.headerColor;

          bar.style.background = color;

          vm.mainColor = color;
          vm.colors = {
            $0: color,
            $1: '#a2d8ff',
            $2: color,
            $3: '#a2d8ff',
            $4: color
          };
        };

        vm.insertAnimation = function(animationName, animationBody, index) {
          document.styleSheets[0].insertRule('@keyframes ' + animationName + ' {' + animationBody + '}', index);
        };

        vm.removeAllAnimation = function() {
          _.each(vm.animationsStorage, function() {
            document.styleSheets[0].deleteRule(vm.startRulesIdx);
          });
        };

        vm.insertAllAnimations = function() {
          var iterationCount = 0;

          _.each(vm.animationsStorage, function(body, name) {
            vm.insertAnimation(name, vm.interpolateBody(body, vm.colors), vm.startRulesIdx + iterationCount);
            iterationCount++;
          });
        };

        vm.setUpColors();
        vm.insertAllAnimations();

        subBar.addEventListener('animationiteration', vm.animationListener, false);

        $scope.$watch('$ctrl.preloader.enable', function(newValue) {
          if (newValue) {
            vm.startPreloader();
          }
        });

        $scope.$watch('$ctrl.headerColor', function(newColor) {
          if (!newColor) {
            return;
          }

          vm.setUpColors(newColor);
          vm.removeAllAnimation();
          vm.insertAllAnimations();
        });

        $scope.$on('$destroy', function() {
          subBar.removeEventListener('animationiteration', vm.animationListener);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('loginAnimation', loginAnimation);

  loginAnimation.$inject = ['$timeout', '_'];

  function loginAnimation($timeout, _) {
    var loginAnimation = {},
      elements = ['cd-cover-overlay', 'cd-cover-layer', 'cd-loading-bar'];

    loginAnimation.animation = {
      enable: false
    };

    loginAnimation.enable = function() {
      loginAnimation.animation.enable = true;
      $timeout(function() {
        loginAnimation.animation.enable = false;
        loginAnimation.removeElements();
      }, 2000);
    };

    loginAnimation.appendElements = function() {
      _.each(elements, function(elem) {
        if (!document.querySelector('.' + elem)) {
          angular.element(document.querySelector('#app')).append('<div class="' + elem + '"></div>');
        }
      });
    };

    loginAnimation.removeElements = function() {
      $timeout(function() {
        _.each(elements, function(elem) {
          var el = document.querySelector('.' + elem);
          if (el) {
            angular.element(el).remove();
          }
        });
      }, 1500);
    };

    return loginAnimation;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('loginAnimationControll', loginAnimationControll);

  loginAnimationControll.$inject = ['loginAnimation'];

  function loginAnimationControll(loginAnimation) {
    return {
      restrict: 'E',
      link: function() {
        loginAnimation.appendElements();
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('languageToggle', languageToggle);

  languageToggle.$inject = [
    '$rootScope',
    '$timeout',
    '$translate',
    '$mdTranslate',
    'LocalesApi',
    '$mdDateLocale',
    'moment',
    'localesStorage',
    '_'
  ];

  function languageToggle(
    $rootScope,
    $timeout,
    $translate,
    $mdTranslate,
    LocalesApi,
    $mdDateLocale,
    moment,
    localesStorage,
    _
  ) {
    return {
      restrict: 'E',
      scope: {
        fixed: '=?'
      },
      bindToController: true,
      templateUrl: 'app/components/shared/language_toggle/language_toggle.html',
      controllerAs: '$ctrl',
      controller: function($scope) {
        var vm = this,
          listener;

        vm.languages = localesStorage.getLanguages();
        vm.currentLocale = localesStorage.getCurrentLocale();
        vm.momentLocale = localesStorage.getMomentLocale();
        vm.showList = false;

        $scope.$on('$mdMenuClose', function() {
          $timeout(function() {
            vm.showList = false;
          }, 300);
        });

        vm.openMenu = function($mdMenu, ev) {
          vm.showList = true;
          $timeout(function() {
            $mdMenu.open(ev);
          }, 0);
        };

        vm.updateAll = function(currentLocale, momentLocale) {
          localesStorage.updateLocale(currentLocale);
          vm.currentLocale = currentLocale;
          vm.momentLocale = momentLocale;
        };

        vm.changeLanguage = function(currentLocale, momentLocale) {
          LocalesApi.set_locale(currentLocale).then(function() {
            vm.updateAll(currentLocale, momentLocale);

            moment.locale(momentLocale);

            $mdDateLocale.months = moment.months();
            $mdDateLocale.shortMonths = moment.monthsShort();
            $mdDateLocale.days = moment.weekdays();
            $mdDateLocale.shortDays = moment.weekdaysMin();
            $mdDateLocale.firstDayOfWeek = moment.localeData()._week.dow;

            $translate.use(currentLocale);
          });
        };

        vm.forceChangeLanguage = function(defaultLocale) {
          vm.languages = localesStorage.getLanguages();

          if (!_.contains(_.keys(vm.languages), vm.currentLocale)) {
            var newLocale = defaultLocale || localesStorage.getFallbackLocale(),
              newMoment = vm.languages[newLocale] || localesStorage.getFallbackMomentLocale();

            vm.changeLanguage(newLocale, newMoment);
          }
        };

        vm.showSearchInput = function() {
          return _.size(_.keys(vm.languages)) > 10;
        };

        vm.filterLanguages = function(languages, search) {
          return _.pick(languages, function(val, key) {
            return (
              ($mdTranslate.instant('Languages', 'language.' + key) || key)
                .toLowerCase()
                .indexOf(search.toLowerCase()) !== -1
            );
          });
        };

        vm.getLanguages = function() {
          return _.isEmpty(vm.query) ? vm.languages : vm.filterLanguages(vm.languages, vm.query);
        };

        listener = $rootScope.$on('changeLocalesList', function(ev, data) {
          vm.forceChangeLanguage(data.defaultLocale);
        });

        $scope.$on('$destroy', listener);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('inputFileArea', inputFileArea);

  inputFileArea.$inject = ['$log', '_'];

  function inputFileArea($log, _) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        ngModel: '=',
        options: '=',
        errors: '=?',
        isRequired: '=',
        callback: '&?'
      },
      templateUrl: 'app/components/shared/input_file_area/input_file_area.html',
      controllerAs: 'fileCtrl',
      controller: function($scope, $element) {
        var vm = this,
          input = _.first($element.find('input')),
          options = {
            translate_key: null,
            input_name: '',
            accept: '',
            shortcodes: {
              label: '',
              drop_file_here: '',
              resolution_file: ''
            }
          };

        $scope.ngModel = '';
        vm.data = {};
        vm.reader = new FileReader();
        vm.preview = new Image();
        vm.options = _.extend({}, options, $scope.options);
        vm.resolutions = {};

        vm.data[vm.options.input_name] = '';

        vm.clear = function() {
          $scope.ngModel = '';
          vm.resolutions = {};
          vm.data[vm.options.input_name] = '';

          try {
            input.value = '';
          } catch (err) {
            $log.error('crear input file is not supported because probably you use IE10-');
          }

          if ($scope.callback) {
            $scope.callback({data: vm.data, file: $scope.ngModel});
          }
        };

        vm.getImageResolution = function(ev) {
          vm.resolutions.width = vm.preview.width || ev.path[0].width;
          vm.resolutions.height = vm.preview.height || ev.path[0].height;
          vm.data[vm.options.input_name] = vm.preview.src;

          if ($scope.callback) {
            $scope.callback({data: vm.data, file: $scope.ngModel});
          }

          $scope.$apply();
        };

        vm.readerLoaded = function() {
          vm.preview.src = _.first($scope.ngModel.type.split('/')) === 'image' ? vm.reader.result : '';
          vm.data[vm.options.input_name] = vm.reader.result;

          if ($scope.callback) {
            $scope.callback({data: vm.data, file: $scope.ngModel});
          }

          $scope.$apply();
        };

        vm.inputChange = function(event) {
          $scope.ngModel = _.first(event.target.files) || '';

          if ($scope.ngModel) {
            vm.reader.readAsDataURL($scope.ngModel);
          }
        };

        vm.dragOver = function() {
          input.parentNode.classList.add('drag-over');
        };

        vm.dragEnd = function() {
          input.parentNode.classList.remove('drag-over');
        };

        vm.checkCancel = function(ev) {
          if (!_.size(ev.target.files)) {
            vm.clear();
          }
        };

        $scope.$on('clearInputFile', function() {
          vm.clear();
        });

        input.addEventListener('change', vm.inputChange);
        input.addEventListener('dragenter', vm.dragOver);
        input.addEventListener('dragleave', vm.dragEnd);
        input.addEventListener('drop', vm.dragEnd);
        input.addEventListener('focus', vm.checkCancel);
        input.addEventListener('blur', vm.checkCancel);
        vm.reader.addEventListener('load', vm.readerLoaded);
        vm.preview.addEventListener('load', vm.getImageResolution);

        $scope.$on('$destroy', function() {
          input.removeEventListener('change', vm.inputChange);
          input.removeEventListener('dragenter', vm.dragOver);
          input.removeEventListener('dragleave', vm.dragEnd);
          input.removeEventListener('drop', vm.dragEnd);
          input.removeEventListener('focus', vm.checkCancel);
          input.removeEventListener('blur', vm.checkCancel);
          vm.reader.removeEventListener('load', vm.readerLoaded);
          vm.preview.removeEventListener('load', vm.getImageResolution);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        notification: ['no_any_notification||notification.no_any_notification']
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('Notification', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('informationPlate', informationPlate);

  informationPlate.$inject = ['$rootScope', 'User', 'NotificationHeaderApi', 'notificationHeader', 'localesStorage'];

  function informationPlate($rootScope, User, NotificationHeaderApi, notificationHeader, localesStorage) {
    return {
      restrict: 'E',
      scope: {
        showFor: '@'
      },
      templateUrl: function(elem, attr) {
        if (attr.showFor === 'affiliate') {
          return 'app/components/shared/information_plate/partials/information_plate.html';
        } else if (attr.showFor === 'anonym') {
          return 'app/components/shared/information_plate/partials/anonym_plate.html';
        }
      },
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope) {
        var vm = this,
          isAnonym = vm.showFor === 'anonym',
          anonymNotify,
          translateListener;

        vm.defaultTextColor = '#000';
        vm.defaultBgColor = '#fff';
        vm.notifyColor = '';
        vm.notifyBg = '';
        vm.notify = null;
        vm.isNotificationRead = true;

        if (isAnonym) {
          anonymNotify = notificationHeader.getNotifyData();

          vm.defaultTextColor = anonymNotify.textColor;
          vm.defaultBgColor = anonymNotify.headerColor;
          vm.notifyColor = vm.defaultTextColor;
          vm.notifyBg = vm.defaultBgColor;
          vm.notify = {
            body: notificationHeader.getTextContent(localesStorage.getCurrentLocale())
          };
        }

        vm.getUserNamespace = function() {
          return User.getUserProperty('namespace');
        };

        vm.canShowNotify = function() {
          return vm.showFor === vm.userNamespace;
        };

        vm.readNotify = function(id) {
          return NotificationHeaderApi.readNotify(id);
        };

        vm.showNotify = function(ev, $mdMenu) {
          $mdMenu.open(ev);

          if (!vm.notify || vm.isNotificationRead) {
            return;
          }

          vm.readNotify(vm.notify.id).then(function() {
            vm.isNotificationRead = true;
          });
        };

        vm.setAnonymNotifyDataToConstant = function(notify, notifyBg, notifyColor, locale) {
          var notifyContent = {};

          notifyContent[locale] = notify ? notify.body : '';

          notificationHeader.setTextContent(notifyContent);
          notificationHeader.setNotifyData({headerColor: notifyBg, textColor: notifyColor});
        };

        vm.getNotify = function() {
          if (!vm.canShowNotify()) {
            return;
          }

          var locale = localesStorage.getCurrentLocale();

          NotificationHeaderApi.getNotifyContent(vm.userNamespace, locale).then(function(response) {
            var data = response.data;

            vm.notify = data.notification;
            vm.isNotificationRead = data.hide_notification;
            vm.notifyColor = vm.notify ? vm.notify.text_color : vm.defaultTextColor;
            vm.notifyBg = vm.notify ? vm.notify.header_color : vm.defaultBgColor;

            if (isAnonym) {
              vm.setAnonymNotifyDataToConstant(vm.notify, vm.notifyBg, vm.notifyColor, locale);
            }
          });
        };

        $scope.$watch(
          function() {
            return vm.getUserNamespace();
          },
          function(value) {
            vm.userNamespace = value || vm.showFor;

            vm.getNotify();
          }
        );

        translateListener = $rootScope.$on('$translateChangeSuccess', function() {
          vm.getNotify();
        });

        $scope.$on('$destroy', function() {
          translateListener();
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('loadLogoControll', loadLogoControll);

  loadLogoControll.$inject = ['logoUrls', '_'];

  function loadLogoControll(logoUrls, _) {
    return {
      restrict: 'A',
      scope: {},
      link: function(scope, element, attr) {
        var errorHudler = _.once(defaultLogo);

        function defaultLogo() {
          element[0].src = logoUrls.getDefaultLogoByType(attr.logoType);
        }

        element[0].addEventListener('error', errorHudler);

        scope.$on('$destroy', function() {
          element[0].removeEventListener('error', errorHudler);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('siteHeader', siteHeader);

  siteHeader.$inject = [
    '$mdBottomSheet',
    '$mdMedia',
    'User',
    'logoUrls',
    'themeColors',
    'permissionsManager',
    'ComponentRegistry'
  ];

  function siteHeader($mdBottomSheet, $mdMedia, User, logoUrls, themeColors, permissionsManager, ComponentRegistry) {
    return {
      restrict: 'E',
      replace: true,
      scope: {},
      templateUrl: 'app/components/shared/header/header.html',
      controllerAs: 'header',
      controller: function($scope) {
        var vm = this;

        vm.logo_type = 'logo_mini';
        vm.balancePermitted = permissionsManager.checkPermission('api2.affiliate.cashoutscontroller.show_balance');
        vm.mdSidenav = null;

        vm.getUserEmail = function() {
          return User.getUserProperty('email');
        };

        vm.getUserNamespace = function() {
          return User.getUserProperty('namespace');
        };

        vm.isAdmin = function() {
          return User.isAdmin();
        };

        vm.getLogoUrl = function() {
          return logoUrls.getLogoMini();
        };

        vm.getHeaderColor = function() {
          return themeColors.getHeaderColor();
        };

        vm.toggleProfileMenu = function() {
          $mdBottomSheet.show({
            templateUrl: 'app/components/shared/header/profile_menu.html',
            scope: $scope,
            preserveScope: true
          });
        };

        ComponentRegistry.getComponent('navigation').then(function(mdSidenav) {
          vm.mdSidenav = mdSidenav;
        });

        $scope.$watch(
          function() {
            return $mdMedia('gt-sm');
          },
          function(value) {
            vm.isGtSm = value;

            if (vm.isGtSm) {
              $mdBottomSheet.hide();
            }
          }
        );

        $scope.$on('permissions_is_updated', function() {
          vm.balancePermitted = permissionsManager.checkPermission('api2.affiliate.cashoutscontroller.show_balance');
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('ReportCreateToastsController', ReportCreateToastsController);

  ReportCreateToastsController.$inject = ['$state', '$mdToast'];

  function ReportCreateToastsController($state, $mdToast) {
    var vm = this;

    vm.moveToDownload = function() {
      vm.hide();
      $state.go(vm.stateToDownload);
    };

    vm.hide = function() {
      $mdToast.hide();
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        download_reports: [
          'title||download_reports.title',
          'format_label||download_reports.format_label',
          'separator_label||download_reports.separator_label',
          'cancel||download_reports.cancel',
          'create_report_success||download_reports.create_report_success',
          'ok||download_reports.ok'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('DownloadReport', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('downloadReport', downloadReport);

  downloadReport.$inject = ['$mdDialog', '$mdToast'];

  function downloadReport($mdDialog, $mdToast) {
    var downloadReport = {};

    downloadReport.openModal = function(params, ev) {
      return $mdDialog.show({
        controller: 'DownloadReportController',
        controllerAs: 'downloadCtrl',
        bindToController: true,
        templateUrl: 'app/components/shared/download_reports/partials/download_reports.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: params || {}
      });
    };

    downloadReport.showToastForDownload = function(translateKey, namespace, stateToDownload) {
      return $mdToast.show({
        templateUrl: 'app/components/shared/download_reports/partials/create_report_toast.html',
        controller: 'ReportCreateToastsController',
        controllerAs: '$ctrl',
        bindToController: true,
        position: 'bottom right',
        toastClass: 'success',
        hideDelay: 6000,
        locals: {
          translateKey: translateKey,
          namespace: namespace,
          stateToDownload: stateToDownload
        }
      });
    };

    return downloadReport;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('DownloadReportController', DownloadReportController);

  DownloadReportController.$inject = ['$mdDialog', '_', 'User', 'Preloader', 'toastsApi', '$q', 'downloadReport'];

  function DownloadReportController($mdDialog, _, User, Preloader, toastsApi, $q, downloadReport) {
    var vm = this;

    vm.translate_key = 'DownloadReport';
    vm.downloadSeparators = vm.options || {};
    vm.downloadFormats = _.keys(vm.downloadSeparators);
    vm.reportInformation = {};
    vm.namespace = User.getUserProperty('namespace');
    vm.stateToDownload = vm.namespace === 'admin' ? 'admin_download_csv' : 'affiliate_download_csv';

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.hide = function() {
      $mdDialog.hide();
    };

    vm.getErrors = function(res) {
      if (!_.isObject(res.data) || !res.data.errors) {
        return null;
      }

      if (_.isArray(res.data.errors)) {
        return {locale: res.data.errors[0]};
      } else if (_.isObject(res.data.errors)) {
        var mes = _.first(_.flatten(_.values(res.data.errors)));
        return mes ? {locale: mes} : null;
      }
    };

    vm.download = function() {
      if (!_.isFunction(vm.downloadReportFunc)) {
        return $q.when();
      }

      var promise = vm.downloadReportFunc(vm.reportInformation);

      vm.hide();

      if (_.isFunction(promise.then)) {
        Preloader.openPreloaderForce();

        promise.then(
          function(response) {
            Preloader.closePreloaderForce();
            downloadReport.showToastForDownload(vm.translate_key, vm.namespace, vm.stateToDownload);
            return response;
          },
          function(response) {
            Preloader.closePreloaderForce();
            toastsApi.toastError(vm.getErrors(response));
            return response;
          }
        );
      }

      return promise;
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('datePeriod', datePeriod);

  datePeriod.$inject = ['$rootScope', '$mdMedia', 'moment', '_'];

  function datePeriod($rootScope, $mdMedia, moment, _) {
    return {
      restrict: 'E',
      scope: {
        translateKey: '=',
        list: '=',
        defaultPeriodType: '=',
        datepickerRangePeriod: '=?'
      },
      templateUrl: 'app/components/shared/date_period/date_period.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope) {
        var vm = this,
          translateListener;

        vm.periods = [];
        vm.activeDatePeriod = null;

        vm.datePeriodOptions = {
          today: {
            startDate: function() {
              return moment();
            },
            endDate: function() {
              return moment();
            }
          },
          yesterday: {
            startDate: function() {
              return moment()
                .subtract(1, 'day')
                .startOf('day');
            },
            endDate: function() {
              return moment()
                .subtract(1, 'day')
                .endOf('day');
            }
          },
          last_7_days: {
            startDate: function() {
              return moment()
                .subtract(6, 'd')
                .startOf('day');
            },
            endDate: function() {
              return moment();
            }
          },
          week: {
            startDate: function() {
              return moment().startOf('week');
            },
            endDate: function() {
              return moment().endOf('week');
            }
          },
          last_week: {
            startDate: function() {
              return moment()
                .subtract(1, 'week')
                .startOf('week');
            },
            endDate: function() {
              return moment()
                .subtract(1, 'week')
                .endOf('week');
            }
          },
          month: {
            startDate: function() {
              return moment().startOf('month');
            },
            endDate: function() {
              return moment().endOf('month');
            }
          },
          last_month: {
            startDate: function() {
              return moment()
                .subtract(1, 'month')
                .startOf('month');
            },
            endDate: function() {
              return moment()
                .subtract(1, 'month')
                .endOf('month');
            }
          },
          year: {
            startDate: function() {
              return moment().startOf('year');
            },
            endDate: function() {
              return moment().endOf('year');
            }
          }
        };

        vm.updatePickerDates = function(item) {
          vm.daterangeStart = item.startDate.toDate();
          vm.daterangeEnd = item.endDate.toDate();
        };

        vm.customReportPeriod = function(data) {
          vm.activeDatePeriod = null;
          $scope.$emit('changePeriod', {start: data.start, end: data.end});
        };

        vm.choosePeriod = function(period) {
          if (period) {
            vm.activeDatePeriod = period;
          }
          vm.updatePickerDates(vm.activeDatePeriod);

          $scope.$emit('changePeriod', {
            start: moment(vm.daterangeStart).format('YYYY-MM-DD'),
            end: moment(vm.daterangeEnd).format('YYYY-MM-DD')
          });
        };

        vm.updatePeriods = function() {
          _.each(vm.periods, function(item) {
            item.startDate = vm.datePeriodOptions[item.type].startDate();
            item.endDate = vm.datePeriodOptions[item.type].endDate();
          });
        };

        vm.getActiveDatePeriod = function(type) {
          return _.find(vm.periods, function(v) {
            return v.type === type;
          });
        };

        $scope.$watch('$ctrl.list', function(newList) {
          if (_.isEmpty(newList)) {
            return;
          }

          vm.periods = _.map(newList, function(item) {
            return {
              type: item.type,
              shortcode: item.shortcode
            };
          });

          vm.updatePeriods();

          vm.activeDatePeriod = vm.getActiveDatePeriod(vm.defaultPeriodType || 'month');
          vm.updatePickerDates(vm.activeDatePeriod);

          $scope.$emit('changePeriod', {
            start: moment(vm.daterangeStart).format('YYYY-MM-DD'),
            end: moment(vm.daterangeEnd).format('YYYY-MM-DD')
          });
        });

        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            vm.isGtXs = value;
          }
        );

        translateListener = $rootScope.$on('$translateChangeSuccess', function() {
          vm.updatePeriods();

          if (vm.activeDatePeriod) {
            vm.choosePeriod(vm.activeDatePeriod);
          }
        });

        $scope.$on('$destroy', function() {
          translateListener();
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('dateLocaleInput', dateLocaleInput);

  dateLocaleInput.$inject = ['$rootScope', 'moment', 'defaultDateFormat'];

  function dateLocaleInput($rootScope, moment, defaultDateFormat) {
    return {
      restrict: 'A',
      require: '?ngModel',
      scope: {
        format: '@'
      },
      link: function(scope, element, attr, ngModel) {
        scope.default_value = null;
        scope.date_format = scope.format || defaultDateFormat || 'L';

        scope.update_value = function(value) {
          if (!scope.default_value || scope.default_value !== value) {
            scope.default_value = value;
          }
          var m = moment(value);
          return m.isValid() ? m.format(scope.date_format) : value;
        };

        if (ngModel) {
          ngModel.$formatters.push(function(modelValue) {
            return scope.update_value(modelValue);
          });
          ngModel.$parsers.push(function() {
            return scope.default_value;
          });
        } else {
          attr.$observe('value', function(interpolatedValue) {
            element[0].value = scope.update_value(interpolatedValue);
          });
        }

        var translateListener = $rootScope.$on('$translateChangeSuccess', function() {
          var newValue = scope.update_value(scope.default_value);
          if (ngModel) {
            ngModel.$setViewValue(newValue);
            ngModel.$render();
          } else {
            element[0].value = newValue;
          }
        });

        scope.$on('$destroy', translateListener);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('dateLocale', dateLocale);

  dateLocale.$inject = ['$rootScope', 'moment', 'defaultDateFormat'];

  function dateLocale($rootScope, moment, defaultDateFormat) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var default_value = null,
          translateListener;

        scope.updateContent = function(value) {
          if (!default_value) {
            default_value = value;
          }

          var val = value || default_value || element[0].textContent,
            format = attr.format || defaultDateFormat || 'L',
            m = moment(val);

          element[0].innerHTML = m.isValid() ? m.format(format) : val;
        };

        attr.$observe('dateLocale', function(interpolatedValue) {
          scope.updateContent(interpolatedValue);
        });

        translateListener = $rootScope.$on('$translateChangeSuccess', function() {
          scope.updateContent();
        });

        scope.$on('$destroy', translateListener);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('ComponentRegistry', ComponentRegistry);

  ComponentRegistry.$inject = ['$mdComponentRegistry'];

  function ComponentRegistry($mdComponentRegistry) {
    var registry = {};

    registry.getComponent = function(name) {
      return $mdComponentRegistry.when(name);
    };

    return registry;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        checkboxes_list: [
          'import_from_csv||checkboxes_list.import_from_csv',
          'check_all||checkboxes_list.check_all',
          'clear_all||checkboxes_list.clear_all',
          'selected||checkboxes_list.selected',
          'from||checkboxes_list.from',
          'no_data||checkboxes_list.no_data'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('CheckboxesList', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('checkboxList', checkboxList);

  checkboxList.$inject = ['$translate', '_'];

  function checkboxList($translate, _) {
    return {
      restrict: 'E',
      scope: {
        list: '=',
        fieldName: '@',
        fieldToServer: '@',
        callback: '&',
        valueTranslateNamespace: '=?',
        importFile: '&?',
        showBtn: '=?',
        disableSearch: '=?',
        locales: '=?',
        allDisabled: '=?'
      },
      templateUrl: 'app/components/shared/checkbox_list/checkbox_list.html',
      controllerAs: 'checkbox_list',
      controller: function($scope) {
        var vm = this;

        $scope.translate_key = 'CheckboxesList';
        $scope.list = $scope.list || [];
        vm.field_name = $scope.fieldName || 'name';
        vm.fieldToServer = $scope.fieldToServer || 'id';
        vm.search_field = '';
        vm.preventMultiClicks = false;

        if ($scope.callback) {
          vm.callback = $scope.callback();
        }

        function toggle(item) {
          var index = _.indexOf(vm.virtual_repeat.selected, item);
          if (~index) {
            vm.virtual_repeat.selected.splice(index, 1);
          } else {
            vm.virtual_repeat.selected.push(item);
          }
          item.check = !item.check;

          sync_group_checkbox();
        }

        function toggle_all(route) {
          vm.virtual_repeat.selected = _.filter(vm.virtual_repeat.items, function(item) {
            item.check = route;
            return route;
          });

          sync_group_checkbox();
        }

        function toggle_group(groupName, selected) {
          var items = vm.groupedItems[groupName] || [];

          items.forEach(function(item) {
            item.check = selected;
          });

          vm.virtual_repeat.selected = _.filter(vm.virtual_repeat.items, {check: true});
        }

        function sync_group_checkbox() {
          vm.groupSelections = {};

          if (!vm.groupedItems) {
            return;
          }

          Object.entries(vm.groupedItems).forEach(function(entry) {
            var groupName = entry[0],
              groupItems = entry[1],
              // 그룹 안 모든 항목이 check: true 이면 그룹 체크박스도 true
              allChecked = groupItems.every(function(item) {
                return item.check === true;
              });

            vm.groupSelections[groupName] = allChecked;
          });
        }

        function group_items(items) {
          var grouped = {};

          items.forEach(function(item) {
            if (_.isArray(item.group)) {
              item.group.forEach(function(groupName) {
                if (!grouped[groupName]) {
                  grouped[groupName] = [];
                }
                grouped[groupName].push(item);
              });
            }
          });

          return Object.keys(grouped).length > 0 ? grouped : null;
        }

        vm.toggle = function(item) {
          if (vm.preventMultiClicks) {
            return;
          }

          vm.preventMultiClicks = true;

          if (vm.callback) {
            vm.callback(
              angular.isDefined(item[vm.fieldToServer]) ? item[vm.fieldToServer] : item[vm.field_name],
              null,
              !item.check
            )
              .then(function() {
                toggle(item);
              })
              .finally(function() {
                vm.preventMultiClicks = false;
              });
          } else {
            toggle(item);
            vm.preventMultiClicks = false;
          }
        };

        vm.choose_all = function() {
          if (vm.preventMultiClicks) {
            return;
          }

          vm.preventMultiClicks = true;

          if (vm.callback) {
            vm.callback('all', null, true, vm.search_field)
              .then(function() {
                toggle_all(true);
              })
              .finally(function() {
                vm.preventMultiClicks = false;
              });
          } else {
            toggle_all(true);
            vm.preventMultiClicks = false;
          }
        };

        vm.reset_all = function() {
          if (vm.preventMultiClicks) {
            return;
          }

          vm.preventMultiClicks = true;

          if (vm.callback) {
            vm.callback('all', null, false, vm.search_field)
              .then(function() {
                toggle_all(false);
              })
              .finally(function() {
                vm.preventMultiClicks = false;
              });
          } else {
            toggle_all(false);
            vm.preventMultiClicks = false;
          }
        };

        vm.choose_group = function(groupName, selected) {
          if (vm.preventMultiClicks) {
            return;
          }

          vm.preventMultiClicks = true;

          // 그룹에 속한 국가들 추출 (1:N 관계 고려)
          var items = vm.groupedItems[groupName] || [],
            uniqueItems = _.uniq(items), // 혹시라도 중복 방지
            applySelection = function() {
              _.forEach(uniqueItems, function(item) {
                item.check = selected;
              });

              // 선택 상태 동기화
              toggle_group(groupName, selected);
            };

          if (vm.callback) {
            vm.callback('group', groupName, selected, vm.search_field)
              .then(applySelection)
              .finally(function() {
                vm.preventMultiClicks = false;
              });
          } else {
            applySelection();
            vm.preventMultiClicks = false;
          }
        };

        vm.update_selected = function() {
          vm.virtual_repeat.filtering(vm.search_field);
          vm.virtual_repeat.getSelected();
        };

        vm.clear = function() {
          vm.search_field = '';
          vm.update_selected();
        };

        vm.virtual_repeat = {
          items: $scope.list,
          selected: [],
          getSelected: function() {
            this.selected = _.filter(this.items, function(item) {
              return item.check;
            });
          },
          refresh: function(newList) {
            this.items = newList;
            vm.update_selected();
          },
          filtering: function(search_text) {
            this.items = _.filter($scope.list, function(item) {
              var original_value = $scope.valueTranslateNamespace
                  ? $translate.instant($scope.valueTranslateNamespace + item[vm.field_name])
                  : item[vm.field_name],
                convert_value = original_value ? original_value.toString().toLowerCase() : '',
                find = !search_text || convert_value.indexOf(search_text.toLowerCase()) !== -1;

              return find;
            });
          },
          getItemAtIndex: function(index) {
            return this.items[index];
          },
          getLength: function() {
            return this.items.length;
          }
        };

        $scope.$watch('list', function(newValue) {
          if (_.isArray(newValue)) {
            vm.search_field = '';
            vm.virtual_repeat.refresh(newValue);
            vm.groupedItems = group_items(newValue);

            sync_group_checkbox();
          }
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateBannerRunner', AffiliateBannerRunner);

  AffiliateBannerRunner.$inject = ['User', 'UserlocalStorage', '$mdDialog', 'AffiliateBannerApi', 'permissionsManager'];

  function AffiliateBannerRunner(User, UserlocalStorage, $mdDialog, AffiliateBannerApi, permissionsManager) {
    var AffiliateBannerRunner = {};

    AffiliateBannerRunner.data = {};

    AffiliateBannerRunner.getBanner = function() {
      return AffiliateBannerApi.getBanner('affiliate').then(function(response) {
        return response.data && response.data.banner;
      });
    };

    AffiliateBannerRunner.checkBanner = function() {
      if (
        User.getUserProperty('namespace') !== 'affiliate' ||
        !permissionsManager.checkPermission('api2.affiliate.bannerscontroller.list')
      ) {
        return;
      }

      AffiliateBannerRunner.getBanner().then(function(banner) {
        if (AffiliateBannerRunner.shouldOpen(banner)) {
          AffiliateBannerRunner.openModal(banner);
        }
      });
    };

    AffiliateBannerRunner.shouldOpen = function(banner) {
      AffiliateBannerRunner.data = UserlocalStorage.get('banner') || {};

      return (
        !User.getSupervisionValue() &&
        User.getUserProperty('namespace') === 'affiliate' &&
        banner &&
        AffiliateBannerRunner.data.updated_at !== banner.updated_at &&
        banner.enabled
      );
    };

    AffiliateBannerRunner.markBannerViewed = function(banner) {
      AffiliateBannerRunner.data.updated_at = banner.updated_at;
      UserlocalStorage.save('banner', AffiliateBannerRunner.data);
    };

    AffiliateBannerRunner.openModal = function(banner, preview, ev) {
      $mdDialog.show({
        controller: 'AffiliateBannerController',
        controllerAs: '$ctrl',
        templateUrl: 'app/components/shared/affiliate_banner/affiliate_banner.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        bindToController: true,
        clickOutsideToClose: preview,
        escapeToClose: preview,
        locals: {
          banner: banner,
          preview: preview
        }
      });
    };

    return AffiliateBannerRunner;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateBannerController', AffiliateBannerController);

  AffiliateBannerController.$inject = ['$mdDialog', 'AffiliateBannerRunner'];

  function AffiliateBannerController($mdDialog, AffiliateBannerRunner) {
    var vm = this;

    vm.closePopup = function() {
      if (!vm.preview) {
        AffiliateBannerRunner.markBannerViewed(vm.banner);
      }
      $mdDialog.hide();
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('paymentSystemsDetails', paymentSystemsDetails);

  paymentSystemsDetails.$inject = ['$q', '$mdDialog', '$mdMedia', '$mdTranslate', 'BalanceService', '_'];

  function paymentSystemsDetails($q, $mdDialog, $mdMedia, $mdTranslate, BalanceService, _) {
    return {
      restrict: 'E',
      require: '^?form',
      scope: {
        type: '=',
        paymentSystems: '=',
        currentSystem: '=',
        countriesList: '=',
        defaultPaymentSystemId: '=?',
        fieldsNamePart: '=?',
        errors: '=',
        defaultSystemCheckbox: '=?',
        pristineForm: '=?',
        name: '=?',
        defaultSystemWithoutApprove: '=?'
      },
      templateUrl: 'app/components/shared/affiliate_balance/partials/payment_systems_details.html',
      controllerAs: '$ctrl',
      bindToController: true,
      link: function(scope, element, attr, formCtrl) {
        scope.$watch('$ctrl.selectedSystemType', function(newValue) {
          if (!newValue || !formCtrl || !scope.$ctrl.pristineForm) {
            return;
          }

          formCtrl.$setPristine();
          formCtrl.$setUntouched();
        });
      },
      controller: function($scope) {
        var vm = this;

        var CANADA_BANK_COUNTRY_CODE = 124;

        vm.translate_key = 'AffiliateBalance';
        vm.regExp = '(^[0-9]{1,2})\\.([0-9]{4}$)';
        vm.availableSystems = [];
        vm.paymentSystemsList = [];
        vm.selectedSystemType = '';
        vm.selectedSystem = {};
        vm.pristineForm = _.isUndefined(vm.pristineForm) ? true : vm.pristineForm;
        vm.defaultSystemCheckbox = _.isUndefined(vm.defaultSystemCheckbox) ? true : vm.defaultSystemCheckbox;
        vm.fieldsNamePart = _.isUndefined(vm.fieldsNamePart) ? '' : vm.fieldsNamePart;
        vm.defaultSystemType = '';

        vm.allPaymentSystems = BalanceService.getPaymentSystems();

        vm.getSystemByType = function(list, type) {
          return _.findWhere(list, {type: type});
        };

        vm.currentSystemControl = function(availableSystems, defaultSystemId) {
          if (!defaultSystemId) {
            vm.setDefaultPaymentSystem();
          } else {
            var system = _.findWhere(availableSystems, {id: defaultSystemId});

            if (system) {
              vm.activateDefaultSystem(system.type);
              vm.setSystemFromAvailable(system.type);
            } else {
              vm.setDefaultPaymentSystem();
            }
          }
        };

        vm.setSystemFromAvailable = function(type) {
          vm.choosePaymentSystem(vm.getSystemByType(vm.availableSystems, type));
        };

        vm.setDefaultPaymentSystem = function() {
          var system = _.findWhere(vm.paymentSystemsList, {default: true}) || _.first(vm.paymentSystemsList);

          if (system) {
            vm.setSystemFromAvailable(system.type);
          }
        };

        vm.changePaymentSystem = function() {
          vm.setSystemFromAvailable(vm.selectedSystemType);
        };

        vm.choosePaymentSystem = function(paymentSystem) {
          vm.selectedSystem = paymentSystem;
          vm.selectedSystemType = vm.selectedSystem.type;
          vm.currentSystem = vm.getSystemByType(vm.paymentSystemsList, vm.selectedSystemType);
        };

        vm.filterPaymentSystems = function(availableSystems) {
          var types = _.pluck(availableSystems, 'type');

          vm.availableSystems = _.filter(vm.allPaymentSystems, function(item) {
            return _.contains(types, item.type);
          });
        };

        vm.activateDefaultSystem = function(currentType, excludeType, value) {
          _.each(excludeType ? _.reject(vm.paymentSystemsList, {type: excludeType}) : vm.paymentSystemsList, function(
            system
          ) {
            system.default = system.type === currentType ? value || !system.default : false;
          });
        };

        vm.setUpDefaultSystem = function(ev) {
          if (vm.currentSystem.default && vm.defaultSystemType === vm.selectedSystemType) {
            return;
          }

          var currentType = vm.selectedSystemType,
            result =
              vm.defaultSystemWithoutApprove || vm.currentSystem.default
                ? $q.when()
                : vm.approveDefaultPaymentSystem(ev);

          result.then(function() {
            vm.activateDefaultSystem(currentType, vm.defaultSystemType);
          });
        };

        vm.fieldControl = function(fieldName) {
          return _.has(vm.selectedSystem.fields, fieldName);
        };

        vm.isRequired = function(fieldName) {
          return vm.selectedSystem.fields[fieldName] && vm.selectedSystem.fields[fieldName].presence;
        };

        vm.isCanadaBankCountry = function() {
          return vm.currentSystem.country_code === CANADA_BANK_COUNTRY_CODE;
        };

        vm.fieldShortcodeControl = function(fieldName) {
          return BalanceService.findFieldShortcode(vm.selectedSystem, fieldName);
        };

        vm.fieldNameControl = function(fieldName) {
          return vm.fieldsNamePart + fieldName;
        };

        vm.approveDefaultPaymentSystem = function(ev) {
          var confirm = $mdDialog
            .confirm()
            .title($mdTranslate.instant(vm.translate_key, 'approve_default_payment_system.title'))
            .textContent($mdTranslate.instant(vm.translate_key, 'approve_default_payment_system.question'))
            .targetEvent(ev)
            .clickOutsideToClose(true)
            .ok($mdTranslate.instant(vm.translate_key, 'approve_default_payment_system.ok'))
            .cancel($mdTranslate.instant(vm.translate_key, 'approve_default_payment_system.cancel'));

          return $mdDialog.show(confirm);
        };

        vm.prepareSystemsList = function(systemsList) {
          return _.map(systemsList, function(system) {
            return _.extend({}, _.first(_.values(system)), {type: _.first(_.keys(system))});
          });
        };

        vm.setDefaultPaymentSystemType = function() {
          vm.defaultSystemType = _.propertyOf(_.findWhere(vm.paymentSystemsList, {default: true}))('type');
        };

        vm.saveDecorator = function(saveMethod) {
          var isCurrentDefault = vm.currentSystem.default,
            currentSystemType = vm.currentSystem.type;

          return saveMethod().then(function() {
            if (isCurrentDefault) {
              vm.activateDefaultSystem(currentSystemType, null, true);
              vm.setDefaultPaymentSystemType();
            }
          });
        };

        BalanceService.addSaveDecorator(vm.name, vm.saveDecorator);

        $scope.$watch('$ctrl.paymentSystems', function(availableSystems) {
          if (!availableSystems) {
            return;
          }

          vm.paymentSystemsList = vm.prepareSystemsList(availableSystems);

          vm.filterPaymentSystems(vm.paymentSystemsList);
          vm.currentSystemControl(vm.paymentSystemsList, vm.defaultPaymentSystemId);
          vm.setDefaultPaymentSystemType();
        });

        $scope.$watch('$ctrl.defaultPaymentSystemId', function(value) {
          if (_.size(vm.paymentSystemsList) === 0) {
            return;
          }

          vm.currentSystemControl(vm.paymentSystemsList, value);
          vm.setDefaultPaymentSystemType();
        });

        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            vm.isGtXs = value;
          }
        );

        $scope.$on('$destroy', function() {
          BalanceService.removeSaveDecorator(vm.name);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('balanceItem', balanceItem);

  balanceItem.$inject = [];

  function balanceItem() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        amount: '=',
        currency: '=',
        withdrawalFunc: '&',
        withdrawalPermission: '=',
        getBalanceAmount: '&'
      },
      templateUrl: 'app/components/shared/affiliate_balance/partials/balance_item.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function() {
        var vm = this;

        vm.balanceWithdrawal = function() {
          if (vm.withdrawalFunc) {
            vm.withdrawalFunc({data: vm.amount});
          }
        };

        vm.filterBalanceAmount = function() {
          if (vm.getBalanceAmount) {
            return vm.getBalanceAmount(vm.amount);
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('BalanceService', BalanceService);

  BalanceService.$inject = ['AffiliateBalanceApi', 'toastsApi', 'permissionsManager', 'projectCurrency', '$q', '_'];

  function BalanceService(AffiliateBalanceApi, toastsApi, permissionsManager, projectCurrency, $q, _) {
    var balanceService = {},
      storage = [],
      // Earned/total figures from current_balance (display-only). `storage` stays the booked
      // (withdrawable) balance for back-compat with the withdrawal flow + balance-item card.
      balanceData = {},
      saveDecorators = {},
      paymentSystems = [
        {
          type: 'Epayments',
          fields: {
            wallet: {presence: true}
          },
          shortcode: 'epayments'
        },
        {
          type: 'Neteller',
          fields: {
            username: {presence: true},
            email: {presence: true}
          },
          shortcode: 'neteller'
        },
        {
          type: 'Paypal',
          fields: {
            username: {presence: true},
            email: {presence: true}
          },
          shortcode: 'paypal'
        },
        {
          type: 'Webmoney',
          fields: {
            username: {presence: true},
            wallet: {presence: true}
          },
          shortcode: 'webmoney'
        },
        {
          type: 'Bank transfer',
          fields: {
            country_code: {presence: false},
            company_name: {presence: false},
            company_country: {presence: false},
            company_city: {presence: false},
            company_address: {presence: false},
            company_postal: {presence: false},
            bank_name: {presence: false},
            bank_country: {presence: false},
            bank_address: {presence: false},
            bank_city: {presence: false},
            bank_postal: {presence: false},
            iban: {presence: false},
            bic: {presence: false},
            account_holders_name: {presence: false},
            branch_code: {presence: false},
            routing_number: {presence: false},
            bank_transit_code: {presence: false},
            institution_number: {presence: false},
            bank_account_number: {presence: false}
          },
          shortcode: 'bank_transfer'
        },
        {
          type: 'Visa/Master card',
          fields: {
            username: {presence: true},
            card_number: {presence: true},
            bank_name: {presence: true},
            country: {presence: true},
            city: {presence: true},
            address: {presence: true},
            iban: {presence: true},
            bic: {presence: true},
            swift: {presence: true}
          },
          shortcode: 'bank_card'
        },
        {
          type: 'Yandex.Money',
          fields: {
            wallet: {presence: true}
          },
          shortcode: 'yandex_money'
        },
        {
          type: 'Qiwi',
          fields: {
            phone_number: {presence: true}
          },
          shortcode: 'qiwi'
        },
        {
          type: 'Capitalist',
          fields: {
            wallet: {presence: true}
          },
          shortcode: 'capitalist'
        },
        {
          type: 'USDT (erc20)',
          fields: {
            wallet: {presence: true}
          },
          shortcode: 'usdt_erc20'
        },
        {
          type: 'USDT (trc20)',
          fields: {
            wallet: {presence: true}
          },
          shortcode: 'usdt_trc20'
        },
        {
          type: 'Skrill',
          fields: {
            username: {presence: true},
            email: {presence: true}
          },
          shortcode: 'skrill'
        },
        {
          type: 'Player account',
          fields: {
            poker_nickname: {presence: true}
          },
          shortcode: 'player_account'
        },
        {
          type: 'Bitcoin',
          fields: {
            wallet: {presence: true}
          },
          shortcode: 'bitcoin'
        }
      ];

    balanceService.getPaymentSystems = function() {
      return angular.copy(paymentSystems);
    };

    balanceService.getAllFields = function() {
      return _.uniq(_.flatten(_.map(_.pluck(paymentSystems, 'fields'), _.keys)));
    };

    balanceService.findFieldShortcode = function(system, fieldName) {
      return 'payment_details_form.' + (system && system.shortcode) + '.' + fieldName;
    };

    balanceService.getBalance = function() {
      return storage;
    };

    balanceService.getCurrency = function() {
      return projectCurrency.getCurrency();
    };

    balanceService.setAffiliateBalance = function(balance) {
      storage = _.isNumber(balance) ? balance : null;
    };

    balanceService.setBalanceData = function(data) {
      balanceData = _.isObject(data) ? data : {};
    };

    function readNumber(key) {
      return _.isNumber(balanceData[key]) ? balanceData[key] : null;
    }

    // Earned (booked + below-threshold carryover) for the currently selected brand.
    balanceService.getBrandEarned = function() {
      return readNumber('brand_earned');
    };

    // Current per-brand payout minimum.
    balanceService.getBrandLimit = function() {
      return readNumber('brand_limit');
    };

    // How much more is needed before the selected brand becomes withdrawable (0 once payable).
    balanceService.getRemainingToLimit = function() {
      return readNumber('remaining_to_limit');
    };

    // Total earned across all (non-retired) brands. True net — can be negative.
    balanceService.getTotalEarned = function() {
      return readNumber('total_earned');
    };

    // True while a backdated commission correction is being computed for the current month (Eddie Q2) —
    // the earned/total figures above come back null for the duration.
    balanceService.isRecalculating = function() {
      return !!balanceData.recalculating;
    };

    balanceService.updateBalance = function() {
      if (!permissionsManager.checkPermission('api2.affiliate.cashoutscontroller.show_balance')) {
        return $q.when();
      }

      var promise = AffiliateBalanceApi.getBalance();

      promise.then(
        function(response) {
          balanceService.setAffiliateBalance(response.data.balance);
          balanceService.setBalanceData(response.data);
          return response;
        },
        function(response) {
          toastsApi.toastError();
          return response;
        }
      );

      return promise;
    };

    balanceService.getPaymentData = function(paymentSystem) {
      return _.extend(
        {},
        {name: paymentSystem.type, default: paymentSystem.default || false},
        _.omit(paymentSystem, 'type', 'default')
      );
    };

    balanceService.addSaveDecorator = function(name, decorator) {
      saveDecorators[name] = _.isFunction(decorator) ? decorator : _.noop;
    };

    balanceService.removeSaveDecorator = function(name) {
      saveDecorators = _.omit(saveDecorators, name);
    };

    balanceService.decorateSaveMethod = function(name, saveMethod) {
      return function() {
        return _.isFunction(saveDecorators[name]) ? saveDecorators[name](saveMethod) : saveMethod();
      };
    };

    return balanceService;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('balance', balance);

  balance.$inject = ['BalanceService', '$state'];

  function balance(BalanceService, $state) {
    return {
      restrict: 'E',
      scope: {
        withdrawalFunc: '&',
        withdrawalPermission: '=',
        watchMerchant: '='
      },
      templateUrl: function($elem, $attrs) {
        if ($attrs.placed === 'header') {
          return 'app/components/shared/affiliate_balance/partials/header_balance.html';
        } else if ($attrs.placed === 'affiliate') {
          return 'app/components/shared/affiliate_balance/partials/affiliate_balance.html';
        }
      },
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope) {
        var vm = this;

        BalanceService.updateBalance();

        vm.getBalance = function() {
          return BalanceService.getBalance();
        };

        vm.getBrandEarned = function() {
          return BalanceService.getBrandEarned();
        };

        vm.getBrandLimit = function() {
          return BalanceService.getBrandLimit();
        };

        vm.getRemainingToLimit = function() {
          return BalanceService.getRemainingToLimit();
        };

        vm.getTotalEarned = function() {
          return BalanceService.getTotalEarned();
        };

        vm.isRecalculating = function() {
          return BalanceService.isRecalculating();
        };

        // True only while the selected brand is genuinely accruing toward its payout minimum
        // (0 <= earned < limit). A negative balance is NOT "on its way to payable" -> show the
        // negative note instead, never both.
        vm.isBelowLimit = function() {
          return BalanceService.getBrandEarned() >= 0 && BalanceService.getRemainingToLimit() > 0;
        };

        vm.getCurrency = function() {
          return BalanceService.getCurrency();
        };

        vm.goToAffiliateBalance = function() {
          $state.go('affiliate_balance');
        };

        if (vm.watchMerchant) {
          $scope.$on('$changeMerchantSuccess', function() {
            BalanceService.updateBalance();
          });
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('accordionGroupButton', accordionGroupButton);

  accordionGroupButton.$inject = [];

  function accordionGroupButton() {
    return {
      restrict: 'E',
      require: '^^accordionGroup',
      transclude: true,
      template: '<md-button class="md-icon-button" ng-click="toggle()"><ng-transclude></ng-transclude></md-button>',
      link: function(scope, element, attr, groupCtrl) {
        scope.toggle = function() {
          groupCtrl.toggle();
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('accordionGroup', accordion);

  accordion.$inject = ['_'];

  function accordion(_) {
    return {
      restrict: 'E',
      require: '^^?accordion',
      replace: true,
      scope: {
        openItem: '=?',
        groupId: '=?',
        defaultOpen: '=?',
        onInit: '&?',
        onToggleEnd: '&?',
        onToggleStart: '&?'
      },
      transclude: {
        contentSlot: '?accordionGroupContent',
        headingSlot: '?accordionGroupHeading'
      },
      templateUrl: 'app/components/shared/accordion/accordion_group.html',
      bindToController: true,
      controllerAs: 'groupCtrl',
      controller: function($scope, $element) {
        var vm = this;

        vm.groupId = vm.groupId || _.uniqueId('accordion-group-');
        vm.open = _.isUndefined(vm.openItem) ? vm.defaultOpen || false : vm.openItem;
        $element.toggleClass('hidden', !vm.open);

        vm.toggle = function() {
          vm.open = !vm.open;
          vm.openItem = vm.open;
        };
      },
      link: function(scope, element, attr, accordionCtrl) {
        var content = element[0].querySelector('.accordion-group-content'),
          contentHolder = content.querySelector('.accordion-group-content-holder');

        accordionCtrl && accordionCtrl.addGroup(scope.groupCtrl);

        function getRefElement() {
          return element;
        }

        if (_.isFunction(scope.groupCtrl.onInit)) {
          scope.groupCtrl.onInit({isOpen: scope.groupCtrl.open, getRefElement: getRefElement});
        }

        scope.$watch('groupCtrl.openItem', function(value) {
          var animation;

          scope.groupCtrl.open = value;

          if (contentHolder.offsetHeight > 0) {
            if (_.isFunction(scope.groupCtrl.onToggleStart)) {
              scope.groupCtrl.onToggleStart({isOpen: scope.groupCtrl.open, getRefElement: getRefElement});
            }

            animation = content.animate(
              [
                {
                  height: content.offsetHeight + 'px'
                },
                {
                  height: value ? contentHolder.offsetHeight + 'px' : '0px'
                }
              ],
              {
                duration: accordionCtrl.duration,
                easing: accordionCtrl.easing
              }
            );

            if (animation.finished && animation.finished.then) {
              animation.finished.then(function() {
                if (_.isFunction(scope.groupCtrl.onToggleEnd)) {
                  scope.groupCtrl.onToggleEnd({isOpen: scope.groupCtrl.open, getRefElement: getRefElement});
                }
              });
            }
          }
          accordionCtrl.groupToggled(scope.groupCtrl);
          element.toggleClass('hidden', !scope.groupCtrl.open);
        });

        scope.$on('$destroy', function() {
          accordionCtrl && accordionCtrl.removeGroup(scope.groupCtrl);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('accordion', accordion);

  accordion.$inject = ['_'];

  function accordion(_) {
    return {
      restrict: 'E',
      scope: {
        oneOpened: '=?',
        collapseAll: '=?',
        duration: '=?',
        easing: '@?'
      },
      transclude: true,
      template: '<ng-transclude></ng-transclude>',
      bindToController: true,
      controllerAs: 'accordionCtrl',
      controller: function($scope) {
        var vm = this;

        vm.duration = vm.duration || 225;
        vm.easing = vm.easing || 'cubic-bezier(0.4, 0, 0.2, 1)';
        vm.oneOpened = _.isUndefined(vm.oneOpened) ? true : vm.oneOpened;
        vm.groups = [];

        vm.addGroup = function(group) {
          vm.groups.push(group);
        };

        vm.removeGroup = function(group) {
          vm.groups = _.reject(vm.groups, {groupId: group.groupId});
        };

        vm.checkAll = function(value) {
          return _.every(vm.groups, function(group) {
            return group.open === value;
          });
        };

        vm.toggleAll = function(collapseAll) {
          _.each(vm.groups, function(group) {
            if ((collapseAll && group.open) || (!collapseAll && !group.open)) {
              group.toggle();
            }
          });
        };

        vm.groupToggled = function(group) {
          if (vm.oneOpened && group.open) {
            _.each(_.reject(vm.groups, {groupId: group.groupId}), function(item) {
              if (item.open) {
                item.toggle();
              }
            });
          } else {
            vm.isAllCollapsed = vm.checkAll(false);
            vm.isAllOpened = vm.checkAll(true);

            if (vm.isAllCollapsed) {
              vm.collapseAll = true;
            }
            if (vm.isAllOpened) {
              vm.collapseAll = false;
            }
          }
        };

        $scope.$watch('accordionCtrl.collapseAll', function(value) {
          if (!_.isUndefined(value)) {
            vm.toggleAll(value);
          }
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').provider('translateManager', translateManagerProvider);

  function translateManagerProvider() {
    var localization_map = {},
      _this = this;

    _this.add_locals_list = function(values) {
      angular.merge(localization_map, values);
    };

    function translateManager(mainApi, _, $q) {
      return new translateManagerApi(mainApi, localization_map, _, $q);
    }

    translateManager.$inject = ['mainApi', '_', '$q'];

    _this.$get = translateManager;
  }

  function translateManagerApi(mainApi, localization_map, _, $q) {
    var _this = this,
      frontend_locales = {},
      frontend_locales_string = [],
      server_locales = {};

    _this.get_backend_list = function() {
      var deferred = $q.defer();

      mainApi.get('admin/translate_manager/server_marks', {}).then(function(res) {
        angular.merge(server_locales, _this.prepare_list_hash(angular.fromJson(res.data.server_locales)));
        deferred.resolve(server_locales);
      });

      return deferred.promise;
    };

    _this.get_frontend_list = function() {
      return frontend_locales;
    };

    _this.get_frontend_list_string = function() {
      return frontend_locales_string;
    };

    _this.prepare_list_hash = function(hash_list, result) {
      var _result = result || {};
      _.each(hash_list, function(value, key) {
        if (value !== '') {
          _result[key] = {};
          if (_.isArray(value)) {
            _.each(value, function(v) {
              if (_.isObject(v)) {
                _this.prepare_list_hash(v, _result[key]);
              } else {
                _result[key][get_key(v)] = '';
              }
            });
          } else {
            _this.prepare_list_hash(value, _result[key]);
          }
        } else {
          _result[key] = '';
        }
      });
      return _result;
    };

    _this.string_list = function(hash_list, result) {
      var _result = result || '';

      return _.map(hash_list, function(value, key) {
        var res_k = _result === '' ? _result + key : _result + '.' + key;
        if (value === '') {
          return res_k;
        } else {
          if (_.isArray(value)) {
            return _.map(value, function(v) {
              if (_.isObject(v)) {
                return _this.string_list(v, res_k);
              } else {
                return res_k + '.' + get_key(v);
              }
            });
          } else {
            return _this.string_list(value, res_k);
          }
        }
      });
    };

    function get_key(key) {
      return key.split('||').shift();
    }

    _this.string_to_hash_backward = function(str, value) {
      var h = {},
        p_s = str.split('.'),
        key = p_s.pop();

      h[key] = value;

      if (!key) {
        return value;
      } else {
        return _this.string_to_hash_backward(p_s.join('.'), h);
      }
    };

    _this.save = function(language, key, value) {
      var url = 'admin/translate_manager/save',
        params = {language: language, new_localisation_data: _this.string_to_hash_backward(key, value)};

      return mainApi.post(url, params);
    };

    frontend_locales = _this.prepare_list_hash(localization_map);
    frontend_locales_string = _.flatten(_this.string_list(localization_map));
  }
})();

(function() {
  'use strict';

  function customInterpolation($interpolate, $state) {
    return {
      setLocale: function() {},
      getInterpolationIdentifier: function() {
        return 'custom';
      },
      interpolate: function(string, interpolateParams) {
        if ($state.current.name !== 'translate_manager') {
          return $interpolate(string)(interpolateParams);
        } else {
          return string;
        }
      }
    };
  }

  customInterpolation.$inject = ['$interpolate', '$state'];

  angular.module('quintessenceAngular').factory('customInterpolation', customInterpolation);
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('asyncLoader', asyncLoader);

  asyncLoader.$inject = ['localesStorage', 'mainApi'];

  function asyncLoader(localesStorage, mainApi) {
    return function(options) {
      var url = 'anonym/translate/locals_list',
        params = {language: options.key};

      return mainApi.get(url, params).then(function(res) {
        localesStorage.replaceValueToEmptyString(res.data);
        return res.data;
      });
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('toastsApi', toastsApi);

  toastsApi.$inject = ['$mdToast', '$translate', '_'];

  function toastsApi($mdToast, $translate, _) {
    var toasts = {},
      defaultOpts = {
        templateUrl: 'app/components/extensions/toasts/toasts.html',
        toastClass: '',
        controller: 'ToastsController',
        controllerAs: '$ctrl',
        position: 'bottom right',
        bindToController: true,
        hideDelay: false,
        locals: {}
      };

    toasts.prepareErrors = function(res) {
      var errors = res && res.data && res.data.errors,
        result;

      if (_.isEmpty(errors)) {
        return;
      }

      result = _.reduce(
        errors,
        function(acc, item) {
          var itemErrors = _.reduce(
            item,
            function(a, er) {
              return a + $translate.instant(er) + '\n';
            },
            ''
          );
          return acc + itemErrors;
        },
        ''
      );

      return result;
    };

    toasts.createToast = function(data, options, toastType) {
      var locals = _.isObject(data || {}) ? _.extend({}, data) : {text: data},
        additional = {locals: locals, toastClass: toastType},
        opts = _.extend({}, defaultOpts, additional, _.omit(options, 'locals'));

      return $mdToast.show(opts);
    };

    toasts.toastCopySuccess = function(data, options) {
      return toasts.createToast(data || {status: 'copy_success'}, options, 'success');
    };

    toasts.toastCreateSuccess = function(data, options) {
      return toasts.createToast(data || {status: 'create_success'}, options, 'success');
    };

    toasts.toastEditSuccess = function(data, options) {
      return toasts.createToast(data || {status: 'edit_success'}, options, 'success');
    };

    toasts.toastRemoveSuccess = function(data, options) {
      return toasts.createToast(data || {status: 'remove_success'}, options, 'success');
    };

    toasts.toastSuccess = function(data, options) {
      return toasts.createToast(data, options, 'success');
    };

    toasts.toastError = function(data, options) {
      return toasts.createToast(data, options, 'error');
    };

    toasts.toastWarn = function(data, options) {
      return toasts.createToast(data, options, 'warn');
    };

    toasts.toastInfo = function(data, options) {
      return toasts.createToast(data, options, 'info');
    };

    toasts.toastDefault = function(data, options) {
      return toasts.createToast(data, options, '');
    };

    return toasts;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('ToastsController', ToastsController);

  ToastsController.$inject = ['$scope', '$mdToast', '$timeout', '_'];

  function ToastsController($scope, $mdToast, $timeout, _) {
    var vm = this,
      translate_key = 'Toasts';

    vm.timeoutId = null;

    vm.conformity = {
      access_error: {translate_key: translate_key, shortcode: 'toasts.access_error'},
      create_success: {translate_key: translate_key, shortcode: 'toasts.created'},
      edit_success: {translate_key: translate_key, shortcode: 'toasts.edited'},
      remove_success: {translate_key: translate_key, shortcode: 'toasts.removed'},
      copy_success: {translate_key: translate_key, shortcode: 'toasts.copied'}
    };

    vm.transmittedData = _.pick(vm.locals, 'text', 'locale', 'translate_key', 'shortcode', 'status');
    vm.defaultContent = _.isEmpty(vm.transmittedData)
      ? {translate_key: translate_key, shortcode: 'toasts.' + vm.toastClass}
      : null;

    vm.cancelTimeout = function() {
      $timeout.cancel(vm.timeoutId);
    };

    vm.closeToast = function() {
      $mdToast.hide();
      vm.cancelTimeout();
    };

    vm.timeoutId = $timeout(function() {
      vm.closeToast();
    }, 4000);

    $scope.$on('$destroy', function() {
      vm.cancelTimeout();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('toastBigContent', toastBigContent);

  toastBigContent.$inject = [];

  function toastBigContent() {
    return {
      restrict: 'A',
      link: function(scope, element) {
        var mdToastContent = element[0].querySelector('.md-toast-content'),
          toastHolder = element[0].querySelector('.toast-content-holder');

        scope.$watch(
          function() {
            return toastHolder.offsetHeight;
          },
          function(val) {
            if (val > mdToastContent.offsetHeight) {
              element.addClass('big-toast');
            }
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        toasts: [
          'success||toasts.success',
          'error||toasts.error',
          'access_error||toasts.access_error',
          'created||toasts.created',
          'edited||toasts.edited',
          'removed||toasts.removed',
          'copied||toasts.copied'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('Toasts', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('expandToastButton', expandToastButton);

  expandToastButton.$inject = [];

  function expandToastButton() {
    return {
      restrict: 'E',
      scope: {
        callback: '&?'
      },
      template: '<div class="view-more" ng-click="expandToast()"><span>...</span></div>',
      link: function(scope) {
        scope.expandToast = function() {
          var toast = document.querySelector('md-toast[toast-big-content]');

          if (!toast) {
            return;
          }

          toast.classList.add('expanded');

          if (scope.callback) {
            scope.callback();
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('textAngularAdvanced', textAngularAdvanced);

  textAngularAdvanced.$inject = ['$timeout', '_'];

  function textAngularAdvanced($timeout, _) {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        change: '&?',
        defaultMode: '@',
        only: '@',
        errors: '=?',
        translateKey: '=?',
        shortcodes: '=?',
        variablesForError: '=?',
        showDropdown: '=?',
        name: '@',
        taToolbar: '=?',
        taShowHtml: '=?',
        taUnsafeSanitizer: '=?'
      },
      controllerAs: '$ctrl',
      bindToController: true,
      templateUrl: 'app/components/extensions/text_angular_advanced/text_angular_advanced.html',
      controller: function($scope, $element) {
        var vm = this;

        vm.mode = vm.only || vm.defaultMode || 'editor';
        vm.textAreaModel = '';
        vm.editorModel = '';

        vm.getTextArea = function() {
          return $element[0].querySelector('.html-area');
        };

        vm.getIframe = function() {
          return $element[0].querySelector('.html-view');
        };

        vm.focusTextArea = function() {
          $timeout(function() {
            var textarea = vm.getTextArea();

            if (vm.textAreaModel) {
              textarea.focus();
            }
          });
        };

        vm.editorChange = function() {
          vm.data = vm.editorModel;

          if (_.isFunction(vm.change)) {
            vm.change();
          }

          vm.errors.clearError(vm.name);
        };

        vm.updateIframeContent = function() {
          var iframe = vm.getIframe();

          iframe.setAttribute('srcdoc', vm.textAreaModel);
        };

        vm.textAreaChange = function() {
          vm.data = vm.textAreaModel;

          if (_.isFunction(vm.change)) {
            vm.change();
          }

          vm.errors.clearError(vm.name);
        };

        vm.textAreaModelWasUpdated = function(ev) {
          $scope.$apply(function() {
            vm.textAreaModel = ev.target.value;
            vm.textAreaChange();
            vm.updateIframeContent();
          });
        };

        vm.textAreaHandler = _.debounce(vm.textAreaModelWasUpdated, 300);

        vm.addTextAreaListener = function() {
          $timeout(function() {
            var textarea = vm.getTextArea();

            textarea.removeEventListener('input', vm.textAreaHandler);
            textarea.addEventListener('input', vm.textAreaHandler);

            textarea.value = vm.textAreaModel;

            vm.updateIframeContent();
          });
        };

        vm.iframeLoadHandler = function() {
          var iframe = vm.getIframe(),
            iframeDoc = iframe.contentDocument ? iframe.contentDocument : iframe.contentWindow.document,
            height = iframeDoc.body.offsetHeight + (vm.textAreaModel ? 40 : 0);

          iframe.setAttribute('height', height);

          if (height > 0) {
            iframe.classList.add('loaded');
          } else {
            iframe.classList.remove('loaded');
          }
        };

        vm.addIframeLoadListener = function() {
          $timeout(function() {
            var iframe = vm.getIframe();

            iframe.removeEventListener('load', vm.iframeLoadHandler);
            iframe.addEventListener('load', vm.iframeLoadHandler);
          });
        };

        vm.switchMode = function() {
          if (vm.mode === 'html') {
            vm.addTextAreaListener();
            vm.addIframeLoadListener();
            vm.textAreaChange();
            vm.focusTextArea();
          } else {
            vm.editorChange();
          }
        };

        vm.init = function() {
          if (vm.mode === 'html') {
            vm.addTextAreaListener();
            vm.addIframeLoadListener();
          }
        };

        vm.init();

        $scope.$watch('$ctrl.data', function(value) {
          if (vm.mode === 'editor' && !angular.equals(vm.editorModel, value)) {
            vm.editorModel = value || '';
          } else if (vm.mode === 'html' && !angular.equals(vm.textAreaModel, value)) {
            vm.textAreaModel = value || '';
          }
        });

        $scope.$on('$destroy', function() {
          var textarea = vm.getTextArea(),
            iframe = vm.getIframe();

          if (textarea) {
            textarea.removeEventListener('input', vm.areaHundler);
          }
          if (iframe) {
            iframe.removeEventListener('load', vm.iframeLoadHandler);
          }
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('mdSubmit', mdSubmit);

  mdSubmit.$inject = ['$parse', '$q', '$timeout'];

  function mdSubmit($parse, $q, $timeout) {
    return {
      restrict: 'A',
      scope: true,
      link: function(scope, element, attr) {
        var invokeFunc = $parse(attr.mdSubmit);

        scope.deferred = null;
        scope.disabled = false;

        scope.submitHandler = function(event) {
          if (scope.disabled) {
            return;
          }

          scope.disabled = true;
          event.preventDefault();

          scope.deferred = invokeFunc(scope, {$event: event});

          if (!scope.deferred || !scope.deferred.finally) {
            scope.deferred = $q.when();
          }

          scope.deferred.finally(function() {
            scope.disabled = false;
          });
        };

        scope.dispatchSubmitEvent = function() {
          if (scope.disabled) {
            return;
          }

          var event = new Event('submit', {cancelable: true});

          element[0].dispatchEvent(event);
        };

        scope.dispatchSubmitEventHandler = function(ev, data) {
          if (!data || !data.name || data.name !== attr.name) {
            return;
          }

          $timeout(function() {
            scope.dispatchSubmitEvent();
          }, 0);
        };

        scope.$on('$dispatchSubmitEvent', function(ev, data) {
          scope.dispatchSubmitEventHandler(ev, data);
        });

        element[0].addEventListener('submit', scope.submitHandler);

        scope.$on('$destroy', function() {
          element[0].removeEventListener('submit', scope.submitHandler);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('mdClick', mdClick);

  mdClick.$inject = ['$parse', '$q'];

  function mdClick($parse, $q) {
    return {
      restrict: 'A',
      scope: true,
      link: function(scope, element, attr) {
        var invokeFunc = $parse(attr.mdClick);

        scope.deferred = null;
        scope.disabled = false;

        scope.disableToggle = function() {
          if (attr.needDisabled) {
            element.attr('disabled', scope.disabled);
          }
        };

        scope.clickHandler = function(event) {
          if (scope.disabled) {
            return;
          }

          scope.disabled = true;
          scope.disableToggle();

          scope.deferred = invokeFunc(scope, {$event: event});

          if (!scope.deferred || !scope.deferred.finally) {
            scope.deferred = $q.when();
          }

          scope.deferred.finally(function() {
            scope.disabled = false;
            scope.disableToggle();
          });
        };

        element[0].addEventListener('click', scope.clickHandler);

        scope.$on('$destroy', function() {
          element[0].removeEventListener('click', scope.clickHandler);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('permissionsManager', permissionsManager);

  permissionsManager.$inject = [
    '$rootScope',
    'PermPermissionStore',
    'PermRoleStore',
    'AdminPermissionsApi',
    '$q',
    '_',
    'permissionsStorage'
  ];

  function permissionsManager(
    $rootScope,
    PermPermissionStore,
    PermRoleStore,
    AdminPermissionsApi,
    $q,
    _,
    permissionsStorage
  ) {
    var permissionsManager = {};

    permissionsManager.setAllPermissions = function(permissions, userRole) {
      PermPermissionStore.defineManyPermissions(permissions, function(permissionName) {
        var rolesStore = PermRoleStore.getStore(),
          role = rolesStore[userRole],
          permissions_array = role ? role.validationFunction : [],
          result = _.contains(permissions_array, permissionName);

        return result;
      });
    };

    permissionsManager.setPermissionsForRole = function(permissionsRole) {
      PermRoleStore.defineManyRoles(permissionsRole);
    };

    permissionsManager.definePermissions = function(permissions, userRole, permissionsRole) {
      this.setAllPermissions(permissions, userRole);
      this.setPermissionsForRole(permissionsRole);
    };

    permissionsManager.clearPermissions = function() {
      PermPermissionStore.clearStore();
      PermRoleStore.clearStore();
    };

    permissionsManager.checkPermission = function(permissionName) {
      var store = PermPermissionStore.getStore(),
        result;

      _.each(store, function(value, key) {
        if (key === permissionName) {
          result = value.validationFunction(key);
        }
      });
      return result;
    };

    permissionsManager.setPermissionsFromStorage = function() {
      var storage = permissionsStorage.getPermissions();

      if (_.isEmpty(storage)) {
        return;
      }

      this.definePermissions(
        storage.permissions,
        _.first(_.keys(storage.permissions_by_role)),
        storage.permissions_by_role
      );
    };

    permissionsManager.initPermissions = function() {
      var _this = this,
        deferred = $q.defer();

      AdminPermissionsApi.getPermissions().then(
        function(response) {
          permissionsStorage.setPermissions(response.data);

          _this.clearPermissions();
          _this.setPermissionsFromStorage();

          $rootScope.$broadcast('permissions_is_updated');

          deferred.resolve(response);
        },
        function(response) {
          deferred.reject(response);
        }
      );

      return deferred.promise;
    };

    return permissionsManager;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminPermissionsApi', AdminPermissionsApi);

  AdminPermissionsApi.$inject = ['mainApi'];

  function AdminPermissionsApi(mainApi) {
    var AdminPermissionsApi = {};

    AdminPermissionsApi.getPermissions = function() {
      var url = 'anonym/permission/list',
        params = {};

      return mainApi.get(url, params);
    };

    AdminPermissionsApi.getUserRolesAndTree = function(namespace) {
      var url = 'admin/roles/list',
        params = {namespace: namespace};

      return mainApi.get(url, params);
    };

    AdminPermissionsApi.getPermissionsTreeByRole = function(role_id) {
      var url = 'admin/roles/' + role_id + '/permissions/list',
        params = {};

      return mainApi.get(url, params);
    };

    AdminPermissionsApi.savePermission = function(role_id, permission) {
      var url = 'admin/roles/' + role_id + '/permissions/save',
        params = {permission: permission};

      return mainApi.post(url, params);
    };

    AdminPermissionsApi.saveRole = function(role) {
      var url = 'admin/roles',
        params = {role: role};

      return mainApi.post(url, params);
    };

    AdminPermissionsApi.getConstants = function() {
      var url = 'admin/project_settings/list_report_fields',
        params = {};

      return mainApi.get(url, params);
    };

    return AdminPermissionsApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('modDatepicker', modDatepicker);

  modDatepicker.$inject = ['moment', 'defaultDateFormat', '_'];

  function modDatepicker(moment, defaultDateFormat, _) {
    return {
      restrict: 'E',
      scope: {
        isRequired: '=?',
        disabled: '=?',
        mdMinDate: '=?',
        mdMaxDate: '=?',
        mdDateFilter: '&?',
        errors: '=?',
        format: '=?',
        modelFormat: '=?',
        regExp: '=?',
        name: '@',
        mdCurrentView: '@',
        mdMode: '@'
      },
      templateUrl: 'app/components/extensions/mod_datepicker/mod_datepicker.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope, $element) {
        var vm = this;

        vm.externalModel = $element.controller('ngModel');
        vm.isModeYear = vm.mdMode === 'month';
        vm.outputDateFormat = vm.format || defaultDateFormat;
        vm.yearDateFormat = null;
        vm.regExpres = null;
        vm.pikerModel = null;
        vm.isOpen = false;

        if (vm.isModeYear) {
          vm.yearDateFormat = vm.format || 'MM.YYYY';
          vm.outputDateFormat = vm.yearDateFormat;
          vm.regExpres = new RegExp(vm.regExp || '^[0-9]{1,2}\\.[0-9]{4}$');
        }

        vm.options = {
          formatDate: function(date) {
            var m = vm.validateDate(date);
            return m ? m.format(vm.outputDateFormat) : date;
          }
        };

        vm.externalModelFormatters = _.debounce(function(value) {
          vm.updateModels(value);
        });

        vm.getParseYearDateFormat = function(value) {
          return vm.regExpres && vm.regExpres.test(value) ? vm.yearDateFormat : null;
        };

        vm.updateModels = function(value) {
          vm.pikerModel = vm.utcDate(value, vm.getParseYearDateFormat(value));
          vm.pickerModelChanged(vm.pikerModel);
        };

        vm.dateFilter = function(date) {
          return _.isFunction(vm.mdDateFilter) ? vm.mdDateFilter({date: date}) : true;
        };

        vm.prepareExternalModelValue = function(value) {
          var m, val;

          if (vm.isModeYear) {
            m = vm.validateDate(value);
            val = m ? m.format(vm.yearDateFormat) : value;
          } else {
            val = vm.modelFormat && value ? moment(value).format(vm.modelFormat) : value;
          }

          return val;
        };

        vm.pickerModelChanged = function(value) {
          vm.externalModel.$setViewValue(vm.prepareExternalModelValue(value));
        };

        vm.openPiker = function() {
          vm.isOpen = true;
        };

        vm.validateDate = function(date, format) {
          if (!date) {
            return null;
          }

          var m = moment(date, format);

          if (!m.isValid()) {
            return null;
          }

          return m;
        };

        vm.utcDate = function(date, format) {
          var m = vm.validateDate(date, format);

          return (
            m &&
            moment
              .utc(m.toDate())
              .utcOffset(m.utcOffset())
              .set({hour: 0, minute: 0, second: 0, millisecond: 0})
              .toDate()
          );
        };

        vm.externalModel.$formatters.push(vm.externalModelFormatters);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        daterange_picker: ['start||daterange_picker.start', 'end||daterange_picker.end']
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('DaterangePicker', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('daterangePicker', daterangePicker);

  daterangePicker.$inject = ['$rootScope', '$mdTranslate', 'moment', 'defaultDateFormat', '_'];

  function daterangePicker($rootScope, $mdTranslate, moment, defaultDateFormat, _) {
    return {
      restrict: 'E',
      scope: {
        start: '=',
        end: '=',
        format: '@',
        startMax: '=?startMax',
        endMin: '=?endMin',
        clearBtn: '=?',
        callback: '&',
        maxRange: '=?',
        allDisabled: '=?'
      },
      templateUrl: 'app/components/extensions/daterangepicker/daterangepicker.html',
      controllerAs: 'picker',
      controller: function($scope) {
        var vm = this,
          format_to_server = 'YYYY-MM-DD',
          translate_key = 'DaterangePicker',
          translateChangeListener;

        $scope.start = $scope.start ? moment($scope.start)._d : null;
        $scope.end = $scope.end ? moment($scope.end)._d : null;
        $scope.format = $scope.format || defaultDateFormat;

        if ($scope.callback) {
          vm.callback = $scope.callback();
        }

        vm.getDates = function() {
          return {
            start:
              $scope.start && $scope.start !== 'Invalid date' ? moment($scope.start).format(format_to_server) : null,
            end: $scope.end && $scope.end !== 'Invalid date' ? moment($scope.end).format(format_to_server) : null
          };
        };

        vm.change_start_date = function() {
          if ($scope.allDisabled) {
            return;
          }

          $scope.endMin = $scope.start;

          vm.update_end();

          if (vm.callback) {
            vm.callback(vm.getDates(), null, true);
          }
        };

        vm.change_end_date = function() {
          if ($scope.allDisabled) {
            return;
          }

          $scope.startMax = $scope.end;

          vm.update_start();

          if (vm.callback) {
            vm.callback(vm.getDates(), null, true);
          }
        };

        vm.clear = function() {
          if ($scope.allDisabled) {
            return;
          }

          $scope.start = null;
          $scope.end = null;

          if (vm.callback) {
            vm.callback(
              {
                start: null,
                end: null
              },
              null,
              true
            );
          }
        };

        translateChangeListener = $rootScope.$on('$translateChangeSuccess', function() {
          vm.display_start_date($scope.start);
          vm.display_end_date($scope.end);
        });

        vm.display_start_date = function(date) {
          vm.display_start = date
            ? moment(date).format($scope.format)
            : $mdTranslate.instant(translate_key, 'daterange_picker.start');
        };

        vm.display_end_date = function(date) {
          vm.display_end = date
            ? moment(date).format($scope.format)
            : $mdTranslate.instant(translate_key, 'daterange_picker.end');
        };

        vm.update_start = function() {
          if (angular.isDefined($scope.maxRange) && $scope.end && $scope.start) {
            var diff = moment($scope.end);
            _.each($scope.maxRange, function(v, k) {
              diff.subtract(v, k);
            });
            $scope.start = diff.isAfter(moment($scope.start)) ? diff._d : $scope.start;
          }
        };

        vm.update_end = function() {
          if (angular.isDefined($scope.maxRange) && $scope.end && $scope.start) {
            var diff = moment($scope.start);
            _.each($scope.maxRange, function(v, k) {
              diff.add(v, k);
            });
            $scope.end = diff.isBefore(moment($scope.end)) ? diff._d : $scope.end;
          }
        };

        $scope.$watch('start', function(newValue) {
          vm.display_start_date(newValue);
        });

        $scope.$watch('end', function(newValue) {
          vm.display_end_date(newValue);
        });

        $scope.$on('$destroy', translateChangeListener);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('watchColorValue', watchColorValue);

  watchColorValue.$inject = ['ColorHelper'];

  function watchColorValue(ColorHelper) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var pikerScope = element.isolateScope();

        function updateFromString(value) {
          var hsva = ColorHelper.stringToHsva(value);

          if (hsva !== null) {
            pikerScope.hsva = hsva;
            pikerScope.update();
            element.val(value);
          }
        }

        attr.$observe('value', function(value) {
          updateFromString(value);
          element.val(value);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('clipboard', clipboard);

  clipboard.$inject = ['Clipboard', '$timeout', '$log'];

  function clipboard(Clipboard, $timeout, $log) {
    return {
      restrict: 'A',
      scope: {
        text: '=?',
        fromTextAttr: '=?',
        success: '&?',
        error: '&?',
        clearSelection: '=?',
        successTooltip: '=?',
        successTooltipClass: '=?',
        successTooltipTime: '=?',
        errorTooltip: '=?',
        errorTooltipClass: '=?',
        errorTooltipTime: '=?'
      },
      link: function(scope, element) {
        var params = {},
          clipboard,
          isSupported = Clipboard.isSupported();

        if (scope.fromTextAttr) {
          params.text = function() {
            return scope.text;
          };
        }

        if (!isSupported) {
          $log.warn('Your browser is not supported Clipboard.js');
        }

        clipboard = new Clipboard(element[0], params);

        scope.successCallbackApply = function() {
          var tooltip = element.find('clipboard-tooltip-success'),
            successTime = scope.successTooltipTime || 1500,
            successClass = scope.successTooltipClass || 'copied';

          if (!tooltip.length) {
            return;
          }

          tooltip.addClass(successClass);

          $timeout(function() {
            tooltip.removeClass(successClass);
          }, successTime);
        };

        scope.errorCallbackApply = function() {
          var tooltip = element.find('clipboard-tooltip-error'),
            errorTime = scope.errorTooltipTime || 1500,
            errorClass = scope.errorTooltipClass || 'copied';

          if (!tooltip.length) {
            return;
          }

          tooltip.addClass(errorClass);

          $timeout(function() {
            tooltip.removeClass(errorClass);
          }, errorTime);
        };

        scope.successCallback = function(e) {
          element.addClass(e.action);

          if (scope.clearSelection) {
            e.clearSelection();
          }

          if (scope.success) {
            scope.success({e: e});
          }

          if (scope.successTooltip) {
            scope.successCallbackApply();
          }
        };

        scope.errorCallback = function(e) {
          element.addClass('error');

          $log.error('Error has been occured for action: ' + e.action);

          if (scope.error) {
            scope.error({e: e});
          }

          if (scope.errorTooltip) {
            scope.errorCallbackApply();
          }
        };

        clipboard.on('success', scope.successCallback);
        clipboard.on('error', scope.errorCallback);

        scope.$on('$destroy', function() {
          clipboard.off('success', scope.successCallback);
          clipboard.off('error', scope.errorCallback);
          clipboard.destroy();
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('charts', charts);

  charts.$inject = ['$mdTranslate', '$rootScope', 'Chart', '_'];

  function charts($mdTranslate, $rootScope, Chart, _) {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        options: '='
      },
      templateUrl: 'app/components/extensions/charts/charts.html',
      bindToController: true,
      controllerAs: '$ctrl',
      controller: function($scope) {
        var vm = this,
          theHelp = Chart.helpers,
          translateListener;

        vm.chartByDay = {
          labels: [],
          series: [],
          data: [],
          colors: ['#1088de', '#ff9800']
        };

        vm.chartByMonth = {
          currentKey: '',
          keysList: [],
          labels: [],
          data: [],
          options: {
            legend: {
              display: true,
              labels: {
                boxWidth: 15,
                fontSize: 14,
                fontFamily: 'OpenSansRegular, sans-serif',
                fontColor: 'rgba(0,0,0,0.87)',
                generateLabels: function(chart) {
                  var data = chart.data;

                  if (!data.labels.length || !data.datasets.length) {
                    return [];
                  }

                  return _.map(data.labels, function(label, i) {
                    var meta = chart.getDatasetMeta(0),
                      ds = data.datasets[0],
                      arc = meta.data[i],
                      custom = (arc && arc.custom) || {},
                      getValue = theHelp.getValueAtIndexOrDefault,
                      arcOpts = chart.options.elements.arc,
                      fill = custom.backgroundColor
                        ? custom.backgroundColor
                        : getValue(ds.backgroundColor, i, arcOpts.backgroundColor),
                      stroke = custom.borderColor
                        ? custom.borderColor
                        : getValue(ds.borderColor, i, arcOpts.borderColor),
                      bw = custom.borderWidth ? custom.borderWidth : getValue(ds.borderWidth, i, arcOpts.borderWidth);

                    return {
                      text: label + ': ' + ds.data[i],
                      fillStyle: fill,
                      strokeStyle: stroke,
                      lineWidth: bw,
                      hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                      index: i
                    };
                  });
                }
              }
            }
          },
          colors: ['#1088de', '#ff9800']
        };

        vm.changeByDayData = function() {
          var data = vm.chartByDay.chartList[vm.chartByDay.currentKey];

          if (_.isEmpty(data)) {
            return;
          }

          vm.chartByDay.labels = _.map(data.month, function(v, i) {
            return i + 1;
          });
          vm.chartByDay.data = [data.month, _.first(data.last_month, _.size(data.month))];
          vm.changeByDaySeries();
        };

        vm.changeByDaySeries = function() {
          vm.chartByDay.series = [
            $mdTranslate.instant(vm.options.translate_key, 'charts.by_day.month'),
            $mdTranslate.instant(vm.options.translate_key, 'charts.by_day.last_month')
          ];
        };

        vm.changeByMonthData = function() {
          var data = vm.chartByMonth.chartList[vm.chartByMonth.currentKey];

          if (_.isEmpty(data)) {
            return;
          }

          vm.chartByMonth.data = [data.new_players, data.old_players];
          vm.changeByMonthLabels();
        };

        vm.changeByMonthLabels = function() {
          vm.chartByMonth.labels = [
            $mdTranslate.instant(vm.options.translate_key, 'charts.by_months.new_players'),
            $mdTranslate.instant(vm.options.translate_key, 'charts.by_months.old_players')
          ];
        };

        $scope.$watch('$ctrl.data', function(data) {
          if (_.isEmpty(data) || !_.isObject(data)) {
            return;
          }

          vm.chartByMonth.chartList = data.by_months;
          vm.chartByDay.chartList = data.by_day;
          vm.chartByMonth.currentKey = _.first(_.keys(data.by_months));
          vm.chartByDay.currentKey = _.first(_.keys(data.by_day));

          vm.changeByMonthData();
          vm.changeByDayData();
        });

        translateListener = $rootScope.$on('$translateChangeSuccess', function() {
          vm.changeByDaySeries();
          vm.changeByMonthLabels();
        });

        $scope.$on('$destroy', function() {
          translateListener();
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminWithdrawalsHistoryApi', AdminWithdrawalsHistoryApi);

  AdminWithdrawalsHistoryApi.$inject = ['mainApi'];

  function AdminWithdrawalsHistoryApi(mainApi) {
    var WithdrawalsHistoryApi = {};

    WithdrawalsHistoryApi.getWithdrawalsHistory = function() {
      var url = 'admin/affiliate_cashouts/approved_and_declined_history/list',
        params = {};

      return mainApi.post(url, params);
    };

    WithdrawalsHistoryApi.historyPagination = function(params) {
      var url = 'admin/affiliate_cashouts/approved_and_declined_history/list',
        _params = params || {};

      _params.period = params.additional_options;

      return mainApi.post(url, _params);
    };

    WithdrawalsHistoryApi.viewWithdrawal = function(id) {
      var url = 'admin/affiliate_cashouts/approved_and_declined_history/' + id,
        params = {};

      return mainApi.get(url, params);
    };

    WithdrawalsHistoryApi.downloadReport = function(reportParams, filterId) {
      var url = 'admin/affiliate_cashouts/approved_and_declined_history/download_report',
        params = {report: reportParams, filter_set_id: filterId};

      return mainApi.post(url, params);
    };

    return WithdrawalsHistoryApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('WebhooksHistoryApi', WebhooksHistoryApi);

  WebhooksHistoryApi.$inject = ['mainApi'];

  function WebhooksHistoryApi(mainApi) {
    var WebhooksHistoryApi = {};

    WebhooksHistoryApi.list = function(namespace) {
      var url = namespace + '/requests/list',
        params = {};

      return mainApi.post(url, params);
    };

    WebhooksHistoryApi.pagination = function(params) {
      var url = params.additional_options.namespace + '/requests/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    WebhooksHistoryApi.listDetails = function(namespace, id) {
      var url = namespace + '/requests/' + id + '/history',
        params = {};

      return mainApi.post(url, params);
    };

    WebhooksHistoryApi.detailsPagination = function(params) {
      var url = params.additional_options.namespace + '/requests/' + params.additional_options.id + '/history',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    WebhooksHistoryApi.getDownloadReportOptions = function(namespace) {
      var url = namespace + '/requests/options',
        params = {};

      return mainApi.post(url, params);
    };

    WebhooksHistoryApi.downloadReport = function(namespace, data, filterId) {
      var url = namespace + '/requests/download_report',
        params = {report: data, filter_set_id: filterId};

      return mainApi.post(url, params);
    };

    return WebhooksHistoryApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('WebhooksApi', WebhooksApi);

  WebhooksApi.$inject = ['mainApi'];

  function WebhooksApi(mainApi) {
    var WebhooksApi = {};

    WebhooksApi.list = function(webhookType) {
      var url = 'affiliate/webhooks/list',
        params = {type: webhookType};

      return mainApi.post(url, params);
    };

    WebhooksApi.pagination = function(params) {
      var url = 'affiliate/webhooks/list',
        _params = params || {};

      _params.type = params.additional_options.type;

      return mainApi.post(url, _params);
    };

    WebhooksApi.create_webhook = function(webhookType) {
      var url = 'affiliate/webhooks',
        params = {type: webhookType};

      return mainApi.post(url, params);
    };

    WebhooksApi.edit = function(webhookId) {
      var url = 'affiliate/webhooks/' + webhookId + '/edit',
        params = {};

      return mainApi.get(url, params);
    };

    WebhooksApi.change_state = function(webhook) {
      var url = 'affiliate/webhooks/' + webhook.id + '/' + (webhook.active ? 'inactive' : 'active'),
        params = {};

      return mainApi.put(url, params);
    };

    WebhooksApi.save_webhook = function(webhook) {
      var url = 'affiliate/webhooks/' + webhook.id,
        params = {webhook: webhook};

      return mainApi.put(url, params);
    };

    WebhooksApi.save_trackers = function(webhookId, data, direction) {
      var url = 'affiliate/webhooks/' + webhookId + '/serials/' + (direction ? 'add' : 'remove'),
        params = {serial: data};

      return mainApi.put(url, params);
    };

    WebhooksApi.save_condition = function(webhookId, condition) {
      var url = 'affiliate/webhooks/' + webhookId + '/conditions/' + (condition.id ? condition.id : ''),
        method = condition.id ? 'put' : 'post',
        params = {condition: condition};

      return mainApi[method](url, params);
    };

    WebhooksApi.removeCondition = function(webhookId, conditionId) {
      var url = 'affiliate/webhooks/' + webhookId + '/conditions/' + conditionId,
        params = {};

      return mainApi['delete'](url, params);
    };

    WebhooksApi.save_uri_options = function(webhookId, option) {
      var url = 'affiliate/webhooks/' + webhookId + '/uri_options/' + (option.id ? option.id : ''),
        method = option.id ? 'put' : 'post',
        params = {uri_option: option};

      return mainApi[method](url, params);
    };

    WebhooksApi.remove_uri_options = function(webhookId, option) {
      var url = 'affiliate/webhooks/' + webhookId + '/uri_options/' + option.id,
        params = {};

      return mainApi['delete'](url, params);
    };

    return WebhooksApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminWebhooksApi', AdminWebhooksApi);

  AdminWebhooksApi.$inject = ['mainApi'];

  function AdminWebhooksApi(mainApi) {
    var AdminWebhooksApi = {};

    AdminWebhooksApi.list = function(webhookType, partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/webhooks/list',
        params = {type: webhookType};

      return mainApi.post(url, params);
    };

    AdminWebhooksApi.pagination = function(params) {
      var url = 'admin/affiliates/' + params.additional_options.partnerId + '/webhooks/list',
        _params = params || {};

      _params.type = params.additional_options.type;

      return mainApi.post(url, _params);
    };

    AdminWebhooksApi.create_webhook = function(webhookType, partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/webhooks',
        params = {type: webhookType};

      return mainApi.post(url, params);
    };

    AdminWebhooksApi.edit = function(webhookId, partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/webhooks/' + webhookId + '/edit',
        params = {};

      return mainApi.get(url, params);
    };

    AdminWebhooksApi.change_state = function(webhook, partnerId) {
      var url =
          'admin/affiliates/' + partnerId + '/webhooks/' + webhook.id + '/' + (webhook.active ? 'inactive' : 'active'),
        params = {};

      return mainApi.put(url, params);
    };

    AdminWebhooksApi.save_webhook = function(webhook, partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/webhooks/' + webhook.id,
        params = {webhook: webhook};

      return mainApi.put(url, params);
    };

    AdminWebhooksApi.save_trackers = function(webhookId, data, direction, partnerId) {
      var url =
          'admin/affiliates/' + partnerId + '/webhooks/' + webhookId + '/serials/' + (direction ? 'add' : 'remove'),
        params = {serial: data};

      return mainApi.put(url, params);
    };

    AdminWebhooksApi.save_condition = function(webhookId, condition, partnerId) {
      var url =
          'admin/affiliates/' +
          partnerId +
          '/webhooks/' +
          webhookId +
          '/conditions/' +
          (condition.id ? condition.id : ''),
        method = condition.id ? 'put' : 'post',
        params = {condition: condition};

      return mainApi[method](url, params);
    };

    AdminWebhooksApi.removeCondition = function(webhookId, conditionId, partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/webhooks/' + webhookId + '/conditions/' + conditionId,
        params = {};

      return mainApi['delete'](url, params);
    };

    AdminWebhooksApi.save_uri_options = function(webhookId, option, partnerId) {
      var url =
          'admin/affiliates/' + partnerId + '/webhooks/' + webhookId + '/uri_options/' + (option.id ? option.id : ''),
        method = option.id ? 'put' : 'post',
        params = {uri_option: option};

      return mainApi[method](url, params);
    };

    AdminWebhooksApi.remove_uri_options = function(webhookId, option, partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/webhooks/' + webhookId + '/uri_options/' + option.id,
        params = {};

      return mainApi['delete'](url, params);
    };

    AdminWebhooksApi.getAffiliate = function(partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/webhooks/affiliate_options',
        params = {};

      return mainApi.get(url, params);
    };

    return AdminWebhooksApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateTrackersApi', AffiliateTrackersApi);

  AffiliateTrackersApi.$inject = ['mainApi'];

  function AffiliateTrackersApi(mainApi) {
    var AffiliateTrackers = {};

    AffiliateTrackers.trackers_list = function() {
      var url = 'affiliate/trackers/list',
        params = {};

      return mainApi.post(url, params);
    };

    AffiliateTrackers.pagination = function(params) {
      var url = 'affiliate/trackers/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AffiliateTrackers.saveTracker = function(tracker) {
      var url = 'affiliate/trackers/' + (tracker.id || ''),
        method = tracker.id ? 'put' : 'post',
        params = {tracker: tracker};

      return mainApi[method](url, params);
    };

    AffiliateTrackers.get_condition = function(tracker_id) {
      var url = 'affiliate/trackers/' + tracker_id + '/show_condition',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateTrackers.getCountries = function() {
      var url = 'affiliate/countries/list',
        params = {};

      return mainApi.get(url, params);
    };

    return AffiliateTrackers;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminTrackersApi', AdminTrackersApi);

  AdminTrackersApi.$inject = ['mainApi'];

  function AdminTrackersApi(mainApi) {
    var AdminTrackers = {};

    AdminTrackers.getTrackers = function() {
      var url = 'admin/trackers/list';

      return mainApi.post(url, {});
    };

    AdminTrackers.pagination = function(params) {
      var url = 'admin/trackers/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AdminTrackers.downloadReport = function(reportParams) {
      var url = 'admin/trackers/download_list',
        params = {report: reportParams};

      return mainApi.post(url, params);
    };

    return AdminTrackers;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminTrackingMirrorsApi', AdminTrackingMirrorsApi);

  AdminTrackingMirrorsApi.$inject = ['mainApi'];

  function AdminTrackingMirrorsApi(mainApi) {
    var AdminTracking = {};

    AdminTracking.getMirrors = function(type) {
      var url = 'admin/mirrors/' + (type === 'common' ? 'list_js' : 'list_no_js'),
        params = {};

      return mainApi.post(url, params);
    };

    AdminTracking.pagination = function(params) {
      var url = 'admin/mirrors/' + (params.additional_options.type === 'common' ? 'list_js' : 'list_no_js'),
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AdminTracking.create = function(data, type) {
      var url = 'admin/mirrors',
        params = {
          mirror: {
            mirror_type: type,
            domain: data.link,
            priority: data.priority,
            enabled: data.enabled
          }
        };

      return mainApi.post(url, params);
    };

    AdminTracking.edit = function(id) {
      var url = 'admin/mirrors/' + id + '/edit',
        params = {};

      return mainApi.get(url, params);
    };

    AdminTracking.update = function(id, data, type) {
      var url = 'admin/mirrors/' + id,
        params = {
          mirror: {
            mirror_type: type,
            domain: data.link,
            priority: data.priority,
            enabled: data.enabled
          }
        };

      return mainApi.put(url, params);
    };

    AdminTracking.destroy = function(id) {
      var url = 'admin/mirrors/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    AdminTracking.getNotification = function() {
      var url = 'admin/project_settings/list_redirector_notifications',
        params = {};

      return mainApi.get(url, params);
    };

    AdminTracking.saveNotification = function(data) {
      var url = 'admin/project_settings/save_redirector_notifications',
        params = {
          redirector_notifications: {
            errors_per_hour_limit: data.errors_per_hour_limit,
            errors_per_day_limit: data.errors_per_day_limit,
            receive_email_restriction: data.receive_email_restriction,
            email: data.email
          }
        };

      return mainApi.post(url, params);
    };

    return AdminTracking;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('SubaffiliateConditionsApi', SubaffiliateConditionsApi);

  SubaffiliateConditionsApi.$inject = ['mainApi'];

  function SubaffiliateConditionsApi(mainApi) {
    var SubaffiliateConditionsApi = {};

    SubaffiliateConditionsApi.conditions_list = function() {
      var url = 'admin/subaffiliate_conditions/list',
        params = {};

      return mainApi.post(url, params);
    };

    SubaffiliateConditionsApi.pagination = function(params) {
      var url = 'admin/subaffiliate_conditions/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    SubaffiliateConditionsApi.get = function() {
      var url = 'admin/subaffiliate_conditions/list_constants',
        params = {};

      return mainApi.get(url, params);
    };

    SubaffiliateConditionsApi.destroy = function(id) {
      var url = 'admin/subaffiliate_conditions/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    SubaffiliateConditionsApi.create_or_update = function(condition) {
      var url =
          'admin/subaffiliate_conditions/' + (condition.id ? condition.id : '0') + '/change_with_nested_attributes',
        params = {subaffiliate_condition: condition};

      return mainApi.put(url, params);
    };

    SubaffiliateConditionsApi.edit = function(id) {
      var url = 'admin/subaffiliate_conditions/' + id + '/edit',
        params = {};

      return mainApi.get(url, params);
    };

    return SubaffiliateConditionsApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('SignInApi', SignInApi);

  SignInApi.$inject = ['Auth'];

  function SignInApi(Auth) {
    var signIn = {};

    signIn.signIn = function(user) {
      var _params = {
          email: user.email,
          password: user.password,
          mfa_code: user.mfa_code || '',
          remember_me: user.remember_me ? '1' : '0'
        },
        config = {
          headers: {
            'X-HTTP-Method-Override': 'POST'
          }
        };

      return Auth.login(_params, config);
    };

    return signIn;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('SignUpApi', SignUpApi);

  SignUpApi.$inject = ['mainApi'];

  function SignUpApi(mainApi) {
    var signUp = {};

    signUp.registration = function(affiliate) {
      var url = 'anonym/registrations',
        params = {affiliate: affiliate};

      return mainApi.post(url, params);
    };

    signUp.confirmation = function(token) {
      var url = 'confirmation',
        params = {confirmation_token: token};

      return mainApi.get(url, params);
    };

    signUp.usernameAvailable = function(username) {
      var url = 'anonym/registrations/username_available',
        params = {username: username};

      return mainApi.get(url, params);
    };

    return signUp;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('SignOutApi', SignOutApi);

  SignOutApi.$inject = ['mainApi', 'Auth'];

  function SignOutApi(mainApi, Auth) {
    var signOut = {};

    signOut.signOut = function() {
      var config = {
        headers: {
          'X-HTTP-Method-Override': 'DELETE'
        }
      };

      return Auth.logout(config);
    };

    signOut.signOutForce = function(supervision) {
      var config = {
        headers: {
          'X-HTTP-Method-Override': 'DELETE'
        }
      };

      return mainApi['delete']('sign_out?supervision=' + supervision, {}, config);
    };

    return signOut;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateProfileSettingsApi', AffiliateProfileSettingsApi);

  AffiliateProfileSettingsApi.$inject = ['mainApi'];

  function AffiliateProfileSettingsApi(mainApi) {
    var AffiliateProfileSettingsApi = {};

    AffiliateProfileSettingsApi.get_attributes = function() {
      var url = 'affiliate/settings/edit',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateProfileSettingsApi.update_settings = function(affiliate_attributes) {
      var url = 'affiliate/settings/data_update',
        params = {affiliate: affiliate_attributes};

      return mainApi.put(url, params);
    };

    AffiliateProfileSettingsApi.update_email = function(affiliate_attributes) {
      var url = 'affiliate/settings/email_update',
        params = {affiliate: affiliate_attributes};

      return mainApi.put(url, params);
    };

    AffiliateProfileSettingsApi.update_password = function(affiliate_attributes) {
      var url = 'affiliate/settings/password_update',
        params = {affiliate: affiliate_attributes};

      return mainApi.put(url, params);
    };

    AffiliateProfileSettingsApi.confirmation_email = function(token) {
      var url = 'confirmation',
        params = {confirmation_token: token};

      return mainApi.get(url, params);
    };

    AffiliateProfileSettingsApi.enableTwoFactorAuth = function(password) {
      var url = 'affiliate/settings/generate_google_secret',
        params = {
          affiliate: {
            password: password
          }
        };

      return mainApi.post(url, params);
    };

    AffiliateProfileSettingsApi.resetTwoFactorAuth = function(mfaCode) {
      var url = 'affiliate/settings/clear_google_secret',
        params = {
          affiliate: {
            mfa_code: mfaCode
          }
        };

      return mainApi.post(url, params);
    };

    AffiliateProfileSettingsApi.confirmMfaCode = function(mfaCode) {
      var url = 'affiliate/settings/confirm_google_secret',
        params = {
          affiliate: {
            mfa_code: mfaCode
          }
        };

      return mainApi.post(url, params);
    };

    AffiliateProfileSettingsApi.getPaymentMethods = function() {
      var url = 'affiliate/payment_systems/allowed_payment_systems',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateProfileSettingsApi.getCountries = function() {
      var url = 'affiliate/payment_systems/countries',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateProfileSettingsApi.savePaymentDetails = function(paymentSystemDetails) {
      var url = 'affiliate/payment_systems/update_payment_system',
        params = {payment_system: paymentSystemDetails};

      return mainApi.post(url, params);
    };

    return AffiliateProfileSettingsApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminOrManagerProfileSettingsApi', AdminOrManagerProfileSettingsApi);

  AdminOrManagerProfileSettingsApi.$inject = ['mainApi'];

  function AdminOrManagerProfileSettingsApi(mainApi) {
    var AdminOrManagerProfileSettings = {};

    AdminOrManagerProfileSettings.show = function() {
      var url = 'admin/profile/edit',
        params = {};

      return mainApi.get(url, params);
    };

    AdminOrManagerProfileSettings.save_name = function(user) {
      var url = 'admin/profile/data_update',
        params = {profile: user};

      return mainApi.put(url, params);
    };

    AdminOrManagerProfileSettings.save_email = function(user) {
      var url = 'admin/profile/email_update',
        params = {profile: user};

      return mainApi.put(url, params);
    };

    AdminOrManagerProfileSettings.save_password = function(user) {
      var url = 'admin/profile/password_update',
        params = {profile: user};

      return mainApi.put(url, params);
    };

    AdminOrManagerProfileSettings.confirmation_email = function(token) {
      var url = 'confirmation',
        params = {confirmation_token: token};

      return mainApi.get(url, params);
    };

    AdminOrManagerProfileSettings.enableTwoFactorAuth = function(password) {
      var url = 'admin/profile/generate_google_secret',
        params = {
          admin: {
            password: password
          }
        };

      return mainApi.post(url, params);
    };

    AdminOrManagerProfileSettings.resetTwoFactorAuth = function(mfaCode) {
      var url = 'admin/profile/clear_google_secret',
        params = {
          admin: {
            mfa_code: mfaCode
          }
        };

      return mainApi.post(url, params);
    };

    AdminOrManagerProfileSettings.confirmMfaCode = function(mfaCode) {
      var url = 'admin/profile/confirm_google_secret',
        params = {
          admin: {
            mfa_code: mfaCode
          }
        };

      return mainApi.post(url, params);
    };

    return AdminOrManagerProfileSettings;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsViewStatsApi', AdminSettingsViewStatsApi);

  AdminSettingsViewStatsApi.$inject = ['mainApi'];

  function AdminSettingsViewStatsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.getAdmins = function() {
      var url = 'admin/project_settings/admins_with_full_stats_access',
        params = {};

      return mainApi.get(url, params);
    };

    AdminSetting.saveAdmins = function(params, direction) {
      var url =
          'admin/project_settings/' +
          (direction ? 'add_admins_with_full_stats_access' : 'remove_admins_with_full_stats_access'),
        _params = {admins_with_full_stats_access: params};

      return mainApi.post(url, _params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsTableColumnsApi', AdminSettingsTableColumnsApi);

  AdminSettingsTableColumnsApi.$inject = ['mainApi'];

  function AdminSettingsTableColumnsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.list = function() {
      var url = 'admin/table_for_displays/list',
        params = {};

      return mainApi.get(url, params);
    };

    AdminSetting.getSelectedTableColumns = function(tableKey) {
      var url = 'admin/table_columns_for_displays/enabled_list',
        params = {key: tableKey};

      return mainApi.get(url, params);
    };

    AdminSetting.getUnselectedTableColumns = function(tableKey) {
      var url = 'admin/table_columns_for_displays/disabled_list',
        params = {key: tableKey};

      return mainApi.get(url, params);
    };

    AdminSetting.saveColumn = function(data) {
      var url = 'admin/table_columns_for_displays/update_element',
        params = {table_column_for_display: data};

      return mainApi.post(url, params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .factory('AdminSettingsRegistrationFieldsApi', AdminSettingsRegistrationFieldsApi);

  AdminSettingsRegistrationFieldsApi.$inject = ['mainApi'];

  function AdminSettingsRegistrationFieldsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.get_fields = function() {
      var url = 'admin/project_settings/required_fields_in_profile_update',
        params = {};

      return mainApi.get(url, params);
    };

    AdminSetting.save_fields = function(params, direction) {
      var url = 'admin/project_settings/' + (direction ? 'add_required_fields' : 'remove_required_fields'),
        _params = {required_fields: params};

      return mainApi.post(url, _params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsPaymentSystemsApi', AdminSettingsPaymentSystemsApi);

  AdminSettingsPaymentSystemsApi.$inject = ['mainApi'];

  function AdminSettingsPaymentSystemsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.getPaymentSystems = function() {
      var url = 'admin/payment_system_lists/allowed_payment_systems',
        params = {};

      return mainApi.get(url, params);
    };

    AdminSetting.savePaymentSystems = function(params, direction) {
      var url = 'admin/payment_system_lists/' + (direction ? 'add_payment_system' : 'remove_payment_system'),
        _params = {payment_system: params};

      return mainApi.put(url, _params);
    };

    AdminSetting.listCountryGroups = function(params) {
      return mainApi.post('admin/bank_transfer_country_groups/list', params || {});
    };

    AdminSetting.getDateForCountryGroup = function(id) {
      return mainApi.get('admin/bank_transfer_country_groups/' + (id || 0) + '/data_by_country_group', {});
    };

    AdminSetting.saveGroup = function(id, group) {
      var url = 'admin/bank_transfer_country_groups/' + (id || ''),
        method = id ? 'put' : 'post',
        params = {
          payment_system_country_group: {
            name: group.name,
            payment_system_countries_attributes: group.countries,
            bank_transfer_validation_attributes: group.bank_transfer_validation
          }
        };

      return mainApi[method](url, params);
    };

    AdminSetting.deleteCountryGroup = function(groupId) {
      return mainApi['delete']('admin/bank_transfer_country_groups/' + groupId, {});
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsInfoPagesApi', AdminSettingsInfoPagesApi);

  AdminSettingsInfoPagesApi.$inject = ['mainApi', '_'];

  function AdminSettingsInfoPagesApi(mainApi, _) {
    var AdminSetting = {},
      pages = [
        'faq',
        'terms',
        'privacy',
        'commission',
        'help',
        'static_page_1',
        'static_page_2',
        'static_page_3',
        'static_page_4',
        'static_page_5'
      ];

    _.each(pages, function(page) {
      AdminSetting['get_' + page] = function(locale) {
        var url = 'admin/static_pages/load_' + page,
          params = {language: locale};

        return mainApi.get(url, params);
      };

      AdminSetting['save_' + page] = function(locale, content) {
        var url = 'admin/static_pages/save_' + page,
          params = {language: locale, content: content};

        return mainApi.post(url, params);
      };
    });

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsFieldsApi', AdminSettingsFieldsApi);

  AdminSettingsFieldsApi.$inject = ['mainApi'];

  function AdminSettingsFieldsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.get_fields = function(id, namespace, fieldsSettingsType) {
      var url = 'admin/project_settings/report_fields',
        params = {
          id: id,
          namespace: namespace,
          report_name: fieldsSettingsType
        };

      return mainApi.get(url, params);
    };

    AdminSetting.save_fields = function(params, direction) {
      var url = 'admin/project_settings/' + (direction ? 'add_report_fields' : 'remove_report_fields'),
        _params = {report_field: params};

      return mainApi.post(url, _params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsFeesApi', AdminSettingsFeesApi);

  AdminSettingsFeesApi.$inject = ['mainApi'];

  function AdminSettingsFeesApi(mainApi) {
    var AdminFees = {};

    AdminFees.getFeesParams = function() {
      var url = 'admin/admin_fees/list',
        params = {};

      return mainApi.get(url, params);
    };

    AdminFees.getOptions = function(merchantId) {
      var url = 'admin/admin_fees/options',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AdminFees.createFeesParams = function(params) {
      var url = 'admin/admin_fees',
        _params = {
          admin_fee: {
            percent: params.limit,
            count_from: params.feeColumn,
            date: params.date
          }
        };

      return mainApi.post(url, _params);
    };

    return AdminFees;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsEmailsApi', AdminSettingsEmailsApi);

  AdminSettingsEmailsApi.$inject = ['mainApi'];

  function AdminSettingsEmailsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.get_all_emails = function() {
      var url = 'admin/mailers_manager/list',
        params = {};

      return mainApi.get(url, params);
    };

    AdminSetting.get_email_params = function(emailName, language) {
      var url = 'admin/mailers_manager/edit',
        params = {id_mailer: emailName, locale: language};

      return mainApi.get(url, params);
    };

    AdminSetting.save_email = function(emailName, mailer, language) {
      var url = 'admin/mailers_manager/save',
        params = {
          id_mailer: emailName,
          locale: language,
          mailer: {subject: mailer.subject, body: mailer.body, enabled: mailer.enabled}
        };

      return mainApi.post(url, params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsColumnsApi', AdminSettingsColumnsApi);

  AdminSettingsColumnsApi.$inject = ['mainApi'];

  function AdminSettingsColumnsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.list = function() {
      var url = 'admin/project_settings/default_order_columns',
        params = {};

      return mainApi.get(url, params);
    };

    AdminSetting.save_columns = function(playersColumns, structureColumns) {
      var url = 'admin/project_settings/default_order_columns_save',
        params = {colums_in_modified_daily_players_statistics: playersColumns, upload_data_structure: structureColumns};

      return mainApi.post(url, params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsClickDomainsApi', AdminSettingsClickDomainsApi);

  AdminSettingsClickDomainsApi.$inject = ['mainApi'];

  function AdminSettingsClickDomainsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.getDomains = function() {
      var url = 'admin/click_domains/list',
        params = {};

      return mainApi.get(url, params);
    };

    AdminSetting.setDefaultDomain = function(id) {
      var url = 'admin/click_domains/' + id + '/set_default',
        params = {id: id};

      return mainApi.post(url, params);
    };

    AdminSetting.addDomain = function(domain) {
      var url = 'admin/click_domains',
        params = {
          click_domain: {
            domain: domain
          }
        };

      return mainApi.post(url, params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsBookkeepingApi', AdminSettingsBookkeepingApi);

  AdminSettingsBookkeepingApi.$inject = ['mainApi'];

  function AdminSettingsBookkeepingApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.get_bookkeeping_params = function() {
      var url = 'admin/history_of_limit_changes/list',
        params = {};

      return mainApi.get(url, params);
    };

    AdminSetting.create_bookkeeping_params = function(params) {
      var url = 'admin/history_of_limit_changes',
        _params = {history_of_limit_change: params};

      return mainApi.post(url, _params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsAutoApproveApi', AdminSettingsAutoApproveApi);

  AdminSettingsAutoApproveApi.$inject = ['mainApi'];

  function AdminSettingsAutoApproveApi(mainApi) {
    var AutoApprove = {};

    AutoApprove.getAutoApprove = function() {
      return mainApi.get('admin/auto_approve_locales/list', {});
    };

    AutoApprove.saveAutoApprove = function(data) {
      var url = 'admin/auto_approve_locales/save',
        params = {auto_approve_locales: data};

      return mainApi.post(url, params);
    };

    return AutoApprove;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminSettingsApi', AdminSettingsApi);

  AdminSettingsApi.$inject = ['mainApi'];

  function AdminSettingsApi(mainApi) {
    var AdminSetting = {};

    AdminSetting.get = function() {
      var url = 'admin/project_settings/list';

      return mainApi.get(url, {});
    };

    AdminSetting.save = function(data, config) {
      var url = 'admin/project_settings/save',
        params = data;

      return mainApi.post(url, params, config);
    };

    AdminSetting.saveInterfaceLocales = function(data) {
      var url = 'admin/project_settings/save_interface_locales',
        params = {
          project_languages: {
            locales: data
          }
        };

      return mainApi.post(url, params);
    };

    AdminSetting.saveCreativeLocales = function(data) {
      var url = 'admin/project_settings/save_creative_locales',
        params = {
          project_languages: {
            locales: data
          }
        };

      return mainApi.post(url, params);
    };

    return AdminSetting;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('SubaffiliateReportApi', SubaffiliateReportApi);

  SubaffiliateReportApi.$inject = ['mainApi'];

  function SubaffiliateReportApi(mainApi) {
    var SubaffiliateReportApi = {};

    SubaffiliateReportApi.namespace = '';

    SubaffiliateReportApi.get_information = function(reportOpts, current_page) {
      var url = this.namespace + '/subaffiliate_reports/generate_report',
        params = {report: reportOpts, page: current_page};

      return mainApi.post(url, params);
    };

    SubaffiliateReportApi.pagination = function(params) {
      var url = this.namespace + '/subaffiliate_reports/generate_report',
        _params = params || {};

      _params.report = params.additional_options;

      return mainApi.post(url, _params);
    };

    SubaffiliateReportApi.report_params = function() {
      var url = this.namespace + '/subaffiliate_reports/options',
        params = {};

      return mainApi.get(url, params);
    };

    SubaffiliateReportApi.templates_list = function(saveKey) {
      var url = this.namespace + '/subaffiliate_reports/' + saveKey + '/list',
        params = {};

      return mainApi.get(url, params);
    };

    SubaffiliateReportApi.create_template = function(saveKey) {
      var url = this.namespace + '/subaffiliate_reports/' + saveKey,
        params = {};

      return mainApi.post(url, params);
    };

    SubaffiliateReportApi.delete_template = function(saveKey, tempId) {
      var url = this.namespace + '/subaffiliate_reports/' + saveKey + '/' + tempId,
        params = {};

      return mainApi['delete'](url, params);
    };

    SubaffiliateReportApi.update_template = function(saveKey, tempId, data) {
      var url = this.namespace + '/subaffiliate_reports/' + saveKey + '/' + tempId,
        params = data || {};

      return mainApi.put(url, params);
    };

    SubaffiliateReportApi.get_tab_data = function(saveKey, tempId, tabId) {
      var url = this.namespace + '/subaffiliate_reports/' + saveKey + '/' + tempId + '/tabs/' + tabId,
        params = {};

      return mainApi.get(url, params);
    };

    SubaffiliateReportApi.add_tab_data = function(saveKey, tempId, tabId, data, direction) {
      var url =
          this.namespace +
          '/subaffiliate_reports/' +
          saveKey +
          '/' +
          tempId +
          '/tabs/' +
          tabId +
          '/' +
          (direction ? 'add' : 'remove'),
        params = {};

      if (saveKey === 'segments') {
        params.segment_tab = {data: data};
      } else if (saveKey === 'structures') {
        params.structure_tab = {data: data};
      }

      return mainApi.put(url, params);
    };

    SubaffiliateReportApi.download_report = function(report_information) {
      var url = this.namespace + '/subaffiliate_reports/download_report',
        params = {report: report_information};

      return mainApi.post(url, params);
    };

    return SubaffiliateReportApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('ReportApi', ReportApi);

  ReportApi.$inject = ['mainApi'];

  function ReportApi(mainApi) {
    var ReportApi = {};

    ReportApi.namespace = '';

    ReportApi.get_information = function(reportOpts, current_page) {
      var url = this.namespace + '/reports/generate_report',
        params = {report: reportOpts, page: current_page};

      return mainApi.post(url, params);
    };

    ReportApi.pagination = function(params) {
      var url = this.namespace + '/reports/generate_report',
        _params = params || {};

      _params.report = _params.additional_options;

      return mainApi.post(url, _params);
    };

    ReportApi.report_params = function() {
      var url = this.namespace + '/reports/options',
        params = {};

      return mainApi.get(url, params);
    };

    ReportApi.templates_list = function(saveKey) {
      var url = this.namespace + '/reports/' + saveKey + '/list',
        params = {};

      return mainApi.get(url, params);
    };

    ReportApi.create_template = function(saveKey) {
      var url = this.namespace + '/reports/' + saveKey,
        params = {};

      return mainApi.post(url, params);
    };

    ReportApi.delete_template = function(saveKey, tempId) {
      var url = this.namespace + '/reports/' + saveKey + '/' + tempId,
        params = {};

      return mainApi['delete'](url, params);
    };

    ReportApi.update_template = function(saveKey, tempId, data) {
      var url = this.namespace + '/reports/' + saveKey + '/' + tempId,
        params = data || {};

      return mainApi.put(url, params);
    };

    ReportApi.get_tab_data = function(saveKey, tempId, tabId) {
      var url = this.namespace + '/reports/' + saveKey + '/' + tempId + '/tabs/' + tabId,
        params = {};

      return mainApi.get(url, params);
    };

    ReportApi.add_tab_data = function(saveKey, tempId, tabId, data, direction) {
      var url =
          this.namespace +
          '/reports/' +
          saveKey +
          '/' +
          tempId +
          '/tabs/' +
          tabId +
          '/' +
          (direction ? 'add' : 'remove'),
        params = {};

      if (saveKey === 'segments') {
        params.segment_tab = {data: data};
      } else if (saveKey === 'structures') {
        params.structure_tab = {data: data};
      }

      return mainApi.put(url, params);
    };

    ReportApi.get_aasm_states = function() {
      var url = this.namespace + '/reports/stucture_states',
        params = {};

      return mainApi.get(url, params);
    };

    ReportApi.download_report = function(report_information) {
      var url = this.namespace + '/reports/download_report',
        params = {report: report_information};

      return mainApi.post(url, params);
    };

    return ReportApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('CreativeReportApi', CreativeReportApi);

  CreativeReportApi.$inject = ['mainApi'];

  function CreativeReportApi(mainApi) {
    var CreativeReportApi = {};

    CreativeReportApi.namespace = '';

    CreativeReportApi.get_information = function(reportOpts, current_page) {
      var url = this.namespace + '/creative_reports/generate_report',
        params = {report: reportOpts, page: current_page};

      return mainApi.post(url, params);
    };

    CreativeReportApi.pagination = function(params) {
      var url = this.namespace + '/creative_reports/generate_report',
        _params = params || {};

      _params.report = params.additional_options;

      return mainApi.post(url, _params);
    };

    CreativeReportApi.report_params = function() {
      var url = this.namespace + '/creative_reports/options',
        params = {};

      return mainApi.get(url, params);
    };

    CreativeReportApi.templates_list = function(saveKey) {
      var url = this.namespace + '/creative_reports/' + saveKey + '/list',
        params = {};

      return mainApi.get(url, params);
    };

    CreativeReportApi.create_template = function(saveKey) {
      var url = this.namespace + '/creative_reports/' + saveKey,
        params = {};

      return mainApi.post(url, params);
    };

    CreativeReportApi.delete_template = function(saveKey, tempId) {
      var url = this.namespace + '/creative_reports/' + saveKey + '/' + tempId,
        params = {};

      return mainApi['delete'](url, params);
    };

    CreativeReportApi.update_template = function(saveKey, tempId, data) {
      var url = this.namespace + '/creative_reports/' + saveKey + '/' + tempId,
        params = data || {};

      return mainApi.put(url, params);
    };

    CreativeReportApi.get_tab_data = function(saveKey, tempId, tabId) {
      var url = this.namespace + '/creative_reports/' + saveKey + '/' + tempId + '/tabs/' + tabId,
        params = {};

      return mainApi.get(url, params);
    };

    CreativeReportApi.add_tab_data = function(saveKey, tempId, tabId, data, direction) {
      var url =
          this.namespace +
          '/creative_reports/' +
          saveKey +
          '/' +
          tempId +
          '/tabs/' +
          tabId +
          '/' +
          (direction ? 'add' : 'remove'),
        params = {};

      if (saveKey === 'segments') {
        params.segment_tab = {data: data};
      } else if (saveKey === 'structures') {
        params.structure_tab = {data: data};
      }

      return mainApi.put(url, params);
    };

    CreativeReportApi.download_report = function(report_information) {
      var url = this.namespace + '/creative_reports/download_report',
        params = {report: report_information};

      return mainApi.post(url, params);
    };

    return CreativeReportApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminQuintsApi', AdminQuintsApi);

  AdminQuintsApi.$inject = ['mainApi'];

  function AdminQuintsApi(mainApi) {
    var QuintsApi = {};

    QuintsApi.getQuintsApiLinks = function() {
      var url = 'admin/profile/api_tokens',
        params = {};

      return mainApi.get(url, params);
    };

    QuintsApi.resetApiToken = function() {
      return mainApi.put('admin/api_tokens_refresh', {});
    };

    return QuintsApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('PromoCodesApi', PromoCodesApi);

  PromoCodesApi.$inject = ['mainApi'];

  function PromoCodesApi(mainApi) {
    var PromoCodes = {};

    PromoCodes.list = function() {
      var url = 'admin/promo_codes/list',
        params = {};

      return mainApi.post(url, params);
    };

    PromoCodes.pagination = function(params) {
      var url = 'admin/promo_codes/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    PromoCodes.createPromoCode = function(promoCode) {
      var url = 'admin/promo_codes',
        params = {
          promo_code: {
            code: promoCode.promo_code,
            serial_id: promoCode.tracker
          }
        };

      return mainApi.post(url, params);
    };

    PromoCodes.getTrackers = function() {
      var url = 'admin/promo_codes/list_trackers',
        params = {};

      return mainApi.get(url, params);
    };

    PromoCodes.destroy = function(id) {
      var url = 'admin/promo_codes/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    PromoCodes.restore = function(id) {
      var url = 'admin/promo_codes/' + id + '/restore',
        params = {};

      return mainApi.post(url, params);
    };

    PromoCodes.getAudits = function(id) {
      var url = 'admin/promo_codes/' + id + '/audits',
        params = {};

      return mainApi.get(url, params);
    };

    return PromoCodes;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliatePlayersCheckApi', AffiliatePlayersCheckApi);

  AffiliatePlayersCheckApi.$inject = ['mainApi'];

  function AffiliatePlayersCheckApi(mainApi) {
    var AffiliatePlayersCheck = {};

    AffiliatePlayersCheck.players_check = function(name) {
      var url = 'affiliate/dashboard/players_check',
        params = {username: name};

      return mainApi.get(url, params);
    };

    AffiliatePlayersCheck.players_check_permit = function() {
      var url = 'affiliate/dashboard/players_check_permit',
        params = {};

      return mainApi.get(url, params);
    };

    return AffiliatePlayersCheck;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminPlayersApi', AdminPlayersApi);

  AdminPlayersApi.$inject = ['mainApi'];

  function AdminPlayersApi(mainApi) {
    var AdminPlayers = {};

    AdminPlayers.list_players = function() {
      var url = 'admin/observing_of_daily_statistics_players',
        params = {};

      return mainApi.post(url, params);
    };

    AdminPlayers.pagination = function(params) {
      var url = 'admin/observing_of_daily_statistics_players',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AdminPlayers.show = function(id) {
      var url = 'admin/observing_of_daily_statistics_players/' + id,
        params = {};

      return mainApi.get(url, params);
    };

    AdminPlayers.showPlayerTrackers = function(id) {
      var url = 'admin/observing_of_daily_statistics_players/' + id + '/trackers',
        params = {};

      return mainApi.get(url, params);
    };

    AdminPlayers.downloadReport = function(reportParams) {
      var url = 'admin/observing_of_daily_statistics_players/download_list',
        params = {report: reportParams};

      return mainApi.post(url, params);
    };

    return AdminPlayers;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminPersonalApi', AdminPersonalApi);

  AdminPersonalApi.$inject = ['mainApi'];

  function AdminPersonalApi(mainApi) {
    var AdminPersonal = {};

    AdminPersonal.index = function() {
      var url = 'admin/personals/list_personals',
        params = {};

      return mainApi.post(url, params);
    };

    AdminPersonal.pagination = function(params) {
      var url = 'admin/personals/list_personals',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AdminPersonal.show = function(id) {
      var url = 'admin/personals/' + id,
        params = {};

      return mainApi.get(url, params);
    };

    AdminPersonal.destroy = function(id) {
      var url = 'admin/personals/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    AdminPersonal.update = function(personal) {
      var url = 'admin/personals/' + personal.id,
        params = {personal: personal};

      return mainApi.put(url, params);
    };

    AdminPersonal.banned = function(id) {
      var url = 'admin/personals/' + id + '/change_ban_status',
        params = {};

      return mainApi.post(url, params);
    };

    AdminPersonal.create = function(personal) {
      var url = 'admin/personals',
        params = {personal: personal};

      return mainApi.post(url, params);
    };

    AdminPersonal.list_roles = function() {
      var url = 'admin/personals/list_roles',
        params = {};

      return mainApi.get(url, params);
    };

    AdminPersonal.resetTwoFactorAuth = function(adminId) {
      var url = 'admin/personals/' + adminId + '/clear_google_secret',
        params = {};

      return mainApi.post(url, params);
    };

    return AdminPersonal;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('partnersMailingApi', partnersMailingApi);

  partnersMailingApi.$inject = ['mainApi'];

  function partnersMailingApi(mainApi) {
    var partnersMailing = {};

    partnersMailing.getOptions = function() {
      var url = 'admin/mailing/options',
        params = {};

      return mainApi.get(url, params);
    };

    partnersMailing.getAffiliates = function(tabsData) {
      var url = 'admin/mailing/list_affiliates',
        params = {
          filters: {
            locales: tabsData[1],
            chief_ids: tabsData[2],
            banned: tabsData[3],
            agree_receive_emails: tabsData[4],
            checked_ids: tabsData[5]
          }
        };

      return mainApi.post(url, params);
    };

    partnersMailing.sendEmail = function(tabsData, emailParams, isTesting) {
      var url = 'admin/mailing/' + (isTesting ? 'testing_send_letter' : 'send_letter'),
        params = {
          filters: {
            agree_receive_emails: tabsData[4],
            locales: tabsData[1],
            chief_ids: tabsData[2],
            banned: tabsData[3],
            ids: tabsData[5]
          },
          letter: {
            subject: emailParams.emailSubject,
            body: emailParams.emailBody,
            sender_email: emailParams.senderEmail,
            sender_name: emailParams.senderName
          },
          emails: emailParams.emailForTesting
        };

      return mainApi.post(url, params);
    };

    return partnersMailing;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('UnconfirmedPartnersApi', UnconfirmedPartnersApi);

  UnconfirmedPartnersApi.$inject = ['mainApi'];

  function UnconfirmedPartnersApi(mainApi) {
    var UnconfirmedPartners = {};

    UnconfirmedPartners.getAffiliates = function() {
      var url = 'admin/affiliates/list_unconfirmed',
        params = {};

      return mainApi.post(url, params);
    };

    UnconfirmedPartners.pagination = function(params) {
      var url = 'admin/affiliates/list_unconfirmed',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    UnconfirmedPartners.sendEmailAgain = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/resend_confirmation_email',
        params = {};

      return mainApi.post(url, params);
    };

    UnconfirmedPartners.getAffiliateToken = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/confirmation_token',
        params = {};

      return mainApi.get(url, params);
    };

    return UnconfirmedPartners;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('partnersRequestHistoryApi', partnersRequestHistoryApi);

  partnersRequestHistoryApi.$inject = ['mainApi'];

  function partnersRequestHistoryApi(mainApi) {
    var partnersRequestHistory = {};

    partnersRequestHistory.get_affiliate_history = function() {
      var url = 'admin/affiliates/list_requests_history',
        params = {};

      return mainApi.post(url, params);
    };

    partnersRequestHistory.pagination = function(params) {
      var url = 'admin/affiliates/list_requests_history',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    partnersRequestHistory.changeStatus = function(id) {
      var url = 'admin/affiliates/' + id + '/rehabilitate_request',
        params = {};

      return mainApi.post(url, params);
    };

    partnersRequestHistory.downloadReport = function(reportParams) {
      var url = 'admin/affiliates/download_list_requests_history',
        params = {report: reportParams};

      return mainApi.post(url, params);
    };

    return partnersRequestHistory;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminPartnersFeesApi', AdminPartnersFeesApi);

  AdminPartnersFeesApi.$inject = ['mainApi'];

  function AdminPartnersFeesApi(mainApi) {
    var PartnersFees = {};

    PartnersFees.getFeesParams = function(partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/admin_fees/list',
        params = {};

      return mainApi.post(url, params);
    };

    PartnersFees.getOptions = function(partnerId, merchantId) {
      var url = 'admin/affiliates/' + partnerId + '/admin_fees/options',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    PartnersFees.createFeesParams = function(partnerId, params) {
      var url = 'admin/affiliates/' + partnerId + '/admin_fees',
        _params = {
          admin_fee: {
            percent: params.limit,
            count_from: params.feeColumn,
            date: params.date
          }
        };

      return mainApi.post(url, _params);
    };

    return PartnersFees;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('partnersBalancesApi', partnersBalancesApi);

  partnersBalancesApi.$inject = ['mainApi'];

  function partnersBalancesApi(mainApi) {
    var BalancesApi = {};

    BalancesApi.getPartnersBalances = function() {
      var url = 'admin/affiliate_cashouts/balance/list',
        params = {};

      return mainApi.post(url, params);
    };

    BalancesApi.pagination = function(params) {
      var url = 'admin/affiliate_cashouts/balance/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    BalancesApi.getPartnerBalance = function(partnerId) {
      var url = 'admin/affiliate_cashouts/balance/' + partnerId,
        params = {};

      return mainApi.get(url, params);
    };

    BalancesApi.saveBalanceAdjustment = function(partnerId, data) {
      var url = 'admin/affiliate_cashouts/balance/update_balance',
        params = {
          affiliate_cashout: {
            amount: data.amount,
            comment: data.comment,
            affiliate_id: partnerId
          }
        };

      return mainApi.post(url, params);
    };

    BalancesApi.downloadReport = function(reportParams, filterId) {
      var url = 'admin/affiliate_cashouts/balance/download_report',
        params = {report: reportParams, filter_set_id: filterId};

      return mainApi.post(url, params);
    };

    return BalancesApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('PartnerTrackerSettingsApi', PartnerTrackerSettingsApi);

  PartnerTrackerSettingsApi.$inject = ['mainApi'];

  function PartnerTrackerSettingsApi(mainApi) {
    var PartnerTrackerSettings = {};

    PartnerTrackerSettings.trackers_list = function(id) {
      var url = 'admin/affiliates/' + id + '/trackers/list',
        params = {};

      return mainApi.post(url, params);
    };

    PartnerTrackerSettings.pagination = function(params) {
      var url = 'admin/affiliates/' + params.additional_options.partnerId + '/trackers/list',
        _params = params;

      return mainApi.post(url, _params);
    };

    PartnerTrackerSettings.tracker_settings = function(id) {
      var url = 'admin/affiliates/' + id + '/show_tracker_settings',
        params = {};

      return mainApi.get(url, params);
    };

    PartnerTrackerSettings.getTracker = function(id, trackerId) {
      var url = 'admin/affiliates/' + id + '/trackers/' + trackerId + '/show_current_tracker',
        params = {};

      return mainApi.get(url, params);
    };

    PartnerTrackerSettings.saveTracker = function(id, tracker) {
      var url = 'admin/affiliates/' + id + '/trackers/' + (tracker.id || ''),
        method = tracker.id ? 'put' : 'post',
        params = {tracker: tracker};

      return mainApi[method](url, params);
    };

    PartnerTrackerSettings.updateTrackerCondition = function(id, tracker) {
      var url = 'admin/affiliates/' + id + '/trackers/' + tracker.id + '/update_condition',
        params = {tracker: tracker};

      return mainApi.put(url, params);
    };

    PartnerTrackerSettings.common_update = function(id, max_count_trackers, condition_id) {
      var url = 'admin/affiliates/' + id,
        params = {affiliate: {max_count_trackers: max_count_trackers, condition_id: condition_id}};

      return mainApi.put(url, params);
    };

    PartnerTrackerSettings.getConditions = function(partnerId) {
      var url = 'admin/affiliates/' + partnerId + '/trackers/conditions_list',
        params = {};

      return mainApi.post(url, params);
    };

    PartnerTrackerSettings.bulkReplaceDeals = function(partnerId, data) {
      var url = 'admin/affiliates/' + partnerId + '/trackers/update_trackers_by_condition',
        params = {
          condition_id: data.conditionId,
          date: data.date,
          selected_tracker_ids: data.selectedItems,
          page: data.paginationParams.page,
          segment_id: data.filterId
        };

      return mainApi.put(url, params);
    };

    return PartnerTrackerSettings;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('PartnerSubaffiliateConditionApi', PartnerSubaffiliateConditionApi);

  PartnerSubaffiliateConditionApi.$inject = ['mainApi'];

  function PartnerSubaffiliateConditionApi(mainApi) {
    var PartnerApi = {};

    PartnerApi.conditionSettings = function(id) {
      var url = 'admin/affiliates/' + id + '/show_subaffiliate_condition',
        params = {};

      return mainApi.get(url, params);
    };

    PartnerApi.getCondition = function(id, merchantId) {
      var url = 'admin/history_of_subaffiliates_changes/' + id + '/edit',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    PartnerApi.createCondition = function(condition) {
      var url = 'admin/history_of_subaffiliates_changes',
        params = {history_of_subaffiliates_change: condition};

      return mainApi.post(url, params);
    };

    PartnerApi.updateCondition = function(condition, merchantId) {
      var url = 'admin/history_of_subaffiliates_changes/' + condition.id,
        params = {history_of_subaffiliates_change: condition, _merchant: merchantId};

      return mainApi.put(url, params);
    };

    PartnerApi.deleteCondition = function(id) {
      var url = 'admin/history_of_subaffiliates_changes/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    return PartnerApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('partnerApi', partnerApi);

  partnerApi.$inject = ['mainApi'];

  function partnerApi(mainApi) {
    var partner = {};

    partner.get_affiliate = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/show_settings',
        params = {};

      return mainApi.get(url, params);
    };

    partner.update = function(affiliate, id) {
      var url = 'admin/affiliates/' + id,
        params = {affiliate: affiliate};

      return mainApi.put(url, params);
    };

    partner.approved = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/approval_request',
        params = {};

      return mainApi.post(url, params);
    };

    partner.reject = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/reject_request',
        params = {};

      return mainApi.post(url, params);
    };

    partner.roles_list = function() {
      var url = 'admin/affiliates/list_roles',
        params = {};

      return mainApi.get(url, params);
    };

    partner.save_subaffiliate = function(params, affiliate_id) {
      var url = 'admin/affiliate_invitations/' + affiliate_id + '/update_affiliate_invitaion',
        _params = {affiliate_invitation: {affiliate_id: params.affiliate_invitation_id, date: params.date}};

      return mainApi.put(url, _params);
    };

    partner.resetTwoFactorAuth = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/clear_google_secret',
        params = {};

      return mainApi.post(url, params);
    };

    partner.acceptPartnerWithManager = function(affiliate_id, managerId) {
      var url = 'admin/affiliates/' + affiliate_id + '/approval_request',
        params = {manager_id: managerId};

      return mainApi.post(url, params);
    };

    partner.getPaymentMethods = function(affiliate_id) {
      var url = 'admin/payment_systems/' + affiliate_id + '/allowed_payment_systems',
        params = {};

      return mainApi.get(url, params);
    };

    partner.getCountries = function(affiliate_id) {
      var url = 'admin/payment_systems/' + affiliate_id + '/countries',
        params = {};

      return mainApi.get(url, params);
    };

    partner.savePaymentDetails = function(paymentSystemDetails, affiliate_id) {
      var url = 'admin/payment_systems/' + affiliate_id + '/update_payment_system',
        params = {payment_system: paymentSystemDetails};

      return mainApi.post(url, params);
    };

    return partner;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('newPartnersApi', newPartnersApi);

  newPartnersApi.$inject = ['mainApi'];

  function newPartnersApi(mainApi) {
    var newPartners = {};

    newPartners.new_affiliates = function() {
      var url = 'admin/affiliates/list_waiting_for_approval',
        params = {};

      return mainApi.post(url, params);
    };

    newPartners.pagination = function(params) {
      var url = 'admin/affiliates/list_waiting_for_approval',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    newPartners.set_count_new_partners = function() {
      var url = 'admin/affiliates/confirmed_awaiting_count',
        params = {};

      return mainApi.get(url, params);
    };

    newPartners.downloadReport = function(reportParams, filterId) {
      var url = 'admin/affiliates/download_waiting_for_approval',
        params = {report: reportParams, filter_set_id: filterId};

      return mainApi.post(url, params);
    };

    newPartners.getManagersList = function() {
      var url = 'admin/affiliates/list_of_affiliate_managers',
        params = {};

      return mainApi.get(url, params);
    };

    return newPartners;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('approvedPartnersApi', approvedPartnersApi);

  approvedPartnersApi.$inject = ['mainApi'];

  function approvedPartnersApi(mainApi) {
    var approvedPartners = {};

    approvedPartners.approve_affiliates = function() {
      var url = 'admin/affiliates/list_approved',
        params = {};

      return mainApi.post(url, params);
    };

    approvedPartners.pagination = function(params) {
      var url = 'admin/affiliates/list_approved',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    approvedPartners.banned = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/change_ban_status',
        params = {};

      return mainApi.post(url, params);
    };

    approvedPartners.supervision = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/enable_supervision',
        params = {};

      return mainApi.post(url, params);
    };

    approvedPartners.supervision_disable = function(affiliate_id) {
      var url = 'admin/affiliates/' + affiliate_id + '/disable_supervision',
        params = {};

      return mainApi['delete'](url, params);
    };

    approvedPartners.downloadReport = function(reportParams, filterId) {
      var url = 'admin/affiliates/download_list_approved',
        params = {report: reportParams, filter_set_id: filterId};

      return mainApi.post(url, params);
    };

    approvedPartners.getManagers = function() {
      var url = 'admin/affiliates/list_of_affiliate_managers',
        params = {};

      return mainApi.get(url, params);
    };

    approvedPartners.changeManager = function(managerId, affiliatesIds, filterId, params) {
      var url = 'admin/affiliates/change_manager_for_affiliates',
        params = {
          manager_id: managerId,
          affiliate_ids: affiliatesIds,
          segment_id: filterId,
          page: params.page
        };

      return mainApi.post(url, params);
    };

    return approvedPartners;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('NotificationHeaderApi', NotificationHeaderApi);

  NotificationHeaderApi.$inject = ['mainApi'];

  function NotificationHeaderApi(mainApi) {
    var notifyApi = {};

    notifyApi.saveNotify = function(notify, notifyAttributes, namespace) {
      var url = 'admin/notifications/' + notify.id,
        params = {
          namespace: namespace,
          notification: {
            header_color: notify.headerColor,
            text_color: notify.textColor,
            visible: notify.visible,
            text_for_notifications_attributes: notifyAttributes
          }
        };

      return mainApi.put(url, params);
    };

    notifyApi.getAdminNotifyContent = function(namespace) {
      var url = 'admin/notifications',
        params = {namespace: namespace};

      return mainApi.get(url, params);
    };

    notifyApi.getNotifyContent = function(namespace, language) {
      var url = 'anonym/notifications/get_text_for_notification_in_header',
        params = {
          namespace: namespace,
          locale: language
        };

      return mainApi.get(url, params);
    };

    notifyApi.readNotify = function(id) {
      var url = 'anonym/notifications/' + id + '/add_view',
        params = {};

      return mainApi.post(url, params);
    };

    return notifyApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminMassRetagApi', AdminMassRetagApi);

  AdminMassRetagApi.$inject = ['mainApi'];

  function AdminMassRetagApi(mainApi) {
    var massRetag = {};

    massRetag.massRetagPlayers = function(data, config) {
      return mainApi.post('admin/mass_retag/retag', data, config);
    };

    return massRetag;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('LocalesApi', LocalesApi);

  LocalesApi.$inject = ['mainApi'];

  function LocalesApi(mainApi) {
    var Locales = {};

    Locales.set_locale = function(locale) {
      var url = 'anonym/translate/locale',
        params = {locale: locale};

      return mainApi.get(url, params);
    };

    return Locales;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('UserlocalStorage', UserlocalStorageApi);

  UserlocalStorageApi.$inject = [];

  function UserlocalStorageApi() {
    var UserlocalStorage = {};

    UserlocalStorage.save = function(key, obj) {
      if (key && obj) {
        localStorage.setItem(key, angular.toJson(obj));
      }
    };

    UserlocalStorage.get = function(key, func) {
      if (key) {
        var data = localStorage.getItem(key);
        if (data) {
          return JSON.parse(data, func);
        }
      }
    };

    UserlocalStorage.removeItem = function(key) {
      if (key) {
        localStorage.removeItem(key);
      }
    };

    UserlocalStorage.clear = function() {
      localStorage.clear();
    };

    UserlocalStorage.getRole = function(userRole) {
      var user_role = UserlocalStorage.get('user_role');

      if (user_role) {
        return userRole ? user_role.role === userRole : user_role.role;
      }
    };

    UserlocalStorage.setRole = function(userRole) {
      UserlocalStorage.save('user_role', {role: userRole});
    };

    UserlocalStorage.userLogout = function() {
      UserlocalStorage.removeItem('user_role');
      UserlocalStorage.removeItem('current_user');
    };

    return UserlocalStorage;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('InfoPagesApi', InfoPagesApi);

  InfoPagesApi.$inject = ['mainApi', '_'];

  function InfoPagesApi(mainApi, _) {
    var PagesApi = {},
      pages = [
        'faq',
        'terms',
        'privacy',
        'commission',
        'help',
        'static_page_1',
        'static_page_2',
        'static_page_3',
        'static_page_4',
        'static_page_5'
      ];

    _.each(pages, function(page) {
      PagesApi['get_' + page] = function() {
        var url = 'affiliate/static_pages/' + page,
          params = {};

        return mainApi.get(url, params);
      };
    });

    PagesApi.get_anonym_terms = function(locale) {
      var url = 'anonym/static_pages/terms',
        params = {language: locale};

      return mainApi.get(url, params);
    };

    PagesApi.get_anonym_privacy = function(locale) {
      var url = 'anonym/static_pages/privacy',
        params = {language: locale};

      return mainApi.get(url, params);
    };

    return PagesApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('importedDataApi', importedDataApi);

  importedDataApi.$inject = ['mainApi'];

  function importedDataApi(mainApi) {
    var importedDataApi = {};

    importedDataApi.list = function() {
      return mainApi.post('admin/ftp_files/list', {});
    };

    importedDataApi.pagination = function(params) {
      return mainApi.post('admin/ftp_files/list', params || {});
    };

    importedDataApi.download = function(id) {
      return mainApi.get('admin/ftp_files/' + id + '/download_link', {});
    };

    return importedDataApi;
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .factory('SettingsSubaffiliateHistoryChangesApi', SettingsSubaffiliateHistoryChangesApi);

  SettingsSubaffiliateHistoryChangesApi.$inject = ['mainApi'];

  function SettingsSubaffiliateHistoryChangesApi(mainApi) {
    var historyChanges = {};

    historyChanges.get_history_item = function(id) {
      var url = 'admin/history_of_subaffiliates_changes/' + id + '/edit';

      return mainApi.get(url, {});
    };

    historyChanges.save_history_item = function(history_item) {
      var url = 'admin/history_of_subaffiliates_changes/' + history_item.id,
        params = {history_of_subaffiliates_change: history_item};

      return mainApi.put(url, params);
    };

    return historyChanges;
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .factory('SettingsBookkeepingHistoryChangesApi', SettingsBookkeepingHistoryChangesApi);

  SettingsBookkeepingHistoryChangesApi.$inject = ['mainApi'];

  function SettingsBookkeepingHistoryChangesApi(mainApi) {
    var historyChanges = {};

    historyChanges.get_item = function(id, merchantId) {
      var url = 'admin/history_of_limit_changes/' + id + '/edit',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    historyChanges.save_item = function(params, merchantId) {
      var url = 'admin/history_of_limit_changes/' + params.id,
        _params = {
          _merchant: merchantId,
          history_of_limit_change: {
            limit: params.limit,
            date: params.date
          }
        };

      return mainApi.put(url, _params);
    };

    return historyChanges;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('SettingsFeesHistoryChangesApi', SettingsFeesHistoryChangesApi);

  SettingsFeesHistoryChangesApi.$inject = ['mainApi'];

  function SettingsFeesHistoryChangesApi(mainApi) {
    var historyChanges = {};

    historyChanges.getItem = function(id, merchantId) {
      var url = 'admin/admin_fees/' + id + '/edit',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    historyChanges.saveItem = function(id, merchantId, params) {
      var url = 'admin/admin_fees/' + id,
        _params = {
          _merchant: merchantId,
          admin_fee: {
            percent: params.limit,
            count_from: params.feeColumn,
            date: params.date
          }
        };

      return mainApi.put(url, _params);
    };

    return historyChanges;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('PartnersFeesHistoryChangesApi', PartnersFeesHistoryChangesApi);

  PartnersFeesHistoryChangesApi.$inject = ['mainApi'];

  function PartnersFeesHistoryChangesApi(mainApi) {
    var historyChanges = {};

    historyChanges.getItem = function(partnerId, id, merchantId) {
      var url = 'admin/affiliates/' + partnerId + '/admin_fees/' + id + '/edit',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    historyChanges.saveItem = function(partnerId, id, merchantId, params) {
      var url = 'admin/affiliates/' + partnerId + '/admin_fees/' + id,
        _params = {
          _merchant: merchantId,
          admin_fee: {
            percent: params.limit,
            count_from: params.feeColumn,
            date: params.date
          }
        };

      return mainApi.put(url, _params);
    };

    return historyChanges;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('historyChanges', historyChangesApi);

  historyChangesApi.$inject = ['mainApi'];

  function historyChangesApi(mainApi) {
    var historyChanges = {};

    historyChanges.remove_item = function(id, params, typeChanges) {
      return this['destroy_' + typeChanges](id, params);
    };

    historyChanges.destroy_players = function(id, params) {
      var url = 'admin/observing_of_daily_statistics_players/' + params.playerId + '/history_of_players_changes/' + id,
        _params = {};

      return mainApi['delete'](url, _params);
    };

    historyChanges.destroy_trackers = function(id) {
      var url = 'admin/history_of_trackers_changes/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    historyChanges.destroy_bookkeeping = function(id) {
      var url = 'admin/history_of_limit_changes/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    historyChanges.destroy_subaffiliate = function(id) {
      var url = 'admin/history_of_subaffiliates_changes/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    historyChanges.destroy_admin_fees = function(id) {
      var url = 'admin/admin_fees/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    historyChanges.destroy_partner_fees = function(id, params) {
      var url = 'admin/affiliates/' + params.itemId + '/admin_fees/' + id,
        _params = {};

      return mainApi['delete'](url, _params);
    };

    historyChanges.destroy_subaffiliate_condition = function(id) {
      var url = 'admin/history_of_subaffiliates_changes/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    historyChanges.edit = function(playerId, id) {
      var url =
          'admin/observing_of_daily_statistics_players/' + playerId + '/history_of_players_changes/' + id + '/edit',
        params = {};

      return mainApi.get(url, params);
    };

    historyChanges.update = function(playerId, item) {
      var url = 'admin/observing_of_daily_statistics_players/' + playerId + '/history_of_players_changes/' + item.id,
        params = {history_of_players_change: item};

      return mainApi.put(url, params);
    };

    historyChanges.edit_trackers = function(id, merchantId) {
      var url = 'admin/history_of_trackers_changes/' + id + '/edit',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    historyChanges.update_trackers = function(item, merchantId) {
      var url = 'admin/history_of_trackers_changes/' + item.id,
        params = {history_of_trackers_change: item, _merchant: merchantId};

      return mainApi.put(url, params);
    };

    historyChanges.create = function(player) {
      var url = 'admin/observing_of_daily_statistics_players/' + player.cid + '/history_of_players_changes',
        params = {history_of_players_change: player};

      return mainApi.post(url, params);
    };

    return historyChanges;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminGroupOfManagersApi', AdminGroupOfManagersApi);

  AdminGroupOfManagersApi.$inject = ['mainApi'];

  function AdminGroupOfManagersApi(mainApi) {
    var GroupOfManagers = {};

    GroupOfManagers.getGroupsList = function() {
      return mainApi.post('admin/admin_groups/list', {});
    };

    GroupOfManagers.pagination = function(params) {
      return mainApi.post('admin/admin_groups/list', params || {});
    };

    GroupOfManagers.getListAdminsForCreate = function() {
      return mainApi.get('admin/admin_groups/list_admins_for_create', {});
    };

    GroupOfManagers.getAdminsOfGroup = function() {
      return mainApi.get('admin/admin_groups/admins_of_group', {});
    };

    GroupOfManagers.getGroup = function(groupId) {
      return mainApi.get('admin/admin_groups/' + groupId, {});
    };

    GroupOfManagers.getManagers = function(groupId) {
      return mainApi.get('admin/admin_groups/' + groupId + '/available_admins', {});
    };

    GroupOfManagers.saveFields = function(groupId, params, direction) {
      return mainApi.post('admin/admin_groups/' + groupId + '/' + (direction ? 'add_admin' : 'remove_admin'), {
        admin: params
      });
    };

    GroupOfManagers.createGroup = function(adminId) {
      return mainApi.post('admin/admin_groups', {admin_group: {admin_id: adminId}});
    };

    GroupOfManagers.updateGroupOwner = function(groupId, adminId) {
      return mainApi.put('admin/admin_groups/' + groupId, {admin_group: {admin_id: adminId}});
    };

    GroupOfManagers.deleteGroup = function(groupId) {
      return mainApi['delete']('admin/admin_groups/' + groupId, {});
    };

    return GroupOfManagers;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('ExportDataApi', ExportDataApi);

  ExportDataApi.$inject = ['mainApi'];

  function ExportDataApi(mainApi) {
    var exportApi = {};

    exportApi.getReportTypes = function(namespace) {
      return mainApi.get(namespace + '/csv_reports/types', {});
    };

    exportApi.createReport = function(namespace, params) {
      return mainApi.post(namespace + '/csv_reports', {
        csv_report: {
          report_type: params.reportType,
          period_month: params.periodMonth,
          period_year: params.periodYear
        }
      });
    };

    return exportApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('DownloadCsvApi', DownloadCsvApi);

  DownloadCsvApi.$inject = ['mainApi'];

  function DownloadCsvApi(mainApi) {
    var downloadApi = {};

    downloadApi.getCsvList = function(namespace) {
      return mainApi.post(namespace + '/background_reports/list', {});
    };

    downloadApi.pagination = function(params) {
      return mainApi.post(params.additional_options.namespace + '/background_reports/list', params || {});
    };

    downloadApi.downloadReport = function(namespace, id) {
      return mainApi.get(namespace + '/background_reports/' + id + '/download_report_link', {});
    };

    downloadApi.removeReport = function(namespace, id) {
      return mainApi['delete'](namespace + '/background_reports/' + id, {});
    };

    return downloadApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateDashboardApi', AffiliateDashboardApi);

  AffiliateDashboardApi.$inject = ['mainApi'];

  function AffiliateDashboardApi(mainApi) {
    var AffiliateDashboard = {};

    AffiliateDashboard.getStats = function(merchantId) {
      var url = 'affiliate/dashboard/get_stats',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AffiliateDashboard.getLastUpdate = function(merchantId) {
      var url = 'affiliate/dashboard/last_update',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AffiliateDashboard.getCharts = function(merchantId) {
      var url = 'affiliate/dashboard/chart',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AffiliateDashboard.getChief = function(merchantId) {
      var url = 'affiliate/dashboard/personal_chief',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AffiliateDashboard.getMerchants = function() {
      return mainApi.get('affiliate/dashboard/get_merchants', {});
    };

    return AffiliateDashboard;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminDashboardApi', AdminDashboardApi);

  AdminDashboardApi.$inject = ['mainApi'];

  function AdminDashboardApi(mainApi) {
    var AdminDashboard = {};

    AdminDashboard.getLastUpdateTime = function(merchantId) {
      var url = 'admin/dashboard/last_update',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AdminDashboard.getStats = function(merchantId) {
      var url = 'admin/dashboard/get_stats',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AdminDashboard.getCharts = function(merchantId) {
      var url = 'admin/dashboard/chart',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AdminDashboard.getTops = function(merchantId) {
      var url = 'admin/dashboard/tops',
        params = {_merchant: merchantId};

      return mainApi.get(url, params);
    };

    AdminDashboard.getMerchants = function() {
      return mainApi.get('admin/dashboard/get_merchants', {});
    };

    return AdminDashboard;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateCreativesApi', AffiliateCreativesApi);

  AffiliateCreativesApi.$inject = ['mainApi'];

  function AffiliateCreativesApi(mainApi) {
    var AffiliateCreativesApi = {};

    AffiliateCreativesApi.get_creatives = function(creative_type) {
      var url = 'affiliate/creatives/' + creative_type + '/list',
        params = {};

      return mainApi.post(url, params);
    };

    AffiliateCreativesApi.pagination = function(params) {
      var url = 'affiliate/creatives/' + params.additional_options.format + '/list',
        _params = params || {};

      // _params.format = params.additional_options.format;

      return mainApi.post(url, _params);
    };

    AffiliateCreativesApi.get_redirect_link = function(params, creativeFormat) {
      var url = 'affiliate/creatives/' + creativeFormat + '/redirect_link',
        _params = params || {};

      return mainApi.get(url, _params);
    };

    AffiliateCreativesApi.getActuallyCreatives = function() {
      var url = 'affiliate/creatives/options',
        params = {};

      return mainApi.get(url, params);
    };

    return AffiliateCreativesApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminCreativesApi', AdminCreativesApi);

  AdminCreativesApi.$inject = ['mainApi', '_'];

  function AdminCreativesApi(mainApi, _) {
    var AdminCreativesApi = {};

    AdminCreativesApi.get_creatives = function(creative_type) {
      var url = 'admin/creatives/list',
        params = {format: creative_type};

      return mainApi.post(url, params);
    };

    AdminCreativesApi.pagination = function(params) {
      var url = 'admin/creatives/list',
        _params = params || {};

      _params.format = params.additional_options.format;

      return mainApi.post(url, _params);
    };

    AdminCreativesApi.show = function(creative_id, format) {
      var url = 'admin/creatives/' + creative_id,
        params = {format: format};

      return mainApi.get(url, params);
    };

    AdminCreativesApi.save_creative = function(creative) {
      var url = 'admin/creatives/' + (creative.id ? creative.id : ''),
        method = creative.id ? 'put' : 'post',
        params = {
          creative: method === 'post' ? _.omit(creative, 'is_exclusive') : creative
        };

      return mainApi[method](url, params);
    };

    AdminCreativesApi.remove_creative = function(creative) {
      var url = 'admin/creatives/' + creative.id,
        params = {creative: creative};

      return mainApi['delete'](url, params);
    };

    AdminCreativesApi.search_advertising_company = function(word) {
      var word_params = word ? '?q=' + word : '',
        url = 'admin/creatives/list_advertising_company' + word_params,
        params = {};

      return mainApi.get(url, params);
    };

    AdminCreativesApi.changeCreativesStatus = function(creativesList, filterId, creativeFormat, setActivated, params) {
      var url = 'admin/creatives/' + (setActivated ? 'active_creatives' : 'inactive_creatives'),
        params = {
          ids: creativesList,
          segment_id: filterId,
          format: creativeFormat,
          page: params.page
        };

      return mainApi.post(url, params);
    };

    AdminCreativesApi.getCreativeLanguages = function() {
      var url = 'admin/creatives/options',
        params = {};

      return mainApi.get(url, params);
    };

    AdminCreativesApi.changeArchiveStatus = function(creativesList, filterId, creativeFormat, archive, params) {
      var url = 'admin/creatives/' + (archive ? 'archive' : 'unarchive'),
        params = {
          ids: creativesList,
          segment_id: filterId,
          page: params.page,
          format: creativeFormat
        };

      return mainApi.post(url, params);
    };

    return AdminCreativesApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('ConditionsApi', ConditionsApi);

  ConditionsApi.$inject = ['mainApi'];

  function ConditionsApi(mainApi) {
    var ConditionsApi = {};

    ConditionsApi.conditions_list = function() {
      var url = 'admin/conditions/list',
        params = {};

      return mainApi.post(url, params);
    };

    ConditionsApi.pagination = function(params) {
      var url = 'admin/conditions/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    ConditionsApi.get = function() {
      var url = 'admin/conditions/list_constants',
        params = {};

      return mainApi.get(url, params);
    };

    ConditionsApi.destroy = function(id) {
      var url = 'admin/conditions/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    ConditionsApi.create_or_update = function(condition, merchantId) {
      var url = 'admin/conditions/' + (condition.id ? condition.id : '0') + '/change_with_nested_attributes',
        params = {_merchant: merchantId, condition: condition};

      return mainApi.put(url, params);
    };

    ConditionsApi.edit = function(id) {
      var url = 'admin/conditions/' + id + '/edit',
        params = {};

      return mainApi.get(url, params);
    };

    ConditionsApi.getCountries = function() {
      var url = 'admin/countries/list',
        params = {};

      return mainApi.get(url, params);
    };

    ConditionsApi.getMerchantsList = function() {
      return mainApi.get('admin/conditions/list_merchants', {});
    };

    return ConditionsApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('ChangePasswordApi', ChangePasswordApi);

  ChangePasswordApi.$inject = ['mainApi'];

  function ChangePasswordApi(mainApi) {
    var changePassword = {};

    changePassword.putEmail = function(email) {
      var url = 'password',
        params = {email: email};

      return mainApi.post(url, params);
    };

    changePassword.confirmEmail = function(token) {
      var url = 'password/edit',
        params = {reset_password_token: token};

      return mainApi.get(url, params);
    };

    changePassword.changePassword = function(password, password_confirmation, token) {
      var url = 'password',
        params = {
          reset_password_token: token,
          password: password,
          password_confirmation: password_confirmation
        };

      return mainApi.put(url, params);
    };

    return changePassword;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateBookkeepingApi', AffiliateBookkeepingApi);

  AffiliateBookkeepingApi.$inject = ['mainApi'];

  function AffiliateBookkeepingApi(mainApi) {
    var AffiliateBookkeepingApi = {};

    AffiliateBookkeepingApi.get_month_payment = function() {
      var url = 'affiliate/bookkeepings/list_affiliate_month_payments',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateBookkeepingApi.pagination = function(params) {
      var url = 'affiliate/bookkeepings/list_affiliate_month_payments',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AffiliateBookkeepingApi.get_affiliate_month_payment = function(date) {
      var url = 'affiliate/bookkeepings/list_affiliate_month_payments_in_one_month',
        params = {date_of_payment: date};

      return mainApi.get(url, params);
    };

    AffiliateBookkeepingApi.pagination_month_report = function(params) {
      var url = 'affiliate/bookkeepings/list_affiliate_month_payments_in_one_month',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AffiliateBookkeepingApi.download_report = function(report_information) {
      var url = 'affiliate/bookkeepings/download_report',
        params = {report: report_information};

      return mainApi.post(url, params);
    };

    return AffiliateBookkeepingApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminBookkeepingApi', AdminBookkeepingApi);

  AdminBookkeepingApi.$inject = ['mainApi'];

  function AdminBookkeepingApi(mainApi) {
    var AdminBookkeeping = {};

    AdminBookkeeping.get_month_payment = function() {
      var url = 'admin/bookkeepings/list_month_payments',
        params = {};

      return mainApi.get(url, params);
    };

    AdminBookkeeping.pagination = function(params) {
      var url = 'admin/bookkeepings/list_month_payments',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AdminBookkeeping.get_affiliate_month_payment = function(date) {
      var url = 'admin/bookkeepings/list_affiliate_month_payments',
        params = {date_of_payment: date};

      return mainApi.get(url, params);
    };

    AdminBookkeeping.pagination_month_report = function(params) {
      var url = 'admin/bookkeepings/list_affiliate_month_payments',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AdminBookkeeping.show_deducation = function(date, id) {
      var url = 'admin/bookkeepings/show_deduction',
        params = {date_of_payment: date, affiliate_id: id};

      return mainApi.get(url, params);
    };

    AdminBookkeeping.save_deduction = function(deduction) {
      var url = 'admin/bookkeepings/deduction',
        params = {
          deduction: deduction,
          date_of_payment: deduction.date_of_payment,
          affiliate_id: deduction.affiliate_id
        };

      return mainApi.post(url, params);
    };

    AdminBookkeeping.chandeStatusMonthPayment = function(date) {
      var url = 'admin/bookkeepings/process_month_payment',
        params = {date_of_payment: date};

      return mainApi.post(url, params);
    };

    AdminBookkeeping.approveMonth = function(date) {
      var url = 'admin/bookkeepings/approve_month_payment',
        params = {date_of_payment: date};

      return mainApi.post(url, params);
    };

    AdminBookkeeping.paidMonth = function(date) {
      var url = 'admin/bookkeepings/pay_month_payment',
        params = {date_of_payment: date};

      return mainApi.post(url, params);
    };

    AdminBookkeeping.download_report = function(report_information) {
      var url = 'admin/bookkeepings/download_report',
        params = {report: report_information};

      return mainApi.post(url, params);
    };

    AdminBookkeeping.transferPayout = function(selectedList, params) {
      var url = 'admin/bookkeepings/update_aasm_state_paid_in_next_month',
        params = {ids: selectedList, page: params.page};

      return mainApi.post(url, params);
    };

    AdminBookkeeping.cancelTransferPayout = function(selectedList, params) {
      var url = 'admin/bookkeepings/update_aasm_state_default_payment',
        params = {ids: selectedList, page: params.page};

      return mainApi.post(url, params);
    };

    AdminBookkeeping.transferPayoffToBalance = function(selectedList, date, params) {
      var url = 'admin/bookkeepings/transfer_payoff',
        params = {ids: selectedList, date_of_payment: date, page: params.page};

      return mainApi.post(url, params);
    };

    return AdminBookkeeping;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminBonusesApi', AdminBonusesApi);

  AdminBonusesApi.$inject = ['mainApi'];

  function AdminBonusesApi(mainApi) {
    var AdminBonuses = {};

    AdminBonuses.get_bonuses = function() {
      var url = 'admin/bonuses/list',
        params = {};

      return mainApi.post(url, params);
    };

    AdminBonuses.pagination = function(params) {
      var url = 'admin/bonuses/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AdminBonuses.create = function(bonus) {
      var url = 'admin/bonuses',
        params = {bonus: bonus};

      return mainApi.post(url, params);
    };

    AdminBonuses.show = function(bonus_id) {
      var url = 'admin/bonuses/' + bonus_id,
        params = {};

      return mainApi.get(url, params);
    };

    AdminBonuses.update = function(bonus) {
      var url = 'admin/bonuses/' + bonus.id,
        params = {bonus: bonus};

      return mainApi.put(url, params);
    };

    AdminBonuses.destroy = function(id) {
      var url = 'admin/bonuses/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    return AdminBonuses;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminAdjustmentsHistoryApi', AdminAdjustmentsHistoryApi);

  AdminAdjustmentsHistoryApi.$inject = ['mainApi'];

  function AdminAdjustmentsHistoryApi(mainApi) {
    var AdjustmentsHistory = {};

    AdjustmentsHistory.getAdjustmentsHistoryList = function() {
      var url = 'admin/affiliate_cashouts/adjustment_history/list',
        params = {};

      return mainApi.post(url, params);
    };

    AdjustmentsHistory.pagination = function(params) {
      var url = 'admin/affiliate_cashouts/adjustment_history/list',
        _params = params || {};

      _params.period = params.additional_options;

      return mainApi.post(url, _params);
    };

    AdjustmentsHistory.downloadReport = function(reportParams, filterId) {
      var url = 'admin/affiliate_cashouts/adjustment_history/download_report',
        params = {report: reportParams, filter_set_id: filterId};

      return mainApi.post(url, params);
    };

    return AdjustmentsHistory;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('UnsubscribeApi', UnsubscribeApi);

  UnsubscribeApi.$inject = ['mainApi'];

  function UnsubscribeApi(mainApi) {
    var Unsubscribe = {};

    Unsubscribe.checkSubscribeStatus = function(token) {
      var url = 'anonym/unsubscribes/' + token + '/check',
        params = {};

      return mainApi.get(url, params);
    };

    Unsubscribe.unsubscribe = function(token) {
      var url = 'anonym/unsubscribes/' + token + '/unsubscribe',
        params = {};

      return mainApi.get(url, params);
    };

    return Unsubscribe;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateRegistrationApi', AffiliateRegistrationApi);

  AffiliateRegistrationApi.$inject = ['mainApi'];

  function AffiliateRegistrationApi(mainApi) {
    var AffiliateRegistration = {};

    AffiliateRegistration.registration = function(token) {
      var url = 'anonym/registrations/referrals_token',
        params = {token: token};

      return mainApi.post(url, params);
    };

    return AffiliateRegistration;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateReferenceApi', AffiliateReferenceApi);

  AffiliateReferenceApi.$inject = ['mainApi'];

  function AffiliateReferenceApi(mainApi) {
    var AffiliateReference = {};

    AffiliateReference.get_token = function() {
      var url = 'affiliate/settings/referrals_token',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateReference.get_subaffiliate_condition = function() {
      var url = 'affiliate/settings/show_subaffiliate_condition',
        params = {};

      return mainApi.get(url, params);
    };

    return AffiliateReference;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateRefLinkApi', AffiliateRefLinkApi);

  AffiliateRefLinkApi.$inject = ['mainApi'];

  function AffiliateRefLinkApi(mainApi) {
    var refLinkApi = {};

    refLinkApi.getConditionTypes = function(conditionParams) {
      var url = 'affiliate/get_creative_links/load_condition_type_of_transaction',
        params = {_merchant: conditionParams.merchant};

      return mainApi.get(url, params);
    };

    refLinkApi.getCreativeTypes = function(creativeParams) {
      var url = 'affiliate/get_creative_links/load_format_of_creative',
        params = {_merchant: creativeParams.merchant};

      return mainApi.get(url, params);
    };

    refLinkApi.getParamsForConditionType = function(creativeParams) {
      var url = 'affiliate/get_creative_links/load_trackers_filter',
        params = {_merchant: creativeParams.merchant, condition_type_of_transaction: creativeParams.condition_type};

      return mainApi.get(url, params);
    };

    refLinkApi.getParamsForCreativeType = function(creativeParams) {
      var url = 'affiliate/get_creative_links/load_creative_language',
        params = {_merchant: creativeParams.merchant, format: creativeParams.creative_type};

      return mainApi.get(url, params);
    };

    refLinkApi.getParamsForLanguage = function(creativeParams) {
      var url = 'affiliate/get_creative_links/load_creative_resolution',
        params = {
          _merchant: creativeParams.merchant,
          format: creativeParams.creative_type,
          language: creativeParams.language
        };

      return mainApi.get(url, params);
    };

    refLinkApi.getParamsForSize = function(creativeParams) {
      var url = 'affiliate/get_creative_links/load_creative_advertising_company',
        params = {
          _merchant: creativeParams.merchant,
          format: creativeParams.creative_type,
          language: creativeParams.language,
          creative_resolution_id: creativeParams.size
        };

      return mainApi.get(url, params);
    };

    refLinkApi.getCreatives = function(creativeParams) {
      var url = 'affiliate/get_creative_links/' + creativeParams.format + '/list_creatives',
        params = creativeParams || {};

      return mainApi.post(url, params);
    };

    refLinkApi.pagination = function(params) {
      var url = 'affiliate/get_creative_links/' + params.additional_options.format + '/list_creatives',
        _params = angular.merge({}, params, params.additional_options);

      return mainApi.post(url, _params);
    };

    return refLinkApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateBannerApi', AffiliateBannerApi);

  AffiliateBannerApi.$inject = ['mainApi'];

  function AffiliateBannerApi(mainApi) {
    var AffiliateBannerApi = {};

    AffiliateBannerApi.getBanner = function(namespace) {
      var url = namespace === 'admin' ? 'admin/banner_settings' : 'affiliate/banners',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateBannerApi.saveBanner = function(banner, config) {
      var url = 'admin/banner_settings';

      return mainApi.put(url, banner, config);
    };

    return AffiliateBannerApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateBalanceApi', AffiliateBalanceApi);

  AffiliateBalanceApi.$inject = ['mainApi'];

  function AffiliateBalanceApi(mainApi) {
    var AffiliateBalance = {};

    AffiliateBalance.getWithdrawalHistory = function() {
      var url = 'affiliate/cashouts/list',
        params = {};

      return mainApi.post(url, params);
    };

    AffiliateBalance.pagination = function(params) {
      var url = 'affiliate/cashouts/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    AffiliateBalance.getBalance = function() {
      var url = 'affiliate/cashouts/current_balance',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateBalance.withdrawalBalance = function(data) {
      var url = 'affiliate/cashouts/withdraw',
        params = {
          payment_system: data
        };

      return mainApi.post(url, params);
    };

    AffiliateBalance.getAvailablePaymentSystems = function() {
      var url = 'affiliate/cashouts/allowed_payment_systems',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateBalance.getCountries = function() {
      var url = 'affiliate/cashouts/countries',
        params = {};

      return mainApi.get(url, params);
    };

    AffiliateBalance.downloadReport = function(reportParams, filterId) {
      var url = 'affiliate/cashouts/download_report',
        params = {report: reportParams, filter_set_id: filterId};

      return mainApi.post(url, params);
    };

    return AffiliateBalance;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AffiliateTokenApi', AffiliateTokenApi);

  AffiliateTokenApi.$inject = ['mainApi'];

  function AffiliateTokenApi(mainApi) {
    var tokenApi = {};

    tokenApi.getToken = function() {
      var url = 'affiliate/settings/api_token',
        params = {};

      return mainApi.get(url, params);
    };

    tokenApi.resetApiToken = function() {
      return mainApi.put('affiliate/api_tokens_refresh', {});
    };

    return tokenApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminWithdrawalsApi', AdminWithdrawalsApi);

  AdminWithdrawalsApi.$inject = ['mainApi'];

  function AdminWithdrawalsApi(mainApi) {
    var WithdrawalsApi = {};

    WithdrawalsApi.getPendingWithdrawals = function() {
      var url = 'admin/affiliate_cashouts/pending_cashouts/list';

      return mainApi.post(url, {});
    };

    WithdrawalsApi.pendingPagination = function(params) {
      var url = 'admin/affiliate_cashouts/pending_cashouts/list',
        _params = params || {};

      _params.period = params.additional_options;

      return mainApi.post(url, _params);
    };

    WithdrawalsApi.approveWithdrawal = function(withdrawalId) {
      var url = 'admin/affiliate_cashouts/pending_cashouts/' + withdrawalId + '/approve',
        params = {};

      return mainApi.put(url, params);
    };

    WithdrawalsApi.denialWithdrawal = function(withdrawalId, reason) {
      var url = 'admin/affiliate_cashouts/pending_cashouts/' + withdrawalId + '/decline',
        params = {comment: reason};

      return mainApi.put(url, params);
    };

    WithdrawalsApi.viewPendingWithdrawal = function(withdrawalId) {
      var url = 'admin/affiliate_cashouts/pending_cashouts/' + withdrawalId,
        params = {};

      return mainApi.get(url, params);
    };

    WithdrawalsApi.downloadReport = function(reportParams, filterId) {
      var url = 'admin/affiliate_cashouts/pending_cashouts/download_report',
        params = {report: reportParams, filter_set_id: filterId};

      return mainApi.post(url, params);
    };

    return WithdrawalsApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AdminCashoutAffiliateBalanceApi', AdminCashoutAffiliateBalanceApi);

  AdminCashoutAffiliateBalanceApi.$inject = ['mainApi'];

  function AdminCashoutAffiliateBalanceApi(mainApi) {
    var AdminCashout = {};

    AdminCashout.getBalance = function(partnerId) {
      var url = 'admin/affiliate_cashouts/balance/' + partnerId,
        params = {};

      return mainApi.get(url, params);
    };

    AdminCashout.withdrawalBalance = function(data, partnerId) {
      var url = 'admin/affiliate_cashouts/withdrawals',
        params = {
          payment_system: data,
          affiliate_id: partnerId
        };

      return mainApi.post(url, params);
    };

    AdminCashout.getAvailablePaymentSystems = function(partnerId) {
      var url = 'admin/payment_systems/' + partnerId + '/allowed_payment_systems',
        params = {};

      return mainApi.get(url, params);
    };

    AdminCashout.getCountries = function(partnerId) {
      var url = 'admin/payment_systems/' + partnerId + '/countries',
        params = {};

      return mainApi.get(url, params);
    };

    return AdminCashout;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateProfileMainController', AffiliateProfileMainController);

  AffiliateProfileMainController.$inject = ['AffiliateProfileSettingsApi', 'outputErrors', '_', 'tabsApi', 'toastsApi'];

  function AffiliateProfileMainController(AffiliateProfileSettingsApi, outputErrors, _, tabsApi, toastsApi) {
    var vm = this;

    vm.translate_key = 'AffiliateProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {birthday: null};
    vm.tabs = tabsApi.getTabsByName('affiliate_profile');

    vm.getData = function(fields) {
      return _.pick(vm.user, fields);
    };

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.updateMain = function() {
      var data = vm.getData([
        'name',
        'surname',
        'username',
        'skype',
        'telegram',
        'birthday',
        'phone_number',
        'site_url',
        'about_affiliate',
        'agree_receive_emails'
      ]);

      return AffiliateProfileSettingsApi.update_settings(data).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('main', vm.updateMain);

    AffiliateProfileSettingsApi.get_attributes().then(
      function(response) {
        vm.user = response.data.affiliate_attributes;

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateProfileTwoFactorAuthController', AffiliateProfileTwoFactorAuthController);

  AffiliateProfileTwoFactorAuthController.$inject = [
    'AffiliateProfileSettingsApi',
    'outputErrors',
    'tabsApi',
    'toastsApi',
    '$window',
    'mfaSettings',
    'AuthApi'
  ];

  function AffiliateProfileTwoFactorAuthController(
    AffiliateProfileSettingsApi,
    outputErrors,
    tabsApi,
    toastsApi,
    $window,
    mfaSettings,
    AuthApi
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('affiliate_profile');

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.confirmMfaCode = function() {
      return AffiliateProfileSettingsApi.confirmMfaCode(vm.user.mfaCode).then(
        function() {
          // MFA 전역 상태 업데이트
          mfaSettings.setEnabled(true);

          // MFA 적용 완료 후 로그아웃하여 재로그인 유도
          // 백엔드 세션을 종료하고 로그인 페이지로 리디렉션
          AuthApi.signOut().then(
            function(res) {
              AuthApi.csrfTokenUpdate(res);
              AuthApi.redirectToLogin();
            },
            function() {
              // 로그아웃 실패해도 프론트엔드에서 로그인 페이지로 이동
              AuthApi.redirectToLogin();
            }
          );
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError();
        }
      );
    };

    vm.enableTwoFactorAuth = function() {
      return AffiliateProfileSettingsApi.enableTwoFactorAuth(vm.user.current_password).then(
        function(response) {
          var data = response.data;

          vm.user.showSecretKey = true;
          vm.user.secretValue = data.google_secret_value;
          vm.user.qrUri = data.google_qr_uri;
          vm.user.mfaCode = '';
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError();
        }
      );
    };

    vm.resetTwoFactorAuth = function() {
      return AffiliateProfileSettingsApi.resetTwoFactorAuth(vm.user.mfaCode).then(
        function() {
          // MFA 전역 상태 업데이트
          mfaSettings.setEnabled(false);

          // MFA 비활성화 완료 후 로그아웃하여 재로그인 유도
          // 백엔드 세션을 종료하고 로그인 페이지로 리디렉션
          AuthApi.signOut().then(
            function(res) {
              AuthApi.csrfTokenUpdate(res);
              AuthApi.redirectToLogin();
            },
            function() {
              // 로그아웃 실패해도 프론트엔드에서 로그인 페이지로 이동
              AuthApi.redirectToLogin();
            }
          );
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError();
        }
      );
    };

    /* eslint-disable no-alert */
    vm.saveTwoFactorAuth = function() {
      if (vm.user.mfa_enabled) {
        return confirm('Are you sure?') && vm.resetTwoFactorAuth();
      } else {
        if (vm.user.showSecretKey) {
          return confirm('Are you sure?') && vm.confirmMfaCode();
        } else {
          return vm.enableTwoFactorAuth();
        }
      }
    };
    /* eslint-enable no-alert */

    vm.tabs.setTabSubmitFunction('two_factor_authentication', vm.saveTwoFactorAuth);

    AffiliateProfileSettingsApi.get_attributes().then(
      function(response) {
        vm.user = response.data.affiliate_attributes;

        vm.user.current_password = '';

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateProfilePasswordController', AffiliateProfilePasswordController);

  AffiliateProfilePasswordController.$inject = [
    'AffiliateProfileSettingsApi',
    'outputErrors',
    '_',
    'tabsApi',
    'toastsApi',
    'AuthApi'
  ];

  function AffiliateProfilePasswordController(
    AffiliateProfileSettingsApi,
    outputErrors,
    _,
    tabsApi,
    toastsApi,
    AuthApi
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('affiliate_profile');

    vm.getData = function(fields) {
      return _.pick(vm.user, fields);
    };

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.updatePassword = function() {
      var data = vm.getData(['password', 'password_confirmation', 'current_password']);

      return AffiliateProfileSettingsApi.update_password(data).then(
        function() {
          // 패스워드 변경 완료 후 로그아웃하여 재로그인 유도
          // 백엔드 세션을 종료하고 로그인 페이지로 리디렉션
          AuthApi.signOut().then(
            function(res) {
              AuthApi.csrfTokenUpdate(res);
              AuthApi.redirectToLogin();
            },
            function() {
              // 로그아웃 실패해도 프론트엔드에서 로그인 페이지로 이동
              AuthApi.redirectToLogin();
            }
          );
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('password', vm.updatePassword);

    AffiliateProfileSettingsApi.get_attributes().then(
      function(response) {
        vm.user = response.data.affiliate_attributes;

        vm.user.password = '';
        vm.user.password_confirmation = '';
        vm.user.current_password = '';

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateProfilePaymentSystemsController', AffiliateProfilePaymentSystemsController);

  AffiliateProfilePaymentSystemsController.$inject = [
    'AffiliateProfileSettingsApi',
    'outputErrors',
    '_',
    'tabsApi',
    'permissionsManager',
    '$q',
    'BalanceService',
    'toastsApi'
  ];

  function AffiliateProfilePaymentSystemsController(
    AffiliateProfileSettingsApi,
    outputErrors,
    _,
    tabsApi,
    permissionsManager,
    $q,
    BalanceService,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.tabs = tabsApi.getTabsByName('affiliate_profile');
    vm.countriesList = [];
    vm.submitPermission = permissionsManager.checkPermission('api2.affiliate.paymentsystemscontroller.update');
    vm.paymentDetailsName = 'affiliatePaymentDetails';

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.handleErrors = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }

      vm.errors.inputErrors(errors);
    };

    vm.updatePaymentSystemsBase = function() {
      vm.paymentDetailsForm.$setSubmitted();

      if (vm.paymentDetailsForm.$invalid) {
        return $q.reject();
      }

      return AffiliateProfileSettingsApi.savePaymentDetails(BalanceService.getPaymentData(vm.currentSystem)).then(
        function() {
          toastsApi.toastSuccess();
          return $q.when();
        },
        function(response) {
          vm.handleErrors(response.data && response.data.errors);
          return $q.reject();
        }
      );
    };

    vm.updatePaymentSystems = BalanceService.decorateSaveMethod(vm.paymentDetailsName, vm.updatePaymentSystemsBase);

    if (vm.submitPermission) {
      vm.tabs.setTabSubmitFunction('payment_systems', vm.updatePaymentSystems);
    }

    AffiliateProfileSettingsApi.getPaymentMethods().then(
      function(response) {
        vm.paymentSystems = response.data.payment_systems;
      },
      function() {
        toastsApi.toastError();
      }
    );

    AffiliateProfileSettingsApi.getCountries().then(
      function(response) {
        vm.countriesList = response.data.countries;
      },
      function() {
        toastsApi.toastError();
      }
    );

    AffiliateProfileSettingsApi.get_attributes().then(
      function(response) {
        vm.user = response.data.affiliate_attributes;

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateProfileEmailController', AffiliateProfileEmailController);

  AffiliateProfileEmailController.$inject = [
    '$rootScope',
    'AffiliateProfileSettingsApi',
    'outputErrors',
    '_',
    'tabsApi',
    'toastsApi'
  ];

  function AffiliateProfileEmailController(
    $rootScope,
    AffiliateProfileSettingsApi,
    outputErrors,
    _,
    tabsApi,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('affiliate_profile');

    vm.getData = function(fields) {
      return _.pick(vm.user, fields);
    };

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.updateEmail = function() {
      var data = vm.getData(['email', 'current_password']);

      return AffiliateProfileSettingsApi.update_email(data).then(
        function() {
          vm.confirmEmailTabControl(false);
          $rootScope.$broadcast('$changeTab', {name: 'confirmation_email'});
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('email', vm.updateEmail);

    AffiliateProfileSettingsApi.get_attributes().then(
      function(response) {
        vm.user = response.data.affiliate_attributes;

        vm.user.current_password = '';

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateProfileConfirmationEmailController', AffiliateProfileConfirmationEmailController);

  AffiliateProfileConfirmationEmailController.$inject = [
    '$rootScope',
    '$stateParams',
    'AffiliateProfileSettingsApi',
    'outputErrors',
    'tabsApi',
    'toastsApi',
    'User'
  ];

  function AffiliateProfileConfirmationEmailController(
    $rootScope,
    $stateParams,
    AffiliateProfileSettingsApi,
    outputErrors,
    tabsApi,
    toastsApi,
    User
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('affiliate_profile');
    vm.token = $stateParams.token;

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.confirmEmail = function() {
      return AffiliateProfileSettingsApi.confirmation_email(vm.token).then(
        function() {
          User.updateUserProperty('email', vm.user.unconfirmed_email);
          $rootScope.$broadcast('$changeTab', {name: 'email'});
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('confirmation_email', vm.confirmEmail);

    AffiliateProfileSettingsApi.get_attributes().then(
      function(response) {
        vm.user = response.data.affiliate_attributes;

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('HistoryChangesFeesController', HistoryChangesFeesController);

  HistoryChangesFeesController.$inject = [
    '$state',
    '$stateParams',
    'AdminSettingsFeesApi',
    'SettingsFeesHistoryChangesApi',
    '_',
    'outputErrors',
    'moment',
    'toastsApi'
  ];

  function HistoryChangesFeesController(
    $state,
    $stateParams,
    AdminSettingsFeesApi,
    SettingsFeesHistoryChangesApi,
    _,
    outputErrors,
    moment,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.errors = outputErrors.createNew();
    vm.history_item = {};
    vm.startDate = null;
    vm.columns = [];

    SettingsFeesHistoryChangesApi.getItem($stateParams.id, $stateParams.merchantId).then(
      function(response) {
        var data = response.data.admin_fee;

        vm.history_item.feeColumn = data.count_from;
        vm.history_item.date = data.date;
        vm.history_item.limit = data.percent;
      },
      function() {
        toastsApi.toastError();
      }
    );

    AdminSettingsFeesApi.getOptions($stateParams.merchantId).then(
      function(response) {
        var data = response.data;

        if (data.date) {
          vm.startDate = moment(data.date, 'YYYY-MM-DD')
            .add(1, 'month')
            .toDate();
        }
        vm.columns = data.count_from;
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.saveHistory = function() {
      return SettingsFeesHistoryChangesApi.saveItem($stateParams.id, $stateParams.merchantId, vm.history_item).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.back = function() {
      $state.go('settings.admin_fees');
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsFeesController', SettingsFeesController);

  SettingsFeesController.$inject = [
    '$scope',
    '$state',
    'AdminSettingsFeesApi',
    '_',
    'outputErrors',
    'toastsApi',
    'tabsApi',
    'merchantStore',
    'moment'
  ];

  function SettingsFeesController(
    $scope,
    $state,
    AdminSettingsFeesApi,
    _,
    outputErrors,
    toastsApi,
    tabsApi,
    merchantStore,
    moment
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;
    vm.params = {limit: null, date: null, feeColumn: ''};
    vm.errors = outputErrors.createNew();
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.startDate = null;
    vm.columns = [];

    vm.optionsChange = {
      typeChanges: 'admin_fees',
      edit_state: 'settings.history_changes_fees',
      params: {},
      permissions: {
        change: 'api2.admin.adminfeescontroller.edit',
        remove: 'api2.admin.adminfeescontroller.delete'
      }
    };

    vm.updateMerchantId = function() {
      vm.optionsChange.params.merchantId = merchantStore.getCurrentMerchantId();
    };

    vm.clearForm = function() {
      vm.params.feeColumn = '';
      vm.params.limit = null;
      vm.params.date = null;
    };

    vm.getFeesParams = function() {
      AdminSettingsFeesApi.getFeesParams().then(
        function(response) {
          vm.tabs.setTabAdditionalData('admin_fees', {historyList: response.data.list});
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getOptions = function() {
      AdminSettingsFeesApi.getOptions().then(
        function(response) {
          var data = response.data;

          if (data.date) {
            vm.startDate = moment(data.date, 'YYYY-MM-DD')
              .add(1, 'month')
              .toDate();
          }
          vm.columns = data.count_from;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.saveParams = function() {
      return AdminSettingsFeesApi.createFeesParams(vm.params).then(
        function() {
          vm.getFeesParams();
          vm.clearForm();
          toastsApi.toastCreateSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.getFeesParams();
    vm.getOptions();
    vm.updateMerchantId();

    vm.tabs.setTabSubmitFunction('admin_fees', vm.saveParams);
    vm.tabs.setTabAdditionalData('admin_fees', {optionsChange: vm.optionsChange});

    $scope.$on('$changeMerchantSuccess', function() {
      vm.getFeesParams();
      vm.getOptions();
      vm.clearForm();
      vm.updateMerchantId();
      vm.tabs.setTabAdditionalData('admin_fees', {historyList: null, optionsChange: vm.optionsChange});
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('SettingsViewStatisticsController', SettingsViewStatisticsController);

  SettingsViewStatisticsController.$inject = ['$state', 'AdminSettingsViewStatsApi', '_', '$q', 'toastsApi'];

  function SettingsViewStatisticsController($state, AdminSettingsViewStatsApi, _, $q, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;

    vm.save_fields = function(fieldName, tabId, direction, searchTerm) {
      var deferred = $q.defer(),
        params = {};

      if (searchTerm && fieldName === 'all') {
        params.search = searchTerm;
        params.value = fieldName;
      } else {
        params.value = fieldName;
      }

      AdminSettingsViewStatsApi.saveAdmins(params, direction).then(
        function() {
          deferred.resolve();
        },
        function() {
          deferred.reject();
          toastsApi.toastError();
        }
      );

      return deferred.promise;
    };

    AdminSettingsViewStatsApi.getAdmins().then(function(response) {
      vm.adminsList = response.data;
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsUploadLogoController', SettingsUploadLogoController);

  SettingsUploadLogoController.$inject = [
    '$scope',
    '$state',
    'AdminSettingsApi',
    '_',
    'outputErrors',
    'logoUrls',
    'tabsApi',
    '$cookies',
    'toastsApi'
  ];

  function SettingsUploadLogoController(
    $scope,
    $state,
    AdminSettingsApi,
    _,
    outputErrors,
    logoUrls,
    tabsApi,
    $cookies,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;
    vm.errors = outputErrors.createNew();
    vm.default_logo_mini = logoUrls.getLogoMini();
    vm.default_favicon = logoUrls.getFavicon();
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.logos = {
      logo_mini: '',
      logo: '',
      favicon: ''
    };

    vm.get_form_data = function(data) {
      var fd = new FormData();

      _.each(data, function(v, k) {
        fd.append(k, v);
      });

      return fd;
    };

    vm.save_logo = function() {
      AdminSettingsApi.save(vm.get_form_data(vm.logos), {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined,
          'x-xsrf-token': $cookies.get('XSRF-TOKEN-X')
        }
      }).then(
        function(response) {
          var data = response.data;

          vm.default_logo_mini = data.logo_mini;
          vm.default_favicon = data.favicon;

          logoUrls.setLogoMain(data.logo);
          logoUrls.setLogoMini(data.logo_mini);
          logoUrls.setFavicon(data.favicon);

          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.update_logo = function(data) {
      logoUrls.setLogoMini(data.logo_mini || vm.default_logo_mini);
    };

    vm.update_favicon = function(data) {
      logoUrls.setFavicon(data.favicon || vm.default_favicon);
    };

    vm.tabs.setTabSubmitFunction('upload_logo', vm.save_logo);

    vm.logo_mini_options = {
      translate_key: vm.translate_key,
      input_name: 'logo_mini',
      accept: 'image/*',
      shortcodes: {
        label: 'upload_logo.choose_logo_mini',
        drop_file_here: 'upload_logo.drop_logo_mini_here',
        resolution_file: 'upload_logo.resolution_logo_mini'
      }
    };

    vm.logo_main_options = {
      translate_key: vm.translate_key,
      input_name: 'logo',
      accept: 'image/*',
      shortcodes: {
        label: 'upload_logo.choose_logo_main',
        drop_file_here: 'upload_logo.drop_logo_main_here',
        resolution_file: 'upload_logo.resolution_logo_main'
      }
    };

    vm.favicon_options = {
      translate_key: vm.translate_key,
      input_name: 'favicon',
      accept: 'image/*',
      shortcodes: {
        label: 'upload_logo.choose_favicon',
        drop_file_here: 'upload_logo.drop_favicon_here',
        resolution_file: 'upload_logo.resolution_favicon'
      }
    };

    $scope.$on('$destroy', function() {
      logoUrls.setLogoMini(vm.default_logo_mini);
      logoUrls.setFavicon(vm.default_favicon);
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('SettingsRegistrationFieldsController', SettingsRegistrationFieldsController);

  SettingsRegistrationFieldsController.$inject = [
    '$scope',
    '$state',
    'AdminSettingsRegistrationFieldsApi',
    '_',
    '$q',
    'outputErrors',
    'registrationFields',
    'toastsApi'
  ];

  function SettingsRegistrationFieldsController(
    $scope,
    $state,
    AdminSettingsRegistrationFieldsApi,
    _,
    $q,
    outputErrors,
    registrationFields,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;
    vm.errors = outputErrors.createNew();
    vm.namespaceField = 'auth.registration.form.';

    vm.save_fields = function(fieldName, tabId, direction, searchTerm) {
      var deferred = $q.defer(),
        params = {};

      if (searchTerm && fieldName === 'all') {
        params.search = searchTerm;
        params.value = fieldName;
      } else {
        params.value = fieldName;
      }

      AdminSettingsRegistrationFieldsApi.save_fields(params, direction).then(
        function() {
          deferred.resolve();
        },
        function() {
          deferred.reject();
          toastsApi.toastError();
        }
      );

      return deferred.promise;
    };

    AdminSettingsRegistrationFieldsApi.get_fields().then(function(response) {
      var data = response.data;

      registrationFields.setFields(data.affiliate_checked);
      vm.registration_fields = registrationFields.getFields();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('SettingsPaymentSystemsController', SettingsPaymentSystemsController);

  SettingsPaymentSystemsController.$inject = [
    '$state',
    'AdminSettingsPaymentSystemsApi',
    '_',
    '$q',
    'toastsApi',
    'permissionsManager'
  ];

  function SettingsPaymentSystemsController(
    $state,
    AdminSettingsPaymentSystemsApi,
    _,
    $q,
    toastsApi,
    permissionsManager
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;
    vm.editPermission = permissionsManager.checkPermission('api2.admin.paymentsystemlistscontroller.update');

    vm.savePaymentSystems = function(fieldName, tabId, direction, searchTerm) {
      if (!vm.editPermission) {
        return $q.reject();
      }

      var deferred = $q.defer(),
        params = {};

      if (searchTerm && fieldName === 'all') {
        params.search = searchTerm;
        params.value = fieldName;
      } else {
        params.value = fieldName;
      }

      AdminSettingsPaymentSystemsApi.savePaymentSystems(params, direction).then(
        function() {
          deferred.resolve();
        },
        function() {
          deferred.reject();
          toastsApi.toastError();
        }
      );

      return deferred.promise;
    };

    AdminSettingsPaymentSystemsApi.getPaymentSystems().then(
      function(response) {
        vm.paymentSystems = response.data.payment_systems;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('SettingsCountryGroupSettingsController', SettingsCountryGroupSettingsController);

  SettingsCountryGroupSettingsController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$mdDialog',
    '$mdMedia',
    'AdminSettingsPaymentSystemsApi',
    '_',
    '$q',
    'outputErrors',
    'toastsApi'
  ];

  function SettingsCountryGroupSettingsController(
    $scope,
    $state,
    $stateParams,
    $mdDialog,
    $mdMedia,
    AdminSettingsPaymentSystemsApi,
    _,
    $q,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.errors = outputErrors.createNew();
    vm.currentField = '';
    vm.group = {
      name: '',
      countries: [],
      bank_transfer_validation: {
        id: null,
        validation_data: {}
      }
    };
    vm.countriesErrors = [
      'customizable_validation_countries.name',
      'customizable_validation_countries.country_code',
      'customizable_validation_countries.country_group_id'
    ];

    vm.back = function() {
      $state.go('settings.payment_systems');
    };

    vm.updateGroup = function(data) {
      angular.extend(vm.group, data);
    };

    vm.changeCountriesCallback = function() {
      _.each(vm.countriesErrors, function(name) {
        vm.errors.clearError(name);
      });
      return $q.when();
    };

    vm.handleError = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }
      vm.errors.inputErrors(errors);
      toastsApi.toastError({locale: _.first(_.flatten(_.values(errors)))});
    };

    vm.handleSuccess = function(data) {
      if (vm.group.id) {
        toastsApi.toastEditSuccess();
      } else {
        toastsApi.toastCreateSuccess();
      }
      vm.updateGroup(data);
      $state.go('.', {groupId: data.id}, {notify: false});
    };

    vm.saveGroup = function() {
      return AdminSettingsPaymentSystemsApi.saveGroup(vm.group.id || $stateParams.groupId, vm.group).then(
        function(response) {
          vm.handleSuccess(response.data);
        },
        function(response) {
          vm.handleError(response.data && response.data.errors);
        }
      );
    };

    vm.selectField = function(fieldName, ev) {
      vm.currentField = fieldName;

      if ($mdMedia('xs')) {
        vm.openModal(ev);
      }
    };

    vm.isEmptyField = function(fieldData) {
      return !fieldData.presence && _.isEqual(fieldData.range, {min: null, max: null});
    };

    vm.clearField = function(fieldName, ev) {
      ev.stopPropagation();
      vm.group.bank_transfer_validation.validation_data[fieldName].presence = false;
      vm.group.bank_transfer_validation.validation_data[fieldName].range = {min: null, max: null};
    };

    vm.openModal = function(ev) {
      return $mdDialog.show({
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        templateUrl: 'app/admin/settings/payment_systems/partials/modal.html',
        parent: angular.element(document.body),
        targetEvent: ev
      });
    };

    vm.closeMobilePopup = function() {
      $mdDialog.hide();
    };

    $scope.$watch(
      function() {
        return $mdMedia('gt-xs');
      },
      function(value) {
        vm.isGtXs = value;
      }
    );

    AdminSettingsPaymentSystemsApi.getDateForCountryGroup($stateParams.groupId).then(
      function(response) {
        vm.updateGroup(response.data);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsCountryGroupsController', SettingsCountryGroupsController);

  SettingsCountryGroupsController.$inject = [
    '$scope',
    '$state',
    'AdminSettingsPaymentSystemsApi',
    '_',
    'defaultDateFormat',
    '$mdTranslate',
    '$mdDialog',
    'toastsApi',
    'tableEngine'
  ];

  function SettingsCountryGroupsController(
    $scope,
    $state,
    AdminSettingsPaymentSystemsApi,
    _,
    defaultDateFormat,
    $mdTranslate,
    $mdDialog,
    toastsApi,
    tableEngine
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;

    vm.editCountryGroup = function(group) {
      $state.go('settings.country_group_settings', {groupId: group.id});
    };

    vm.addNewGroup = function() {
      $state.go('settings.country_group_settings');
    };

    vm.handleErrors = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }
      return toastsApi.toastError({locale: _.first(_.flatten(_.values(errors)))});
    };

    vm.getRemoveTranslate = function(groupName) {
      return {
        title: $mdTranslate.instant(vm.translate_key, 'remove_modal.title'),
        question: $mdTranslate.instant(vm.translate_key, 'remove_modal.delete_question', {name: groupName}),
        ok: $mdTranslate.instant(vm.translate_key, 'remove_modal.answer_yes'),
        cancel: $mdTranslate.instant(vm.translate_key, 'remove_modal.answer_no')
      };
    };

    vm.openRemoveModal = function(data, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(data.title)
        .textContent(data.question)
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok(data.ok)
        .cancel(data.cancel);

      return $mdDialog.show(confirm);
    };

    vm.applyRemoveGroup = function(groupId) {
      AdminSettingsPaymentSystemsApi.deleteCountryGroup(groupId).then(
        function() {
          vm.table.removeListItem();
          toastsApi.toastRemoveSuccess();
        },
        function(response) {
          vm.handleErrors(response.data && response.data.errors);
        }
      );
    };

    vm.removeCountryGroup = function(group, ev) {
      var locales = vm.getRemoveTranslate(group.name);

      vm.openRemoveModal(locales, ev).then(function() {
        vm.applyRemoveGroup(group.id);
      });
    };

    vm.table = tableEngine.init({
      api: AdminSettingsPaymentSystemsApi,
      api_method: 'listCountryGroups',
      name: 'countryGroups',
      mobile: {
        defaultColumns: ['name']
      },
      buttons: {
        url: 'app/admin/settings/payment_systems/partials/table.html',
        methods: {
          edit: vm.editCountryGroup,
          remove: vm.removeCountryGroup
        }
      }
    });

    AdminSettingsPaymentSystemsApi.listCountryGroups().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('created_at', {format: defaultDateFormat + ' HH:mm:ss'});
        vm.table.addOptionsToColumn('updated_at', {format: defaultDateFormat + ' HH:mm:ss'});
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('SettingsNotificationHeaderController', SettingsNotificationHeaderController);

  SettingsNotificationHeaderController.$inject = [
    'tabsApi',
    'NotificationHeaderApi',
    'notificationHeader',
    'localesStorage',
    'outputErrors',
    'toastsApi',
    '_'
  ];

  function SettingsNotificationHeaderController(
    tabsApi,
    NotificationHeaderApi,
    notificationHeader,
    localesStorage,
    outputErrors,
    toastsApi,
    _
  ) {
    var vm = this,
      notifyData = notificationHeader.getNotifyData();

    vm.translate_key = 'AdminSettings';
    vm.languages = localesStorage.getLanguages();
    vm.currentLanguage = localesStorage.getCurrentLocale();
    vm.errors = outputErrors.createNew();
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.namespaceList = ['anonym', 'affiliate'];
    vm.userNamespace = 'anonym';
    vm.notifyContent = {};
    vm.notification = {};
    vm.selectLanguagesOptions = {
      find_in_key: true,
      search_in_translate: true,
      key_as_shortcode_part: true,
      translate_key: 'Languages',
      shortcode: 'language.{{part}}'
    };

    vm.getDefaultTextColor = function() {
      return vm.userNamespace === 'anonym' ? notifyData.textColor : '#000';
    };

    vm.getDefaultHeaderColor = function() {
      return vm.userNamespace === 'anonym' ? notifyData.headerColor : '#fff';
    };

    vm.updateNotification = function(notify) {
      if (!notify) {
        return;
      }

      vm.notification.attributes = notify.text_for_notifications_attributes || [];
      vm.notification.headerColor = notify.header_color || vm.getDefaultHeaderColor();
      vm.notification.textColor = notify.text_color || vm.getDefaultTextColor();
      vm.notification.visible = notify.visible;
      vm.notification.id = notify.id || vm.notification.id || null;
    };

    vm.getNotifyByLocale = function(locale) {
      return _.findWhere(vm.notification.attributes, {locale: locale});
    };

    vm.setNotifyAnonymDataToConstant = function(notification, notifyContent) {
      if (vm.userNamespace !== 'anonym') {
        return;
      }

      notificationHeader.setNotifyData(notification);
      notificationHeader.setTextContent(notifyContent);
    };

    vm.setNotifyContent = function() {
      _.each(vm.languages, function(v, k) {
        vm.notifyContent[k] = _.propertyOf(vm.getNotifyByLocale(k))('body') || '';
      });
    };

    vm.getUpdatedNotifyAttributes = function() {
      var attrs = [];

      _.each(vm.notifyContent, function(value, key) {
        var item = vm.getNotifyByLocale(key),
          result = item ? _.pick(item, 'id', 'body', 'locale') : {};

        result.body = value;
        result.locale = key;

        if (result.id || result.body) {
          attrs.push(result);
        }
      });

      return attrs;
    };

    vm.getDataForSaveNotify = function() {
      return {
        notification: _.pick(vm.notification, 'id', 'headerColor', 'textColor', 'visible'),
        notifyContent: _.pick(vm.notifyContent, _.keys(vm.languages)),
        notifyAttributes: vm.getUpdatedNotifyAttributes()
      };
    };

    vm.applySaveNotify = function(notification, notifyAttributes, userNamespace) {
      return NotificationHeaderApi.saveNotify(notification, notifyAttributes, userNamespace);
    };

    vm.saveNotifySuccess = function(notification, notifyContent) {
      vm.updateNotification(notification);
      vm.setNotifyAnonymDataToConstant(notification, notifyContent);
      toastsApi.toastEditSuccess();
    };

    vm.saveNotifyError = function(errors) {
      var textError = errors['text_for_notifications.body'] || errors['base'];

      if (textError) {
        vm.errors.inputErrors({body: textError});
      } else {
        toastsApi.toastError();
      }
    };

    vm.saveNotify = function() {
      var data = vm.getDataForSaveNotify();

      vm.applySaveNotify(data.notification, data.notifyAttributes, vm.userNamespace).then(
        function(response) {
          vm.saveNotifySuccess(response.data.notification, data.notifyContent);
        },
        function(response) {
          vm.saveNotifyError(response.data.errors || {});
        }
      );
    };

    vm.changeNamespace = function() {
      vm.getNotifyContent();
    };

    vm.getNotifyContent = function() {
      NotificationHeaderApi.getAdminNotifyContent(vm.userNamespace).then(
        function(response) {
          vm.updateNotification(response.data.notification);
          vm.setNotifyContent();
          vm.setNotifyAnonymDataToConstant(vm.notification, vm.notifyContent);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getNotifyContent();

    vm.tabs.setTabSubmitFunction('notification_header', vm.saveNotify);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminSettingsController', AdminSettingsController);

  AdminSettingsController.$inject = ['$scope', 'permissionsManager', 'tabsApi', '_'];

  function AdminSettingsController($scope, permissionsManager, tabsApi, _) {
    var vm = this;

    vm.translate_key = 'AdminSettings';

    vm.staticPagesPermissions = [
      'api2.admin.staticpagescontroller.faq',
      'api2.admin.staticpagescontroller.terms',
      'api2.admin.staticpagescontroller.privacy',
      'api2.admin.staticpagescontroller.commission',
      'api2.admin.staticpagescontroller.help',
      'api2.admin.staticpagescontroller.static_page_1',
      'api2.admin.staticpagescontroller.static_page_2',
      'api2.admin.staticpagescontroller.static_page_3',
      'api2.admin.staticpagescontroller.static_page_4',
      'api2.admin.staticpagescontroller.static_page_5'
    ];

    vm.getStaticPagesAccess = function() {
      return _.some(
        _.map(vm.staticPagesPermissions, function(val) {
          return permissionsManager.checkPermission(val);
        })
      );
    };

    vm.tabs = tabsApi.init({
      name: 'project_settings',
      translateKey: vm.translate_key,
      list: [
        {
          name: 'company',
          shortcode: 'company.tab_name',
          state: 'settings.company'
        },
        {
          name: 'affiliate_auto_approve',
          shortcode: 'affiliate_auto_approve.tab_name',
          state: 'settings.affiliate_auto_approve',
          hide: !permissionsManager.checkPermission('api2.admin.autoapprovelocalescontroller.show')
        },
        {
          name: 'information',
          shortcode: 'information.tab_name',
          state: 'settings.information',
          hide: !vm.getStaticPagesAccess()
        },
        {
          name: 'emails',
          shortcode: 'emails.tab_name',
          state: 'settings.emails',
          hide: !permissionsManager.checkPermission('api2.admin.mailersmanagercontroller.edit')
        },
        {
          name: 'bookkeeping',
          shortcode: 'bookkeeping.tab_name',
          state: 'settings.bookkeeping',
          hide: !permissionsManager.checkPermission('api2.admin.historyoflimitchangescontroller.create')
        },
        {
          name: 'admin_fees',
          shortcode: 'admin_fees.tab_name',
          state: 'settings.admin_fees',
          hide: !permissionsManager.checkPermission('api2.admin.adminfeescontroller.edit')
        },
        // {
        //   name: 'columns',
        //   shortcode: 'columns.tab_name',
        //   state: 'settings.columns',
        //   hide: !permissionsManager.checkPermission('api2.admin.projectsettingscontroller.default_order_columns')
        // },
        {
          name: 'columns_for_tables',
          shortcode: 'columns_for_tables.tab_name',
          state: 'settings.columns_for_tables',
          hide: !permissionsManager.checkPermission('api2.admin.tablefordisplayscontroller.show')
        },
        {
          name: 'view_all_statistics',
          shortcode: 'view_all_statistics.tab_name',
          state: 'settings.view_all_statistics',
          hide: !permissionsManager.checkPermission(
            'api2.admin.projectsettingscontroller.admins_with_full_stats_access'
          )
        },
        {
          name: 'registration_fields',
          shortcode: 'registration_fields.tab_name',
          state: 'settings.registration_fields',
          hide: !permissionsManager.checkPermission(
            'api2.admin.projectsettingscontroller.required_fields_in_profile_update'
          )
        },
        {
          name: 'payment_systems',
          shortcode: 'payment_systems.tab_name',
          state: 'settings.payment_systems',
          hide: !permissionsManager.checkPermission('api2.admin.paymentsystemlistscontroller.show')
        },
        {
          name: 'upload_logo',
          shortcode: 'upload_logo.tab_name',
          state: 'settings.upload_logo'
        },
        {
          name: 'notification_header',
          shortcode: 'notification_header.tab_name',
          state: 'settings.notification_header',
          hide: !permissionsManager.checkPermission('api2.admin.notificationscontroller.show')
        },
        {
          name: 'affiliate_banner',
          shortcode: 'affiliate_banner.tab_name',
          state: 'settings.affiliate_banner',
          hide: !permissionsManager.checkPermission('api2.admin.bannersettingscontroller.show')
        },
        {
          name: 'click_domains',
          shortcode: 'click_domains.tab_name',
          state: 'settings.click_domains',
          hide: !permissionsManager.checkPermission('api2.admin.clickdomainscontroller.show')
        }
      ]
    });

    $scope.$on('$destroy', function() {
      vm.tabs.destroy();
      _.invoke(document.querySelectorAll('.color-picker'), 'remove');
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('textAngularEvent', textAngularEvent);

  textAngularEvent.$inject = ['$timeout'];

  function textAngularEvent($timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var Errors = scope[attr.vm].errors;

        $timeout(function() {
          var container = element[0].querySelector('[contenteditable="true"]');

          container.addEventListener('input', function() {
            Errors.clearError(attr.name);
          });
        }, 0);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsEmailsController', SettingsEmailsController);

  SettingsEmailsController.$inject = [
    '$state',
    'AdminSettingsEmailsApi',
    '_',
    'tabsApi',
    'outputErrors',
    'textAngularManager',
    'localesStorage',
    'toastsApi'
  ];

  function SettingsEmailsController(
    $state,
    AdminSettingsEmailsApi,
    _,
    tabsApi,
    outputErrors,
    textAngularManager,
    localesStorage,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;
    vm.errors = outputErrors.createNew();
    vm.current_mailer = null;
    vm.choosed_email_name = '';
    vm.translate_namespace = '';
    vm.languages = localesStorage.getLanguages();
    vm.current_language = localesStorage.getCurrentLocale();
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.variables_for_error = [];
    vm.canBeDisabledList = [];
    vm.selectLanguagesOptions = {
      find_in_key: true,
      search_in_translate: true,
      key_as_shortcode_part: true,
      translate_key: 'Languages',
      shortcode: 'language.{{part}}'
    };

    vm.custom_toolbar = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
      ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
      ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
      ['html', 'insertLink', 'wordcount', 'charcount'],
      ['dropdown']
    ];

    vm.toolSetup = {
      display: [
        '<md-menu class="btn btn-default dropdown-btn" name="dropdown">',
        '<span class="text" ng-click="$mdMenu.open($event)">',
        '<md-translate key="\'AdminSettings\'", shortcode="\'emails.variables\'"></md-translate>',
        '</span>',
        '<md-menu-content width="4">',
        '<md-menu-item ng-repeat="item in variables">',
        '<md-button ng-click="action(item)">',
        '<span ng-bind="item"></span>',
        '</md-button>',
        '</md-menu-item>',
        '</md-menu>'
      ].join(''),
      variables: [],
      action: function(item) {
        this.$editor().displayElements.text.focus();
        this.$editor().wrapSelection('insertHTML', '{' + item + '}');
        vm.errors.clearError('body');
      }
    };

    vm.canBeDisabled = function() {
      return _.contains(vm.canBeDisabledList, vm.current_mailer && vm.current_mailer.id_mailer);
    };

    vm.save_current_email = function() {
      return AdminSettingsEmailsApi.save_email(vm.choosed_email_name, vm.current_mailer, vm.current_language).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.variables_for_error = response.data.variable || [];
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.update_dropdown = function(variables) {
      vm.toolSetup.variables = variables;

      textAngularManager.removeTool('dropdown');
      textAngularManager.addTool('dropdown', vm.toolSetup);
    };

    AdminSettingsEmailsApi.get_all_emails().then(
      function(response) {
        var data = response.data;

        vm.emails_list = data.list;
        vm.translate_namespace = data.translate_namespace;
        vm.canBeDisabledList = data.disableable_list;
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.choose_current_email = function() {
      if (!vm.choosed_email_name) {
        return;
      }

      AdminSettingsEmailsApi.get_email_params(vm.choosed_email_name, vm.current_language).then(
        function(response) {
          var data = response.data;

          vm.current_mailer = data.mailer;
          vm.current_mailer.enabled = _.isUndefined(vm.current_mailer.enabled) ? false : vm.current_mailer.enabled;
          vm.current_mailer_variables = vm.emails_list[vm.choosed_email_name];
          vm.update_dropdown(vm.current_mailer_variables);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.tabs.setTabSubmitFunction('emails', vm.save_current_email);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsInfoPagesController', SettingsInfoPagesController);

  SettingsInfoPagesController.$inject = [
    'AdminSettingsInfoPagesApi',
    '_',
    'outputErrors',
    'localesStorage',
    'permissionsManager',
    'tabsApi',
    'toastsApi'
  ];

  function SettingsInfoPagesController(
    AdminSettingsInfoPagesApi,
    _,
    outputErrors,
    localesStorage,
    permissionsManager,
    tabsApi,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.languages = localesStorage.getLanguages();
    vm.currentLanguage = localesStorage.getCurrentLocale();
    vm.errors = outputErrors.createNew();
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.editor_content = {};
    vm.settingsTypes = _.filter(
      [
        'faq',
        'terms',
        'privacy',
        'commission',
        'help',
        'static_page_1',
        'static_page_2',
        'static_page_3',
        'static_page_4',
        'static_page_5'
      ],
      function(page) {
        return permissionsManager.checkPermission('api2.admin.staticpagescontroller.' + page);
      }
    );
    vm.settingsType = _.first(vm.settingsTypes);
    vm.selectLanguagesOptions = {
      find_in_key: true,
      search_in_translate: true,
      key_as_shortcode_part: true,
      translate_key: 'Languages',
      shortcode: 'language.{{part}}'
    };
    vm.selectPagesOptions = {
      search_in_translate: true,
      translate_key: vm.translate_key,
      shortcode: 'information.settings_{{part}}'
    };

    vm.getPageInfo = function() {
      AdminSettingsInfoPagesApi['get_' + vm.settingsType](vm.currentLanguage).then(
        function(response) {
          vm.editor_content.content = response.data.content || '';
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.savePageInfo = function() {
      return AdminSettingsInfoPagesApi['save_' + vm.settingsType](vm.currentLanguage, vm.editor_content.content).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getPageInfo();

    vm.tabs.setTabSubmitFunction('information', vm.savePageInfo);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsCompanyController', SettingsCompanyController);

  SettingsCompanyController.$inject = [
    '$rootScope',
    '$scope',
    'AdminSettingsApi',
    '_',
    'outputErrors',
    'tabsApi',
    'projectCurrency',
    'themeColors',
    'pageTitle',
    'toastsApi',
    '$q',
    '$timeout',
    '$translate',
    'CreativeDomain',
    'localesStorage'
  ];

  function SettingsCompanyController(
    $rootScope,
    $scope,
    AdminSettingsApi,
    _,
    outputErrors,
    tabsApi,
    projectCurrency,
    themeColors,
    pageTitle,
    toastsApi,
    $q,
    $timeout,
    $translate,
    CreativeDomain,
    localesStorage
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.errors = outputErrors.createNew();
    vm.defaultLocale = localesStorage.getFallbackLocale();
    vm.company_fields = {};
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.countOfCreativeDomains = CreativeDomain.getCount();

    vm.company_fields.header_color = themeColors.getHeaderColor();
    vm.company_fields.buttons_color = themeColors.getButtonsColor();
    vm.company_fields.project_languages = {};

    vm.prepareBackendList = function(list, selected) {
      return _.map(list, function(item) {
        return {id: item, value: item, check: _.contains(selected, item)};
      });
    };

    vm.prepareSelectedList = function(list) {
      return _.pluck(
        _.filter(list, function(item) {
          return item.check;
        }),
        'id'
      );
    };

    vm.prepareDefaultLocales = function(selected) {
      return _.map(_.union([vm.defaultLocale], selected), function(val) {
        return {id: val, value: val, check: val === vm.company_fields.default_locale};
      });
    };

    vm.defaultLocaleValueControl = function(value, selected) {
      return _.contains(selected, value) ? value : vm.defaultLocale;
    };

    vm.getListWithoutDefaultLocale = function(list) {
      return _.without(list, vm.defaultLocale);
    };

    vm.getCreativeDomainName = function(index) {
      return CreativeDomain.buildDomainName(index);
    };

    vm.setCreativeDomains = function(count, data) {
      _.times(count, function(i) {
        var name = vm.getCreativeDomainName(i);
        vm.company_fields[name] = data[name] || null;
      });
    };

    vm.updateInterfaceLocales = function() {
      vm.company_fields.project_languages.interface_locales = _.union(
        [vm.defaultLocale],
        vm.prepareSelectedList(vm.allLocales)
      );

      vm.defaultLocalesList = vm.prepareDefaultLocales(vm.company_fields.project_languages.interface_locales);
      vm.company_fields.default_locale = vm.defaultLocaleValueControl(
        vm.company_fields.default_locale,
        vm.company_fields.project_languages.interface_locales
      );
    };

    vm.updateAllLocales = function(selectedLocales) {
      _.each(vm.allLocales, function(item) {
        item.check = _.contains(selectedLocales, item.id);
      });
    };

    vm.updateInterfaceLocalesSuccess = function(selectedLocales) {
      vm.updateAllLocales(selectedLocales);
      vm.updateInterfaceLocales();
      localesStorage.updateProjectLanguages(selectedLocales);
    };

    vm.updateInterfaceLocalesFail = function(data) {
      if (data && data.locales) {
        vm.updateInterfaceLocalesSuccess(data.locales);
      }

      if (data && data.errors) {
        vm.errors.inputErrors({interface_locales: _.values(data.errors)});
      } else {
        toastsApi.toastError();
      }
    };

    vm.updateAllCreativeLocales = function(selectedLocales) {
      vm.allCreativeLocales = _.map(vm.allCreativeLocales, function(item) {
        return {id: item.id, value: item.value, check: _.contains(selectedLocales, item.id)};
      });
    };

    vm.updateCreativeLocales = function() {
      vm.company_fields.project_languages.creative_locales = vm.prepareSelectedList(vm.allCreativeLocales);
    };

    vm.updateCreativeLocalesSuccess = function(selectedLocales) {
      vm.updateAllCreativeLocales(selectedLocales);
      vm.updateCreativeLocales();
      localesStorage.updateCreativeLanguages(selectedLocales);
    };

    vm.updateCreativeLocalesFail = function(data) {
      if (data && data.locales) {
        vm.updateCreativeLocalesSuccess(data.locales);
      }

      if (data && data.errors) {
        $timeout(function() {
          vm.errors.inputErrors({creative_locales: _.values(data.errors)});
        }, 0);
      } else {
        toastsApi.toastError();
      }
    };

    vm.saveProjectLanguages = function() {
      var deferred = $q.defer();

      deferred.resolve();

      $timeout(function() {
        vm.updateInterfaceLocales();
      });

      return deferred.promise;
    };

    vm.saveCreativeLanguages = function() {
      var deferred = $q.defer();

      deferred.resolve();

      $timeout(function() {
        vm.updateCreativeLocales();
      });

      return deferred.promise;
    };

    vm.prepareAllLocales = function(interfaceLocales, creativeLocales) {
      var all = _.keys(localesStorage.getAllLanguages());

      vm.allLocales = vm.prepareBackendList(vm.getListWithoutDefaultLocale(all), interfaceLocales);
      vm.allCreativeLocales = vm.prepareBackendList(all, creativeLocales);
      vm.defaultLocalesList = vm.prepareDefaultLocales(interfaceLocales);
    };

    vm.initLanguagesData = function(data) {
      var interfaceLocales = _.keys(localesStorage.getLanguages()),
        creativeLocales = localesStorage.getCreativeLocales();

      vm.company_fields.project_languages.creative_locales = creativeLocales;
      vm.company_fields.project_languages.interface_locales = interfaceLocales;
      vm.company_fields.default_locale = vm.defaultLocaleValueControl(data.default_locale, interfaceLocales);

      vm.prepareAllLocales(interfaceLocales, creativeLocales);
    };

    vm.updateDefaultLocaleSuccess = function() {
      vm.defaultLocale = vm.company_fields.default_locale;
      localesStorage.setFallbackLocale(vm.defaultLocale);

      vm.prepareAllLocales(
        vm.company_fields.project_languages.interface_locales,
        vm.company_fields.project_languages.creative_locales
      );

      $translate.fallbackLanguage(vm.defaultLocale);
    };

    vm.rememberDefaultSubaffiliateCondition = function() {
      vm.savedDefaultSubaffiliateConditionId = vm.company_fields.current_default_subaffiliate_condition_id;
      vm.hasSavedDefaultSubaffiliateCondition = true;
    };

    vm.restoreDefaultSubaffiliateCondition = function() {
      if (!vm.hasSavedDefaultSubaffiliateCondition) {
        return;
      }

      vm.company_fields.current_default_subaffiliate_condition_id = vm.savedDefaultSubaffiliateConditionId;
    };

    vm.save_company = function() {
      var data = _.omit(vm.company_fields, 'project_languages');

      return AdminSettingsApi.save(data).then(
        function() {
          vm.rememberDefaultSubaffiliateCondition();
          projectCurrency.setCurrency(vm.list_currency[vm.company_fields.currency]);
          pageTitle.setTitle(vm.company_fields.title);
          toastsApi.toastEditSuccess();

          vm.updateDefaultLocaleSuccess();
          $rootScope.$broadcast('changeLocalesList', {defaultLocale: vm.company_fields.default_locale});
        },
        function(response) {
          var subaffiliateDefaultChanged =
            vm.hasSavedDefaultSubaffiliateCondition &&
            vm.company_fields.current_default_subaffiliate_condition_id !==
              vm.savedDefaultSubaffiliateConditionId;

          vm.restoreDefaultSubaffiliateCondition();

          // Putting the select back re-runs its validator, which always passes and clears a
          // server error set in this same turn. Apply the error after that check.
          if (subaffiliateDefaultChanged) {
            $timeout(function() {
              vm.errors.inputErrors(response.data.errors);
            });
          } else {
            vm.errors.inputErrors(response.data.errors);
          }
        }
      );
    };

    vm.saveInterfaceLocales = function() {
      return AdminSettingsApi.saveInterfaceLocales(vm.company_fields.project_languages.interface_locales).then(
        function(response) {
          vm.updateInterfaceLocalesSuccess(response.data.locales);
          $rootScope.$broadcast('changeLocalesList', {defaultLocale: vm.company_fields.default_locale});
        },
        function(response) {
          vm.updateInterfaceLocalesFail(response.data);
        }
      );
    };

    vm.saveCreativeLocales = function() {
      return AdminSettingsApi.saveCreativeLocales(vm.company_fields.project_languages.creative_locales).then(
        function(response) {
          vm.updateCreativeLocalesSuccess(response.data.locales);
        },
        function(response) {
          vm.updateCreativeLocalesFail(response.data);
        }
      );
    };

    vm.saveLanguages = function() {
      return $q.all([vm.saveInterfaceLocales(), vm.saveCreativeLocales()]);
    };

    vm.saveAll = function() {
      var deferred = $q.defer();

      vm.save_company().finally(function() {
        vm.saveLanguages().finally(function() {
          deferred.resolve();
        });
      });

      return deferred.promise;
    };

    vm.getCompanyInfo = function() {
      AdminSettingsApi.get().then(
        function(response) {
          var data = response.data;

          vm.company_fields.max_trackers = data.max_trackers;
          // vm.company_fields.redirector_domain = data.redirector_domain;
          vm.company_fields.deafult_creative_id = data.deafult_creative_id;
          vm.company_fields.deafult_serial_id = data.deafult_serial_id;
          vm.company_fields.company_name = data.company_name;
          vm.company_fields.current_default_condition_id = data.current_default_condition_id;
          vm.company_fields.current_default_subaffiliate_condition_id = data.current_default_subaffiliate_condition_id;
          vm.rememberDefaultSubaffiliateCondition();
          vm.company_fields.title = data.title;
          vm.company_fields.currency = _.invert(data.list_currency)[projectCurrency.getCurrency()];

          vm.initLanguagesData(data);
          vm.setCreativeDomains(vm.countOfCreativeDomains, data);

          vm.conditions_list = data.all_condition;
          vm.admins_list = data.admins_list;
          vm.creatives_list = data.creatives_list;
          vm.serial_id_list = data.serials_list;
          vm.list_currency = data.list_currency;
          vm.subaffiliate_conditions_list = data.all_subaffiliate_condition;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getCompanyInfo();

    vm.tabs.setTabSubmitFunction('company', vm.saveAll);

    $scope.$on('$changeMerchantSuccess', function() {
      vm.getCompanyInfo();
    });

    $scope.$watch('company.company_fields.buttons_color', function(newColor) {
      if (!newColor) {
        return;
      }

      themeColors.setButtonsColor(newColor);
    });

    $scope.$watch('company.company_fields.header_color', function(newColor) {
      if (!newColor) {
        return;
      }

      themeColors.setHeaderColor(newColor);
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tablesNavItem', tablesNavItem);

  tablesNavItem.$inject = [];

  function tablesNavItem() {
    return {
      restrict: 'A',
      scope: true,
      templateUrl: 'app/admin/settings/columns_for_tables/partials/tables_nav_item.html',
      link: function() {}
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tablesNav', tablesNav);

  tablesNav.$inject = [];

  function tablesNav() {
    return {
      restrict: 'E',
      scope: {
        list: '=',
        activeTableKey: '='
      },
      templateUrl: 'app/admin/settings/columns_for_tables/partials/tables_nav.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope) {
        var vm = this;

        vm.toggle = function(item) {
          item.open = !item.open;
        };

        vm.edit = function(item) {
          $scope.$emit('edit_table', item);
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsTableColumnsController', SettingsTableColumnsController);

  SettingsTableColumnsController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'AdminSettingsTableColumnsApi',
    '_',
    'outputErrors',
    'toastsApi'
  ];

  function SettingsTableColumnsController(
    $scope,
    $state,
    $stateParams,
    AdminSettingsTableColumnsApi,
    _,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.errors = outputErrors.createNew();
    vm.table = {};
    vm.dnd_lists = {
      selected: null,
      columns: {
        selected: [],
        unselected: []
      },
      itemControl: function(item, listName) {
        item.wasInList = listName;
      },
      drop: function(list, item, newIndex) {
        var oldIndex = list.indexOf(item),
          _newIndex = newIndex;

        if (~oldIndex) {
          if (newIndex > oldIndex) {
            --_newIndex;
          }

          list.splice(oldIndex, 1);
          list.splice(_newIndex, 0, item);
          return false;
        }

        return item;
      }
    };

    vm.checkItemInList = function(list, item) {
      return _.isEmpty(_.findWhere(list, {id: item.id}));
    };

    vm.getPrevOrNextId = function(list, item, type) {
      var index = _.pluck(list, 'id').indexOf(item.id),
        newIndex;

      if (type === 'prev') {
        newIndex = index - 1;
      } else if (type === 'next') {
        newIndex = index + 1;
      }

      return index !== -1 && list[newIndex] ? list[newIndex].id : null;
    };

    vm.buildDataToSave = function(item) {
      var enabled = vm.checkItemInList(vm.dnd_lists.columns.unselected, item),
        result = {
          column_id: item.id,
          previous_element_id: null,
          next_element_id: null,
          enabled: enabled
        };

      if (enabled) {
        result.previous_element_id = vm.getPrevOrNextId(vm.dnd_lists.columns.selected, item, 'prev');
        result.next_element_id = vm.getPrevOrNextId(vm.dnd_lists.columns.selected, item, 'next');
      }

      return result;
    };

    vm.drag_end = function(item) {
      var data = vm.buildDataToSave(item);

      if (!data.enabled && item.wasInList === 'unselected') {
        return;
      }

      vm.save(data);
    };

    vm.set_selected = function(item) {
      vm.dnd_lists.selected = vm.dnd_lists.selected === item ? null : item;
    };

    vm.save = function(data) {
      AdminSettingsTableColumnsApi.saveColumn(data).then(
        function() {},
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.back = function() {
      $state.go('^');
    };

    vm.getTableByKey = function() {
      $scope.columnsCtrl.getTable($stateParams.tableKey).then(function(data) {
        vm.table = data;
      });
    };

    vm.getTableByKey();

    AdminSettingsTableColumnsApi.getSelectedTableColumns($stateParams.tableKey).then(
      function(response) {
        vm.dnd_lists.columns.selected = response.data.list;
      },
      function() {
        toastsApi.toastError();
      }
    );

    AdminSettingsTableColumnsApi.getUnselectedTableColumns($stateParams.tableKey).then(
      function(response) {
        vm.dnd_lists.columns.unselected = response.data.list;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsTablesController', SettingsTablesController);

  SettingsTablesController.$inject = [
    '$scope',
    '$state',
    'AdminSettingsTableColumnsApi',
    '_',
    'outputErrors',
    'toastsApi',
    '$q'
  ];

  function SettingsTablesController($scope, $state, AdminSettingsTableColumnsApi, _, outputErrors, toastsApi, $q) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;
    vm.errors = outputErrors.createNew();
    vm.listRequestDone = false;
    vm.deferred = {};
    vm.tableKey = null;
    vm.backTablesList = [];
    vm.tableFieldForId = 'key';

    $scope.$on('edit_table', function(ev, data) {
      vm.tableKey = data[vm.tableFieldForId];
      $state.go('settings.columns_for_tables.settings', {tableKey: vm.tableKey});
    });

    vm.sortBy = function(a, b) {
      if (a[vm.tableFieldForId] < b[vm.tableFieldForId]) {
        return -1;
      }
      if (a[vm.tableFieldForId] > b[vm.tableFieldForId]) {
        return 1;
      }
      return 0;
    };

    vm.getTableBy = function(tablesList, tableKey, fieldName) {
      var query = {};

      query[fieldName] = tableKey;

      return _.findWhere(tablesList, query);
    };

    vm.getTable = function(tableKey) {
      if (vm.listRequestDone) {
        return $q.when(vm.getTableBy(vm.backTablesList, tableKey, vm.tableFieldForId));
      }

      vm.deferred = $q.defer();
      vm.tableKey = tableKey;

      return vm.deferred.promise;
    };

    vm.stringToHash = function(str, value) {
      var result = {},
        arr = str.split('.'),
        key = arr.pop();

      result[key] = value;

      return key ? vm.stringToHash(arr.join('.'), result) : value;
    };

    vm.prepareData = function(backList, fieldName) {
      var result = {};

      _.each(backList, function(v) {
        angular.merge(result, vm.stringToHash(v.locale_key, v[fieldName]));
      });

      return result;
    };

    vm.buildMap = function(hashList, result) {
      var _result = result || {};

      _.each(hashList, function(val, key) {
        if (_.isString(val)) {
          _result[key] = {
            name: key,
            folder: false,
            open: false,
            active: false
          };
          _result[key][vm.tableFieldForId] = val;
        } else {
          _result[key] = {
            name: key,
            folder: true,
            open: false,
            childs: {}
          };
          vm.buildMap(val, _result[key].childs);
        }
      });

      return _result;
    };

    AdminSettingsTableColumnsApi.list().then(
      function(response) {
        vm.backTablesList = response.data.list || [];
        vm.backTablesList.sort(vm.sortBy);
        vm.tablesMap = vm.buildMap(vm.prepareData(vm.backTablesList, vm.tableFieldForId));
        vm.listRequestDone = true;

        if (vm.deferred.resolve) {
          vm.deferred.resolve(vm.getTableBy(vm.backTablesList, vm.tableKey, vm.tableFieldForId));
        }
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsColumnsController', SettingsColumnsController);

  SettingsColumnsController.$inject = ['$scope', '$state', 'AdminSettingsColumnsApi', '_', 'outputErrors', 'toastsApi'];

  function SettingsColumnsController($scope, $state, AdminSettingsColumnsApi, _, outputErrors, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;
    vm.errors = outputErrors.createNew();
    vm.settings_types = ['structures_columns', 'statistics_columns'];
    vm.current_settings = _.first(vm.settings_types);
    vm.dnd_lists = {
      selected: null,
      structures_columns: {},
      statistics_columns: [],
      drop: function(list, item, newIndex) {
        var oldIndex = list.indexOf(item),
          _newIndex = newIndex;

        if (~oldIndex) {
          if (newIndex > oldIndex) {
            --_newIndex;
          }

          list.splice(oldIndex, 1);
          list.splice(_newIndex, 0, item);
          return false;
        }

        return item;
      }
    };

    vm.drag_end = function() {
      vm.save();
    };

    vm.set_selected = function(item) {
      vm.dnd_lists.selected = vm.dnd_lists.selected === item ? null : item;
    };

    vm.save = function() {
      AdminSettingsColumnsApi.save_columns(vm.dnd_lists.statistics_columns, vm.dnd_lists.structures_columns).then(
        function() {},
        function() {
          toastsApi.toastError();
        }
      );
    };

    AdminSettingsColumnsApi.list().then(
      function(response) {
        var data = response.data;

        vm.dnd_lists.structures_columns = data.upload_data_structure;
        vm.dnd_lists.statistics_columns = data.colums_in_modified_daily_players_statistics;
        vm.columnsNamespace = data.locale_key + '.';
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminSettingsClickDomainsController', AdminSettingsClickDomainsController);

  AdminSettingsClickDomainsController.$inject = [
    'tabsApi',
    '$state',
    'AdminSettingsClickDomainsApi',
    '_',
    'permissionsManager',
    'toastsApi'
  ];

  function AdminSettingsClickDomainsController(
    tabsApi,
    $state,
    AdminSettingsClickDomainsApi,
    _,
    permissionsManager,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.domainsList = [];
    vm.defaultDomainId = null;
    vm.defaultDomainName = '';
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.saveDomainPerm = permissionsManager.checkPermission('api2.admin.clickdomainscontroller.edit');

    vm.getDefaultDomainProp = function(list, prop) {
      return _.propertyOf(_.findWhere(list, {default: true}))(prop);
    };

    vm.setDefaultDomain = function() {
      vm.saveForm.$setSubmitted();

      if (vm.saveForm.$invalid) {
        return;
      }

      return AdminSettingsClickDomainsApi.setDefaultDomain(vm.defaultDomainId).then(
        function() {
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.addDomain = function() {
      $state.go('settings.add_click_domain');
    };

    if (vm.saveDomainPerm) {
      vm.tabs.setTabSubmitFunction('click_domains', vm.setDefaultDomain);
    }

    AdminSettingsClickDomainsApi.getDomains().then(
      function(response) {
        vm.domainsList = response.data;
        vm.defaultDomainId = vm.getDefaultDomainProp(vm.domainsList, 'id');
        vm.defaultDomainName = vm.getDefaultDomainProp(vm.domainsList, 'domain');
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminAddClickDomainController', AdminAddClickDomainController);

  AdminAddClickDomainController.$inject = ['$state', 'AdminSettingsClickDomainsApi', '_', 'outputErrors', 'toastsApi'];

  function AdminAddClickDomainController($state, AdminSettingsClickDomainsApi, _, outputErrors, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.errors = outputErrors.createNew();
    vm.domain = '';

    vm.back = function() {
      $state.go('settings.click_domains');
    };

    vm.save = function() {
      return AdminSettingsClickDomainsApi.addDomain(vm.domain).then(
        function() {
          vm.domain = '';
          toastsApi.toastSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('HistoryChangesPercentController', HistoryChangesPercentController);

  HistoryChangesPercentController.$inject = [
    '$state',
    '$stateParams',
    'SettingsBookkeepingHistoryChangesApi',
    '_',
    'outputErrors',
    'toastsApi'
  ];

  function HistoryChangesPercentController(
    $state,
    $stateParams,
    SettingsBookkeepingHistoryChangesApi,
    _,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.errors = outputErrors.createNew();

    SettingsBookkeepingHistoryChangesApi.get_item($stateParams.id, $stateParams.merchantId).then(
      function(response) {
        vm.history_item = response.data.history_of_limit_change;
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.save_history = function() {
      SettingsBookkeepingHistoryChangesApi.save_item(vm.history_item, $stateParams.merchantId).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.back = function() {
      $state.go('settings.bookkeeping');
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsBookkeepingController', SettingsBookkeepingController);

  SettingsBookkeepingController.$inject = [
    '$scope',
    '$state',
    'AdminSettingsBookkeepingApi',
    '_',
    'outputErrors',
    'tabsApi',
    'merchantStore',
    'toastsApi'
  ];

  function SettingsBookkeepingController(
    $scope,
    $state,
    AdminSettingsBookkeepingApi,
    _,
    outputErrors,
    tabsApi,
    merchantStore,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tab_name = $state.current.data.name;
    vm.params = {};
    vm.errors = outputErrors.createNew();
    vm.tabs = tabsApi.getTabsByName('project_settings');

    vm.optionsChange = {
      typeChanges: 'bookkeeping',
      edit_state: 'settings.history_changes_percent',
      params: {},
      permissions: {
        change: 'api2.admin.historyoflimitchangescontroller.edit',
        remove: 'api2.admin.historyoflimitchangescontroller.delete'
      }
    };

    vm.updateMerchantId = function() {
      vm.optionsChange.params.merchantId = merchantStore.getCurrentMerchantId();
    };

    vm.getBookkeepingParams = function() {
      AdminSettingsBookkeepingApi.get_bookkeeping_params().then(
        function(response) {
          vm.tabs.setTabAdditionalData('bookkeeping', {historyList: response.data.list});
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.saveParams = function() {
      return AdminSettingsBookkeepingApi.create_bookkeeping_params(vm.params).then(
        function() {
          vm.getBookkeepingParams();
          toastsApi.toastCreateSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.getBookkeepingParams();
    vm.updateMerchantId();

    vm.tabs.setTabSubmitFunction('bookkeeping', vm.saveParams);
    vm.tabs.setTabAdditionalData('bookkeeping', {optionsChange: vm.optionsChange});

    $scope.$on('$changeMerchantSuccess', function() {
      vm.getBookkeepingParams();
      vm.updateMerchantId();
      vm.tabs.setTabAdditionalData('bookkeeping', {historyList: null, optionsChange: vm.optionsChange});
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('SettingsAffiliateBannerController', SettingsAffiliateBannerController);

  SettingsAffiliateBannerController.$inject = [
    'AffiliateBannerApi',
    '_',
    '$cookies',
    'outputErrors',
    'tabsApi',
    'toastsApi',
    'localesApi',
    'permissionsManager',
    'AffiliateBannerRunner'
  ];

  function SettingsAffiliateBannerController(
    AffiliateBannerApi,
    _,
    $cookies,
    outputErrors,
    tabsApi,
    toastsApi,
    localesApi,
    permissionsManager,
    AffiliateBannerRunner
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.errors = outputErrors.createNew();
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.banner = {};
    vm.canBePreviewed = false;
    vm.bannerImageSrcForPreview = '';
    vm.oldImage = '';
    vm.isValidImage = false;
    vm.editPermission = permissionsManager.checkPermission('api2.admin.bannersettingscontroller.edit');

    vm.bannerInputOptions = {
      translate_key: vm.translate_key,
      input_name: 'image',
      accept: 'image/jpeg, image/png, image/gif',
      maxFileSize: 1,
      shortcodes: {
        label: 'affiliate_banner.choose_banner',
        drop_file_here: 'affiliate_banner.drop_banner_here',
        resolution_file: 'affiliate_banner.resolution_banner'
      }
    };

    AffiliateBannerApi.getBanner('admin').then(function(response) {
      var data = response.data;

      vm.oldImage = data.banner.image;
      vm.banner = {
        image: '',
        link: data.banner.link,
        enabled: data.banner.enabled
      };

      vm.updateBanner();
    });

    vm.buildFormData = function(data) {
      var fd = new FormData();

      _.each(data, function(v, k) {
        fd.append(k, v);
      });

      return fd;
    };

    vm.getDataToServer = function(data) {
      return data.image ? data : _.omit(data, 'image');
    };

    vm.updateBanner = function(data) {
      if (data && data.image) {
        vm.bannerImageSrcForPreview = data.image;
      } else {
        vm.bannerImageSrcForPreview = vm.oldImage;
      }
      vm.canBePreviewed = !!vm.bannerImageSrcForPreview;
    };

    vm.preview = function(ev) {
      vm.validate();

      if (!vm.isValidImage) {
        return;
      }

      AffiliateBannerRunner.openModal(
        {
          image: vm.bannerImageSrcForPreview,
          link: vm.banner.link
        },
        true,
        ev
      );
    };

    vm.getPossibleErrors = function(file) {
      var errors = [];

      if (file && file.size / 1024 / 1024 > 1) {
        errors.push(localesApi.get_locale(vm.translate_key, 'affiliate_banner.invalid_file_size'));
      }

      if (file && file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/gif') {
        errors.push(localesApi.get_locale(vm.translate_key, 'affiliate_banner.invalid_file_format'));
      }

      return errors;
    };

    vm.setErrors = function(errors) {
      if (errors.length) {
        vm.errors.inputErrors({image: errors});
      } else {
        vm.errors.clearError('image');
      }
    };

    vm.validate = function() {
      if (vm.banner.image) {
        vm.setErrors(vm.getPossibleErrors(vm.banner.image));
        vm.bannerForm.$setSubmitted();
      }

      if (vm.oldImage) {
        vm.isValidImage = vm.banner.image ? vm.bannerForm.$valid : true;
      } else {
        vm.bannerForm.$setSubmitted();
        vm.isValidImage = vm.bannerForm.$valid;
      }
    };

    vm.save = function() {
      vm.validate();

      if (!vm.isValidImage) {
        return;
      }

      var fd = vm.buildFormData(vm.getDataToServer(vm.banner));

      AffiliateBannerApi.saveBanner(fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined,
          'x-xsrf-token': $cookies.get('XSRF-TOKEN-X')
        }
      }).then(
        function(response) {
          vm.oldImage = response.data.banner.image;

          toastsApi.toastSuccess();
        },
        function(response) {
          var errors = response.data && response.data.errors;

          if (errors) {
            vm.errors.inputErrors(errors);
          } else {
            toastsApi.toastError();
          }
        }
      );
    };

    if (vm.editPermission) {
      vm.tabs.setTabSubmitFunction('affiliate_banner', vm.save);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminSettingsAutoApproveController', AdminSettingsAutoApproveController);

  AdminSettingsAutoApproveController.$inject = [
    'tabsApi',
    'AdminSettingsAutoApproveApi',
    '_',
    'outputErrors',
    'localesStorage',
    'autoAcceptAffiliateRequest',
    'permissionsManager',
    'toastsApi'
  ];

  function AdminSettingsAutoApproveController(
    tabsApi,
    AdminSettingsAutoApproveApi,
    _,
    outputErrors,
    localesStorage,
    autoAcceptAffiliateRequest,
    permissionsManager,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSettings';
    vm.tabs = tabsApi.getTabsByName('project_settings');
    vm.errors = outputErrors.createNew();
    vm.autoApprove = false;
    vm.defaultApproveAdmin = null;
    vm.adminsList = [];
    vm.model = {};
    vm.langsList = _.keys(localesStorage.getLanguages());
    vm.permEdit = permissionsManager.checkPermission('api2.admin.autoapprovelocalescontroller.edit');

    vm.updateModel = function(model) {
      vm.model = model;
    };

    vm.errorHandler = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }

      vm.errors.inputErrors(errors);
      toastsApi.toastError({locale: _.first(_.flatten(_.values(errors)))});

      if (errors.localized_admins) {
        vm.localizedAdminsErrors = _.flatten([errors.localized_admins]);
      }
    };

    vm.removeError = function(error) {
      vm.localizedAdminsErrors = _.without(vm.localizedAdminsErrors, error);
    };

    vm.saveAutoApprove = function() {
      var data = {
        localized_admins: vm.model,
        auto_approve_locales: vm.autoApprove,
        admin_id_for_all_locales: vm.defaultApproveAdmin
      };

      return AdminSettingsAutoApproveApi.saveAutoApprove(data).then(
        function(response) {
          if (response.data.localized_admins) {
            vm.updateModel(response.data.localized_admins);
          }
          autoAcceptAffiliateRequest.setAccept(data.auto_approve_locales);
          toastsApi.toastEditSuccess();
        },
        function(response) {
          var data = response.data || {};

          vm.errorHandler(data.errors);

          if (data && data.localized_admins) {
            vm.updateModel(data.localized_admins);
          }
        }
      );
    };

    if (vm.permEdit) {
      vm.tabs.setTabSubmitFunction('affiliate_auto_approve', vm.saveAutoApprove);
    }

    AdminSettingsAutoApproveApi.getAutoApprove().then(
      function(response) {
        var data = response.data.auto_approve_locales;

        vm.adminsList = response.data.admins_list;
        vm.autoApprove = data.auto_approve_locales;
        vm.defaultApproveAdmin = data.admin_id_for_all_locales;
        vm.model = data.localized_admins;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('affiliateApproveSettings', affiliateApproveSettings);

  affiliateApproveSettings.$inject = ['$timeout', '$mdMedia', '$mdDialog', '$q', '_'];

  function affiliateApproveSettings($timeout, $mdMedia, $mdDialog, $q, _) {
    return {
      restrict: 'E',
      scope: {
        admins: '=',
        langs: '=',
        model: '=',
        queryField: '@'
      },
      templateUrl: 'app/admin/settings/affiliate_auto_approve/partials/affiliate_approve_settings.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope) {
        var vm = this;

        vm.langsNamespace = 'common.languages.';
        vm.translateKey = 'AdminSettings';
        vm.baseLanguages = [];
        vm.languages = [];
        vm.adminForLang = null;
        vm.currentAdmin = null;
        vm.currentLang = '';
        vm.queryField = vm.queryField || 'value';
        vm.query = {};
        vm.query[vm.queryField] = '';

        vm.clearQuery = function() {
          vm.query[vm.queryField] = '';
        };

        vm.removeAdminFromModel = function(admin) {
          vm.model = _.omit(vm.model, admin.id);
        };

        vm.clearAdmin = function(admin, ev) {
          ev.stopPropagation();
          vm.resetAdminSelectedLangs(admin);
          vm.removeAdminFromModel(admin);
          vm.updateLangs(vm.currentAdmin);
        };

        vm.isEmptyAdmin = function(admin) {
          return vm.model && _.size(vm.model[admin.id]) === 0;
        };

        vm.buildBaseLangs = function(langs, selectedLangs) {
          return _.map(langs, function(val) {
            return {id: val, value: val, check: _.contains(selectedLangs, val)};
          });
        };

        vm.getSelectedLangs = function(admin) {
          return _.difference(_.uniq(_.flatten(_.values(vm.model))), vm.model[admin.id]);
        };

        vm.filterLangs = function(allSelectedLangs) {
          return _.filter(vm.baseLanguages, function(val) {
            return !_.contains(allSelectedLangs, val.id);
          });
        };

        vm.resetAdminSelectedLangs = function(admin) {
          _.each(vm.baseLanguages, function(val) {
            if (_.contains(vm.model[admin.id], val.id)) {
              val.check = false;
            }
          });
        };

        vm.updateLangs = function(admin) {
          vm.languages = vm.filterLangs(vm.getSelectedLangs(admin));
        };

        vm.updateModel = function() {
          vm.model[vm.currentAdmin.id] = _.pluck(
            _.filter(vm.languages, function(val) {
              return val.check;
            }),
            'id'
          );

          if (_.size(vm.model[vm.currentAdmin.id]) === 0) {
            vm.removeAdminFromModel(vm.currentAdmin);
          }
        };

        vm.applyAdminSelection = function(admin, ev) {
          vm.selectAdmin(admin);

          if ($mdMedia('xs')) {
            vm.openModal(ev);
          }
        };

        vm.selectAdmin = function(admin) {
          vm.currentAdmin = admin;
          vm.updateLangs(admin);
        };

        vm.selectLangs = function() {
          return $q.when().then(function() {
            $timeout(function() {
              vm.updateModel();
            });
          });
        };

        vm.changeLang = function() {
          vm.adminForLang = _.first(
            _.filter(vm.admins, function(admin) {
              return _.contains(vm.model[admin.id], vm.currentLang);
            })
          );
        };

        vm.clearLangSelect = function() {
          vm.currentLang = '';
        };

        vm.findAdminInList = function() {
          vm.query[vm.queryField] = vm.adminForLang[vm.queryField];
          vm.selectAdmin(vm.adminForLang);
          vm.adminForLang = null;
          vm.clearLangSelect();
        };

        vm.synchronize = function() {
          if (_.isEmpty(vm.admins) || !vm.model || _.isEmpty(vm.langs)) {
            return;
          }
          vm.baseLanguages = vm.buildBaseLangs(vm.langs, _.uniq(_.flatten(_.values(vm.model))));
          vm.selectAdmin(vm.currentAdmin || _.first(vm.admins));
        };

        vm.openModal = function(ev) {
          return $mdDialog.show({
            scope: $scope,
            preserveScope: true,
            clickOutsideToClose: true,
            escapeToClose: true,
            templateUrl: 'app/admin/settings/affiliate_auto_approve/partials/modal.html',
            parent: angular.element(document.body),
            targetEvent: ev
          });
        };

        vm.closeMobilePopup = function() {
          $mdDialog.hide();
        };

        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            vm.isGtXs = value;
          }
        );

        $scope.$watch('$ctrl.admins', function() {
          vm.synchronize();
        });

        $scope.$watch('$ctrl.model', function() {
          vm.synchronize();
        });

        $scope.$watch('$ctrl.langs', function() {
          vm.synchronize();
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminProfileTwoFactorAuthController', AdminProfileTwoFactorAuthController);

  AdminProfileTwoFactorAuthController.$inject = [
    'AdminOrManagerProfileSettingsApi',
    'outputErrors',
    'tabsApi',
    'toastsApi',
    '$window',
    'mfaSettings',
    'AuthApi'
  ];

  function AdminProfileTwoFactorAuthController(
    AdminOrManagerProfileSettingsApi,
    outputErrors,
    tabsApi,
    toastsApi,
    $window,
    mfaSettings,
    AuthApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('admin_profile');

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.confirmMfaCode = function() {
      // MFA code가 비어있으면 API 호출 막기
      if (!vm.user.mfaCode) {
        vm.errors.inputErrors({mfa_code: ['MFA code is required']});
        return;
      }

      AdminOrManagerProfileSettingsApi.confirmMfaCode(vm.user.mfaCode).then(
        function() {
          // MFA 전역 상태 업데이트
          mfaSettings.setEnabled(true);

          // MFA 적용 완료 후 로그아웃하여 재로그인 유도
          // 백엔드 세션을 종료하고 로그인 페이지로 리디렉션
          AuthApi.signOut().then(
            function(res) {
              AuthApi.csrfTokenUpdate(res);
              AuthApi.redirectToLogin();
            },
            function() {
              // 로그아웃 실패해도 프론트엔드에서 로그인 페이지로 이동
              AuthApi.redirectToLogin();
            }
          );
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError();
        }
      );
    };

    vm.enableTwoFactorAuth = function() {
      // Current password가 비어있으면 API 호출 막기
      if (!vm.user.current_password) {
        vm.errors.inputErrors({current_password: ['Current password is required']});
        return;
      }

      AdminOrManagerProfileSettingsApi.enableTwoFactorAuth(vm.user.current_password).then(
        function(response) {
          var data = response.data;

          vm.user.showSecretKey = true;
          vm.user.secretValue = data.google_secret_value;
          vm.user.qrUri = data.google_qr_uri;
          vm.user.mfaCode = '';
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError();
        }
      );
    };

    vm.resetTwoFactorAuth = function() {
      // MFA code가 비어있으면 API 호출 막기
      if (!vm.user.mfaCode) {
        vm.errors.inputErrors({mfa_code: ['MFA code is required']});
        return;
      }

      AdminOrManagerProfileSettingsApi.resetTwoFactorAuth(vm.user.mfaCode).then(
        function() {
          // MFA 전역 상태 업데이트
          mfaSettings.setEnabled(false);

          // MFA 비활성화 완료 후 로그아웃하여 재로그인 유도
          // 백엔드 세션을 종료하고 로그인 페이지로 리디렉션
          AuthApi.signOut().then(
            function(res) {
              AuthApi.csrfTokenUpdate(res);
              AuthApi.redirectToLogin();
            },
            function() {
              // 로그아웃 실패해도 프론트엔드에서 로그인 페이지로 이동
              AuthApi.redirectToLogin();
            }
          );
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError();
        }
      );
    };

    /* eslint-disable no-alert */
    vm.saveTwoFactorAuth = function() {
      if (vm.user.mfa_enabled) {
        // MFA OFF: MFA code 필수 체크 후 confirm 창 표시
        if (!vm.user.mfaCode) {
          vm.errors.inputErrors({mfa_code: ['MFA code is required']});
          return;
        }
        confirm('Are you sure?') && vm.resetTwoFactorAuth();
      } else {
        if (vm.user.showSecretKey) {
          // MFA 활성화 확인: MFA code 필수 체크 후 confirm 창 표시
          if (!vm.user.mfaCode) {
            vm.errors.inputErrors({mfa_code: ['MFA code is required']});
            return;
          }
          confirm('Are you sure?') && vm.confirmMfaCode();
        } else {
          // MFA 활성화 시작: Current password 필수 체크 (confirm 창 없음)
          vm.enableTwoFactorAuth();
        }
      }
    };
    /* eslint-enable no-alert */

    vm.tabs.setTabSubmitFunction('two_factor_authentication', vm.saveTwoFactorAuth);

    AdminOrManagerProfileSettingsApi.show().then(
      function(response) {
        vm.user = response.data.profile;

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminProfilePasswordController', AdminProfilePasswordController);

  AdminProfilePasswordController.$inject = [
    'AdminOrManagerProfileSettingsApi',
    'outputErrors',
    '_',
    'tabsApi',
    'toastsApi',
    'AuthApi'
  ];

  function AdminProfilePasswordController(
    AdminOrManagerProfileSettingsApi,
    outputErrors,
    _,
    tabsApi,
    toastsApi,
    AuthApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('admin_profile');

    vm.getData = function(fields) {
      return _.pick(vm.user, fields);
    };

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.updatePassword = function() {
      var data = vm.getData(['password', 'password_confirmation', 'current_password']),
        validationErrors = {};

      // Validation: 모든 필드가 입력되었는지 확인
      vm.errors.errors = {};

      if (!data.password || data.password.trim() === '') {
        validationErrors.password = ['Required field'];
      }

      if (!data.password_confirmation || data.password_confirmation.trim() === '') {
        validationErrors.password_confirmation = ['Required field'];
      }

      if (!data.current_password || data.current_password.trim() === '') {
        validationErrors.current_password = ['Required field'];
      }

      if (!_.isEmpty(validationErrors)) {
        vm.errors.inputErrors(validationErrors);
        return;
      }

      return AdminOrManagerProfileSettingsApi.save_password(data).then(
        function() {
          // 패스워드 변경 완료 후 로그아웃하여 재로그인 유도
          // 백엔드 세션을 종료하고 로그인 페이지로 리디렉션
          AuthApi.signOut().then(
            function(res) {
              AuthApi.csrfTokenUpdate(res);
              AuthApi.redirectToLogin();
            },
            function() {
              // 로그아웃 실패해도 프론트엔드에서 로그인 페이지로 이동
              AuthApi.redirectToLogin();
            }
          );
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('password', vm.updatePassword);

    AdminOrManagerProfileSettingsApi.show().then(
      function(response) {
        vm.user = response.data.profile;

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminProfileMainController', AdminProfileMainController);

  AdminProfileMainController.$inject = [
    'AdminOrManagerProfileSettingsApi',
    'outputErrors',
    '_',
    'tabsApi',
    'toastsApi'
  ];

  function AdminProfileMainController(AdminOrManagerProfileSettingsApi, outputErrors, _, tabsApi, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('admin_profile');

    vm.getData = function(fields) {
      return _.pick(vm.user, fields);
    };

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.updateMain = function() {
      var data = vm.getData(['name', 'skype']);

      return AdminOrManagerProfileSettingsApi.save_name(data).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('main', vm.updateMain);

    AdminOrManagerProfileSettingsApi.show().then(
      function(response) {
        vm.user = response.data.profile;

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminProfileConfirmationEmailController', AdminProfileConfirmationEmailController);

  AdminProfileConfirmationEmailController.$inject = [
    '$rootScope',
    '$stateParams',
    'AdminOrManagerProfileSettingsApi',
    'outputErrors',
    'tabsApi',
    'toastsApi',
    'User'
  ];

  function AdminProfileConfirmationEmailController(
    $rootScope,
    $stateParams,
    AdminOrManagerProfileSettingsApi,
    outputErrors,
    tabsApi,
    toastsApi,
    User
  ) {
    var vm = this;

    vm.translate_key = 'AdminProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('admin_profile');
    vm.token = $stateParams.token;

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.confirmEmail = function() {
      return AdminOrManagerProfileSettingsApi.confirmation_email(vm.token).then(
        function() {
          User.updateUserProperty('email', vm.user.unconfirmed_email);
          $rootScope.$broadcast('$changeTab', {name: 'email'});
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('confirmation_email', vm.confirmEmail);

    AdminOrManagerProfileSettingsApi.show().then(
      function(response) {
        vm.user = response.data.profile;

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminProfileEmailController', AdminProfileEmailController);

  AdminProfileEmailController.$inject = [
    '$rootScope',
    'AdminOrManagerProfileSettingsApi',
    'outputErrors',
    '_',
    'tabsApi',
    'toastsApi'
  ];

  function AdminProfileEmailController(
    $rootScope,
    AdminOrManagerProfileSettingsApi,
    outputErrors,
    _,
    tabsApi,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminProfileSettings';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.tabs = tabsApi.getTabsByName('admin_profile');

    vm.getData = function(fields) {
      return _.pick(vm.user, fields);
    };

    vm.confirmEmailTabControl = function(shouldDisable) {
      if (shouldDisable) {
        vm.tabs.disableTab('confirmation_email');
      } else {
        vm.tabs.enableTab('confirmation_email');
      }
    };

    vm.updateEmail = function() {
      var data = vm.getData(['email', 'current_password']);

      return AdminOrManagerProfileSettingsApi.save_email(data).then(
        function() {
          vm.confirmEmailTabControl(false);
          $rootScope.$broadcast('$changeTab', {name: 'confirmation_email'});
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs.setTabSubmitFunction('email', vm.updateEmail);

    AdminOrManagerProfileSettingsApi.show().then(
      function(response) {
        vm.user = response.data.profile;

        vm.confirmEmailTabControl(!vm.user.unconfirmed_email);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('PartnerMainSettingsController', PartnerMainSettingsController);

  PartnerMainSettingsController.$inject = ['$scope', '$state', 'tabsApi', 'tableEngine', 'permissionsManager'];

  function PartnerMainSettingsController($scope, $state, tabsApi, tableEngine, permissionsManager) {
    var vm = this;

    vm.translate_key = 'AdminPartners';

    vm.back = function() {
      $state.go('partners');
    };

    vm.tabs = tabsApi.init({
      name: 'partners_settings',
      translateKey: vm.translate_key,
      list: [
        {
          name: 'main_data',
          shortcode: 'settings_main_data.tab_name',
          state: 'partners.settings.main_data'
        },
        {
          name: 'trackers',
          shortcode: 'settings_trackers.tab_name',
          state: 'partners.settings.trackers'
        },
        {
          name: 'subaffiliate_condition',
          shortcode: 'subaffiliate_condition.tab_name',
          state: 'partners.settings.subaffiliate_condition'
        },
        {
          name: 'fees',
          shortcode: 'settings_fees.tab_name',
          state: 'partners.settings.fees',
          hide: !permissionsManager.checkPermission('api2.admin.adminfeescontroller.edit')
        }
      ]
    });

    vm.destroyHandler = function() {
      vm.tabs.destroy();

      var trackersTable = tableEngine.getTableByName('partner_tracker_list');

      if (trackersTable) {
        trackersTable.destroy();
      }
    };

    $scope.$on('$destroy', vm.destroyHandler);
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('PartnerProfileSettingsController', PartnerProfileSettingsController);

  PartnerProfileSettingsController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'partnerApi',
    '_',
    'tabsApi',
    '$q',
    'outputErrors',
    'tableEngine',
    'toastsApi',
    'BalanceService',
    'permissionsManager'
  ];

  function PartnerProfileSettingsController(
    $scope,
    $state,
    $stateParams,
    partnerApi,
    _,
    tabsApi,
    $q,
    outputErrors,
    tableEngine,
    toastsApi,
    BalanceService,
    permissionsManager
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('partners');
    vm.partner = {};
    vm.regExp = '(^[0-9]{1,2})\\.([0-9]{4}$)';
    vm.twoFactorEnabled = false;
    vm.affiliate_types = ['Appsflyer', 'SEO', 'Communities/Forums', 'Other'];
    vm.mayEdit = permissionsManager.checkPermission('api2.admin.affiliatescontroller.edit');
    vm.mayResetAuth = permissionsManager.checkPermission('api2.admin.affiliatescontroller.clear_google_secret');
    vm.paymentMethodsPerm = permissionsManager.checkPermission('api2.admin.paymentsystemscontroller.show');
    vm.savePaymentDataPerm = permissionsManager.checkPermission('api2.admin.paymentsystemscontroller.update');
    vm.affiliateInvitaionPerm = permissionsManager.checkPermission('api2.admin.affiliateinvitationscontroller.edit');
    vm.paymentSystems = [];
    vm.countriesList = [];
    vm.currentSystem = {};
    vm.isStatusEnabled = false;
    vm.paymentDetailsName = 'partnerPaymentDetails';

    vm.partner.birthday = null;

    partnerApi.get_affiliate($stateParams.partnerId).then(
      function(response) {
        var data = response.data;

        vm.partner = data.affiliate;
        vm.report_fields = data.report_fields;
        vm.roles_list = data.roles;
        vm.affiliates_list = data.affiliates;
        vm.chiefs_list = data.chiefs;

        vm.twoFactorEnabled = vm.partner.mfa_enabled;
      },
      function() {
        toastsApi.toastError();
      }
    );

    if (vm.paymentMethodsPerm) {
      partnerApi.getCountries($stateParams.partnerId).then(
        function(response) {
          vm.countriesList = response.data.countries;
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    vm.back = function() {
      $state.go('partners');
    };

    vm.handleErrors = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }

      vm.errors.inputErrors(errors);
    };

    vm.resetTwoFactorAuth = function(affiliateId) {
      if (!vm.mayResetAuth || !vm.twoFactorEnabled || vm.partner.mfa_enabled) {
        return;
      }

      partnerApi.resetTwoFactorAuth(affiliateId).then(
        function() {
          vm.twoFactorEnabled = false;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getAffiliateFields = function(fields) {
      return _.pick(vm.partner, fields);
    };

    vm.updateProfile = function() {
      var data = vm.getAffiliateFields([
        'name',
        'surname',
        'username',
        'birthday',
        'site_url',
        'role_id',
        'banned',
        'chief_id',
        'about_affiliate',
        'admin_note',
        'affiliate_type'
      ]);

      return partnerApi.update(data, vm.partner.id).then(
        function() {
          vm.table.pagination();
          toastsApi.toastEditSuccess();
          vm.resetTwoFactorAuth(vm.partner.id);
        },
        function(response) {
          vm.handleErrors(response.data && response.data.errors);
        }
      );
    };

    vm.saveContactDetails = function() {
      var data = vm.getAffiliateFields(['email', 'skype', 'telegram', 'phone_number', 'agree_receive_emails']);

      return partnerApi.update(data, vm.partner.id).then(
        function() {
          vm.table.pagination();
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.handleErrors(response.data && response.data.errors);
        }
      );
    };

    vm.getPaymentMethods = function() {
      if (!vm.paymentMethodsPerm) {
        return;
      }

      partnerApi.getPaymentMethods($stateParams.partnerId).then(
        function(response) {
          vm.paymentSystems = response.data.payment_systems;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.changeTabSuccess = function(tab) {
      if (tab.name === 'payment_information') {
        vm.getPaymentMethods();
      }
    };

    vm.savePaymentDetailsBase = function() {
      vm.paymentDetailsForm.$setSubmitted();

      if (vm.paymentDetailsForm.$invalid) {
        return $q.reject();
      }

      return partnerApi.savePaymentDetails(BalanceService.getPaymentData(vm.currentSystem), vm.partner.id).then(
        function() {
          toastsApi.toastEditSuccess();
          return $q.when();
        },
        function(response) {
          vm.handleErrors(response.data && response.data.errors);
          return $q.reject();
        }
      );
    };

    vm.savePaymentDetails = BalanceService.decorateSaveMethod(vm.paymentDetailsName, vm.savePaymentDetailsBase);

    vm.saveSubaffiliate = function() {
      var data = vm.getAffiliateFields(['affiliate_invitation_id', 'date']);

      return partnerApi.save_subaffiliate(data, vm.partner.id).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.handleErrors(response.data && response.data.errors);
        }
      );
    };

    vm.tabs = tabsApi.init({
      name: 'partner_profile',
      translateKey: vm.translate_key,
      changeTabCallback: vm.changeTabSuccess,
      list: [
        {
          name: 'main_data',
          shortcode: 'main_data.tab_name',
          state: 'partners.profile.main_data'
        },
        {
          name: 'contact_information',
          shortcode: 'contact_information.tab_name',
          state: 'partners.profile.contact_information'
        },
        {
          name: 'payment_information',
          shortcode: 'payment_information.tab_name',
          state: 'partners.profile.payment_information',
          hide: !vm.paymentMethodsPerm
        },
        {
          name: 'manual_subaffiliate',
          shortcode: 'manual_subaffiliate.tab_name',
          state: 'partners.profile.manual_subaffiliate',
          hide: !vm.affiliateInvitaionPerm
        }
      ]
    });

    if (vm.mayEdit) {
      vm.tabs.setTabSubmitFunction('main_data', vm.updateProfile);
      vm.tabs.setTabSubmitFunction('contact_information', vm.saveContactDetails);
    }

    if (vm.savePaymentDataPerm) {
      vm.tabs.setTabSubmitFunction('payment_information', vm.savePaymentDetails);
    }

    if (vm.affiliateInvitaionPerm) {
      vm.tabs.setTabSubmitFunction('manual_subaffiliate', vm.saveSubaffiliate);
    }

    $scope.affiliateStatus.then(function(isStatusEnabled) {
      vm.isStatusEnabled = isStatusEnabled;
    });

    $scope.$on('$destroy', function() {
      vm.tabs.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPartnersController', AdminPartnersController);

  AdminPartnersController.$inject = [
    '$scope',
    '$state',
    '$mdTranslate',
    'approvedPartnersApi',
    '$mdDialog',
    '$q',
    '_',
    'permissionsManager',
    'outputErrors',
    'AuthApi',
    'tableEngine',
    'toastsApi',
    'downloadReport'
  ];

  function AdminPartnersController(
    $scope,
    $state,
    $mdTranslate,
    approvedPartnersApi,
    $mdDialog,
    $q,
    _,
    permissionsManager,
    outputErrors,
    AuthApi,
    tableEngine,
    toastsApi,
    downloadReport
  ) {
    var vm = this;

    vm.affiliateStatusDefer = $q.defer();
    vm.translate_key = 'AdminPartners';
    vm.errors = outputErrors.createNew();
    vm.managerId = null;
    vm.managersList = [];
    vm.changeManagerPermission = permissionsManager.checkPermission(
      'api2.admin.affiliatescontroller.change_manager_for_affiliates'
    );

    vm.localize = function(shortcode) {
      return $mdTranslate.instant(vm.translate_key, shortcode);
    };

    vm.getModalText = function(goal, affiliateName) {
      return (
        vm.localize('modal_window.status_question') +
        goal +
        vm.localize('modal_window.status_question_partner') +
        affiliateName +
        '?'
      );
    };

    vm.getTranslations = function(status, affiliateName) {
      var goal = vm.localize('modal_window.' + (status === 'blocked' ? 'goal_unblock' : 'goal_block'));

      return {
        title: vm.localize('modal_window.status_title'),
        content: vm.getModalText(goal, affiliateName || ''),
        ok: vm.localize('modal_window.answer_yes'),
        cancel: vm.localize('modal_window.answer_no')
      };
    };

    vm.openModal = function(locales, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(locales.title)
        .textContent(locales.content)
        .clickOutsideToClose(true)
        .targetEvent(ev)
        .ok(locales.ok)
        .cancel(locales.cancel);

      return $mdDialog.show(confirm);
    };

    vm.applyChangeBanStatus = function(affiliateId) {
      return approvedPartnersApi.banned(affiliateId).then(
        function() {
          vm.table.pagination();
          toastsApi.toastEditSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.changeStatus = function(affiliate, ev) {
      var locales = vm.getTranslations(affiliate.status, affiliate.name);

      vm.openModal(locales, ev).then(function() {
        vm.applyChangeBanStatus(affiliate.id);
      });
    };

    vm.destroyChildTable = function() {
      var childTable = tableEngine.getTableByName('partner_tracker_list');

      if (childTable && childTable.destroy) {
        childTable.destroy();
      }
    };

    vm.view_partner_tracker = function(id) {
      vm.destroyChildTable();
      $state.go('.settings.main_data', {partnerId: id});
    };

    vm.view_partner = function(id) {
      $state.go('.profile.main_data', {partnerId: id});
    };

    vm.supervision = function(id) {
      approvedPartnersApi.supervision(id).then(
        function(response) {
          $state.go('check_access', {user: response.data.current_user, isSupervision: true});
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.applyDownloadReport = function(data) {
      return approvedPartnersApi.downloadReport(data, vm.table.getSegmentId());
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.hide = function() {
      $mdDialog.hide();
    };

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.chooseManager = function() {
      vm.changeManagerForm.$setSubmitted();

      if (vm.changeManagerForm.$valid) {
        vm.hide();
      }
    };

    vm.getConfirmModalTranslations = function() {
      return {
        title: $mdTranslate.instant(vm.translate_key, 'confirm_action.title'),
        question: $mdTranslate.instant(vm.translate_key, 'confirm_action.question'),
        ok: $mdTranslate.instant(vm.translate_key, 'confirm_action.ok'),
        cancel: $mdTranslate.instant(vm.translate_key, 'confirm_action.cancel')
      };
    };

    vm.openConfirmActionModal = function(ev) {
      var translations = vm.getConfirmModalTranslations(),
        confirm = $mdDialog
          .confirm()
          .title(translations.title)
          .textContent(translations.question)
          .targetEvent(ev)
          .ok(translations.ok)
          .cancel(translations.cancel);

      return $mdDialog.show(confirm);
    };

    vm.openChangeManagerModal = function(ev) {
      return $mdDialog.show({
        scope: $scope,
        preserveScope: true,
        templateUrl: 'app/admin/partners/list/partials/change_manager_modal.html',
        parent: angular.element(document.body),
        targetEvent: ev
      });
    };

    vm.changeManager = function(selectedItems, filterId, params) {
      vm.openChangeManagerModal(null).then(function() {
        vm.openConfirmActionModal(null).then(function() {
          vm.applyChangeManger(selectedItems, filterId, params);
        });
      });
    };

    vm.applyChangeManger = function(selectedItems, filterId, params) {
      approvedPartnersApi.changeManager(vm.managerId, selectedItems, filterId, params).then(
        function() {
          vm.table.pagination();
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.partnerWebhooks = function(id) {
      $state.go('.webhooks.registration', {partnerId: id});
    };

    vm.tableFiliterColumns = [
      {
        name: 'id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'manager',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'email',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'username',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'name',
        type: 'checkbox',
        display: true,
        empty: true
      }
    ];

    vm.table = tableEngine.init({
      api: approvedPartnersApi,
      name: 'partners',
      mobile: {
        defaultColumns: ['email']
      },
      buttons: {
        url: 'app/admin/partners/list/partials/table.html',
        methods: {
          view_partner: vm.view_partner,
          supervision: vm.supervision,
          view_partner_tracker: vm.view_partner_tracker,
          partnerWebhooks: vm.partnerWebhooks,
          changeStatus: vm.changeStatus
        }
      },
      column_checkboxes: {
        enable: true,
        actions: [
          {
            name: 'changeManager',
            action: vm.changeManager,
            display: vm.changeManagerPermission,
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'list_partners.change_manager'
            }
          }
        ]
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/admin/affiliates',
        actionForFilter: 'list_approved',
        filterName: 'affiliate'
      }
    });

    if (vm.changeManagerPermission) {
      approvedPartnersApi.getManagers().then(
        function(response) {
          vm.managersList = response.data.list;
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    approvedPartnersApi.approve_affiliates().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);

        vm.downloadFormats = data.separators_for_format;
        vm.affiliateStatusDefer.resolve(vm.table.doesColumnExist('status'));
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.affiliateStatus = vm.affiliateStatusDefer.promise;

    $scope.$on('$destroy', function() {
      vm.table.destroy();
      vm.destroyChildTable();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminBulkEmailV2EditorController', AdminBulkEmailV2EditorController);

  /** @ngInject */
  function AdminBulkEmailV2EditorController(
    $http,
    $state,
    $stateParams,
    $window,
    $timeout,
    $scope,
    $mdDialog,
    $cookies,
    envService,
    toastsApi
  ) {
    var vm = this,
      // Default sender configuration
      // IMPORTANT: DEFAULT_SENDER_EMAIL must match BulkEmail::MailgunSenderService::DEFAULT_SENDER_EMAIL
      DEFAULT_SENDER_NAME = 'The GGPartners Team',
      DEFAULT_SENDER_EMAIL = 'no-reply@ggpartners.com';

    vm.apiUrl = envService.read('apiUrl');
    vm.translate_key = 'AdminBulkEmailV2';

    vm.campaign = {
      state: 'draft',
      stats: {}
    };
    vm.uploading = false;

    // Recipient list viewer
    vm.recipients = [];
    vm.recipientMeta = {
      total: 0,
      current_page: 1,
      per_page: 25,
      total_pages: 1
    };
    vm.searchQuery = '';

    // Audit trail
    vm.audits = [];
    vm.showAuditTrail = false;

    // Validate email body text length (strip HTML)
    vm.validateBodyLength = function() {
      if (!vm.campaign.body_html) {
        return false;
      }
      var text = vm.campaign.body_html.replace(/<[^>]*>/g, '').trim();
      return text.length >= 20;
    };

    // Watch for body changes and update form validity
    $scope.$watch('editor.campaign.body_html', function(newVal) {
      if ($scope.campaignForm && $scope.campaignForm.body) {
        var isValid = vm.validateBodyLength();
        $scope.campaignForm.body.$setValidity('minlength', isValid || !newVal);
      }
    });

    // Custom toolbar configuration for text-angular
    vm.customToolbar = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
      ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
      ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
      ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
    ];

    activate();

    function activate() {
      if ($stateParams.id) {
        loadCampaign($stateParams.id);
      } else {
        // Set defaults for new campaign
        vm.campaign.sender_name = DEFAULT_SENDER_NAME;
        vm.campaign.sender_email = DEFAULT_SENDER_EMAIL;
      }
    }

    function loadCampaign(id) {
      $http
        .get(vm.apiUrl + 'admin/bulk_email_campaigns/' + id)
        .then(function(response) {
          vm.campaign = response.data;
          // Load recipients after campaign is loaded
          vm.loadRecipients();
        })
        .catch(function() {
          toastsApi.toastError({text: 'Failed to load campaign'});
          $state.go('bulk_email_v2');
        });
    }

    vm.save = function(returnToDashboard) {
      var promise;
      if (vm.campaign.id) {
        promise = $http.put(vm.apiUrl + 'admin/bulk_email_campaigns/' + vm.campaign.id, {
          bulk_email_campaign: vm.campaign
        });
      } else {
        promise = $http.post(vm.apiUrl + 'admin/bulk_email_campaigns', {bulk_email_campaign: vm.campaign});
      }

      promise
        .then(function(response) {
          vm.campaign = response.data;

          if (returnToDashboard) {
            toastsApi.toastSuccess({text: 'Campaign saved successfully'});
            $state.go('bulk_email_v2');
          } else if (!$stateParams.id) {
            // Redirect to edit mode to enable uploads for new campaigns
            toastsApi.toastSuccess({text: 'Campaign created! You can now upload CSV or continue editing.'});
            $state.go('bulk_email_v2_edit', {id: vm.campaign.id});
          } else {
            // Stay on page with contextual message
            toastsApi.toastSuccess({text: 'Campaign saved successfully. Continue editing or return to dashboard.'});
          }
        })
        .catch(function(error) {
          // Handle validation errors
          var msg = 'Save failed';
          if (error.data && error.data.errors) {
            msg = error.data.errors.join(', ');
          }
          toastsApi.toastError({text: msg});
        });
    };

    vm.saveAndReturn = function() {
      vm.save(true);
    };

    vm.uploadCsv = function() {
      var fileInput = document.getElementById('csvFileUpload'),
        existingCount,
        confirm;

      if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        toastsApi.toastWarn({text: 'Please select a file'});
        return;
      }

      // CONFIRMATION: Check if recipients already exist
      existingCount = vm.recipientMeta.total;

      if (existingCount > 0) {
        confirm = $mdDialog
          .confirm()
          .title('Replace Existing Recipients?')
          .textContent(
            'WARNING: This will REPLACE all ' +
              existingCount +
              ' existing recipients with the new CSV data. This action cannot be undone.'
          )
          .ok('Continue')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(
          function() {
            // User confirmed - proceed with upload
            performCsvUpload(fileInput);
          },
          function() {
            // User cancelled - do nothing
          }
        );
      } else {
        // No existing recipients - upload directly
        performCsvUpload(fileInput);
      }
    };

    function performCsvUpload(fileInput) {
      var file = fileInput.files[0],
        fd = new FormData();

      fd.append('file', file);

      vm.uploading = true;

      $http
        .post(vm.apiUrl + 'admin/bulk_email_campaigns/' + vm.campaign.id + '/upload_csv', fd, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined,
            'x-xsrf-token': $cookies.get('XSRF-TOKEN-X')
          }
        })
        .then(function(response) {
          var data = response.data,
            message = data.message,
            validRecipients = data.campaign && data.campaign.stats && data.campaign.stats.valid_recipients;

          if (data.replaced_count > 0) {
            message += ' Replaced ' + data.replaced_count + ' existing recipients.';
          }

          // Show error toast if no valid recipients found
          if (validRecipients === 0) {
            toastsApi.toastError({text: message});
          } else {
            toastsApi.toastSuccess({text: message});
          }

          // Reload campaign and recipients
          loadCampaign(vm.campaign.id);
          vm.loadRecipients();
          vm.loadAudits(); // Refresh audit trail to show upload result
        })
        .catch(function(error) {
          var errorMsg = 'Upload failed';
          if (error.data && error.data.error) {
            errorMsg += ': ' + error.data.error;
          }
          toastsApi.toastError({text: errorMsg});
          vm.loadAudits(); // Refresh audit trail to show validation errors
        })
        .finally(function() {
          vm.uploading = false;
          // Clear file input
          fileInput.value = '';
        });
    }

    vm.isReadOnly = function() {
      // Lock everything in 'ready', 'sending', 'sent', 'failed' states
      // Only allow editing in 'draft' and 'testing' states
      return vm.campaign.state && vm.campaign.state !== 'draft' && vm.campaign.state !== 'testing';
    };

    // Recipient list functions
    vm.loadRecipients = function(page) {
      if (!vm.campaign.id) {
        return;
      }

      var currentPage = page || vm.recipientMeta.current_page;

      $http
        .get(vm.apiUrl + 'admin/bulk_email_campaigns/' + vm.campaign.id + '/recipients', {
          params: {
            page: currentPage,
            per_page: vm.recipientMeta.per_page,
            search: vm.searchQuery
          }
        })
        .then(function(response) {
          vm.recipients = response.data.recipients;
          vm.recipientMeta = response.data.meta;
        })
        .catch(function() {
          // Silent fail - recipients are optional
        });
    };

    vm.searchRecipients = function() {
      vm.recipientMeta.current_page = 1; // Reset to first page on new search
      vm.loadRecipients(1);
    };

    vm.clearSearch = function() {
      vm.searchQuery = '';
      vm.searchRecipients();
    };

    vm.nextPage = function() {
      if (vm.recipientMeta.current_page < vm.recipientMeta.total_pages) {
        vm.loadRecipients(vm.recipientMeta.current_page + 1);
      }
    };

    vm.prevPage = function() {
      if (vm.recipientMeta.current_page > 1) {
        vm.loadRecipients(vm.recipientMeta.current_page - 1);
      }
    };

    // Audit trail functions
    vm.loadAudits = function() {
      if (!vm.campaign.id) {
        return;
      }

      $http
        .get(vm.apiUrl + 'admin/bulk_email_campaigns/' + vm.campaign.id + '/audits')
        .then(function(response) {
          vm.audits = response.data;
        })
        .catch(function() {
          // Silent fail - audits are optional
        });
    };

    vm.toggleAuditTrail = function() {
      vm.showAuditTrail = !vm.showAuditTrail;
      if (vm.showAuditTrail && vm.audits.length === 0) {
        vm.loadAudits();
      }
    };

    vm.formatAuditAction = function(action) {
      var actions = {
        create: 'Created',
        update: 'Updated',
        destroy: 'Deleted',
        test_send_error: 'Test Send Error',
        send_error: 'Send Error',
        csv_upload_error: 'CSV Upload Error'
      };
      return actions[action] || action;
    };

    vm.getAuditIcon = function(action) {
      var icons = {
        create: 'fa-plus-circle',
        update: 'fa-edit',
        destroy: 'fa-trash',
        test_send_error: 'fa-exclamation-triangle',
        send_error: 'fa-exclamation-circle',
        csv_upload_error: 'fa-exclamation-triangle'
      };
      return icons[action] || 'fa-info-circle';
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminBulkEmailV2DashboardController', AdminBulkEmailV2DashboardController);

  AdminBulkEmailV2DashboardController.$inject = [
    '$scope',
    '$http',
    '$mdDialog',
    '$timeout',
    'envService',
    'toastsApi',
    'tableEngine'
  ];

  /** @ngInject */
  function AdminBulkEmailV2DashboardController($scope, $http, $mdDialog, $timeout, envService, toastsApi, tableEngine) {
    // Mailgun configuration constants
    // IMPORTANT: These must match the backend constants in BulkEmail::MailgunSenderService
    var vm = this,
      MAILGUN_DOMAIN = 'mg.ggpartners.com', // Should match Rails.application.secrets.mailgun_domain
      CAMPAIGN_TAG_PREFIX = 'campaign-',
      apiUrl = envService.read('apiUrl'),
      // Define API service object for tableEngine
      BulkEmailCampaignsApi = {
        pagination: function(params) {
          var url = apiUrl + 'admin/bulk_email_campaigns';
          return $http.get(url, {params: params});
        }
      };

    vm.translate_key = 'AdminBulkEmailV2';

    // IMPORTANT: Define all button methods BEFORE initializing table
    // Otherwise they will be undefined when table.config.buttons.methods is set

    vm.deleteCampaign = deleteCampaign;
    vm.getMailgunDashboardLink = getMailgunDashboardLink;
    vm.sendTest = sendTest;
    vm.resetToDraft = resetToDraft;
    vm.launch = launch;

    // Initialize table with tableEngine
    vm.table = tableEngine.init({
      api: BulkEmailCampaignsApi,
      name: 'bulk_email_campaigns',
      api_method: 'pagination',
      sticky: true,
      mobile: {
        collapseAll: true,
        defaultColumns: ['name']
      },
      buttons: {
        url: 'app/admin/bulk_email_v2/dashboard/table_buttons.html',
        methods: {
          deleteCampaign: vm.deleteCampaign,
          getMailgunDashboardLink: vm.getMailgunDashboardLink,
          sendTest: vm.sendTest,
          resetToDraft: vm.resetToDraft,
          launch: vm.launch
        }
      }
    });

    // Load initial data
    activate();

    function activate() {
      loadCampaigns();
    }

    function loadCampaigns() {
      BulkEmailCampaignsApi.pagination({page: 1, per_page: 25})
        .then(function(response) {
          var data = response.data;
          vm.table.update({
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          });
        })
        .catch(function(error) {
          toastsApi.toastError({
            text: 'Failed to load campaigns: ' + ((error.data && error.data.error) || error.statusText)
          });
        });
    }

    function deleteCampaign(id, ev) {
      var confirm = $mdDialog
        .confirm()
        .title('Delete Campaign?')
        .textContent('Are you sure you want to delete this campaign? This action cannot be undone.')
        .targetEvent(ev)
        .ok('Delete')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        $http
          .delete(apiUrl + 'admin/bulk_email_campaigns/' + id)
          .then(function() {
            toastsApi.toastSuccess({text: 'Campaign deleted successfully'});
            vm.table.removeListItem(); // Refresh table
          })
          .catch(function(error) {
            toastsApi.toastError({text: 'Failed to delete: ' + ((error.data && error.data.error) || error.statusText)});
          });
      });
    }

    // Generate Mailgun dashboard link with pre-filtered campaign tag
    function getMailgunDashboardLink(campaignId) {
      if (!campaignId) {
        return '#';
      }

      // Mailgun dashboard URL with tag filter
      // Format: https://app.mailgun.com/app/sending/domains/{domain}/logs?q=tag:campaign-{id}
      var tag = CAMPAIGN_TAG_PREFIX + campaignId;

      return 'https://app.mailgun.com/app/sending/domains/' + MAILGUN_DOMAIN + '/logs?q=tag:' + tag;
    }

    function sendTest(id, ev) {
      var confirm = $mdDialog
        .prompt()
        .title('Send Test Email')
        .textContent('Enter email addresses (comma-separated). Leave empty to send to your email.')
        .placeholder('email1@example.com, email2@example.com')
        .ariaLabel('Test Emails')
        .targetEvent(ev)
        .ok('Send Test')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function(result) {
        var requestData = {};
        if (result && result.trim()) {
          requestData.test_emails = result.trim();
        }

        $http
          .post(apiUrl + 'admin/bulk_email_campaigns/' + id + '/test_send', requestData)
          .then(function(response) {
            var data = response.data,
              message = data.message;

            // Show appropriate toast based on results
            if (data.sent_count === 0 && data.failed && data.failed.length > 0) {
              // All failed - show error
              toastsApi.toastError({text: message});
            } else if (data.failed && data.failed.length > 0) {
              // Partial failure - show warning
              toastsApi.toastWarn({text: message});
            } else {
              // All succeeded - show success
              toastsApi.toastSuccess({text: message});
            }
            vm.table.pagination(); // Refresh status
          })
          .catch(function(error) {
            toastsApi.toastError({text: 'Test Send failed: ' + ((error.data && error.data.error) || error.statusText)});
          });
      });
    }

    function resetToDraft(id, ev) {
      var confirm = $mdDialog
        .confirm()
        .title('Reset Campaign to Draft?')
        .htmlContent(
          '<p>This will unlock the campaign for editing. You will be able to:</p>' +
            '<ul style="margin-left: 20px; margin-top: 10px;">' +
            '<li>Modify email content (subject, body, sender info)</li>' +
            '<li>Upload a new recipient list (CSV)</li>' +
            '<li>Send new test emails</li>' +
            '</ul>' +
            '<p style="margin-top: 15px;"><strong>Note:</strong> You\'ll need to review and test the campaign again before launching.</p>'
        )
        .targetEvent(ev)
        .ok('Reset to Draft')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        $http
          .post(apiUrl + 'admin/bulk_email_campaigns/' + id + '/reset_to_draft')
          .then(function() {
            toastsApi.toastSuccess({text: 'Campaign reset to draft. All fields are now editable.'});
            vm.table.pagination(); // Refresh status
          })
          .catch(function(error) {
            toastsApi.toastError({text: 'Reset failed: ' + ((error.data && error.data.error) || error.statusText)});
          });
      });
    }

    function launch(id, recipientCount, ev) {
      ev.stopPropagation();

      // First, fetch full campaign details
      $http
        .get(apiUrl + 'admin/bulk_email_campaigns/' + id)
        .then(function(response) {
          var campaign = response.data;

          // Show enhanced confirmation modal with recipient preview
          $mdDialog.show({
            controller: [
              '$scope',
              '$mdDialog',
              '$http',
              'toastsApi',
              function($scope, $mdDialog, $http, toastsApi) {
                $scope.campaign = {
                  Id: campaign.id,
                  Name: campaign.name,
                  Subject: campaign.subject,
                  SenderName: campaign.sender_name,
                  SenderEmail: campaign.sender_email,
                  Recipients: campaign.stats.valid_recipients || recipientCount,
                  InvalidRecipients: campaign.stats.invalid_rows || 0
                };
                $scope.recipients = [];
                $scope.recipientMeta = {
                  total: campaign.stats.valid_recipients || recipientCount || 0,
                  current_page: 1,
                  per_page: 10,
                  total_pages: 1
                };
                $scope.searchQuery = '';
                $scope.loading = true;
                $scope.launching = false;

                // Load recipients for preview
                function loadRecipients() {
                  $scope.loading = true;
                  $http
                    .get(apiUrl + 'admin/bulk_email_campaigns/' + id + '/recipients', {
                      params: {
                        search: $scope.searchQuery,
                        page: $scope.recipientMeta.current_page,
                        per_page: $scope.recipientMeta.per_page
                      }
                    })
                    .then(function(response) {
                      $scope.recipients = response.data.recipients;
                      $scope.recipientMeta = response.data.meta;
                    })
                    .catch(function() {
                      toastsApi.toastError({text: 'Failed to load recipients'});
                    })
                    .finally(function() {
                      $scope.loading = false;
                    });
                }

                // Initial load
                loadRecipients();

                // Search functionality
                $scope.searchRecipients = function() {
                  $scope.recipientMeta.current_page = 1;
                  loadRecipients();
                };

                $scope.clearSearch = function() {
                  $scope.searchQuery = '';
                  $scope.recipientMeta.current_page = 1;
                  loadRecipients();
                };

                // Pagination
                $scope.nextPage = function() {
                  if ($scope.recipientMeta.current_page < $scope.recipientMeta.total_pages) {
                    $scope.recipientMeta.current_page++;
                    loadRecipients();
                  }
                };

                $scope.prevPage = function() {
                  if ($scope.recipientMeta.current_page > 1) {
                    $scope.recipientMeta.current_page--;
                    loadRecipients();
                  }
                };

                // Actions
                $scope.cancel = function() {
                  $mdDialog.cancel();
                };

                $scope.launch = function() {
                  $scope.launching = true;

                  $http
                    .post(apiUrl + 'admin/bulk_email_campaigns/' + id + '/launch')
                    .then(function() {
                      toastsApi.toastSuccess({
                        text:
                          '🚀 Sending campaign to ' +
                          $scope.recipientMeta.total +
                          ' recipients in background. Refresh dashboard for delivery stats.'
                      });
                      $mdDialog.hide();
                      vm.table.pagination(); // Reload dashboard table immediately

                      // Auto-refresh after 5 seconds to show initial progress
                      $timeout(function() {
                        vm.table.pagination();
                      }, 5000);
                    })
                    .catch(function(error) {
                      toastsApi.toastError({
                        text: 'Launch failed: ' + ((error.data && error.data.error) || error.statusText)
                      });
                    })
                    .finally(function() {
                      $scope.launching = false;
                    });
                };
              }
            ],
            templateUrl: 'app/admin/bulk_email_v2/launch_confirmation_modal.html',
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: true
          });
        })
        .catch(function() {
          toastsApi.toastError({text: 'Failed to load campaign details'});
        });
    }

    // Clean up on destroy
    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });

    // Refresh on merchant change
    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('tableEngine', tableEngine);

  tableEngine.$inject = ['$q', '_', 'toastsApi', '$mdDialog', 'permissionsManager', 'User'];

  function tableEngine($q, _, toastsApi, $mdDialog, permissionsManager, User) {
    var tableEngine = {},
      tableStorage = {},
      options = {
        api: {},
        api_method: 'pagination',
        buttons: null,
        columns_namespace: '',
        name: '',
        sticky: true,
        total: null,
        params: {
          total_pages: null,
          total_entries: null,
          start_row_num: null,
          end_row_num: null,
          data: {
            additional_options: null,
            page: 1,
            filter_set_id: 0,
            search: {
              keyword: ''
            }
          }
        },
        mobile: {
          collapseAll: true,
          defaultColumns: []
        },
        column_checkboxes: {
          enable: false,
          column_to_save: 'id',
          storage: {},
          actions: [],
          if_no_choosed: {},
          validate: false
        },
        filter: {
          id: 0,
          enable: false,
          columns: [],
          pathForFilter: '',
          actionForFilter: '',
          byMerchant: false,
          filterName: ''
        }
      };

    function Table(config) {
      this.config = config;
      this.columns = [];
      this.list = [];
      this.list_length = null;
      this.isSortAvailable = false;
      this.isMatchAvailable = false;
      this.columnsShowedWhenCollapsed = [];
      this._isRendered = false;
    }

    Table.prototype.updateColumns = function(columns) {
      this.columns = columns || [];
      this.isSortAvailable = this.isColumnActionAvailable('sort');
      this.isMatchAvailable = this.isColumnActionAvailable('match');
    };

    Table.prototype.setColumnsNamespce = function(namespace) {
      this.config.columns_namespace = namespace + '.';
    };

    Table.prototype.prepareList = function(list) {
      return _.map(_.has(list, 'data') ? list.data : list, function(v) {
        return v.attributes ? _.omit(_.extend(v, v.attributes), 'attributes') : v;
      });
    };

    Table.prototype.updateList = function(list, totalPages, totalEntries, startRowNum, endRowNum) {
      this.list = this.prepareList(list);
      this.list_length = this.list.length;

      this.config.params.total_pages = totalPages;
      this.config.params.total_entries = totalEntries;
      this.config.params.start_row_num = startRowNum;
      this.config.params.end_row_num = endRowNum;
    };

    Table.prototype.update = function(opts) {
      this.updateColumns(opts.columns);
      this.updateList(opts.list, opts.total_pages, opts.total_entries, opts.start_row_num, opts.end_row_num);
      this.setColumnsNamespce(opts.locale_key);
      this.updateColumnsShowedWhenCollapsed();
      this._isRendered = true;
    };

    Table.prototype.pagination = function() {
      var _this = this,
        promise = null,
        params = _this.config.params.data;

      promise = _this.config.api[_this.config.api_method](params);
      _this.list_length = null;

      promise.then(
        function(response) {
          var data = response.data;
          _this.updateList(data.list, data.total_pages, data.total_entries, data.start_row_num, data.end_row_num);
          return data;
        },
        function(response) {
          return response;
        }
      );

      return promise;
    };

    Table.prototype.prevPage = function() {
      this.config.params.data.page = this.config.params.data.page > 1 ? --this.config.params.data.page : 1;
      return this.pagination();
    };

    Table.prototype.nextPage = function() {
      this.config.params.data.page =
        this.config.params.data.page < this.config.params.total_pages
          ? ++this.config.params.data.page
          : this.config.params.total_pages;
      return this.pagination();
    };

    Table.prototype.getPage = function() {
      var deferred = $q.defer();

      if (this.config.params.data.page >= 1 && this.config.params.data.page <= this.config.params.total_pages) {
        this.pagination().then(function() {
          deferred.resolve();
        });
      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    Table.prototype.removeListItem = function() {
      var params = this.config.params,
        data = params.data;

      this.config.params.data.page =
        params.end_row_num === params.start_row_num && data.page > 1 ? data.page - 1 : data.page;
      return this.pagination();
    };

    Table.prototype.updateListItemById = function(item, id, prop) {
      var idx = _.indexOf(
          this.list,
          _.find(this.list, function(v) {
            return v[prop || 'id'] === +id;
          })
        ),
        newItem;

      if (~idx) {
        newItem = _.mapObject(this.list[idx], function(v, k) {
          return _.isUndefined(item[k]) ? v : item[k];
        });

        if (_.isEqual(this.list[idx], newItem)) {
          return;
        }

        this.list[idx] = _.omit(newItem, '$$hashKey');
      }
    };

    Table.prototype.addOptionsToColumn = function(name, options) {
      _.extend(_.findWhere(this.columns, {name: name}), options);
    };

    Table.prototype.doesColumnExist = function(name) {
      return !_.isEmpty(_.findWhere(this.columns, {name: name}));
    };

    Table.prototype.search = function() {
      this.config.params.data.page = 1;
      return this.pagination();
    };

    Table.prototype.searchClear = function() {
      this.config.params.data.search.keyword = '';
      return this.pagination();
    };

    Table.prototype.sort = function(column) {
      var data = this.config.params.data,
        sortType;

      data.order = _.pick(data.order, column.name);
      sortType = data.order[column.name] === 'desc' ? 'asc' : '';
      data.order[column.name] = data.order[column.name] ? sortType : 'desc';

      if (data.order[column.name] === '') {
        delete data.order;
      }

      return this.pagination();
    };

    Table.prototype.isColumnActionAvailable = function(actionName) {
      return _.some(this.columns, function(column) {
        return column[actionName];
      });
    };

    Table.prototype.isSortActivated = function() {
      return !_.isEmpty(this.config.params.data.order);
    };

    Table.prototype.getSortTypeByColumnName = function(columnName) {
      return _.propertyOf(this.config.params.data.order)(columnName);
    };

    Table.prototype.updateAdditionalOptions = function(options) {
      this.config.params.data.additional_options = options;
    };

    Table.prototype.updateTotalColumns = function(totalColumns) {
      this.config.total.data = angular.merge({}, {total_columns: totalColumns, columns: _.rest(this.columns)});
    };

    Table.prototype.markCopyColumns = function(columnNames) {
      var names = _.isArray(columnNames) ? columnNames : [columnNames];

      _.each(this.columns, function(v) {
        v.copy = _.contains(names, v.name);
      });
    };

    Table.prototype.tpggleAll = function() {
      var storage = this.config.column_checkboxes.storage,
        key = this.config.column_checkboxes.column_to_save,
        value = this.isCheckedAll();

      _.each(this.list, function(item) {
        storage[item[key]] = !value;
      });
    };

    Table.prototype.toggleItem = function(item) {
      var storage = this.config.column_checkboxes.storage,
        key = this.config.column_checkboxes.column_to_save;

      storage[item[key]] = !storage[item[key]];
    };

    Table.prototype.getCurrentValuesList = function() {
      return _.pluck(this.list, this.config.column_checkboxes.column_to_save).sort();
    };

    Table.prototype.isCheckedAll = function() {
      var selected = this.getSelected(),
        allList = this.getCurrentValuesList();

      return _.isEqual(selected, allList) && _.size(selected);
    };

    Table.prototype.isCheckedItem = function(item) {
      var storage = this.config.column_checkboxes.storage,
        key = this.config.column_checkboxes.column_to_save;

      return storage[item[key]];
    };

    Table.prototype.getSelected = function() {
      var storage = this.config.column_checkboxes.storage,
        allList = this.getCurrentValuesList(),
        selected = [];

      _.each(storage, function(v, k) {
        if (!v) {
          return;
        }

        var key = Number(k);

        if (_.contains(allList, key)) {
          selected.push(key);
        }
      });

      return selected.sort();
    };

    Table.prototype.checkAvailableActions = function() {
      return _.some(_.pluck(this.config.column_checkboxes.actions, 'display'));
    };

    Table.prototype.notifyUnchecked = function() {
      var opts = this.config.column_checkboxes.if_no_choosed;

      if (opts.translate_key && opts.shortcode) {
        return toastsApi.toastWarn({translate_key: opts.translate_key, shortcode: opts.shortcode});
      }
    };

    Table.prototype.displayAction = function(item) {
      return (_.isBoolean(item.display) && item.display) || (_.isFunction(item.display) && item.display());
    };

    Table.prototype.applyAction = function(actionItem) {
      var selected = this.getSelected();

      if (!actionItem.no_validate && this.config.column_checkboxes.validate) {
        if (_.size(selected) === 0) {
          return this.notifyUnchecked();
        }
      }

      actionItem.action(selected, this.config.params.data.filter_set_id, this.config.params.data);
    };

    Table.prototype.isChoosedAnyItem = function() {
      return _.size(this.getSelected()) !== 0;
    };

    Table.prototype.openFilter = function(ev) {
      return $mdDialog.show({
        controller: 'TableFilterController',
        controllerAs: 'FilterCtrl',
        templateUrl: 'app/components/table/partials/filter_dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: {
          table: this
        }
      });
    };

    Table.prototype.isFilterEnabled = function() {
      var namespace = User.getUserProperty('namespace');
      return (
        this.config.filter.enable &&
        permissionsManager.checkPermission('api2.' + namespace + '.filtersetscontroller.show')
      );
    };

    Table.prototype.setFilterId = function(id) {
      this.config.filter.id = id || 0;
    };

    Table.prototype.getFilterId = function() {
      return this.config.filter.id;
    };

    Table.prototype.getFilterName = function() {
      return this.config.filter.filterName;
    };

    Table.prototype.getPathForFilter = function() {
      return this.config.filter.pathForFilter;
    };

    Table.prototype.getActionForFilter = function() {
      return this.config.filter.actionForFilter;
    };

    Table.prototype.getByMerchant = function() {
      return this.config.filter.byMerchant;
    };

    Table.prototype.updateFilterColumns = function(tabsList, fullTabsList) {
      _.each(this.config.filter.columns, function(column) {
        column.display = _.contains(tabsList, column.name);
        column.empty = !_.contains(fullTabsList, column.name);
      });
    };

    Table.prototype.applyFilter = function() {
      this.setSegmentId(this.getFilterId());
      this.config.params.data.page = 1;

      return this.pagination();
    };

    Table.prototype.cancelFilter = function() {
      this.setSegmentId(0);
      this.config.params.data.page = 1;

      return this.pagination();
    };

    Table.prototype.resetFilter = function() {
      this.setFilterId(0);
      this.setSegmentId(0);
      this.config.params.data.page = 1;
    };

    Table.prototype.setSegmentId = function(id) {
      this.config.params.data.filter_set_id = id;
    };

    Table.prototype.getSegmentId = function() {
      return this.config.params.data.filter_set_id;
    };

    Table.prototype.filterIsActivated = function() {
      return this.config.params.data.filter_set_id !== 0;
    };

    Table.prototype.clearParams = function() {
      this.config.params = angular.merge({}, options.params);
    };

    Table.prototype.setUpNewPage = function(page) {
      this.config.params.data.page = page;
    };

    Table.prototype.isRendered = function() {
      return this._isRendered;
    };

    Table.prototype.toggleAll = function() {
      this.config.mobile.collapseAll = !this.config.mobile.collapseAll;
    };

    Table.prototype.controlColumnInDefaults = function(column) {
      column.showWhenCollapsed = !column.showWhenCollapsed;
      this.saveColumnsShowedWhenCollapsed();
      this.updateColumnsShowedWhenCollapsed();
    };

    Table.prototype.saveColumnsShowedWhenCollapsed = function() {
      var columns = this.getDefaultColumns(),
        columnNames = _.pluck(columns, 'name');

      localStorage.setItem(this.config.name, JSON.stringify(columnNames));
    };

    Table.prototype.getDefaultColumns = function() {
      return _.where(this.columns, {showWhenCollapsed: true});
    };

    Table.prototype.updateColumnsShowedWhenCollapsed = function() {
      var columns = this.getSavedColumnsShowedWhenCollapsed(),
        newColumns;

      _.each(this.columns, function(column) {
        column.showWhenCollapsed = _.contains(columns, column.name);
      });

      newColumns = _.where(this.columns, {showWhenCollapsed: true});

      this.columnsShowedWhenCollapsed = _.isEmpty(newColumns) ? [_.first(this.columns)] : newColumns;
    };

    Table.prototype.getSavedColumnsShowedWhenCollapsed = function() {
      var data = localStorage.getItem(this.config.name);
      return _.isEmpty(data) ? this.config.mobile.defaultColumns : JSON.parse(data);
    };

    Table.prototype.destroy = function() {
      delete tableStorage[this.config.name];
    };

    tableEngine.createTable = function(config) {
      return new Table(angular.merge({}, options, config));
    };

    tableEngine.getTableByName = function(name) {
      return tableStorage[name];
    };

    tableEngine.init = function(config) {
      tableStorage[config.name] = this.createTable(config);
      return this.getTableByName(config.name);
    };

    tableEngine.getOrCreate = function(config) {
      var table = tableEngine.getTableByName(config.name);

      if (table) {
        table.pagination();
        return table;
      }

      return tableEngine.init(config);
    };

    return tableEngine;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableMobileSort', tableMobileSort);

  tableMobileSort.$inject = ['_'];

  function tableMobileSort(_) {
    return {
      restrict: 'E',
      scope: {
        table: '='
      },
      templateUrl: 'app/components/table/partials/table_mobile_sort.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function() {
        var vm = this;

        vm.searchSortQuery = '';

        vm.clearSortSearch = function() {
          vm.searchSortQuery = '';
        };

        vm.sort = function(column, ev) {
          var btn = ev.target.closest('.sort-mobile-icons'),
            wrapper = ev.target.closest('md-menu-content'),
            buttons = wrapper.querySelectorAll('.sort-mobile-icons'),
            cls;

          _.each(buttons, function(el) {
            el.classList.remove('desc', 'asc');
          });

          vm.table.sort(column);

          cls = vm.table.getSortTypeByColumnName(column.name);

          if (cls) {
            btn.classList.add(cls);
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableMobileDefaultColumnsList', tableMobileDefaultColumnsList);

  tableMobileDefaultColumnsList.$inject = [];

  function tableMobileDefaultColumnsList() {
    return {
      restrict: 'E',
      require: '^^tableListMobile',
      scope: {
        table: '='
      },
      templateUrl: 'app/components/table/partials/table_mobile_default_columns_list.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function() {
        var vm = this;

        vm.searchQuery = '';

        vm.clearSearch = function() {
          vm.searchQuery = '';
        };
      },
      link: function(scope, element, attr, tableListCtrl) {
        scope.controlDefaultColumn = function(column) {
          tableListCtrl.controlDefaultColumn(column);
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableMobileContentRow', tableMobileContentRow);

  tableMobileContentRow.$inject = [];

  function tableMobileContentRow() {
    return {
      restrict: 'E',
      scope: {
        namespace: '=',
        item: '=',
        column: '='
      },
      templateUrl: 'app/components/table/partials/table_mobile_content_row.html'
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableListSearch', tableListSearch);

  tableListSearch.$inject = ['$mdMedia', '$timeout', '_'];

  function tableListSearch($mdMedia, $timeout, _) {
    return {
      restrict: 'E',
      scope: {
        table: '='
      },
      templateUrl: 'app/components/table/partials/table_list_search.html',
      controllerAs: 'searchCtrl',
      controller: function($scope) {
        var vm = this;

        vm.focusInput = function() {
          var input = _.last(document.querySelectorAll('.table-search-input'));

          if (input) {
            $timeout(function() {
              input.focus();
            }, 0);
          }
        };

        vm.clear = function() {
          $scope.table.searchClear();
          vm.focusInput();
        };

        vm.clearMobile = function(ev, $mdMenu) {
          ev.stopPropagation();

          if ($scope.table.config.params.data.search.keyword) {
            vm.clear();
          } else {
            $mdMenu.close();
          }
        };

        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            $scope.isGtXs = value;
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableListPagination', tableListPagination);

  tableListPagination.$inject = [];

  function tableListPagination() {
    return {
      restrict: 'E',
      scope: {
        table: '='
      },
      templateUrl: 'app/components/table/partials/table_list_pagination.html',
      controllerAs: 'paginationCtrl',
      controller: function($scope) {
        var vm = this;

        vm.disabled = false;

        vm.callback = function() {
          vm.disabled = false;
        };

        vm.next = function() {
          vm.disabled = true;
          $scope.table.nextPage().finally(vm.callback);
        };

        vm.prev = function() {
          vm.disabled = true;
          $scope.table.prevPage().finally(vm.callback);
        };

        vm.set_page = function() {
          vm.disabled = true;
          $scope.table.getPage().finally(vm.callback);
        };

        vm.scrollTop = function() {
          var viewContent = document.querySelector('.view-content');

          if (viewContent) {
            viewContent.scrollIntoView({behavior: 'smooth'});
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableListMobile', tableListMobile);

  tableListMobile.$inject = ['$timeout', '$translate', 'tableHelper', '_'];

  function tableListMobile($timeout, $translate, tableHelper, _) {
    return {
      restrict: 'E',
      scope: {
        table: '=',
        onRendered: '&?'
      },
      templateUrl: 'app/components/table/partials/table_list_mobile.html',
      controllerAs: 'tableList',
      controller: function($scope, $element) {
        var vm = this,
          timeoutDef,
          tableBody = $element[0].querySelector('.table-mobile-body'),
          rowHeight = 49;

        vm.setTransitionToHeadings = function() {
          $timeout(
            function() {
              var headings = $element[0].querySelectorAll('.item-nav-row');

              _.each(headings, function(heading) {
                angular.element(heading).css({transition: 'min-height 225ms cubic-bezier(0.4, 0, 0.2, 1)'});
              });
            },
            0,
            false
          );
        };

        vm.setMinHeight = function(heading, isOpen) {
          heading.css({'min-height': rowHeight * (isOpen ? 1 : $scope.table.columnsShowedWhenCollapsed.length) + 'px'});
        };

        vm.changeHeadingHeight = function(isOpen, getRefElement) {
          vm.setMinHeight(getRefElement().find('accordion-group-heading'), isOpen);
        };

        vm.controlDefaultColumn = function(column) {
          $scope.table.controlColumnInDefaults(column);
          vm.changeAllDefaultColumnsHeight();
        };

        vm.changeAllDefaultColumnsHeight = function() {
          _.each($element[0].querySelectorAll('.table-mobile-body-item:not(.total-row)'), function(group) {
            var el = angular.element(group),
              isolateScope = el.isolateScope(),
              heading = el.find('accordion-group-heading');

            if (heading) {
              vm.setMinHeight(heading, isolateScope && isolateScope.groupCtrl.open);
            }
          });
        };

        vm.determine_content = function(item, column) {
          return tableHelper.getColumnContent(
            item,
            column,
            $scope.table.config.params.data.search.keyword,
            $scope.table.config.separate_numbers
          );
        };

        vm.clickRow = function(e) {
          var row = angular.element(e.target.closest('.table-mobile-body-item-row:not(.item-head-row)'));
          row.toggleClass('active');
        };

        vm.callback = function() {
          if (timeoutDef) {
            $timeout.cancel(timeoutDef);
          }
          timeoutDef = $timeout(
            function() {
              vm.changeAllDefaultColumnsHeight();
              vm.setTransitionToHeadings();
              vm.showTable();

              if (_.isFunction($scope.onRendered)) {
                $scope.onRendered();
              }
            },
            0,
            false
          );
        };

        vm.showTable = _.once(function() {
          $element.addClass('rendered');
        });

        vm.checkUpdatedList = function(count) {
          vm.load_buttons = $scope.table.config.buttons && count ? _.after(count, vm.callback) : angular.noop;

          if (!($scope.table.config.buttons && count) && $translate.isReady()) {
            vm.callback();
          }
        };

        $scope.$watch('table.list_length', function(count) {
          if (_.isNull(count)) {
            return;
          }
          vm.checkUpdatedList(count);
        });

        $scope.$watch('table.columnsShowedWhenCollapsed', function() {
          $timeout(function() {
            vm.changeAllDefaultColumnsHeight();
          }, 0);
        });

        tableBody.addEventListener('click', vm.clickRow);

        $scope.$on('$destroy', function() {
          tableBody.removeEventListener('click', vm.clickRow);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableListDesktop', tableListDesktop);

  tableListDesktop.$inject = [
    '$rootScope',
    '$window',
    '$timeout',
    '$translate',
    'tableHelper',
    'toastsApi',
    '_',
    'Clipboard'
  ];

  function tableListDesktop($rootScope, $window, $timeout, $translate, tableHelper, toastsApi, _, Clipboard) {
    return {
      restrict: 'E',
      scope: {
        table: '=',
        onRendered: '&?'
      },
      templateUrl: 'app/components/table/partials/table_list_desktop.html',
      controllerAs: 'tableList',
      controller: function($scope, $element) {
        var vm = this,
          mainView = document.querySelector('.main-view'),
          card = findUp('primary-card'),
          card_header = card.querySelector('.card-header'),
          duplicate_header = card.querySelector('.duplicate-list-header'),
          tableHolder = $element[0].querySelector('.table-list-holder'),
          table_body = $element[0].querySelector('.table-list-body'),
          show_prompt = false,
          timeoutDef,
          clipboardCells,
          translateListener;

        function findUp(findedClassName, startElement) {
          var startEl = startElement || $element[0];
          while ((startEl = startEl.parentElement) && !startEl.classList.contains(findedClassName)) {}
          return startEl;
        }

        vm.determine_content = function(item, column) {
          return tableHelper.getColumnContent(
            item,
            column,
            $scope.table.config.params.data.search.keyword,
            $scope.table.config.separate_numbers
          );
        };

        vm.update_cell_width = function() {
          var cells_original = $element[0].querySelectorAll('.table-list-head .table-list-head-cell'),
            cells_duplicate = $element[0].querySelectorAll('.duplicate-list-header .table-list-head-cell'),
            cells_width = _.map(cells_original, function(item) {
              return {width: item.getBoundingClientRect().width, content: item.textContent};
            });

          _.each(cells_width, function(item, i) {
            cells_duplicate[i].style.width = item.width + 'px';

            var span = cells_duplicate[i].querySelector('.column-name');

            if (span) {
              span.innerHTML = item.content;
            }
          });
        };

        vm.scrollControll = function(action /* , offset */) {
          card_header.classList[action]('sticky');
          duplicate_header.classList[action]('sticky');
          // card.style.paddingTop = card_header.offsetHeight + 'px';
          // card_header.style.top = action === 'add' ? mainView.offsetTop + offset.top * -1 + 'px' : '0px';
          // duplicate_header.style.top = action === 'add' ? card_header.offsetTop - 1 + 'px' : '0px';
        };

        vm.updateScroll = function() {
          var card_offset = card.getBoundingClientRect(),
            action =
              card_offset.top - mainView.offsetTop > 0 ||
              ($scope.table.list_length !== null && $scope.table.list_length < 6) ||
              card_offset.bottom < 310
                ? 'remove'
                : 'add';

          vm.scrollControll(action, card_offset);
        };

        vm.updateHeaderScroll = function(ev) {
          duplicate_header.scrollLeft = ev ? ev.target.scrollLeft : tableHolder.scrollLeft;
        };

        vm.setTopToDuplicateHeader = function() {
          duplicate_header.style.top = card_header.offsetHeight - 1 + 'px';
        };

        vm.digest_end_callback = function() {
          if (timeoutDef) {
            $timeout.cancel(timeoutDef);
          }
          timeoutDef = $timeout(
            function() {
              vm.update_cell_width();

              if ($scope.table.config.sticky) {
                vm.updateScroll();
              }

              vm.clipboardCellsControll();
              vm.show_table();
              vm.setTopToDuplicateHeader();
              vm.updateHeaderScroll();

              if (_.isFunction($scope.onRendered)) {
                $scope.onRendered();
              }
            },
            0,
            false
          );
        };

        vm.render_item = function() {
          if ($translate.isReady()) {
            vm.digest_end_callback();
          }
        };

        vm.clipboardCellsControll = function() {
          if (!Clipboard.isSupported()) {
            return;
          }

          var copyCells = table_body.querySelectorAll('.table-list-body-cell table-list-cell[data-copy="true"]');

          if (!copyCells.length) {
            return;
          }

          if (clipboardCells) {
            clipboardCells.destroy();
          }

          clipboardCells = new Clipboard(copyCells);

          clipboardCells.on('success', function() {
            toastsApi.toastSuccess('Copied!');
          });

          clipboardCells.on('error', function() {
            toastsApi.toastError('Not copied!');
          });
        };

        vm.click_row = function(e) {
          var row = angular.element(e.target.closest('.table-list-body-row'));
          row.toggleClass('active');
        };

        vm.show_hint = function(cell) {
          if (!show_prompt) {
            return;
          }

          var inner = cell ? cell.querySelector('table-list-cell') : null,
            hint = cell ? cell.querySelector('.cell-hint') : null,
            clear_hint,
            pos;

          if (!inner) {
            return;
          }

          inner.style.display = 'inline-block';

          if (inner.offsetWidth >= cell.offsetWidth - 50 && !hint) {
            hint = document.createElement('div');
            hint.classList.add('cell-hint');
            hint.innerHTML = cell.textContent;
            cell.appendChild(hint);
            cell.classList.add('hint-over');

            clear_hint = function() {
              cell.classList.remove('hint-over');
              hint.remove();
              cell.removeEventListener('mouseleave', clear_hint);
            };

            cell.addEventListener('mouseleave', clear_hint);

            pos = hint.getBoundingClientRect();

            if (pos.right >= $window.innerWidth) {
              hint.style.maxWidth = $window.innerWidth - pos.left - 15 + 'px';
              hint.style.minWidth = $window.innerWidth - pos.left - 15 + 'px';
              hint.classList.add('break');
            }
          }

          inner.style.display = 'block';
        };

        vm.resizeHandler = function() {
          vm.update_cell_width();
          vm.setTopToDuplicateHeader();
        };

        vm.hover_body = _.debounce(function(e) {
          var cell = e.target.closest('.table-list-body-cell');
          show_prompt = true;
          _.delay(vm.show_hint, 100, cell);
        }, 500);

        vm.hover_body_clear = _.debounce(function() {
          show_prompt = false;
        }, 500);

        vm.show_table = _.once(function() {
          $element.addClass('rendered');
        });

        $scope.$watch('table.list_length', function(count) {
          if (_.isNull(count)) {
            return;
          }

          vm.load_buttons =
            $scope.table.config.buttons && count ? _.after(count, vm.digest_end_callback) : angular.noop;

          if (!($scope.table.config.buttons && count) && $translate.isReady()) {
            vm.digest_end_callback();
          }
        });

        translateListener = $rootScope.$on('$translateChangeSuccess', function() {
          vm.digest_end_callback();
        });

        $window.addEventListener('resize', vm.resizeHandler);

        if ($scope.table.config.sticky) {
          mainView.addEventListener('scroll', vm.updateScroll);
        }

        tableHolder.addEventListener('scroll', vm.updateHeaderScroll);
        table_body.addEventListener('click', vm.click_row);
        table_body.addEventListener('mouseover', vm.hover_body);
        table_body.addEventListener('mouseleave', vm.hover_body_clear);

        $scope.$on('$destroy', function() {
          translateListener();
          $window.removeEventListener('resize', vm.resizeHandler);
          if ($scope.table.config.sticky) {
            mainView.removeEventListener('scroll', vm.updateScroll);
          }
          tableHolder.removeEventListener('scroll', vm.updateHeaderScroll);
          table_body.removeEventListener('click', vm.click_row);
          table_body.removeEventListener('mouseover', vm.hover_body);
          table_body.removeEventListener('mouseleave', vm.hover_body_clear);
          // card.style.paddingTop = '0px';
          card_header.classList['remove']('sticky');

          if (clipboardCells) {
            clipboardCells.destroy();
          }
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableList', tableList);

  tableList.$inject = ['$mdMedia'];

  function tableList($mdMedia) {
    return {
      restrict: 'E',
      scope: {
        table: '=',
        onRendered: '&?'
      },
      templateUrl: 'app/components/table/partials/table_list.html',
      controller: function($scope) {
        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            $scope.isGtXs = value;
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('tableHelper', tableHelper);

  tableHelper.$inject = ['$filter', '_', 'localesApi', '$interpolate', '$translate', 'defaultDateFormat', 'moment'];

  function tableHelper($filter, _, localesApi, $interpolate, $translate, defaultDateFormat, moment) {
    var tableHelper = {},
      noValue = '&ndash;',
      excludeSeparate = ['cid', 'creative_id', 'serial_id', 'merchant_id'];

    tableHelper.getColumnContent = function(item, column, searchValue, separateNumbers) {
      var interpolatedValue = item[column.name],
        value = '',
        result = '',
        opts = {};

      if (column.localizied) {
        if (column.locales.truth && item[column.name]) {
          value = column.locales.truth;
        } else if (column.locales.lie && !item[column.name]) {
          value = column.locales.lie;
        } else if (column.locales.shortcode && column.locales.shortcode_part_in_value) {
          value = $interpolate(column.locales.shortcode)({shortcode_part: item[column.name]});
        } else if (column.locales.shortcode) {
          value = column.locales.shortcode;
        } else {
          value = item[column.name];
        }

        if (column.locales.translate_key) {
          value = localesApi.get_locale(column.locales.translate_key, value);
        } else {
          value = column.locales.namespace + '.' + value;
        }

        interpolatedValue = $translate.instant(value);
      }

      opts.value =
        column.column_type === 'datetime' || column.column_type === 'date' ? item[column.name] : interpolatedValue;
      opts.type = column.column_type;
      opts.match = column.match;
      opts.name = column.name;
      opts.format = column.format || defaultDateFormat;
      opts.filterValue = column.filterValue;
      opts.insertAsText = column.insertAsText;
      opts.separateNumber = column.separateNumber;

      if (column.column_type === 'datetime') {
        result = tableHelper.determineTemplate(
          opts,
          ' - ',
          searchValue,
          _.isUndefined(opts.separateNumber) ? separateNumbers : opts.separateNumber
        );
      } else {
        result = tableHelper.determineTemplate(
          opts,
          null,
          searchValue,
          _.isUndefined(opts.separateNumber) ? separateNumbers : opts.separateNumber
        );
      }

      if (
        !opts.have_html &&
        opts.match &&
        !_.contains(['datetime', 'date'], opts.type) &&
        !(separateNumbers || opts.separateNumber) &&
        !opts.filterValue &&
        !opts.insertAsText
      ) {
        result = tableHelper.findSearchTerm(opts.value || result, searchValue);
      }

      return result;
    };

    tableHelper.determineTemplate = function(opts, separator, searchValue, separateNumbers) {
      var separ = separator || ' ',
        hasValue = _.isNumber(opts.value) || _.isBoolean(opts.value) || !_.isEmpty(opts.value),
        arr = hasValue ? opts.value.toString().split(separ) : [noValue],
        temp = '';

      if (opts.insertAsText) {
        arr = _.isEmpty(opts.value) ? ['–'] : arr;
      }

      _.each(arr, function(v, i) {
        temp += tableHelper.getTemp(v, opts, separ, i, arr.length, searchValue, separateNumbers);
      });

      return temp;
    };

    tableHelper.getTemp = function(value, opts, separator, index, arr_length, searchValue, separateNumbers) {
      var new_value = value,
        last = index < arr_length - 1;

      if ((opts.type === 'datetime' || opts.type === 'date') && !opts.insertAsText) {
        new_value = tableHelper.isValidDate(value, opts.format) ? moment(value).format(opts.format) : value;
      }

      if (_.isFunction(opts.filterValue)) {
        new_value = opts.filterValue(new_value);
      }

      if (
        (opts.type === 'integer' || opts.type === 'float') &&
        (separateNumbers || opts.separateNumber) &&
        !_.contains(excludeSeparate, opts.name) &&
        !opts.insertAsText
      ) {
        new_value = $filter('numberSeparate')($filter('number')(new_value));
      }

      if (opts.match && !opts.insertAsText) {
        new_value = tableHelper.findSearchTerm(new_value, searchValue);
      }

      if (tableHelper.isValidUrl(value) && !opts.insertAsText) {
        new_value = '<a href="' + value + '" target="_blank">' + new_value + '</a>';
        opts.have_html = true;
      } else if (tableHelper.isValidEmail(value) && !opts.insertAsText) {
        new_value = '<a href="mailto:' + value + '">' + new_value + '</a>';
        opts.have_html = true;
      }

      new_value = last ? new_value + separator : new_value;

      return new_value;
    };

    tableHelper.isValidUrl = function(url) {
      var pattern = /^(?:(?:https?|ftp|telnet):\/\/(?:[a-z0-9_-]{1,32}(?::[a-z0-9_-]{1,32})?@)?)?(?:(?:[a-z0-9-]{1,128}\.)+(?:com|net|org|mil|edu|arpa|ru|gov|biz|info|aero|inc|name|[a-z]{2})|(?!0)(?:(?!0[^.]|255)[0-9]{1,3}\.){3}(?!0|255)[0-9]{1,3})(?:\/[a-z0-9.,_@%&?+=~/-]*)?(?:#[^ '"&<>]*)?$/gi;
      return pattern.test(url);
    };

    tableHelper.isValidEmail = function(email) {
      var pattern = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/gi;
      return pattern.test(email);
    };

    tableHelper.isValidDate = function(date) {
      return date !== noValue ? moment(date).isValid() : false;
    };

    tableHelper.findSearchTerm = function(value, searchValue) {
      if (searchValue && value && value !== noValue) {
        return value
          .toString()
          .replace(
            new RegExp(tableHelper.escapeRegExp(searchValue.toString()), 'gi'),
            '<span class="highlight">$&</span>'
          );
      }
      return value;
    };

    tableHelper.escapeRegExp = function(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    return tableHelper;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableFilterCompare', tableFilterCompare);

  tableFilterCompare.$inject = ['_'];

  function tableFilterCompare(_) {
    return {
      restrict: 'E',
      scope: {
        columnData: '=',
        translateKey: '=',
        saveCallback: '&',
        allDisabled: '=?',
        clearBtn: '=?'
      },
      templateUrl: 'app/components/table/partials/compare.html',
      bindToController: true,
      controllerAs: 'CompareCtrl',
      controller: function() {
        var vm = this;

        vm.compareSeparators = [
          {
            label: '.and',
            mark: '&&'
          },
          {
            label: '.or',
            mark: '||'
          }
        ];

        vm.compareConditions = [
          {
            label: '.greater_than',
            mark: '>'
          },
          {
            label: '.less_than',
            mark: '<'
          },
          {
            label: '.greater_than_or_equal',
            mark: '>='
          },
          {
            label: '.less_than_or_equal',
            mark: '<='
          },
          {
            label: '.equal',
            mark: '='
          }
        ];

        vm.showClearCompareBtn = function(data) {
          return vm.clearBtn && data && (data.mark || _.isNumber(data.value));
        };

        vm.addSecondCondition = function() {
          vm.columnData.second_condition = {
            first: {
              mark: null,
              value: null
            },
            second: {
              mark: null,
              value: null
            }
          };
          vm.columnData.compare_separator = '&&';
        };

        vm.removeSecondCondition = function() {
          vm.columnData.second_condition = null;
          vm.columnData.compare_separator = null;
          vm.compareCallback();
        };

        vm.clearConditionPart = function(data) {
          data.mark = null;
          data.value = null;
          vm.compareCallback();
        };

        vm.compareCallback = function() {
          vm.saveCallback();
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableFilter', tableFilter);

  tableFilter.$inject = ['$interpolate', '$timeout', '$mdDialog', '$mdMedia', 'toastsApi', '_'];

  function tableFilter($interpolate, $timeout, $mdDialog, $mdMedia, toastsApi, _) {
    return {
      restrict: 'E',
      scope: {
        columns: '=',
        columnsNamespace: '=',
        getDataFunction: '&',
        saveDataFunction: '&'
      },
      templateUrl: 'app/components/table/partials/filter_template.html',
      bindToController: true,
      controllerAs: '$ctrl',
      controller: function($scope) {
        var vm = this;

        vm.currentColumn = {};
        vm.currentData = {};
        vm.templateUrl = 'app/components/table/partials/{{type}}_template.html';
        vm.compareTranslateKey = 'Reports';
        vm.allDisabled = false;
        vm.clearBtn = true;
        vm.preloader = false;

        $scope.$watch(
          function() {
            return $mdMedia('xs');
          },
          function(value) {
            vm.isXs = value;
          }
        );

        vm.getColumnDataById = _.propertyOf(vm.currentData);

        $scope.$on('filterHasBeenUpdated', function() {
          if (_.isEmpty(vm.currentColumn)) {
            return;
          }

          vm.chooseColumn(vm.currentColumn);
        });

        vm.getColumnById = function(name) {
          return _.findWhere(vm.columns, {name: name});
        };

        vm.openModal = function(ev) {
          return $mdDialog.show({
            multiple: true,
            scope: $scope,
            preserveScope: true,
            clickOutsideToClose: true,
            escapeToClose: true,
            templateUrl: 'app/components/table/partials/filter_temp_mobile.html',
            parent: angular.element(document.body),
            targetEvent: ev
          });
        };

        vm.closeMobilePopup = function() {
          $mdDialog.hide();
        };

        vm.chooseColumn = function(column, ev) {
          if (!$mdMedia('xs') && vm.currentColumn.name === column.name) {
            return;
          }
          vm.preloader = true;

          vm.getDataFunction({columnName: column.name})
            .then(
              function(response) {
                if (vm.currentColumn.type !== column.type) {
                  vm.typeTemplateUrl = $interpolate(vm.templateUrl)(column);
                }

                vm.currentColumn = column;
                vm.currentData[column.name] = response.data[column.name] || {};
                // vm.preloader = false;

                if ($mdMedia('xs')) {
                  vm.openModal(ev);
                }
              },
              function() {
                toastsApi.toastError();
              }
            )
            .finally(function() {
              vm.preloader = false;
            });
        };

        vm.getDefaultData = function(column) {
          if (column.type === 'date') {
            return {start: null, end: null};
          } else if (column.type === 'compare') {
            return {first_condition: null};
          } else if (column.type === 'checkbox') {
            return {value: 'all'};
          }
        };

        vm.setDefaultData = function(column, defaultData) {
          if (column.type === 'date') {
            vm.currentData[column.name] = defaultData;
          } else if (column.type === 'compare') {
            vm.currentData[column.name] = defaultData;
          } else if (column.type === 'checkbox') {
            vm.currentData[column.name] = _.map(vm.getColumnDataById(column.name), function(v) {
              v.check = false;
              return v;
            });
          }
        };

        vm.clearData = function(column, ev) {
          ev.stopPropagation();

          var saveData = {},
            promise;

          saveData.columnName = column.name;
          saveData.params = vm.getDefaultData(column);
          saveData.direction = column.type !== 'checkbox';

          promise = vm.saveDataFunction({data: saveData});

          promise.then(function() {
            vm.setDefaultData(column, saveData.params);
            column.empty = true;
          });

          return promise;
        };

        vm.showClearCompareBtn = function(data) {
          return vm.clearBtn && data && (data.mark || _.isNumber(data.value));
        };

        vm.checkDateEmpty = function(columnName) {
          $timeout(function() {
            var column = vm.getColumnById(columnName),
              data = vm.getColumnDataById(columnName);

            column.empty = !data.start && !data.end;
          }, 0);
        };

        vm.checkCheckboxEmpty = function(columnName) {
          $timeout(function() {
            var column = vm.getColumnById(columnName),
              data = vm.getColumnDataById(columnName);

            column.empty = !_.some(_.pluck(data, 'check'));
          }, 0);
        };

        vm.checkCompareData = function(data, result) {
          var _result = result || [];

          _.each(data, function(v) {
            if (_.isObject(v)) {
              if (_.isEmpty(v)) {
                _result.push(false);
              } else {
                vm.checkCompareData(v, _result);
              }
            } else {
              _result.push(!_.isNull(v));
            }
          });

          return _result;
        };

        vm.checkCompareEmpty = function(columnName) {
          var column = vm.getColumnById(columnName),
            data = vm.getColumnDataById(columnName);

          column.empty = !_.some(vm.checkCompareData(data));
        };

        vm.getCheckboxData = function(data, tabId, direction, search_term) {
          var saveData = {
            columnName: vm.currentColumn.name,
            direction: direction,
            params: {}
          };

          if (_.isObject(data)) {
            saveData.params = data;
          } else {
            if (search_term && data === 'all') {
              saveData.params.search = search_term;
              saveData.params.value = data;
            } else {
              saveData.params.value = data;
            }
          }

          return saveData;
        };

        vm.checkboxCallback = function(data, tabId, direction, search_term) {
          var saveData = vm.getCheckboxData(data, tabId, direction, search_term),
            promise;

          promise = vm.saveDataFunction({data: saveData});

          promise.then(
            function() {
              vm.checkCheckboxEmpty(saveData.columnName);
            },
            function() {
              vm.checkCheckboxEmpty(saveData.columnName);
            }
          );

          return promise;
        };

        vm.dateCallback = function(data) {
          var saveData = {
              columnName: vm.currentColumn.name,
              params: data,
              direction: true
            },
            promise;

          promise = vm.saveDataFunction({data: saveData});

          promise.then(
            function() {
              vm.checkDateEmpty(saveData.columnName);
            },
            function() {
              vm.checkDateEmpty(saveData.columnName);
            }
          );

          return promise;
        };

        vm.compareCallback = function() {
          var saveData = {
              columnName: vm.currentColumn.name,
              params: vm.getColumnDataById(vm.currentColumn.name),
              direction: true
            },
            promise;

          promise = vm.saveDataFunction({data: saveData});

          promise.then(
            function() {
              vm.checkCompareEmpty(saveData.columnName);
            },
            function() {
              vm.checkCompareEmpty(saveData.columnName);
            }
          );

          return promise;
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('TableFilterController', TableFilterController);

  TableFilterController.$inject = ['$scope', '$mdDialog', 'tableFilterApi', 'toastsApi', 'User', '_'];

  function TableFilterController($scope, $mdDialog, tableFilterApi, toastsApi, User, _) {
    var vm = this;

    vm.translate_key = 'MainTable';
    vm.namespace = User.getUserProperty('namespace');
    vm.filtersList = [];
    vm.filterName = vm.table.getFilterName();
    vm.startFilterId = vm.table.getFilterId();
    vm.pathForFilter = vm.table.getPathForFilter();
    vm.actionForFilter = vm.table.getActionForFilter();
    vm.byMerchant = vm.table.getByMerchant();
    vm.currentFilterId = null;

    vm.hide = function() {
      $mdDialog.hide();
    };

    vm.applyFilter = function() {
      vm.table.applyFilter().then(vm.hide, vm.hide);
    };

    vm.cancelFilter = function() {
      vm.table.cancelFilter().then(vm.hide, vm.hide);
    };

    vm.isActivatedFilter = function(filterId) {
      return filterId === vm.table.getSegmentId();
    };

    vm.getCurrentFilterId = function(list, condition, filterId) {
      if (condition === 'first') {
        return _.first(list);
      } else if (condition === 'last') {
        return _.last(list);
      } else {
        return filterId;
      }
    };

    vm.changeFilterCallback = function(data, condition, filterId) {
      vm.filtersList = data.filter_set_ids;

      vm.currentFilterId = vm.getCurrentFilterId(vm.filtersList, condition, filterId);

      vm.table.setFilterId(vm.currentFilterId);
      vm.table.updateFilterColumns(data.allowed_filter_segments, data.upload_filter_segments);

      $scope.$broadcast('filterHasBeenUpdated');
    };

    vm.selectFilter = function(filterId) {
      if (vm.currentFilterId === filterId) {
        return;
      }

      vm.getFilter(vm.namespace, vm.filterName, filterId).then(
        function(response) {
          vm.changeFilterCallback(response.data, null, filterId);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.initFilter = function() {
      vm.getFilter(vm.namespace, vm.filterName, null).then(
        function(response) {
          vm.changeFilterCallback(response.data, 'first');
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.addNewFilter = function() {
      vm.getFilter(vm.namespace, vm.filterName, 'new').then(
        function(response) {
          vm.changeFilterCallback(response.data, 'last');
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getFilter = function(namespace, filterName, filterId) {
      return tableFilterApi.getTableFilter(
        namespace,
        filterName,
        filterId,
        vm.pathForFilter,
        vm.actionForFilter,
        vm.byMerchant
      );
    };

    vm.saveColumnData = function(data) {
      var saveData = {};

      saveData.filterId = vm.currentFilterId;
      saveData.filterName = vm.filterName;
      saveData.namespace = vm.namespace;
      saveData.columnName = data.columnName;
      saveData.params = data.params;
      saveData.direction = data.direction;
      saveData.pathForFilter = vm.pathForFilter;
      saveData.actionForFilter = vm.actionForFilter;
      saveData.byMerchant = vm.byMerchant;

      return tableFilterApi.saveTableColumnData(saveData);
    };

    vm.getColumnData = function(columnName) {
      var saveData = {};

      saveData.filterId = vm.currentFilterId;
      saveData.filterName = vm.filterName;
      saveData.namespace = vm.namespace;
      saveData.columnName = columnName;
      saveData.pathForFilter = vm.pathForFilter;
      saveData.actionForFilter = vm.actionForFilter;
      saveData.byMerchant = vm.byMerchant;

      return tableFilterApi.getTableColumnData(saveData);
    };

    if (vm.startFilterId) {
      vm.selectFilter(vm.startFilterId);
    } else {
      vm.initFilter();
    }
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableListCell', tableListCell);

  tableListCell.$inject = ['$rootScope', '_'];

  function tableListCell($rootScope, _) {
    return {
      restrict: 'E',
      require: ['?^tableListDesktop', '?^tableListMobile'],
      scope: {
        item: '=',
        column: '='
      },
      link: function(scope, element, attr, tableCtrls) {
        var determineContent = _.propertyOf(_.first(_.compact(tableCtrls)))('determine_content'),
          listener;

        if (_.contains(['date', 'datetime'], scope.column.column_type) || scope.column.localizied) {
          listener = $rootScope.$on('$translateChangeSuccess', function() {
            element[0].innerHTML = determineContent ? determineContent(scope.item, scope.column) : '';
          });

          scope.$on('$destroy', listener);
        }

        if (scope.column.insertAsText) {
          element[0].textContent = determineContent ? determineContent(scope.item, scope.column) : '';
        } else {
          element[0].innerHTML = determineContent ? determineContent(scope.item, scope.column) : '';
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('tableFilterApi', tableFilterApi);

  tableFilterApi.$inject = ['mainApi'];

  function tableFilterApi(mainApi) {
    var FilterApi = {};

    FilterApi.getTableFilter = function(namespace, filterName, filterId, pathForFilter, actionForFilter, byMerchant) {
      var url = namespace + '/filter_sets/' + filterName + '/list_or_create',
        params = {
          path_for_filter: pathForFilter,
          action_for_filter: actionForFilter,
          by_merchant: byMerchant
        };

      if (filterId) {
        params.filter_set_id = filterId;
      }

      return mainApi.post(url, params);
    };

    FilterApi.getTableColumnData = function(data) {
      var url = data.namespace + '/filter_sets/' + data.filterId + '/filter_segments/' + data.columnName,
        params = {
          path_for_filter: data.pathForFilter,
          action_for_filter: data.actionForFilter,
          by_merchant: data.byMerchant
        };

      return mainApi.get(url, params);
    };

    FilterApi.saveTableColumnData = function(data) {
      var url =
          data.namespace +
          '/filter_sets/' +
          data.filterId +
          '/filter_segments/' +
          data.columnName +
          '/' +
          (data.direction ? 'add' : 'remove'),
        params = {
          path_for_filter: data.pathForFilter,
          action_for_filter: data.actionForFilter,
          by_merchant: data.byMerchant,
          filter_segment: {
            data: data.params
          }
        };

      return mainApi.put(url, params);
    };

    return FilterApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tableActions', tableActions);

  tableActions.$inject = [];

  function tableActions() {
    return {
      restrict: 'E',
      scope: {
        table: '='
      },
      templateUrl: 'app/components/table/partials/table_actions.html'
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('renderListItem', renderListItem);

  renderListItem.$inject = [];

  function renderListItem() {
    return {
      restrict: 'A',
      require: '?^tableListDesktop',
      link: function(scope, element, attr, tableCtrl) {
        if (scope.$last && tableCtrl) {
          tableCtrl.render_item();
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('noTableData', noTableData);

  noTableData.$inject = [];

  function noTableData() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/table/partials/no_data.html'
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        table: [
          {
            pagination: ['from||main_table.pagination.from'],
            search: ['placeholder||main_table.search.placeholder'],
            filter: [
              'title||main_table.filter.title',
              'no_name||main_table.filter.no_name',
              'add_new_filter||main_table.filter.add_new_filter',
              'cancel_filter||main_table.filter.cancel_filter',
              'apply_filter||main_table.filter.apply_filter'
            ]
          },
          'no_data||main_table.no_data'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('MainTable', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tabsContent', tabsContent);

  tabsContent.$inject = ['tabsApi'];

  function tabsContent(tabsApi) {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: 'app/components/tabs/partials/tabs_content.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope, $element, $attrs) {
        var vm = this,
          listener;

        vm.viewName = $attrs.viewName || '';

        listener = $scope.$watch(
          function() {
            return tabsApi.getTabsByName($attrs.tabsName);
          },
          function(value) {
            if (value) {
              listener();

              vm.tabs = value;
            }
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('tabsApi', tabsApi);

  tabsApi.$inject = ['_'];

  function tabsApi(_) {
    var tabsApi = {},
      tabsStorage = {},
      options = {
        name: '',
        translateKey: '',
        defaultActiveTabName: '',
        nav: true,
        redirectTo: '^'
      };

    function Tabs(list, config) {
      this.list = list;
      this.config = config;
      this.activeTab = {};

      if (!config.nav) {
        this.config.defaultActiveTabName = config.defaultActiveTabName || _.propertyOf(_.first(this.list))('name');
      }
    }

    Tabs.prototype.setActiveTab = function(tab) {
      this.activeTab = tab;
    };

    Tabs.prototype.findTabByCondition = function(predicate) {
      if (!_.isFunction(predicate)) {
        return;
      }

      return _.find(this.list, predicate);
    };

    Tabs.prototype.setTabSubmitFunction = function(tabName, fn) {
      var tab = this.findTabByCondition(function(tab) {
        return tab.name === tabName;
      });

      if (tab) {
        tab.submitFn = fn;
      }
    };

    Tabs.prototype.setTabAdditionalData = function(tabName, data) {
      var tab = this.findTabByCondition(function(tab) {
        return tab.name === tabName;
      });

      if (tab) {
        tab.data = angular.merge(tab.data || {}, data || {});
      }
    };

    Tabs.prototype.setUpTable = function(tabName, table) {
      var tab = this.findTabByCondition(function(tab) {
        return tab.name === tabName;
      });

      if (tab) {
        tab.table = table;
      }
    };

    Tabs.prototype.resetFilterForAllTables = function() {
      _.each(this.list, function(tab) {
        if (tab.table && tab.table.resetFilter) {
          tab.table.resetFilter();
        }
      });
    };

    Tabs.prototype.disableTabControl = function(tabName, value) {
      var tab = this.findTabByCondition(function(tab) {
        return tab.name === tabName;
      });

      if (tab) {
        tab.disabled = value;
      }
    };

    Tabs.prototype.hideTabControl = function(tabName, value) {
      var tab = this.findTabByCondition(function(tab) {
        return tab.name === tabName;
      });

      if (tab) {
        tab.hide = value;
      }
    };

    Tabs.prototype.disableTab = function(tabName) {
      this.disableTabControl(tabName, true);
    };

    Tabs.prototype.enableTab = function(tabName) {
      this.disableTabControl(tabName, false);
    };

    Tabs.prototype.showTab = function(tabName) {
      this.hideTabControl(tabName, false);
    };

    Tabs.prototype.hideTab = function(tabName) {
      this.hideTabControl(tabName, true);
    };

    Tabs.prototype.destroy = function() {
      delete tabsStorage[this.config.name];
    };

    tabsApi.createTabs = function(config) {
      return new Tabs(config.list, angular.merge({}, options, _.omit(config, 'list')));
    };

    tabsApi.getTabsByName = function(name) {
      return tabsStorage[name];
    };

    tabsApi.init = function(config) {
      tabsStorage[config.name] = tabsApi.createTabs(config);

      return this.getTabsByName(config.name);
    };

    return tabsApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('tabsList', tabsList);

  tabsList.$inject = ['$state', '$mdMedia', 'tabsApi', '_'];

  function tabsList($state, $mdMedia, tabsApi, _) {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: 'app/components/tabs/partials/tabs_list.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope, $element, $attrs) {
        var vm = this,
          listener;

        vm.tabs = null;
        vm.centerMobileTabs = _.isEmpty($attrs.mobileCenterTabs) ? false : $attrs.mobileCenterTabs;
        vm.stretchMobileTabs = _.isEmpty($attrs.mobileStretchTabs) ? 'never' : $attrs.mobileStretchTabs;

        vm.changeTabCallback = function(tab) {
          if (_.isFunction(vm.tabs.config.changeTabCallback)) {
            vm.tabs.config.changeTabCallback(tab);
          }
        };

        vm.applyChooseTab = function(tab) {
          if (!tab || tab.name === vm.tabs.activeTab.name) {
            return;
          }

          vm.tabs.setActiveTab(tab);
          vm.changeTabCallback(tab);
        };

        vm.forceChangeTab = function(ev, data) {
          var tab = vm.tabs.findTabByCondition(function(tab) {
            return tab.name === data.name;
          });

          vm.chooseTab(tab);
        };

        vm.chooseTab = function(tab, ev) {
          if (!tab || tab.disabled || tab.hide || tab.name === vm.tabs.activeTab.name) {
            if (ev && ev.preventDefault) {
              ev.preventDefault();
            }
            return false;
          }

          if (vm.tabs.config.nav) {
            $state.go(tab.state, tab.stateParams || {}).then(function() {
              vm.applyChooseTab(tab);
            });
          } else {
            vm.applyChooseTab(tab);
          }
        };

        vm.setOtherActiveTab = function() {
          var tab = vm.tabs.findTabByCondition(function(tab) {
            return !tab.disabled && !tab.hide;
          });

          if (tab) {
            vm.chooseTab(tab);
          } else {
            if (vm.tabs.config.nav) {
              $state.go(vm.tabs.config.redirectTo);
            }
          }
        };

        vm.setUpActiveTab = function() {
          var tab = vm.tabs.findTabByCondition(function(tab) {
            return vm.tabs.config.nav ? $state.includes(tab.state) : vm.tabs.config.defaultActiveTabName === tab.name;
          });

          if (!tab) {
            return;
          }

          if (tab.disabled || tab.hide) {
            vm.setOtherActiveTab();
          } else {
            vm.applyChooseTab(tab);
          }
        };

        vm.preventChangingState = function(ev, toState) {
          var tab = vm.tabs.findTabByCondition(function(tab) {
            return toState.name === tab.state;
          });

          if (tab && (tab.disabled || tab.hide)) {
            ev.preventDefault();
            return false;
          }
        };

        vm.changeStateCallback = function() {
          var tab = vm.tabs.findTabByCondition(function(tab) {
            return $state.includes(tab.state);
          });

          vm.applyChooseTab(tab);
        };

        vm.setUpWatcher = function() {
          $scope.$watch(
            function() {
              return vm.tabs.activeTab.hide || vm.tabs.activeTab.disabled;
            },
            function(value) {
              if (!_.isEmpty(vm.tabs.activeTab) && value) {
                vm.setUpActiveTab();
              }
            }
          );
        };

        vm.setUpListeners = function() {
          $scope.$on('$stateChangeStart', vm.preventChangingState);
          $scope.$on('$stateChangeSuccess', vm.changeStateCallback);
        };

        vm.init = function(value) {
          vm.tabs = value;

          if (vm.tabs.config.nav) {
            vm.setUpListeners();
          }

          vm.setUpWatcher();

          if (_.isEmpty(vm.tabs.activeTab)) {
            vm.setUpActiveTab();
          }
        };

        listener = $scope.$watch(
          function() {
            return tabsApi.getTabsByName($attrs.tabsName);
          },
          function(value) {
            if (!_.isEmpty(value)) {
              listener();
              vm.init(value);
            }
          }
        );

        $scope.$on('$changeTab', vm.forceChangeTab);

        $scope.$watch(
          function() {
            return $mdMedia('gt-sm');
          },
          function(value) {
            vm.isGtSm = value;
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('sidenav', sidenav);

  sidenav.$inject = ['$mdMedia', 'ComponentRegistry', 'themeColors'];

  function sidenav($mdMedia, ComponentRegistry, themeColors) {
    return {
      restrict: 'E',
      scope: {},
      bindToController: true,
      controllerAs: '$ctrl',
      templateUrl: 'app/components/sidenav/sidenav.html',
      controller: function($scope) {
        var vm = this;

        vm.sidenavName = 'navigation';
        vm.mdSidenav = null;

        ComponentRegistry.getComponent(vm.sidenavName).then(function(mdSidenav) {
          vm.mdSidenav = mdSidenav;
        });

        $scope.$on('$stateChangeSuccess', function() {
          if (vm.mdSidenav && vm.mdSidenav.isOpen()) {
            vm.mdSidenav.close();
          }
        });

        $scope.$watch(
          function() {
            return $mdMedia('gt-sm');
          },
          function(value) {
            vm.isGtSm = value;
          }
        );

        $scope.$watch(
          function() {
            return themeColors.getHeaderColor();
          },
          function(value) {
            $scope.toolbarBg = value;
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('statsBlock', statsBlock);

  statsBlock.$inject = ['$interpolate', '$mdMedia', '$mdDialog', '_', 'moment', '$timeout'];

  function statsBlock($interpolate, $mdMedia, $mdDialog, _, moment, $timeout) {
    return {
      restrict: 'E',
      scope: {
        list: '=',
        statsData: '=?statsData',
        templateUrl: '@',
        callback: '&',
        allDisabled: '=?',
        translateKey: '='
      },
      templateUrl: 'app/components/reports/partials/stats_block.html',
      controllerAs: 'stats',
      controller: function($scope) {
        var vm = this;

        vm.all_stats_list = $scope.list;
        vm.current_column = {};
        vm.template_url = $scope.templateUrl;
        $scope.statsData = $scope.statsData || {};

        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            vm.isGtXs = value;
          }
        );

        if ($scope.callback) {
          vm.callback = function(data, tabId, direction, search_term) {
            var fn = $scope.callback(),
              _tabId = tabId,
              deferred;

            if (!_tabId) {
              _tabId = vm.current_column.id;
            }

            deferred = fn(data, _tabId, direction, search_term);

            deferred.then(function() {
              $timeout(function() {
                vm.check_column(vm.current_column);
              }, 0);
            });

            return deferred;
          };
        }

        vm.closeMobilePopup = function() {
          $mdDialog.hide();
        };

        vm.openModal = function(ev) {
          return $mdDialog.show({
            // multiple: true,
            scope: $scope,
            preserveScope: true,
            clickOutsideToClose: true,
            escapeToClose: true,
            templateUrl: 'app/components/reports/partials/stats_block_mobile.html',
            parent: angular.element(document.body),
            targetEvent: ev
          });
        };

        vm.choose_column = function(column, ev) {
          // if (vm.current_column.type !== column.type) {
          vm.type_template_url = $interpolate(vm.template_url)(column);
          // }

          vm.current_column = column;
          vm.srtingToDate();

          if ($mdMedia('xs')) {
            vm.openModal(ev);
          }
        };

        vm.clear = function(column, ev) {
          if ($scope.allDisabled) {
            return;
          }

          ev.stopPropagation();

          if ($scope.callback) {
            var data = null,
              direction = true;

            if (column.type === 'date') {
              data = {start: null, end: null};
            } else if (column.type === 'compare') {
              data = {
                first_condition: {
                  first: {mark: null, value: null},
                  second: {mark: null, value: null}
                }
              };
            } else if (column.type === 'checkbox') {
              data = 'all';
              direction = false;
            }

            vm.callback(data, column.id, direction, '').then(function() {
              if (column.type === 'checkbox') {
                $scope.statsData[column.id] = _.map($scope.statsData[column.id], function(v) {
                  v.check = false;
                  return v;
                });
              } else {
                $scope.statsData[column.id] = data;
              }
              vm.check_column(column);
            });
          }
        };

        vm.check_column = function(column) {
          var data = $scope.statsData[column.id],
            result = vm.check_column_data(data);

          column.empty = !_.some(result);
        };

        vm.check_column_data = function(data, result) {
          var _result = result || [];

          if (_.isArray(data)) {
            _result.push(_.findWhere(data, {check: true}));
          } else {
            _.each(data, function(v) {
              if (_.isObject(v) && !_.isDate(v)) {
                if (_.isEmpty(v)) {
                  _result.push(false);
                } else {
                  vm.check_column_data(v, _result);
                }
              } else {
                _result.push(v);
              }
            });
          }

          return _result;
        };

        vm.srtingToDate = function() {
          _.each($scope.statsData, function(v, k) {
            var column = _.findWhere(vm.all_stats_list, {id: parseInt(k)});

            if (column && column.type === 'date') {
              if (!v) {
                $scope.statsData[k] = {start: null, end: null};
              } else {
                v.start = v.start && v.start !== 'Invalid date' ? moment(v.start)._d : null;
                v.end = v.end && v.end !== 'Invalid date' ? moment(v.end)._d : null;
              }
            }
            if (column && column.type === 'compare') {
              if (!v) {
                $scope.statsData[k] = {
                  first_condition: {
                    first: {
                      mark: null,
                      value: null
                    },
                    second: {
                      mark: null,
                      value: null
                    }
                  }
                };
              }
            }

            vm.check_column(column);
          });
        };

        $scope.$watch('statsData', function() {
          vm.srtingToDate();
        });

        // if (vm.all_stats_list);
        // vm.choose_column(vm.all_stats_list[0]);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('ReportsController', ReportsController);

  ReportsController.$inject = [
    '$scope',
    '$state',
    '$timeout',
    'tableEngine',
    '_',
    '$mdDialog',
    '$mdMedia',
    '$q',
    '$mdTranslate',
    'outputErrors',
    '$injector',
    'permissionsManager',
    'uploadFile',
    'toastsApi',
    'downloadReport'
  ];

  function ReportsController(
    $scope,
    $state,
    $timeout,
    tableEngine,
    _,
    $mdDialog,
    $mdMedia,
    $q,
    $mdTranslate,
    outputErrors,
    $injector,
    permissionsManager,
    uploadFile,
    toastsApi,
    downloadReport
  ) {
    var vm = this,
      segments_key = 'segments',
      structures_key = 'structures',
      current_data = $state.current.data,
      report_api = $injector.get(current_data.report_api);

    vm.translate_key = current_data.translate_key;
    vm.namespace = current_data.namespace;
    vm.errors = outputErrors.createNew();
    vm.permissions = {};
    vm.columns = [];
    vm.group_by = [];
    // Max selectable date range for report export. Raised from 1 year to allow
    // All-time pulls (data goes back to 2019) so teams no longer stitch yearly
    // exports by hand. Backend already accepts any period:{start,end}.
    vm.datepicker_range_period = {years: 20};
    vm.structuresExist = !_.isEmpty(current_data.structure_tabs);
    vm.tableRenderedDeffer = null;

    vm.permissions.generate = 'api2.' + vm.namespace + '.' + current_data.permission_ctrl_name + '.generate_report';
    vm.permissions.download = 'api2.' + vm.namespace + '.' + current_data.permission_ctrl_name + '.download_report';
    vm.permissions.stucture_states =
      'api2.' + vm.namespace + '.' + current_data.permission_ctrl_name + '.stucture_states';

    report_api.namespace = vm.namespace;

    vm.group_by_map = current_data.group_by_map || {};

    report_api.report_params().then(
      function(response) {
        var data = response.data,
          group_by = data.group_by;

        vm.downloadFormats = data.separators_for_format;

        _.each(group_by, function(value, key) {
          vm.group_by.push({
            key: key,
            value: value,
            locale: vm.group_by_map[key].locale,
            model: vm.group_by_map[key].model,
            order: vm.group_by_map[key].order,
            item_locale: vm.group_by_map[key].item_locale
          });
        });
      },
      function() {
        vm.errorHandler();
      }
    );

    // Periods
    vm.periods = [
      {
        type: 'today',
        shortcode: 'date_range.today'
      },
      {
        type: 'yesterday',
        shortcode: 'date_range.yesterday'
      },
      {
        type: 'last_7_days',
        shortcode: 'date_range.last_7_days'
      },
      {
        type: 'week',
        shortcode: 'date_range.week'
      },
      {
        type: 'last_week',
        shortcode: 'date_range.last_week'
      },
      {
        type: 'month',
        shortcode: 'date_range.month'
      },
      {
        type: 'last_month',
        shortcode: 'date_range.last_month'
      },
      {
        type: 'year',
        shortcode: 'date_range.year'
      }
    ];

    vm.tableRenderedCallback = function() {
      vm.tableRenderedDeffer && vm.tableRenderedDeffer.resolve();
    };

    vm.generate_report = function() {
      vm.report_information.segment_id = vm.segments.current_temp.id;

      if (vm.structuresExist) {
        vm.report_information.structure_id = vm.structures.current_temp.id;
      }

      vm.table.clearParams();
      vm.tableRenderedDeffer = $q.defer();

      return report_api.get_information(vm.report_information, 1).then(function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.updateTotalColumns(data.sum_columns);
        vm.table.updateAdditionalOptions(vm.report_information);
        vm.tableRenderedDeffer.promise.then(function() {
          vm.scrollToTable();
        });
      }, vm.errorHandler);
    };

    vm.scrollToTable = function() {
      if ($mdMedia('gt-xs')) {
        return;
      }

      $timeout(function() {
        var card = document.querySelector('#report-table-card');

        if (card) {
          card.scrollIntoView({behavior: 'smooth'});
        }
      }, 100);
    };

    vm.applyDownloadReport = function(data) {
      _.extend(vm.report_information, data);

      return report_api.download_report(vm.report_information);
    };

    vm.downloadReport = function(ev) {
      vm.report_information.segment_id = vm.segments.current_temp.id;

      if (vm.structuresExist) {
        vm.report_information.structure_id = vm.structures.current_temp.id;
      }

      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.errorHandler = function() {
      return toastsApi.toastError();
    };

    vm.initSegments = function(segmentsList, tabsList) {
      var list = _.each(segmentsList || [], function(e) {
          e.read_only = _.isUndefined(e.read_only) ? false : e.read_only;
          e.show = false;
        }),
        tabs_list = tabsList || [],
        all_tabs = vm.segment_tabs.concat(vm.all_stats_list),
        default_template;

      _.each(all_tabs, function(tab) {
        tab.display = _.contains(tabs_list, tab.id);
      });

      vm.segments = new Segments(list, vm.segment_tabs);

      default_template = {
        id: 0,
        name: segments_key + '.all_players',
        show: false,
        read_only: true
      };
      vm.segments.templates.push(default_template);
      vm.segments.choose_template(default_template);
    };

    vm.initStructures = function(structuresList, tabsList, localeKey) {
      var list = _.each(structuresList || [], function(e) {
          e.read_only = _.isUndefined(e.read_only) ? false : e.read_only;
          e.show = false;
        }),
        tabs_list = tabsList || [],
        all_tabs = vm.structure_tabs,
        default_template;

      _.each(all_tabs, function(tab) {
        tab.display = _.contains(tabs_list, tab.id);
      });

      vm.structures = new Structures(list, vm.structure_tabs);
      vm.columns_namespace = localeKey + '.';

      default_template = {
        id: 0,
        name: structures_key + '.all_columns',
        show: false,
        read_only: true
      };
      vm.structures.templates.push(default_template);
      vm.structures.choose_template(default_template);
    };

    vm.refreshPage = function() {
      $state.go('.', null, {reload: true});
    };

    // Stats
    vm.all_stats_list = current_data.all_stats_list || [];

    // Segments list
    vm.segment_tabs =
      _.each(current_data.segment_tabs, function(e) {
        if (angular.isString(e.all_stats_key)) {
          e.all_stats_list = vm[e.all_stats_key];
        }
      }) || [];

    // structure tabs
    vm.structure_tabs = current_data.structure_tabs || [];

    function ReportTemplate(templatesArray, tabsArray) {
      this.current_temp = {};
      this.current_tab = {};
      this.templates = templatesArray || [];
      this.tabs = tabsArray || [];
      this.preloader = false;
      this.all_disabled = false;
      this.showAll = false;
    }

    ReportTemplate.prototype.choose_template = function(temp) {
      this.current_temp = temp;
      this.get_tab_data();
    };

    ReportTemplate.prototype.add_template = function() {
      var _this = this;

      return report_api.create_template(_this.save_key).then(function(response) {
        var data = response.data,
          temp = {};

        if (_this.save_key === segments_key) {
          temp = data.segment;
        } else if (_this.save_key === structures_key) {
          temp = data.structure;
        }

        if (_.isUndefined(temp.read_only)) {
          temp.read_only = false;
        }

        temp.show = _this.showAll;

        _this.templates.push(temp);
        _this.choose_template(temp);
      }, vm.errorHandler);
    };

    ReportTemplate.prototype.remove_template = function(temp, ev) {
      if (ev) {
        ev.stopPropagation();
      }

      var _this = this,
        confirm = $mdDialog
          .confirm()
          .title($mdTranslate.instant(vm.translate_key, 'remove_window.title'))
          .textContent($mdTranslate.instant(vm.translate_key, 'remove_window.question', {name: temp.name, id: temp.id}))
          .targetEvent(ev)
          .ok($mdTranslate.instant(vm.translate_key, 'remove_window.yes'))
          .cancel($mdTranslate.instant(vm.translate_key, 'remove_window.no'));

      $mdDialog.show(confirm).then(function() {
        report_api.delete_template(_this.save_key, temp.id).then(function() {
          _this.templates = _.reject(_this.templates, {id: temp.id});
          if (temp.id === _this.current_temp.id) {
            var default_temp = _.findWhere(_this.templates, {id: 0});
            _this.choose_template(default_temp);
          }
        }, vm.errorHandler);
      });
    };

    ReportTemplate.prototype.save_tab_data = function(data, tabId, direction, search_term) {
      var _this = this,
        params = {},
        _tabId = tabId || _this.current_tab.id,
        deferred = $q.defer();

      if (_.isObject(data)) {
        params = data;
      } else {
        if (search_term && data === 'all') {
          params.search = search_term;
          params.value = data;
        } else {
          params.value = data;
        }
      }

      if (_this.current_temp.read_only) {
        deferred.reject();
      } else {
        report_api.add_tab_data(_this.save_key, _this.current_temp.id, _tabId, params, direction).then(
          function() {
            deferred.resolve();
          },
          function() {
            deferred.reject();
            vm.errorHandler();
          }
        );
      }

      return deferred.promise;
    };

    ReportTemplate.prototype.choose_tab = function(tab) {
      this.current_tab = tab;
      this.get_tab_data();
    };

    ReportTemplate.prototype.toggle_constructor = function(temp) {
      temp.show = !temp.show;
    };

    ReportTemplate.prototype.toggleAllConstructors = function() {
      var _this = this;

      _this.showAll = !_this.showAll;

      _.each(_this.templates, function(temp) {
        temp.show = _this.showAll;
      });
    };

    ReportTemplate.prototype.get_tab_data = function() {
      var _this = this;

      if (!(_this.current_temp && _this.current_temp.id) || !(_this.current_tab && _this.current_tab.id)) {
        return;
      }

      if (!_this.current_temp.template_data) {
        _this.current_temp.template_data = {};
      }

      _this.preloader = true;
      _this.all_disabled = true;

      report_api.get_tab_data(_this.save_key, _this.current_temp.id, _this.current_tab.id).then(
        function(response) {
          _this.current_temp.template_data[_this.current_tab.id] = response.data;
          $timeout(function() {
            _this.preloader = false;
            _this.all_disabled = false;
          }, 0);
        },
        function() {
          vm.errorHandler().then(function() {
            _this.preloader = false;
            _this.all_disabled = false;
          });
        }
      );
    };

    ReportTemplate.prototype.change_template_name = function() {
      var _this = this,
        params = {};

      if (_this.current_temp.read_only) {
        return;
      }

      if (_this.save_key === segments_key) {
        params.report_segment = {name: _this.current_temp.name};
      } else if (_this.save_key === structures_key) {
        params.report_structure = {name: _this.current_temp.name};
      }

      report_api.update_template(_this.save_key, _this.current_temp.id, params).then(angular.noop, vm.errorHandler);
    };

    function Segments() {
      ReportTemplate.apply(this, arguments);

      this.save_key = segments_key;
    }

    Segments.prototype = Object.create(ReportTemplate.prototype);
    Segments.prototype.constructor = Segments;

    Segments.prototype.import_from_csv = function(ev) {
      var _this = this;

      if (!_this.current_tab.upload_from_file) {
        return;
      }

      uploadFile
        .openDialog({
          targetEvent: ev,
          locals: {
            // file_formats: _this.current_tab.upload_params.file_formats,
            format_for_locale: 'csv',
            upload_params: {
              url:
                vm.namespace +
                '/reports/segments/' +
                _this.current_temp.id +
                '/tabs/' +
                _this.current_tab.id +
                '/' +
                _this.current_tab.upload_params.url,
              method: 'PUT'
            }
          }
        })
        .then(function() {
          _this.get_tab_data();
        }, _.noop);
    };

    function Structures() {
      ReportTemplate.apply(this, arguments);

      this.save_key = structures_key;
      this.is_permit = permissionsManager.checkPermission(vm.permissions.stucture_states);
    }

    Structures.prototype = Object.create(ReportTemplate.prototype);
    Structures.prototype.constructor = Structures;

    Structures.prototype.change_aasm_state = function() {
      var _this = this,
        params = {};

      if (_this.current_temp.read_only) {
        return;
      }

      params.report_structure = {aasm_state: _this.current_temp.aasm_state};

      report_api.update_template(_this.save_key, _this.current_temp.id, params).then(angular.noop, vm.errorHandler);
    };

    if (permissionsManager.checkPermission(vm.permissions.stucture_states) && vm.structuresExist) {
      report_api.get_aasm_states().then(
        function(response) {
          vm.aasm_states_list = response.data.stucture_states;
        },
        function() {
          vm.errorHandler();
        }
      );
    }

    report_api.templates_list(segments_key).then(
      function(response) {
        var data = response.data || {};

        vm.initSegments(data.list, data.tabs_list);
      },
      function(response) {
        var data = response.data || {};

        vm.segmentsOrStructuresNotLoaded = true;

        vm.initSegments(data.list, data.tabs_list);
        vm.errorHandler();
      }
    );

    if (vm.structuresExist) {
      report_api.templates_list(structures_key).then(
        function(response) {
          var data = response.data || {};

          vm.initStructures(data.list, data.tabs_list, data.locale_key);
        },
        function(response) {
          var data = response.data || {};

          vm.segmentsOrStructuresNotLoaded = true;

          vm.initStructures(data.list, data.tabs_list, data.locale_key);
          vm.errorHandler();
        }
      );
    }

    vm.table = tableEngine.init({
      api: report_api,
      name: current_data.report_api + '_reports_' + vm.namespace,
      separate_numbers: true,
      mobile: {
        defaultColumns: ['transaction_date_for_reports'],
        collapseAll: true
      },
      total: {
        translate_key: vm.translate_key,
        shortcode: 'result.total',
        data: {}
      }
    });

    // Main report information
    vm.report_information = {
      period: {
        start: null,
        end: null
      },
      group_by_date: 'group_by_alltime',
      group_by_affiliate_params: 'group_by_merchant',
      group_by_player_params: 'all_players',
      per_page: 10
    };

    $scope.$on('changePeriod', function(ev, data) {
      vm.report_information.period.start = data.start;
      vm.report_information.period.end = data.end;
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('reportsTemplate', reportsTemplate);

  reportsTemplate.$inject = ['$mdMedia'];

  function reportsTemplate($mdMedia) {
    return {
      restrict: 'E',
      scope: {
        template: '=',
        namespace: '@',
        aasmStates: '=?',
        translateKey: '=',
        columnsNamespace: '=?'
      },
      templateUrl: 'app/components/reports/partials/templates.html',
      controllerAs: 'tempObj',
      controller: function($scope) {
        var vm = this;

        $scope.template.save_tab_data = $scope.template.save_tab_data.bind($scope.template);

        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            vm.isGtXs = value;
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var reports = {
        common: {
          reports: [
            {
              configuration: [
                'header||reports.header',
                'generate_report||reports.generate_report',
                'download_report||reports.download_report',
                'some_error_occured||reports.some_error_occured',
                'refresh_page_button||reports.refresh_page_button',
                {
                  date_range: [
                    'today||date_range.today',
                    'yesterday||date_range.yesterday',
                    'last_7_days||date_range.last_7_days',
                    'week||date_range.week',
                    'last_week||date_range.last_week',
                    'month||date_range.month',
                    'last_month||date_range.last_month',
                    'year||date_range.year'
                  ]
                },
                {
                  group_by: [
                    {
                      date: [
                        'group_by_day||group_by.group_by_day',
                        'group_by_week||group_by.group_by_week',
                        'group_by_month||group_by.group_by_month',
                        'group_by_alltime||group_by.group_by_alltime'
                      ]
                    },
                    {
                      affiliate_params: [
                        'group_by_merchant||group_by.group_by_merchant',
                        'group_by_affiliate||group_by.group_by_affiliate',
                        'group_by_tracker||group_by.group_by_tracker',
                        'group_by_anid||group_by.group_by_anid',
                        'group_by_player||group_by.group_by_player',
                        'group_by_manager||group_by.group_by_manager'
                      ]
                    },
                    {
                      player_params: [
                        'all_players||group_by.all_players',
                        'new_players||group_by.new_players',
                        'new_ftds||group_by.new_ftds',
                        'old_players||group_by.old_players',
                        'cpa_qualified_players||group_by.cpa_qualified_players'
                      ]
                    },
                    {
                      per_page: ['rows_per_page||group_by.rows_per_page']
                    }
                  ]
                },
                {
                  segments: [
                    'all_players||segments.all_players',
                    'no_name||segments.no_name',
                    'add_new_element||segments.add_new_element',
                    {
                      tabs: [
                        'merchant_ids||segments.tabs.merchant_ids',
                        'managers||segments.tabs.managers',
                        'roles||segments.tabs.roles',
                        'affiliates||segments.tabs.affiliates',
                        'invated_affiliates||segments.tabs.invated_affiliates',
                        'trackers||segments.tabs.trackers',
                        'anid||segments.tabs.anid',
                        'creatives||segments.tabs.creatives',
                        'players||segments.tabs.players',
                        'stats||segments.tabs.stats',
                        'date_of_registration||segments.tabs.date_of_registration',
                        'date_of_ftd||segments.tabs.date_of_ftd',
                        'date_of_last_deposit||segments.tabs.date_of_last_deposit',
                        'date_of_last_rmp_activity||segments.tabs.date_of_last_rmp_activity',
                        'inactive_days||segments.tabs.inactive_days',
                        'first_deposit_size||segments.tabs.first_deposit_size',
                        'last_deposit_size||segments.tabs.last_deposit_size',
                        'amount_of_deposits||segments.tabs.amount_of_deposits',
                        'average_deposit_size||segments.tabs.average_deposit_size',
                        'sum_of_deposits||segments.tabs.sum_of_deposits',
                        'ngr_all_time||segments.tabs.ngr_all_time',
                        'ggr_all_time||segments.tabs.ggr_all_time',
                        'ngr_this_month||segments.tabs.ngr_this_month',
                        'ggr_this_month||segments.tabs.ggr_this_month',
                        // 'country||segments.tabs.country',
                        'country_code||segments.tabs.country_code',
                        'country_ip_code||segments.tabs.country_ip_code',
                        'name||segments.name',
                        {
                          compare: [
                            'condition_selector||compare.condition_selector',
                            'compare_value||compare.compare_value',
                            'add_condition||compare.add_condition',
                            'remove_condition||compare.remove_condition',
                            'and||compare.and',
                            'or||compare.or',
                            'greater_than||compare.greater_than',
                            'less_than||compare.less_than',
                            'greater_than_or_equal||compare.greater_than_or_equal',
                            'less_than_or_equal||compare.less_than_or_equal',
                            'equal||compare.equal'
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  structures: [
                    'all_columns||structures.all_columns',
                    'no_name||structures.no_name',
                    'add_new_element||structures.add_new_element',
                    {
                      tabs: [
                        'general_columns||structures.tabs.general_columns',
                        'player_columns||structures.tabs.player_columns',
                        'product_columns||structures.tabs.product_columns',
                        'comission_columns||structures.tabs.comission_columns',
                        'stats_columns||structures.tabs.stats_columns',
                        'name||structures.name',
                        'aasm_state||structures.aasm_state',
                        'for_private||structures.for_private',
                        'for_admin||structures.for_admin',
                        'for_affiliate||structures.for_affiliate',
                        'for_all||structures.for_all'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              dialog_window: [
                {
                  remove: [
                    'title||remove_window.title',
                    'question||remove_window.question',
                    'yes||remove_window.yes',
                    'no||remove_window.no'
                  ]
                }
              ]
            },
            {
              result: ['header||result.header', 'total||result.total']
            }
          ]
        }
      },
      subaffiliate_reports = {
        common: {
          subaffiliate_reports: [
            {
              configuration: [
                'header||reports.header',
                'generate_report||reports.generate_report',
                'download_report||reports.download_report',
                'some_error_occured||reports.some_error_occured',
                'refresh_page_button||reports.refresh_page_button',
                {
                  date_range: [
                    'today||date_range.today',
                    'yesterday||date_range.yesterday',
                    'last_7_days||date_range.last_7_days',
                    'week||date_range.week',
                    'last_week||date_range.last_week',
                    'month||date_range.month',
                    'last_month||date_range.last_month',
                    'year||date_range.year'
                  ]
                },
                {
                  group_by: [
                    {
                      date: [
                        'group_by_day||group_by.group_by_day',
                        'group_by_week||group_by.group_by_week',
                        'group_by_month||group_by.group_by_month',
                        'group_by_alltime||group_by.group_by_alltime'
                      ]
                    },
                    {
                      per_page: ['rows_per_page||group_by.rows_per_page']
                    }
                  ]
                },
                {
                  segments: [
                    'all_players||segments.all_players',
                    'no_name||segments.no_name',
                    'add_new_element||segments.add_new_element',
                    {
                      tabs: [
                        'managers||segments.tabs.managers',
                        'affiliates||segments.tabs.affiliates',
                        'invated_affiliates||segments.tabs.invated_affiliates',
                        'name||segments.name'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              dialog_window: [
                {
                  remove: [
                    'title||remove_window.title',
                    'question||remove_window.question',
                    'yes||remove_window.yes',
                    'no||remove_window.no'
                  ]
                }
              ]
            },
            {
              result: ['header||result.header', 'total||result.total']
            }
          ]
        }
      },
      creative_reports = {
        common: {
          creative_reports: [
            {
              configuration: [
                'header||reports.header',
                'generate_report||reports.generate_report',
                'download_report||reports.download_report',
                'some_error_occured||reports.some_error_occured',
                'refresh_page_button||reports.refresh_page_button',
                {
                  date_range: [
                    'today||date_range.today',
                    'yesterday||date_range.yesterday',
                    'last_7_days||date_range.last_7_days',
                    'week||date_range.week',
                    'last_week||date_range.last_week',
                    'month||date_range.month',
                    'last_month||date_range.last_month',
                    'year||date_range.year'
                  ]
                },
                {
                  group_by: [
                    {
                      date: [
                        'group_by_day||group_by.group_by_day',
                        'group_by_week||group_by.group_by_week',
                        'group_by_month||group_by.group_by_month',
                        'group_by_alltime||group_by.group_by_alltime'
                      ]
                    },
                    {
                      affiliate_params: [
                        'group_by_merchant||group_by.group_by_merchant',
                        'group_by_creative||group_by.group_by_creative',
                        'group_by_affiliate||group_by.group_by_affiliate',
                        'group_by_tracker||group_by.group_by_tracker',
                        'group_by_anid||group_by.group_by_anid',
                        'group_by_manager||group_by.group_by_manager'
                      ]
                    },
                    {
                      per_page: ['rows_per_page||group_by.rows_per_page']
                    }
                  ]
                },
                {
                  segments: [
                    'all_players||segments.all_players',
                    'no_name||segments.no_name',
                    'add_new_element||segments.add_new_element',
                    {
                      tabs: [
                        'merchant_ids||segments.tabs.merchant_ids',
                        'creatives||segments.tabs.creatives_for_creatives_report',
                        // 'affiliates||segments.tabs.affiliates_for_creatives_report',
                        // 'trackers||segments.tabs.trackers_for_creatives_report',
                        'anid||segments.tabs.anids_for_creatives_report',
                        'name||segments.name',
                        'managers||segments.tabs.managers',
                        'affiliates||segments.tabs.affiliates',
                        'trackers||segments.tabs.trackers'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              dialog_window: [
                {
                  remove: [
                    'title||remove_window.title',
                    'question||remove_window.question',
                    'yes||remove_window.yes',
                    'no||remove_window.no'
                  ]
                }
              ]
            },
            {
              result: ['header||result.header', 'total||result.total']
            }
          ]
        }
      };

    translateManagerProvider.add_locals_list(reports);
    translateManagerProvider.add_locals_list(subaffiliate_reports);
    translateManagerProvider.add_locals_list(creative_reports);
    localesApiProvider.set_locales('Reports', reports);
    localesApiProvider.set_locales('SubaffiliateReports', subaffiliate_reports);
    localesApiProvider.set_locales('CreativeReports', creative_reports);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('statsCompare', statsCompare);

  statsCompare.$inject = [];

  function statsCompare() {
    return {
      restrict: 'E',
      scope: {
        statsData: '=',
        callback: '&',
        allDisabled: '=?',
        clearBtn: '=?',
        translateKey: '='
      },
      templateUrl: 'app/components/reports/partials/stats_parts/compare_conditions_template.html',
      controllerAs: 'compare',
      controller: function($scope) {
        var vm = this;

        if ($scope.callback) {
          vm.parent_callback = $scope.callback();
        }

        vm.compare_separators = [
          {
            label: '.and',
            mark: '&&'
          },
          {
            label: '.or',
            mark: '||'
          }
        ];

        vm.compare_conditions = [
          {
            label: '.greater_than',
            mark: '>'
          },
          {
            label: '.less_than',
            mark: '<'
          },
          {
            label: '.greater_than_or_equal',
            mark: '>='
          },
          {
            label: '.less_than_or_equal',
            mark: '<='
          },
          {
            label: '.equal',
            mark: '='
          }
        ];

        vm.add_condition = function() {
          $scope.statsData.second_condition = {
            first: {
              mark: null,
              value: null
            },
            second: {
              mark: null,
              value: null
            }
          };
        };

        vm.remove_condition = function() {
          if ($scope.allDisabled) {
            return;
          }

          $scope.statsData.second_condition = null;
          $scope.statsData.compare_separator = null;
          vm.callback();
        };

        vm.clear = function(data) {
          if ($scope.allDisabled) {
            return;
          }

          data.mark = null;
          data.value = null;

          vm.callback();
        };

        vm.callback = function() {
          if ($scope.allDisabled) {
            return;
          }

          if (vm.parent_callback) {
            vm.parent_callback($scope.statsData, null, true);
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').filter('mdTranslate', mdTranslate);

  function mdTranslate($translate, localesApi) {
    var translateFilter = function(shortcode, key, params) {
      var locale = localesApi.get_locale(key, shortcode);
      return $translate.instant(locale, params);
    };

    if ($translate.statefulFilter()) {
      translateFilter.$stateful = true;
    }

    return translateFilter;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('$mdTranslate', $mdTranslate);

  $mdTranslate.$inject = ['localesApi', '$translate'];

  function $mdTranslate(localesApi, $translate) {
    var $mdTranslate = {};

    $mdTranslate.instant = function(key, shortCode, params, forceLanguage) {
      var locale = localesApi.get_locale(key, shortCode);
      return $translate.instant(locale, params, null, forceLanguage);
    };

    return $mdTranslate;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('mdTranslate', mdTranslate);

  mdTranslate.$inject = ['localesApi'];

  function mdTranslate(localesApi) {
    return {
      restrict: 'EA',
      scope: {
        key: '=',
        shortcode: '=',
        translateValues: '=?',
        translateDefault: '@',
        watchShortcode: '=?'
      },
      template: function(elem, attr) {
        var temp = '<translate';

        if (attr.translateDefault) {
          temp += ' translate-default="{{translateDefault}}"';
        }

        if (attr.translateValues) {
          temp += ' translate-values="translateValues"';
        }

        if (attr.translateKeepContent) {
          temp += ' translate-keep-content="true"';
        }

        temp += '>{{locale}}</translate>';

        return temp;
      },
      link: function(scope) {
        scope.locale = localesApi.get_locale(scope.key, scope.shortcode);
        scope.translateValues = scope.translateValues || {};
        scope.translateDefault = scope.translateDefault || '';

        if (scope.watchShortcode) {
          scope.$watch('shortcode', function(newValue) {
            scope.locale = localesApi.get_locale(scope.key, newValue);
          });
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').provider('localesApi', localesApiProvider);

  function localesApiProvider() {
    var _this = this,
      shortcodes = {};

    _this.$log = angular.injector(['ng']).get('$log');
    _this.locales_map = {};

    _this.prepare_locales = function(localesKey, locales, translateKey, result) {
      var _result = result || {},
        _translateKey = translateKey || '';

      angular.forEach(locales, function(value, key) {
        var locale_path = _translateKey === '' ? _translateKey + key : _translateKey + '.' + key;

        if (angular.isArray(value)) {
          angular.forEach(value, function(val) {
            if (angular.isString(val)) {
              var arr = val.split('||'),
                last_key = arr.shift(),
                short_code = arr.pop(),
                full_path = locale_path + '.' + last_key;

              if (short_code) {
                if (~shortcodes[localesKey].indexOf(short_code)) {
                  _this.$log.error(
                    'Shortcode "%s" is already defined for "%s" key! Duplicate not allowed!',
                    short_code,
                    localesKey
                  );
                } else {
                  shortcodes[localesKey].push(short_code);
                  _result[short_code] = full_path;
                }
              } else {
                _this.$log.warn('Shortcode is not defined for locale: %s', full_path);
              }
            } else {
              _this.prepare_locales(localesKey, val, locale_path, _result);
            }
          });
        } else {
          _this.prepare_locales(localesKey, value, locale_path, _result);
        }
      });

      return _result;
    };

    _this.set_locales = function(key, values) {
      if (_this.locales_map[key]) {
        _this.$log.error('Key "%s" is already defined! Duplicate not allowed!', key);
      } else {
        shortcodes[key] = [];
        _this.locales_map[key] = _this.prepare_locales(key, values);
      }
    };

    _this.get_locale = function(key, shortCode) {
      var key_area = _this.locales_map[key],
        locale = key_area ? key_area[shortCode] : '';

      if (!key_area) {
        _this.$log.error('Key "%s" is wrong or not defined! Shortcode: %s', key, shortCode);
        return shortCode;
      }

      if (!locale) {
        _this.$log.error('Shortcode "%s" for "%s" key is wrong or not defined!', shortCode, key);
        return shortCode;
      }

      return locale;
    };

    _this.create_fragment_array = function(list, localePart) {
      var arr = angular.isArray(list) ? list : Object.keys(list);
      return arr.map(function(v) {
        return v + '||' + localePart + v;
      });
    };

    function LocalesApi() {}

    LocalesApi.prototype.get_locale = function(key, shortCode) {
      return _this.get_locale(key, shortCode);
    };

    function createApi() {
      return new LocalesApi();
    }

    _this.$get = createApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider, localesStorage) {
    var list = {
      common: {
        languages: localesApiProvider.create_fragment_array(localesStorage.getAllLanguages(), 'language.')
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('Languages', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        available_new_version: ['available_new_version||available_new_version']
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AvailableNewVersion', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('lastUpdateControl', lastUpdateControl);

  lastUpdateControl.$inject = ['$http', '$timeout', '$window', '$cookies'];

  function lastUpdateControl($http, $timeout, $window, $cookies) {
    return {
      restrict: 'E',
      scope: true,
      bindToController: true,
      templateUrl: 'app/components/last_update/partials/last_update.html',
      controllerAs: '$ctrl',
      controller: function() {
        var vm = this;

        vm.delay = 60 * 60 * 1000;
        vm.showUpdateButton = false;
        vm.hash = '';

        vm.getWindow = function() {
          return $window;
        };

        vm.getHash = function() {
          return Math.random()
            .toString()
            .slice(2);
        };

        vm.getCommitSha = function() {
          return $http.get('/last_update/last_update.json?' + vm.getHash());
        };

        vm.setCookies = function(value) {
          $cookies.put('last_update', value);
        };

        vm.getCookies = function() {
          return $cookies.get('last_update');
        };

        vm.refreshPage = function() {
          var windowService = vm.getWindow();

          windowService.location.href = windowService.location.origin + '?' + vm.getHash() + '/';
        };

        vm.update = function() {
          vm.getCommitSha().then(
            function(response) {
              vm.setCookies(response.data.last_update);
              vm.refreshPage();
            },
            function() {
              vm.setCookies(vm.hash);
              vm.refreshPage();
            }
          );
        };

        vm.compareUpdateTime = function(newHash) {
          var savedHash = vm.getCookies();
          vm.showUpdateButton = !!(newHash && savedHash && newHash !== savedHash);
        };

        vm.watchNewVersion = function() {
          $timeout(function() {
            vm.checkUpdateTime();
          }, vm.delay);
        };

        vm.checkUpdateTime = function() {
          vm.getCommitSha().then(
            function(response) {
              vm.hash = response.data.last_update;

              if (!vm.getCookies()) {
                vm.setCookies(vm.hash);
              }
              vm.compareUpdateTime(vm.hash);
              vm.watchNewVersion();
            },
            function() {
              vm.watchNewVersion();
            }
          );
        };

        vm.checkUpdateTime();
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      common: {
        history_changes: [
          'header||history_changes.header',
          'change||history_changes.change',
          'remove||history_changes.remove',
          'history_empty||history_changes.history_empty',
          {
            modal_window: [
              'remove_title||modal_window.remove_title',
              'remove_question||modal_window.remove_question',
              'answer_yes||modal_window.answer_yes',
              'answer_no||modal_window.answer_no'
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('HistoryChanges', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('historyChanges', historyChangesFn);

  historyChangesFn.$inject = [
    '$state',
    'historyChanges',
    '$mdTranslate',
    '_',
    '$mdDialog',
    'outputErrors',
    'toastsApi'
  ];

  function historyChangesFn($state, historyChanges, $mdTranslate, _, $mdDialog, outputErrors, toastsApi) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        historyChanges: '=?',
        optionsChange: '=?'
      },
      templateUrl: 'app/components/history_changes/history_changes.html',
      controllerAs: 'historyCtrl',
      controller: function($scope) {
        var vm = this;

        vm.translate_key = 'HistoryChanges';
        vm.errors = outputErrors.createNew();
        vm.date_format = 'L HH:mm';

        vm.changeHistoryItem = function(item) {
          if ($scope.optionsChange.edit_state) {
            var params = $scope.optionsChange.params || {};
            params.id = item.id;
            $state.go($scope.optionsChange.edit_state, params);
          }
        };

        vm.removeHistoryItem = function(id, ev) {
          var confirm = $mdDialog
            .confirm()
            .title($mdTranslate.instant(vm.translate_key, 'modal_window.remove_title'))
            .textContent($mdTranslate.instant(vm.translate_key, 'modal_window.remove_question'))
            .targetEvent(ev)
            .ok($mdTranslate.instant(vm.translate_key, 'modal_window.answer_yes'))
            .cancel($mdTranslate.instant(vm.translate_key, 'modal_window.answer_no'));

          $mdDialog.show(confirm).then(function() {
            var params = $scope.optionsChange.params || {},
              type = $scope.optionsChange.typeChanges;

            historyChanges.remove_item(id, params, type).then(
              function() {
                $scope.historyChanges = _.reject($scope.historyChanges, {id: id});
                toastsApi.toastRemoveSuccess();
              },
              function() {
                toastsApi.toastError();
              }
            );
          });
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('ExportDataController', ExportDataController);

  ExportDataController.$inject = [
    '$state',
    'ExportDataApi',
    '_',
    'moment',
    'outputErrors',
    'toastsApi',
    'User',
    'downloadReport'
  ];

  function ExportDataController($state, ExportDataApi, _, moment, outputErrors, toastsApi, User, downloadReport) {
    var vm = this;

    vm.stateData = $state.current.data;
    vm.translate_key = vm.stateData.translateKey;
    vm.namespace = User.getUserProperty('namespace');
    vm.reportTypesList = [];
    vm.reportType = '';
    vm.periodMonth = moment().month();
    vm.periodYear = moment().year();
    vm.reportPeriod = vm.periodMonth + 1 + '.' + vm.periodYear;
    vm.regExp = '(^[0-9]{1,2})\\.([0-9]{4}$)';
    vm.maxDate = moment().toDate();
    vm.errors = outputErrors.createNew();
    vm.stateToDownload = vm.namespace === 'admin' ? 'admin_download_csv' : 'affiliate_download_csv';

    vm.changeReportPeriod = function() {
      var date = vm.reportPeriod.split('.');

      vm.periodMonth = Number(date[0]);
      vm.periodYear = Number(date[1]);
    };

    vm.getDataParams = function() {
      return {
        reportType: vm.reportType,
        periodMonth: vm.periodMonth,
        periodYear: vm.periodYear
      };
    };

    vm.createReport = function() {
      var data = vm.getDataParams();

      vm.createReportForm.$setSubmitted();

      if (vm.createReportForm.$invalid) {
        return;
      }

      return ExportDataApi.createReport(vm.namespace, data).then(
        function() {
          downloadReport.showToastForDownload('DownloadReport', vm.namespace, vm.stateToDownload);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    ExportDataApi.getReportTypes(vm.namespace).then(
      function(response) {
        vm.reportTypesList = response.data.list;
        vm.changeReportPeriod();
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('DownloadCsvController', DownloadCsvController);

  DownloadCsvController.$inject = [
    '$scope',
    '$state',
    '$window',
    '$mdDialog',
    '$mdTranslate',
    'tableEngine',
    'DownloadCsvApi',
    'permissionsManager',
    'defaultDateFormat',
    '$cookies',
    '_',
    'toastsApi',
    'User'
  ];

  function DownloadCsvController(
    $scope,
    $state,
    $window,
    $mdDialog,
    $mdTranslate,
    tableEngine,
    DownloadCsvApi,
    permissionsManager,
    defaultDateFormat,
    $cookies,
    _,
    toastsApi,
    User
  ) {
    var vm = this;

    vm.stateData = $state.current.data;
    vm.translate_key = vm.stateData.translateKey;
    vm.deletePermission = permissionsManager.checkPermission(vm.stateData.deletePermission);
    vm.namespace = User.getUserProperty('namespace');

    vm.downloadReport = function(item) {
      DownloadCsvApi.downloadReport(vm.namespace, item.id).then(
        function(response) {
          if (response.data && response.data.link) {
            $window.location.href =
              response.data.link + ('?authenticity_token=' + encodeURIComponent($cookies.get('XSRF-TOKEN-X')));
          }
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getRemoveLocales = function() {
      return {
        title: $mdTranslate.instant(vm.translate_key, 'remove_modal.title'),
        question: $mdTranslate.instant(vm.translate_key, 'remove_modal.question'),
        ok: $mdTranslate.instant(vm.translate_key, 'remove_modal.answer_yes'),
        cancel: $mdTranslate.instant(vm.translate_key, 'remove_modal.answer_no')
      };
    };

    vm.openRemoveModal = function(locales, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(locales.title)
        .textContent(locales.question)
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok(locales.ok)
        .cancel(locales.cancel);

      return $mdDialog.show(confirm);
    };

    vm.removeReport = function(item, ev) {
      var locales = vm.getRemoveLocales();

      vm.openRemoveModal(locales, ev).then(function() {
        vm.applyRemoveReport(item.id);
      });
    };

    vm.applyRemoveReport = function(id) {
      DownloadCsvApi.removeReport(vm.namespace, id).then(
        function() {
          toastsApi.toastSuccess();
          vm.table.removeListItem();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.table = tableEngine.init({
      api: DownloadCsvApi,
      name: 'download_csv',
      mobile: {
        defaultColumns: ['report_file_name']
      },
      buttons: {
        url: 'app/components/download_csv/partials/table.html',
        methods: {
          download: vm.downloadReport,
          remove: vm.deletePermission ? vm.removeReport : null
        }
      },
      params: {
        data: {
          additional_options: {
            namespace: vm.namespace
          }
        }
      }
    });

    DownloadCsvApi.getCsvList(vm.namespace).then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('created_at', {format: defaultDateFormat + ' HH:mm:ss'});
        vm.table.addOptionsToColumn('aasm_state', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: 'aasm_state.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('asyncLoaderConfig').factory('loadConfigHandler', loadConfigHandler);

  loadConfigHandler.$inject = ['$document', 'appConfigConstants', '_'];

  function loadConfigHandler($document, appConfigConstants, _) {
    var Handler = {};

    Handler.defineBrowserName = function() {
      var browsers = ['MSIE', 'Firefox', 'Safari', 'Chrome', 'Opera'],
        result = 'browser-not-defined';

      _.each(browsers, function(browser) {
        if (~navigator.userAgent.indexOf(browser)) {
          result = browser.toLowerCase();
        }
      });

      angular.element($document[0].body).addClass(result);
    };

    Handler.setAppConstants = function() {
      angular
        .module('quintessenceAngular')
        .constant('envConfig', appConfigConstants.envConfig)
        .constant('localesStorage', appConfigConstants.localesStorage)
        .constant('themeColors', appConfigConstants.themeColors)
        .constant('ProductsStorage', appConfigConstants.ProductsStorage)
        .constant('CreativeDomain', appConfigConstants.CreativeDomain)
        .value('autoAcceptAffiliateRequest', appConfigConstants.autoAcceptAffiliateRequest)
        .value('permissionsStorage', appConfigConstants.permissionsStorage)
        .value('projectCurrency', appConfigConstants.projectCurrency)
        .value('registrationFields', appConfigConstants.registrationFields)
        .value('User', appConfigConstants.User)
        .value('logoUrls', appConfigConstants.logoUrls)
        .value('pageTitle', appConfigConstants.pageTitle)
        .value('notificationHeader', appConfigConstants.notificationHeader)
        .value('merchantStore', appConfigConstants.merchantStore)
        .value('mfaSettings', appConfigConstants.mfaSettings);
    };

    Handler.launchModule = function() {
      angular.bootstrap(document.querySelector('#app'), ['quintessenceAngular']);
    };

    Handler.initApplication = function() {
      Handler.defineBrowserName();
      Handler.setAppConstants();
      Handler.launchModule();
    };

    Handler.handleSeverError = function() {
      var preloader = document.querySelector('.preloader-wrapper'),
        main = document.querySelector('.main-view > div');

      if (preloader) {
        preloader.classList.remove('activate');
      }

      if (main) {
        main.insertAdjacentHTML(
          'beforeend',
          '<div class="server-error">Sorry, server is not available. Try again later...</div>'
        );
      }
    };

    return Handler;
  }
})();

(function() {
  'use strict';

  angular.module('launcherModule').run(runConfigModule);

  /** @ngInject */
  function runConfigModule(configLoader, loadConfigHandler) {
    configLoader.fetchConfig().then(loadConfigHandler.initApplication, loadConfigHandler.handleSeverError);
  }
})();

(function() {
  'use strict';

  angular.module('asyncLoaderConfig').factory('configLoader', configLoader);

  configLoader.$inject = ['$http', '$q', 'appConfigConstants', '_'];

  function configLoader($http, $q, appConfigConstants, _) {
    var Loader = {};

    Loader.apiUrl = '';

    Loader.setApiUrl = function(url) {
      this.apiUrl = url || '';
    };

    Loader.joinUrl = function(path) {
      return this.apiUrl + path;
    };

    Loader.getApiUrlFromEnvConfig = function(envConfig) {
      var url;

      _.each(envConfig.domains, function(v, k) {
        if (~v.indexOf(window.location.hostname)) {
          url = _.propertyOf(envConfig.vars[k])('apiUrl');
        }
      });

      return url;
    };

    Loader.setCookieToken = function(token) {
      document.cookie = 'XSRF-TOKEN-X=' + token;
    };

    Loader.getEnvConfig = function() {
      return $http.get(Loader.joinUrl('env/config.json')).then(function(res) {
        Loader.apiUrl = Loader.getApiUrlFromEnvConfig(res.data);
        appConfigConstants.envConfig = res.data;
      });
    };

    Loader.getCsrfToken = function() {
      return $http.get(Loader.joinUrl('csrf_token'), {withCredentials: true}).then(
        function(res) {
          Loader.setCookieToken(res.headers('XSRF-TOKEN'));
          return {token: res.data.authenticity_token, supervision: res.data.supervision};
        },
        function(res) {
          return res;
        }
      );
    };

    Loader.getAllOptions = function(data) {
      return $q.all([Loader.getUploadConfig(data).then(Loader.getLocalesList), Loader.getPermissions(data)]);
    };

    Loader.getUploadConfig = function(authData) {
      return $http
        .get(Loader.joinUrl('upload_config'), {
          withCredentials: true,
          params: {
            authenticity_token: authData.token
          }
        })
        .then(function(res) {
          var data = res.data;

          appConfigConstants.themeColors.setAllColors(data.buttons_color, data.header_color);
          appConfigConstants.autoAcceptAffiliateRequest.setAccept(data.auto_accept_affiliate_request);
          appConfigConstants.projectCurrency.setCurrency(data.currency);
          appConfigConstants.registrationFields.setFields(data.required_fields_in_profile_update_affiliate);
          appConfigConstants.User.setUser(data.current_user, authData.supervision);
          appConfigConstants.logoUrls.setAllLogos(data.logo_mini, data.logo, data.favicon);
          appConfigConstants.pageTitle.setTitle(data.title);
          appConfigConstants.notificationHeader.setNotifyData(data.notification_in_header);
          appConfigConstants.ProductsStorage.setProducts(data.products_list);
          appConfigConstants.CreativeDomain._setCount(data.default_domains_count_for_creatives);
          appConfigConstants.merchantStore.setMerchantList(data.merchants_list);
          appConfigConstants.mfaSettings.setEnabled(data.mfa_enabled);

          return {
            token: authData.token,
            creativeLocales: data.enabled_locales.creative_locales,
            languages: data.enabled_locales.interface_locales,
            allLanguages: data.list_locales,
            locale: data.locale,
            fallbackLocale: data.fallback_locale
          };
        });
    };

    Loader.getPermissions = function(authData) {
      return $http
        .get(Loader.joinUrl('anonym/permission/list'), {
          withCredentials: true,
          params: {
            authenticity_token: authData.token
          }
        })
        .then(function(res) {
          appConfigConstants.permissionsStorage.setPermissions(res.data);
        });
    };

    Loader.getLocaleData = function(requestUrl, locale, token) {
      return $http
        .get(requestUrl, {
          withCredentials: true,
          params: {
            language: locale,
            authenticity_token: token
          }
        })
        .then(function(res) {
          appConfigConstants.localesStorage.replaceValueToEmptyString(res.data);
          appConfigConstants.localesStorage.updateStorage(locale, res.data);
        });
    };

    Loader.getLocalesList = function(data) {
      appConfigConstants.localesStorage.setAllData(
        data.creativeLocales,
        data.languages,
        data.allLanguages,
        data.locale,
        data.fallbackLocale
      );

      var currentLocale = appConfigConstants.localesStorage.getCurrentLocale(),
        fallbackLocale = appConfigConstants.localesStorage.getFallbackLocale(),
        requestUrl = Loader.joinUrl('anonym/translate/locals_list'),
        all_promises = [Loader.getLocaleData(requestUrl, currentLocale, data.token)];

      if (currentLocale !== fallbackLocale) {
        all_promises.push(Loader.getLocaleData(requestUrl, fallbackLocale, data.token));
      }

      return $q.all(all_promises);
    };

    Loader.fetchConfig = function() {
      return this.getEnvConfig()
        .then(this.getCsrfToken)
        .then(this.getAllOptions);
    };

    return Loader;
  }
})();

(function() {
  'use strict';

  angular.module('asyncLoaderConfig').factory('appConfigConstants', appConfigConstants);

  appConfigConstants.$inject = ['$interpolate', '_', 'moment'];

  function appConfigConstants($interpolate, _, moment) {
    var AppConstants = {};

    AppConstants.defaults = {
      autoAccept: false,
      products: [],
      title: 'Quintessence',
      currency: '$',
      locale: 'en_US',
      moment: 'en',
      color: '#1088DE',
      favicon: '',
      logoMini: 'assets/images/logo-mini.png',
      logoMain: 'assets/images/logo-main.png'
    };

    AppConstants.buildLocalesMap = function(allLocales, momentLocales) {
      var result = {};

      _.each(allLocales, function(val) {
        var arr = val.split('_'),
          part1 = _.first(arr),
          part2 = _.last(arr),
          query = part1 + '-' + part2.toLowerCase();

        if (_.contains(momentLocales, query)) {
          result[val] = query;
        } else {
          if (_.contains(momentLocales, part1)) {
            result[val] = part1;
          } else {
            result[val] = AppConstants.defaults.moment;
          }
        }
      });

      return result;
    };

    AppConstants.envConfig = {};
    AppConstants.localesStorage = new LocalesStorage();
    AppConstants.themeColors = new ThemeColors();
    AppConstants.autoAcceptAffiliateRequest = new AutoAcceptAffiliateRequest();
    AppConstants.permissionsStorage = new PermissionsStorage();
    AppConstants.projectCurrency = new ProjectCurrency();
    AppConstants.registrationFields = new RegistrationFields();
    AppConstants.User = new User();
    AppConstants.logoUrls = new LogoUrls();
    AppConstants.pageTitle = new PageTitle();
    AppConstants.notificationHeader = new NotificationHeader();
    AppConstants.ProductsStorage = new ProductsStorage();
    AppConstants.merchantStore = new MerchantStore();
    AppConstants.CreativeDomain = new CreativeDomain();
    AppConstants.mfaSettings = new MfaSettings();

    function LocalesStorage() {
      var LocaleMap = {},
        defaultLocale = AppConstants.defaults.locale,
        defaultMoment = AppConstants.defaults.moment,
        MomentLocales = moment.locales(),
        CreativeLocales = [],
        LanguagesList = {},
        TranslateStorage = {},
        FallbackLocale = '',
        CurrentLocale = '',
        MomentLocale = '';

      this.buildLocalesMap = function(allLocales, momentLocales) {
        var result = {};

        _.each(allLocales, function(val) {
          var arr = val.split('_'),
            part1 = _.first(arr),
            part2 = _.last(arr),
            query = part1 + '-' + part2.toLowerCase();

          if (_.contains(momentLocales, query)) {
            result[val] = query;
          } else {
            if (_.contains(momentLocales, part1)) {
              result[val] = part1;
            } else {
              result[val] = AppConstants.defaults.moment;
            }
          }
        });

        return result;
      };
      this.replaceValueToEmptyString = function(data, prevObj) {
        var _this = this;
        _.each(data, function(val, key) {
          if (_.isObject(val)) {
            _this.replaceValueToEmptyString(val, val);
          } else if (!val) {
            if (prevObj) {
              prevObj[key] = '';
            }
          }
        });
      };
      this.mixinLocaleToList = function(list) {
        return _.union([this.getFallbackLocale() || defaultLocale], list);
      };
      this.getLanguages = function() {
        return _.clone(LanguagesList);
      };
      this.updateProjectLanguages = function(list) {
        LanguagesList = _.pick(this.getAllLanguages(), this.mixinLocaleToList(list));
      };
      this.getAllLanguages = function() {
        return _.clone(LocaleMap);
      };
      this.getStorage = function() {
        return TranslateStorage;
      };
      this.setFallbackLocale = function(locale) {
        FallbackLocale = locale || defaultLocale;
      };
      this.getFallbackLocale = function() {
        return FallbackLocale;
      };
      this.getFallbackMomentLocale = function() {
        return defaultMoment;
      };
      this.getMomentLocale = function() {
        return MomentLocale;
      };
      this.getCurrentLocale = function() {
        return CurrentLocale;
      };
      this.getCreativeLocales = function() {
        return _.map(CreativeLocales, function(v) {
          return v;
        });
      };
      this.updateCreativeLanguages = function(list) {
        CreativeLocales = this.mixinLocaleToList(list);
      };
      this.updateLocale = function(locale) {
        CurrentLocale = locale || defaultLocale;
        MomentLocale = LanguagesList[CurrentLocale] || defaultMoment;
      };
      this.setAllData = function(creativeLocales, projectLocales, allLanguagesList, currentLocale, fallbackLocale) {
        LocaleMap = this.buildLocalesMap(allLanguagesList, MomentLocales);
        this.setFallbackLocale(fallbackLocale);
        this.updateProjectLanguages(projectLocales);
        this.updateCreativeLanguages(creativeLocales);

        this.updateLocale(currentLocale);
      };
      this.updateStorage = function(locale, data) {
        TranslateStorage[locale] = _.isObject(data) ? data : {};
      };
    }

    function ThemeColors() {
      var defaultColor = AppConstants.defaults.color,
        ButtonsColor = '',
        HeaderColor = '';

      this.createStyleForButtons = function() {
        if (ButtonsColor === defaultColor) {
          return;
        }

        var styleTag = document.querySelector('style[custom-buttons-color]') || document.createElement('style'),
          styles = [
            '.md-button.md-primary.md-raised:not([disabled]) {',
            'background: {{color}};',
            '}',
            '.tabs-list .tab-list-item.active {',
            'background: {{color}};',
            'border-color: {{color}};',
            '}',
            '.tabs-list.products-list .tab-list-item.active .remove-product {',
            '-webkit-text-stroke: 1px {{color}};',
            '}'
          ].join('');

        styleTag.setAttribute('custom-buttons-color', '');
        styleTag.textContent = $interpolate(styles)({color: ButtonsColor});

        document.head.appendChild(styleTag);
      };
      this.getButtonsColor = function() {
        return ButtonsColor;
      };
      this.getHeaderColor = function() {
        return HeaderColor;
      };
      this.setButtonsColor = function(color) {
        ButtonsColor = color || defaultColor;
        this.createStyleForButtons();
      };
      this.setHeaderColor = function(color) {
        HeaderColor = color || defaultColor;
      };
      this.setAllColors = function(buttonsColor, headerColor) {
        this.setButtonsColor(buttonsColor);
        this.setHeaderColor(headerColor);
      };
    }

    function AutoAcceptAffiliateRequest() {
      var defaultAccept = AppConstants.defaults.autoAccept,
        autoAccept = null;

      this.getAccept = function() {
        return autoAccept;
      };
      this.setAccept = function(accept) {
        autoAccept = accept || defaultAccept;
      };
    }

    function PermissionsStorage() {
      var storage = {
        permissions: [],
        permissions_by_role: {}
      };

      this.getPermissions = function() {
        return storage;
      };
      this.setPermissions = function(data) {
        storage.permissions = data.permissions || [];
        storage.permissions_by_role = data.permissions_by_role || {};
      };
    }

    function ProjectCurrency() {
      var defaultCurrency = AppConstants.defaults.currency,
        currency = '';

      this.getCurrency = function() {
        return currency;
      };
      this.setCurrency = function(newCurrency) {
        currency = newCurrency || defaultCurrency;
      };
    }

    function RegistrationFields() {
      var fields = [];

      this.getFields = function() {
        return fields;
      };
      this.setFields = function(newFields) {
        fields = _.isArray(newFields) ? newFields : [];
      };
    }

    function User() {
      var user = {},
        supervisionValue = null;

      this.getUserProperty = function(prop) {
        return user[prop];
      };
      this.setToStorage = function() {
        var supervision = this.getSupervisionValue();
        localStorage.setItem('user', JSON.stringify(angular.extend({supervision: supervision}, user)));
      };
      this.setUser = function(newUser, supervision) {
        user = _.isObject(newUser) ? newUser : {};

        this.setSupervision(supervision);
      };
      this.setSupervision = function(supervision) {
        supervisionValue = supervision;
      };
      this.getSupervisionValue = function() {
        return supervisionValue;
      };
      this.isAdmin = function() {
        return user.namespace === 'admin';
      };
      this.resetUser = function() {
        user = {};

        this.setSupervision(null);
      };
      this.updateUserProperty = function(propName, value) {
        if (_.has(user, propName)) {
          user[propName] = value;
        }
      };
    }

    function LogoUrls() {
      var defaultLogoMini = AppConstants.defaults.logoMini,
        defaultLogoMain = AppConstants.defaults.logoMain,
        defaultFavicon = AppConstants.defaults.favicon,
        logoMini = '',
        logoMain = '',
        favicon = '';

      this.getLinkTag = function(selector) {
        return document.querySelector(selector);
      };
      this.createLinkTag = function() {
        return document.createElement('link');
      };
      this.appendFaviconToHead = function() {
        var head = document.getElementsByTagName('head')[0],
          link = this.getLinkTag('link[rel="icon"]') || this.createLinkTag(),
          linkExtended = this.getLinkTag('link[rel="shortcut icon"]'),
          linkApple = this.getLinkTag('link[rel="apple-touch-icon"]');

        if (!favicon) {
          link.rel = 'icon';
          link.href = 'data:,';
          link.removeAttribute('type');
          head.appendChild(link);

          if (linkExtended) {
            linkExtended.remove();
          }
          if (linkApple) {
            linkApple.remove();
          }
        } else {
          linkExtended = linkExtended || this.createLinkTag();
          linkApple = linkApple || this.createLinkTag();

          link.type = 'image/x-icon';
          link.rel = 'icon';
          link.href = favicon;

          linkExtended.type = 'image/x-icon';
          linkExtended.rel = 'shortcut icon';
          linkExtended.href = favicon;

          linkApple.href = favicon;
          linkApple.rel = 'apple-touch-icon';

          head.appendChild(linkApple);
          head.appendChild(link);
          head.appendChild(linkExtended);
        }
      };

      this.getLogoMini = function() {
        return logoMini;
      };

      this.getLogoMain = function() {
        return logoMain;
      };

      this.getFavicon = function() {
        return favicon;
      };

      this.getDefaultLogoByType = function(logoType) {
        if (logoType === 'logo_mini') {
          return defaultLogoMini;
        } else if (logoType === 'logo_main') {
          return defaultLogoMain;
        }
        return '';
      };

      this.setLogoMini = function(logoUrl) {
        logoMini = logoUrl || defaultLogoMini;
      };

      this.setLogoMain = function(logoUrl) {
        logoMain = logoUrl || defaultLogoMain;
      };

      this.setFavicon = function(faviconUrl) {
        favicon = faviconUrl || defaultFavicon;
        this.appendFaviconToHead();
      };

      this.setAllLogos = function(logoMini, logoMain, favicon) {
        this.setLogoMini(logoMini);
        this.setLogoMain(logoMain);
        this.setFavicon(favicon);
      };
    }

    function PageTitle() {
      var defaultTitle = AppConstants.defaults.title,
        title = '';

      this.setTitle = function(newTitle) {
        title = newTitle || defaultTitle;
        this.updateDocumentTitle();
      };
      this.updateDocumentTitle = function() {
        document.title = title;
      };
    }

    function NotificationHeader() {
      var defaultColor = AppConstants.defaults.color,
        notificationInHeader = {
          headerColor: defaultColor,
          textColor: '#fff'
        },
        textContent = {};

      this.setNotifyData = function(data) {
        if (_.isEmpty(data) || !_.isObject(data)) {
          return;
        }

        notificationInHeader.headerColor = data.headerColor || defaultColor;
        notificationInHeader.textColor = data.textColor || '#fff';
      };
      this.getNotifyData = function() {
        return notificationInHeader;
      };
      this.setTextContent = function(content) {
        _.each(content, function(value, key) {
          textContent[key] = value;
        });
      };
      this.getTextContent = function(key) {
        return textContent[key] || '';
      };
    }

    function MerchantStore() {
      var store = [],
        currentMerchantId = null,
        currentMerchantName = '',
        cookieName = 'merchant_id';

      this._createMerchantList = function(list) {
        return _.map(list, function(merchant) {
          return _.pick(merchant, 'id', 'value');
        });
      };
      this._setMerchantIdToCookies = function(id, expires) {
        document.cookie = cookieName + '=' + id + (expires ? '; expires=' + expires : '');
      };
      this._setMerchantFromUrl = function() {
        var value = _.first(_.rest(window.location.href.match('[?&]merchant=([^&]+)') || [])),
          merchant = _.find(store, function(merchant) {
            return merchant.value === value;
          });

        if (merchant) {
          this.setCurrentMerchant(merchant);
        }
      };
      this._getMerchantIdFromCookies = function() {
        var matches = document.cookie.match(
          new RegExp('(?:^|; )' + cookieName.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
          // '(?:^|; )' + cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
        );

        return matches ? Number(decodeURIComponent(matches[1])) : undefined;
      };
      this._getMerchantFromListById = function(id) {
        return _.findWhere(store, {id: id});
      };
      this.setMerchantList = function(list) {
        store = _.isArray(list) && !_.isEmpty(list) ? this._createMerchantList(list) : [];

        this._setMerchantFromUrl();

        var id = this.getCurrentMerchantId(),
          merchant = this._getMerchantFromListById(id);

        if (!merchant) {
          this._setMerchantIdToCookies('', new Date(0).toUTCString());

          merchant = _.first(store);
        }

        this.setCurrentMerchant(merchant);
      };
      this.getMerchantList = function() {
        return this._createMerchantList(store);
      };
      this.setCurrentMerchantId = function(id) {
        if (!id) {
          return;
        }

        var merchantId = Number(id);

        currentMerchantId = merchantId;

        this._setMerchantIdToCookies(merchantId);
      };
      this.getCurrentMerchantId = function() {
        return currentMerchantId || this._getMerchantIdFromCookies();
      };
      this.setCurrentMerchantName = function(name) {
        if (!name) {
          return;
        }

        currentMerchantName = name;
      };
      this.getCurrentMerchantName = function() {
        return currentMerchantName || _.propertyOf(this._getMerchantFromListById(this.getCurrentMerchantId()))('value');
      };
      this.setCurrentMerchant = function(merchant) {
        if (!merchant) {
          return;
        }

        this.setCurrentMerchantId(merchant.id);
        this.setCurrentMerchantName(merchant.value);
      };
    }

    function ProductsStorage() {
      var products = [];

      this.setProducts = function(productsList) {
        products = productsList || [];
      };
      this.getProducts = function() {
        return _.map(products, function(v) {
          return v;
        });
      };
    }

    function CreativeDomain() {
      var countOfDomains = 0;

      this._setCount = function(count) {
        countOfDomains = count == null ? 0 : Number(count);
      };
      this.getCount = function() {
        return countOfDomains;
      };
      this.buildDomainName = function(index) {
        return 'creative_default_domain' + (index === 0 ? '' : index + 1);
      };
    }

    function MfaSettings() {
      var isEnabled = false;

      this.setEnabled = function(enabled) {
        isEnabled = !!enabled;
      };

      this.isEnabled = function() {
        return isEnabled;
      };
    }

    return AppConstants;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partnership_program: {
          bookkeeping: [
            'header||bookkeeping.header',
            {
              aasm_state: [
                'new_plan||aasm_state.new_plan',
                'approved||aasm_state.approved',
                'paid||aasm_state.paid',
                'in_process||aasm_state.in_process',
                'can_be_process||aasm_state.can_be_process'
              ]
            },
            {
              transfer_payment_statuses: [
                'default_payment||transfer_payment_statuses.default_payment',
                'paid_in_next_month||transfer_payment_statuses.paid_in_next_month'
              ]
            },
            {
              bookkeeping_month_report: [
                'back||bookkeeping_month_report.back',
                'paid||bookkeeping_month_report.paid',
                'approved||bookkeeping_month_report.approved',
                'download_report||bookkeeping_month_report.download_report',
                'transfer_payout||bookkeeping_month_report.transfer_payout',
                'cancel_transfer_payout||bookkeeping_month_report.cancel_transfer_payout',
                'transfer_payoff_to_balance||bookkeeping_month_report.transfer_payoff_to_balance',
                'no_choosed_affiliates||bookkeeping_month_report.no_choosed_affiliates',
                'close_month_available_description||bookkeeping_month_report.close_month_available_description',
                'recalculating||bookkeeping_month_report.recalculating',
                {
                  modal_window: [
                    'goal_approved||modal_window.goal_approved',
                    'goal_paid||modal_window.goal_paid',
                    'close||modal_window.close',
                    'cancel||modal_window.cancel',
                    'answer_yes||modal_window.answer_yes',
                    'answer_no||modal_window.answer_no',
                    'change||modal_window.change',
                    'change_question||modal_window.change_question'
                  ]
                },
                {
                  deduction: [
                    {
                      form: [
                        'affiliate||form.affiliate',
                        'deduction_size||form.deduction_size',
                        'deduction_comment||form.deduction_comment'
                      ]
                    },
                    'save||deduction.save',
                    'delete||deduction.delete',
                    'back||deduction.back',
                    'edit_deduction||deduction.edit_deduction',
                    'create_deduction||deduction.create_deduction'
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminBookkeeping', list);
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('BookkeepingMonthReportController', BookkeepingMonthReportController);

  BookkeepingMonthReportController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$mdTranslate',
    'tableEngine',
    '_',
    '$mdDialog',
    'outputErrors',
    '$injector',
    'toastsApi',
    'permissionsManager',
    'downloadReport'
  ];

  function BookkeepingMonthReportController(
    $scope,
    $state,
    $stateParams,
    $mdTranslate,
    tableEngine,
    _,
    $mdDialog,
    outputErrors,
    $injector,
    toastsApi,
    permissionsManager,
    downloadReport
  ) {
    var vm = this;

    vm.translate_key = 'AdminBookkeeping';
    vm.title = $stateParams.month_payment_date;
    vm.errors = outputErrors.createNew();
    vm.stateData = $state.current.data;
    vm.readonly = vm.stateData.readonly;
    vm.parentState = vm.stateData.parent_state;
    vm.namespace = vm.stateData.namespace;
    vm.tableCheckboxes = vm.stateData.checkboxes;
    vm.bookkeepingApi = $injector.get(vm.stateData.api_name);
    vm.report_information = {date: $stateParams.month_payment_date};
    vm.cannotCloseMonth = false;
    vm.cannotCloseMonthLocale = '';
    vm.unclosedMerchants = {};
    vm.transferPayoutPerm = permissionsManager.checkPermission('api2.admin.bookkeepingscontroller.transfer_payment');
    vm.transferPayoffToBalancePerm = permissionsManager.checkPermission(
      'api2.admin.bookkeepingscontroller.transfer_payoff'
    );
    vm.displayTransferPayoutAction = false;
    vm.displayTransferPayoffToBalanceAction = false;
    vm.parentTable = tableEngine.getTableByName(vm.namespace + '_bookkeeping');

    vm.back = function() {
      $state.go(vm.parentState);
    };

    vm.add_deduction = function(affiliate) {
      if (vm.readonly) {
        return;
      }

      $state.go('deduction', {
        month_payment_date: $stateParams.month_payment_date,
        affiliate_id: affiliate.affiliate_id
      });
    };

    vm.monthStatusControl = function(aasm_state) {
      vm.month_payments_aasm_state = aasm_state;
    };

    vm.closeMonthError = function() {
      vm.cannotCloseMonth = false;
    };

    vm.handleCloseMonthError = function(resData) {
      if (!resData || !resData.errors) {
        return;
      }

      vm.cannotCloseMonth = true;
      vm.cannotCloseMonthLocale = _.first(resData.errors.aasm_state);
      vm.unclosedMerchants = resData.error_values && resData.error_values.can_not_be_closed_until_previous_month_is;
    };

    vm.getModalTranslations = function(aasm_state) {
      var purpose = aasm_state === 'approved',
        title = $mdTranslate.instant(vm.translate_key, 'modal_window.change'),
        question = $mdTranslate.instant(vm.translate_key, 'modal_window.change_question'),
        goal = purpose
          ? $mdTranslate.instant(vm.translate_key, 'modal_window.goal_approved')
          : $mdTranslate.instant(vm.translate_key, 'modal_window.goal_paid'),
        ok = purpose
          ? $mdTranslate.instant(vm.translate_key, 'modal_window.close')
          : $mdTranslate.instant(vm.translate_key, 'modal_window.answer_yes'),
        cancel = purpose
          ? $mdTranslate.instant(vm.translate_key, 'modal_window.cancel')
          : $mdTranslate.instant(vm.translate_key, 'modal_window.answer_no');

      return {
        title: title,
        question: question,
        goal: goal,
        ok: ok,
        cancel: cancel
      };
    };

    vm.openModal = function(data, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(data.title)
        .textContent(data.question + ' ' + data.goal)
        .targetEvent(ev)
        .ok(data.ok)
        .cancel(data.cancel);

      return $mdDialog.show(confirm);
    };

    vm.approveMonth = function(ev) {
      if (vm.readonly || !vm.close_month_available) {
        return;
      }

      var locales = vm.getModalTranslations('approved');

      vm.openModal(locales, ev).then(function() {
        vm.submitApproveMonth('approved');
      });
    };

    vm.paidMonth = function(ev) {
      if (vm.readonly) {
        return;
      }

      var locales = vm.getModalTranslations('paid');

      vm.openModal(locales, ev).then(function() {
        vm.submitPaidMonth('paid');
      });
    };

    vm.submitApproveMonth = function(aasm_state) {
      vm.bookkeepingApi.approveMonth($stateParams.month_payment_date).then(
        function() {
          vm.monthStatusControl(aasm_state);
          vm.table.pagination();
          vm.parentTable.pagination();
          toastsApi.toastEditSuccess();
        },
        function(response) {
          toastsApi.toastError();
          vm.handleCloseMonthError(response.data);
        }
      );
    };

    vm.submitPaidMonth = function(aasm_state) {
      vm.bookkeepingApi.paidMonth($stateParams.month_payment_date).then(
        function() {
          vm.monthStatusControl(aasm_state);
          vm.table.pagination();
          vm.parentTable.pagination();
          toastsApi.toastEditSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getInfo = function() {
      return vm.close_month_available
        ? ''
        : $mdTranslate.instant(vm.translate_key, 'bookkeeping_month_report.close_month_available_description');
    };

    vm.transferPayout = function(selectedItems, filterId, params) {
      vm.bookkeepingApi.transferPayout(selectedItems, params).then(
        function() {
          vm.table.pagination();
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.cancelTransferPayout = function(selectedItems, filterId, params) {
      vm.bookkeepingApi.cancelTransferPayout(selectedItems, params).then(
        function() {
          vm.table.pagination();
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.transferPayoffToBalance = function(selectedItems, filterId, params) {
      vm.bookkeepingApi.transferPayoffToBalance(selectedItems, $stateParams.month_payment_date, params).then(
        function() {
          vm.table.pagination();
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.checkTransferPayoutAction = function() {
      return vm.displayTransferPayoutAction && vm.transferPayoutPerm;
    };

    vm.checkTransferPayoffAction = function() {
      return vm.displayTransferPayoffToBalanceAction && vm.transferPayoffToBalancePerm;
    };

    vm.checkAasmStateForTransferPayoff = function(aasmState) {
      return _.contains(['new_plan', 'can_be_process', 'in_process', 'approved', 'paid'], aasmState);
    };

    vm.checkAasmStateForTransferPayout = function(aasmState) {
      return _.contains(['new_plan', 'can_be_process', 'in_process'], aasmState);
    };

    vm.applyDownloadReport = function(data) {
      _.extend(vm.report_information, data);

      return vm.bookkeepingApi.download_report(vm.report_information);
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.table = tableEngine.init({
      api: vm.bookkeepingApi,
      name: vm.namespace + '_bookkeepingMonthReport',
      api_method: 'pagination_month_report',
      separate_numbers: true,
      mobile: {
        defaultColumns: ['affiliate_username']
      },
      buttons: {
        url: 'app/components/bookkeeping/partials/table_month_report.html',
        methods: {
          add_deduction: vm.add_deduction
        }
      },
      params: {
        data: {
          date_of_payment: $stateParams.month_payment_date
        }
      },
      column_checkboxes: {
        enable: vm.tableCheckboxes,
        if_no_choosed: {
          translate_key: vm.translate_key,
          shortcode: 'bookkeeping_month_report.no_choosed_affiliates'
        },
        actions: [
          {
            name: 'transferPayout',
            action: vm.transferPayout,
            display: vm.checkTransferPayoutAction,
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'bookkeeping_month_report.transfer_payout'
            }
          },
          {
            name: 'cancelTransferPayout',
            action: vm.cancelTransferPayout,
            display: vm.checkTransferPayoutAction,
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'bookkeeping_month_report.cancel_transfer_payout'
            }
          },
          {
            name: 'transferPayoffToBalance',
            action: vm.transferPayoffToBalance,
            display: vm.checkTransferPayoffAction,
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'bookkeeping_month_report.transfer_payoff_to_balance'
            }
          }
        ]
      }
    });

    vm.bookkeepingApi.get_affiliate_month_payment($stateParams.month_payment_date).then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('status', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: 'aasm_state.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });
        vm.table.addOptionsToColumn('aasm_state', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: 'transfer_payment_statuses.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });

        vm.month_payments_aasm_state = data.month_payment_data && data.month_payment_data.state;
        vm.close_month_available = data.month_payment_data && data.month_payment_data.close_month_available;
        // A backdated commission correction is being computed for this affiliate/month (Eddie Q2) — the
        // numeric columns above already come back blank; this drives an explicit banner.
        vm.recalculating = !!data.recalculating;
        vm.downloadFormats = data.separators_for_format;
        vm.displayTransferPayoffToBalanceAction = vm.checkAasmStateForTransferPayoff(vm.month_payments_aasm_state);
        vm.displayTransferPayoutAction = vm.checkAasmStateForTransferPayout(vm.month_payments_aasm_state);
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('BookkeepingDeductionController', BookkeepingDeductionController);

  BookkeepingDeductionController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'AdminBookkeepingApi',
    '_',
    'outputErrors',
    'tableEngine',
    'toastsApi'
  ];

  function BookkeepingDeductionController(
    $scope,
    $state,
    $stateParams,
    AdminBookkeepingApi,
    _,
    outputErrors,
    tableEngine,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminBookkeeping';
    vm.errors = outputErrors.createNew();
    vm.deduction = {};
    vm.title = 'deduction.create_deduction';
    vm.table = tableEngine.getTableByName('admin_bookkeepingMonthReport');
    vm.canBeUpdated = false;

    AdminBookkeepingApi.show_deducation($stateParams.month_payment_date, $stateParams.affiliate_id).then(
      function(response) {
        var data = response.data;

        vm.deduction = data.deduction;
        vm.title = vm.deduction.deduction ? 'deduction.edit_deduction' : 'deduction.create_deduction';
        vm.remove_btn = !!vm.deduction.deduction;

        vm.deduction.date_of_payment = $stateParams.month_payment_date;
        vm.aasm_state = data.month_payment_aasm_state;
        vm.canBeUpdated = vm.aasm_state === 'in_process' || vm.aasm_state === 'new_plan';
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.save_deduction = function() {
      AdminBookkeepingApi.save_deduction(vm.deduction).then(
        function() {
          vm.remove_btn = _.some(_.omit(vm.deduction, 'date_of_payment', 'affiliate_id', 'affiliate_username'));
          vm.title = vm.remove_btn ? 'deduction.edit_deduction' : 'deduction.create_deduction';

          vm.table.pagination();

          if (vm.remove_btn) {
            toastsApi.toastEditSuccess();
          } else {
            toastsApi.toastRemoveSuccess();
          }
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.remove_deduction = function() {
      vm.deduction.deduction = 0;
      vm.deduction.deduction_commit = null;
      vm.save_deduction();
    };

    vm.back = function() {
      $state.go('admin_bookkeeping.bookkeeping_month_report', {month_payment_date: $stateParams.month_payment_date});
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('BookkeepingController', BookkeepingController);

  BookkeepingController.$inject = [
    '$scope',
    '$state',
    'tableEngine',
    '_',
    'outputErrors',
    '$injector',
    'toastsApi',
    '$q'
  ];

  function BookkeepingController($scope, $state, tableEngine, _, outputErrors, $injector, toastsApi, $q) {
    var vm = this;

    vm.translate_key = 'AdminBookkeeping';
    vm.errors = outputErrors.createNew();
    vm.stateData = $state.current.data;
    vm.readonly = vm.stateData.readonly;
    vm.childState = vm.stateData.child_state;
    vm.namespace = vm.stateData.namespace;
    vm.bookkeepingApi = $injector.get(vm.stateData.api_name);

    vm.changeMonthStatus = function(data) {
      var deferred = $q.defer();

      if (data.aasm_state === 'can_be_process' && !vm.readonly) {
        vm.bookkeepingApi.chandeStatusMonthPayment(data.date_of_payment).then(
          function() {
            deferred.resolve();
          },
          function() {
            toastsApi.toastError();
            deferred.resolve();
          }
        );
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    };

    vm.show_month = function(mp) {
      vm.changeMonthStatus(mp).then(function() {
        $state.go(vm.childState, {month_payment_date: mp.date_of_payment});
      });
    };

    vm.table = tableEngine.init({
      api: vm.bookkeepingApi,
      name: vm.namespace + '_bookkeeping',
      separate_numbers: true,
      mobile: {
        defaultColumns: ['date_of_payment']
      },
      buttons: {
        url: 'app/components/bookkeeping/partials/table.html',
        methods: {
          show_month: vm.show_month
        }
      }
    });

    vm.bookkeepingApi.get_month_payment().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('date_of_payment', {format: 'MMMM YYYY'});
        vm.table.addOptionsToColumn('aasm_state', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: 'aasm_state.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });
        vm.table.addOptionsToColumn('status', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: 'aasm_state.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AuthApi', AuthApi);

  AuthApi.$inject = [
    '$rootScope',
    '$q',
    '$cookies',
    '$state',
    'SignOutApi',
    'SignInApi',
    'SignUpApi',
    'User',
    'toastsApi',
    'permissionsManager',
    'mfaSettings'
  ];

  function AuthApi(
    $rootScope,
    $q,
    $cookies,
    $state,
    SignOutApi,
    SignInApi,
    SignUpApi,
    User,
    toastsApi,
    permissionsManager,
    mfaSettings
  ) {
    var Auth = {};

    Auth._isSignOutProcess = false;

    Auth.signOut = function() {
      return SignOutApi.signOut();
    };

    Auth.signOutForce = function(supervision) {
      return SignOutApi.signOutForce(supervision);
    };

    Auth.signIn = function(user) {
      return SignInApi.signIn(user);
    };

    Auth.registration = function(affiliate, host) {
      return SignUpApi.registration(affiliate, host);
    };

    Auth.confirmation = function(token) {
      return SignUpApi.confirmation(token);
    };

    Auth.usernameAvailable = function(username) {
      return SignUpApi.usernameAvailable(username);
    };

    Auth.canBeLogout = function() {
      return !Auth._isSignOutProcess && User.getUserProperty('id');
    };

    Auth.csrfTokenUpdate = function(res) {
      if (res && res.headers) {
        $cookies.put('XSRF-TOKEN-X', res.headers('XSRF-TOKEN'));
      }
    };

    Auth.getPermissions = function() {
      return permissionsManager.initPermissions();
    };

    Auth.handleError = function(res) {
      toastsApi.toastError();

      if (res && res.data && res.data.session_token && !res.data.user) {
        Auth.csrfTokenUpdate(res);
        Auth.redirectToLogin();
      }
    };

    Auth.redirectToDashboard = function(currentUser, isSupervision, state) {
      User.setUser(currentUser, isSupervision ? currentUser.id : null);
      $rootScope.$broadcast('set_count_new_partners');
      $rootScope.$broadcast('change_menu');
      $state.go(state || currentUser.namespace);
    };

    Auth.redirectToLogin = function() {
      User.resetUser();
      $state.go('sign_in');
    };

    Auth.redirectToMfaSetup = function(currentUser) {
      User.setUser(currentUser);
      var mfaState =
        currentUser.namespace === 'admin'
          ? 'admin_settings_profile.two_factor_authentication'
          : 'affiliate_settings_profile.two_factor_authentication';
      $state.go(mfaState);
    };

    Auth.redirectDependingOnUser = function(currentUser, isSupervision, state) {
      if (currentUser) {
        if (mfaSettings && !mfaSettings.isEnabled()) {
          Auth.redirectToMfaSetup(currentUser);
        } else {
          Auth.redirectToDashboard(currentUser, isSupervision, state);
        }
      } else {
        Auth.redirectToLogin();
      }
      User.setToStorage();
    };

    Auth.checkUserAccess = function(currentUser, isSupervision, state) {
      return Auth.getPermissions().then(function() {
        Auth.redirectDependingOnUser(currentUser, isSupervision, state);
      });
    };

    Auth.applyLogout = function() {
      var isSupervision = !!User.getSupervisionValue(),
        logoutMethod = isSupervision ? Auth.signOutForce : Auth.signOut;

      return logoutMethod(isSupervision).then(function(res) {
        Auth.csrfTokenUpdate(res);
        return Auth.checkUserAccess(res && res.data && res.data.user, null, isSupervision ? 'partners' : null);
      }, Auth.handleError);
    };

    Auth.userLogout = function() {
      if (!Auth.canBeLogout()) {
        return $q.reject();
      }
      Auth._isSignOutProcess = true;

      return Auth.applyLogout().finally(function() {
        Auth._isSignOutProcess = false;
      });
    };

    return Auth;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('ArticlesViewController', ArticlesViewController);

  ArticlesViewController.$inject = ['$state', '$stateParams', 'ArticlesApi', 'toastsApi'];

  function ArticlesViewController($state, $stateParams, ArticlesApi, toastsApi) {
    var vm = this;

    vm.stateData = $state.current.data;
    vm.translate_key = vm.stateData.translate_key;
    vm.listState = vm.stateData.list_state;
    vm.namespace = vm.stateData.namespace;

    vm.back = function() {
      $state.go(vm.listState);
    };

    ArticlesApi.view(vm.namespace, $stateParams.articleId).then(
      function(response) {
        var data = response.data;

        vm.articleTitle = data.article.title;
        vm.articleContent = data.article.body;
        vm.articleLastUpdate = data.article.updated_at;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('ArticlesSettingsController', ArticlesSettingsController);

  ArticlesSettingsController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    'ArticlesApi',
    'toastsApi',
    'outputErrors',
    'localesStorage',
    '_',
    '$mdTranslate',
    'tableEngine'
  ];

  function ArticlesSettingsController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    ArticlesApi,
    toastsApi,
    outputErrors,
    localesStorage,
    _,
    $mdTranslate,
    tableEngine
  ) {
    var vm = this,
      translteListener;

    vm.stateData = $state.current.data;
    vm.translate_key = vm.stateData.translate_key;
    vm.listState = vm.stateData.list_state;
    vm.titleShortcode = 'articles_settings.header_create';
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('admin_articles');
    vm.article = {};

    vm.back = function() {
      $state.go(vm.listState);
    };

    vm.saveArticle = function() {
      ArticlesApi.save(vm.article).then(
        function() {
          vm.table.pagination();
          toastsApi.toastSuccess();

          if (!vm.article.id) {
            vm.back();
          }
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.prepareLanguagesList = function(list) {
      return _.union(
        [{id: null, translate: $mdTranslate.instant(vm.translate_key, 'articles.language.all')}],
        _.map(list, function(val, key) {
          return {id: key, translate: $mdTranslate.instant('Languages', 'language.' + key)};
        })
      );
    };

    vm.updateLanguagesTranslate = function() {
      vm.languagesList = vm.prepareLanguagesList(localesStorage.getLanguages());
    };

    translteListener = $rootScope.$on('$translateChangeSuccess', function() {
      vm.updateLanguagesTranslate();
    });

    vm.updateLanguagesTranslate();

    if ($stateParams.articleId) {
      vm.titleShortcode = 'articles_settings.header_edit';

      ArticlesApi.view('admin', $stateParams.articleId).then(
        function(response) {
          vm.article = response.data.article;
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    $scope.$on('$destroy', function() {
      translteListener();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('articlesLast', articlesLast);

  articlesLast.$inject = ['$state', '$rootScope', 'ArticlesApi', 'permissionsManager', '_'];

  function articlesLast($state, $rootScope, ArticlesApi, permissionsManager, _) {
    return {
      restrict: 'E',
      scope: {
        options: '='
      },
      bindToController: true,
      templateUrl: 'app/components/articles/partials/last_articles.html',
      controllerAs: '$ctrl',
      controller: function($scope) {
        var vm = this,
          translateListener;

        vm.defaultDateFormat = 'L HH:mm';

        vm.view = function(item) {
          $state.go(vm.options.view_state, {articleId: item.id});
        };

        vm.noArticles = function(list) {
          return _.isArray(list) && list.length === 0;
        };

        vm.getArticles = function() {
          if (!permissionsManager.checkPermission(vm.options.permission)) {
            return;
          }

          ArticlesApi.getLastArticles(vm.options.namespace).then(function(response) {
            vm.articlesList = response.data.list_articles || [];
          });
        };

        translateListener = $rootScope.$on('$translateChangeSuccess', function() {
          vm.getArticles();
        });

        $scope.$on('$destroy', translateListener);

        vm.getArticles();
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('ArticlesApi', ArticlesApi);

  ArticlesApi.$inject = ['mainApi'];

  function ArticlesApi(mainApi) {
    var ArticlesApi = {};

    ArticlesApi.articlesList = function(namespace) {
      var url = namespace + '/articles/list',
        params = {};

      return mainApi.post(url, params);
    };

    ArticlesApi.pagination = function(params) {
      var url = params.additional_options.namespace + '/articles/list',
        _params = params || {};

      return mainApi.post(url, _params);
    };

    ArticlesApi.getLastArticles = function(namespace) {
      var url = namespace + '/articles/list_articles',
        params = {};

      return mainApi.get(url, params);
    };

    ArticlesApi.save = function(data) {
      var url = 'admin/articles/' + (data.id || ''),
        method = data.id ? 'put' : 'post',
        params = {
          article: {
            title: data.title,
            body: data.body,
            locale: data.locale
          }
        };

      return mainApi[method](url, params);
    };

    ArticlesApi.view = function(namespace, id) {
      var url = namespace + '/articles/' + id,
        params = {};

      return mainApi.get(url, params);
    };

    ArticlesApi.destroy = function(id) {
      var url = 'admin/articles/' + id,
        params = {};

      return mainApi['delete'](url, params);
    };

    return ArticlesApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('ArticlesListController', ArticlesListController);

  ArticlesListController.$inject = [
    '$scope',
    '$rootScope',
    '$state',
    'ArticlesApi',
    'tableEngine',
    '_',
    'outputErrors',
    '$mdDialog',
    '$mdTranslate',
    'toastsApi',
    'permissionsManager'
  ];

  function ArticlesListController(
    $scope,
    $rootScope,
    $state,
    ArticlesApi,
    tableEngine,
    _,
    outputErrors,
    $mdDialog,
    $mdTranslate,
    toastsApi,
    permissionsManager
  ) {
    var vm = this,
      translateListener;

    vm.stateData = $state.current.data;
    vm.translate_key = vm.stateData.translate_key;
    vm.namespace = vm.stateData.namespace;
    vm.viewState = vm.stateData.view_state;
    vm.buttons = vm.stateData.buttons || {};
    vm.viewNewsBtn =
      vm.buttons.view && permissionsManager.checkPermission('api2.' + vm.namespace + '.articlescontroller.show');
    vm.editNewsBtn = vm.buttons.edit && permissionsManager.checkPermission('api2.admin.articlescontroller.update');
    vm.destroyNewsBtn =
      vm.buttons.destroy && permissionsManager.checkPermission('api2.admin.articlescontroller.destroy');
    vm.errors = outputErrors.createNew();

    vm.viewArticle = function(item) {
      $state.go(vm.viewState, {articleId: item.id});
    };

    vm.createArticle = function() {
      $state.go('admin_articles.create');
    };

    vm.editArticle = function(item) {
      $state.go('admin_articles.edit', {articleId: item.id});
    };

    vm.destroyArticle = function(item, ev) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'modal_remove.title'))
        .textContent($mdTranslate.instant(vm.translate_key, 'modal_remove.question'))
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, 'modal_remove.delete'))
        .cancel($mdTranslate.instant(vm.translate_key, 'modal_remove.cancel'));

      $mdDialog.show(confirm).then(function() {
        ArticlesApi.destroy(item.id).then(
          function() {
            vm.table.removeListItem();
            toastsApi.toastRemoveSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.showCreateArticleBtn = function() {
      return vm.namespace === 'admin' && permissionsManager.checkPermission('api2.admin.articlescontroller.create');
    };

    vm.translateLanguage = function(lang) {
      if (lang === 'all') {
        return $mdTranslate.instant(vm.translate_key, 'articles.language.all');
      } else {
        return $mdTranslate.instant('Languages', 'language.' + lang);
      }
    };

    vm.table = tableEngine.init({
      api: ArticlesApi,
      name: vm.namespace + '_articles',
      mobile: {
        defaultColumns: ['title']
      },
      buttons: {
        url: 'app/components/articles/partials/table.html',
        methods: {
          viewNews: vm.viewNewsBtn ? vm.viewArticle : null,
          editNews: vm.editNewsBtn ? vm.editArticle : null,
          destroyNews: vm.destroyNewsBtn ? vm.destroyArticle : null
        }
      },
      params: {
        data: {
          additional_options: {
            namespace: vm.namespace
          }
        }
      }
    });

    ArticlesApi.articlesList(vm.namespace).then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('locale', {
          filterValue: vm.translateLanguage
        });
      },
      function() {
        toastsApi.toastError();
      }
    );

    translateListener = $rootScope.$on('$translateChangeSuccess', function() {
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
      translateListener();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('mainApi', mainApi);

  mainApi.$inject = ['$state', '$http', '$mdDialog', 'envService', 'toastsApi', 'User', '$interpolate', '_'];

  function mainApi($state, $http, $mdDialog, envService, toastsApi, User, $interpolate, _) {
    var urlBase = envService.read('apiUrl'),
      methods = ['get', 'post', 'put', 'delete'],
      commonUrlsPart = ['permission', 'translate', 'anonym/notifications', 'disable_supervision', 'sign_out'],
      supervisionUrlPart = 'admin/supervision/',
      main = {};

    main.isSupervision = function() {
      return User.getSupervisionValue();
    };

    main.isNotCommonUrl = function(url) {
      return _.every(commonUrlsPart, function(part) {
        return url.indexOf(part) === -1;
      });
    };

    main.getResponseMetaDataForSentry = function(response) {
      return {
        status: response.status,
        method: response.config.method,
        url: response.config.url,
        reqDataKey: response.config.params ? 'params' : 'data',
        reqData: JSON.stringify(response.config.params || response.config.data || {})
      };
    };

    main.getErrorMessageForSentry = function(template, data) {
      return $interpolate(template)(data);
    };

    main.captureException = function(response) {
      if (!window.Raven || !window.Raven.isSetup() || response.status < 500) {
        return;
      }

      var message = main.getErrorMessageForSentry(
        'status: {{status}}; method: {{method}}; url: {{url}}; {{reqDataKey}}: {{reqData}};',
        main.getResponseMetaDataForSentry(response)
      );

      window.Raven.captureException(new Error(message));
    };

    main.checkInSupervision = function(res) {
      if (res.data && res.data.redirect_to_supervision) {
        $mdDialog.cancel();
        toastsApi.toastError({status: 'access_error'});
        $state.go('check_access', {user: res.data.current_user, isSupervision: true});
      }
    };

    main.userUnauthorized = function(response) {
      if (!response.data || response.data.authorized !== false) {
        return;
      }

      $mdDialog.cancel();
      toastsApi.toastError({status: 'access_error'});

      // authorized: false is returned both when the session is genuinely gone (401 — an
      // expired session with no valid remember-me cookie to fall back on) AND when a logged-in
      // user just lacks permission for this one action (CanCan::AccessDenied, 400 Bad Request).
      // Only the former should force a full logout — nuking the session on a plain permission
      // gap was needlessly disruptive, and on a remembered device would incorrectly revoke it
      // (logout calls sign_out for real, which now also revokes the trusted-device cookie).
      if (response.status === 401) {
        $state.go('logout');
      }
    };

    main.getRequestUrl = function(url) {
      return main.isSupervision() && main.isNotCommonUrl(url) ? urlBase + supervisionUrlPart + url : urlBase + url;
    };

    main.getRequestParams = function(params, m) {
      var isSV = !!main.isSupervision(),
        _params = params;

      if (isSV) {
        _params.supervision = isSV;
      }

      return m === 'get' ? {params: _params} : _params;
    };

    _.each(methods, function(m) {
      main[m] = function(url, _params, config) {
        var realUrl = main.getRequestUrl(url),
          realParams = main.getRequestParams(_params, m),
          method = $http[m](realUrl, realParams, config);

        method.then(
          function(response) {
            return response;
          },
          function(response) {
            main.captureException(response);
            main.checkInSupervision(response);
            main.userUnauthorized(response);

            return response;
          }
        );

        return method;
      };
    });

    return main;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('UnsubscribeController', UnsubscribeController);

  UnsubscribeController.$inject = ['$stateParams', 'UnsubscribeApi', 'toastsApi'];

  function UnsubscribeController($stateParams, UnsubscribeApi, toastsApi) {
    var vm = this;

    vm.translate_key = 'UnsubscribePage';
    vm.token = $stateParams.token;
    vm.showText = false;
    vm.isSubscribed = true;

    UnsubscribeApi.checkSubscribeStatus(vm.token).then(
      function(response) {
        vm.isSubscribed = !response.data.unsubscribe_status;
        vm.showText = true;
      },
      function() {
        vm.showText = true;
        toastsApi.toastError();
      }
    );

    vm.unsubscribe = function() {
      UnsubscribeApi.unsubscribe(vm.token).then(
        function() {
          vm.isSubscribed = false;
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider) {
    $stateProvider.state('affiliate_unsubscribe', {
      url: '/unsubscribe/:token',
      templateUrl: 'app/auth/unsubscribe/partials/unsubscribe.html',
      controller: 'UnsubscribeController',
      controllerAs: 'UnsubscribeCtrl'
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      auth: {
        affiliate_unsubscribe: [
          'want_to_unsubscribe||affiliate_unsubscribe.want_to_unsubscribe',
          'have_been_unsubscribed||affiliate_unsubscribe.have_been_unsubscribed',
          'unsubscribe_button||affiliate_unsubscribe.unsubscribe_button'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('UnsubscribePage', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SignInController', SignInController);

  SignInController.$inject = [
    'AuthApi',
    'outputErrors',
    'loginAnimation',
    'User',
    'toastsApi',
    'AnonymRulesApi',
    'AffiliateBannerRunner',
    '$timeout',
    'mfaSettings'
  ];

  function SignInController(
    AuthApi,
    outputErrors,
    loginAnimation,
    User,
    toastsApi,
    AnonymRulesApi,
    AffiliateBannerRunner,
    $timeout,
    mfaSettings
  ) {
    var vm = this;

    vm.translate_key = 'AuthSignIn';
    vm.errors = outputErrors.createNew();
    vm.user = {};
    vm.requireMfaCode = false;

    vm.getTerms = function(ev) {
      AnonymRulesApi.getTerms('AuthRegistration', 'terms.header', ev);
    };

    vm.acceptUser = function(currentUser) {
      return AuthApi.checkUserAccess(currentUser).then(function() {
        loginAnimation.enable();
        $timeout(function() {
          AffiliateBannerRunner.checkBanner();
        }, 2600);
      });
    };

    vm.isUser = function() {
      return User.getUserProperty('id');
    };

    vm.login = function() {
      if (vm.isUser()) {
        return;
      }

      return AuthApi.signIn(vm.user).then(
        function(res) {
          // 로그인 응답에서 받은 mfa_enabled 상태를 업데이트
          if (res.mfa_enabled !== undefined) {
            mfaSettings.setEnabled(res.mfa_enabled);
          }
          return vm.acceptUser(res.user);
        },
        function(response) {
          if (response.data && response.data.required_mfa_code) {
            vm.requireMfaCode = true;
          }
          vm.errors.inputErrors(response.data && response.data.errors);

          if (!response.data) {
            toastsApi.toastError();
          }
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider) {
    $stateProvider.state('sign_in', {
      url: '/sign_in',
      templateUrl: 'app/auth/sign_in/partials/sign_in.html',
      controller: 'SignInController',
      controllerAs: 'signIn',
      resolve: {
        isLogged: [
          '$state',
          'User',
          '$timeout',
          function($state, User, $timeout) {
            if (User.getUserProperty('id')) {
              $timeout(function() {
                $state.go('home');
              }, 0);
            }
          }
        ]
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      auth: {
        sign_in: [
          'title||sign_in.title',
          'email||sign_in.email',
          'password||sign_in.password',
          'password_new||sign_in.password_new',
          'submit||sign_in.submit',
          'two_factor_auth_description||sign_in.two_factor_auth_description',
          'mfa_code||sign_in.mfa_code',
          'remember_device||sign_in.remember_device'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AuthSignIn', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('AnonymRulesApi', AnonymRulesApi);

  AnonymRulesApi.$inject = ['$mdDialog', 'InfoPagesApi', 'localesStorage'];

  function AnonymRulesApi($mdDialog, InfoPagesApi, localesStorage) {
    var rulesApi = {};

    rulesApi.createModal = function(data, translateKey, headerShortcode, ev) {
      $mdDialog.show({
        controller: 'AnonymRulesController',
        controllerAs: '$ctrl',
        templateUrl: 'app/auth/rules/rules.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: {
          translateKey: translateKey,
          modalTitle: headerShortcode,
          modalContent: data.content,
          updatedAt: data.updated_at
        }
      });
    };

    rulesApi._getRules = function(methodName, translateKey, titleShortcode, ev) {
      InfoPagesApi[methodName](localesStorage.getCurrentLocale()).then(function(response) {
        rulesApi.createModal(response.data, translateKey, titleShortcode, ev);
      });
    };

    rulesApi.getTerms = function(translateKey, titleShortcode, ev) {
      rulesApi._getRules('get_anonym_terms', translateKey, titleShortcode, ev);
    };

    rulesApi.getPrivacy = function(translateKey, titleShortcode, ev) {
      rulesApi._getRules('get_anonym_privacy', translateKey, titleShortcode, ev);
    };

    return rulesApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AnonymRulesController', AnonymRulesController);

  AnonymRulesController.$inject = ['$mdDialog'];

  function AnonymRulesController($mdDialog) {
    var vm = this;

    vm.closeModal = function() {
      $mdDialog.cancel();
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(stateProviderConfig);

  /** @ngInject */
  function stateProviderConfig($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('affiliate_data', {
        url: '/registration',
        templateUrl: 'app/auth/registration/partials/affiliate_data.html',
        controller: 'RegistrationController',
        controllerAs: 'registration',
        data: {
          permissions: permissionsStateAccess.init(['api2.anonym.registrationscontroller.create'])
        }
      })
      .state('affiliate_data.confirmation', {
        url: '/confirmation/:token',
        templateUrl: 'app/auth/registration/partials/confirmation.html',
        controller: 'AuthConfirmationController',
        controllerAs: 'confirmCtrl'
      })
      .state('affiliate_data.done', {
        url: '/done',
        templateUrl: 'app/auth/registration/partials/done.html'
      })
      .state('affiliate_registration', {
        url: '/affiliate_ref/{token}',
        resolve: {
          isToken: [
            '$state',
            '$stateParams',
            '$q',
            'AffiliateRegistrationApi',
            function($state, $stateParams, $q, AffiliateRegistrationApi) {
              var deferred = $q.defer(),
                token = $stateParams.token;

              if (token) {
                AffiliateRegistrationApi.registration(token).then(
                  function() {
                    deferred.reject();
                    $state.go('affiliate_data');
                  },
                  function() {
                    deferred.reject();
                    $state.go('affiliate_data');
                  }
                );
              } else {
                deferred.reject();
                $state.go('affiliate_data');
              }

              return deferred.promise;
            }
          ]
        }
      });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('RegistrationController', RegistrationController);

  RegistrationController.$inject = ['$state', 'AuthApi', 'outputErrors', 'registrationFields', '_', 'AnonymRulesApi'];

  function RegistrationController($state, AuthApi, outputErrors, registrationFields, _, AnonymRulesApi) {
    var vm = this,
      usernameCheckId = 0;

    vm.translate_key = 'AuthRegistration';
    vm.new_user = {};
    vm.new_user.birthday = null;
    vm.maxDate = new Date();
    vm.errors = outputErrors.createNew();
    vm.fields_map = {};

    vm.accept_terms_and_conditions = false;

    vm.new_user.agree_receive_emails = false;

    _.each(registrationFields.getFields(), function(v) {
      vm.fields_map[v.id] = v.check;
    });

    vm.checkUsername = function() {
      var username = vm.new_user.username,
        checkId = ++usernameCheckId;

      if (!username) {
        vm.errors.setFieldErrors('username', null);
        return;
      }

      AuthApi.usernameAvailable(username).then(function(response) {
        if (checkId !== usernameCheckId) {
          return;
        }

        vm.errors.setFieldErrors('username', response.data.available ? null : response.data.errors.username);
      });
    };

    vm.registration = function() {
      if (!vm.accept_terms_and_conditions) {
        return;
      }

      usernameCheckId += 1;

      return AuthApi.registration(vm.new_user).then(
        function() {
          $state.go('affiliate_data.confirmation');
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.getRules = function(ev) {
      ev.stopPropagation();

      AnonymRulesApi.getTerms(vm.translate_key, 'terms.header', ev);
    };

    vm.getTariffs = function(ev) {
      ev.stopPropagation();

      AnonymRulesApi.getPrivacy(vm.translate_key, 'privacy.header', ev);
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      auth: {
        registration: [
          'header||registration.header',
          'submit_btn||registration.submit_btn',
          'attention_first_part||registration.attention_first_part',
          'attention_second_part||registration.attention_second_part',
          'attention_last_part||registration.attention_last_part',
          {
            form: [
              'name||form.name',
              'surname||form.surname',
              'username||form.username',
              'email||form.email',
              'password||form.password',
              'phone_number||form.phone_number',
              'skype||form.skype',
              'telegram||form.telegram',
              'birthday||form.birthday',
              'site_url||form.site_url',
              'about_affiliate||form.about_affiliate',
              'agree_receive_emails||form.agree_receive_emails'
            ],
            confirmation: [
              'header||confirmation.header',
              'hint||confirmation.hint',
              'token||confirmation.token',
              'confirm_email||confirmation.confirm_email',
              'next||confirmation.next'
            ],
            done: ['header||done.header', 'description||done.description', 'finish||done.finish']
          },
          {
            terms: ['header||terms.header']
          },
          {
            privacy: ['header||privacy.header']
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AuthRegistration', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AuthConfirmationController', AuthConfirmationController);

  AuthConfirmationController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    'AuthApi',
    'outputErrors',
    'autoAcceptAffiliateRequest',
    'toastsApi'
  ];

  function AuthConfirmationController(
    $scope,
    $state,
    $stateParams,
    $timeout,
    AuthApi,
    outputErrors,
    autoAcceptAffiliateRequest,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AuthRegistration';
    vm.confirmation_token = $stateParams.token;
    vm.errors = outputErrors.createNew();

    vm.confirmation = function() {
      if (vm.confirmationForm.$invalid) {
        return;
      }

      return AuthApi.confirmation(vm.confirmation_token).then(
        function() {
          toastsApi.toastSuccess({translate_key: vm.translate_key, shortcode: 'confirmation.confirm_email'});
          $state.go(autoAcceptAffiliateRequest.getAccept() ? 'sign_in' : 'affiliate_data.done');
        },
        function(response) {
          vm.errors.inputErrors({
            confirmation_token: response.data.errors.confirmation_token || response.data.errors.email
          });
        }
      );
    };

    vm.dispatchSubmitEvent = function() {
      $scope.$broadcast('$dispatchSubmitEvent', {name: vm.confirmationForm.$name});
    };

    if (vm.confirmation_token) {
      $timeout(function() {
        vm.dispatchSubmitEvent();
      }, 0);
    }
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider) {
    $stateProvider
      .state('password_new', {
        name: 'password_new',
        url: '/passwords/password_new',
        templateUrl: 'app/auth/change_password/partials/password_new.html',
        controller: 'PasswordsController',
        controllerAs: 'changePassword',
        resolve: {
          isLogged: [
            '$state',
            'User',
            '$timeout',
            function($state, User, $timeout) {
              if (User.getUserProperty('id')) {
                $timeout(function() {
                  $state.go('home');
                }, 0);
              }
            }
          ]
        }
      })
      .state('confirm_email', {
        name: 'confirm_email',
        url: '/passwords/confirm_email/:token',
        templateUrl: 'app/auth/change_password/partials/confirm_email.html',
        controller: 'PasswordsController',
        controllerAs: 'changePassword'
      })
      .state('change_password', {
        name: 'change_password',
        url: '/passwords/change_password/:token',
        templateUrl: 'app/auth/change_password/partials/change_password.html',
        controller: 'PasswordsController',
        controllerAs: 'changePassword',
        resolve: {
          checkToken: function($state, $stateParams, $timeout) {
            if (!$stateParams.token) {
              $timeout(function() {
                $state.go('confirm_email');
              }, 0);
            }
          }
        }
      })
      .state('save_password', {
        name: 'save_password',
        url: '/passwords/save_password/:token',
        templateUrl: 'app/auth/change_password/partials/save_password.html',
        controller: 'PasswordsController',
        controllerAs: 'changePassword',
        resolve: {
          checkToken: function($state, $stateParams, $timeout) {
            if (!$stateParams.token) {
              $timeout(function() {
                $state.go('confirm_email');
              }, 0);
            }
          }
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('PasswordsController', PasswordsController);

  PasswordsController.$inject = [
    '$scope',
    '$timeout',
    '$state',
    '$stateParams',
    'ChangePasswordApi',
    'outputErrors',
    'toastsApi'
  ];

  function PasswordsController($scope, $timeout, $state, $stateParams, ChangePasswordApi, outputErrors, toastsApi) {
    var vm = this;

    vm.translate_key = 'AuthChangePassword';
    vm.translateNamespace = 'auth.restore_password';
    vm.confirmation = $stateParams.token;
    vm.errors = outputErrors.createNew();

    vm.submitForm = function() {
      if (vm.userEmailForm.$valid) {
        return ChangePasswordApi.putEmail(vm.email).then(
          function() {
            $state.go('confirm_email');
          },
          function(response) {
            vm.errors.inputErrors(response.data.errors);
          }
        );
      }
    };

    vm.confirmationChange = function() {
      if (vm.confirmEmailForm.$valid) {
        return ChangePasswordApi.confirmEmail(vm.confirmation).then(
          function() {
            $state.go('change_password', {token: vm.confirmation});
          },
          function(response) {
            vm.errors.inputErrors(response.data.errors);
          }
        );
      }
    };

    vm.submitPasswordForm = function() {
      if (vm.newPasswordForm.$valid) {
        return ChangePasswordApi.changePassword(vm.password, vm.password_confirmation, vm.confirmation).then(
          function() {
            $state.go('save_password', {token: vm.confirmation});
          },
          function(response) {
            var errors = response.data.errors;

            if (errors.reset_password_token) {
              toastsApi.toastError(errors.reset_password_token[0]);
            }

            vm.errors.inputErrors(errors);
          }
        );
      }
    };

    vm.dispatchSubmitEvent = function() {
      if (!vm.confirmEmailForm) {
        return;
      }

      $scope.$broadcast('$dispatchSubmitEvent', {name: vm.confirmEmailForm.$name});
    };

    if (vm.confirmation) {
      $timeout(function() {
        vm.dispatchSubmitEvent();
      }, 0);
    }
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      auth: {
        restore_password: {
          new_password: [
            'header||new_password.header',
            'text||new_password.text',
            'email||new_password.email',
            'submit||new_password.submit'
          ],
          confirm_email: [
            'header||confirm_email.header',
            'token||confirm_email.token',
            'text||confirm_email.text',
            'submit||confirm_email.submit'
          ],
          change_password: [
            'header||change_password.header',
            'password||change_password.password',
            'password_confirmation||change_password.password_confirmation',
            'submit||change_password.submit'
          ],
          save_password: ['header||save_password.header', 'text||save_password.text', 'log_in||save_password.log_in']
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AuthChangePassword', list);
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateWebhooksHistoryDetailsController', AffiliateWebhooksHistoryDetailsController);

  AffiliateWebhooksHistoryDetailsController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'WebhooksHistoryApi',
    '_',
    'tableEngine',
    'toastsApi',
    'defaultDateFormat'
  ];

  function AffiliateWebhooksHistoryDetailsController(
    $scope,
    $state,
    $stateParams,
    WebhooksHistoryApi,
    _,
    tableEngine,
    toastsApi,
    defaultDateFormat
  ) {
    var vm = this;

    vm.stateData = $state.current.data;
    vm.translate_key = vm.stateData.translateKey;
    vm.namespace = vm.stateData.namespace;

    vm.back = function() {
      $state.go('^');
    };

    vm.table = tableEngine.init({
      api: WebhooksHistoryApi,
      name: vm.namespace + '_webhooks_history_details',
      api_method: 'detailsPagination',
      mobile: {
        defaultColumns: ['kind']
      },
      params: {
        data: {
          additional_options: {
            namespace: vm.namespace,
            id: $stateParams.id
          }
        }
      }
    });

    WebhooksHistoryApi.listDetails(vm.namespace, $stateParams.id).then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('updated_at', {format: defaultDateFormat + ' HH:mm:ss'});
        vm.table.addOptionsToColumn('response_body', {insertAsText: true});
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateWebhooksHistoryController', AffiliateWebhooksHistoryController);

  AffiliateWebhooksHistoryController.$inject = [
    '$scope',
    '$state',
    'WebhooksHistoryApi',
    '_',
    'tableEngine',
    'toastsApi',
    'downloadReport',
    'permissionsManager',
    'defaultDateFormat'
  ];

  function AffiliateWebhooksHistoryController(
    $scope,
    $state,
    WebhooksHistoryApi,
    _,
    tableEngine,
    toastsApi,
    downloadReport,
    permissionsManager,
    defaultDateFormat
  ) {
    var vm = this;

    vm.stateData = $state.current.data;
    vm.translate_key = vm.stateData.translateKey;
    vm.downloadPermission = vm.stateData.downloadReportPermission;
    vm.namespace = vm.stateData.namespace;
    vm.tableFiliterColumns = vm.stateData.tableFiliterColumns;
    vm.downloadingIsPermitted = permissionsManager.checkPermission(vm.downloadPermission);

    vm.applyDownloadReport = function(data) {
      return WebhooksHistoryApi.downloadReport(vm.namespace, data, vm.table.getSegmentId());
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.showDetails = function(item) {
      $state.go('.details', {id: item.id});
    };

    vm.table = tableEngine.init({
      api: WebhooksHistoryApi,
      name: vm.namespace + '_webhooks_history',
      mobile: {
        defaultColumns: ['kind']
      },
      buttons: {
        url: 'app/affiliate/webhooks_history/partials/table.html',
        methods: {
          showDetails: vm.showDetails
        }
      },
      params: {
        data: {
          additional_options: {
            namespace: vm.namespace
          }
        }
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/' + vm.namespace + '/requests',
        actionForFilter: 'list',
        byMerchant: true,
        filterName: 'webhook_request'
      }
    });

    if (vm.downloadingIsPermitted) {
      WebhooksHistoryApi.getDownloadReportOptions(vm.namespace).then(
        function(response) {
          var data = response.data;

          vm.downloadFormats = data.separators_for_format;
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    WebhooksHistoryApi.list(vm.namespace).then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('updated_at', {format: defaultDateFormat + ' HH:mm:ss'});
        vm.table.addOptionsToColumn('response_body', {insertAsText: true});
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.resetFilter();
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('webhooks_history', {
        url: '/webhooks_history',
        templateUrl: 'app/affiliate/webhooks_history/partials/webhooks_history.html',
        controller: 'AffiliateWebhooksHistoryController',
        controllerAs: 'webhooksHistoryCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.affiliate.requestscontroller.show']),
          namespace: 'affiliate',
          downloadReportPermission: 'api2.affiliate.requestscontroller.download_report',
          translateKey: 'WebhooksHistory',
          tableFiliterColumns: [
            {
              name: 'merchant_name',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'webhook_id',
              type: 'compare',
              display: true,
              empty: true
            },
            {
              name: 'serial_id',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'kind',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'uri',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'params',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'updated_at',
              type: 'date',
              display: true,
              empty: true
            },
            {
              name: 'response_code',
              type: 'checkbox',
              display: true,
              empty: true
            }
          ]
        }
      })
      .state('webhooks_history.details', {
        url: '/details/:id',
        templateUrl: 'app/affiliate/webhooks_history/partials/webhooks_history_details.html',
        controller: 'AffiliateWebhooksHistoryDetailsController',
        controllerAs: 'historyDetailsCtrl',
        data: {
          namespace: 'affiliate',
          translateKey: 'WebhooksHistory'
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        webhooks_history: [
          'header||webhooks_history.header',
          'download_report_btn||webhooks_history.download_report',
          {
            history_details: ['header||webhooks_history_details.header', 'back||webhooks_history_details.back']
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('WebhooksHistory', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('WebhooksSettingsController', WebhooksSettingsController);

  WebhooksSettingsController.$inject = [
    '$state',
    '$stateParams',
    '$mdDialog',
    '$q',
    '$injector',
    'outputErrors',
    '_',
    'toastsApi',
    '$mdTranslate'
  ];

  function WebhooksSettingsController(
    $state,
    $stateParams,
    $mdDialog,
    $q,
    $injector,
    outputErrors,
    _,
    toastsApi,
    $mdTranslate
  ) {
    var vm = this;

    vm.translate_key = 'Webhooks';
    vm.stateData = $state.current.data;
    vm.isAdmin = vm.stateData.admin;
    vm.apiFactory = $injector.get(vm.stateData.apiName);
    vm.disabled_all = true;
    vm.webhook = {};
    vm.webhook.kind = $stateParams.webhookType;
    vm.show_content = false;
    vm.errors = outputErrors.createNew();

    vm.back = function() {
      $state.go(vm.stateData.parentState + '.' + $stateParams.webhookType);
    };

    vm.showAddConditionBtn = function() {
      return vm.webhook.kind === 'activity' ? true : _.size(vm.conditions) === 0;
    };

    vm.addCondition = function(ev) {
      if (vm.disabled_all) {
        return;
      }

      var condition = {};

      vm.set_condition(ev, condition).then(function() {
        vm.conditions.push(condition);
      });
    };

    vm.removeCondition = function(ev, conditionItem) {
      ev.stopPropagation();

      var confirm = $mdDialog.confirm();

      confirm.title($mdTranslate.instant(vm.translate_key, 'remove_condition_modal.title'));
      confirm.textContent($mdTranslate.instant(vm.translate_key, 'remove_condition_modal.question'));
      confirm.targetEvent(ev);
      confirm.ok($mdTranslate.instant(vm.translate_key, 'remove_condition_modal.answer_yes'));
      confirm.cancel($mdTranslate.instant(vm.translate_key, 'remove_condition_modal.answer_no'));

      $mdDialog.show(confirm).then(function() {
        vm.apiFactory.removeCondition(vm.webhook.id, conditionItem.id, $stateParams.partnerId).then(
          function() {
            vm.conditions = _.reject(vm.conditions, {id: conditionItem.id});
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.save_trackers = function(data, tabId, direction, searchTerm) {
      var deferred = $q.defer(),
        params = {};

      if (searchTerm && data === 'all') {
        params.search = searchTerm;
        params.value = data;
      } else {
        params.value = data;
      }

      vm.apiFactory.save_trackers(vm.webhook.id, params, direction, $stateParams.partnerId).then(
        function() {
          deferred.resolve();
        },
        function() {
          deferred.reject();
        }
      );

      return deferred.promise;
    };

    vm.set_condition = function(ev, condition) {
      if (vm.disabled_all) {
        return;
      }

      var clone = _.defaults(_.clone(condition), {
          obtained_result: '',
          condition_for_comparison: null,
          desired_value: null
        }),
        modalPromise = $mdDialog.show({
          controller: 'WebhooksConditionModalController',
          controllerAs: 'modal',
          templateUrl: 'app/affiliate/webhooks/partials/condition_modal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          bindToController: true,
          locals: {
            webhook_id: vm.webhook.id,
            condition: condition || {},
            options_for_conditions: vm.options_for_conditions || {},
            apiFactory: vm.apiFactory,
            partnerId: $stateParams.partnerId
          }
        });

      modalPromise.then(_.noop, function() {
        _.extend(condition, clone);
      });

      return modalPromise;
    };

    vm.update_webhook = function() {
      var deferred = $q.defer();

      vm.apiFactory.save_webhook(vm.webhook, $stateParams.partnerId).then(
        function(response) {
          vm.disabled_all = response.data.webhook.build;

          deferred.resolve();
        },
        function(response) {
          deferred.reject(response.data.errors);
        }
      );

      return deferred.promise;
    };

    vm.update_uri_options = function(option) {
      var deferred = $q.defer();

      vm.apiFactory.save_uri_options(vm.webhook.id, option, $stateParams.partnerId).then(
        function(response) {
          deferred.resolve(response.data.uri_option);
        },
        function(response) {
          deferred.reject(response.data.errors);
        }
      );

      return deferred.promise;
    };

    vm.remove_uri_option = function(option) {
      var deferred = $q.defer();

      vm.apiFactory.remove_uri_options(vm.webhook.id, option, $stateParams.partnerId).then(
        function() {
          deferred.resolve();
        },
        function(response) {
          deferred.reject();
          vm.errors.inputErrors(response.data.errors);
        }
      );

      return deferred.promise;
    };

    vm.apiFactory.edit($stateParams.webhookId, $stateParams.partnerId).then(
      function(response) {
        var data = response.data;

        vm.webhook = data.webhook;
        vm.serial_ids = data.serial_ids;
        vm.uri_options = data.uri_options;
        vm.request_methods = data.request_methods;
        vm.disabled_all = data.webhook.build;
        vm.conditions = data.conditions;
        vm.options_for_conditions = _.isEmpty(data.condition_options) ? null : data.condition_options;
        vm.show_content = true;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('WebhooksTabController', WebhooksTabController);

  WebhooksTabController.$inject = [
    '$scope',
    '$injector',
    '$state',
    '$stateParams',
    'tabsApi',
    'tableEngine',
    'toastsApi'
  ];

  function WebhooksTabController($scope, $injector, $state, $stateParams, tabsApi, tableEngine, toastsApi) {
    var vm = this;

    vm.translate_key = 'Webhooks';
    vm.stateData = $state.current.data;
    vm.isAdmin = vm.stateData.admin;
    vm.apiFactory = $injector.get(vm.stateData.apiName);
    vm.tabs = tabsApi.getTabsByName('webhooks');

    vm.editWebhook = function(webhook) {
      $state.go(vm.stateData.editState, {webhookId: webhook.id, webhookType: webhook.type || vm.stateData.type});
    };

    vm.updateWebhookState = function(webhook, ev) {
      ev.stopPropagation();

      vm.apiFactory.change_state(webhook, $stateParams.partnerId).then(
        function() {
          vm.table.updateListItemById({active: !webhook.active}, webhook.id);
          toastsApi.toastEditSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.table = tableEngine.getOrCreate({
      api: vm.apiFactory,
      name: 'webhooks_' + vm.stateData.type,
      mobile: {
        defaultColumns: ['uri']
      },
      buttons: {
        url: 'app/affiliate/webhooks/partials/table.html',
        methods: {
          edit: vm.editWebhook,
          update: vm.updateWebhookState
        }
      },
      params: {
        data: {
          additional_options: {
            type: vm.stateData.type,
            partnerId: $stateParams.partnerId
          }
        }
      }
    });

    vm.tabs.setUpTable(vm.stateData.type, vm.table);

    if (!vm.table.isRendered()) {
      vm.apiFactory.list(vm.stateData.type, $stateParams.partnerId).then(
        function(response) {
          var data = response.data,
            opts = {
              locale_key: data.locale_key,
              columns: data.columns_for_display_data,
              list: data.list,
              total_pages: data.total_pages,
              total_entries: data.total_entries,
              start_row_num: data.start_row_num,
              end_row_num: data.end_row_num
            };

          vm.table.update(opts);
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('WebhooksController', WebhooksController);

  WebhooksController.$inject = [
    '$scope',
    '$injector',
    '$state',
    '$stateParams',
    '$mdDialog',
    'tabsApi',
    'tableEngine',
    '_',
    'toastsApi',
    '$interpolate'
  ];

  function WebhooksController(
    $scope,
    $injector,
    $state,
    $stateParams,
    $mdDialog,
    tabsApi,
    tableEngine,
    _,
    toastsApi,
    $interpolate
  ) {
    var vm = this;

    vm.translate_key = 'Webhooks';
    vm.stateData = $state.current.data;
    vm.isAdmin = vm.stateData.admin;
    vm.apiFactory = $injector.get(vm.stateData.apiName);
    vm.affiliateInfo = '';

    vm.buildTabs = function(list) {
      return _.map(list, function(val) {
        return {
          name: val,
          shortcode: val + '.tab_name',
          state: vm.stateData.parentState + '.' + val,
          table: null,
          stateParams: {
            partnerId: $stateParams.partnerId
          }
        };
      });
    };

    vm.tabs = tabsApi.init({
      name: 'webhooks',
      translateKey: vm.translate_key,
      list: vm.buildTabs(vm.stateData.tabsList)
    });

    vm.editWebhook = function(webhook) {
      $state.go(vm.stateData.editState, {webhookId: webhook.id, webhookType: webhook.type || vm.stateData.type});
    };

    vm.destroyAllTables = function() {
      _.each(vm.stateData.tabsList, function(val) {
        var table = tableEngine.getTableByName('webhooks_' + val);

        if (table) {
          table.destroy();
        }
      });
    };

    vm.createWebhook = function(ev) {
      $mdDialog
        .show({
          controller: 'WebhooksCreateModalController',
          controllerAs: 'createCtrl',
          templateUrl: 'app/affiliate/webhooks/partials/create_webhook_modal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          bindToController: true,
          locals: {
            types_list: vm.stateData.tabsList,
            webhook_type: vm.tabs.activeTab.name,
            apiFactory: vm.apiFactory,
            partnerId: $stateParams.partnerId
          }
        })
        .then(function(data) {
          vm.editWebhook(data);
        });
    };

    vm.back = function() {
      $state.go('partners');
    };

    if (vm.isAdmin) {
      vm.apiFactory.getAffiliate($stateParams.partnerId).then(
        function(response) {
          var data = response.data.affiliate;

          data.id = $stateParams.partnerId;

          vm.affiliateInfo = $interpolate(' {{id}} - {{email}} - {{username}}')(data);
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    $scope.$on('$destroy', function() {
      vm.destroyAllTables();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('urlConstructor', urlConstructor);

  urlConstructor.$inject = ['$filter', '$timeout', 'outputErrors', '_'];

  function urlConstructor($filter, $timeout, outputErrors, _) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        uriOptions: '=',
        webhook: '=',
        requestMethods: '=',
        webhookCallback: '&',
        optionsCallback: '&',
        removeCallback: '&',
        allDisabled: '=?',
        translateKey: '='
      },
      templateUrl: 'app/affiliate/webhooks/partials/url_constructor.html',
      controllerAs: 'urlCtrl',
      controller: function($scope) {
        var vm = this,
          uri_def = null,
          pattern = {
            key: '',
            value: '',
            description: '',
            aasm_state: 'custom',
            active: true
          };

        vm.errors = outputErrors.createNew();

        vm.change_webhook = function(delay) {
          if (uri_def) {
            $timeout.cancel(uri_def);
          }

          uri_def = $timeout(
            function() {
              if ($scope.webhookCallback) {
                $scope.webhookCallback().then(
                  function() {
                    vm.build_url();
                  },
                  function(error) {
                    vm.errors.inputErrors(error);
                  }
                );
              }
            },
            angular.isDefined(delay) ? delay : 500
          );
        };

        vm.update_uri_default_options = function(option, delay) {
          if (option.deferred) {
            $timeout.cancel(option.deferred);
          }

          option.deferred = $timeout(
            function() {
              if ($scope.optionsCallback) {
                $scope.optionsCallback({option: option}).then(
                  function() {
                    vm.build_url();
                  },
                  function() {}
                );
              }
            },
            angular.isDefined(delay) ? delay : 500
          );
        };

        vm.update_uri_custom_options = function(option, delay) {
          if (option.deferred) {
            $timeout.cancel(option.deferred);
          }

          option.deferred = $timeout(
            function() {
              if ($scope.optionsCallback) {
                if (!option.id) {
                  option.disable = true;
                }

                $scope.optionsCallback({option: option}).then(
                  function(uri_option) {
                    var key = option.id ? option.id + '' : 'key';

                    vm.keyForm[key].$setValidity(key, true);

                    if (!option.id) {
                      option.id = uri_option.id;
                    }

                    vm.add_empty_row(vm.custom_uri_options);
                    vm.build_url();

                    option.disable = false;
                  },
                  function(error) {
                    if (error.key) {
                      var key = option.id ? option.id + '' : 'key';

                      vm.keyForm[key].$setValidity(key, false);
                      vm.keyForm[key].$setTouched();
                      vm.error_key_message = error.key;
                    }
                    option.disable = false;
                  }
                );
              }
            },
            angular.isDefined(delay) ? delay : 500
          );
        };

        vm.remove_option = function(option) {
          if ($scope.removeCallback) {
            $scope.removeCallback({option: option}).then(
              function() {
                vm.custom_uri_options = _.reject(vm.custom_uri_options, {id: option.id});
                vm.build_url();
              },
              function() {}
            );
          }
        };

        vm.add_empty_row = function(options) {
          var last = _.last(options);

          if (!last || last.id) {
            options.push(angular.copy(pattern));
          }
        };

        vm.build_url = function() {
          vm.url_result = '';

          var all_params = _.flatten([vm.default_uri_options, vm.custom_uri_options]);

          _.each(all_params, function(v, i) {
            if (all_params.length - 1 !== i) {
              vm.url_result += v.key && v.active ? v.key + '=' + v.value + '&' : '';
            } else {
              vm.url_result =
                v.key && v.active ? vm.url_result + v.key + '=' + v.value : vm.url_result.replace(/&$/g, '');
            }
          });

          if ($scope.webhook.uri) {
            vm.url_result = $scope.webhook.uri + '?' + vm.url_result;
          }
        };

        $scope.$watch('uriOptions', function(newValue) {
          if (newValue) {
            vm.default_uri_options = _.where(newValue, {aasm_state: 'default'});
            vm.custom_uri_options = _.where(newValue, {aasm_state: 'custom'});

            vm.default_uri_options = $filter('orderBy')(vm.default_uri_options, 'weight');

            vm.add_empty_row(vm.custom_uri_options);
            vm.build_url();
          }
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    var tabsList = ['registration', 'deposit', 'activity'];

    $stateProvider
      .state('webhooks', {
        url: '/webhooks',
        templateUrl: 'app/affiliate/webhooks/partials/webhooks.html',
        controller: 'WebhooksController',
        controllerAs: 'webhooksCtrl',
        data: {
          parentState: 'webhooks',
          editState: 'webhooks.settings',
          tabsList: tabsList,
          apiName: 'WebhooksApi',
          permissions: permissionsStateAccess.init(['api2.affiliate.webhookscontroller.all'])
        }
      })
      .state('webhooks.settings', {
        url: '/settings/:webhookType/:webhookId',
        templateUrl: 'app/affiliate/webhooks/partials/webhooks_settings.html',
        controller: 'WebhooksSettingsController',
        controllerAs: 'settingsCtrl',
        data: {
          parentState: 'webhooks',
          apiName: 'WebhooksApi'
        }
      });

    angular.forEach(tabsList, function(name) {
      $stateProvider.state('webhooks.' + name, {
        url: '/' + name,
        data: {
          type: name,
          editState: 'webhooks.settings',
          apiName: 'WebhooksApi'
        },
        views: {
          'content@webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/list.html',
            controller: 'WebhooksTabController',
            controllerAs: 'tabCtrl'
          },
          'search@webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/search.html'
          },
          'pagination@webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/pagination.html'
          }
        }
      });
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        webhooks: [
          'header||webhooks.header',
          'add_webhook||webhooks.add_webhook',
          {
            modal_window: [
              {
                create: [
                  'title||create_modal.title',
                  'webhook_type||create_modal.webhook_type',
                  'save||create_modal.save',
                  'cancel||create_modal.cancel'
                ]
              }
            ]
          },
          {
            webhook_settings: [
              'header||webhook_settings.header',
              'webhook_type||webhook_settings.webhook_type',
              'active||webhook_settings.active',
              'success_confirmation||webhook_settings.success_confirmation',
              'checkboxes_label||webhook_settings.checkboxes_label',
              'back||webhook_settings.back',
              {
                condition: [
                  'label||condition.label',
                  'set_condition||condition.set_condition',
                  'add_condition_btn||condition.add_condition_btn',
                  {
                    modal: [
                      'title||condition.modal.title',
                      'save||condition.modal.save',
                      'cancel||condition.modal.cancel',
                      {
                        form: [
                          'obtained_result||condition.modal.form.obtained_result',
                          'condition_for_comparison||condition.modal.form.condition_for_comparison',
                          'desired_value||condition.modal.form.desired_value'
                        ]
                      }
                    ],
                    remove_condition_modal: [
                      'title||remove_condition_modal.title',
                      'question||remove_condition_modal.question',
                      'answer_yes||remove_condition_modal.answer_yes',
                      'answer_no||remove_condition_modal.answer_no'
                    ]
                  }
                ]
              },
              {
                url_constructor: [
                  'label||url_constructor.label',
                  'url||url_constructor.url',
                  'request_method||url_constructor.request_method',
                  'result_url||url_constructor.result_url',
                  {
                    table: [
                      {
                        header: [
                          'key||url_constructor.table.header.key',
                          'value||url_constructor.table.header.value',
                          'description||url_constructor.table.header.description'
                        ],
                        body: [
                          'key||url_constructor.table.body.placeholder_key',
                          'value||url_constructor.table.body.placeholder_value',
                          'description||url_constructor.table.body.placeholder_description'
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            tabs: [
              {
                registration: ['tab_name||registration.tab_name'],
                deposit: ['tab_name||deposit.tab_name'],
                activity: ['tab_name||activity.tab_name']
              }
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('Webhooks', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('WebhooksCreateModalController', WebhooksCreateModalController);

  WebhooksCreateModalController.$inject = ['$scope', '$mdDialog', '_', 'outputErrors'];

  function WebhooksCreateModalController($scope, $mdDialog, _, outputErrors) {
    var vm = this;

    vm.translate_key = 'Webhooks';
    vm.errors = outputErrors.createNew();

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.hide = function(data) {
      return $mdDialog.hide(data);
    };

    vm.save = function() {
      return vm.apiFactory.create_webhook(vm.webhook_type, vm.partnerId).then(
        function(response) {
          return vm.hide({id: response.data.webhook.id, type: vm.webhook_type});
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('WebhooksConditionModalController', WebhooksConditionModalController);

  WebhooksConditionModalController.$inject = ['$scope', '$mdDialog', '_', 'outputErrors'];

  function WebhooksConditionModalController($scope, $mdDialog, _, outputErrors) {
    var vm = this;

    vm.translate_key = 'Webhooks';
    vm.errors = outputErrors.createNew();

    vm.check_any_parametr = function() {
      if (vm.condition.condition_for_comparison === 'any') {
        vm.condition.desired_value = null;
      }
    };

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.hide = function(data) {
      $mdDialog.hide(data || vm);
    };

    vm.save = function() {
      vm.apiFactory.save_condition(vm.webhook_id, vm.condition, vm.partnerId).then(
        function(response) {
          if (!vm.condition.id) {
            vm.condition.id = response.data.condition.id;
          }
          vm.hide();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateTrackersController', AffiliateTrackersController);

  AffiliateTrackersController.$inject = [
    '$scope',
    '$state',
    'tableEngine',
    'AffiliateTrackersApi',
    '$mdDialog',
    '_',
    'permissionsManager',
    'outputErrors',
    'toastsApi'
  ];

  function AffiliateTrackersController(
    $scope,
    $state,
    tableEngine,
    AffiliateTrackersApi,
    $mdDialog,
    _,
    permissionsManager,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateTrackers';
    vm.errors = outputErrors.createNew();

    vm.createModal = function(data, ev) {
      return $mdDialog.show({
        controller: 'AffiliateSaveTrackerModalController',
        controllerAs: '$ctrl',
        templateUrl: 'app/affiliate/trackers/partials/form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: data || {}
      });
    };

    vm.addTracker = function(ev) {
      var params = {
        shortcodePart: 'modal_create',
        tracker: {}
      };

      vm.createModal(params, ev).then(function(data) {
        vm.table.pagination();
        vm.available_trackers = data.available_trackers;
      });
    };

    vm.editDescription = function(tracker, ev) {
      var params = {
        shortcodePart: 'modal_edit',
        tracker: _.pick(tracker, 'id', 'description', 'tracker_code', 'assigning_at')
      };

      vm.createModal(params, ev).then(function(data) {
        vm.table.updateListItemById({description: data.tracker.description}, tracker.id);
      });
    };

    vm.affiliateCreatives = function(tracker) {
      $state.go('affiliate_trackers.creatives', {trackerCode: tracker.tracker_code});
    };

    vm.disabledCreateBtn = function() {
      return (
        !permissionsManager.checkPermission('api2.affiliate.trackerscontroller.create') || vm.available_trackers === 0
      );
    };

    vm.showCondition = function(tracker) {
      $state.go('affiliate_trackers.condition', {trackerId: tracker.id});
    };

    vm.table = tableEngine.init({
      api: AffiliateTrackersApi,
      name: 'affiliate_trackers',
      mobile: {
        defaultColumns: ['tracker_code']
      },
      buttons: {
        url: 'app/affiliate/trackers/partials/table.html',
        methods: {
          showCondition: vm.showCondition,
          affiliateCreatives: vm.affiliateCreatives,
          editDescription: vm.editDescription
        }
      }
    });

    AffiliateTrackersApi.trackers_list().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('type_of_transaction', {
          localizied: true,
          locales: {
            translate_key: 'AdminConditions',
            shortcode: 'main_params.form.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });

        vm.available_trackers = data.available_trackers;
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('affiliate_trackers', {
        url: '/affiliate_trackers',
        templateUrl: 'app/affiliate/trackers/partials/trackers.html',
        controller: 'AffiliateTrackersController',
        controllerAs: 'affiliate_tracker',
        data: {
          permissions: permissionsStateAccess.init(['api2.affiliate.trackerscontroller.show'])
        }
      })
      .state('affiliate_trackers.condition', {
        url: '/condition/:trackerId',
        templateUrl: 'app/affiliate/trackers/partials/condition.html',
        controller: 'AffiliateConditionController',
        controllerAs: 'settings'
      });
  });
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateSaveTrackerModalController', AffiliateSaveTrackerModalController);

  AffiliateSaveTrackerModalController.$inject = ['$mdDialog', 'AffiliateTrackersApi', 'outputErrors', 'toastsApi'];

  function AffiliateSaveTrackerModalController($mdDialog, AffiliateTrackersApi, outputErrors, toastsApi) {
    var vm = this;

    vm.translate_key = 'AffiliateTrackers';
    vm.errors = outputErrors.createNew();

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.hide = function(data) {
      return $mdDialog.hide(data);
    };

    vm.saveTracker = function() {
      vm.saveTrackerForm.$setSubmitted();

      if (vm.saveTrackerForm.$invalid) {
        return;
      }

      return AffiliateTrackersApi.saveTracker(vm.tracker).then(
        function(response) {
          var data = response.data || {};
          toastsApi.toastCreateSuccess();
          return vm.hide({tracker: vm.tracker, available_trackers: data.available_trackers});
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        trackers: [
          'header||trackers.header',
          'button_add_tracker||trackers.button_add_tracker',
          'available_tracker||trackers.available_tracker',
          'deals_button||trackers.deals_button',
          {
            modal_window: [
              {
                create: [
                  'title||modal_create.title',
                  'description||modal_create.description',
                  'ok||modal_create.button_save',
                  'cancel||modal_create.button_cancel'
                ],
                edit: [
                  'title||modal_edit.title',
                  'description||modal_edit.description',
                  'button_save||modal_edit.button_save',
                  'button_cancel||modal_edit.button_cancel'
                ]
              }
            ]
          },
          {
            condition: [
              'header||condition.header',
              'condition_is_absent||condition.condition_is_absent',
              'back||condition.back'
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateTrackers', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateConditionController', AffiliateConditionController);

  AffiliateConditionController.$inject = [
    '$scope',
    '$state',
    '$q',
    '$stateParams',
    'AffiliateTrackersApi',
    'ConditionInstance',
    'conditionFilter',
    'outputErrors',
    '_',
    'toastsApi'
  ];

  function AffiliateConditionController(
    $scope,
    $state,
    $q,
    $stateParams,
    AffiliateTrackersApi,
    ConditionInstance,
    conditionFilter,
    outputErrors,
    _,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminConditions';
    vm.condition_defer = $q.defer();
    vm.get_countries_defer = $q.defer();
    vm.all_promises = [vm.condition_defer.promise, vm.get_countries_defer.promise];
    vm.condition_url = '';
    vm.errors = outputErrors.createNew();
    vm.condition_instance = null;
    vm.show_content = false;
    vm.merchantName = '';
    vm.commissions_attributes = {
      for_deposits: {commission_type: 'for_deposits', value: 0},
      for_withdrawals: {commission_type: 'for_withdrawals', value: 0},
      for_deduction: {commission_type: 'for_deduction', value: 0},
      for_reward_program: {commission_type: 'for_reward_program', value: 0}
    };

    vm.determineCountryList = [
      {value: false, shortcode: 'filters.based_on_registration'},
      {value: true, shortcode: 'filters.based_on_ip_address'}
    ];

    vm.calculatingProfitMethodsList = [
      {value: false, shortcode: 'main_params.form.enable_accrual_of_interest_on_the_each_interval'},
      {value: true, shortcode: 'main_params.form.enable_accrual_of_interest_on_the_upper_interval'}
    ];

    vm.transferringNegativeCommissionList = [
      {value: false, shortcode: 'main_params.form.disable_transferring_a_negative_commission'},
      {value: true, shortcode: 'main_params.form.enable_transferring_a_negative_commission'}
    ];

    vm.showSumByConditionSteps = function() {
      return vm.merchantName === 'All';
    };

    vm.getShortcode = function(list, value) {
      if (_.isUndefined(value)) {
        return;
      }

      return _.propertyOf(_.findWhere(list, {value: value}))('shortcode');
    };

    vm.back = function() {
      $state.go('affiliate_trackers');
    };

    vm.create_instant = function(condition) {
      return ConditionInstance.createNew(condition);
    };

    vm.set_products_list = function(conditionInstance) {
      if (conditionInstance.productsList) {
        conditionInstance.productsList(vm.constants_from_server.condition_steps.obtained_result);
      }
    };

    vm.set_payment_columns = function(conditionInstance) {
      if (conditionInstance.setPaymentColumns) {
        conditionInstance.setPaymentColumns(vm.constants_from_server.condition_steps.payment_column);
      }
    };

    vm.update_condition_url = function(conditionInstance) {
      vm.condition_url = 'app/admin/conditions/partials/' + conditionInstance.condition.type_of_transaction + '.html';
    };

    vm.update_condition_instant = function(conditionInstance) {
      vm.set_products_list(conditionInstance);
      vm.set_payment_columns(conditionInstance);
      vm.update_condition_url(conditionInstance);
      conditionInstance.fullUpdate();

      if (conditionInstance.condition.id) {
        conditionInstance.preValidateAll();
        conditionInstance.validateCondition();
      }
    };

    vm.buildConditionForFilter = function() {
      return _.extend(
        {},
        _.omit(vm.condition_instance.condition, ['condition_steps_attributes', 'condition_items_attributes'])
      );
    };

    vm.buildConditionObject = function(filter) {
      var condition = _.extend({}, _.omit(vm.condition, 'condition_filters_attributes'));

      condition.condition_items_attributes = filter.condition_items_attributes || [];
      condition.condition_steps_attributes = filter.condition_steps_attributes || [];

      return condition;
    };

    vm.conditionDecorator = function(self, method, filterIde) {
      return function() {
        var isValid = method.apply(self, arguments);

        vm.Filter.invalidFiltersControl(isValid, filterIde);

        return isValid;
      };
    };

    vm.createConditionInstanceForFilter = function(filter, condition) {
      var instance = vm.create_instant(condition);

      instance.validateCondition = vm.conditionDecorator(instance, instance.validateCondition, filter.ide);
      vm.update_condition_instant(instance);
      instance.validateCondition();

      return instance;
    };

    vm.filterTemplates = [
      {
        ide: 0,
        _destroy: 0,
        show: false,
        aasm_state: 'default',
        type: 'ConditionFilterCountry',
        name: 'filters.filter_all_countries',
        value: [],
        condition_items_attributes: [],
        condition_steps_attributes: []
      }
    ];

    vm.filterOptions = {
      readOnly: true,
      savedFiled: 'country_code',
      showedField: 'name',
      chooseFilter: function(filter) {
        if (!_.isEmpty(vm.condition_instance) && vm.condition_instance.validateCondition) {
          var commonFields = ['type_of_transaction', 'title', 'description', 'commissions_attributes', 'country_by_ip'];

          if (vm.condition_instance.condition.calculating_profit_method) {
            commonFields.push('calculating_profit_method');
          }

          _.extend(filter.condition_instance.condition, _.pick(vm.condition_instance.condition, commonFields));

          vm.condition_instance.validateCondition();
        }

        vm.condition_instance = filter.condition_instance;
      },
      isAllFiltersValid: function(filter) {
        return filter.condition_instance.validateCondition() && !filter.noCountryChoosed;
      },
      implementsCondition: function(filter) {
        filter.condition_instance = vm.createConditionInstanceForFilter(filter, vm.buildConditionObject(filter));

        return filter;
      }
    };

    vm.initFilter = function(condition, countriesList, filterOptions) {
      vm.filterOptions.readOnly = condition.read_only;
      vm.Filter = conditionFilter.createNew(condition.condition_filters_attributes, countriesList, filterOptions);

      vm.Filter.implementsCondition();
      vm.Filter.chooseFilter(_.findWhere(vm.Filter.filters, {aasm_state: 'default'}));
    };

    vm.getKeyOfValue = function(value, instant, dataSrc1, dataSrc2) {
      if (!vm.constants_from_server || !vm.condition_instance) {
        return;
      }

      var data = vm.constants_from_server[dataSrc1][dataSrc2],
        list;

      if (instant.current_product) {
        list = vm.condition_instance.isHybrid
          ? data['hybrid'][instant.condition.type_of_transaction][instant.current_product]
          : data[instant.condition.type_of_transaction][instant.current_product];
      }

      if (instant.conditions_for_all) {
        list = vm.condition_instance.isHybrid
          ? data['hybrid'][instant.condition.type_of_transaction]
          : data[instant.condition.type_of_transaction];
      }
      return _.findKey(list, function(v) {
        return v === value;
      });
    };

    vm.methods = {
      getKeyOfValue: vm.getKeyOfValue
    };

    $q.all(vm.all_promises).then(
      function() {
        vm.initFilter(vm.condition, vm.countriesList, vm.filterOptions);
      },
      function() {
        toastsApi.toastError();
      }
    );

    AffiliateTrackersApi.getCountries().then(
      function(response) {
        vm.countriesList = response.data;

        vm.get_countries_defer.resolve();
      },
      function() {
        vm.get_countries_defer.reject();
      }
    );

    AffiliateTrackersApi.get_condition($stateParams.trackerId).then(
      function(response) {
        var data = response.data;

        vm.show_content = true;

        if (!data.condition) {
          return;
        }

        data.condition.hide_commissions_attributes = true;

        vm.condition = data.condition;
        vm.constants_from_server = data.constants;
        vm.condition_classes = data.constants.condition.type_of_transaction;
        vm.calculating_profit_methods = data.constants.condition.calculating_profit_method_hybrid;
        vm.commissions_attributes = _.size(data.condition.commissions_attributes)
          ? _.extend(vm.commissions_attributes, _.indexBy(data.condition.commissions_attributes, 'commission_type'))
          : vm.commissions_attributes;
        vm.merchantName = _.propertyOf(_.findWhere(data.merchants, {id: vm.condition.merchant_id}))('value');

        vm.condition_defer.resolve();
      },
      function() {
        toastsApi.toastError();
        vm.condition_defer.reject();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('affiliate_reports', {
        url: '/affiliate_reports',
        templateUrl: 'app/components/reports/partials/reports.html',
        controller: 'ReportsController',
        controllerAs: 'reports',
        data: {
          report_api: 'ReportApi',
          translate_key: 'Reports',
          namespace: 'affiliate',
          permission_ctrl_name: 'reportscontroller',
          permissions: permissionsStateAccess.init(['api2.affiliate.reportscontroller.generate_report']),
          group_by_map: {
            date: {
              locale: 'date',
              model: 'group_by_date',
              order: 1
            },
            affiliate: {
              locale: 'affiliate_params',
              model: 'group_by_affiliate_params',
              order: 2
            },
            player: {
              locale: 'player_params',
              model: 'group_by_player_params',
              order: 3
            },
            row_on_page: {
              locale: 'per_page',
              item_locale: 'rows_per_page',
              model: 'per_page',
              order: 4
            }
          },
          all_stats_list: [
            {
              id: 7,
              name: 'date_of_registration',
              shortcode: 'segments.tabs.date_of_registration',
              empty: true,
              type: 'date'
            },
            {
              id: 8,
              name: 'date_of_ftd',
              shortcode: 'segments.tabs.date_of_ftd',
              empty: true,
              type: 'date'
            },
            {
              id: 9,
              name: 'date_of_last_deposit',
              shortcode: 'segments.tabs.date_of_last_deposit',
              empty: true,
              type: 'date'
            },
            {
              id: 10,
              name: 'date_of_last_rmp_activity',
              shortcode: 'segments.tabs.date_of_last_rmp_activity',
              empty: true,
              type: 'date'
            },
            {
              id: 11,
              name: 'inactive_days',
              shortcode: 'segments.tabs.inactive_days',
              empty: true,
              type: 'compare'
            },
            {
              id: 12,
              name: 'first_deposit_size',
              shortcode: 'segments.tabs.first_deposit_size',
              empty: true,
              type: 'compare'
            },
            {
              id: 13,
              name: 'last_deposit_size',
              shortcode: 'segments.tabs.last_deposit_size',
              empty: true,
              type: 'compare'
            },
            {
              id: 14,
              name: 'amount_of_deposits',
              shortcode: 'segments.tabs.amount_of_deposits',
              empty: true,
              type: 'compare'
            },
            {
              id: 15,
              name: 'average_deposit_size',
              shortcode: 'segments.tabs.average_deposit_size',
              empty: true,
              type: 'compare'
            },
            {
              id: 16,
              name: 'sum_of_deposits',
              shortcode: 'segments.tabs.sum_of_deposits',
              empty: true,
              type: 'compare'
            },
            {
              id: 19,
              name: 'ngr_all_time',
              shortcode: 'segments.tabs.ngr_all_time',
              empty: true,
              type: 'compare'
            },
            {
              id: 20,
              name: 'ggr_all_time',
              shortcode: 'segments.tabs.ggr_all_time',
              empty: true,
              type: 'compare'
            },
            {
              id: 21,
              name: 'ngr_this_month',
              shortcode: 'segments.tabs.ngr_this_month',
              empty: true,
              type: 'compare'
            },
            {
              id: 22,
              name: 'ggr_this_month',
              shortcode: 'segments.tabs.ggr_this_month',
              empty: true,
              type: 'compare'
            },
            // {
            //   id: 17,
            //   name: 'country',
            //   shortcode: 'segments.tabs.country',
            //   empty: true,
            //   type: 'checkbox'
            // },
            {
              id: 36,
              name: 'country_code',
              shortcode: 'segments.tabs.country_code',
              empty: true,
              type: 'checkbox'
            },
            {
              id: 37,
              name: 'country_ip_code',
              shortcode: 'segments.tabs.country_ip_code',
              empty: true,
              type: 'checkbox'
            }
          ],
          segment_tabs: [
            {
              id: 300,
              type: 'merchant_ids',
              shortcode: 'segments.tabs.merchant_ids',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 51,
              type: 'managers',
              shortcode: 'segments.tabs.managers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 1,
              type: 'affiliates',
              shortcode: 'segments.tabs.affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 2,
              type: 'trackers',
              shortcode: 'segments.tabs.trackers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 3,
              type: 'anid',
              shortcode: 'segments.tabs.anid',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 4,
              type: 'creatives',
              shortcode: 'segments.tabs.creatives',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 5,
              type: 'players',
              shortcode: 'segments.tabs.players',
              field_name: 'value',
              upload_from_file: true,
              upload_params: {
                url: 'load_file_with_players',
                file_formats: [{format: '.csv', type: 'text/csv'}]
              },
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 6,
              type: 'stats',
              shortcode: 'segments.tabs.stats',
              templateUrl: 'app/components/reports/partials/stats_template.html',
              stats_column_template_url: 'app/components/reports/partials/stats_parts/{{type}}_template.html',
              all_stats_key: 'all_stats_list'
            }
          ],
          structure_tabs: [
            {
              id: 5,
              type: 'general_columns',
              shortcode: 'structures.tabs.general_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 1,
              type: 'player_columns',
              shortcode: 'structures.tabs.player_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 2,
              type: 'product_columns',
              shortcode: 'structures.tabs.product_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 3,
              type: 'comission_columns',
              shortcode: 'structures.tabs.comission_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 4,
              type: 'stats_columns',
              shortcode: 'structures.tabs.stats_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            }
          ]
        }
      })
      .state('affiliate_subaffiliate_reports', {
        url: '/affiliate_subaffiliate_reports',
        templateUrl: 'app/components/reports/partials/reports.html',
        controller: 'ReportsController',
        controllerAs: 'reports',
        data: {
          report_api: 'SubaffiliateReportApi',
          translate_key: 'SubaffiliateReports',
          namespace: 'affiliate',
          permission_ctrl_name: 'subaffiliatereportscontroller',
          permissions: permissionsStateAccess.init(['api2.affiliate.subaffiliatereportscontroller.generate_report']),
          group_by_map: {
            date: {
              locale: 'date',
              model: 'group_by_date',
              order: 1
            },
            affiliate: {
              locale: 'affiliate_params',
              model: 'group_by_affiliate_params',
              order: 2
            },
            player: {
              locale: 'player_params',
              model: 'group_by_player_params',
              order: 3
            },
            row_on_page: {
              locale: 'per_page',
              item_locale: 'rows_per_page',
              model: 'per_page',
              order: 4
            }
          },
          segment_tabs: [
            {
              id: 51,
              type: 'managers',
              shortcode: 'segments.tabs.managers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 1,
              type: 'affiliates',
              shortcode: 'segments.tabs.affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 18,
              type: 'invated_affiliates',
              shortcode: 'segments.tabs.invated_affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            }
          ]
        }
      })
      .state('affiliate_creative_reports', {
        url: '/affiliate_creative_reports',
        templateUrl: 'app/components/reports/partials/reports.html',
        controller: 'ReportsController',
        controllerAs: 'reports',
        data: {
          report_api: 'CreativeReportApi',
          translate_key: 'CreativeReports',
          namespace: 'affiliate',
          permission_ctrl_name: 'creativereportscontroller',
          permissions: permissionsStateAccess.init(['api2.affiliate.creativereportscontroller.generate_report']),
          group_by_map: {
            date: {
              locale: 'date',
              model: 'group_by_date',
              order: 1
            },
            affiliate: {
              locale: 'affiliate_params',
              model: 'group_by_affiliate_params',
              order: 2
            },
            player: {
              locale: 'player_params',
              model: 'group_by_player_params',
              order: 3
            },
            row_on_page: {
              locale: 'per_page',
              item_locale: 'rows_per_page',
              model: 'per_page',
              order: 4
            }
          },
          segment_tabs: [
            {
              id: 300,
              type: 'merchant_ids',
              shortcode: 'segments.tabs.merchant_ids',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 23,
              type: 'creatives_for_creatives_report',
              shortcode: 'segments.tabs.creatives_for_creatives_report',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 24,
              type: 'affiliates_for_creatives_report',
              shortcode: 'segments.tabs.affiliates_for_creatives_report',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 25,
              type: 'trackers_for_creatives_report',
              shortcode: 'segments.tabs.trackers_for_creatives_report',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 26,
              type: 'anids_for_creatives_report',
              shortcode: 'segments.tabs.anids_for_creatives_report',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 51,
              type: 'managers',
              shortcode: 'segments.tabs.managers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 1,
              type: 'affiliates',
              shortcode: 'segments.tabs.affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 2,
              type: 'trackers',
              shortcode: 'segments.tabs.trackers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            }
          ]
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    // var child_states = [
    // 'main',
    // 'email',
    // 'password',
    // 'confirmation_email',
    // 'two_factor_authentication',
    // 'payment_systems'
    // ];

    $stateProvider
      .state('affiliate_settings_profile', {
        // abstract: true,
        url: '/affiliate/settings_profile',
        templateUrl: 'app/affiliate/profile_settings/partials/settings.html',
        controller: 'AffiliateProfileSettingsController',
        controllerAs: 'profile_affiliate',
        data: {
          permissions: permissionsStateAccess.init(['api2.affiliate.settingscontroller.show'])
        }
      })
      .state('affiliate_settings_profile.main', {
        url: '/main',
        views: {
          'content@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/main/partials/main.html',
            controller: 'AffiliateProfileMainController',
            controllerAs: 'profileMain'
          },
          'buttons@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/partials/buttons.html'
          }
        }
      })
      .state('affiliate_settings_profile.email', {
        url: '/email',
        views: {
          'content@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/email/partials/email.html',
            controller: 'AffiliateProfileEmailController',
            controllerAs: 'profileEmail'
          },
          'buttons@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/partials/buttons.html'
          }
        }
      })
      .state('affiliate_settings_profile.password', {
        url: '/password',
        views: {
          'content@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/password/partials/password.html',
            controller: 'AffiliateProfilePasswordController',
            controllerAs: 'profilePassword'
          },
          'buttons@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/partials/buttons.html'
          }
        }
      })
      .state('affiliate_settings_profile.confirmation_email', {
        url: '/confirmation_email/:token',
        views: {
          'content@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/confirmation_email/partials/confirmation_email.html',
            controller: 'AffiliateProfileConfirmationEmailController',
            controllerAs: 'profileConfirmEmail'
          },
          'buttons@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/partials/buttons.html'
          }
        }
      })
      .state('affiliate_settings_profile.two_factor_authentication', {
        url: '/two_factor_auth',
        views: {
          'content@affiliate_settings_profile': {
            templateUrl:
              'app/affiliate/profile_settings/two_factor_authentication/partials/two_factor_authentication.html',
            controller: 'AffiliateProfileTwoFactorAuthController',
            controllerAs: 'profileTwoFactorAuth'
          },
          'buttons@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.affiliate.settingscontroller.two_factor_auth'])
        }
      })
      .state('affiliate_settings_profile.payment_systems', {
        url: '/payment_systems',
        views: {
          'content@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/payment_systems/partials/payment_systems.html',
            controller: 'AffiliateProfilePaymentSystemsController',
            controllerAs: 'profilePaymentSystems'
          },
          'buttons@affiliate_settings_profile': {
            templateUrl: 'app/affiliate/profile_settings/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.affiliate.paymentsystemscontroller.show'])
        }
      });

    // angular.forEach(child_states, function(name) {
    //   var params = {
    //     url: '/' + name,
    //     templateUrl: 'app/affiliate/profile_settings/' + name + '/partials/' + name + '.html',
    //     data: {name: name}
    //   };

    //   if (name === 'confirmation_email') {
    //     params.url += '/:token';
    //     params.controller = [
    //       '$scope',
    //       '$stateParams',
    //       function($scope, $stateParams) {
    //         $scope.$emit('confirmation_token', $stateParams);
    //       }
    //     ];
    //   }

    //   if (name === 'two_factor_authentication') {
    //     params.url = '/two_factor_auth';
    //     params.data.permissions = permissionsStateAccess.init(['api2.affiliate.settingscontroller.two_factor_auth']);
    //   }

    //   if (name === 'payment_systems') {
    //     params.data.permissions = permissionsStateAccess.init(['api2.affiliate.paymentsystemscontroller.show']);
    //   }

    //   $stateProvider.state('affiliate_settings_profile.' + name, params);
    // });
  });
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateProfileSettingsController', AffiliateProfileSettingsController);

  AffiliateProfileSettingsController.$inject = ['$scope', 'tabsApi', 'permissionsManager'];

  function AffiliateProfileSettingsController($scope, tabsApi, permissionsManager) {
    var vm = this;

    vm.translate_key = 'AffiliateProfileSettings';
    vm.twoFactorAuth = permissionsManager.checkPermission('api2.affiliate.settingscontroller.two_factor_auth');
    vm.paymentMethodsPerm = permissionsManager.checkPermission('api2.affiliate.paymentsystemscontroller.show');

    vm.tabs = tabsApi.init({
      name: 'affiliate_profile',
      translateKey: vm.translate_key,
      list: [
        {
          name: 'main',
          shortcode: 'main.tab_name',
          state: 'affiliate_settings_profile.main'
        },
        {
          name: 'email',
          shortcode: 'email.tab_name',
          state: 'affiliate_settings_profile.email'
        },
        {
          name: 'password',
          shortcode: 'password.tab_name',
          state: 'affiliate_settings_profile.password'
        },
        {
          name: 'confirmation_email',
          shortcode: 'confirmation_email.tab_name',
          state: 'affiliate_settings_profile.confirmation_email'
        },
        {
          name: 'two_factor_authentication',
          shortcode: 'two_factor_authentication.tab_name',
          state: 'affiliate_settings_profile.two_factor_authentication',
          hide: !vm.twoFactorAuth
        },
        {
          name: 'payment_systems',
          shortcode: 'payment_systems.tab_name',
          state: 'affiliate_settings_profile.payment_systems',
          hide: !vm.paymentMethodsPerm
        }
      ]
    });

    $scope.$on('$destroy', function() {
      vm.tabs.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        profile_settings: [
          'header||profile_settings.header',
          'save||profile_settings.save',
          {
            tabs: [
              {
                main: [
                  'tab_name||main.tab_name',
                  'name||main.name',
                  'surname||main.surname',
                  'username||main.username',
                  'skype||main.skype',
                  'telegram||main.telegram',
                  'birthday||main.birthday',
                  'phone_number||main.phone_number',
                  'site_url||main.site_url',
                  'about_affiliate||main.about_affiliate',
                  'agree_receive_emails||main.agree_receive_emails'
                ],
                email: [
                  'tab_name||email.tab_name',
                  'email||email.email',
                  // 'email_confirmation||email.email_confirmation',
                  'unconfirmed_email||email.unconfirmed_email',
                  'current_email||email.current_email',
                  'current_password||email.current_password'
                ],
                password: [
                  'tab_name||password.tab_name',
                  'password||password.password',
                  'password_confirmation||password.password_confirmation',
                  'current_password||password.current_password'
                ],
                confirmation_email: ['tab_name||confirmation_email.tab_name', 'token||confirmation_email.token'],
                two_factor_authentication: [
                  'tab_name||two_factor_authentication.tab_name',
                  'current_password||two_factor_authentication.current_password',
                  'secret_value||two_factor_authentication.secret_value',
                  'enter_mfa_code_for_disable||two_factor_authentication.enter_mfa_code_for_disable',
                  'enter_mfa_code_for_enable||two_factor_authentication.enter_mfa_code_for_enable',
                  'two_factor_auth_enabled||two_factor_authentication.two_factor_auth_enabled',
                  'two_factor_auth_disabled||two_factor_authentication.two_factor_auth_disabled'
                ],
                payment_systems: ['tab_name||payment_systems.tab_name']
              }
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateProfileSettings', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('affiliate_faq', {
      url: '/faq',
      templateUrl: 'app/affiliate/faq_handbook/partials/faq_handbook.html',
      controller: 'AffiliateFaqHandbookController',
      controllerAs: '$ctrl',
      data: {
        permissions: permissionsStateAccess.init(['api2.affiliate.staticpagescontroller.faq'])
      }
    });

    var pages = [
      'terms',
      'privacy',
      'commission',
      'help',
      'static_page_1',
      'static_page_2',
      'static_page_3',
      'static_page_4',
      'static_page_5'
    ];

    angular.forEach(pages, function(page) {
      $stateProvider.state('affiliate_' + page, {
        url: '/' + page,
        templateUrl: 'app/affiliate/info_pages/partials/info_page.html',
        controller: 'AffiliateInfoPagesController',
        controllerAs: '$ctrl',
        data: {
          page: page,
          permissions: permissionsStateAccess.init(['api2.affiliate.staticpagescontroller.' + page])
        }
      });
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        faq: ['header||faq.header', 'last_update||faq.last_update'],
        terms: ['header||terms.header', 'last_update||terms.last_update'],
        privacy: ['header||privacy.header', 'last_update||privacy.last_update'],
        commission: ['header||commission.header', 'last_update||commission.last_update'],
        help: ['header||help.header', 'last_update||help.last_update'],
        static_page_1: ['header||static_page_1.header', 'last_update||static_page_1.last_update'],
        static_page_2: ['header||static_page_2.header', 'last_update||static_page_2.last_update'],
        static_page_3: ['header||static_page_3.header', 'last_update||static_page_3.last_update'],
        static_page_4: ['header||static_page_4.header', 'last_update||static_page_4.last_update'],
        static_page_5: ['header||static_page_5.header', 'last_update||static_page_5.last_update']
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateInfoPages', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateInfoPagesController', AffiliateInfoPagesController);

  AffiliateInfoPagesController.$inject = [
    '$scope',
    '$state',
    'InfoPagesApi',
    'outputErrors',
    '$rootScope',
    'toastsApi'
  ];

  function AffiliateInfoPagesController($scope, $state, InfoPagesApi, outputErrors, $rootScope, toastsApi) {
    var vm = this,
      translateListener;

    vm.translate_key = 'AffiliateInfoPages';
    vm.currentPage = $state.current.data.page;
    vm.getMethodName = 'get_' + vm.currentPage;
    vm.errors = outputErrors.createNew();

    vm.getPage = function() {
      InfoPagesApi[vm.getMethodName]().then(
        function(response) {
          vm.contentPage = response.data.content;
          vm.updatedAt = response.data.updated_at;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getPage();

    translateListener = $rootScope.$on('$translateChangeSuccess', function() {
      vm.getPage();
    });

    $scope.$on('$destroy', function() {
      translateListener();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('affiliate_ref_link', {
        url: '/creatives_link',
        templateUrl: 'app/affiliate/get_ref_link/partials/form.html',
        controller: 'AffiliateRefLinkController',
        controllerAs: '$ctrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.affiliate.getcreativelinkscontroller.get_link'])
        }
      })
      .state('affiliate_ref_link.list', {
        url: '/list/:merchant/:condition_type/:tracker/:creative_type/:language/:campaign/:size',
        templateUrl: 'app/affiliate/get_ref_link/partials/list.html',
        controller: 'AffiliateRefLinkListController',
        controllerAs: '$ctrl'
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        get_creatives_link: [
          'header||get_creatives_link.header',
          {
            form: [
              'merchant||get_creatives_link.form.merchant',
              'condition_type||get_creatives_link.form.condition_type',
              'tracker||get_creatives_link.form.tracker',
              'creative_type||get_creatives_link.form.creative_type',
              'language||get_creatives_link.form.language',
              'size||get_creatives_link.form.size',
              'all_sizes||get_creatives_link.form.all_sizes',
              'campaign||get_creatives_link.form.campaign',
              'all_campaigns||get_creatives_link.form.all_campaigns'
            ]
          },
          'get_link_button||get_creatives_link.get_link_button',
          {
            list: [
              'header||get_creatives_link.list.header',
              'preview_button||get_creatives_link.list.preview_button',
              'view_code_button||get_creatives_link.list.view_code_button',
              'copy_code_button||get_creatives_link.list.copy_code_button',
              'back||get_creatives_link.list.back',
              {
                modal_window: [
                  'creative_code||list.modal_window.creative_code',
                  'button_cancel||list.modal_window.button_cancel',
                  'button_copy||list.modal_window.button_copy'
                ]
              }
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateRefLink', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateRefLinkListController', AffiliateRefLinkListController);

  AffiliateRefLinkListController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$mdDialog',
    'outputErrors',
    'tableEngine',
    'AffiliateRefLinkApi',
    '$sce',
    'toastsApi',
    '_'
  ];

  function AffiliateRefLinkListController(
    $scope,
    $state,
    $stateParams,
    $mdDialog,
    outputErrors,
    tableEngine,
    AffiliateRefLinkApi,
    $sce,
    toastsApi,
    _
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateRefLink';
    vm.errors = outputErrors.createNew();
    vm.params = $stateParams;
    vm.allParams = {
      _merchant: vm.params.merchant,
      format: vm.params.creative_type,
      language: vm.params.language,
      creative_advertising_company_id: vm.params.campaign,
      creative_resolution_id: vm.params.size,
      serial_id: vm.params.tracker
    };
    vm.paramsToServer =
      vm.params.creative_type === 'link' ? _.omit(vm.allParams, 'creative_resolution_id') : _.clone(vm.allParams);

    vm.creativeModalTmp = {
      bannerflow_gif: 'app/affiliate/creatives/partials/view_iframe.html',
      jpeg: 'app/affiliate/creatives/partials/creative_img.html',
      png: 'app/affiliate/creatives/partials/creative_img.html',
      gif: 'app/affiliate/creatives/partials/creative_img.html',
      iframe: 'app/affiliate/creatives/partials/view_iframe.html',
      flash: 'app/affiliate/creatives/partials/view_flash.html'
    };

    vm.back = function() {
      $state.go('affiliate_ref_link');
    };

    vm.closePopup = function() {
      $mdDialog.hide();
    };

    vm.getModalOptions = function(creative) {
      return {
        title: creative.title,
        src: $sce.trustAsResourceUrl(
          creative[_.contains(['iframe', 'bannerflow_gif'], creative.format) ? 'body' : 'img']
        ),
        width: creative.resolution ? _.first(creative.resolution.split('x')) : 'auto',
        height: creative.resolution ? _.last(creative.resolution.split('x')) : 'auto'
      };
    };

    vm.openModal = function(creative, templateUrl, ev) {
      $mdDialog.show({
        controller: 'AffiliateCreativeViewController',
        controllerAs: 'viewCtrl',
        bindToController: true,
        templateUrl: templateUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: vm.getModalOptions(creative)
      });
    };

    vm.viewCreativeImage = function(creative, ev) {
      vm.openModal(creative, vm.creativeModalTmp[vm.params.creative_type], ev);
    };

    vm.viewCreativeCode = function(creative, ev) {
      vm.clickUrl = vm.params.creative_type === 'link' ? creative.url : creative.url_js;
      vm.creativeTitle = creative.title;

      $mdDialog.show({
        scope: $scope,
        preserveScope: true,
        templateUrl: 'app/affiliate/get_ref_link/partials/creative_code_tmp.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      });
    };

    vm.copySuccess = function() {
      toastsApi.toastCopySuccess();
    };

    vm.table = tableEngine.init({
      api: AffiliateRefLinkApi,
      name: 'refCreativeList',
      mobile: {
        defaultColumns: ['title']
      },
      buttons: {
        url: 'app/affiliate/get_ref_link/partials/table.html',
        methods: {
          viewCreativeImage: vm.params.creative_type === 'link' ? null : vm.viewCreativeImage,
          viewCreativeCode: vm.viewCreativeCode,
          copySuccess: vm.copySuccess
        }
      },
      params: {
        data: {
          _merchant: vm.params.merchant
        }
      }
    });

    AffiliateRefLinkApi.getCreatives(vm.paramsToServer).then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.updateAdditionalOptions(vm.paramsToServer);

        vm.table.addOptionsToColumn('language', {
          localizied: true,
          locales: {
            namespace: 'creative.list_locales'
          }
        });
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateRefLinkController', AffiliateRefLinkController);

  AffiliateRefLinkController.$inject = [
    '$state',
    'outputErrors',
    'AffiliateRefLinkApi',
    '_',
    'toastsApi',
    'merchantStore'
  ];

  function AffiliateRefLinkController($state, outputErrors, AffiliateRefLinkApi, _, toastsApi, merchantStore) {
    var vm = this;

    vm.translate_key = 'AffiliateRefLink';
    vm.errors = outputErrors.createNew();
    vm.showFilter = false;
    vm.params = {};
    vm.merchantsList = merchantStore.getMerchantList();
    vm.virtualSelectOpts = {
      prop_for_value: 'value',
      selective_translate: true
    };

    vm.errorHandler = function() {
      toastsApi.toastError();
    };

    vm.disableField = function(fieldName) {
      return (
        vm.dependencies[fieldName].wait &&
        _.isUndefined(_.propertyOf(vm.params)(vm.dependencies[fieldName].wait)) &&
        !vm.params[fieldName]
      );
    };

    vm.isNotValidSomeField = function() {
      var fields =
        vm.params.creative_type === 'link' ? _.without(_.keys(vm.dependencies), 'size') : _.keys(vm.dependencies);

      return _.some(
        _.map(fields, function(v) {
          return _.isUndefined(vm.params[v]);
        })
      );
    };

    vm.callNext = function(list, fieldName, propName) {
      if (_.size(list) !== 1) {
        return;
      }

      var value = _.first(list);

      vm.params[fieldName] = _.isObject(value) && propName ? value[propName] : value;
      vm.changeFilterParams(fieldName);
    };

    vm.changeFilterParams = function(fieldName) {
      var field = vm.dependencies[fieldName];

      vm.params = _.omit(vm.params, field.excludes || []);

      if (_.isFunction(field.method)) {
        field.method(_.pick(vm.params, field.includes || _.keys(vm.dependencies)));
      }
    };

    vm.prepareList = function(fullList, prop, shortcode) {
      var list = _.reject(fullList, Object.defineProperty({}, prop, {value: 'all', enumerable: true}));

      if (_.size(list) === 1) {
        return list;
      } else {
        return _.map(fullList, function(v) {
          if (v[prop] === 'all') {
            v.translate_key = vm.translate_key;
            v.shortcode = shortcode;
          }
          return v;
        });
      }
    };

    vm.goToListPage = function() {
      if (vm.isNotValidSomeField()) {
        return;
      }

      $state.go('affiliate_ref_link.list', vm.params);
    };

    vm.getMetchantsList = function() {
      vm.merchantsList = merchantStore.getMerchantList();
      vm.showFilter = true;
      vm.callNext(vm.merchantsList, 'merchant', 'id');
    };

    vm.getParamsForMerchant = function(params) {
      AffiliateRefLinkApi.getConditionTypes(params).then(function(response) {
        vm.conditionTypes = response.data.list_condition_type_of_transaction;
        vm.callNext(vm.conditionTypes, 'condition_type');
      }, vm.errorHandler);
    };

    vm.getParamsForConditionType = function(params) {
      AffiliateRefLinkApi.getParamsForConditionType(params).then(function(response) {
        vm.trackersList = response.data.list;
        vm.callNext(vm.trackersList, 'tracker', 'value');
      }, vm.errorHandler);
    };

    vm.getCreativeTypes = function(params) {
      AffiliateRefLinkApi.getCreativeTypes(params).then(function(response) {
        vm.creativeTypes = response.data.list_format_of_creative;
        vm.callNext(vm.creativeTypes, 'creative_type');
      }, vm.errorHandler);
    };

    vm.getParamsForCreativeType = function(params) {
      vm.hideSizeField = params.creative_type === 'link';
      vm.dependencies.campaign.wait = vm.hideSizeField ? 'language' : 'size';

      AffiliateRefLinkApi.getParamsForCreativeType(params).then(function(response) {
        vm.languagesList = response.data.list;
        vm.callNext(vm.languagesList, 'language');
      }, vm.errorHandler);
    };

    vm.getParamsForLanguage = function(params) {
      if (vm.hideSizeField) {
        var par = _.omit(params, 'size');
        vm.getParamsForSize(par);
      } else {
        AffiliateRefLinkApi.getParamsForLanguage(params).then(function(response) {
          vm.sizesList = vm.prepareList(
            response.data.list,
            'creative_resolution_id',
            'get_creatives_link.form.all_sizes'
          );
          vm.callNext(vm.sizesList, 'size', 'creative_resolution_id');
        }, vm.errorHandler);
      }
    };

    vm.getParamsForSize = function(params) {
      AffiliateRefLinkApi.getParamsForSize(params).then(function(response) {
        vm.campaignesList = vm.prepareList(
          response.data.list,
          'creative_advertising_company_id',
          'get_creatives_link.form.all_campaigns'
        );

        if (vm.campaignesList.length > 0) {
          // 기본 All Campaign 디폴트 선택 되도록 설정
          vm.params.campaign = vm.campaignesList[0].creative_advertising_company_id;
        }
        vm.callNext(vm.campaignesList, 'campaign', 'creative_advertising_company_id');
      }, vm.errorHandler);
    };

    vm.dependencies = {
      merchant: {
        wait: '',
        includes: ['merchant'],
        excludes: ['condition_type', 'tracker', 'creative_type', 'language', 'size', 'campaign'],
        method: vm.getParamsForMerchant
      },
      condition_type: {
        wait: 'merchant',
        includes: ['merchant', 'condition_type'],
        excludes: ['tracker'],
        method: vm.getParamsForConditionType
      },
      tracker: {
        wait: 'condition_type',
        includes: ['merchant'],
        method: vm.getCreativeTypes
      },
      creative_type: {
        wait: 'tracker',
        includes: ['merchant', 'creative_type'],
        excludes: ['language', 'size', 'campaign'],
        method: vm.getParamsForCreativeType
      },
      language: {
        wait: 'creative_type',
        includes: ['merchant', 'creative_type', 'language'],
        excludes: ['size', 'campaign'],
        method: vm.getParamsForLanguage
      },
      size: {
        wait: 'language',
        includes: ['merchant', 'creative_type', 'language', 'size'],
        excludes: ['campaign'],
        method: vm.getParamsForSize
      },
      campaign: {
        wait: 'size'
      }
    };

    vm.getMetchantsList();
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateFaqHandbookController', AffiliateFaqHandbookController);

  AffiliateFaqHandbookController.$inject = ['$scope', '$rootScope', 'localesStorage', 'FaqHandbookContent'];

  function AffiliateFaqHandbookController($scope, $rootScope, localesStorage, FaqHandbookContent) {
    var vm = this,
      translateListener;

    vm.translate_key = 'AffiliateInfoPages';

    vm.setSections = function() {
      var locale = localesStorage.getCurrentLocale();
      vm.sections = FaqHandbookContent[locale] || FaqHandbookContent.en_US;
    };

    vm.setSections();

    translateListener = $rootScope.$on('$translateChangeSuccess', vm.setSections);

    $scope.$on('$destroy', translateListener);
  }
})();

(function() {
  'use strict';

  // Locale-driven content for the Affiliate Guide (faq_handbook). Only en_US and ru_RU are
  // populated - this app has no other locale with translated guide content, and none is
  // planned. The template (faq_handbook.haml) renders whichever array matches the current
  // locale generically; see faq_handbook.controller.js.
  //
  // The "Marketing Guidelines" section (jurisdiction-specific compliance text - NL/DE/UK/LATAM/
  // Malta/Brazil) is intentionally NOT part of this content model. It isn't translated and stays
  // as static markup directly in faq_handbook.haml, rendered identically for every locale.

  var EN_US = [
      {
        title: 'Profile Setup',
        faqs: [
          {
            question: 'How do I setup my GGPartners Profile?',
            answerHtml:
              '<ol>' +
              '<li>Login to your account</li>' +
              '<li>Click on the "Gear" symbol on the top right corner of the page</li>' +
              '<li>Click on General Settings</li>' +
              '<li>Fill out as much information and click Save</li>' +
              '</ol>' +
              '<div class="faq-images-row">' +
              '<div class="faq-images-col">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image20.png" alt="Gear icon on navigation bar">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image12.png" alt="Profile settings - General settings tab">' +
              '</div>' +
              '<div class="faq-images-col">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image27.png" alt="Profile settings form">' +
              '</div>' +
              '</div>'
          },
          {
            question: 'I forgot the password to my GGPartner’s account. How do I change the password for my account?',
            answerHtml:
              '<ol>' +
              '<li>Head to <a href="https://affiliates.ggpartners.com/#/sign_in" target="_blank">https://affiliates.ggpartners.com/#/sign_in</a></li>' +
              '<li>Click on Forgot Password</li>' +
              '</ol>'
          },
          {
            question: 'How do I set up MFA? (optional)',
            answerHtml:
              '<p>Click <a href="https://docs.google.com/presentation/d/1lzOMLLwfhrkf2QUqQ7ZEUyi_-SXAuDf5Z9rspHf2rkI/edit?slide=id.g3083ec00730_0_26#slide=id.g3083ec00730_0_26" target="_blank">HERE</a> to see instructions regarding MFA setup, or see the <strong>MFA Setup Guide</strong> section below for a full step-by-step walkthrough.</p>'
          }
        ]
      },
      {
        title: 'MFA Setup Guide',
        faqs: [
          {
            question: 'Overview',
            answerHtml:
              '<p>To enhance login security for our backoffice website, we have implemented Multi-Factor Authentication (MFA) using Time-based One-Time Password (TOTP) authentication. This additional layer of security helps protect user accounts by requiring a one-time code from an OTP authentication app, in addition to standard login credentials.</p>' +
              '<p>Any TOTP-based authentication app can be used, such as Google Authenticator, Microsoft Authenticator, Authy, or any other OTP app.</p>' +
              '<p>This section provides step-by-step instructions on enabling and disabling MFA, setting up an OTP app, and logging in using MFA.</p>'
          },
          {
            question: 'Enabling MFA',
            answerHtml:
              '<ol>' +
              '<li>Click the profile icon at the top of the page and go to Profile Settings.</li>' +
              '<li>Navigate to Profile Settings &gt; General Settings &gt; MFA Tab.</li>' +
              '</ol>' +
              '<img class="faq-image" src="assets/images/faq_handbook/mfa1.png" alt="Profile settings - Two-factor authentication tab">'
          },
          {
            question: 'Installing an OTP App',
            answerHtml:
              '<ol>' +
              '<li>Open the Google Play Store (Android) or App Store (iOS) on your smartphone.</li>' +
              '<li>Search for and install an OTP authentication app (e.g., Google Authenticator, Microsoft Authenticator, or Authy).</li>' +
              '</ol>'
          },
          {
            question: 'Linking Your OTP App to Your Account',
            answerHtml:
              '<ol>' +
              '<li>Enter your current password and click SUBMIT.</li>' +
              '<li>Open your OTP app and tap "Get Started" or "+" to add a new account.</li>' +
              '<li>Scan the QR code displayed on the page using your OTP app.</li>' +
              '<li>Once the app generates a verification code, it will be saved automatically.</li>' +
              '<li>Enter the generated code into the "Enter MFA code to enable" field and click SUBMIT.</li>' +
              '<li>If successful, the screen will update to display "Enter MFA code to disable".</li>' +
              '</ol>'
          },
          {
            question: 'Logging in with MFA',
            answerHtml:
              '<ol>' +
              '<li>Log in to the GGPartners site.</li>' +
              '<li>Open your OTP app and retrieve the code for your account.</li>' +
              '<li>Enter the code in the "MFA code" field to complete login.</li>' +
              '</ol>'
          },
          {
            question: 'Disabling MFA',
            answerHtml:
              '<ol>' +
              '<li>Click the profile icon at the top of the page and go to Profile Settings.</li>' +
              '<li>Navigate to Profile Settings &gt; General Settings &gt; MFA Tab.</li>' +
              '<li>Open your OTP app and retrieve the code for your account.</li>' +
              '<li>Enter the code into the "Enter MFA code to disable" field and click SUBMIT.</li>' +
              '<li>Upon successful verification, MFA will be disabled, and the screen will update to "Current password".</li>' +
              '</ol>'
          }
        ]
      },
      {
        title: 'Dashboard',
        faqs: [
          {
            question: 'Overview',
            answerHtml:
              '<ul>' +
              '<li>Your Dashboard is the central hub where you will find all of the major statistics for your affiliate traffic such as Views, Clicks, Sign-ups, and FTDs (first time deposits).</li>' +
              '<li>These major statistics can be further broken down by "Brand" by clicking "All" in the dropdown menu then selecting a Brand.</li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image1.png" alt="Dashboard stats bar with brand dropdown">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image8.png" alt="Dashboard with brand dropdown open">' +
              '<ul>' +
              '<li>The Dashboard will also show any new important articles or announcements which you can click and read.</li>' +
              '<li>You will also see information regarding your GGPoker Affiliate Manager.</li>' +
              '<li>Players can also be checked by entering a player&#39;s CID number.</li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image19.png" alt="Articles, manager info, and check players sections">'
          }
        ]
      },
      {
        title: 'Commissions',
        faqs: [
          {
            question: 'How do I setup my withdrawal method?',
            answerHtml:
              '<ol>' +
              '<li>Login to your account</li>' +
              '<li>Click on the "Gear" icon on the top right corner of the page' +
              '<img class="faq-image" src="assets/images/faq_handbook/image2.png" alt="Top-right navigation bar"></li>' +
              '<li>Click on Payment Systems' +
              '<img class="faq-image" src="assets/images/faq_handbook/image13.png" alt="Profile settings - Payment systems tab"></li>' +
              '<li>Select Payment System <strong>(We cannot withdraw to Paypal at this current time)</strong>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image3.png" alt="Select payment system dropdown">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image7.png" alt="Payment methods list"></li>' +
              '<li>Enter Payment Details</li>' +
              '<li>Click on Default Payment System to save your preferred withdrawal method' +
              '<img class="faq-image" src="assets/images/faq_handbook/image25.png" alt="Default payment system checkbox">' +
              '<p>Confirm your Default Payment Method</p>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image14.png" alt="Setting default payment system confirmation dialog"></li>' +
              '</ol>'
          },
          {
            question: 'How do I withdraw?',
            answerHtml:
              '<ul>' +
              '<li>You must have a minimum $1000 balance in commissions to withdraw from GGPoker and GGPokerUK brands.</li>' +
              '<li>For brands GGPokerCA there is no minimum balance required for withdrawal.</li>' +
              '<li>If you do not accumulate $1000 in commissions, your balance will be carried over to the next month.</li>' +
              '<li>Minimum balance requirements per brand:</li>' +
              '</ul>' +
              '<div class="faq-info-box">' +
              '<dl>' +
              '<dt>GGPoker</dt><dd>$1000 minimum</dd>' +
              '<dt>GGPokerUK</dt><dd>$1000 minimum</dd>' +
              '<dt>GGPokerCA</dt><dd>No minimum required</dd>' +
              '</dl>' +
              '</div>' +
              '<ul>' +
              '<li>Withdrawal requests can take up to 7 days to be processed.</li>' +
              '</ul>' +
              '<p class="faq-login-label">Login to your QUINTS account:</p>' +
              '<br>' +
              '<ol>' +
              '<li>Select <strong>Reports</strong> and then <strong>Aff Balance</strong>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image15.png" alt="Sidebar showing Reports - Aff balance"></li>' +
              '<li>Click on the <strong>Withdraw</strong> Button.' +
              '<img class="faq-image" src="assets/images/faq_handbook/image22.png" alt="Withdraw button"></li>' +
              '</ol>'
          }
        ]
      },
      {
        title: 'Technical Questions',
        faqs: [
          {
            question: 'How do I get Creatives (Links, Banners, GIFs and PNG files)?',
            answerHtml:
              '<ol>' +
              '<li>Click on Tracking Links and <strong>Get Your Link</strong></li>' +
              '<li>Select the Brand (GGPoker, GGPokerUK, GGPokerCA)' +
              '<img class="faq-image" src="assets/images/faq_handbook/image21.png" alt="Get your link page"></li>' +
              '<li>The Deal Type will automatically appear.</li>' +
              '<li>Select the <strong>Tracker code</strong> you would like to use. You will also see the Tracker Description for easy referencing.' +
              '<img class="faq-image" src="assets/images/faq_handbook/image32.png" alt="Creative format dropdown showing BannerFlow, Gif, Links, PNG"></li>' +
              '<li>Select the Creative Format' +
              '<ul><li>BannerFlow</li><li>Gif</li><li>Links</li><li>PNG</li></ul></li>' +
              '<li>Select the language &amp; creative size (only applicable for Banners, GIFs, and PNG files), and campaign' +
              '<img class="faq-image" src="assets/images/faq_handbook/image18.png" alt="Get your link form with highlighted fields"></li>' +
              '<li>Click Get Link</li>' +
              '<li>Click Copy Referral Code</li>' +
              '<li><strong>Paste</strong> the Referral Code into your website banners</li>' +
              '<li>When a potential player clicks your banner, they will then be redirected to the landing page for registration and your Affiliate information will then be connected to the player' +
              '<img class="faq-image" src="assets/images/faq_handbook/image5.png" alt="Copy referral code button"></li>' +
              '</ol>'
          },
          {
            question: 'Can I create more Trackers?',
            answerHtml:
              '<ul>' +
              '<li>Upon registration of your Affiliate account, a default tracker will be created and linked to a commission deal.</li>' +
              '<li>If you require additional trackers you can create them yourself within the Affiliate dashboard:' +
              '<ol><li>Click the "Tracking Links" tab</li><li>Click "Trackers"</li><li>Click "Add Tracker"</li><li>Enter Tracker description</li></ol></li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image6.png" alt="Sidebar - Tracking links with Trackers circled">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image10.png" alt="Trackers page with Add Tracker button">'
          },
          {
            question: 'Can I access downloadable Creatives to use on my website?',
            answerHtml:
              '<ul>' +
              '<li>Your Affiliate Manager will provide you with access to downloadable Creatives which you may use on your website.</li>' +
              '<li>If you require any Creatives with special dimensions or any other non-standard Creative requests, please contact your Affiliate Manager.</li>' +
              '</ul>'
          },
          {
            question: 'How do I create a new Promo Code?',
            answerHtml:
              '<p>Please contact your Affiliate Manager to create a new Promo Code. Your affiliate manager will confirm when your promo code has been created.</p>' +
              '<p><strong>Required Information:</strong></p>' +
              '<ul>' +
              '<li>Promo Code name</li>' +
              '<li>Brand (GGPoker, GGPokerUK, GGPokerCA)</li>' +
              '<li>Tracker Code (promo code must be linked to a specific tracker)</li>' +
              '</ul>'
          },
          {
            question: 'How can I create a Private Tournament for my followers?',
            answerHtml:
              '<ul>' +
              '<li>Please contact your Affiliate Manager if interested in creating a Private Tournament.</li>' +
              '<li>All Private Tournament Request forms must be fully completed and submitted 1 week prior to the tournament start date and 2 weeks prior for more complex tournaments.</li>' +
              '<li>Private Tournaments will have different <strong>access</strong> options which you will indicate on the Private Tournament form when submitting:' +
              '<ol>' +
              '<li>Ticket only required (will require a list of eligible players as tickets will be manually provided)</li>' +
              '<li>Password only required</li>' +
              '<li>No ticket or password required (tournament will only be visible and accessible to player accounts tagged with your Affiliate ID)</li>' +
              '</ol></li>' +
              '<li>Private Tournaments will be visible on the GGPoker app/client within <strong>70 days</strong> of the tournament start date.</li>' +
              '</ul>'
          },
          {
            question: 'How do I generate reports on my statistics?',
            answerHtml:
              '<ul>' +
              '<li>Reports are used to analyze and track your performance as well as player performance</li>' +
              '<li>Click the "Reports" dropdown menu then click "Reports" (for general report type)</li>' +
              '<li>Follow the instructions below to set up your report for quick viewing or full download</li>' +
              '</ul>' +
              '<ol>' +
              '<li>Select the Time Frame' +
              '<img class="faq-image" src="assets/images/faq_handbook/image16.png" alt="Date range picker"></li>' +
              '<li>Select the Grouping' +
              '<ul>' +
              '<li><div class="faq-text-image-row"><div class="faq-text-col">Time Frame</div><div class="faq-image-col"><img class="faq-image" src="assets/images/faq_handbook/image4.png" alt="Group by day, week, month, or selected period"></div></div></li>' +
              '<li><div class="faq-text-image-row"><div class="faq-text-col">Type<ul><li>Brand</li><li>Tracker</li><li>Player</li></ul></div><div class="faq-image-col"><img class="faq-image" src="assets/images/faq_handbook/image23.png" alt="Group by brand, manager, affiliate, tracker, utm code, player"></div></div></li>' +
              '<li><div class="faq-text-image-row"><div class="faq-text-col">Players<ul><li>All Players</li><li>New Players</li><li>FTDs</li><li>Old Players</li></ul></div><div class="faq-image-col"><img class="faq-image" src="assets/images/faq_handbook/image9.png" alt="Player filter dropdown"></div></div></li>' +
              '<li>How many Results per page<ul><li>10</li><li>50</li><li>100</li></ul></li>' +
              '</ul></li>' +
              '<li>Set any additional filters and name it for future use' +
              '<img class="faq-image" src="assets/images/faq_handbook/image11.png" alt="Filters panel"></li>' +
              '<li>Click <strong>Download</strong> or <strong>Generate A Report</strong>' +
              '<ul>' +
              '<li>For <strong>quick viewing</strong> of report statistics, click <strong>Generate A Report</strong></li>' +
              '<li>For <strong>large</strong> data sets that require downloading' +
              '<ul>' +
              '<li>Click the <strong>DOWNLOAD</strong> button</li>' +
              '<li>Click <strong>"OK"</strong> on the Downloading report box that will pop up</li>' +
              '<li>Click <strong>"DOWNLOAD REPORT"</strong> (will pop up on the bottom right corner of the screen)</li>' +
              '<li>Click the <strong>blue Download icon</strong> when report is available (may require page refreshing for larger reports)</li>' +
              '</ul></li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image26.png" alt="Generate A Report and Download buttons">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image24.png" alt="Downloading report dialog - click OK">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image28.png" alt="Report created - click DOWNLOAD REPORT">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image30.png" alt="Export data - Download report option">' +
              '<img class="faq-image" src="assets/images/faq_handbook/image31.png" alt="Download report icon"></li>' +
              '</ol>'
          },
          {
            question: 'How do I add Postback / Pixel Tracking (S2S Requests)?',
            answerHtml: '<p>Please contact your Affiliate Manager if you would like to have Postback/Pixel Tracking</p>'
          }
        ]
      },
      {
        title: 'AppsFlyer',
        faqs: [
          {
            question: 'Overview',
            answerHtml:
              '<ul>' +
              '<li>AppsFlyer is a mobile attribution and marketing analytics platform that helps iGaming Affiliates track and optimize their marketing campaigns.</li>' +
              '<li>To use AppsFlyer the Affiliate must first complete the registration for their GGPoker Affiliate account then create an AppsFlyer account and provide their AppsFlyer agency name and AppsFlyer permissions as well as AppsFlyer brands to their GGPoker Affiliate Manager.</li>' +
              '<li>The Affiliate must also make sure to activate the <strong>"PID"</strong> setting on their AppsFlyer account in order for the OneLink to work correctly.</li>' +
              '<li>The following mandatory AppsFlyer Parameters will also be integrated by GGPoker however the Affiliate will need to provide <strong>qtag</strong> information to their GGPoker Affiliate Manager for correct setup:</li>' +
              '</ul>' +
              '<h3 class="faq-subsection-title">1. Mandatory AppsFlyer Parameters</h3>' +
              '<dl class="faq-params-list">' +
              '<dt>pid (Media Source):</dt><dd>Primary media information for attribution reports (e.g., XYZ_Media).</dd>' +
              '<dt>af_sub1 (Affiliate ID):</dt><dd>The unique ID of the affiliate.</dd>' +
              '<dt>qtag (Main):</dt><dd>Unique tracking tag for internal matching. It must follow the internal tracking format (e.g., axxx_txxx_cxxx_s).</dd>' +
              '<dt>af_sub2 (PID Backup):</dt><dd>Backup of Media Source to prevent data loss.</dd>' +
              '<dt>af_sub3 (QTag Backup 1):</dt><dd>First backup location for QTag.</dd>' +
              '<dt>deep_link_sub2 (QTag Backup 2):</dt><dd>Ensures QTag delivery via the Deep Link path (UDL).</dd>' +
              '</dl>' +
              '<h3 class="faq-subsection-title">2. Fixed/Internal Parameters (These are not mandatory)</h3>' +
              '<dl class="faq-params-list">' +
              '<dt>af_dp (App Scheme):</dt>' +
              '<dd>Set to <a href="ggpoker.com//onelink" target="_blank">ggpoker.com//onelink</a> (for GGPokerCOM brand)</dd>' +
              '<dd>Set to <a href="ggpokerca://onelink" target="_blank">ggpokerca://onelink</a> (for GGPokerCA brand)</dd>' +
              '<dt>Af_xp:</dt><dd>Set to App</dd>' +
              '</dl>' +
              '<h3 class="faq-subsection-title">3. Optional Flexible Fields</h3>' +
              '<dl class="faq-params-list">' +
              '<dt>af_sub4 ~ af_sub8:</dt><dd>Affiliates can use these for custom pass-through values (e.g., click_id).</dd>' +
              '</dl>'
          },
          {
            question: 'QTAG for Parameters: qtag, af_sub3, deep_link_sub2',
            answerHtml:
              '<ul>' +
              '<li>To find your <strong>qtag</strong> please refer to the <strong>"Get Your Link"</strong> instructions above and after choosing a campaign and pasting in the referral code in a web browser you will see your qtag.</li>' +
              '<li>You will also find your GGPoker Affiliate ID (for parameter <strong>af_sub1</strong>) on the qtag which is the first set of numbers right after the <strong>"a"</strong> in the qtag (24781 in the example below).</li>' +
              '<li>You will only need to provide the below underlined area of the <strong>qtag</strong> to your GGPoker Affiliate Manager which in the <strong>example</strong> below would be <strong>"a24781_t6432_c1"</strong> <strong>(alphanumerics from the "Q" and after are not required)</strong>.</li>' +
              '<li><strong>Remember to add _s at the end of the qtag.</strong></li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image29.png" alt="Browser URL showing qtag parameter">' +
              '<p class="faq-note"><strong>QTAG ABOVE IS EXAMPLE ONLY - DO NOT USE THE ABOVE QTAG</strong></p>' +
              '<div class="faq-info-box">' +
              '<p><strong>QTAG Breakdown:</strong></p>' +
              '<dl>' +
              '<dt>A</dt><dd>GGPoker Affiliate ID number</dd>' +
              '<dt>T</dt><dd>GGPoker Tracker number</dd>' +
              '<dt>C</dt><dd>Creative ID number</dd>' +
              '</dl>' +
              '</div>'
          },
          {
            question: 'AppsFlyer Affiliate activation',
            answerHtml:
              '<p>The Affiliate will need to complete the AppsFlyer setup on their end first before requesting AppsFlyer integration with GGPoker. Please click the following link which will take you to the official AppsFlyer Partner Activation setup guide:</p>' +
              '<p><a href="https://support.appsflyer.com/hc/en-us/articles/360000844778-Partner-activation-deactivation#activating-a-partner" target="_blank">https://support.appsflyer.com/hc/en-us/articles/360000844778-Partner-activation-deactivation#activating-a-partner</a></p>' +
              '<p>Once the Affiliate has completed the registration process for their GGPoker Affiliate account and completed the AppsFlyer setup on their end and provides all the required AppsFlyer information to the GGPoker Affiliate Manager, the AppsFlyer OneLinks for each requested brand (GGPokerUK, GGPokerCA) will then be provided to the Affiliate</p>' +
              '<p>You can find further instructions here: <a href="https://support.appsflyer.com/hc/en-us/articles/360000844778-Partner-activation-deactivation#activating-a-partner" target="_blank">https://support.appsflyer.com/hc/en-us/articles/360000844778-Partner-activation-deactivation#activating-a-partner</a></p>'
          }
        ]
      },
      {
        title: 'Postback Integration Setup',
        faqs: [
          {
            question: 'Overview & Parameters',
            answerHtml:
              '<h3 class="faq-subsection-title">What is a Postback?</h3>' +
              '<p>A postback is a webhook — a server-to-server HTTP request that Quints fires to an affiliate&#39;s server when a specific event occurs (e.g. a player registration or first deposit). Affiliates use postbacks to track conversions on their end in real time.</p>' +
              '<h3 class="faq-subsection-title">Parameter Types</h3>' +
              '<p>Parameters can be used to understand where your traffic comes from.</p>' +
              '<dl class="faq-params-list">' +
              '<dt>Static Parameters</dt><dd>Never change. Example: <code>organization=234567</code></dd>' +
              '<dt>Dynamic Parameters</dt><dd>Change per click or per player. Example: click IDs passed through the ANID field.</dd>' +
              '</dl>' +
              '<p>BTag structure: <code>aXXX_tXXX_cXXXX_sXXXX_XXXX_XXXX</code></p>' +
              '<h3 class="faq-subsection-title">Available Quints Variables</h3>' +
              '<p>The following variables can be used as values in the postback URL designer:</p>' +
              '<dl class="faq-params-list">' +
              '<dt>{affiliate_id}</dt><dd>The affiliate&#39;s Quints ID</dd>' +
              '<dt>{cid}</dt><dd>Player ID</dd>' +
              '<dt>{creative_id}</dt><dd>Creative (banner) ID</dd>' +
              '<dt>{serial_id}</dt><dd>Equivalent to {anid} — the full ANID value passed by the affiliate in the creative link</dd>' +
              '<dt>{source_id1} through {source_id5}</dt><dd>Individual segments of the ANID value, split by underscore</dd>' +
              '<dt>{source_id}</dt><dd>Sends all 5 source ID segments at once</dd>' +
              '</dl>' +
              '<p><strong>Note on {serial_id}:</strong> In postback settings, {serial_id} refers to {anid}. If the affiliate passes <code>anid=v1_v2</code> then {serial_id} = v1_v2, {source_id1} = v1, and {source_id2} = v2.</p>' +
              '<h3 class="faq-subsection-title">Creative Link Structure</h3>' +
              '<p>Quints can store up to 5 parameters (Dynamic or Static) at a time. The standard creative link structure is:</p>' +
              '<p><code>https://click.ggpartners.com/?serial=4017&amp;creative_id=4937&amp;anid={source_id1}_{source_id2}_{source_id3}_{source_id4}_{source_id5}</code></p>'
          },
          {
            question: 'Setting Up a Postback',
            answerHtml:
              '<h3 class="faq-subsection-title">1. Affiliate\'s Postback URL(s)</h3>' +
              '<p>Affiliate must provide their postback server URL(s) to their Affiliate Manager. Affiliates typically have separate URLs for Registration and FTD. Example:</p>' +
              '<dl class="faq-params-list">' +
              '<dt>Registration</dt><dd><code>https://www.pixelhere.com/et/event.php?advertiser=182876&amp;cid=INSERT_CLICK_ID&amp;id=32a3cb</code></dd>' +
              '<dt>FTD</dt><dd><code>https://www.pixelhere.com/et/event.php?advertiser=182876&amp;cid=INSERT_CLICK_ID&amp;id=f2fefe</code></dd>' +
              '</dl>' +
              '<h3 class="faq-subsection-title">2. Open the Postback Settings in Quints</h3>' +
              '<p>Go to your <strong>side panel</strong> → <strong>Tracking links</strong> → click the <strong>Postback icon</strong> (highlighted in yellow).</p>' +
              '<img class="faq-image" style="width: 150px" src="assets/images/faq_handbook/image44.png" alt="Side panel with Tracking links expanded and Postback menu item circled in red">' +
              '<h3 class="faq-subsection-title">3. Add a Webhook under Registration</h3>' +
              '<ol>' +
              '<li>Click <strong>Add Webhook</strong> under the Registration section.</li>' +
              '<li>Set the <strong>Request Method.</strong> Unless specified otherwise, use <strong>GET.</strong></li>' +
              '</ol>' +
              '<p>When you click Add Webhook, a creation dialog appears — select <strong>Registration</strong> to set up a registration postback.</p>' +
              '<p><strong>Note:</strong> You cannot enter URL parameters until you have selected a Request Method.</p>' +
              '<img class="faq-image" style="width: 50%" src="assets/images/faq_handbook/image39.png" alt="Add Webhook creation dialog with Registration, Deposit and Activity options">' +
              '<p>There are 3 request methods:</p>' +
              '<dl class="faq-params-list">' +
              '<dt>GET</dt><dd>Retrieves / reads data from Quints (default)</dd>' +
              '<dt>POST</dt><dd>Sends data to the affiliate&#39;s postback server</dd>' +
              '<dt>PUT</dt><dd>Modifies data on the affiliate&#39;s postback server</dd>' +
              '</dl>'
          }
        ]
      }
    ],
    RU_RU = [
      {
        title: 'Настройка профиля',
        faqs: [
          {
            question: 'Как настроить свой профиль в GGPartners?',
            answerHtml:
              '<ol>' +
              '<li>Войдите в свой аккаунт.</li>' +
              '<li>Нажмите на значок шестерёнки в правом верхнем углу страницы.</li>' +
              '<li>Перейдите в раздел Основные настройки.</li>' +
              '<li>Заполните как можно больше информации и нажмите Сохранить.</li>' +
              '</ol>' +
              '<div class="faq-images-row">' +
              '<div class="faq-images-col">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image20.png" alt="Значок шестерёнки на панели навигации">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image12.png" alt="Настройки профиля - вкладка Основные настройки">' +
              '</div>' +
              '<div class="faq-images-col">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image27.png" alt="Форма настроек профиля">' +
              '</div>' +
              '</div>'
          },
          {
            question: 'Я забыл пароль от своего аккаунта GGPartners. Как изменить пароль?',
            answerHtml:
              '<ol>' +
              '<li>Перейдите на страницу входа в аккаунт: <a href="https://affiliates.ggpartners.com/#/sign_in" target="_blank">https://affiliates.ggpartners.com/#/sign_in</a></li>' +
              '<li>Нажмите «Забыли пароль?».</li>' +
              '</ol>'
          },
          {
            question: 'Как настроить двухфакторную аутентификацию?',
            answerHtml:
              '<p>Нажмите <a href="https://docs.google.com/presentation/d/1lzOMLLwfhrkf2QUqQ7ZEUyi_-SXAuDf5Z9rspHf2rkI/edit?slide=id.g3083ec00730_0_26#slide=id.g3083ec00730_0_26" target="_blank">«Здесь»</a>, чтобы открыть инструкцию по настройке двухфакторной аутентификации, или см. раздел <strong>«Руководство по настройке MFA»</strong> ниже для получения полной пошаговой инструкции.</p>'
          }
        ]
      },
      {
        title: 'Руководство по настройке MFA',
        faqs: [
          {
            question: 'Обзор',
            answerHtml:
              '<p>Для повышения безопасности входа в наш бэк-офис мы внедрили многофакторную аутентификацию (MFA) с использованием одноразовых паролей на основе времени (TOTP). Этот дополнительный уровень защиты помогает обезопасить учётные записи пользователей, требуя при входе не только стандартные учётные данные, но и одноразовый код из приложения для аутентификации.</p>' +
              '<p>Вы можете использовать любое приложение, поддерживающее TOTP, например Google Authenticator, Microsoft Authenticator, Authy или любое другое приложение для генерации одноразовых кодов.</p>' +
              '<p>В этом разделе приведены пошаговые инструкции по включению и отключению MFA, настройке приложения для аутентификации и входу в систему с использованием MFA.</p>'
          },
          {
            question: 'Включение MFA',
            answerHtml:
              '<ol>' +
              '<li>Нажмите на значок профиля в верхней части страницы и перейдите в раздел «Настройки профиля».</li>' +
              '<li>Откройте раздел «Настройки профиля» → вкладка «Two-factor authentication».</li>' +
              '</ol>' +
              '<img class="faq-image" src="assets/images/faq_handbook/mfa1.png" alt="Настройки профиля - вкладка Two-factor authentication">'
          },
          {
            question: 'Установка приложения для генерации одноразовых кодов',
            answerHtml:
              '<ol>' +
              '<li>Откройте Google Play (на Android) или App Store (на iOS) на своём смартфоне.</li>' +
              '<li>Найдите и установите приложение для генерации одноразовых кодов (например, Google Authenticator, Microsoft Authenticator или Authy).</li>' +
              '</ol>'
          },
          {
            question: 'Подключение приложения для генерации одноразовых кодов к вашему аккаунту',
            answerHtml:
              '<ol>' +
              '<li>Введите текущий пароль и нажмите «Отправить».</li>' +
              '<li>Откройте приложение для генерации одноразовых кодов и нажмите «Начать» или «+», чтобы добавить новый аккаунт.</li>' +
              '<li>Отсканируйте QR-код, отображаемый на странице, с помощью приложения.</li>' +
              '<li>После генерации кода подтверждения он будет автоматически сохранён в приложении.</li>' +
              '<li>Введите полученный код в поле «Enter MFA code to enable» и нажмите «Сохранить».</li>' +
              '<li>Если всё выполнено успешно, на экране появится поле «Enter MFA code to disable».</li>' +
              '</ol>'
          },
          {
            question: 'Вход в систему с использованием MFA',
            answerHtml:
              '<ol>' +
              '<li>Войдите в аккаунт.</li>' +
              '<li>Откройте приложение для генерации одноразовых кодов и получите код для своего аккаунта.</li>' +
              '<li>Введите полученный код в поле «MFA code», чтобы завершить вход.</li>' +
              '</ol>'
          },
          {
            question: 'Отключение MFA',
            answerHtml:
              '<ol>' +
              '<li>Нажмите на значок профиля в верхней части страницы и перейдите в раздел «Настройки профиля».</li>' +
              '<li>Откройте раздел «Настройки профиля» → вкладка «Two-factor authentication».</li>' +
              '<li>Откройте приложение для генерации одноразовых кодов и получите код для своего аккаунта.</li>' +
              '<li>Введите полученный код в поле «Enter MFA code to disable» и нажмите «Сохранить».</li>' +
              '<li>После успешной проверки MFA будет отключена, а на экране снова появится поле «Текущий пароль».</li>' +
              '</ol>'
          }
        ]
      },
      {
        title: 'Панель управления',
        faqs: [
          {
            question: 'Обзор',
            answerHtml:
              '<ul>' +
              '<li>Панель управления — это основной раздел, где отображается вся ключевая статистика по вашему партнёрскому трафику, включая просмотры, клики, регистрации и первые депозиты.</li>' +
              '<li>Эту статистику можно дополнительно отфильтровать по брендам. Для этого в выпадающем меню выберите пункт «All», а затем укажите нужный бренд.</li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image1.png" alt="Панель статистики с выпадающим меню брендов">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image8.png" alt="Панель управления с открытым выпадающим меню брендов">' +
              '<ul>' +
              '<li>На панели управления также отображаются новые важные статьи и объявления, которые можно открыть и прочитать.</li>' +
              '<li>Здесь же вы найдёте информацию о вашем менеджере партнёрской программы.</li>' +
              '<li>Вы также можете найти игрока, введя его идентификационный номер (CID).</li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image19.png" alt="Разделы со статьями, информацией о менеджере и поиском игроков">'
          }
        ]
      },
      {
        title: 'Комиссии',
        faqs: [
          {
            question: 'Как настроить способ вывода средств?',
            answerHtml:
              '<ol>' +
              '<li>Войдите в свой аккаунт.</li>' +
              '<li>Нажмите на значок шестерёнки в правом верхнем углу страницы.' +
              '<img class="faq-image" src="assets/images/faq_handbook/image2.png" alt="Панель навигации в правом верхнем углу"></li>' +
              '<li>Перейдите в раздел «Платёжные системы».' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image13.png" alt="Настройки профиля - вкладка Платёжные системы"></li>' +
              '<li>Выберите платёжную систему. <strong>В настоящее время вывод средств на PayPal недоступен.</strong>' +
              '<img class="faq-image" src="assets/images/faq_handbook/image3.png" alt="Выпадающий список платёжных систем">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image7.png" alt="Список способов оплаты"></li>' +
              '<li>Введите платёжные данные.</li>' +
              '<li>Нажмите «Дефолтная платёжная система», чтобы сохранить выбранный способ вывода средств.' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image25.png" alt="Флажок платёжной системы по умолчанию">' +
              '<p>Подтвердите выбранный способ вывода средств.</p>' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image14.png" alt="Диалог подтверждения способа вывода по умолчанию"></li>' +
              '</ol>'
          },
          {
            question: 'Как вывести средства?',
            answerHtml:
              '<ul>' +
              '<li>Для вывода комиссии по брендам GGPoker и GGPokerUK необходимо накопить не менее 1000 долларов США.</li>' +
              '<li>Для бренда GGPokerCA минимальная сумма для вывода отсутствует.</li>' +
              '<li>Если сумма комиссии не достигнет $1000, она будет перенесена на следующий месяц.</li>' +
              '<li>Минимальная сумма для вывода по брендам:</li>' +
              '</ul>' +
              '<div class="faq-info-box">' +
              '<dl>' +
              '<dt>GGPoker</dt><dd>минимум $1000</dd>' +
              '<dt>GGPokerUK</dt><dd>минимум $1000</dd>' +
              '<dt>GGPokerCA</dt><dd>минимальная сумма не требуется</dd>' +
              '</dl>' +
              '</div>' +
              '<ul>' +
              '<li>Обработка заявок на вывод средств может занять до 7 дней.</li>' +
              '</ul>' +
              '<p class="faq-login-label">Войдите в свой аккаунт QUINTS:</p>' +
              '<br>' +
              '<ol>' +
              '<li>Перейдите в раздел <strong>«Отчёты»</strong>, затем откройте <strong>«Баланс партнёра»</strong>' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image15.png" alt="Боковое меню - Отчёты - Баланс партнёра"></li>' +
              '<li>Нажмите кнопку <strong>«Вывод»</strong>.' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image22.png" alt="Кнопка вывода средств"></li>' +
              '</ol>'
          }
        ]
      },
      {
        title: 'Технические вопросы',
        faqs: [
          {
            question: 'Как получить рекламные материалы (ссылки, баннеры, GIF и PNG файлы)?',
            answerHtml:
              '<ol>' +
              '<li>Перейдите в раздел «Трекинговые ссылки» и нажмите <strong>«Получить ссылку»</strong>.</li>' +
              '<li>Выберите бренд (GGPoker, GGPokerUK, GGPokerCA)' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image21.png" alt="Страница получения ссылки"></li>' +
              '<li>Тип сделки будет выбран автоматически.</li>' +
              '<li>Выберите код <strong>трекера</strong>, который хотите использовать. Для удобства также будет отображаться описание трекера.' +
              '<img class="faq-image" src="assets/images/faq_handbook/image32.png" alt="Выпадающий список форматов рекламных материалов: BannerFlow, Gif, Links, PNG"></li>' +
              '<li>Выберите формат рекламного материала' +
              '<ul><li>BannerFlow</li><li>Gif</li><li>Ссылки</li><li>PNG</li></ul></li>' +
              '<li>Выберите язык и размер рекламного материала (применимо только к баннерам, GIF и PNG файлам), а также кампанию' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image18.png" alt="Форма получения ссылки с выделенными полями"></li>' +
              '<li>Нажмите «Получить ссылку».</li>' +
              '<li>Нажмите «Скопировать реферальный код».</li>' +
              '<li><strong>Вставьте</strong> реферальный код в баннеры на вашем сайте.</li>' +
              '<li>Когда потенциальный игрок нажмёт на ваш баннер, он будет перенаправлен на страницу регистрации, а информация о вашем партнёрском аккаунте автоматически привяжется к этому игроку' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image5.png" alt="Кнопка копирования реферального кода"></li>' +
              '</ol>'
          },
          {
            question: 'Можно ли создать дополнительные трекеры?',
            answerHtml:
              '<ul>' +
              '<li>При регистрации партнёрского аккаунта автоматически создаётся трекер по умолчанию, который ваш менеджер привязывает к условиям выплаты комиссии.</li>' +
              '<li>Если вам нужны дополнительные трекеры, вы можете создать их самостоятельно в личном кабинете партнёра:' +
              '<ol><li>Перейдите на вкладку «Трекинговые ссылки».</li><li>Откройте раздел «Трекеры».</li><li>Нажмите «Добавить трекер».</li><li>Укажите описание трекера.</li></ol></li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image6.png" alt="Боковое меню - Трекинговые ссылки с выделенным разделом Трекеры">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image10.png" alt="Страница трекеров с кнопкой Добавить трекер">'
          },
          {
            question: 'Могу ли я получить рекламные материалы для размещения на своем сайте?',
            answerHtml:
              '<ul>' +
              '<li>Ваш менеджер предоставит вам доступ к рекламным материалам, которые можно использовать на вашем сайте.</li>' +
              '<li>Если вам нужны рекламные материалы нестандартного размера или с другими особыми требованиями, обратитесь к своему менеджеру.</li>' +
              '</ul>'
          },
          {
            question: 'Как создать новый промокод?',
            answerHtml:
              '<p>Чтобы создать новый промокод, обратитесь к своему менеджеру. Он сообщит вам, когда промокод будет создан.</p>' +
              '<p><strong>Необходимая информация:</strong></p>' +
              '<ul>' +
              '<li>Название промокода</li>' +
              '<li>Бренд (GGPoker, GGPokerUK, GGPokerCA)</li>' +
              '<li>Код трекера (промокод должен быть привязан к определённому трекеру)</li>' +
              '</ul>'
          },
          {
            question: 'Как создать приватный турнир для своих подписчиков?',
            answerHtml:
              '<ul>' +
              '<li>Если вы хотите создать приватный турнир, обратитесь к своему менеджеру.</li>' +
              '<li>Заявка на проведение приватного турнира должна быть полностью заполнена и отправлена не позднее чем за 1 неделю до даты начала турнира, а для более сложных турниров — не позднее чем за 2 недели.</li>' +
              '<li>При подаче заявки необходимо выбрать один из вариантов <strong>доступа</strong> к турниру:' +
              '<ol>' +
              '<li>Только по билету (необходимо предоставить список игроков, которым билеты будут выданы вручную)</li>' +
              '<li>Только по паролю</li>' +
              '<li>Без билета и без пароля (турнир будет виден и доступен только игрокам, чьи аккаунты привязаны к вашему партнёрскому идентификатору)</li>' +
              '</ol></li>' +
              '<li>Приватные турниры появятся в приложении/клиенте GGPoker в течение <strong>70 дней</strong> с даты начала турнира.</li>' +
              '</ul>'
          },
          {
            question: 'Как сформировать отчёты по статистике?',
            answerHtml:
              '<ul>' +
              '<li>Отчёты используются для анализа и отслеживания вашей эффективности, а также активности игроков.</li>' +
              '<li>Откройте выпадающее меню «Отчёты» и выберите пункт «Отчёты» (для формирования общего отчёта).</li>' +
              '<li>Следуйте приведённым ниже инструкциям, чтобы настроить отчёт для быстрого просмотра или полной выгрузки.</li>' +
              '</ul>' +
              '<ol>' +
              '<li>Выберите период' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image16.png" alt="Выбор диапазона дат"></li>' +
              '<li>Выберите параметры группировки' +
              '<ul>' +
              '<li><div class="faq-text-image-row"><div class="faq-text-col">Период</div><div class="faq-image-col"><img class="faq-image" src="assets/images/faq_handbook/ru/image4.png" alt="Группировка по дню, неделе, месяцу или выбранному периоду"></div></div></li>' +
              '<li><div class="faq-text-image-row"><div class="faq-text-col">Тип<ul><li>По бренду</li><li>По трекеру</li><li>По игроку</li></ul></div><div class="faq-image-col"><img class="faq-image" src="assets/images/faq_handbook/ru/image23.png" alt="Группировка по бренду, менеджеру, партнёру, трекеру, utm-коду, игроку"></div></div></li>' +
              '<li><div class="faq-text-image-row"><div class="faq-text-col">Игроки<ul><li>Все игроки</li><li>Новые игроки</li><li>Игроки с первым депозитом</li><li>Существующие игроки</li></ul></div><div class="faq-image-col"><img class="faq-image" src="assets/images/faq_handbook/ru/image9.png" alt="Фильтр по игрокам"></div></div></li>' +
              '<li>Количество результатов на странице<ul><li>10</li><li>50</li><li>100</li></ul></li>' +
              '</ul></li>' +
              '<li>При необходимости задайте дополнительные фильтры и сохраните их под названием для дальнейшего использования' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image11.png" alt="Панель фильтров"></li>' +
              '<li>Нажмите <strong>«Скачать»</strong> или <strong>«Сформировать отчёт»</strong>' +
              '<ul>' +
              '<li>Для <strong>быстрого просмотра</strong> статистики нажмите <strong>«Сформировать отчёт»</strong></li>' +
              '<li>Для выгрузки <strong>больших</strong> объёмов данных' +
              '<ul>' +
              '<li>Нажмите кнопку <strong>«Скачать»</strong></li>' +
              '<li>В появившемся окне загрузки отчёта нажмите <strong>«ОК»</strong></li>' +
              '<li>Нажмите <strong>«Скачать отчёт»</strong> (кнопка появится в правом нижнем углу экрана)</li>' +
              '<li>Когда отчёт будет готов, нажмите на <strong>синюю иконку загрузки</strong>. Для больших отчётов может потребоваться обновить страницу</li>' +
              '</ul></li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image26.png" alt="Кнопки Сформировать отчёт и Скачать">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image24.png" alt="Диалог загрузки отчёта - нажмите ОК">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image28.png" alt="Отчёт создан - нажмите Скачать отчёт">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image30.png" alt="Экспорт данных - опция скачивания отчёта">' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image31.png" alt="Значок скачивания отчёта"></li>' +
              '</ol>'
          },
          {
            question: 'Как подключить Postback / Pixel Tracking (S2S-запросы)?',
            answerHtml: '<p>Если вы хотите подключить Postback / Pixel Tracking, обратитесь к своему менеджеру.</p>'
          }
        ]
      },
      {
        title: 'AppsFlyer',
        faqs: [
          {
            question: 'Обзор',
            answerHtml:
              '<ul>' +
              '<li>AppsFlyer — это платформа мобильной атрибуции и маркетинговой аналитики, которая помогает партнёрам в сфере iGaming отслеживать и оптимизировать свои маркетинговые кампании.</li>' +
              '<li>Для использования AppsFlyer партнёру необходимо сначала зарегистрировать аккаунт в партнёрской программе, затем создать аккаунт AppsFlyer и предоставить своему менеджеру свое агентское имя AppsFlyer, права доступа в AppsFlyer, а также список брендов, с которыми он работает в AppsFlyer.</li>' +
              '<li>Также партнёру необходимо убедиться, что в аккаунте AppsFlyer активирован параметр <strong>«PID»</strong>, чтобы OneLink работал корректно.</li>' +
              '<li>Следующие обязательные параметры AppsFlyer также настраиваются со стороны партнёрки. При этом партнёру необходимо предоставить своему менеджеру информацию о <strong>qtag</strong> для корректной настройки:</li>' +
              '</ul>' +
              '<h3 class="faq-subsection-title">1. Обязательные параметры AppsFlyer</h3>' +
              '<dl class="faq-params-list">' +
              '<dt>pid (источник трафика):</dt><dd>Основной источник трафика, используемый в отчётах по атрибуции (например, XYZ_Media).</dd>' +
              '<dt>af_sub1 (идентификатор партнёра):</dt><dd>Уникальный идентификатор партнёра.</dd>' +
              '<dt>qtag (основной):</dt><dd>Уникальный тег отслеживания для внутреннего сопоставления данных. Должен соответствовать внутреннему формату отслеживания (например, axxx_txxx_cxxx_s).</dd>' +
              '<dt>af_sub2 (резервная копия PID):</dt><dd>Резервное значение источника трафика для предотвращения потери данных.</dd>' +
              '<dt>af_sub3 (резервная копия QTag 1):</dt><dd>Первое резервное поле для QTag.</dd>' +
              '<dt>deep_link_sub2 (резервная копия QTag 2):</dt><dd>Обеспечивает передачу QTag через механизм глубокой ссылки (UDL).</dd>' +
              '</dl>' +
              '<h3 class="faq-subsection-title">2. Фиксированные внутренние параметры (не являются обязательными)</h3>' +
              '<dl class="faq-params-list">' +
              '<dt>af_dp (схема приложения):</dt>' +
              '<dd>Устанавливается в значение <a href="ggpoker.com//onelink" target="_blank">ggpoker.com//onelink</a> (для бренда GGPokerCOM)</dd>' +
              '<dd>Устанавливается в значение <a href="ggpokerca://onelink" target="_blank">ggpokerca://onelink</a> (для бренда GGPokerCA)</dd>' +
              '<dt>af_xp:</dt><dd>Устанавливается в значение App</dd>' +
              '</dl>' +
              '<h3 class="faq-subsection-title">3. Необязательные дополнительные поля</h3>' +
              '<dl class="faq-params-list">' +
              '<dt>af_sub4 – af_sub8:</dt><dd>Партнёры могут использовать эти поля для передачи собственных параметров (например, click_id).</dd>' +
              '</dl>'
          },
          {
            question: 'QTAG для параметров: qtag, af_sub3, deep_link_sub2',
            answerHtml:
              '<ul>' +
              '<li>Чтобы найти свой <strong>qtag</strong>, следуйте инструкции <strong>«Получить ссылку»</strong> выше. После выбора кампании и вставки реферальной ссылки в браузер вы увидите свой qtag.</li>' +
              '<li>В qtag также содержится ваш идентификатор партнёра (для параметра <strong>af_sub1</strong>). Это первый набор цифр сразу после буквы <strong>«a»</strong> в qtag (24781 в приведённом ниже примере).</li>' +
              '<li>Менеджеру необходимо предоставить только подчёркнутую часть <strong>qtag</strong>. В приведённом ниже <strong>примере</strong> это <strong>«a24781_t6432_c1»</strong> <strong>(символы, начиная с «Q» и далее, указывать не требуется)</strong>.</li>' +
              '<li><strong>Не забудьте добавить «_s» в конце qtag.</strong></li>' +
              '</ul>' +
              '<img class="faq-image" src="assets/images/faq_handbook/ru/image29.png" alt="Адресная строка браузера с параметром qtag">' +
              '<p class="faq-note"><strong>Приведённый выше QTAG является только примером — не используйте этот QTAG.</strong></p>' +
              '<div class="faq-info-box">' +
              '<p><strong>Структура QTAG:</strong></p>' +
              '<dl>' +
              '<dt>A</dt><dd>идентификатор партнёра</dd>' +
              '<dt>T</dt><dd>номер трекера</dd>' +
              '<dt>C</dt><dd>идентификатор рекламного креатива</dd>' +
              '</dl>' +
              '</div>'
          },
          {
            question: 'Активация партнёра AppsFlyer',
            answerHtml:
              '<p>Перед тем как запрашивать интеграцию AppsFlyer, партнёру необходимо самостоятельно завершить настройку AppsFlyer. Для этого воспользуйтесь официальным руководством по активации партнёра AppsFlyer:</p>' +
              '<p><a href="https://support.appsflyer.com/hc/en-us/articles/360000844778-Partner-activation-deactivation#activating-a-partner" target="_blank">https://support.appsflyer.com/hc/en-us/articles/360000844778-Partner-activation-deactivation#activating-a-partner</a></p>' +
              '<p>После того как партнёр зарегистрирует аккаунт в партнёрской программе, завершит настройку AppsFlyer со своей стороны и предоставит своему менеджеру всю необходимую информацию AppsFlyer, ему будут предоставлены AppsFlyer OneLink для каждого запрошенного бренда (GGPokerUK, GGPokerCA).</p>' +
              '<p>Дополнительные инструкции доступны по ссылке: <a href="https://support.appsflyer.com/hc/en-us/articles/360000844778-Partner-activation-deactivation#activating-a-partner" target="_blank">https://support.appsflyer.com/hc/en-us/articles/360000844778-Partner-activation-deactivation#activating-a-partner</a></p>'
          }
        ]
      },
      {
        title: 'Настройка интеграции Postback',
        faqs: [
          {
            question: 'Обзор и параметры',
            answerHtml:
              '<h3 class="faq-subsection-title">Что такое Postback?</h3>' +
              '<p>Postback — это вебхук, то есть HTTP-запрос от сервера к серверу, который Quints отправляет на сервер партнёра при наступлении определённого события (например, регистрации игрока или первого депозита). Партнёры используют Postback для отслеживания конверсий в режиме реального времени.</p>' +
              '<h3 class="faq-subsection-title">Типы параметров</h3>' +
              '<p>Параметры используются для определения источника вашего трафика.</p>' +
              '<dl class="faq-params-list">' +
              '<dt>Статические параметры</dt><dd>Не изменяются. Пример: <code>organization=234567</code>.</dd>' +
              '<dt>Динамические параметры</dt><dd>Изменяются для каждого клика или каждого игрока. Например, идентификаторы кликов, передаваемые через поле ANID.</dd>' +
              '</dl>' +
              '<p>Структура BTag: <code>aXXX_tXXX_cXXXX_sXXXX_XXXX_XXXX</code></p>' +
              '<h3 class="faq-subsection-title">Доступные переменные Quints</h3>' +
              '<p>Следующие переменные можно использовать в качестве значений при настройке URL для Postback:</p>' +
              '<dl class="faq-params-list">' +
              '<dt>{affiliate_id}</dt><dd>Идентификатор партнёра в Quints</dd>' +
              '<dt>{cid}</dt><dd>Идентификатор игрока</dd>' +
              '<dt>{creative_id}</dt><dd>Идентификатор рекламного материала (баннера)</dd>' +
              '<dt>{serial_id}</dt><dd>Эквивалент {anid} — полное значение ANID, переданное партнёром в рекламной ссылке</dd>' +
              '<dt>{source_id1} – {source_id5}</dt><dd>Отдельные части значения ANID, разделённые символом подчёркивания</dd>' +
              '<dt>{source_id}</dt><dd>Передаёт сразу все пять частей source ID</dd>' +
              '</dl>' +
              '<p><strong>Примечание по {serial_id}:</strong> В настройках Postback переменная {serial_id} соответствует {anid}. Если партнёр передаёт <code>anid=v1_v2</code>, то {serial_id} = v1_v2, {source_id1} = v1, а {source_id2} = v2.</p>' +
              '<h3 class="faq-subsection-title">Структура рекламной ссылки</h3>' +
              '<p>Quints может одновременно хранить до пяти параметров (статических или динамических). Стандартная структура рекламной ссылки выглядит следующим образом:</p>' +
              '<p><code>https://click.ggpartners.com/?serial=4017&amp;creative_id=4937&amp;anid={source_id1}_{source_id2}_{source_id3}_{source_id4}_{source_id5}</code></p>'
          },
          {
            question: 'Настройка Postback',
            answerHtml:
              '<h3 class="faq-subsection-title">1. URL-адреса Postback партнёра</h3>' +
              '<p>Партнёр должен предоставить URL-адрес(а) своего сервера для Postback своему менеджеру. Как правило, используются отдельные URL для регистрации и первого депозита. Пример:</p>' +
              '<dl class="faq-params-list">' +
              '<dt>Регистрация</dt><dd><code>https://www.pixelhere.com/et/event.php?advertiser=182876&amp;cid=INSERT_CLICK_ID&amp;id=32a3cb</code></dd>' +
              '<dt>Первый депозит (FTD)</dt><dd><code>https://www.pixelhere.com/et/event.php?advertiser=182876&amp;cid=INSERT_CLICK_ID&amp;id=f2fefe</code></dd>' +
              '</dl>' +
              '<h3 class="faq-subsection-title">2. Откройте настройки Postback в Quints</h3>' +
              '<p>Перейдите в <strong>боковое меню</strong> → <strong>«Трекинговые ссылки»</strong> → нажмите на значок <strong>Postback</strong> (выделен жёлтым).</p>' +
              '<img class="faq-image" style="width: 150px" src="assets/images/faq_handbook/ru/image44.png" alt="Боковое меню с развёрнутым разделом Трекинговые ссылки и пунктом Postback, выделенным красным">' +
              '<h3 class="faq-subsection-title">3. Добавьте вебхук для регистрации</h3>' +
              '<ol>' +
              '<li>В разделе «Регистрация» нажмите <strong>«Добавить вебхук»</strong>.</li>' +
              '<li>Выберите <strong>метод запроса</strong>. Если не указано иное, используйте метод <strong>GET</strong>.</li>' +
              '</ol>' +
              '<p>После нажатия «Добавить вебхук» откроется окно создания. Выберите <strong>«Регистрация»</strong>, чтобы настроить Postback для регистрации.</p>' +
              '<p><strong>Примечание:</strong> Вы не сможете указать параметры URL, пока не выберете метод запроса.</p>' +
              '<img class="faq-image" style="width: 50%" src="assets/images/faq_handbook/ru/image39.png" alt="Диалог создания вебхука с вариантами Registration, Deposit и Activity">' +
              '<p>Существует 3 метода запроса:</p>' +
              '<dl class="faq-params-list">' +
              '<dt>GET</dt><dd>Получает (считывает) данные из Quints (используется по умолчанию)</dd>' +
              '<dt>POST</dt><dd>Отправляет данные на сервер Postback партнёра</dd>' +
              '<dt>PUT</dt><dd>Изменяет данные на сервере Postback партнёра</dd>' +
              '</dl>'
          }
        ]
      }
    ];

  angular.module('quintessenceAngular').constant('FaqHandbookContent', {
    en_US: EN_US,
    ru_RU: RU_RU
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('affiliate_download_csv', {
      url: '/affiliate/download_csv',
      templateUrl: 'app/components/download_csv/partials/list.html',
      controller: 'DownloadCsvController',
      controllerAs: 'downloadCtrl',
      data: {
        translateKey: 'AffiliateDownloadCsv',
        deletePermission: 'api2.affiliate.backgroundreportscontroller.edit',
        permissions: permissionsStateAccess.init(['api2.affiliate.backgroundreportscontroller.show'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        export: {
          download_csv: [
            'header||download_csv.header',
            {
              remove_modal: [
                'title||remove_modal.title',
                'question||remove_modal.question',
                'answer_yes||remove_modal.answer_yes',
                'answer_no||remove_modal.answer_no'
              ]
            },
            {
              aasm_state: ['in_progress||aasm_state.in_progress', 'ready||aasm_state.ready']
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateDownloadCsv', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider) {
    $stateProvider.state('affiliate', {
      url: '/affiliate',
      templateUrl: 'app/affiliate/dashboard/partials/dashboard.html',
      controller: 'AffiliateDashboardController',
      controllerAs: 'affiliateCtrl'
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        dashboard: [
          'last_update||dashboard.last_update',
          {
            periods: [
              'today||periods.today',
              'yesterday||periods.yesterday',
              'last_week||periods.last_week',
              'week||periods.week',
              'month||periods.month',
              'last_month||periods.last_month',
              'year||periods.year'
            ],
            stats_block: [
              'header||stats_block.header',
              'views_count||stats_block.views_count',
              'clicks_count||stats_block.clicks_count',
              'partner_commission||stats_block.partner_commission',
              'number_of_registrations||stats_block.number_of_registrations',
              'number_of_depositaries||stats_block.number_of_depositaries'
            ],
            manager_block: [
              'header||manager_block.header',
              'name||manager_block.name',
              'skype||manager_block.skype',
              'email||manager_block.email'
            ],
            checking_player: [
              'header||checking_player.header',
              'players_name||checking_player.players_name',
              'check_button||checking_player.check_button',
              'placeholder||checking_player.placeholder',
              {
                modal_window: ['title||modal_window.title', 'close||modal_window.close']
              }
            ],
            charts: [
              {
                by_day: [
                  'header||charts.by_day.header',
                  'month||charts.by_day.month',
                  'last_month||charts.by_day.last_month'
                ]
              },
              {
                by_months: [
                  'header||charts.by_months.header',
                  'old_players||charts.by_months.old_players',
                  'new_players||charts.by_months.new_players'
                ]
              }
            ],
            last_articles: [
              'title||last_articles.title',
              'no_articles||last_articles.no_articles',
              'see_more||last_articles.see_more'
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateDashboard', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateDashboardController', AffiliateDashboardController);

  AffiliateDashboardController.$inject = [
    '$state',
    '$mdTranslate',
    'AffiliateDashboardApi',
    'AffiliatePlayersCheckApi',
    '$mdDialog',
    'outputErrors',
    'permissionsManager',
    '_',
    'toastsApi'
  ];

  function AffiliateDashboardController(
    $state,
    $mdTranslate,
    AffiliateDashboardApi,
    AffiliatePlayersCheckApi,
    $mdDialog,
    outputErrors,
    permissionsManager,
    _,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateDashboard';
    vm.periods = ['today', 'yesterday', 'last_week', 'week', 'month', 'last_month', 'year'];
    vm.month = vm.periods[4];
    vm.getStatsPermission = permissionsManager.checkPermission('api2.affiliate.dashboardcontroller.get_stats');
    vm.lastUpdatePermission = permissionsManager.checkPermission('api2.affiliate.dashboardcontroller.last_update');
    vm.chartsPermission = permissionsManager.checkPermission('api2.affiliate.dashboardcontroller.chart');
    vm.chiefPermission = permissionsManager.checkPermission('api2.affiliate.dashboardcontroller.personal_chief');
    vm.articlesPermission = permissionsManager.checkPermission('api2.affiliate.articlescontroller.show');
    vm.playersCheckPermission = permissionsManager.checkPermission('api2.affiliate.dashboardcontroller.players_check');
    vm.errors = outputErrors.createNew();

    vm.articlesOptions = {
      namespace: 'affiliate',
      view_state: 'affiliate_articles.view',
      translate_key: vm.translate_key,
      no_articles_shortcode: 'last_articles.no_articles',
      permission: 'api2.affiliate.articlescontroller.show',
      date_format: 'LLL'
    };
    vm.currentMerchant = null;
    vm.merchantsList = [];

    vm.chartOptions = {
      translate_key: vm.translate_key,
      namespace: 'affiliate',
      by_day_header_shortcode: 'charts.by_day.header',
      by_months_header_shortcode: 'charts.by_months.header'
    };

    vm.changeMonthInfo = function() {
      vm.affiliate_current_data = vm.statistics[vm.month];
    };

    vm.players_check = function() {
      if (!vm.playersCheckPermission) {
        return;
      }

      if (vm.PlayerCheckForm.$valid) {
        AffiliatePlayersCheckApi.players_check(vm.players_name).then(
          function(response) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .clickOutsideToClose(true)
                .title($mdTranslate.instant(vm.translate_key, 'modal_window.title'))
                .textContent(response.data.result)
                .ok($mdTranslate.instant(vm.translate_key, 'modal_window.close'))
            );
          },
          function(response) {
            vm.errors.alertDialog(
              response.data.errors || response.data.result,
              $mdTranslate.instant(vm.translate_key, 'modal_window.title'),
              $mdTranslate.instant(vm.translate_key, 'modal_window.close')
            );
          }
        );
      }
    };

    vm.showAllArticles = function() {
      $state.go('affiliate_articles');
    };

    vm.getLastUpdate = function() {
      if (!vm.lastUpdatePermission) {
        return;
      }

      AffiliateDashboardApi.getLastUpdate(vm.currentMerchant).then(
        function(response) {
          vm.date_update_statistic = response.data.date_update_statistic;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getCharts = function() {
      if (!vm.chartsPermission) {
        return;
      }

      AffiliateDashboardApi.getCharts(vm.currentMerchant).then(
        function(response) {
          var data = response.data;

          vm.chartsData = data.chart;
          vm.chartOptions.columnsNamespace = data.locale_key_chart + '.';
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.changeMerchant = function() {
      vm.getLastUpdate();
      vm.getCharts();
      vm.getStats();
      vm.getPersonalChief();
    };

    vm.setUpCurrentMerchant = function(list) {
      return _.propertyOf(_.findWhere(list, {default: true}))('id');
    };

    vm.getStats = function() {
      if (!vm.getStatsPermission) {
        return;
      }

      AffiliateDashboardApi.getStats(vm.currentMerchant).then(
        function(response) {
          var data = response.data;

          vm.statistics = data.statistics;
          vm.affiliate_current_data = vm.statistics ? vm.statistics[vm.month] : {};
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getPersonalChief = function() {
      if (!vm.chiefPermission) {
        return;
      }

      AffiliateDashboardApi.getChief().then(
        function(response) {
          vm.chief = response.data.chief;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    if (vm.getStatsPermission) {
      AffiliateDashboardApi.getMerchants().then(
        function(response) {
          vm.merchantsList = response.data;
          vm.currentMerchant = vm.setUpCurrentMerchant(vm.merchantsList);

          vm.changeMerchant();
        },
        function() {
          toastsApi.toastError();
        }
      );
    } else {
      vm.changeMerchant();
    }
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateCreativeViewController', AffiliateCreativeViewController);

  AffiliateCreativeViewController.$inject = ['$mdDialog'];

  function AffiliateCreativeViewController($mdDialog) {
    var vm = this;

    vm.closePopup = function() {
      $mdDialog.hide();
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    var tabsList = ['link', 'jpeg', 'png', 'gif', 'bannerflow_gif', 'iframe', 'flash'];

    $stateProvider.state('affiliate_trackers.creatives', {
      url: '/creatives/:trackerCode',
      templateUrl: 'app/affiliate/creatives/partials/creatives.html',
      controller: 'AffiliateCreativesListController',
      controllerAs: '$ctrl',
      data: {
        tabsList: tabsList,
        permissions: permissionsStateAccess.init(['api2.affiliate.creativescontroller.show'])
      }
    });

    angular.forEach(tabsList, function(name) {
      $stateProvider.state('affiliate_trackers.creatives.' + name, {
        url: '/' + name,
        data: {
          type: name
        },
        views: {
          'content@affiliate_trackers.creatives': {
            templateUrl: 'app/affiliate/creatives/partials/list.html',
            controller: 'AffiliateCreativeTabController',
            controllerAs: 'tabCtrl'
          },
          'search@affiliate_trackers.creatives': {
            templateUrl: 'app/affiliate/creatives/partials/search.html'
          },
          'pagination@affiliate_trackers.creatives': {
            templateUrl: 'app/affiliate/creatives/partials/pagination.html'
          }
        }
      });
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        creatives: [
          {
            tabs: [
              'link||creatives_tab.link',
              'jpeg||creatives_tab.jpeg',
              'png||creatives_tab.png',
              'gif||creatives_tab.gif',
              'bannerflow_gif||creatives_tab.bannerflow_gif',
              'iframe||creatives_tab.iframe',
              'flash||creatives_tab.flash'
            ],
            modal_window: [
              'title||modal_window.title',
              'banner_code||modal_window.banner_code',
              'zone_id||modal_window.zone_id',
              'redirect_link||modal_window.redirect_link',
              {
                integration_format: [
                  'label||modal_window.integration_format.label',
                  'url||modal_window.integration_format.url',
                  'url_js||modal_window.integration_format.url_js'
                ]
              },
              'button_copy||modal_window.button_copy',
              'button_cancel||modal_window.button_cancel'
            ]
          },
          'header||creatives.header',
          'no_creatives||creatives.no_creatives',
          'back||creatives.back'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateCreatives', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateCreativeTabController', AffiliateCreativeTabController);

  AffiliateCreativeTabController.$inject = [
    '$scope',
    '$state',
    '$mdDialog',
    'tableEngine',
    'AffiliateCreativesApi',
    '_',
    'tabsApi',
    '$sce',
    'toastsApi'
  ];

  function AffiliateCreativeTabController(
    $scope,
    $state,
    $mdDialog,
    tableEngine,
    AffiliateCreativesApi,
    _,
    tabsApi,
    $sce,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateCreatives';
    vm.stateData = $state.current.data;
    vm.tabs = tabsApi.getTabsByName('affiliate_creatives');

    vm.getModalOptions = function(creative) {
      return {
        title: creative.title,
        src: $sce.trustAsResourceUrl(
          creative[_.contains(['iframe', 'bannerflow_gif'], creative.format) ? 'body' : 'img']
        ),
        width: creative.resolution ? _.first(creative.resolution.split('x')) : 'auto',
        height: creative.resolution ? _.last(creative.resolution.split('x')) : 'auto'
      };
    };

    vm.openModal = function(creative, templateUrl, ev) {
      $mdDialog.show({
        controller: 'AffiliateCreativeViewController',
        controllerAs: 'viewCtrl',
        bindToController: true,
        templateUrl: templateUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: vm.getModalOptions(creative)
      });
    };

    vm.showCreative = function(creative, ev) {
      vm.openModal(creative, vm.tabs.activeTab.modal_template_url, ev);
    };

    vm.showCreativeCode = function(creative, ev) {
      $mdDialog.show({
        controller: 'CreativeCodeController',
        controllerAs: 'creative_code',
        bindToController: true,
        templateUrl: 'app/affiliate/creatives/partials/creative_code_tmp.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          translate_key: vm.translate_key,
          serial_id: vm.tabs.activeTab.data.serialId,
          creative_id: creative.id,
          img: creative.img,
          creative_type: vm.stateData.type,
          creative: creative || {}
        }
      });
    };

    vm.getTab = function(type) {
      return vm.tabs.findTabByCondition(function(tab) {
        return tab.name === type;
      });
    };

    vm.getMethods = function() {
      var tab = vm.getTab(vm.stateData.type);

      return tab ? _.omit(vm.creativeMethods, tab.excluded_methods || []) : {};
    };

    vm.tableFiliterColumns = [
      {
        name: 'merchant_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'title',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'advertising_company',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'language',
        type: 'checkbox',
        display: true,
        empty: true,
        checkbox_namespace: 'common.languages.'
      },
      {
        name: 'at_beginning_show',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'at_end_show',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'created_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'resolution',
        type: 'checkbox',
        display: true,
        empty: true
      }
    ];

    vm.creativeMethods = {
      show: vm.showCreative,
      showCode: vm.showCreativeCode
    };

    vm.table = tableEngine.getOrCreate({
      api: AffiliateCreativesApi,
      name: 'affiliate_creatives_' + vm.stateData.type,
      mobile: {
        defaultColumns: ['title']
      },
      buttons: {
        url: 'app/affiliate/creatives/partials/table.html',
        methods: vm.getMethods()
      },
      params: {
        data: {
          additional_options: {
            format: vm.stateData.type
          }
        }
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/affiliate/creatives/' + vm.stateData.type,
        actionForFilter: 'list',
        filterName: 'creative_' + vm.stateData.type
      }
    });

    vm.tabs.setUpTable(vm.stateData.type, vm.table);

    if (!vm.table.isRendered()) {
      AffiliateCreativesApi.get_creatives(vm.stateData.type).then(
        function(response) {
          var data = response.data,
            opts = {
              locale_key: data.locale_key,
              columns: data.columns_for_display_data,
              list: data.list,
              total_pages: data.total_pages,
              total_entries: data.total_entries,
              start_row_num: data.start_row_num,
              end_row_num: data.end_row_num
            };

          vm.table.update(opts);
          vm.table.addOptionsToColumn('language', {
            localizied: true,
            locales: {
              namespace: 'creative.list_locales'
            }
          });
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AffiliateCreativesListController', AffiliateCreativesListController);

  AffiliateCreativesListController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'tableEngine',
    'AffiliateCreativesApi',
    'tabsApi',
    'toastsApi',
    '_'
  ];

  function AffiliateCreativesListController(
    $scope,
    $state,
    $stateParams,
    tableEngine,
    AffiliateCreativesApi,
    tabsApi,
    toastsApi,
    _
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateCreatives';
    vm.serialId = $stateParams.trackerCode;
    vm.stateData = $state.current.data;
    vm.noCreatives = true;
    vm.dataReceived = false;

    vm.options = {
      link: {excluded_methods: ['show']},
      jpeg: {modal_template_url: 'app/affiliate/creatives/partials/creative_img.html'},
      png: {modal_template_url: 'app/affiliate/creatives/partials/creative_img.html'},
      gif: {modal_template_url: 'app/affiliate/creatives/partials/creative_img.html'},
      bannerflow_gif: {modal_template_url: 'app/affiliate/creatives/partials/view_iframe.html'},
      iframe: {modal_template_url: 'app/affiliate/creatives/partials/view_iframe.html'},
      flash: {modal_template_url: 'app/affiliate/creatives/partials/view_flash.html'}
    };

    vm.buildTabs = function(list) {
      return _.map(list, function(val) {
        return {
          name: val,
          shortcode: 'creatives_tab.' + val,
          state: 'affiliate_trackers.creatives.' + val,
          excluded_methods: vm.options[val].excluded_methods || [],
          modal_template_url: vm.options[val].modal_template_url || '',
          table: null
        };
      });
    };

    vm.displayTabs = function(activeList) {
      _.each(activeList, function(val, key) {
        vm.tabs.hideTabControl(key, !val);
        vm.tabs.setTabAdditionalData(key, {serialId: vm.serialId});
      });
    };

    vm.checkActivesList = function(activeList) {
      vm.noCreatives = !_.some(_.values(activeList));
      vm.dataReceived = true;
    };

    vm.backToTrackers = function() {
      $state.go('affiliate_trackers');
    };

    vm.getFirstTabName = function(list) {
      var actives = _.filter(_.keys(list), function(val) {
        return list[val];
      });

      return _.find(vm.stateData.tabsList, function(val) {
        return _.contains(actives, val);
      });
    };

    vm.tabs = tabsApi.init({
      name: 'affiliate_creatives',
      translateKey: vm.translate_key,
      list: vm.buildTabs(vm.stateData.tabsList)
    });

    vm.getActuallyCreatives = function() {
      AffiliateCreativesApi.getActuallyCreatives().then(
        function(response) {
          var activeTypes = response.data.active_type,
            name = vm.getFirstTabName(activeTypes);

          vm.displayTabs(activeTypes);
          vm.checkActivesList(activeTypes);

          if (_.isEmpty(vm.tabs.activeTab)) {
            $scope.$broadcast('$changeTab', {name: name});
          } else {
            $state.go('affiliate_trackers.creatives.' + vm.tabs.activeTab.name).catch(function() {
              if (name) {
                $state.go('affiliate_trackers.creatives.' + name);
              }
            });
          }
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.destroyTables = function() {
      _.each(vm.stateData.tabsList, function(val) {
        var table = tableEngine.getTableByName('affiliate_creatives_' + val);

        if (table) {
          table.destroy();
        }
      });
    };

    vm.getActuallyCreatives();

    $scope.$on('$changeMerchantSuccess', function() {
      vm.getActuallyCreatives();
    });

    $scope.$on('$destroy', function() {
      vm.destroyTables();
      vm.tabs.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('CreativeCodeController', CreativeCodeController);

  CreativeCodeController.$inject = [
    '$scope',
    '$mdDialog',
    'AffiliateCreativesApi',
    'UserlocalStorage',
    'toastsApi',
    '_'
  ];

  function CreativeCodeController($scope, $mdDialog, AffiliateCreativesApi, UserlocalStorage, toastsApi, _) {
    var vm = this;

    vm.zone_id = '';
    vm.redirect_link = '';
    vm.creative_code = '';
    vm.last_format = UserlocalStorage.get('last_format_changes') || {};

    vm.params_for_url = {
      creative_id: vm.creative_id,
      serial: vm.serial_id
    };

    vm.set_zone_id = function() {
      vm.params_for_url.anid = vm.zone_id;
      vm.get_redirect_link();
    };

    vm.change_click_url_format = function() {
      vm.last_format[vm.creative_type] = vm.integration_format;
      UserlocalStorage.save('last_format_changes', vm.last_format);
    };

    vm.get_redirect_link = function() {
      AffiliateCreativesApi.get_redirect_link(vm.params_for_url, vm.creative.format).then(
        function(response) {
          vm.redirect_link = response.data.redirect_url;
          vm.click_url = response.data.click_url;
          vm.integration_format = vm.last_format[vm.creative_type] || 'url';
          vm.click_url_formats = _.keys(vm.click_url);

          if (!vm.click_url[vm.integration_format]) {
            vm.integration_format = vm.click_url_formats[0];
          }
        },
        function() {}
      );
    };

    vm.copySuccess = function() {
      toastsApi.toastCopySuccess();
    };

    vm.close = function() {
      $mdDialog.hide();
    };

    vm.set_zone_id();
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('affiliate_bookkeeping', {
        url: '/affiliate/bookkeeping',
        templateUrl: 'app/components/bookkeeping/partials/bookkeeping.html',
        controller: 'BookkeepingController',
        controllerAs: 'bookkeeping',
        data: {
          readonly: true,
          namespace: 'affiliate',
          api_name: 'AffiliateBookkeepingApi',
          child_state: 'affiliate_bookkeeping.bookkeeping_month_report',
          permissions: permissionsStateAccess.init(['api2.affiliate.bookkeepingscontroller.show'])
        }
      })
      .state('affiliate_bookkeeping.bookkeeping_month_report', {
        url: '/month_report/:month_payment_date',
        templateUrl: 'app/components/bookkeeping/partials/bookkeeping_month_report.html',
        controller: 'BookkeepingMonthReportController',
        controllerAs: 'bookkeepingMonthReport',
        data: {
          readonly: true,
          namespace: 'affiliate',
          api_name: 'AffiliateBookkeepingApi',
          parent_state: 'affiliate_bookkeeping'
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateWithdrawalController', AffiliateWithdrawalController);

  AffiliateWithdrawalController.$inject = [
    '$state',
    '$stateParams',
    '$injector',
    'BalanceService',
    'outputErrors',
    'toastsApi',
    'tableEngine',
    '_'
  ];

  function AffiliateWithdrawalController(
    $state,
    $stateParams,
    $injector,
    BalanceService,
    outputErrors,
    toastsApi,
    tableEngine,
    _
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateBalance';
    vm.errors = outputErrors.createNew();
    vm.paymentSystems = [];
    vm.currentSystem = {};
    vm.countriesList = [];
    vm.stateData = $state.current.data;
    vm.table = tableEngine.getTableByName(vm.stateData.tableName);
    vm.balanceApi = $injector.get(vm.stateData.balanceApi);
    vm.withdrawalPermission = vm.stateData.withdrawalPermission;

    vm.getBalance = function() {
      return BalanceService.getBalance();
    };

    vm.getCurrency = function() {
      return BalanceService.getCurrency();
    };

    vm.handleError = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }

      if (errors.payment_system) {
        vm.errors.inputErrors(errors.payment_system);
      }

      if (errors.wrong_affiliate_balance) {
        return toastsApi.toastError({locale: errors.wrong_affiliate_balance[0]});
      } else {
        var specialError = errors.affiliate_cashout;

        if (specialError && specialError.amount) {
          return toastsApi.toastError({locale: specialError.amount[0]});
        }
      }

      return toastsApi.toastError({
        locale: _.first(_.flatten(_.values(_.isEmpty(errors.affiliate_cashout) ? errors : errors.affiliate_cashout)))
      });
    };

    vm.submitWithdrawal = function() {
      vm.paymentDetailsForm.$setSubmitted();

      if (vm.paymentDetailsForm.$invalid) {
        return;
      }

      var data = BalanceService.getPaymentData(vm.currentSystem);

      data = _.omit(_.extend(data, {payment_system_name: data.name}), 'name');

      return vm.balanceApi.withdrawalBalance(data, $stateParams.partnerId).then(
        function(response) {
          BalanceService.setAffiliateBalance(response.data.balance);
          vm.table && vm.table.pagination().then(vm.back, vm.back);
        },
        function(response) {
          vm.handleError(response.data.errors);
        }
      );
    };

    vm.back = function() {
      $state.go('^');
    };

    vm.balanceApi.getAvailablePaymentSystems($stateParams.partnerId).then(
      function(response) {
        vm.paymentSystems = response.data.payment_systems;
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.balanceApi.getCountries($stateParams.partnerId).then(
      function(response) {
        vm.countriesList = response.data.countries;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('affiliate_balance', {
        url: '/affiliate/balance',
        templateUrl: 'app/affiliate/balance/partials/balance.html',
        controller: 'AffiliateBalanceController',
        controllerAs: 'balanceCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.affiliate.cashoutscontroller.list'])
        }
      })
      .state('affiliate_balance.withdrawal', {
        url: '/withdrawal',
        templateUrl: 'app/affiliate/balance/partials/withdrawal.html',
        controller: 'AffiliateWithdrawalController',
        controllerAs: 'withdrawalCtrl',
        data: {
          balanceApi: 'AffiliateBalanceApi',
          namespace: 'affiliate',
          tableName: 'affiliate_balance',
          withdrawalPermission: 'api2.affiliate.cashoutscontroller.withdraw',
          permissions: permissionsStateAccess.init(['api2.affiliate.cashoutscontroller.withdraw'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        balance: [
          'header||affiliate_balance.header',
          'withdrawal_button||affiliate_balance.withdrawal_button',
          'download_report_button||affiliate_balance.download_report_button',
          'balance_in_site_header||affiliate_balance.balance_in_site_header',
          'total_all_brands||affiliate_balance.total_all_brands',
          'brand_earned||affiliate_balance.brand_earned',
          'recalculating||affiliate_balance.recalculating',
          {
            statuses: [
              'income||affiliate_balance.statuses.income',
              'pending||affiliate_balance.statuses.pending',
              'paid||affiliate_balance.statuses.paid',
              'canceled||affiliate_balance.statuses.canceled',
              'adjustment||affiliate_balance.statuses.adjustment'
            ]
          },
          {
            withdrawal: [
              'header||affiliate_balance.withdrawal.header',
              'back||affiliate_balance.withdrawal.back',
              {
                payment_details_form: [
                  'submit_button||affiliate_balance.withdrawal.submit_button',
                  'select_payment_system||affiliate_balance.withdrawal.select_payment_system',
                  'default_payment_system||affiliate_balance.withdrawal.default_payment_system',
                  {
                    approve_default_payment_system: [
                      'title||approve_default_payment_system.title',
                      'question||approve_default_payment_system.question',
                      'ok||approve_default_payment_system.ok',
                      'cancel||approve_default_payment_system.cancel'
                    ]
                  },
                  {
                    epayments: ['wallet||payment_details_form.epayments.wallet']
                  },
                  {
                    neteller: [
                      'username||payment_details_form.neteller.username',
                      'email||payment_details_form.neteller.email'
                    ]
                  },
                  {
                    paypal: [
                      'username||payment_details_form.paypal.username',
                      'email||payment_details_form.paypal.email'
                    ]
                  },
                  {
                    webmoney: [
                      'username||payment_details_form.webmoney.username',
                      'wallet||payment_details_form.webmoney.wallet'
                    ]
                  },
                  {
                    bank_transfer: [
                      'country_code||payment_details_form.bank_transfer.country_code',
                      'company_name||payment_details_form.bank_transfer.company_name',
                      'company_country||payment_details_form.bank_transfer.company_country',
                      'company_city||payment_details_form.bank_transfer.company_city',
                      'company_address||payment_details_form.bank_transfer.company_address',
                      'company_postal||payment_details_form.bank_transfer.company_postal',
                      'bank_name||payment_details_form.bank_transfer.bank_name',
                      'bank_country||payment_details_form.bank_transfer.bank_country',
                      'bank_address||payment_details_form.bank_transfer.bank_address',
                      'bank_city||payment_details_form.bank_transfer.bank_city',
                      'bank_postal||payment_details_form.bank_transfer.bank_postal',
                      'iban||payment_details_form.bank_transfer.iban',
                      'bic||payment_details_form.bank_transfer.bic',
                      'account_holders_name||payment_details_form.bank_transfer.account_holders_name',
                      'branch_code||payment_details_form.bank_transfer.branch_code',
                      'routing_number||payment_details_form.bank_transfer.routing_number',
                      'bank_transit_code||payment_details_form.bank_transfer.bank_transit_code',
                      'institution_number||payment_details_form.bank_transfer.institution_number',
                      'bank_account_number||payment_details_form.bank_transfer.bank_account_number'
                    ]
                  },
                  {
                    bank_card: [
                      'username||payment_details_form.bank_card.username',
                      'card_number||payment_details_form.bank_card.card_number',
                      'bank_name||payment_details_form.bank_card.bank_name',
                      'country||payment_details_form.bank_card.country',
                      'city||payment_details_form.bank_card.city',
                      'address||payment_details_form.bank_card.address',
                      'iban||payment_details_form.bank_card.iban',
                      'bic||payment_details_form.bank_card.bic',
                      'swift||payment_details_form.bank_card.swift'
                    ]
                  },
                  {
                    yandex_money: ['wallet||payment_details_form.yandex_money.wallet']
                  },
                  {
                    qiwi: ['phone_number||payment_details_form.qiwi.phone_number']
                  },
                  {
                    capitalist: ['wallet||payment_details_form.capitalist.wallet']
                  },
                  {
                    usdt_erc20: ['wallet||payment_details_form.usdt_erc20.wallet']
                  },
                  {
                    usdt_trc20: ['wallet||payment_details_form.usdt_trc20.wallet']
                  },
                  {
                    skrill: [
                      'username||payment_details_form.skrill.username',
                      'email||payment_details_form.skrill.email'
                    ]
                  },
                  {
                    player_account: ['poker_nickname||payment_details_form.player_account.poker_nickname']
                  },
                  {
                    bitcoin: ['wallet||payment_details_form.bitcoin.wallet']
                  }
                ]
              }
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateBalance', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateBalanceController', AffiliateBalanceController);

  AffiliateBalanceController.$inject = [
    '$scope',
    '$state',
    'AffiliateBalanceApi',
    'tableEngine',
    'toastsApi',
    'downloadReport',
    'defaultDateFormat'
  ];

  function AffiliateBalanceController(
    $scope,
    $state,
    AffiliateBalanceApi,
    tableEngine,
    toastsApi,
    downloadReport,
    defaultDateFormat
  ) {
    var vm = this;

    vm.translate_key = 'AffiliateBalance';
    vm.downloadFormats = [];

    vm.balanceWithdrawal = function() {
      $state.go('.withdrawal');
    };

    vm.tableFiliterColumns = [
      {
        name: 'merchant_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'created_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'comment',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'amount',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'state',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_details',
        type: 'checkbox',
        display: true,
        empty: true
      }
    ];

    vm.applyDownloadReport = function(data) {
      return AffiliateBalanceApi.downloadReport(data, vm.table.getSegmentId());
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.table = tableEngine.init({
      api: AffiliateBalanceApi,
      name: 'affiliate_balance',
      mobile: {
        defaultColumns: ['amount']
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/affiliate/cashouts',
        actionForFilter: 'list',
        byMerchant: true,
        filterName: 'affiliate_cashout'
      }
    });

    AffiliateBalanceApi.getWithdrawalHistory().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            table_id: data.report_id,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('amount', {separateNumber: true});
        vm.table.addOptionsToColumn('created_at', {format: defaultDateFormat + ' HH:mm:ss'});
        vm.table.addOptionsToColumn('state', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: 'affiliate_balance.statuses.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });
        vm.downloadFormats = data.separators_for_format;
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.resetFilter();
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('affiliate_articles', {
        url: '/affiliate/articles',
        templateUrl: 'app/components/articles/partials/list.html',
        controller: 'ArticlesListController',
        controllerAs: 'ArticlesCtrl',
        data: {
          namespace: 'affiliate',
          translate_key: 'AffiliateArticles',
          list_state: 'affiliate_articles',
          view_state: 'affiliate_articles.view',
          buttons: {
            view: true
          },
          permissions: permissionsStateAccess.init(['api2.affiliate.articlescontroller.show'])
        }
      })
      .state('affiliate_articles.view', {
        url: '/view/:articleId',
        templateUrl: 'app/components/articles/partials/view.html',
        controller: 'ArticlesViewController',
        controllerAs: 'ViewCtrl',
        data: {
          namespace: 'affiliate',
          list_state: 'affiliate_articles',
          translate_key: 'AffiliateArticles'
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        articles: [
          'header||articles.header',
          {
            view: ['last_update||articles_view.last_update', 'back||articles_view.back']
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateArticles', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('affiliate_reference', {
        url: '/affiliate_reference',
        templateUrl: 'app/affiliate/affiliate_reference/partials/affiliate_reference.html',
        controller: 'AffiliateReferenceController',
        controllerAs: 'ref',
        data: {
          permissions: permissionsStateAccess.init(['api2.affiliate.settingscontroller.referrals_token'])
        }
      })
      .state('affiliate_reference.subaffiliate_condition', {
        url: '/subaffiliate_condition',
        templateUrl: 'app/affiliate/affiliate_reference/partials/condition.html',
        controller: 'AffiliateSubConditionController',
        controllerAs: '$ctrl',
        data: {
          // permissions: permissionsStateAccess.init(['api2.affiliate.settingscontroller.referrals_token'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        registration_reference: [
          'header||registration_reference.header',
          'copy||registration_reference.copy',
          'link||registration_reference.link',
          'show_condition_btn||registration_reference.show_condition_btn',
          {
            condition: [
              'header||condition.header',
              'back||condition.back',
              {
                form: ['title||condition.form.title', 'description||condition.form.description']
              },
              {
                step: ['step||condition.step.step']
              }
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateReference', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateSubConditionController', AffiliateSubConditionController);

  AffiliateSubConditionController.$inject = ['$state', 'AffiliateReferenceApi', 'outputErrors', 'toastsApi'];

  function AffiliateSubConditionController($state, AffiliateReferenceApi, outputErrors, toastsApi) {
    var vm = this;

    vm.translate_key = 'AffiliateReference';
    vm.errors = outputErrors.createNew();
    vm.condition_mark = '%';

    vm.markFor = function(step) {
      return step && step.payment_column === 'cpa_flat' ? '$' : vm.condition_mark;
    };

    vm.labelFor = function(step) {
      if (!step || !step.payment_column) {
        return '';
      }

      var columns = vm.payment_columns || {};
      var keys = Object.keys(columns);
      for (var i = 0; i < keys.length; i++) {
        if (columns[keys[i]] === step.payment_column) {
          return keys[i];
        }
      }

      return step.payment_column;
    };

    vm.back = function() {
      $state.go('affiliate_reference');
    };

    AffiliateReferenceApi.get_subaffiliate_condition().then(
      function(response) {
        vm.condition = response.data.subaffiliate_condition;
        vm.payment_columns = response.data.constants.subaffiliate_condition_steps.payment_column;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateReferenceController', AffiliateReferenceController);

  AffiliateReferenceController.$inject = [
    '$state',
    'AffiliateReferenceApi',
    '$location',
    '$interpolate',
    'outputErrors',
    'toastsApi'
  ];

  function AffiliateReferenceController(
    $state,
    AffiliateReferenceApi,
    $location,
    $interpolate,
    outputErrors,
    toastsApi
  ) {
    var vm = this,
      link = '{{protocol}}://{{domain}}/#/affiliate_ref/{{token}}',
      params = {
        protocol: $location.protocol(),
        domain: $location.host(),
        token: ''
      };

    vm.translate_key = 'AffiliateReference';
    vm.errors = outputErrors.createNew();

    vm.showCondition = function() {
      $state.go('affiliate_reference.subaffiliate_condition');
    };

    vm.copySuccess = function() {
      toastsApi.toastCopySuccess();
    };

    AffiliateReferenceApi.get_token().then(
      function(response) {
        params.token = response.data.token;
        vm.link = $interpolate(link)(params);
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('affiliate_api', {
      url: '/affiliate_api',
      templateUrl: 'app/affiliate/affiliate_api/partials/affiliate_api.html',
      controller: 'AffiliateApiController',
      controllerAs: 'affiliateApi',
      data: {
        permissions: permissionsStateAccess.init(['api2.affiliate.settingscontroller.api_stats'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      affiliate: {
        affiliate_api: [
          'header||affiliate_api.header',
          'copy||affiliate_api.copy',
          'link||affiliate_api.link',
          'reset_api_token_button||quints_api.reset_api_token_button',
          {
            confirm_reset_api_token_modal: [
              'title||confirm_reset_api_token_modal.title',
              'question||confirm_reset_api_token_modal.question',
              'answer_yes||confirm_reset_api_token_modal.answer_yes',
              'answer_no||confirm_reset_api_token_modal.answer_no'
            ]
          }
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AffiliateApi', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AffiliateApiController', AffiliateApiController);

  AffiliateApiController.$inject = ['AffiliateTokenApi', 'outputErrors', 'toastsApi', '$mdDialog', '$mdTranslate', '_'];

  function AffiliateApiController(AffiliateTokenApi, outputErrors, toastsApi, $mdDialog, $mdTranslate, _) {
    var vm = this;

    vm.translate_key = 'AffiliateApi';
    vm.errors = outputErrors.createNew();
    vm.apiUri = '';

    vm.copySuccess = function() {
      toastsApi.toastCopySuccess();
    };

    vm.getToken = function() {
      AffiliateTokenApi.getToken().then(
        function(response) {
          vm.apiUri = response.data.domain;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getResetTokenTranslation = function() {
      return {
        title: $mdTranslate.instant(vm.translate_key, 'confirm_reset_api_token_modal.title'),
        question: $mdTranslate.instant(vm.translate_key, 'confirm_reset_api_token_modal.question'),
        ok: $mdTranslate.instant(vm.translate_key, 'confirm_reset_api_token_modal.answer_yes'),
        cancel: $mdTranslate.instant(vm.translate_key, 'confirm_reset_api_token_modal.answer_no')
      };
    };

    vm.confirmResetingTokenModal = function(data, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(data.title)
        .textContent(data.question)
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok(data.ok)
        .cancel(data.cancel);

      return $mdDialog.show(confirm);
    };

    vm.applyResetToken = function() {
      AffiliateTokenApi.resetApiToken().then(
        function() {
          vm.getToken();
          toastsApi.toastSuccess();
        },
        function(response) {
          var errors = response.data && response.data.errors;

          if (_.isEmpty(errors)) {
            return toastsApi.toastError();
          }

          toastsApi.toastError({locale: _.first(errors)});
        }
      );
    };

    vm.resetApiToken = function(ev) {
      var locales = vm.getResetTokenTranslation();

      vm.confirmResetingTokenModal(locales, ev).then(function() {
        vm.applyResetToken();
      });
    };

    vm.getToken();
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminWithdrawalsHistoryController', AdminWithdrawalsHistoryController);

  AdminWithdrawalsHistoryController.$inject = [
    '$scope',
    '$state',
    'tableEngine',
    'AdminWithdrawalsHistoryApi',
    '_',
    'toastsApi',
    'defaultDateFormat',
    'downloadReport'
  ];

  function AdminWithdrawalsHistoryController(
    $scope,
    $state,
    tableEngine,
    AdminWithdrawalsHistoryApi,
    _,
    toastsApi,
    defaultDateFormat,
    downloadReport
  ) {
    var vm = this;

    vm.translate_key = 'AdminWithdrawalsHistory';
    vm.downloadFormats = [];
    vm.downloadSeparators = {};
    $scope.stateShortcodePart = 'withdrawals_history.state.';

    vm.viewWithdrawal = function(withdrawal) {
      $state.go('.view_withdrawal', {withdrawalId: withdrawal.id});
    };

    vm.applyDownloadReport = function(data) {
      return AdminWithdrawalsHistoryApi.downloadReport(data, vm.table.getSegmentId());
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.tableFiliterColumns = [
      {
        name: 'merchant_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'created_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'updated_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'creator_id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'creator_type',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_email',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_username',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'amount',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'state',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'admin_email',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_details',
        type: 'checkbox',
        display: true,
        empty: true
      }
    ];

    vm.table = tableEngine.init({
      api: AdminWithdrawalsHistoryApi,
      api_method: 'historyPagination',
      name: 'withdrawals_history',
      mobile: {
        defaultColumns: ['affiliate_id']
      },
      buttons: {
        url: 'app/admin/withdrawals_history/partials/table.html',
        methods: {
          viewWithdrawal: vm.viewWithdrawal
        }
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/admin/affiliate_cashouts/approved_and_declined_history',
        actionForFilter: 'list',
        byMerchant: true,
        filterName: 'approved_and_declined_history'
      }
    });

    AdminWithdrawalsHistoryApi.getWithdrawalsHistory().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            table_id: data.report_id,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('amount', {separateNumber: true});
        vm.table.addOptionsToColumn('created_at', {format: defaultDateFormat + ' HH:mm:ss'});
        vm.table.addOptionsToColumn('updated_at', {format: defaultDateFormat + ' HH:mm:ss'});
        vm.table.addOptionsToColumn('state', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: $scope.stateShortcodePart + '{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });

        vm.downloadFormats = data.separators_for_format;
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.resetFilter();
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminWithdrawalsHistoryViewController', AdminWithdrawalsHistoryViewController);

  AdminWithdrawalsHistoryViewController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'AdminWithdrawalsHistoryApi',
    'BalanceService',
    '_',
    'toastsApi'
  ];

  function AdminWithdrawalsHistoryViewController(
    $scope,
    $state,
    $stateParams,
    AdminWithdrawalsHistoryApi,
    BalanceService,
    _,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminWithdrawalsHistory';
    vm.withdrawal = {created_at: null};
    vm.paymentSystems = BalanceService.getPaymentSystems();
    vm.allFields = BalanceService.getAllFields();
    vm.stateShortcodePart = $scope.stateShortcodePart;

    vm.back = function() {
      $state.go('^');
    };

    vm.findFieldShortcode = function(fieldName) {
      var system = _.find(vm.paymentSystems, {type: vm.withdrawal.payment_system_name});

      return BalanceService.findFieldShortcode(system, fieldName);
    };

    AdminWithdrawalsHistoryApi.viewWithdrawal($stateParams.withdrawalId).then(
      function(response) {
        vm.withdrawal = response.data[0];
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('admin_withdrawals_history', {
        url: '/withdrawals_history',
        templateUrl: 'app/admin/withdrawals_history/partials/withdrawals_history.html',
        controller: 'AdminWithdrawalsHistoryController',
        controllerAs: 'withdrawalsCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.affiliatecashoutscontroller.withdrawals_history_show'])
        }
      })
      .state('admin_withdrawals_history.view_withdrawal', {
        url: '/view/:withdrawalId',
        templateUrl: 'app/admin/withdrawals_history/partials/view_withdrawal.html',
        controller: 'AdminWithdrawalsHistoryViewController',
        controllerAs: 'viewCtrl'
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          withdrawals_history: [
            'header||withdrawals_history.header',
            'download_report_button||withdrawals_history.download_report_button',
            {
              state: ['paid||withdrawals_history.state.paid', 'canceled||withdrawals_history.state.canceled']
            },
            {
              view_withdrawal: [
                'header||view_withdrawal.header',
                'back||view_withdrawal.back',
                {
                  form: [
                    'merchant_name||view_withdrawal.form.merchant_name',
                    'affiliate_email||view_withdrawal.form.affiliate_email',
                    'affiliate_id||view_withdrawal.form.affiliate_id',
                    'affiliate_username||view_withdrawal.form.affiliate_username',
                    'amount||view_withdrawal.form.amount',
                    'payment_method_type||view_withdrawal.form.payment_method_type',
                    'created_at||view_withdrawal.form.created_at',
                    'admin_email||view_withdrawal.form.admin_email',
                    'state||view_withdrawal.form.state',
                    'payment_system_name||view_withdrawal.form.payment_system_name',
                    'creator_type||view_withdrawal.form.creator_type',
                    'creator_id||view_withdrawal.form.creator_id',
                    'creator_email||view_withdrawal.form.creator_email'
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminWithdrawalsHistory', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('admin_webhooks_history', {
        url: '/admin/webhooks_history',
        templateUrl: 'app/affiliate/webhooks_history/partials/webhooks_history.html',
        controller: 'AffiliateWebhooksHistoryController',
        controllerAs: 'webhooksHistoryCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.requestscontroller.all']),
          namespace: 'admin',
          downloadReportPermission: 'api2.admin.requestscontroller.all',
          translateKey: 'AdminWebhooksHistory',
          tableFiliterColumns: [
            {
              name: 'merchant_name',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'affiliate_id',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'webhook_id',
              type: 'compare',
              display: true,
              empty: true
            },
            {
              name: 'serial_id',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'kind',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'uri',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'params',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'updated_at',
              type: 'date',
              display: true,
              empty: true
            },
            {
              name: 'response_code',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'email',
              type: 'checkbox',
              display: true,
              empty: true
            },
            {
              name: 'username',
              type: 'checkbox',
              display: true,
              empty: true
            }
          ]
        }
      })
      .state('admin_webhooks_history.details', {
        url: '/details/:id',
        templateUrl: 'app/affiliate/webhooks_history/partials/webhooks_history_details.html',
        controller: 'AffiliateWebhooksHistoryDetailsController',
        controllerAs: 'historyDetailsCtrl',
        data: {
          namespace: 'admin',
          translateKey: 'AdminWebhooksHistory'
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          webhooks_history: [
            'header||webhooks_history.header',
            'download_report_btn||webhooks_history.download_report',
            {
              history_details: ['header||webhooks_history_details.header', 'back||webhooks_history_details.back']
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminWebhooksHistory', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminTranslateManagerController', AdminTranslateManagerController);

  AdminTranslateManagerController.$inject = [
    '$scope',
    '$translate',
    '_',
    'translateManager',
    'localesStorage',
    'outputErrors',
    '$rootScope',
    '$window',
    '$cookies',
    'envService',
    '$interpolate',
    'toastsApi',
    'uploadFile',
    '$mdTranslate'
  ];

  function AdminTranslateManagerController(
    $scope,
    $translate,
    _,
    translateManager,
    localesStorage,
    outputErrors,
    $rootScope,
    $window,
    $cookies,
    envService,
    $interpolate,
    toastsApi,
    uploadFile,
    $mdTranslate
  ) {
    var vm = this,
      async_load;

    vm.translate_key = 'AdminTranslateManager';
    vm.dataToSave = {};
    vm.language = localesStorage.getCurrentLocale();
    vm.language_list = localesStorage.getLanguages();
    vm.frontend_locales_backup = translateManager.get_frontend_list();
    vm.backend_locales_backup = [];
    vm.errors = outputErrors.createNew();
    vm.only_empty = false;
    vm.search_term = '';
    vm.exportFileUri = '{{host}}admin/translate_manager/export/?authenticity_token={{token}}&language={{language}}';
    vm.exportFileParams = {host: envService.read('apiUrl')};
    vm.fallbackLanguage = localesStorage.getFallbackLocale();

    vm.changeFallbackLanguage = function(language) {
      $translate.fallbackLanguage(language || 'we_WE');
    };

    vm.getTranslateDefault = function(shortcode, translateKey) {
      return $mdTranslate.instant(translateKey || vm.translate_key, shortcode, null, vm.fallbackLanguage);
    };

    vm.recalculate = function() {
      vm.frontend_locales_string = translateManager.get_frontend_list_string();
      vm.backend_locales_string = _.flatten(translateManager.string_list(vm.backend_locales_backup));

      vm.frontend_filtered_locales = _.reduce(
        _.filter(vm.frontend_locales_string, function(link) {
          var t = $translate.instant(link, null, null, vm.language),
            ifNoEmpty = t !== link && vm.search_term ? ~t.toLowerCase().indexOf(vm.search_term.toLowerCase()) : false;

          return vm.only_empty ? t === '' || t === link : ifNoEmpty;
        }),
        function(memo, v) {
          return angular.merge(translateManager.string_to_hash_backward(v, ''), memo);
        },
        {}
      );

      vm.backend_filtered_locales = _.reduce(
        _.filter(vm.backend_locales_string, function(link) {
          var t = $translate.instant(link, null, null, vm.language),
            ifNoEmpty = t !== link && vm.search_term ? ~t.toLowerCase().indexOf(vm.search_term.toLowerCase()) : false;

          return vm.only_empty ? t === '' || t === link : ifNoEmpty;
        }),
        function(memo, v) {
          return angular.merge(translateManager.string_to_hash_backward(v, ''), memo);
        },
        {}
      );
    };

    vm.change_list = function() {
      vm.frontend_list = vm.only_empty || vm.search_term ? vm.frontend_filtered_locales : vm.frontend_locales_backup;
      vm.backend_list = vm.only_empty || vm.search_term ? vm.backend_filtered_locales : vm.backend_locales_backup;
    };

    vm.init = function() {
      $translate.instant('', null, null, vm.language);
      vm.changeFallbackLanguage();
      vm.recalculate();
      vm.change_list();
    };

    vm.clear_search = function() {
      vm.search_term = '';
      vm.init();
    };

    vm.save = function(data) {
      return translateManager.save(data.language, data.key, data.value);
    };

    vm.exportFile = function() {
      vm.exportFileParams.token = encodeURIComponent($cookies.get('XSRF-TOKEN-X'));
      vm.exportFileParams.language = vm.language;

      var uri = $interpolate(vm.exportFileUri)(vm.exportFileParams);

      $window.open(uri, '_self');
    };

    vm.importFile = function(value, ev) {
      uploadFile
        .openDialog({
          targetEvent: ev,
          locals: {
            // file_formats: [{format: '.yml', type: 'application/x-yaml'}],
            format_for_locale: 'yml',
            upload_params: {
              url: 'admin/translate_manager/import',
              method: 'POST',
              formData: [{force_load: value}, {language: vm.language}]
            }
          }
        })
        .then(function() {
          $translate.refresh(vm.language).then(function() {
            toastsApi.toastSuccess();
          });
        });
    };

    translateManager.get_backend_list().then(function(data) {
      vm.backend_locales_backup = data;
      vm.init();
    });

    async_load = $rootScope.$on('$translateLoadingEnd', function() {
      $translate.onReady().then(function() {
        vm.init();
      });
    });

    $scope.$on('$destroy', function() {
      async_load();
    });

    $scope.$on('$stateChangeSuccess', function(ev, toState) {
      if (toState.name !== 'translate_manager') {
        vm.changeFallbackLanguage(vm.fallbackLanguage);
      }
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('translateList', translateList);

  translateList.$inject = ['$translate', 'localesStorage', '_'];

  function translateList($translate, localesStorage, _) {
    return {
      restrict: 'EA',
      scope: {
        list: '=',
        toSave: '=',
        language: '=',
        saveFunc: '&'
      },
      template:
        '<ol>' +
        '<li item-template ng-repeat="(key, value) in list | filterByObjectProperties" namespace="{{::key}}" key="{{::key}}" value="value" language="language"></li>' +
        '</ol>',
      controllerAs: 'tmCtrl',
      controller: function($scope) {
        var vm = this;

        vm.options = {
          to_save: $scope.toSave,
          invoke_translate: function(
            translationId,
            interpolateParams,
            interpolationId,
            defaultTranslationText,
            forceLanguage
          ) {
            return $translate.call(
              null,
              translationId,
              interpolateParams,
              interpolationId,
              defaultTranslationText,
              forceLanguage
            );
          },
          translate_default: function(namespace) {
            return _.first(
              _.reject(
                [
                  $translate.instant(namespace, null, null, $scope.language),
                  $translate.instant(namespace, null, null, localesStorage.getFallbackLocale()),
                  '<!-- translate is missing -->'
                ],
                function(e) {
                  return namespace === e;
                }
              )
            );
          },
          update_value: function(namespace, value) {
            var link = $scope.language + namespace;
            if (value) {
              if (!$scope.toSave[link]) {
                $scope.toSave[link] = value;
              }
            } else {
              delete $scope.toSave[link];
            }
          },
          clear: function(namespace) {
            vm.options.update_value(namespace);
          },
          set_value: function(namespace) {
            vm.options.invoke_translate(namespace, null, null, null, $scope.language).then(function(translations) {
              vm.options.update_value(namespace, translations);
            });
          },
          reset_value: function(namespace) {
            var link = $scope.language + namespace;
            if ($scope.toSave[link] === $translate.instant(namespace, null, null, $scope.language)) {
              delete $scope.toSave[link];
            }
          },
          save: function(namespace) {
            var data = {
              language: $scope.language,
              key: namespace,
              value: $scope.toSave[$scope.language + namespace]
            };

            $scope.saveFunc({data: data}).then(function() {
              $translate.refresh($scope.language).then(function() {
                vm.options.update_value(namespace);
              });
            });
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('translate_manager', {
      name: 'translate_manager',
      url: '/admin/translate_manager',
      templateUrl: 'app/admin/translate_manager/partials/translate_manager.html',
      controller: 'AdminTranslateManagerController',
      controllerAs: 'translate_manager',
      data: {
        permissions: permissionsStateAccess.init(['api2.admin.translatemanagercontroller.edit'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        settings: {
          translate_manager: [
            'title||translate_manager.title',
            'language||translate_manager.language',
            'front_end||translate_manager.front_end',
            'back_end||translate_manager.back_end',
            'search_locales||translate_manager.search_locales',
            'empty_locales||translate_manager.empty_locales',
            'export_file_button||translate_manager.export_file_button',
            'import_file_button||translate_manager.import_file_button',
            'force_write||translate_manager.force_write',
            'write_only_empty||translate_manager.write_only_empty'
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminTranslateManager', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('itemTemplate', itemTemplate);

  itemTemplate.$inject = [];

  function itemTemplate() {
    return {
      restrict: 'A',
      require: '?^translateList',
      scope: {
        list: '=value',
        translateLanguage: '=language',
        key: '@',
        namespace: '@'
      },
      template:
        '<div class="tree-node tree-node-content angular-tree-handle" layout-xs="row" layout-align-xs="start center" ng-class="::{notfolder: list === \'\'}">' +
        '<a class="btn btn-success btn-xs" ng-click="toggle()" ng-if="list !== \'\'">' +
        '<i class="fa fa-folder"></i>' +
        '</a>' +
        '<label class="label" ng-bind="::key" flex-xs="nogrow"></label>' +
        '<span class="input-box" flex-xs="grow" ng-if="list === \'\'">' +
        '<input type="text" translate ' +
        'ng-model="options.to_save[translateLanguage + namespace]" ' +
        'translate-attr-placeholder="{{namespace}}" ' +
        'translate-default="{{options.translate_default(namespace)}}" ' +
        'ng-focus="options.set_value(namespace)" ' +
        'ng-blur="options.reset_value(namespace)" ' +
        'ng-class="{\'pd-right\': !list && options.to_save[translateLanguage + namespace]}"' +
        '>' +
        '<span class="btn-box" ng-if="!list && options.to_save[translateLanguage + namespace]">' +
        '<a class="btn btn-primary btn-xs" ng-click="options.save(namespace)">' +
        '<i class="fa fa-check"></i>' +
        '</a>' +
        '<a class="btn btn-danger btn-xs" ng-click="options.clear(namespace)">' +
        '<i class="fa fa-ban"></i>' +
        '</a>' +
        '</span>' +
        '</span>' +
        '</div>' +
        '<ol ng-if="!collapsed">' +
        '<li item-template ng-repeat="(key, value) in list | filterByObjectProperties" value="value" language="translateLanguage" namespace="{{::(namespace + \'.\' + key)}}" key="{{::key}}"></li>' +
        '</ol>',
      link: function(scope, element, attr, tmCtrl) {
        scope.collapsed = true;
        scope.options = tmCtrl.options;

        scope.toggle = function() {
          var icon = angular.element(element[0].querySelector('.btn-success .fa')),
            isClosed = icon.hasClass('fa-folder');

          icon.removeClass(isClosed ? 'fa-folder' : 'fa-folder-open');
          icon.addClass(isClosed ? 'fa-folder-open' : 'fa-folder');

          scope.collapsed = !scope.collapsed;
        };
      }
    };
  }
})();

(function() {
  'use strict';

  // angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
  //   $stateProvider.state('mirrors_notifications', {
  //     url: '/mirrors_notifications',
  //     templateUrl: 'app/admin/tracking_mirrors_notifications/partials/mirrors_notifications.html',
  //     controller: 'AdminMirrorsNotificationsController',
  //     controllerAs: 'mirrorsCtrl',
  //     data: {
  //       permissions: permissionsStateAccess.init(['api2.admin.projectsettingscontroller.redirector_notifications'])
  //     }
  //   });
  // });

})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminMirrorsNotificationsController', AdminMirrorsNotificationsController);

  AdminMirrorsNotificationsController.$inject = ['AdminTrackingMirrorsApi', '_', 'outputErrors', 'toastsApi'];

  function AdminMirrorsNotificationsController(AdminTrackingMirrorsApi, _, outputErrors, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminMirrorsNotifications';
    vm.errors = outputErrors.createNew();
    vm.notify = {
      errors_per_hour_limit: '',
      errors_per_day_limit: '',
      receive_email_restriction: '',
      email: ''
    };

    vm.save = function() {
      AdminTrackingMirrorsApi.saveNotification(vm.notify).then(
        function() {
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    AdminTrackingMirrorsApi.getNotification().then(
      function(response) {
        var data = response.data.redirector_notifications;

        if (!data) {
          return;
        }

        vm.notify.errors_per_hour_limit = data.errors_per_hour_limit;
        vm.notify.errors_per_day_limit = data.errors_per_day_limit;
        vm.notify.receive_email_restriction = data.receive_email_restriction;
        vm.notify.email = data.email;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  // angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  // function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
  //   var list = {
  //     admin: {
  //       mirrors: {
  //         mirrors_notifications: [
  //           'header||mirrors_notifications.header',
  //           'save||mirrors_notifications.save',
  //           {
  //             form: [
  //               'errors_per_hour_limit||form.errors_per_hour_limit',
  //               'errors_per_day_limit||form.errors_per_day_limit',
  //               'receive_email_restriction||form.receive_email_restriction',
  //               'email||form.email'
  //             ]
  //           }
  //         ]
  //       }
  //     }
  //   };

  //   translateManagerProvider.add_locals_list(list);
  //   localesApiProvider.set_locales('AdminMirrorsNotifications', list);
  // }

})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminTrackingMirrorsController', AdminTrackingMirrorsController);

  AdminTrackingMirrorsController.$inject = [
    '$scope',
    '$state',
    'tableEngine',
    'AdminTrackingMirrorsApi',
    '_',
    '$mdDialog',
    'outputErrors',
    '$mdTranslate',
    'toastsApi'
  ];

  function AdminTrackingMirrorsController(
    $scope,
    $state,
    tableEngine,
    AdminTrackingMirrorsApi,
    _,
    $mdDialog,
    outputErrors,
    $mdTranslate,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = $state.current.data.translate_key;
    vm.mirrorsType = $state.current.data.type;
    vm.errors = outputErrors.createNew();

    vm.removeMirror = function(tracker, ev) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'modal_remove.remove_title'))
        .textContent($mdTranslate.instant(vm.translate_key, 'modal_remove.remove_message'))
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, 'modal_remove.ok'))
        .cancel($mdTranslate.instant(vm.translate_key, 'modal_remove.cancel'));

      $mdDialog.show(confirm).then(function() {
        AdminTrackingMirrorsApi.destroy(tracker.id).then(
          function() {
            vm.table.removeListItem();
            toastsApi.toastRemoveSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.editMirror = function(item) {
      $state.go('.edit_tracking', {mirrorId: item.id});
    };

    vm.add = function() {
      $state.go('.add_tracking.manual');
    };

    vm.table = tableEngine.init({
      api: AdminTrackingMirrorsApi,
      name: 'mirrors_' + vm.mirrorsType,
      mobile: {
        defaultColumns: ['domain']
      },
      buttons: {
        url: 'app/admin/tracking_mirrors/partials/table.html',
        methods: {
          removeMirror: vm.removeMirror,
          editMirror: vm.editMirror
        }
      },
      params: {
        data: {
          additional_options: {
            type: vm.mirrorsType
          }
        }
      }
    });

    AdminTrackingMirrorsApi.getMirrors(vm.mirrorsType).then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            table_id: data.report_id,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('enabled', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            truth: 'tracking.status_enabled',
            lie: 'tracking.status_disabled'
          }
        });
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('mirrors_list_js', {
        url: '/mirrors_list_js',
        templateUrl: 'app/admin/tracking_mirrors/partials/tracking_mirrors.html',
        controller: 'AdminTrackingMirrorsController',
        controllerAs: 'trackersCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.mirrorscontroller.show']),
          type: 'common',
          translate_key: 'AdminTrackersMirrorsListJs'
        }
      })
      .state('mirrors_list_js.add_tracking', {
        url: '/add',
        templateUrl: 'app/admin/tracking_mirrors/partials/add_tracking.html',
        controller: 'AddTrackingMirrorsController',
        controllerAs: 'addCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.mirrorscontroller.create']),
          type: 'common',
          translate_key: 'AdminTrackersMirrorsListJs',
          parentState: 'mirrors_list_js'
        }
      })
      .state('mirrors_list_js.add_tracking.manual', {
        url: '/manually',
        views: {
          'content@mirrors_list_js.add_tracking': {
            templateUrl: 'app/admin/tracking_mirrors/partials/create_manual.html'
          },
          'buttons@mirrors_list_js.add_tracking': {
            templateUrl: 'app/admin/tracking_mirrors/partials/buttons.html'
          }
        }
      })
      .state('mirrors_list_js.add_tracking.from_file', {
        url: '/file',
        views: {
          'content@mirrors_list_js.add_tracking': {
            templateUrl: 'app/admin/tracking_mirrors/partials/create_with_file.html'
          },
          'buttons@mirrors_list_js.add_tracking': {
            templateUrl: 'app/admin/tracking_mirrors/partials/buttons.html'
          }
        }
      })
      .state('mirrors_list_js.edit_tracking', {
        url: '/edit/:mirrorId',
        templateUrl: 'app/admin/tracking_mirrors/partials/edit_tracking.html',
        controller: 'EditTrackingMirrorsController',
        controllerAs: 'editCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.mirrorscontroller.edit']),
          type: 'common',
          translate_key: 'AdminTrackersMirrorsListJs'
        }
      })
      .state('mirrors_list_no_js', {
        url: '/mirrors_list_no_js',
        templateUrl: 'app/admin/tracking_mirrors/partials/tracking_mirrors.html',
        controller: 'AdminTrackingMirrorsController',
        controllerAs: 'trackersCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.mirrorscontroller.show']),
          type: 'nojs',
          translate_key: 'AdminTrackersMirrorsListNoJs'
        }
      })
      .state('mirrors_list_no_js.add_tracking', {
        url: '/add',
        templateUrl: 'app/admin/tracking_mirrors/partials/add_tracking.html',
        controller: 'AddTrackingMirrorsController',
        controllerAs: 'addCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.mirrorscontroller.create']),
          type: 'nojs',
          translate_key: 'AdminTrackersMirrorsListNoJs',
          parentState: 'mirrors_list_no_js'
        }
      })
      .state('mirrors_list_no_js.add_tracking.manual', {
        url: '/manually',
        views: {
          'content@mirrors_list_no_js.add_tracking': {
            templateUrl: 'app/admin/tracking_mirrors/partials/create_manual.html'
          },
          'buttons@mirrors_list_no_js.add_tracking': {
            templateUrl: 'app/admin/tracking_mirrors/partials/buttons.html'
          }
        }
      })
      .state('mirrors_list_no_js.add_tracking.from_file', {
        url: '/file',
        views: {
          'content@mirrors_list_no_js.add_tracking': {
            templateUrl: 'app/admin/tracking_mirrors/partials/create_with_file.html'
          },
          'buttons@mirrors_list_no_js.add_tracking': {
            templateUrl: 'app/admin/tracking_mirrors/partials/buttons.html'
          }
        }
      })
      .state('mirrors_list_no_js.edit_tracking', {
        url: '/edit/:mirrorId',
        templateUrl: 'app/admin/tracking_mirrors/partials/edit_tracking.html',
        controller: 'EditTrackingMirrorsController',
        controllerAs: 'editCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.mirrorscontroller.edit']),
          type: 'nojs',
          translate_key: 'AdminTrackersMirrorsListNoJs'
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var listJs = {
        admin: {
          mirrors: {
            mirrors_list_js: [
              'header||tracking.header',
              'button_add||tracking.button_add_tracking',
              'status_enabled||tracking.status_enabled',
              'status_disabled||tracking.status_disabled',
              {
                modal_window: [
                  'remove_message||modal_remove.remove_message',
                  'remove_title||modal_remove.remove_title',
                  'ok||modal_remove.ok',
                  'cancel||modal_remove.cancel'
                ]
              },
              {
                add_tracking: [
                  'header||add_tracking.header',
                  'save||add_tracking.save',
                  'back||add_tracking.back',
                  {
                    tabs: [
                      {
                        manual: [
                          'tab_name||manual.tab_name',
                          {
                            form: ['link||form.link', 'priority||form.priority', 'enabled||form.enabled']
                          }
                        ],
                        from_file: [
                          'tab_name||from_file.tab_name',
                          'header||from_file.header',
                          'description||from_file.description',
                          'errors_in_file||from_file.errors_in_file'
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                edit_tracking: [
                  'header||edit_tracking.header',
                  'save||edit_tracking.save',
                  'back||edit_tracking.back',
                  {
                    form: ['link||edit_form.link', 'priority||edit_form.priority', 'enabled||edit_form.enabled']
                  }
                ]
              }
            ]
          }
        }
      },
      listNoJs = {
        admin: {
          mirrors: {
            mirrors_list_no_js: [
              'header||tracking.header',
              'button_add||tracking.button_add_tracking',
              'status_enabled||tracking.status_enabled',
              'status_disabled||tracking.status_disabled',
              {
                modal_window: [
                  'remove_message||modal_remove.remove_message',
                  'remove_title||modal_remove.remove_title',
                  'ok||modal_remove.ok',
                  'cancel||modal_remove.cancel'
                ]
              },
              {
                add_tracking: [
                  'header||add_tracking.header',
                  'save||add_tracking.save',
                  'back||add_tracking.back',
                  {
                    tabs: [
                      {
                        manual: [
                          'tab_name||manual.tab_name',
                          {
                            form: ['link||form.link', 'priority||form.priority', 'enabled||form.enabled']
                          }
                        ],
                        from_file: [
                          'tab_name||from_file.tab_name',
                          'header||from_file.header',
                          'description||from_file.description',
                          'errors_in_file||from_file.errors_in_file'
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                edit_tracking: [
                  'header||edit_tracking.header',
                  'save||edit_tracking.save',
                  'back||edit_tracking.back',
                  {
                    form: ['link||edit_form.link', 'priority||edit_form.priority', 'enabled||edit_form.enabled']
                  }
                ]
              }
            ]
          }
        }
      };

    translateManagerProvider.add_locals_list(listJs);
    localesApiProvider.set_locales('AdminTrackersMirrorsListJs', listJs);
    translateManagerProvider.add_locals_list(listNoJs);
    localesApiProvider.set_locales('AdminTrackersMirrorsListNoJs', listNoJs);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('EditTrackingMirrorsController', EditTrackingMirrorsController);

  EditTrackingMirrorsController.$inject = [
    '$state',
    '$stateParams',
    'AdminTrackingMirrorsApi',
    '_',
    'outputErrors',
    'tableEngine',
    'toastsApi'
  ];

  function EditTrackingMirrorsController(
    $state,
    $stateParams,
    AdminTrackingMirrorsApi,
    _,
    outputErrors,
    tableEngine,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = $state.current.data.translate_key;
    vm.mirrorsType = $state.current.data.type;
    vm.errors = outputErrors.createNew();
    vm.mirror = {link: '', priority: null, enabled: false};
    vm.table = tableEngine.getTableByName('mirrors_' + vm.mirrorsType);

    vm.back = function() {
      $state.go('^');
    };

    vm.save = function() {
      AdminTrackingMirrorsApi.update($stateParams.mirrorId, vm.mirror, vm.mirrorsType).then(
        function() {
          toastsApi.toastEditSuccess();
          vm.table.pagination();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    AdminTrackingMirrorsApi.edit($stateParams.mirrorId).then(
      function(response) {
        var data = response.data;

        vm.mirror.id = data.id;
        vm.mirror.link = data.domain;
        vm.mirror.priority = data.priority;
        vm.mirror.enabled = data.enabled;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AddTrackingMirrorsController', AddTrackingMirrorsController);

  AddTrackingMirrorsController.$inject = [
    '$state',
    'FileUploader',
    'AdminTrackingMirrorsApi',
    '_',
    'envService',
    '$q',
    'outputErrors',
    '$cookies',
    'tableEngine',
    'tabsApi',
    'localesApi',
    'toastsApi'
  ];

  function AddTrackingMirrorsController(
    $state,
    FileUploader,
    AdminTrackingMirrorsApi,
    _,
    envService,
    $q,
    outputErrors,
    $cookies,
    tableEngine,
    tabsApi,
    localesApi,
    toastsApi
  ) {
    var vm = this,
      urlBase = envService.read('apiUrl');

    vm.translate_key = $state.current.data.translate_key;
    vm.mirrorsType = $state.current.data.type;
    vm.parentState = $state.current.data.parentState;
    vm.errors = outputErrors.createNew();
    vm.mirror = {link: '', priority: null, enabled: false};
    vm.table = tableEngine.getTableByName('mirrors_' + vm.mirrorsType);
    vm.isError = false;
    vm.fileUploadDeferred = {};

    vm.uploader = new FileUploader({
      url: urlBase + 'admin/mirrors/create_with_file',
      withCredentials: true,
      queueLimit: 1,
      removeAfterUpload: true,
      formData: [{mirror_type: vm.mirrorsType}],
      headers: {
        'x-xsrf-token': $cookies.get('XSRF-TOKEN-X')
      }
    });

    vm.back = function() {
      $state.go(vm.parentState);
    };

    vm.addManually = function() {
      return AdminTrackingMirrorsApi.create(vm.mirror, vm.mirrorsType).then(
        function() {
          vm.mirror.link = '';
          vm.mirror.priority = null;
          vm.mirror.enabled = false;
          toastsApi.toastCreateSuccess();
          vm.table.pagination();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.addFromFile = function() {
      if (!vm.uploader.queue.length) {
        return $q.when();
      }

      vm.fileUploadDeferred = $q.defer();
      vm.isError = false;
      vm.uploader.uploadAll();

      return vm.fileUploadDeferred.promise;
    };

    vm.tabs = tabsApi.init({
      name: 'tracking_mirrors',
      translateKey: vm.translate_key,
      list: [
        {
          name: 'manual',
          shortcode: 'manual.tab_name',
          state: vm.parentState + '.add_tracking.manual'
        },
        {
          name: 'from_file',
          shortcode: 'from_file.tab_name',
          state: vm.parentState + '.add_tracking.from_file'
        }
      ]
    });

    vm.tabs.setTabSubmitFunction('manual', vm.addManually);
    vm.tabs.setTabSubmitFunction('from_file', vm.addFromFile);

    vm.uploader.onErrorItem = function(fileItem, response) {
      vm.isError = true;
      vm.errors.inputErrors({
        file: (response.errors && response.errors.file) || [
          localesApi.get_locale(vm.translate_key, 'from_file.errors_in_file')
        ]
      });
    };

    vm.uploader.onAfterAddingFile = function() {
      vm.errors.clearError('file');
    };

    vm.uploader.onCompleteAll = function() {
      vm.fileUploadDeferred.resolve();

      if (!vm.isError) {
        vm.table.pagination();
        toastsApi.toastCreateSuccess();
        vm.errors.clearError('file');
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminTrackersController', AdminTrackersController);

  AdminTrackersController.$inject = ['$scope', 'tableEngine', 'AdminTrackersApi', '_', 'toastsApi', 'downloadReport'];

  function AdminTrackersController($scope, tableEngine, AdminTrackersApi, _, toastsApi, downloadReport) {
    var vm = this;

    vm.translate_key = 'AdminTrackers';

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: AdminTrackersApi.downloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.table = tableEngine.init({
      api: AdminTrackersApi,
      name: 'trackers',
      mobile: {
        defaultColumns: ['tracker_code']
      }
    });

    AdminTrackersApi.getTrackers().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('aasm_state', {
          localizied: true,
          locales: {
            translate_key: 'AdminTrackers',
            shortcode: 'trackers.aasm_state.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });

        vm.downloadFormats = data.separators_for_format;
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('trackers', {
      name: 'trackers',
      url: '/trackers',
      templateUrl: 'app/admin/trackers/partials/trackers.html',
      controller: 'AdminTrackersController',
      controllerAs: 'trackers',
      data: {
        permissions: permissionsStateAccess.init(['api2.admin.trackerscontroller.show'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partnership_program: {
          trackers: [
            'header||trackers.header',
            'download_report||trackers.download_report',
            {
              aasm_state: ['assigned||trackers.aasm_state.assigned']
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminTrackers', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('subaffiliate_conditions', {
        url: '/subaffiliate_conditions',
        templateUrl: 'app/admin/subaffiliate_conditions/partials/conditions.html',
        controller: 'AdminSubaffiliateConditionsController',
        controllerAs: 'conditions',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.subaffiliateconditionscontroller.show'])
        }
      })
      .state('subaffiliate_conditions.settings', {
        url: '/settings/:conditionId',
        templateUrl: 'app/admin/subaffiliate_conditions/partials/settings_condition.html',
        controller: 'AdminSubaffiliateSettingsController',
        controllerAs: 'settings',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.subaffiliateconditionscontroller.edit'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partnership_program: {
          subaffiliate_conditions: [
            'header||conditions.header',
            'create_plan||conditions.create_plan',
            {
              modal_window: [
                'remove||remove_condition.remove',
                'remove_question||remove_condition.remove_question',
                'delete||remove_condition.delete',
                'cancel||remove_condition.cancel'
              ]
            },
            {
              create_edit: [
                'header_create||main_params.header_create',
                'header_edit||main_params.header_edit',
                'save||common_button.save',
                'back||common_button.back',
                'step_settings_header||step_settings_header',
                {
                  form: ['title||main_params.form.title', 'description||main_params.form.description']
                },
                {
                  step: [
                    'payment_size_empty||steps_and_step_items.payment_size_empty',
                    'step||steps_and_step_items.step',
                    {
                      validations: [
                        'step_invalid||validations.step_invalid',
                        'payment_size_value_is_not_valid||validations.payment_size_value_is_not_valid'
                      ]
                    },
                    {
                      modal_window: {
                        set_condition: [
                          'title||set_condition.title',
                          'cancel||set_condition.cancel',
                          'save||set_condition.save',
                          {
                            form: [
                              'value||set_condition.form.value',
                              'payment_column||set_condition.form.payment_column'
                            ]
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminSubaffiliateConditions', list);
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminSubaffiliateSettingsController', AdminSubaffiliateSettingsController);

  AdminSubaffiliateSettingsController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'SubaffiliateConditionsApi',
    '$mdDialog',
    '_',
    'outputErrors',
    '$q',
    'tableEngine',
    'toastsApi'
  ];

  function AdminSubaffiliateSettingsController(
    $scope,
    $state,
    $stateParams,
    SubaffiliateConditionsApi,
    $mdDialog,
    _,
    outputErrors,
    $q,
    tableEngine,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSubaffiliateConditions';
    vm.condition_id = $stateParams.conditionId || 0;
    vm.main_title = vm.condition_id ? 'main_params.header_edit' : 'main_params.header_create';
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('subaffiliate_conditions');
    vm.condition = {};
    vm.condition_mark = '%';
    vm.payment_columns = {};

    vm.markFor = function(step) {
      return step && step.payment_column === 'cpa_flat' ? '$' : '%';
    };

    vm.labelFor = function(step) {
      if (!step || !step.payment_column) {
        return '';
      }

      var columns = vm.payment_columns || {};
      var keys = Object.keys(columns);
      for (var i = 0; i < keys.length; i++) {
        if (columns[keys[i]] === step.payment_column) {
          return keys[i];
        }
      }

      return step.payment_column;
    };

    vm.condition.subaffiliate_condition_steps_attributes = [{}];

    vm.back = function() {
      $state.go('subaffiliate_conditions');
    };

    vm.open_modal = function(params, ev) {
      return $mdDialog.show({
        controller: 'AdminSubaffiliateConditionsModalController',
        controllerAs: 'conditions',
        templateUrl: params.templateUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: params.data || {}
      });
    };

    vm.set_condition = function(step, ev) {
      if (vm.condition.read_only) {
        return;
      }

      var draft = _.defaults(_.clone(step), {payment_size: null, payment_column: null}),
        params = {
          templateUrl: 'app/admin/subaffiliate_conditions/partials/set_condition_form.html',
          data: {
            step: draft,
            payment_columns: vm.payment_columns
          }
        };

      vm.open_modal(params, ev).then(
        function(saved) {
          _.extend(step, _.pick(saved, ['payment_size', 'payment_column']));
          vm.validateStep(step);
        },
        function() {
          return null;
        }
      );
    };

    vm.validateStep = function(step) {
      step.is_invalid = !_.isNumber(step.payment_size) || _.isEmpty(step.payment_column);

      return !step.is_invalid;
    };

    vm.save_condition = function() {
      vm.conditionForm.$setSubmitted();

      var stepValid = vm.validateStep(_.first(vm.condition.subaffiliate_condition_steps_attributes));

      if (vm.conditionForm.$valid && stepValid) {
        return SubaffiliateConditionsApi.create_or_update(vm.condition).then(
          function() {
            if (vm.condition.id) {
              toastsApi.toastEditSuccess();
            } else {
              toastsApi.toastCreateSuccess();
            }
            vm.table.pagination();
            vm.back();
          },
          function(response) {
            vm.errors.inputErrors(response.data.errors);
            toastsApi.toastError();
          }
        );
      }
    };

    SubaffiliateConditionsApi.get().then(
      function(response) {
        vm.payment_columns = response.data.constants.subaffiliate_condition_steps.payment_column;
      },
      function() {
        toastsApi.toastError();
      }
    );

    if (vm.condition_id) {
      SubaffiliateConditionsApi.edit(vm.condition_id).then(
        function(response) {
          vm.condition = response.data.subaffiliate_condition;

          if (_.isEmpty(vm.condition.subaffiliate_condition_steps_attributes)) {
            vm.condition.subaffiliate_condition_steps_attributes = [{}];
          } else {
            vm.validateStep(_.first(vm.condition.subaffiliate_condition_steps_attributes));
          }
        },
        function() {
          toastsApi.toastError();
        }
      );
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminSubaffiliateConditionsModalController', AdminSubaffiliateConditionsModalController);

  AdminSubaffiliateConditionsModalController.$inject = ['outputErrors', 'localesApi', '$mdDialog'];

  function AdminSubaffiliateConditionsModalController(outputErrors, localesApi, $mdDialog) {
    var vm = this;

    vm.translate_key = 'AdminSubaffiliateConditions';
    vm.errors = outputErrors.createNew();

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.hide = function(data) {
      $mdDialog.hide(data || vm);
    };

    vm.set = function() {
      vm.setForm.$setSubmitted();

      var flat = vm.step.payment_column === 'cpa_flat';
      if (vm.step.payment_size < 0 || (!flat && vm.step.payment_size > 100)) {
        vm.errors.inputErrors({
          payment_size: [localesApi.get_locale(vm.translate_key, 'validations.payment_size_value_is_not_valid')]
        });
      }

      if (vm.setForm.$valid) {
        vm.hide(vm.step);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminSubaffiliateConditionsController', AdminSubaffiliateConditionsController);

  AdminSubaffiliateConditionsController.$inject = [
    '$scope',
    '$state',
    '$mdTranslate',
    'tableEngine',
    'SubaffiliateConditionsApi',
    '$mdDialog',
    '_',
    'outputErrors',
    'toastsApi'
  ];

  function AdminSubaffiliateConditionsController(
    $scope,
    $state,
    $mdTranslate,
    tableEngine,
    SubaffiliateConditionsApi,
    $mdDialog,
    _,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminSubaffiliateConditions';
    vm.errors = outputErrors.createNew();

    vm.edit_condition = function(id) {
      $state.go('subaffiliate_conditions.settings', {conditionId: id});
    };

    vm.create_condition = function() {
      $state.go('subaffiliate_conditions.settings');
    };

    vm.removeCondition = function(condition_id, ev) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'remove_condition.remove'))
        .textContent($mdTranslate.instant(vm.translate_key, 'remove_condition.remove_question'))
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, 'remove_condition.delete'))
        .cancel($mdTranslate.instant(vm.translate_key, 'remove_condition.cancel'));

      $mdDialog.show(confirm).then(function() {
        SubaffiliateConditionsApi.destroy(condition_id).then(
          function() {
            vm.table.removeListItem();
            toastsApi.toastRemoveSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.table = tableEngine.init({
      api: SubaffiliateConditionsApi,
      name: 'subaffiliate_conditions',
      mobile: {
        defaultColumns: ['title']
      },
      buttons: {
        url: 'app/admin/subaffiliate_conditions/partials/table.html',
        methods: {
          edit_condition: vm.edit_condition,
          removeCondition: vm.removeCondition
        }
      }
    });

    SubaffiliateConditionsApi.conditions_list().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('settings', {
        url: '/settings',
        templateUrl: 'app/admin/settings/main/partials/settings.html',
        controller: 'AdminSettingsController',
        controllerAs: 'settings',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.projectsettingscontroller.edit'])
        }
      })
      .state('settings.company', {
        url: '/company',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/company/partials/company.html',
            controller: 'SettingsCompanyController',
            controllerAs: 'company'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          }
        }
      })
      .state('settings.affiliate_auto_approve', {
        url: '/auto_approve',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/affiliate_auto_approve/partials/affiliate_auto_approve.html',
            controller: 'AdminSettingsAutoApproveController',
            controllerAs: 'approveCtrl'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.autoapprovelocalescontroller.show'])
        }
      })
      .state('settings.information', {
        url: '/information',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/information/partials/information.html',
            controller: 'SettingsInfoPagesController',
            controllerAs: 'information'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init([
            'api2.admin.staticpagescontroller.faq',
            'api2.admin.staticpagescontroller.terms',
            'api2.admin.staticpagescontroller.privacy',
            'api2.admin.staticpagescontroller.commission',
            'api2.admin.staticpagescontroller.help',
            'api2.admin.staticpagescontroller.static_page_1',
            'api2.admin.staticpagescontroller.static_page_2',
            'api2.admin.staticpagescontroller.static_page_3',
            'api2.admin.staticpagescontroller.static_page_4',
            'api2.admin.staticpagescontroller.static_page_5'
          ])
        }
      })
      .state('settings.emails', {
        url: '/emails',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/emails/partials/emails.html',
            controller: 'SettingsEmailsController',
            controllerAs: 'emails'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.mailersmanagercontroller.edit'])
        }
      })
      .state('settings.bookkeeping', {
        url: '/bookkeeping',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/bookkeeping/partials/bookkeeping.html',
            controller: 'SettingsBookkeepingController',
            controllerAs: 'bookkeeping'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          },
          'history_changes@settings': {
            templateUrl: 'app/admin/settings/main/partials/history_changes_view.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.historyoflimitchangescontroller.create'])
        }
      })
      .state('settings.history_changes_percent', {
        url: '/bookkeeping/:merchantId/history/:id',
        templateUrl: 'app/admin/settings/bookkeeping/partials/history_changes.html',
        controller: 'HistoryChangesPercentController',
        controllerAs: 'history',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.historyoflimitchangescontroller.edit'])
        }
      })
      .state('settings.admin_fees', {
        url: '/fees',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/admin_fees/partials/admin_fees.html',
            controller: 'SettingsFeesController',
            controllerAs: 'feesCtrl'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          },
          'history_changes@settings': {
            templateUrl: 'app/admin/settings/main/partials/history_changes_view.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.adminfeescontroller.edit'])
        }
      })
      .state('settings.history_changes_fees', {
        url: '/fees/:merchantId/history/:id',
        templateUrl: 'app/admin/settings/admin_fees/partials/history_changes.html',
        controller: 'HistoryChangesFeesController',
        controllerAs: 'history',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.adminfeescontroller.edit'])
        }
      })
      // .state('settings.columns', {
      //   url: '/columns',
      //   views: {
      //     'content@settings': {
      //       templateUrl: 'app/admin/settings/columns/partials/columns.html',
      //       controller: 'SettingsColumnsController',
      //       controllerAs: 'columns'
      //     }
      //   },
      //   data: {
      //     permissions: permissionsStateAccess.init(['api2.admin.projectsettingscontroller.default_order_columns'])
      //   }
      // })
      .state('settings.columns_for_tables', {
        url: '/columns_for_tables',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/columns_for_tables/partials/columns_for_tables.html',
            controller: 'SettingsTablesController',
            controllerAs: 'columnsCtrl'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.tablefordisplayscontroller.show'])
        }
      })
      .state('settings.columns_for_tables.settings', {
        url: '/edit/:tableKey',
        templateUrl: 'app/admin/settings/columns_for_tables/partials/settings_table_columns.html',
        controller: 'SettingsTableColumnsController',
        controllerAs: 'settingsCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.tablecolumnsfordisplayscontroller.edit'])
        }
      })
      .state('settings.view_all_statistics', {
        url: '/view_all_statistics',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/view_all_statistics/partials/view_all_statistics.html',
            controller: 'SettingsViewStatisticsController',
            controllerAs: 'viewStatsCtrl'
          }
        },
        data: {
          permissions: permissionsStateAccess.init([
            'api2.admin.projectsettingscontroller.admins_with_full_stats_access'
          ])
        }
      })
      .state('settings.registration_fields', {
        url: '/registration_fields',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/registration_fields/partials/registration_fields.html',
            controller: 'SettingsRegistrationFieldsController',
            controllerAs: 'regFieldsCtrl'
          }
        },
        data: {
          permissions: permissionsStateAccess.init([
            'api2.admin.projectsettingscontroller.required_fields_in_profile_update'
          ])
        }
      })
      .state('settings.payment_systems', {
        url: '/payment_systems',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/payment_systems/partials/payment_systems.html',
            controller: 'SettingsPaymentSystemsController',
            controllerAs: 'paymentCtrl'
          },
          'table@settings': {
            templateUrl: 'app/admin/settings/payment_systems/partials/list.html',
            controller: 'SettingsCountryGroupsController',
            controllerAs: 'countryGroupsCtrl'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.paymentsystemlistscontroller.show'])
        }
      })
      .state('settings.country_group_settings', {
        url: '/payment_systems/settings/:groupId',
        templateUrl: 'app/admin/settings/payment_systems/partials/group_settings.html',
        controller: 'SettingsCountryGroupSettingsController',
        controllerAs: 'groupSettingsCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.banktransfercountrygroupscontroller.edit'])
        }
      })
      .state('settings.upload_logo', {
        url: '/upload_logo',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/upload_logo/partials/upload_logo.html',
            controller: 'SettingsUploadLogoController',
            controllerAs: 'uploadCtrl'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          }
        }
      })
      .state('settings.notification_header', {
        url: '/notification_header',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/notification_header/partials/notification_header.html',
            controller: 'SettingsNotificationHeaderController',
            controllerAs: 'notifyCtrl'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.notificationscontroller.show'])
        }
      })
      .state('settings.affiliate_banner', {
        url: '/affiliate_banner',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/affiliate_banner/partials/affiliate_banner.html',
            controller: 'SettingsAffiliateBannerController',
            controllerAs: 'affBannerCtrl'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.bannersettingscontroller.show'])
        }
      })
      .state('settings.click_domains', {
        url: '/click_domains',
        views: {
          'content@settings': {
            templateUrl: 'app/admin/settings/click_domains/partials/click_domains.html',
            controller: 'AdminSettingsClickDomainsController',
            controllerAs: 'clickCtrl'
          },
          'buttons@settings': {
            templateUrl: 'app/admin/settings/main/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.clickdomainscontroller.show'])
        }
      })
      .state('settings.add_click_domain', {
        url: '/click_domains/add',
        templateUrl: 'app/admin/settings/click_domains/partials/add_domain.html',
        controller: 'AdminAddClickDomainController',
        controllerAs: 'addCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.clickdomainscontroller.edit'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider, CreativeDomain) {
    var list = {
      admin: {
        settings: {
          general_settings: [
            'main_title||general_settings.main_title',
            'save||general_settings.save',
            {
              tabs: [
                {
                  company: [
                    'tab_name||company.tab_name',
                    'company_name||company.company_name',
                    'max_trackers||company.max_trackers',
                    // 'redirector_domain||company.redirector_domain',
                    'deafult_creative_id||company.deafult_creative_id',
                    'deafult_serial_id||company.deafult_serial_id',
                    'default_condition||company.default_condition',
                    'default_subaffiliate_condition||company.default_subaffiliate_condition',
                    'title||company.title',
                    'currency||company.currency',
                    'header_color||company.header_color',
                    'buttons_color||company.buttons_color',
                    'default_language||company.default_language',
                    'project_languages||company.project_languages',
                    'creative_languages||company.creative_languages'
                  ].concat(
                    Array.from(Array(CreativeDomain.getCount()).keys()).map(function(i) {
                      var name = CreativeDomain.buildDomainName(i);
                      return name + '||company.' + name;
                    })
                  )
                },
                {
                  affiliate_auto_approve: [
                    'tab_name||affiliate_auto_approve.tab_name',
                    'auto_accept_affiliate_request||affiliate_auto_approve.auto_accept_affiliate_request',
                    'select_admin_for_all_languages||affiliate_auto_approve.select_admin_for_all_languages',
                    'admins_have_not_been_found||affiliate_auto_approve.admins_have_not_been_found',
                    'select_language_for_searching_admin||affiliate_auto_approve.select_language_for_searching_admin'
                  ]
                },
                {
                  information: [
                    'tab_name||information.tab_name',
                    'language||information.language',
                    'settings_type||information.settings_type',
                    'settings_terms||information.settings_terms',
                    'settings_privacy||information.settings_privacy',
                    'settings_faq||information.settings_faq',
                    'settings_commission||information.settings_commission',
                    'settings_help||information.settings_help',
                    'settings_static_page_1||information.settings_static_page_1',
                    'settings_static_page_2||information.settings_static_page_2',
                    'settings_static_page_3||information.settings_static_page_3',
                    'settings_static_page_4||information.settings_static_page_4',
                    'settings_static_page_5||information.settings_static_page_5'
                  ]
                },
                {
                  emails: [
                    'tab_name||emails.tab_name',
                    'language||emails.language',
                    'emails_list||emails.emails_list',
                    'email_settings||emails.email_settings',
                    'subject||emails.subject',
                    'body||emails.body',
                    'enable_sending_email||emails.enable_sending_email',
                    'email_cannot_be_disabled||emails.email_cannot_be_disabled',
                    'variables||emails.variables'
                  ]
                },
                {
                  bookkeeping: [
                    'tab_name||bookkeeping.tab_name',
                    {
                      form: ['limit||bookkeeping.limit', 'date||bookkeeping.date']
                    },
                    {
                      history_changes: [
                        {
                          edit: [
                            'header||bookkeeping.history_changes.header',
                            'save||bookkeeping.history_changes.save',
                            'back||bookkeeping.history_changes.back',
                            {
                              form: [
                                'limit||bookkeeping.history_changes.limit',
                                'date||bookkeeping.history_changes.date'
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  admin_fees: [
                    'tab_name||admin_fees.tab_name',
                    {
                      form: [
                        'percent||admin_fees.percent',
                        'count_from||admin_fees.count_from',
                        'date||admin_fees.date'
                      ]
                    },
                    {
                      history_changes: [
                        {
                          edit: [
                            'header||admin_fees.history_changes.header',
                            'save||admin_fees.history_changes.save',
                            'back||admin_fees.history_changes.back',
                            {
                              form: [
                                'percent||admin_fees.history_changes.percent',
                                'count_from||admin_fees.history_changes.count_from',
                                'date||admin_fees.history_changes.date'
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  columns: [
                    'tab_name||columns.tab_name',
                    'choose_settings||columns.choose_settings',
                    'structures_columns_name||columns.structures_columns_name',
                    'statistics_columns_name||columns.statistics_columns_name',
                    {
                      structures_columns: [
                        'general_columns||structures_columns.general_columns',
                        'players_column||structures_columns.players_column',
                        'product_column||structures_columns.product_column',
                        'comission_column||structures_columns.comission_column',
                        'stats_column||structures_columns.stats_column'
                      ]
                    },
                    {
                      statistics_columns: ['players_statistics_columns||statistics_columns.players_statistics_columns']
                    }
                  ]
                },
                {
                  columns_for_tables: [
                    'tab_name||columns_for_tables.tab_name',
                    'tables||columns_for_tables.tables',
                    {
                      settings_table_columns: [
                        'selected_columns||columns_for_tables.columns_selected',
                        'unselected_columns||columns_for_tables.columns_unselected',
                        'back||settings_table_columns.back'
                      ]
                    }
                  ]
                },
                {
                  registration_fields: ['tab_name||registration_fields.tab_name', 'label||registration_fields.label']
                },
                {
                  view_all_statistics: ['tab_name||view_all_statistics.tab_name', 'label||view_all_statistics.label']
                },
                {
                  payment_systems: [
                    'tab_name||payment_systems.tab_name',
                    'label||payment_systems.label',
                    'country_groups_header||payment_systems.country_groups_header',
                    'add_new_country_group||payment_systems.add_new_country_group',
                    {
                      remove_group_modal: [
                        'title||remove_modal.title',
                        'delete_question||remove_modal.delete_question',
                        'answer_yes||remove_modal.answer_yes',
                        'answer_no||remove_modal.answer_no'
                      ]
                    },
                    {
                      group_settings: [
                        'header||group_settings.header',
                        'group_name||group_settings.group_name',
                        'countries_list||group_settings.countries_list',
                        'configure_fields||group_settings.configure_fields',
                        'required_field||group_settings.required_field',
                        'max_length||group_settings.max_length',
                        'min_length||group_settings.min_length',
                        'save_button||group_settings.save_button',
                        'back_button||group_settings.back_button'
                      ]
                    }
                  ]
                },
                {
                  upload_logo: [
                    'tab_name||upload_logo.tab_name',
                    'choose_logo_mini||upload_logo.choose_logo_mini',
                    'drop_logo_mini_here||upload_logo.drop_logo_mini_here',
                    'resolution_logo_mini||upload_logo.resolution_logo_mini',
                    'choose_logo_main||upload_logo.choose_logo_main',
                    'drop_logo_main_here||upload_logo.drop_logo_main_here',
                    'resolution_logo_main||upload_logo.resolution_logo_main',
                    'choose_favicon||upload_logo.choose_favicon',
                    'drop_favicon_here||upload_logo.drop_favicon_here',
                    'resolution_favicon||upload_logo.resolution_favicon'
                  ]
                },
                {
                  notification_header: [
                    'tab_name||notification_header.tab_name',
                    'namespace||notification_header.namespace',
                    'for_anonymous||notification_header.for_anonym',
                    'for_affiliates||notification_header.for_affiliate',
                    'header_color||notification_header.header_color',
                    'text_color||notification_header.text_color',
                    'language||notification_header.language',
                    'text_content||notification_header.text_content',
                    'state||notification_header.state'
                  ]
                },
                {
                  affiliate_banner: [
                    'tab_name||affiliate_banner.tab_name',
                    'choose_banner||affiliate_banner.choose_banner',
                    'drop_banner_here||affiliate_banner.drop_banner_here',
                    'resolution_banner||affiliate_banner.resolution_banner',
                    'invalid_file_format||affiliate_banner.invalid_file_format',
                    'invalid_file_size||affiliate_banner.invalid_file_size',
                    'link||affiliate_banner.link',
                    'enabled||affiliate_banner.enabled',
                    'preview_banner_btn||affiliate_banner.preview_banner_btn'
                  ]
                },
                {
                  click_domains: [
                    'tab_name||click_domains.tab_name',
                    'add_domain_button||click_domains.add_domain',
                    {
                      form: ['default_domain||form.default_domain']
                    },
                    {
                      add_domain: [
                        'header||add_domain.header',
                        'save||add_domain.save',
                        'back||add_domain.back',
                        {
                          form: ['domain||add_domain.form.domain']
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminSettings', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('reports', {
        url: '/reports',
        templateUrl: 'app/components/reports/partials/reports.html',
        controller: 'ReportsController',
        controllerAs: 'reports',
        data: {
          report_api: 'ReportApi',
          translate_key: 'Reports',
          namespace: 'admin',
          permission_ctrl_name: 'reportscontroller',
          permissions: permissionsStateAccess.init(['api2.admin.reportscontroller.generate_report']),
          group_by_map: {
            date: {
              locale: 'date',
              model: 'group_by_date',
              order: 1
            },
            affiliate: {
              locale: 'affiliate_params',
              model: 'group_by_affiliate_params',
              order: 2
            },
            player: {
              locale: 'player_params',
              model: 'group_by_player_params',
              order: 3
            },
            row_on_page: {
              locale: 'per_page',
              item_locale: 'rows_per_page',
              model: 'per_page',
              order: 4
            }
          },
          all_stats_list: [
            {
              id: 7,
              name: 'date_of_registration',
              shortcode: 'segments.tabs.date_of_registration',
              empty: true,
              type: 'date'
            },
            {
              id: 8,
              name: 'date_of_ftd',
              shortcode: 'segments.tabs.date_of_ftd',
              empty: true,
              type: 'date'
            },
            {
              id: 9,
              name: 'date_of_last_deposit',
              shortcode: 'segments.tabs.date_of_last_deposit',
              empty: true,
              type: 'date'
            },
            {
              id: 10,
              name: 'date_of_last_rmp_activity',
              shortcode: 'segments.tabs.date_of_last_rmp_activity',
              empty: true,
              type: 'date'
            },
            {
              id: 11,
              name: 'inactive_days',
              shortcode: 'segments.tabs.inactive_days',
              empty: true,
              type: 'compare'
            },
            {
              id: 12,
              name: 'first_deposit_size',
              shortcode: 'segments.tabs.first_deposit_size',
              empty: true,
              type: 'compare'
            },
            {
              id: 13,
              name: 'last_deposit_size',
              shortcode: 'segments.tabs.last_deposit_size',
              empty: true,
              type: 'compare'
            },
            {
              id: 14,
              name: 'amount_of_deposits',
              shortcode: 'segments.tabs.amount_of_deposits',
              empty: true,
              type: 'compare'
            },
            {
              id: 15,
              name: 'average_deposit_size',
              shortcode: 'segments.tabs.average_deposit_size',
              empty: true,
              type: 'compare'
            },
            {
              id: 16,
              name: 'sum_of_deposits',
              shortcode: 'segments.tabs.sum_of_deposits',
              empty: true,
              type: 'compare'
            },
            {
              id: 19,
              name: 'ngr_all_time',
              shortcode: 'segments.tabs.ngr_all_time',
              empty: true,
              type: 'compare'
            },
            {
              id: 20,
              name: 'ggr_all_time',
              shortcode: 'segments.tabs.ggr_all_time',
              empty: true,
              type: 'compare'
            },
            {
              id: 21,
              name: 'ngr_this_month',
              shortcode: 'segments.tabs.ngr_this_month',
              empty: true,
              type: 'compare'
            },
            {
              id: 22,
              name: 'ggr_this_month',
              shortcode: 'segments.tabs.ggr_this_month',
              empty: true,
              type: 'compare'
            },
            // {
            //   id: 17,
            //   name: 'country',
            //   shortcode: 'segments.tabs.country',
            //   empty: true,
            //   type: 'checkbox'
            // },
            {
              id: 36,
              name: 'country_code',
              shortcode: 'segments.tabs.country_code',
              empty: true,
              type: 'checkbox'
            },
            {
              id: 37,
              name: 'country_ip_code',
              shortcode: 'segments.tabs.country_ip_code',
              empty: true,
              type: 'checkbox'
            }
          ],
          segment_tabs: [
            {
              id: 300,
              type: 'merchant_ids',
              shortcode: 'segments.tabs.merchant_ids',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 51,
              type: 'managers',
              shortcode: 'segments.tabs.managers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 52,
              type: 'roles',
              shortcode: 'segments.tabs.roles',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 1,
              type: 'affiliates',
              shortcode: 'segments.tabs.affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 53,
              type: 'subaffiliates',
              shortcode: 'segments.tabs.invated_affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 2,
              type: 'trackers',
              shortcode: 'segments.tabs.trackers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 3,
              type: 'anid',
              shortcode: 'segments.tabs.anid',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 4,
              type: 'creatives',
              shortcode: 'segments.tabs.creatives',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 5,
              type: 'players',
              shortcode: 'segments.tabs.players',
              field_name: 'value',
              upload_from_file: true,
              upload_params: {
                url: 'load_file_with_players',
                file_formats: [{format: '.csv', type: 'text/csv'}]
              },
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 6,
              type: 'stats',
              shortcode: 'segments.tabs.stats',
              templateUrl: 'app/components/reports/partials/stats_template.html',
              stats_column_template_url: 'app/components/reports/partials/stats_parts/{{type}}_template.html',
              all_stats_key: 'all_stats_list'
            }
          ],
          structure_tabs: [
            {
              id: 5,
              type: 'general_columns',
              shortcode: 'structures.tabs.general_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 1,
              type: 'player_columns',
              shortcode: 'structures.tabs.player_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 2,
              type: 'product_columns',
              shortcode: 'structures.tabs.product_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 3,
              type: 'comission_columns',
              shortcode: 'structures.tabs.comission_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 4,
              type: 'stats_columns',
              shortcode: 'structures.tabs.stats_columns',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            }
          ]
        }
      })
      .state('subaffiliate_reports', {
        url: '/subaffiliate_reports',
        templateUrl: 'app/components/reports/partials/reports.html',
        controller: 'ReportsController',
        controllerAs: 'reports',
        data: {
          report_api: 'SubaffiliateReportApi',
          translate_key: 'SubaffiliateReports',
          namespace: 'admin',
          permission_ctrl_name: 'subaffiliatereportscontroller',
          permissions: permissionsStateAccess.init(['api2.admin.subaffiliatereportscontroller.generate_report']),
          group_by_map: {
            date: {
              locale: 'date',
              model: 'group_by_date',
              order: 1
            },
            affiliate: {
              locale: 'affiliate_params',
              model: 'group_by_affiliate_params',
              order: 2
            },
            player: {
              locale: 'player_params',
              model: 'group_by_player_params',
              order: 3
            },
            row_on_page: {
              locale: 'per_page',
              item_locale: 'rows_per_page',
              model: 'per_page',
              order: 4
            }
          },
          segment_tabs: [
            {
              id: 51,
              type: 'managers',
              shortcode: 'segments.tabs.managers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 1,
              type: 'affiliates',
              shortcode: 'segments.tabs.affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 18,
              type: 'invated_affiliates',
              shortcode: 'segments.tabs.invated_affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            }
          ]
        }
      })
      .state('creative_reports', {
        url: '/creative_reports',
        templateUrl: 'app/components/reports/partials/reports.html',
        controller: 'ReportsController',
        controllerAs: 'reports',
        data: {
          report_api: 'CreativeReportApi',
          translate_key: 'CreativeReports',
          namespace: 'admin',
          permission_ctrl_name: 'creativereportscontroller',
          permissions: permissionsStateAccess.init(['api2.admin.creativereportscontroller.generate_report']),
          group_by_map: {
            date: {
              locale: 'date',
              model: 'group_by_date',
              order: 1
            },
            affiliate: {
              locale: 'affiliate_params',
              model: 'group_by_affiliate_params',
              order: 2
            },
            player: {
              locale: 'player_params',
              model: 'group_by_player_params',
              order: 3
            },
            row_on_page: {
              locale: 'per_page',
              item_locale: 'rows_per_page',
              model: 'per_page',
              order: 4
            }
          },
          segment_tabs: [
            {
              id: 300,
              type: 'merchant_ids',
              shortcode: 'segments.tabs.merchant_ids',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 23,
              type: 'creatives_for_creatives_report',
              shortcode: 'segments.tabs.creatives_for_creatives_report',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 24,
              type: 'affiliates_for_creatives_report',
              shortcode: 'segments.tabs.affiliates_for_creatives_report',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 25,
              type: 'trackers_for_creatives_report',
              shortcode: 'segments.tabs.trackers_for_creatives_report',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 26,
              type: 'anids_for_creatives_report',
              shortcode: 'segments.tabs.anids_for_creatives_report',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 51,
              type: 'managers',
              shortcode: 'segments.tabs.managers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 1,
              type: 'affiliates',
              shortcode: 'segments.tabs.affiliates',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            },
            {
              id: 2,
              type: 'trackers',
              shortcode: 'segments.tabs.trackers',
              field_name: 'value',
              templateUrl: 'app/components/reports/partials/checkbox_template.html'
            }
          ]
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('quints_api', {
      url: '/quints_api',
      templateUrl: 'app/admin/quints_api/partials/quints_api.html',
      controller: 'AdminQuintsApiController',
      controllerAs: 'quintsApiCtrl',
      data: {
        permissions: permissionsStateAccess.init(['api2.admin.profilecontroller.api_tokens'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminQuintsApiController', AdminQuintsApiController);

  AdminQuintsApiController.$inject = ['AdminQuintsApi', 'outputErrors', 'toastsApi', '$mdDialog', '$mdTranslate', '_'];

  function AdminQuintsApiController(AdminQuintsApi, outputErrors, toastsApi, $mdDialog, $mdTranslate, _) {
    var vm = this;

    vm.translate_key = 'AdminQuintsApi';
    vm.errors = outputErrors.createNew();
    vm.affiliatesApiLink = '';
    vm.trackersApiLink = '';

    vm.copySuccess = function() {
      toastsApi.toastCopySuccess();
    };

    vm.getQuintsApiLinks = function() {
      AdminQuintsApi.getQuintsApiLinks().then(
        function(response) {
          vm.affiliatesApiLink = response.data.affiliate_link.domain;
          vm.trackersApiLink = response.data.tracker_link.domain;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getResetTokenTranslation = function() {
      return {
        title: $mdTranslate.instant(vm.translate_key, 'confirm_reset_api_token_modal.title'),
        question: $mdTranslate.instant(vm.translate_key, 'confirm_reset_api_token_modal.question'),
        ok: $mdTranslate.instant(vm.translate_key, 'confirm_reset_api_token_modal.answer_yes'),
        cancel: $mdTranslate.instant(vm.translate_key, 'confirm_reset_api_token_modal.answer_no')
      };
    };

    vm.confirmResetingTokenModal = function(data, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(data.title)
        .textContent(data.question)
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok(data.ok)
        .cancel(data.cancel);

      return $mdDialog.show(confirm);
    };

    vm.applyResetToken = function() {
      AdminQuintsApi.resetApiToken().then(
        function() {
          vm.getQuintsApiLinks();
          toastsApi.toastSuccess();
        },
        function(response) {
          var errors = response.data && response.data.errors;

          if (_.isEmpty(errors)) {
            return toastsApi.toastError();
          }

          toastsApi.toastError({locale: _.first(errors)});
        }
      );
    };

    vm.resetApiToken = function(ev) {
      var locales = vm.getResetTokenTranslation();

      vm.confirmResetingTokenModal(locales, ev).then(function() {
        vm.applyResetToken();
      });
    };

    vm.getQuintsApiLinks();
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        settings: {
          quints_api: [
            'header||quints_api.header',
            'affiliates_api_link||quints_api.affiliates_api_link',
            'trackers_api_link||quints_api.trackers_api_link',
            'copy_affiliates_api_link||quints_api.copy_affiliates_api_link',
            'copy_trackers_api_link||quints_api.copy_trackers_api_link',
            'reset_api_token_button||quints_api.reset_api_token_button',
            {
              confirm_reset_api_token_modal: [
                'title||confirm_reset_api_token_modal.title',
                'question||confirm_reset_api_token_modal.question',
                'answer_yes||confirm_reset_api_token_modal.answer_yes',
                'answer_no||confirm_reset_api_token_modal.answer_no'
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminQuintsApi', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('admin_promo_codes', {
        url: '/promo_codes',
        templateUrl: 'app/admin/promo_codes/partials/promo_codes.html',
        controller: 'AdminPromoCodesController',
        controllerAs: '$ctrlList',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.promocodescontroller.show'])
        }
      })
      .state('admin_promo_codes.create', {
        url: '/create',
        templateUrl: 'app/admin/promo_codes/partials/create.html',
        controller: 'PromoCodeCreateController',
        controllerAs: '$ctrlCreate',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.promocodescontroller.create'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPromoCodesController', AdminPromoCodesController);

  AdminPromoCodesController.$inject = [
    '$scope',
    '$state',
    'PromoCodesApi',
    '_',
    'toastsApi',
    'tableEngine',
    '$mdDialog',
    '$mdTranslate'
  ];

  function AdminPromoCodesController(
    $scope,
    $state,
    PromoCodesApi,
    _,
    toastsApi,
    tableEngine,
    $mdDialog,
    $mdTranslate
  ) {
    var vm = this;

    vm.translate_key = 'AdminPromoCodes';

    vm.createPromoCode = function() {
      $state.go('admin_promo_codes.create');
    };

    // Deleted codes stay in the list (greyed out via table.config.rowClass, see
    // components/table/partials/table_list_desktop.haml), not removed -- decision #2.
    // Patches the row in place by id instead of re-fetching the page, matching
    // admin/personal/personal.controller.js's updateListItemById pattern.
    vm.removePromoCode = function(item, ev) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'delete_modal.title', {code: item.code}))
        .textContent($mdTranslate.instant(vm.translate_key, 'delete_modal.message', {code: item.code}))
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, 'delete_modal.ok'))
        .cancel($mdTranslate.instant(vm.translate_key, 'delete_modal.cancel'));

      $mdDialog.show(confirm).then(function() {
        PromoCodesApi.destroy(item.id).then(
          function() {
            vm.table.updateListItemById({deleted: true}, item.id);
            toastsApi.toastRemoveSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    // Dialog copy is built from the row's own already-loaded data (affiliate_username,
    // serial_id) -- no new backend work needed for this. These are page-load values, so a
    // tracker reassignment between load and click could show a stale owner here; acceptable,
    // since the actual restore always reflects the real post-restore state regardless.
    vm.restorePromoCode = function(item, ev) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'restore_modal.title', {code: item.code}))
        .textContent(
          $mdTranslate.instant(vm.translate_key, 'restore_modal.message', {
            code: item.code,
            affiliate: item.affiliate_username,
            tracker: item.serial_id
          })
        )
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, 'restore_modal.ok'))
        .cancel($mdTranslate.instant(vm.translate_key, 'restore_modal.cancel'));

      $mdDialog.show(confirm).then(function() {
        PromoCodesApi.restore(item.id).then(
          function() {
            vm.table.updateListItemById({deleted: false}, item.id);
            toastsApi.toastEditSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.showHistory = function(item, ev) {
      $mdDialog.show({
        controller: 'AdminPromoCodeHistoryModalController',
        controllerAs: '$ctrl',
        templateUrl: 'app/admin/promo_codes/partials/history_modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: {promoCode: item}
      });
    };

    vm.table = tableEngine.init({
      api: PromoCodesApi,
      name: 'promo_codes',
      mobile: {
        defaultColumns: ['code']
      },
      buttons: {
        url: 'app/admin/promo_codes/partials/table.html',
        methods: {
          removePromoCode: vm.removePromoCode,
          restorePromoCode: vm.restorePromoCode,
          showHistory: vm.showHistory
        }
      },
      rowClass: function(item) {
        return {'row-deleted': item.deleted};
      }
    });

    PromoCodesApi.list().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partnership_program: {
          promo_codes: [
            'header||promo_codes.header',
            'create_button||promo_codes.create_button',
            {
              delete_modal: [
                'title||delete_modal.title',
                'message||delete_modal.message',
                'ok||delete_modal.ok',
                'cancel||delete_modal.cancel'
              ]
            },
            {
              restore_modal: [
                'title||restore_modal.title',
                'message||restore_modal.message',
                'ok||restore_modal.ok',
                'cancel||restore_modal.cancel'
              ]
            },
            {
              history_modal: [
                'title||history_modal.title',
                'close||history_modal.close',
                'no_history||history_modal.no_history',
                {
                  actions: [
                    'create||history_modal.actions.create',
                    'destroy||history_modal.actions.destroy',
                    'restore||history_modal.actions.restore',
                    // No UI path writes an update audit today (only create/destroy/restore --
                    // see promo_code.rb's `audited except: :deleted_at`), but a future console
                    // edit of code/serial_id would write one, and history_modal.haml's
                    // shortcode is built dynamically from audit.action -- seeded now so that
                    // never silently renders a raw i18n key instead of a label.
                    'update||history_modal.actions.update'
                  ]
                }
              ]
            },
            {
              create: [
                'header||create.header',
                'back||create.back',
                'save||create.save',
                {
                  form: ['promo_code||create.form.promo_code', 'tracker||create.form.tracker']
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminPromoCodes', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPromoCodeHistoryModalController', AdminPromoCodeHistoryModalController);

  AdminPromoCodeHistoryModalController.$inject = ['$mdDialog', 'PromoCodesApi', 'toastsApi'];

  function AdminPromoCodeHistoryModalController($mdDialog, PromoCodesApi, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminPromoCodes';
    vm.audits = [];
    vm.loading = true;

    vm.hide = function() {
      $mdDialog.hide();
    };

    PromoCodesApi.getAudits(vm.promoCode.id).then(
      function(response) {
        vm.audits = response.data.audits;
        vm.loading = false;
      },
      function() {
        vm.loading = false;
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('PromoCodeCreateController', PromoCodeCreateController);

  PromoCodeCreateController.$inject = [
    '$scope',
    '$state',
    'PromoCodesApi',
    '_',
    'outputErrors',
    'toastsApi',
    'tableEngine'
  ];

  function PromoCodeCreateController($scope, $state, PromoCodesApi, _, outputErrors, toastsApi, tableEngine) {
    var vm = this;

    vm.translate_key = 'AdminPromoCodes';
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('promo_codes');
    vm.promoCode = {
      promo_code: '',
      tracker: null
    };

    vm.back = function() {
      $state.go('admin_promo_codes');
    };

    vm.createPromoCode = function() {
      vm.createPromoCodeForm.$setSubmitted();

      if (vm.createPromoCodeForm.$invalid) {
        return;
      }

      return PromoCodesApi.createPromoCode(vm.promoCode).then(
        function() {
          vm.promoCode.promo_code = '';
          vm.createPromoCodeForm.$setPristine();
          vm.table.pagination();
          toastsApi.toastSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    PromoCodesApi.getTrackers().then(
      function(response) {
        vm.trackersList = response.data.list_trackers;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('admin_settings_profile', {
        url: '/admin/settings_profile',
        templateUrl: 'app/admin/profile_settings/partials/settings.html',
        controller: 'AdminProfileSettingsController',
        controllerAs: 'profile_admin',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.profilecontroller.edit'])
        }
      })
      .state('admin_settings_profile.main', {
        url: '/main',
        views: {
          'content@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/main/partials/main.html',
            controller: 'AdminProfileMainController',
            controllerAs: 'profileMain'
          },
          'buttons@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/partials/buttons.html'
          }
        }
      })
      .state('admin_settings_profile.email', {
        url: '/email',
        views: {
          'content@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/email/partials/email.html',
            controller: 'AdminProfileEmailController',
            controllerAs: 'profileEmail'
          },
          'buttons@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/partials/buttons.html'
          }
        }
      })
      .state('admin_settings_profile.password', {
        url: '/password',
        views: {
          'content@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/password/partials/password.html',
            controller: 'AdminProfilePasswordController',
            controllerAs: 'profilePassword'
          },
          'buttons@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/partials/buttons.html'
          }
        }
      })
      .state('admin_settings_profile.confirmation_email', {
        url: '/confirmation_email/:token',
        views: {
          'content@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/confirmation_email/partials/confirmation_email.html',
            controller: 'AdminProfileConfirmationEmailController',
            controllerAs: 'profileConfirmEmail'
          },
          'buttons@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/partials/buttons.html'
          }
        }
      })
      .state('admin_settings_profile.two_factor_authentication', {
        url: '/two_factor_auth',
        views: {
          'content@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/two_factor_authentication/partials/two_factor_authentication.html',
            controller: 'AdminProfileTwoFactorAuthController',
            controllerAs: 'profileTwoFactorAuth'
          },
          'buttons@admin_settings_profile': {
            templateUrl: 'app/admin/profile_settings/partials/buttons.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.profilecontroller.two_factor_auth'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminProfileSettingsController', AdminProfileSettingsController);

  AdminProfileSettingsController.$inject = ['$scope', 'tabsApi', 'permissionsManager'];

  function AdminProfileSettingsController($scope, tabsApi, permissionsManager) {
    var vm = this;

    vm.translate_key = 'AdminProfileSettings';
    vm.twoFactorAuth = permissionsManager.checkPermission('api2.admin.profilecontroller.two_factor_auth');

    vm.tabs = tabsApi.init({
      name: 'admin_profile',
      translateKey: vm.translate_key,
      list: [
        {
          name: 'main',
          shortcode: 'main.tab_name',
          state: 'admin_settings_profile.main'
        },
        {
          name: 'email',
          shortcode: 'email.tab_name',
          state: 'admin_settings_profile.email'
        },
        {
          name: 'password',
          shortcode: 'password.tab_name',
          state: 'admin_settings_profile.password'
        },
        {
          name: 'confirmation_email',
          shortcode: 'confirmation_email.tab_name',
          state: 'admin_settings_profile.confirmation_email'
        },
        {
          name: 'two_factor_authentication',
          shortcode: 'two_factor_authentication.tab_name',
          state: 'admin_settings_profile.two_factor_authentication',
          hide: !vm.twoFactorAuth
        }
      ]
    });

    $scope.$on('$destroy', function() {
      vm.tabs.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        profile_settings: [
          {
            tabs: [
              {
                main: ['tab_name||main.tab_name', 'name||main.name', 'skype||main.skype']
              },
              {
                email: [
                  'tab_name||email.tab_name',
                  'current_email||email.current_email',
                  'unconfirmed_email||email.unconfirmed_email',
                  'current_password||email.current_password'
                ]
              },
              {
                password: [
                  'tab_name||password.tab_name',
                  'password||password.password',
                  'password_confirmation||password.password_confirmation',
                  'current_password||password.current_password'
                ]
              },
              {
                confirmation_email: ['tab_name||confirmation_email.tab_name', 'token||confirmation_email.token']
              },
              {
                two_factor_authentication: [
                  'tab_name||two_factor_authentication.tab_name',
                  'mfa_required_notice||two_factor_authentication.mfa_required_notice',
                  'current_password||two_factor_authentication.current_password',
                  'secret_value||two_factor_authentication.secret_value',
                  'enter_mfa_code_for_disable||two_factor_authentication.enter_mfa_code_for_disable',
                  'enter_mfa_code_for_enable||two_factor_authentication.enter_mfa_code_for_enable',
                  'two_factor_auth_enabled||two_factor_authentication.two_factor_auth_enabled',
                  'two_factor_auth_disabled||two_factor_authentication.two_factor_auth_disabled'
                ]
              }
            ]
          },
          'main_title||profile_settings.main_title',
          'save||profile_settings.save',
          'back||profile_settings.back'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminProfileSettings', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('personal', {
        url: '/personal',
        templateUrl: 'app/admin/personal/partials/personal.html',
        controller: 'AdminPersonalController',
        controllerAs: 'personal',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.personalscontroller.show'])
        }
      })
      .state('personal.edit', {
        url: '/edit/:personalId',
        templateUrl: 'app/admin/personal/partials/edit_profile.html',
        controller: 'AdminPersonalEditController',
        controllerAs: 'editCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.personalscontroller.edit'])
        }
      })
      .state('personal.create', {
        url: '/create',
        templateUrl: 'app/admin/personal/partials/create_profile.html',
        controller: 'AdminPersonalCreateController',
        controllerAs: 'createCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.personalscontroller.create'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPersonalEditController', AdminPersonalEditController);

  AdminPersonalEditController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$mdTranslate',
    'AdminPersonalApi',
    '$mdDialog',
    '_',
    'outputErrors',
    'User',
    '$rootScope',
    'permissionsManager',
    'tableEngine',
    'toastsApi'
  ];

  function AdminPersonalEditController(
    $scope,
    $state,
    $stateParams,
    $mdTranslate,
    AdminPersonalApi,
    $mdDialog,
    _,
    outputErrors,
    User,
    $rootScope,
    permissionsManager,
    tableEngine,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPersonal';
    vm.roles_list = [];
    vm.personal = {};
    vm.table = tableEngine.getTableByName('personal');
    vm.errors = outputErrors.createNew();
    vm.twoFactorEnabled = false;
    vm.mayResetAuth = permissionsManager.checkPermission('api2.admin.personalscontroller.clear_google_secret');

    vm.back = function() {
      $state.go('personal');
    };

    vm.save = function(ev) {
      var title = $mdTranslate.instant(vm.translate_key, 'edit_modal.title'),
        message = $mdTranslate.instant(vm.translate_key, 'edit_modal.message'),
        confirm = $mdDialog.confirm();

      confirm.title(title);
      confirm.textContent(message);
      confirm.targetEvent(ev);
      confirm.ok($mdTranslate.instant(vm.translate_key, 'edit_modal.answer_yes'));
      confirm.cancel($mdTranslate.instant(vm.translate_key, 'edit_modal.answer_no'));

      $mdDialog.show(confirm).then(function() {
        AdminPersonalApi.update(vm.personal).then(
          function() {
            vm.table.pagination();
            if (vm.personal.id === User.getUserProperty('id')) {
              permissionsManager.initPermissions();
            }
            vm.resetTwoFactorAuth(vm.personal.id);
            toastsApi.toastEditSuccess();
          },
          function(response) {
            vm.errors.inputErrors(response.data.errors);
          }
        );
      });
    };

    vm.resetTwoFactorAuth = function(adminId) {
      if (!vm.mayResetAuth || !vm.twoFactorEnabled || vm.personal.mfa_enabled) {
        return;
      }

      AdminPersonalApi.resetTwoFactorAuth(adminId).then(
        function() {
          vm.twoFactorEnabled = false;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    if ($stateParams.personalId) {
      AdminPersonalApi.show($stateParams.personalId).then(
        function(response) {
          vm.personal = response.data.personal;
          vm.roles_list = response.data.roles;
          vm.twoFactorEnabled = vm.personal.mfa_enabled;
        },
        function() {
          toastsApi.toastError();
        }
      );
    }
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPersonalCreateController', AdminPersonalCreateController);

  AdminPersonalCreateController.$inject = [
    '$scope',
    '$state',
    'AdminPersonalApi',
    '_',
    'outputErrors',
    'tableEngine',
    'toastsApi'
  ];

  function AdminPersonalCreateController($scope, $state, AdminPersonalApi, _, outputErrors, tableEngine, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminPersonal';
    vm.roles_list = [];
    vm.personal = {
      name: '',
      email: '',
      role_id: null
    };
    vm.table = tableEngine.getTableByName('personal');
    vm.errors = outputErrors.createNew();

    vm.back = function() {
      $state.go('personal');
    };

    vm.create = function() {
      return AdminPersonalApi.create(vm.personal).then(
        function() {
          vm.table.pagination();
          vm.personal = {};
          vm.createAdminForm.$setPristine();
          toastsApi.toastCreateSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    AdminPersonalApi.list_roles().then(function(response) {
      vm.roles_list = response.data.roles;
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPersonalController', AdminPersonalController);

  AdminPersonalController.$inject = [
    '$scope',
    '$state',
    '$mdTranslate',
    'AdminPersonalApi',
    'tableEngine',
    '$mdDialog',
    '_',
    'outputErrors',
    'toastsApi'
  ];

  function AdminPersonalController(
    $scope,
    $state,
    $mdTranslate,
    AdminPersonalApi,
    tableEngine,
    $mdDialog,
    _,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPersonal';
    vm.errors = outputErrors.createNew();

    vm.editProfile = function(pers) {
      $state.go('personal.edit', {personalId: pers.id});
    };

    vm.addAdmin = function() {
      $state.go('personal.create');
    };

    vm.removePersonal = function(pers, ev) {
      var title = $mdTranslate.instant(vm.translate_key, 'remove_modal.title', {name: pers.name}),
        message = $mdTranslate.instant(vm.translate_key, 'remove_modal.message', {name: pers.name}),
        confirm = $mdDialog.confirm();

      confirm.title(title);
      confirm.textContent(message);
      confirm.targetEvent(ev);
      confirm.ok($mdTranslate.instant(vm.translate_key, 'remove_modal.answer_yes'));
      confirm.cancel($mdTranslate.instant(vm.translate_key, 'remove_modal.answer_no'));

      $mdDialog.show(confirm).then(function() {
        AdminPersonalApi.destroy(pers.id).then(
          function() {
            vm.table.removeListItem();
            toastsApi.toastRemoveSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.changeStatus = function(pers, ev) {
      var title = $mdTranslate.instant(vm.translate_key, pers.banned ? 'status.title_banned' : 'status.title_unbanned'),
        message = $mdTranslate.instant(
          vm.translate_key,
          pers.banned ? 'status.message_banned' : 'status.message_unbanned',
          {name: pers.name}
        ),
        confirm = $mdDialog.confirm();

      confirm.title(title);
      confirm.textContent(message);
      confirm.targetEvent(ev);
      confirm.ok($mdTranslate.instant(vm.translate_key, 'status.answer_yes'));
      confirm.cancel($mdTranslate.instant(vm.translate_key, 'status.answer_no'));

      $mdDialog.show(confirm).then(function() {
        AdminPersonalApi.banned(pers.id).then(
          function(response) {
            vm.table.updateListItemById(
              {
                banned: !pers.banned,
                ban_status_name: response.data.personal.ban_status_name,
                ban_status_chaged_at: response.data.personal.ban_status_chaged_at
              },
              pers.id
            );
            toastsApi.toastEditSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.table = tableEngine.init({
      api: AdminPersonalApi,
      name: 'personal',
      mobile: {
        defaultColumns: ['name']
      },
      buttons: {
        url: 'app/admin/personal/partials/table.html',
        methods: {
          editProfile: vm.editProfile,
          changeStatus: vm.changeStatus,
          removePersonal: vm.removePersonal
        }
      }
    });

    AdminPersonalApi.index().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        personal: {
          list_personal: [
            'header||list_personal.header',
            'add_admin||list_personal.add_admin',
            {
              create_admin: [
                'main_title||create_admin.main_title',
                'name||create_admin.name',
                'email||create_admin.email',
                'role||create_admin.role',
                'create||create_admin.create',
                'back||create_admin.back'
              ]
            },
            {
              edit_admin: [
                'main_title||edit_admin.main_title',
                'name||edit_admin.name',
                'email||edit_admin.email',
                'skype||edit_admin.skype',
                'role||edit_admin.role',
                'status||edit_admin.status',
                'lock||edit_admin.lock',
                'unlock||edit_admin.unlock',
                'status_description||edit_admin.status_description',
                'save||edit_admin.save',
                'back||edit_admin.back',
                'mfa_enabled_label||edit_admin.mfa_enabled_label',
                'mfa_enabled||edit_admin.mfa_enabled',
                'mfa_disabled||edit_admin.mfa_disabled',
                {
                  modal_window: [
                    'title||edit_modal.title',
                    'message||edit_modal.message',
                    'answer_yes||edit_modal.answer_yes',
                    'answer_no||edit_modal.answer_no'
                  ]
                }
              ]
            },
            {
              modal_window: {
                remove: [
                  'title||remove_modal.title',
                  'message||remove_modal.message',
                  'answer_yes||remove_modal.answer_yes',
                  'answer_no||remove_modal.answer_no'
                ],
                status: [
                  'title_banned||status.title_banned',
                  'title_unbanned||status.title_unbanned',
                  'message_banned||status.message_banned',
                  'message_unbanned||status.message_unbanned',
                  'answer_yes||status.answer_yes',
                  'answer_no||status.answer_no'
                ]
              }
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminPersonal', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('ViewPlayerController', ViewPlayerController);

  ViewPlayerController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'AdminPlayersApi',
    'historyChanges',
    '_',
    'outputErrors',
    'toastsApi',
    'tabsApi',
    'permissionsManager'
  ];

  function ViewPlayerController(
    $scope,
    $state,
    $stateParams,
    AdminPlayersApi,
    historyChanges,
    _,
    outputErrors,
    toastsApi,
    tabsApi,
    permissionsManager
  ) {
    var vm = this;

    vm.translate_key = 'AdminPlayers';
    vm.errors = outputErrors.createNew();
    vm.trackersPermission = 'api2.admin.observingofdailystatisticsplayerscontroller.trackers';
    vm.mayChangeTracker = permissionsManager.checkPermission(vm.trackersPermission);
    vm.profileColumnsLocale = '';
    vm.playerProfileColumns = [];
    vm.fieldsToExclude = [
      'serial_id',
      'history_of_players_changes',
      'date_of_first_deposit',
      'date_of_last_activity',
      'registrationdate'
    ];

    vm.optionsChange = {
      typeChanges: 'players',
      edit_state: 'players.history_changes_players',
      params: {
        playerId: $stateParams.playerId
      },
      permissions: {
        change: vm.trackersPermission,
        remove: vm.trackersPermission
      }
    };

    vm.excludeFields = function(list) {
      return _.filter(list, function(field) {
        return !_.contains(vm.fieldsToExclude, field);
      });
    };

    vm.getProfileColumnsLocale = function() {
      $scope.players.getLocaleKey().then(function(value) {
        vm.profileColumnsLocale = value;
      });
    };

    vm.initialize = function() {
      AdminPlayersApi.show($stateParams.playerId).then(
        function(response) {
          var data = response.data;

          vm.player = data.player;
          vm.optionsChange.playerId = data.player.cid;
          vm.player.date = vm.player.date ? vm.player.date : null;
          vm.playerProfileColumns = vm.excludeFields(data.columns_view_order);
        },
        function() {
          toastsApi.toastError();
        }
      );

      vm.showPlayerTrackers();
    };

    vm.showPlayerTrackers = function() {
      if (vm.mayChangeTracker) {
        AdminPlayersApi.showPlayerTrackers($stateParams.playerId).then(
          function(response) {
            var data = response.data;

            vm.historyChanges = data;
          },
          function() {
            toastsApi.toastError();
          }
        );
      }
    };

    vm.back = function() {
      $state.go('players');
    };

    vm.saveTrackerSettings = function() {
      return historyChanges.create(vm.player).then(
        function(response) {
          vm.historyChanges = response.data.history_of_players_changes;
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.tabs = tabsApi.init({
      name: 'view_player',
      translateKey: vm.translate_key,
      list: [
        {
          name: 'main_data',
          shortcode: 'main_data.tab_name',
          state: 'players.view_player.main_data'
        },
        {
          name: 'activities_player',
          shortcode: 'activities_player.tab_name',
          state: 'players.view_player.activities_player'
        },
        {
          name: 'tracker_player',
          shortcode: 'tracker_player.tab_name',
          state: 'players.view_player.tracker_player',
          hide: !vm.mayChangeTracker
        }
      ]
    });

    vm.tabs.setTabSubmitFunction('tracker_player', vm.saveTrackerSettings);
    vm.initialize();
    vm.getProfileColumnsLocale();

    $scope.$on('$changeMerchantSuccess', function() {
      vm.initialize();
    });

    $scope.$on('$destroy', function() {
      vm.tabs.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('players', {
        url: '/players',
        templateUrl: 'app/admin/players/partials/players.html',
        controller: 'AdminPlayersController',
        controllerAs: 'players',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.observingofdailystatisticsplayerscontroller.show'])
        }
      })
      .state('players.view_player', {
        url: '/view_player/:playerId',
        templateUrl: 'app/admin/players/partials/view_player.html',
        controller: 'ViewPlayerController',
        controllerAs: 'view_player'
      })
      .state('players.view_player.main_data', {
        url: '/main_data',
        views: {
          'content@players.view_player': {
            templateUrl: 'app/admin/players/partials/main_player_info.html'
          }
        }
      })
      .state('players.view_player.activities_player', {
        url: '/player_activity',
        views: {
          'content@players.view_player': {
            templateUrl: 'app/admin/players/partials/player_activity.html'
          }
        }
      })
      .state('players.view_player.tracker_player', {
        url: '/tracker_player',
        views: {
          'content@players.view_player': {
            templateUrl: 'app/admin/players/partials/player_trackers.html'
          },
          'buttons@players.view_player': {
            templateUrl: 'app/admin/players/partials/buttons.html'
          },
          'history_changes@players.view_player': {
            templateUrl: 'app/admin/players/partials/history_changes.html'
          }
        }
      })
      .state('players.history_changes_players', {
        url: '/view_player/change_history/:playerId/:id',
        templateUrl: 'app/admin/players/partials/history_changes_players.html',
        controller: 'HistoryChangesPlayersController',
        controllerAs: 'history',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.observingofdailystatisticsplayerscontroller.trackers'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPlayersController', AdminPlayersController);

  AdminPlayersController.$inject = [
    '$scope',
    '$state',
    'AdminPlayersApi',
    '$q',
    '_',
    'outputErrors',
    'tableEngine',
    'toastsApi',
    'downloadReport'
  ];

  function AdminPlayersController(
    $scope,
    $state,
    AdminPlayersApi,
    $q,
    _,
    outputErrors,
    tableEngine,
    toastsApi,
    downloadReport
  ) {
    var vm = this;

    vm.translate_key = 'AdminPlayers';
    vm.errors = outputErrors.createNew();
    vm.getLocaleKeyDefer = $q.defer();

    vm.view_player = function(player) {
      $state.go('players.view_player.main_data', {playerId: player.cid});
    };

    vm.edit_player = function(player) {
      $state.go('players.view_player.tracker_player', {playerId: player.cid});
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: AdminPlayersApi.downloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.getLocaleKey = function() {
      return vm.getLocaleKeyDefer.promise;
    };

    vm.table = tableEngine.init({
      api: AdminPlayersApi,
      name: 'players',
      mobile: {
        defaultColumns: ['cid']
      },
      buttons: {
        url: 'app/admin/players/partials/table.html',
        methods: {
          view_player: vm.view_player,
          edit_player: vm.edit_player
        }
      }
    });

    AdminPlayersApi.list_players().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);

        vm.downloadFormats = data.separators_for_format;

        vm.getLocaleKeyDefer.resolve(opts.locale_key);
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        players: {
          list_players: [
            'header||list_players.header',
            'download_report||list_players.download_report',
            {
              view_player: [
                'header||view_player.header',
                'back||view_player.back',
                'save||view_player.save',
                {
                  tabs: [
                    {
                      main_data: [
                        'tab_name||main_data.tab_name',
                        'cid||main_data.cid',
                        'username||main_data.username',
                        'registrationcountry||main_data.registrationcountry',
                        'country_ip||main_data.country_ip'
                      ]
                    },
                    {
                      activities_player: [
                        'tab_name||activities_player.tab_name',
                        'registrationdate||activities_player.registrationdate',
                        'date_of_first_deposit||activities_player.date_of_first_deposit',
                        'date_of_last_activity||activities_player.date_of_last_activity'
                      ]
                    },
                    {
                      tracker_player: [
                        'tab_name||tracker_player.tab_name',
                        'serial_id||tracker_player.serial_id',
                        'anid||tracker_player.anid',
                        'incoming_url||tracker_player.incoming_url',
                        'date||tracker_player.date',
                        {
                          history_changes_players: [
                            {
                              edit: [
                                'header||history_changes_players.header',
                                'save||history_changes_players.save',
                                'back||history_changes_players.back',
                                {
                                  form: [
                                    'serial_id||history_changes_players.serial_id',
                                    'anid||history_changes_players.anid',
                                    'date||history_changes_players.date'
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminPlayers', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('HistoryChangesPlayersController', HistoryChangesPlayersController);

  HistoryChangesPlayersController.$inject = [
    '$state',
    '$stateParams',
    'historyChanges',
    '_',
    'outputErrors',
    'toastsApi'
  ];

  function HistoryChangesPlayersController($state, $stateParams, historyChanges, _, outputErrors, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminPlayers';
    vm.history_item_id = $stateParams.id;
    vm.errors = outputErrors.createNew();

    historyChanges.edit($stateParams.playerId, vm.history_item_id).then(
      function(response) {
        vm.history_item = response.data.history_of_players_change;
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.save_history = function() {
      historyChanges.update($stateParams.playerId, vm.history_item).then(
        function() {
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.back = function() {
      $state.go('players.view_player.tracker_player', {playerId: $stateParams.playerId});
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('permissions_manager', {
      url: '/admin/permissions_manager',
      templateUrl: 'app/admin/permissions_manager/partials/permissions_manager.html',
      controller: 'AdminPermissionsManagerController',
      controllerAs: 'permissions_manager',
      data: {
        permissions: permissionsStateAccess.init(['api2.admin.rolescontroller.create'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('permissionsTemplate', permissionsTemplate);

  permissionsTemplate.$inject = [];

  function permissionsTemplate() {
    return {
      restrict: 'A',
      template:
        '<div class="tree-node tree-node-content angular-tree-handle" layout-xs="row" layout-align-xs="space-between center">' +
        '<a class="btn btn-success btn-xs" ng-click="toggle()" ng-if="isFolder">' +
        '<i class="fa fa-folder folder-icon"></i>' +
        '</a>' +
        '<label class="label" ng-bind="::key"></label>' +
        // '<md-button ng-if="!isFolder" class="md-fab md-primary primary-tooltip">' +
        //   '<md-tooltip md-direction="top">Description</md-tooltip>' +
        //   '<i class="fa fa-question-circle"></i>' +
        // '</md-button>' +
        '<span class="input-box" ng-if="!isFolder">' +
        '<span class="toggle-permission" ng-click="permissions_manager.change_permission(this, url, value, parent_url, key)" ng-class="{\'enabled\': value, \'disabled\': !value}">' +
        '<span class="toggle-bar"></span>' +
        '<span class="toggle-thumb-container">' +
        '<span class="toggle-thumb"></span>' +
        '</span>' +
        '</span>' +
        '</span>' +
        '<span class="btn-save-wrap" ng-if="permissions_manager[permissions_manager.namespace][permissions_manager.choosed_role.name].controll_names.indexOf(url) !== -1">' +
        '<button class="btn btn-success" ng-click="permissions_manager.save_permission(url, value, key)">' +
        '<i class="fa fa-check"></i>' +
        '</button>' +
        '<button class="btn btn-danger" ng-click="permissions_manager.remove_permission_changes(url, value, key)">' +
        '<i class="fa fa-ban"></i>' +
        '</button>' +
        '</span>' +
        '</div>' +
        '<ol class="permission-list angular-tree-hidden">' +
        '<li permissions-template ng-repeat="(key, value) in value | filterByObjectProperties" data-collapsed="true"></li>' +
        '</ol>',
      controller: function($scope, $element) {
        $scope.collapsed = true;
        $scope.isFolder = angular.isObject($scope.value);
        $scope.parent_url = $scope.$parent.url || $scope.$parent.key;
        $scope.url = $scope.parent_url ? $scope.parent_url + '.' + $scope.key : $scope.key;

        if (!$scope.isFolder) {
          $scope.change_value = function() {
            $scope.value = !$scope.value;
          };
        }

        $scope.toggle = function() {
          var icon = $element[0].querySelector('.folder-icon'),
            list = $element[0].querySelector('.permission-list');

          if (icon) {
            if (icon.classList.contains('fa-folder')) {
              icon.classList.remove('fa-folder');
              icon.classList.add('fa-folder-open');
            } else {
              icon.classList.remove('fa-folder-open');
              icon.classList.add('fa-folder');
            }
          }

          if (list) {
            list.classList.toggle('angular-tree-hidden');
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminPermissionsManagerController', AdminPermissionsManagerController);

  AdminPermissionsManagerController.$inject = [
    '$scope',
    '$rootScope',
    '_',
    'AdminPermissionsApi',
    'permissionsManager',
    '$q',
    'outputErrors',
    'AdminSettingsFieldsApi',
    'tabsApi',
    'toastsApi'
  ];

  function AdminPermissionsManagerController(
    $scope,
    $rootScope,
    _,
    AdminPermissionsApi,
    permissionsManager,
    $q,
    outputErrors,
    AdminSettingsFieldsApi,
    tabsApi,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPermissionsManager';
    vm.namespace_list = ['admin', 'affiliate'];
    vm.fields_permission = 'api2.admin.projectsettingscontroller.report_fields';
    vm.namespace = '';
    vm.fields_list = [];
    vm.basic_list = {};
    vm.list = {};
    vm.roles_list = [];
    vm.roles_for_copy = [];
    vm.choosed_role = {};
    vm.errors = outputErrors.createNew();
    vm.getValue = getValue;
    vm.setValue = setValue;
    vm.prepare_list = prepare_list;
    vm.string_to_hash = string_to_hash;
    vm.get_actions = get_actions;
    vm.deleteEmptyObjects = deleteEmptyObjects;
    vm.constantsList = {};
    vm.copyRoleId = null;

    vm.fieldsSelectOptions = {
      translate_key: vm.translate_key,
      shortcode: 'columns_for_permit.{{part}}',
      search_in_translate: true,
      find_in_key: false
    };

    vm.rolesSelectOptions = {
      selective_translate: true,
      find_in_key: false,
      prop_for_value: 'name'
    };

    function UserPermissions(role) {
      this.role_name = role;
      this.permissions_list = {};
      this.changes_list = {};
      this.controll_names = [];
    }

    UserPermissions.prototype.change_list = function(newList) {
      this.permissions_list = _.keys(this.permissions_list).length
        ? this.permissions_list
        : angular.merge({}, vm.basic_list, newList);
      vm.list = this.permissions_list;
    };

    UserPermissions.prototype.change_permission = function(permissionObj) {
      angular.merge(this.permissions_list, permissionObj || this.changes_list);
    };

    UserPermissions.prototype.check_changes = function(parentLink, key, obj) {
      var list = this.changes_list,
        isKey = _.has(list[parentLink], key)
          ? _.omit(list[parentLink], key)
          : _.defaults(list[parentLink], obj[parentLink]);

      list[parentLink] = _.has(list, parentLink) ? isKey : obj[parentLink];

      this.controll_btn_save(list[parentLink], parentLink);
      this.changes_list = vm.deleteEmptyObjects(list);
    };

    UserPermissions.prototype.controll_btn_save = function(obj, link) {
      var list = this.controll_names;

      this.controll_names =
        _.contains(list, link) && !_.keys(obj).length ? _.without(list, link) : _.union(list, [link]);
    };

    UserPermissions.prototype.remove_changes = function(strLink) {
      _.each(
        this.changes_list[strLink],
        _.bind(function(value, key) {
          this.permissions_list[strLink][key] = !value;
          this.check_changes(strLink, key);
        }, this)
      );
    };

    UserPermissions.prototype.clear = function(strLink) {
      this.changes_list = _.omit(this.changes_list, strLink);
      this.controll_btn_save({}, strLink);
    };

    AdminPermissionsApi.getConstants().then(
      function(response) {
        vm.constantsList = response.data.list_report_fields;
        vm.enableNamespaceSelect = true;
      },
      function() {
        vm.enableNamespaceSelect = true;
        toastsApi.toastError();
      }
    );

    vm.create_instans = function(name) {
      return new UserPermissions(name);
    };

    vm.check_fields_permission = function() {
      return permissionsManager.checkPermission(vm.fields_permission);
    };

    vm.showCheckboxList = function() {
      return vm.fields_list.length && vm.choosed_role.id && vm.fieldsSettingsType;
    };

    vm.showSelect = function() {
      return vm.choosed_role.id;
    };

    vm.changeFieldsSettingsType = function() {
      vm.get_fields();
    };

    vm.get_fields = function() {
      if (vm.check_fields_permission()) {
        AdminSettingsFieldsApi.get_fields(vm.choosed_role.id, 'role', vm.fieldsSettingsType).then(
          function(response) {
            vm.fields_list = response.data.fields;
            vm.columnsNamespace = response.data.locale_key + '.';
          },
          function() {
            toastsApi.toastError();
          }
        );
      }
    };

    vm.change_namespace = function() {
      if (!vm[vm.namespace]) {
        vm[vm.namespace] = {};
      }

      vm.choosed_role = {};
      vm.list = {};
      vm.basic_list = {};
      vm.roles_list = [];
      vm.roles_for_copy = [];
      vm.fields_list = [];
      vm.permissions_block = false;
      vm.fieldsSettingsList = vm.constantsList[vm.namespace];
      vm.fieldsSettingsType = _.first(vm.fieldsSettingsList);
      vm.copyRoleId = null;

      AdminPermissionsApi.getUserRolesAndTree(vm.namespace).then(
        function(response) {
          var data = response.data;
          vm.roles_list = data.list;
          vm.roles_for_copy = _.union(
            [{id: null, translate_key: vm.translate_key, shortcode: 'create.empty_role'}],
            data.list
          );
          vm.basic_list = vm.prepare_list(data.permissions_tree, null, false);
          if (vm.roles_list) {
            _.each(vm.roles_list, function(value) {
              if (!vm[vm.namespace][value.name]) {
                vm[vm.namespace][value.name] = vm.create_instans(value.name);
              }
            });
          }
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.change_role = function() {
      vm.get_fields();

      AdminPermissionsApi.getPermissionsTreeByRole(vm.choosed_role.id).then(
        function(response) {
          var data = response.data,
            permissions_list = vm.prepare_list(data.permissions_tree, null, true);

          vm[vm.namespace][vm.choosed_role.name].change_list(permissions_list);
          vm.permissions_block = true;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.change_permission = function(scope, strLink, value, parentLink, key) {
      var obj = vm.string_to_hash(strLink, !value);
      vm[vm.namespace][vm.choosed_role.name].check_changes(parentLink, key, obj);
      vm[vm.namespace][vm.choosed_role.name].change_permission(obj);
      scope.change_value();
    };

    vm.remove_permission_changes = function(strLink, value, key) {
      vm[vm.namespace][vm.choosed_role.name].remove_changes(strLink, value, key);
    };

    vm.save_permission = function(strLink, value, key) {
      var result = {
        actions: vm.get_actions(value),
        controller_name: key
      };

      AdminPermissionsApi.savePermission(vm.choosed_role.id, result).then(
        function() {
          vm[vm.namespace][vm.choosed_role.name].clear(strLink);
          permissionsManager.initPermissions().then(function() {
            vm.get_fields();
          });
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.save_fields = function(fieldName, tabId, direction, searchTerm) {
      var deferred = $q.defer(),
        params = {};

      if (searchTerm && fieldName === 'all') {
        params.search = searchTerm;
        params.value = fieldName;
      } else {
        params.value = fieldName;
      }
      params.id = vm.choosed_role.id;
      params.namespace = 'role';
      params.report_name = vm.fieldsSettingsType;

      if (!vm.check_fields_permission()) {
        deferred.reject();
      } else {
        AdminSettingsFieldsApi.save_fields(params, direction).then(
          function() {
            deferred.resolve();
          },
          function() {
            deferred.reject();
            toastsApi.toastError();
          }
        );
      }

      return deferred.promise;
    };

    vm.createRoleSuccess = function(data) {
      $scope.$broadcast('$changeTab', {name: 'edit'});
      vm.roles_list.push(data.role);
      vm.roles_for_copy.push(data.role);
      vm.choosed_role = data.role;
      vm[vm.namespace][vm.choosed_role.name] = vm.create_instans(vm.choosed_role.name);
      vm.new_role = '';
      vm.copyRoleId = null;
      vm.addRoleForm.$setPristine();
      vm.change_role();
      toastsApi.toastCreateSuccess();
    };

    vm.createRoleApply = function(result) {
      return AdminPermissionsApi.saveRole(result).then(
        function(response) {
          vm.createRoleSuccess(response.data);
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError();
        }
      );
    };

    vm.createRole = function() {
      if (vm.addRoleForm.$invalid) {
        return $q.when();
      }

      var role_name = vm.new_role.replace(/\s+/g, '_'),
        result = {
          name: role_name,
          namespace: vm.namespace
        };

      if (vm.copyRoleId) {
        result.copy_permissions_from_role_id = vm.copyRoleId;
      }

      vm.createRoleApply(result);
    };

    vm.tabs = tabsApi.init({
      name: 'permissions',
      translateKey: vm.translate_key,
      nav: false,
      list: [
        {
          name: 'create',
          shortcode: 'create.tab_name',
          content: 'app/admin/permissions_manager/partials/create.html'
        },
        {
          name: 'edit',
          shortcode: 'edit.tab_name',
          content: 'app/admin/permissions_manager/partials/edit.html'
        }
      ]
    });

    vm.tabs.setTabSubmitFunction('create', vm.createRole);

    $scope.$on('$destroy', function() {
      vm.tabs.destroy();
    });

    function getValue(obj, str) {
      var ifString = _.isString(str) && str.length ? str.split('.') : [],
        arr = _.isArray(str) ? str : ifString,
        v = arr.length ? obj[arr.shift()] : obj;

      return arr.length ? getValue(v, arr) : v;
    }

    function setValue(obj, str, value) {
      var ifString = _.isString(str) && str.length ? str.split('.') : [],
        arr = _.isArray(str) ? str : ifString,
        prop = arr.shift();

      if (arr.length) {
        obj[prop] = _.isObject(obj[prop]) && !_.isArray(obj[prop]) ? obj[prop] : {};
        setValue(obj[prop], arr, value);
      } else {
        obj[prop] = value;
      }
    }

    function prepare_list(hash_list, result, endValue) {
      var _result = result || {};
      _.each(hash_list, function(value, key) {
        if (value !== '') {
          _result[key] = {};
          if (_.isArray(value)) {
            _.each(value, function(v) {
              if (_.isObject(v)) {
                prepare_list(v, _result[key], endValue);
              } else {
                _result[key][v] = endValue;
              }
            });
          } else {
            prepare_list(value, _result[key], endValue);
          }
        } else {
          _result[key] = endValue;
        }
      });
      return _result;
    }

    function string_to_hash(str, value) {
      var h = {},
        p_s = str.split('.'),
        key = p_s.pop();

      h[key] = value;

      if (!key) {
        return value;
      } else {
        return string_to_hash(p_s.join('.'), h);
      }
    }

    function get_actions(hash_list, result) {
      var _result = result || [];
      _.each(hash_list, function(value, key) {
        if (!_.isArray(value) && _.isObject(value)) {
          _.each(value, function(v, k) {
            if (!_.isObject(v)) {
              if (v) {
                _result.push(k);
              }
            } else {
              prepare_list(v, _result);
            }
          });
        } else {
          if (value) {
            _result.push(key);
          }
        }
      });
      return _result;
    }

    function deleteEmptyObjects(obj) {
      var _obj = obj || {};
      _.each(_obj, function(value, key) {
        if (_.isObject(value) && !_.isArray(value)) {
          deleteEmptyObjects(value);
          if (!_.keys(value).length) {
            delete _obj[key];
          }
        }
      });
      return _obj;
    }
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        settings: {
          permissions_manager: [
            {
              tabs: [
                {
                  create: [
                    'tab_name||create.tab_name',
                    'role_name||create.role_name',
                    'copy_role||create.copy_role',
                    'empty_role||create.empty_role',
                    'add_role||create.add_role'
                  ],
                  edit: [
                    'tab_name||edit.tab_name',
                    'fields_settings_type||create.fields_settings_type',
                    'choose_role||edit.choose_role',
                    'sub_header_permissions||edit.sub_header_permissions',
                    'sub_header_fields||edit.sub_header_fields',
                    {
                      columns_for_permit: [
                        'reports||columns_for_permit.report',
                        'creative_reports||columns_for_permit.creative_report',
                        'subaffiliate_reports||columns_for_permit.subaffiliate_report',
                        'affiliate_bookkeeping_months||columns_for_permit.list_affiliate_month_payments',
                        'affiliate_bookkeeping_one_month||columns_for_permit.list_affiliate_month_payments_in_one_month',
                        'dashboard_chart_by_day||columns_for_permit.chart_by_day',
                        'dashboard_chart_by_month||columns_for_permit.chart_by_month'
                      ]
                    }
                  ]
                }
              ]
            },
            'page_title||permissions_manager.page_title',
            'namespace||permissions_manager.namespace'
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminPermissionsManager', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('hasPermission', hasPermission);

  hasPermission.$inject = ['permissionsManager', '_'];

  function hasPermission(permissionsManager, _) {
    return {
      restrict: 'A',
      require: 'permission',
      link: function(scope, element, attrs, ctrl) {
        var permissions = ctrl.only,
          elem = element,
          id = Math.random()
            .toFixed(8)
            .slice(2),
          replace_elem =
            '<span id="permission_' +
            id +
            '" class="ng-hide"><!-- permission ' +
            attrs.permissionOnly +
            ' is not available --></span>',
          result;

        permission_controll();

        scope.$on('permissions_is_updated', permission_controll);

        function permission_controll() {
          if (_.isArray(permissions)) {
            var result_array = _.filter(permissions, function(value) {
              return permissionsManager.checkPermission(value);
            });
            result = !!result_array.length;
          } else {
            result = permissionsManager.checkPermission(permissions);
          }
          update_element(result);
        }

        function update_element(result) {
          var el;
          if (result) {
            el = document.getElementById('permission_' + id);
            if (el) {
              el.parentNode.replaceChild(elem[0], el);
              elem[0].classList.remove('ng-hide');
            }
          } else {
            if (elem[0].parentNode) {
              elem[0].outerHTML = replace_elem;
            }
          }
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminWithdrawalViewController', AdminWithdrawalViewController);

  AdminWithdrawalViewController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'AdminWithdrawalsApi',
    'BalanceService',
    '_',
    'toastsApi'
  ];

  function AdminWithdrawalViewController(
    $scope,
    $state,
    $stateParams,
    AdminWithdrawalsApi,
    BalanceService,
    _,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPendingWithdrawals';
    vm.withdrawal = {created_at: null};
    vm.paymentSystems = BalanceService.getPaymentSystems();
    vm.allFields = BalanceService.getAllFields();

    vm.back = function() {
      $state.go('^');
    };

    vm.approveWithdrawal = function($event) {
      $scope.$emit('applyApproveWithdrawal', {id: $stateParams.withdrawalId, event: $event});
    };

    vm.denialWithdrawal = function($event) {
      $scope.$emit('applyDenialWithdrawal', {id: $stateParams.withdrawalId, event: $event});
    };

    vm.findFieldShortcode = function(fieldName) {
      var system = _.find(vm.paymentSystems, {type: vm.withdrawal.payment_system_name});

      return BalanceService.findFieldShortcode(system, fieldName);
    };

    AdminWithdrawalsApi.viewPendingWithdrawal($stateParams.withdrawalId).then(
      function(response) {
        vm.withdrawal = response.data[0];
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('admin_pending_withdrawals', {
        url: '/pending_withdrawals',
        templateUrl: 'app/admin/pending_withdrawals/partials/pending_withdrawals.html',
        controller: 'AdminPendingWithdrawalsController',
        controllerAs: 'withdrawalsCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.affiliatecashoutscontroller.pending_withdrawals_show'])
        }
      })
      .state('admin_pending_withdrawals.view_withdrawal', {
        url: '/view/:withdrawalId',
        templateUrl: 'app/admin/pending_withdrawals/partials/view_withdrawal.html',
        controller: 'AdminWithdrawalViewController',
        controllerAs: 'viewCtrl'
      });
  });
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminPendingWithdrawalsController', AdminPendingWithdrawalsController);

  AdminPendingWithdrawalsController.$inject = [
    '$scope',
    '$state',
    'tableEngine',
    'AdminWithdrawalsApi',
    '_',
    '$mdDialog',
    '$mdTranslate',
    'toastsApi',
    'defaultDateFormat',
    'downloadReport'
  ];

  function AdminPendingWithdrawalsController(
    $scope,
    $state,
    tableEngine,
    AdminWithdrawalsApi,
    _,
    $mdDialog,
    $mdTranslate,
    toastsApi,
    defaultDateFormat,
    downloadReport
  ) {
    var vm = this;

    vm.translate_key = 'AdminPendingWithdrawals';
    vm.deniedWithdrawal = {};
    vm.reasonForDenial = '';

    vm.clearReasonForDenial = function() {
      vm.deniedWithdrawal = {};
      vm.reasonForDenial = '';
    };

    vm.applyDialog = function(shortcodePart, ev) {
      var confirm = $mdDialog
        .confirm()
        .clickOutsideToClose(true)
        .title($mdTranslate.instant(vm.translate_key, shortcodePart + '.title'))
        .textContent($mdTranslate.instant(vm.translate_key, shortcodePart + '.message'))
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, shortcodePart + '.ok'))
        .cancel($mdTranslate.instant(vm.translate_key, shortcodePart + '.cancel'));

      return $mdDialog.show(confirm);
    };

    vm.applyReasonDialog = function(ev) {
      return $mdDialog.show({
        scope: $scope,
        preserveScope: true,
        templateUrl: 'app/admin/pending_withdrawals/partials/reason_for_denial.html',
        parent: angular.element(document.body),
        targetEvent: ev
      });
    };

    vm.cancelDialog = function() {
      $mdDialog.cancel();
    };

    vm.backToTable = function() {
      if ($state.current.name === 'admin_pending_withdrawals.view_withdrawal') {
        $state.go('admin_pending_withdrawals');
      }
    };

    vm.approveWithdrawal = function(withdrawal, ev) {
      vm.applyDialog('approve_withdrawal', ev).then(function() {
        vm.applyApproveWithdrawal(withdrawal);
      });
    };

    vm.pointReasonForDenial = function(withdrawal, ev) {
      vm.deniedWithdrawal = withdrawal;
      vm.applyReasonDialog(ev).then(vm.clearReasonForDenial, vm.clearReasonForDenial);
    };

    vm.denialWithdrawal = function(withdrawal, ev) {
      vm.applyDialog('denial_withdrawal', ev).then(function() {
        vm.pointReasonForDenial(withdrawal, ev);
      });
    };

    vm.applyDenialWithdrawal = function() {
      AdminWithdrawalsApi.denialWithdrawal(vm.deniedWithdrawal.id, vm.reasonForDenial).then(
        function() {
          vm.cancelDialog();
          vm.table.pagination().then(vm.backToTable);
          toastsApi.toastSuccess();
        },
        function() {
          vm.cancelDialog();
          toastsApi.toastError();
        }
      );
    };

    vm.applyApproveWithdrawal = function(withdrawal) {
      AdminWithdrawalsApi.approveWithdrawal(withdrawal.id).then(
        function() {
          vm.table.pagination().then(vm.backToTable);
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.viewWithdrawal = function(withdrawal) {
      $state.go('.view_withdrawal', {withdrawalId: withdrawal.id});
    };

    vm.applyDownloadReport = function(data) {
      return AdminWithdrawalsApi.downloadReport(data, vm.table.getSegmentId());
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.tableFiliterColumns = [
      {
        name: 'merchant_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'created_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'updated_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'creator_id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'creator_type',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_email',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_username',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'amount',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'state',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_details',
        type: 'checkbox',
        display: true,
        empty: true
      }
    ];

    vm.table = tableEngine.init({
      api: AdminWithdrawalsApi,
      api_method: 'pendingPagination',
      name: 'pending_withdrawals',
      mobile: {
        defaultColumns: ['affiliate_id']
      },
      buttons: {
        url: 'app/admin/pending_withdrawals/partials/table.html',
        methods: {
          approveWithdrawal: vm.approveWithdrawal,
          denialWithdrawal: vm.denialWithdrawal,
          viewWithdrawal: vm.viewWithdrawal
        }
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/admin/affiliate_cashouts/pending_cashouts',
        actionForFilter: 'list',
        byMerchant: true,
        filterName: 'pending_cashout'
      }
    });

    AdminWithdrawalsApi.getPendingWithdrawals().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            table_id: data.report_id,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('amount', {separateNumber: true});
        vm.table.addOptionsToColumn('created_at', {format: defaultDateFormat + ' HH:mm:ss'});

        vm.downloadFormats = data.separators_for_format;
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('applyApproveWithdrawal', function(ev, data) {
      vm.approveWithdrawal({id: data.id}, data.event);
    });

    $scope.$on('applyDenialWithdrawal', function(ev, data) {
      vm.denialWithdrawal({id: data.id}, data.event);
    });

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.resetFilter();
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          pending_withdrawals: [
            'header||pending_withdrawals.header',
            'download_report_button||pending_withdrawals.download_report_button',
            {
              modal_windows: [
                {
                  approve_withdrawal: [
                    'title||approve_withdrawal.title',
                    'question||approve_withdrawal.message',
                    'approve||approve_withdrawal.ok',
                    'cancel||approve_withdrawal.cancel'
                  ]
                },
                {
                  denial_withdrawal: [
                    'title||denial_withdrawal.title',
                    'question||denial_withdrawal.message',
                    'proceed||denial_withdrawal.ok',
                    'cancel||denial_withdrawal.cancel'
                  ]
                },
                {
                  reason_for_denial: [
                    'title||reason_for_denial.title',
                    'reason||reason_for_denial.message',
                    'proceed||reason_for_denial.ok',
                    'cancel||reason_for_denial.cancel'
                  ]
                }
              ]
            },
            {
              view_withdrawal: [
                'header||view_withdrawal.header',
                'back||view_withdrawal.back',
                'approve_withdrawal_button||view_withdrawal.approve_withdrawal_button',
                'denial_withdrawal_button||view_withdrawal.denial_withdrawal_button',
                {
                  form: [
                    'merchant_name||view_withdrawal.form.merchant_name',
                    'affiliate_email||view_withdrawal.form.payment_method_email',
                    'affiliate_id||view_withdrawal.form.affiliate_id',
                    'affiliate_username||view_withdrawal.form.payment_method_username',
                    'amount||view_withdrawal.form.amount',
                    'payment_method_type||view_withdrawal.form.payment_method_type',
                    'payment_method_wallet||view_withdrawal.form.payment_method_wallet',
                    'payment_method_bank_name||view_withdrawal.form.payment_method_bank_name',
                    'payment_method_bic||view_withdrawal.form.payment_method_bic',
                    'payment_method_card_expiration_date||view_withdrawal.form.payment_method_card_expiration_date',
                    'payment_method_card_number||view_withdrawal.form.payment_method_card_number',
                    'payment_method_iban||view_withdrawal.form.payment_method_iban',
                    'payment_method_phone_number||view_withdrawal.form.payment_method_phone_number',
                    'created_at||view_withdrawal.form.created_at',
                    'payment_system_name||view_withdrawal.form.payment_system_name',
                    'creator_type||view_withdrawal.form.creator_type',
                    'creator_id||view_withdrawal.form.creator_id',
                    'creator_email||view_withdrawal.form.creator_email'
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminPendingWithdrawals', list);
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminUnconfirmedPartnersController', AdminUnconfirmedPartnersController);

  AdminUnconfirmedPartnersController.$inject = [
    '$scope',
    '$location',
    'UnconfirmedPartnersApi',
    'tableEngine',
    '_',
    '$mdDialog',
    'toastsApi',
    '$interpolate'
  ];

  function AdminUnconfirmedPartnersController(
    $scope,
    $location,
    UnconfirmedPartnersApi,
    tableEngine,
    _,
    $mdDialog,
    toastsApi,
    $interpolate
  ) {
    var vm = this;

    vm.translate_key = 'AdminUnconfirmedPartners';
    vm.domain = $location.host();
    vm.protocol = $location.protocol();
    vm.urlForConfirmingEmail = '{{protocol}}://{{domain}}/#/registration/confirmation/{{token}}';
    vm.resultUrl = '';

    UnconfirmedPartnersApi.getAffiliates().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.sendEmailAgain = function(affiliate) {
      UnconfirmedPartnersApi.sendEmailAgain(affiliate.id).then(
        function() {
          toastsApi.toastSuccess({
            translate_key: vm.translate_key,
            shortcode: 'partners_with_unconfirmed_emails.email_has_sent'
          });
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getPartnerToken = function(affiliate, ev) {
      UnconfirmedPartnersApi.getAffiliateToken(affiliate.id).then(
        function(response) {
          vm.resultUrl = $interpolate(vm.urlForConfirmingEmail)({
            protocol: vm.protocol,
            domain: vm.domain,
            token: response.data.token
          });

          $mdDialog.show({
            scope: $scope,
            preserveScope: true,
            templateUrl: 'app/admin/partners_with_unconfirmed_emails/partials/view_token.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
          });
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.closeModal = function() {
      $mdDialog.cancel();
    };

    vm.copySuccess = function() {
      toastsApi.toastCopySuccess();
      $mdDialog.hide();
    };

    vm.table = tableEngine.init({
      api: UnconfirmedPartnersApi,
      columns_namespace: 'columns_for_display_data.admin.affiliates.',
      name: 'unconfirmed_partners',
      mobile: {
        defaultColumns: ['email']
      },
      buttons: {
        url: 'app/admin/partners_with_unconfirmed_emails/partials/table.html',
        methods: {
          sendEmailAgain: vm.sendEmailAgain,
          getPartnerToken: vm.getPartnerToken
        }
      }
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('unconfirmed_partners', {
      url: '/partners_with_unconfirmed_emails',
      templateUrl: 'app/admin/partners_with_unconfirmed_emails/partials/unconfirmed_partners.html',
      controller: 'AdminUnconfirmedPartnersController',
      controllerAs: 'UnconfirmedCtrl',
      data: {
        permissions: permissionsStateAccess.init(['api2.admin.affiliatescontroller.unconfirmed_email'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          partners_with_unconfirmed_emails: [
            'header||partners_with_unconfirmed_emails.header',
            'email_has_sent||partners_with_unconfirmed_emails.email_has_sent',
            {
              modal_window: [
                'header||modal_window.header',
                'url_for_confirming_email||modal_window.url_for_confirming_email',
                'copy||modal_window.copy',
                'cancel||modal_window.cancel'
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminUnconfirmedPartners', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('orders', {
        url: '/request_history',
        templateUrl: 'app/admin/partners_request_history/partials/request_history.html',
        controller: 'PartnersRequestHistoryController',
        controllerAs: 'orders',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.affiliatescontroller.show'])
        }
      })
      .state('orders.profile', {
        url: '/profile/:partnerId',
        templateUrl: 'app/admin/partner/partials/profile.html',
        controller: 'AdminPartnerProfileController',
        controllerAs: 'partner_profile',
        params: {
          partnerId: '',
          parentTabState: 'orders.profile'
        },
        data: {
          parentState: 'orders',
          tableName: 'partners_request_history'
        }
      })
      .state('orders.profile.main_data', {
        url: '/general',
        views: {
          'content@orders.profile': {
            templateUrl: 'app/admin/partner/partials/main_data.html'
          },
          'buttons@orders.profile': {
            templateUrl: 'app/admin/partner/partials/buttons.html'
          }
        }
      })
      .state('orders.profile.contact_information', {
        url: '/contacts',
        views: {
          'content@orders.profile': {
            templateUrl: 'app/admin/partner/partials/contact_information.html'
          },
          'buttons@orders.profile': {
            templateUrl: 'app/admin/partner/partials/buttons.html'
          }
        }
      })
      .state('orders.profile.offer', {
        url: '/offer',
        views: {
          'content@orders.profile': {
            templateUrl: 'app/admin/partner/partials/offer.html'
          },
          'buttons@orders.profile': {
            templateUrl: 'app/admin/partner/partials/buttons.html'
          }
        }
      });
  });
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('PartnersRequestHistoryController', PartnersRequestHistoryController);

  PartnersRequestHistoryController.$inject = [
    '$scope',
    '$state',
    'partnersRequestHistoryApi',
    '$mdDialog',
    '$mdTranslate',
    'tableEngine',
    '_',
    'defaultDateFormat',
    'outputErrors',
    'toastsApi',
    'downloadReport'
  ];

  function PartnersRequestHistoryController(
    $scope,
    $state,
    partnersRequestHistoryApi,
    $mdDialog,
    $mdTranslate,
    tableEngine,
    _,
    defaultDateFormat,
    outputErrors,
    toastsApi,
    downloadReport
  ) {
    var vm = this;

    vm.translate_key = 'AdminRequestHistory';
    vm.errors = outputErrors.createNew();

    vm.back = function() {
      $state.go('orders');
    };

    vm.next = function(id) {
      $state.go('orders.profile.main_data', {partnerId: id});
    };

    vm.applyChangeStatus = function(partnerId) {
      partnersRequestHistoryApi.changeStatus(partnerId).then(
        function() {
          toastsApi.toastSuccess({
            translate_key: vm.translate_key,
            shortcode: 'request_history.toasts.status_has_been_changed'
          });
          vm.table.removeListItem();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getDialogParams = function(item, ev) {
      return $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'change_status_modal.title'))
        .textContent($mdTranslate.instant(vm.translate_key, 'change_status_modal.question', {email: item.email}))
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, 'change_status_modal.answer_yes'))
        .cancel($mdTranslate.instant(vm.translate_key, 'change_status_modal.answer_no'));
    };

    vm.changeStatus = function(item, ev) {
      var params = vm.getDialogParams(item, ev);

      $mdDialog.show(params).then(function() {
        vm.applyChangeStatus(item.id);
      });
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: partnersRequestHistoryApi.downloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.table = tableEngine.init({
      api: partnersRequestHistoryApi,
      name: 'partners_request_history',
      mobile: {
        defaultColumns: ['email']
      },
      buttons: {
        url: 'app/admin/partners_request_history/partials/table.html',
        methods: {
          next: vm.next,
          changeStatus: vm.changeStatus
        }
      }
    });

    partnersRequestHistoryApi.get_affiliate_history().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('decision_time', {format: defaultDateFormat + ' HH:mm'});
        vm.table.addOptionsToColumn('aasm_state', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: 'request_history.aasm_state.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });

        vm.downloadFormats = data.separators_for_format;
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          request_history: [
            'header||request_history.header',
            'download_report||request_history.download_report',
            {
              aasm_state: ['approved||request_history.aasm_state.approved', 'denied||request_history.aasm_state.denied']
            },
            {
              change_status_modal: [
                'title||change_status_modal.title',
                'question||change_status_modal.question',
                'answer_yes||change_status_modal.answer_yes',
                'answer_no||change_status_modal.answer_no'
              ]
            },
            {
              toasts: ['status_has_been_changed||request_history.toasts.status_has_been_changed']
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminRequestHistory', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('partners_balances', {
        url: '/partners_balances',
        templateUrl: 'app/admin/partners_balances/partials/partners_balances.html',
        controller: 'AdminPartnersBalancesController',
        controllerAs: 'balancesCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.affiliatecashoutscontroller.affiliates_balances_show'])
        }
      })
      .state('partners_balances.balance_adjustment', {
        url: '/adjustment/:partnerId',
        templateUrl: 'app/admin/partners_balances/partials/balance_adjustment.html',
        controller: 'AdminPartnersBalanceAdjustmentController',
        controllerAs: 'adjustmentCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.affiliatecashoutscontroller.affiliates_balances_edit'])
        }
      })
      .state('partners_balances.withdrawal_affiliate_balance', {
        url: '/withdrawal/:partnerId',
        templateUrl: 'app/affiliate/balance/partials/withdrawal.html',
        controller: 'AffiliateWithdrawalController',
        controllerAs: 'withdrawalCtrl',
        data: {
          balanceApi: 'AdminCashoutAffiliateBalanceApi',
          namespace: 'admin',
          tableName: 'partners_balances',
          withdrawalPermission: 'api2.admin.affiliatecashoutscontroller.withdrawals_create',
          permissions: permissionsStateAccess.init(['api2.admin.paymentsystemscontroller.show'])
        },
        resolve: {
          balance: [
            '$stateParams',
            '$q',
            'AdminCashoutAffiliateBalanceApi',
            'BalanceService',
            'permissionsManager',
            function($stateParams, $q, AdminCashoutAffiliateBalanceApi, BalanceService, permissionsManager) {
              if (
                !permissionsManager.checkPermission('api2.admin.affiliatecashoutscontroller.affiliates_balances_show')
              ) {
                return $q.resolve();
              }
              return AdminCashoutAffiliateBalanceApi.getBalance($stateParams.partnerId).then(function(response) {
                BalanceService.setAffiliateBalance(response.data[0].amount);
              });
            }
          ]
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPartnersBalancesController', AdminPartnersBalancesController);

  AdminPartnersBalancesController.$inject = [
    '$scope',
    '$state',
    'partnersBalancesApi',
    'tableEngine',
    'toastsApi',
    'downloadReport'
  ];

  function AdminPartnersBalancesController(
    $scope,
    $state,
    partnersBalancesApi,
    tableEngine,
    toastsApi,
    downloadReport
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartnersBalances';

    vm.balanceAdjustment = function(item) {
      $state.go('.balance_adjustment', {partnerId: item.id});
    };

    vm.goToPartnerBalance = function(item) {
      $state.go('.withdrawal_affiliate_balance', {partnerId: item.id});
    };

    vm.applyDownloadReport = function(data) {
      return partnersBalancesApi.downloadReport(data, vm.table.getSegmentId());
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.tableFiliterColumns = [
      {
        name: 'merchant_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'email',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'username',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'amount',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_details',
        type: 'checkbox',
        display: true,
        empty: true
      }
    ];

    vm.table = tableEngine.init({
      api: partnersBalancesApi,
      name: 'partners_balances',
      mobile: {
        defaultColumns: ['affiliate_id']
      },
      buttons: {
        url: 'app/admin/partners_balances/partials/table.html',
        methods: {
          balanceAdjustment: vm.balanceAdjustment,
          goToPartnerBalance: vm.goToPartnerBalance
        }
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/admin/affiliate_cashouts/balance',
        actionForFilter: 'list',
        filterName: 'balance'
      }
    });

    partnersBalancesApi.getPartnersBalances().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            table_id: data.report_id,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.downloadFormats = data.separators_for_format;

        vm.table.update(opts);
        vm.table.addOptionsToColumn('amount', {separateNumber: true});
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          partners_balances: [
            'header||partners_balances.header',
            'download_report_button||partners_balances.download_report_button',
            {
              balance_adjustment: [
                'header||balance_adjustment.header',
                'save||balance_adjustment.save',
                'back||balance_adjustment.back',
                {
                  form: [
                    'affiliate||balance_adjustment.form.affiliate',
                    'current_balance||balance_adjustment.form.current_balance',
                    'balance_amount||balance_adjustment.form.balance_amount',
                    'comment||balance_adjustment.form.comment'
                  ]
                },
                {
                  modal_window: [
                    'title||modal_window.title',
                    'question||modal_window.question',
                    'answer_yes||modal_window.answer_yes',
                    'answer_no||modal_window.answer_no'
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminPartnersBalances', list);
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminPartnersBalanceAdjustmentController', AdminPartnersBalanceAdjustmentController);

  AdminPartnersBalanceAdjustmentController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$mdDialog',
    '$mdTranslate',
    'partnersBalancesApi',
    'tableEngine',
    'outputErrors',
    'toastsApi'
  ];

  function AdminPartnersBalanceAdjustmentController(
    $scope,
    $state,
    $stateParams,
    $mdDialog,
    $mdTranslate,
    partnersBalancesApi,
    tableEngine,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminPartnersBalances';
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('partners_balances');
    vm.partnerBalance = {};
    vm.affiliate = '';

    vm.back = function() {
      $state.go('^');
    };

    vm.submitBalanceAdjustmentForm = function(partnerId, data) {
      partnersBalancesApi.saveBalanceAdjustment(partnerId, data).then(
        function(response) {
          vm.partnerBalance.amount = null;
          vm.partnerBalance.comment = '';
          vm.partnerBalance.current_balance = response.data.balance;

          vm.table.pagination();
          toastsApi.toastSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.openDialog = function(ev) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'modal_window.title'))
        .textContent($mdTranslate.instant(vm.translate_key, 'modal_window.question'))
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok($mdTranslate.instant(vm.translate_key, 'modal_window.answer_yes'))
        .cancel($mdTranslate.instant(vm.translate_key, 'modal_window.answer_no'));

      return $mdDialog.show(confirm);
    };

    vm.getData = function() {
      return {
        amount: vm.partnerBalance.amount,
        comment: vm.partnerBalance.comment
      };
    };

    vm.makeBalanceAdjustment = function(ev) {
      return vm.openDialog(ev).then(function() {
        vm.submitBalanceAdjustmentForm($stateParams.partnerId, vm.getData());
      });
    };

    vm.updateCurrentBalance = function(data) {
      vm.affiliate = data.id + ' - ' + data.email + ' - ' + data.username;
      vm.partnerBalance.current_balance = data.amount;
    };

    vm.getPartnerBalance = function() {
      partnersBalancesApi.getPartnerBalance($stateParams.partnerId).then(
        function(response) {
          vm.updateCurrentBalance(response.data[0]);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getPartnerBalance();

    $scope.$on('$changeMerchantSuccess', function() {
      vm.getPartnerBalance();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('partners', {
        url: '/partners',
        templateUrl: 'app/admin/partners/list/partials/partners.html',
        controller: 'AdminPartnersController',
        controllerAs: 'partners',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.affiliatescontroller.show'])
        }
      })
      .state('partners.profile', {
        url: '/profile/:partnerId',
        templateUrl: 'app/admin/partners/profile/partials/profile.html',
        controller: 'PartnerProfileSettingsController',
        controllerAs: 'parnterSetting'
      })
      .state('partners.profile.main_data', {
        url: '/general',
        views: {
          'content@partners.profile': {
            templateUrl: 'app/admin/partners/profile/partials/main_data.html'
          },
          'buttons@partners.profile': {
            templateUrl: 'app/admin/partners/profile/partials/buttons.html'
          }
        }
      })
      .state('partners.profile.contact_information', {
        url: '/contacts',
        views: {
          'content@partners.profile': {
            templateUrl: 'app/admin/partners/profile/partials/contact_information.html'
          },
          'buttons@partners.profile': {
            templateUrl: 'app/admin/partners/profile/partials/buttons.html'
          }
        }
      })
      .state('partners.profile.payment_information', {
        url: '/payment_details',
        views: {
          'content@partners.profile': {
            templateUrl: 'app/admin/partners/profile/partials/payment_information.html'
          },
          'buttons@partners.profile': {
            templateUrl: 'app/admin/partners/profile/partials/buttons.html'
          }
        }
      })
      .state('partners.profile.manual_subaffiliate', {
        url: '/subaffiliate',
        views: {
          'content@partners.profile': {
            templateUrl: 'app/admin/partners/profile/partials/manual_subaffiliate.html'
          },
          'buttons@partners.profile': {
            templateUrl: 'app/admin/partners/profile/partials/buttons.html'
          }
        }
      })
      .state('partners.settings', {
        abstract: true,
        url: '/settings/:partnerId',
        templateUrl: 'app/admin/partners/settings/partials/settings.html',
        controller: 'PartnerMainSettingsController',
        controllerAs: 'settingsCtrl'
      })
      .state('partners.settings.main_data', {
        url: '/main',
        views: {
          'content@partners.settings': {
            templateUrl: 'app/admin/partners/settings/main_data/partials/main_data.html',
            controller: 'PartnerMainDataController',
            controllerAs: 'mainDataCtrl'
          },
          'buttons@partners.settings': {
            templateUrl: 'app/admin/partners/settings/main_data/partials/buttons.html'
          }
        }
      })
      .state('partners.settings.trackers', {
        url: '/trackers',
        views: {
          'content@partners.settings': {
            templateUrl: 'app/admin/partners/settings/trackers/partials/trackers_list.html',
            controller: 'AdminPartnersTrackersListController',
            controllerAs: 'trackersList'
          },
          'buttons@partners.settings': {
            templateUrl: 'app/admin/partners/settings/trackers/partials/buttons.html'
          },
          'search@partners.settings': {
            templateUrl: 'app/admin/partners/settings/trackers/partials/search.html'
          },
          'pagination@partners.settings': {
            templateUrl: 'app/admin/partners/settings/trackers/partials/pagination.html'
          }
        }
      })
      .state('partners.settings.subaffiliate_condition', {
        url: '/subaffiliate_condition',
        views: {
          'content@partners.settings': {
            templateUrl: 'app/admin/partners/settings/subaffiliate_condition/partials/subaffiliate_condition.html',
            controller: 'PartnerSubaffiliateConditionController',
            controllerAs: 'conditionCtrl'
          },
          'buttons@partners.settings': {
            templateUrl: 'app/admin/partners/settings/subaffiliate_condition/partials/buttons.html'
          },
          'history_changes@partners.settings': {
            templateUrl: 'app/admin/partners/settings/subaffiliate_condition/partials/history_changes_view.html'
          }
        }
      })
      .state('partners.settings.fees', {
        url: '/fees',
        views: {
          'content@partners.settings': {
            templateUrl: 'app/admin/partners/settings/fees/partials/fees.html',
            controller: 'AdminPartnersFeesController',
            controllerAs: 'feesCtrl'
          },
          'buttons@partners.settings': {
            templateUrl: 'app/admin/partners/settings/fees/partials/buttons.html'
          },
          'history_changes@partners.settings': {
            templateUrl: 'app/admin/partners/settings/fees/partials/history_changes_view.html'
          }
        },
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.adminfeescontroller.edit'])
        }
      })
      .state('partners.settings.history_changes_partner_fees', {
        url: '/fees/:merchantId/history/:id',
        templateUrl: 'app/admin/partners/settings/fees/partials/history_changes.html',
        controller: 'HistoryChangesPartnerFeesController',
        controllerAs: 'history',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.adminfeescontroller.edit'])
        }
      })
      .state('partners.settings.history_changes_subaffiliate_condition', {
        url: '/subaffiliate_condition/:merchantId/history/:id',
        templateUrl: 'app/admin/partners/settings/subaffiliate_condition/partials/history_changes.html',
        controller: 'HistoryChangesConditionController',
        controllerAs: 'condition',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.historyofsubaffiliateschangescontroller.edit'])
        }
      })
      .state('partners.settings.settings_tracker_conditions', {
        url: '/trackers/:trackerCode/conditions',
        templateUrl: 'app/admin/partners/settings/trackers/partials/tracker_settings.html',
        controller: 'PartnerTrackerSettingsController',
        controllerAs: 'trackerCtrl'
      })
      .state('partners.settings.settings_tracker_conditions.history_changes_trackers', {
        url: '/:merchantId/history/:id',
        templateUrl: 'app/admin/partners/settings/trackers/partials/history_changes.html',
        controller: 'HistoryChangesTrackersController',
        controllerAs: 'history',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.historyoftrackerschangescontroller.edit'])
        }
      })
      .state('partners.webhooks', {
        url: '/webhooks/:partnerId',
        templateUrl: 'app/affiliate/webhooks/partials/webhooks.html',
        controller: 'WebhooksController',
        controllerAs: 'webhooksCtrl',
        data: {
          parentState: 'partners.webhooks',
          editState: 'partners.webhooks.settings',
          tabsList: ['registration', 'deposit', 'activity'],
          apiName: 'AdminWebhooksApi',
          admin: true,
          permissions: permissionsStateAccess.init(['api2.admin.affiliatescontroller.show'])
        }
      })
      .state('partners.webhooks.activity', {
        url: '/activity',
        data: {
          type: 'activity',
          admin: true,
          editState: 'partners.webhooks.settings',
          apiName: 'AdminWebhooksApi'
        },
        views: {
          'content@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/list.html',
            controller: 'WebhooksTabController',
            controllerAs: 'tabCtrl'
          },
          'search@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/search.html'
          },
          'pagination@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/pagination.html'
          }
        }
      })
      .state('partners.webhooks.registration', {
        url: '/registration',
        data: {
          type: 'registration',
          admin: true,
          editState: 'partners.webhooks.settings',
          apiName: 'AdminWebhooksApi'
        },
        views: {
          'content@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/list.html',
            controller: 'WebhooksTabController',
            controllerAs: 'tabCtrl'
          },
          'search@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/search.html'
          },
          'pagination@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/pagination.html'
          }
        }
      })
      .state('partners.webhooks.deposit', {
        url: '/deposit',
        data: {
          type: 'deposit',
          admin: true,
          editState: 'partners.webhooks.settings',
          apiName: 'AdminWebhooksApi'
        },
        views: {
          'content@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/list.html',
            controller: 'WebhooksTabController',
            controllerAs: 'tabCtrl'
          },
          'search@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/search.html'
          },
          'pagination@partners.webhooks': {
            templateUrl: 'app/affiliate/webhooks/partials/pagination.html'
          }
        }
      })
      .state('partners.webhooks.settings', {
        url: '/settings/:webhookType/:webhookId',
        templateUrl: 'app/affiliate/webhooks/partials/webhooks_settings.html',
        controller: 'WebhooksSettingsController',
        controllerAs: 'settingsCtrl',
        data: {
          admin: true,
          parentState: 'partners.webhooks',
          apiName: 'AdminWebhooksApi'
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          list_partners: [
            'header||list_partners.header',
            'download_report||list_partners.download_report',
            'change_manager||list_partners.change_manager',
            {
              modal_window: [
                'goal_unblock||modal_window.goal_unblock',
                'goal_block||modal_window.goal_block',
                'status_title||modal_window.status_title',
                'status_question||modal_window.status_question',
                'status_question_partner||modal_window.status_question_partner',
                'answer_yes||modal_window.answer_yes',
                'answer_no||modal_window.answer_no'
              ]
            },
            {
              change_manager_modals: [
                {
                  choose_manager: [
                    'title||choose_manager.title',
                    'choose_manager_label||choose_manager.choose_manager_label',
                    'ok||choose_manager.ok',
                    'cancel||choose_manager.cancel'
                  ]
                },
                {
                  confirm_action: [
                    'title||confirm_action.title',
                    'question||confirm_action.question',
                    'ok||confirm_action.ok',
                    'cancel||confirm_action.cancel'
                  ]
                }
              ]
            },
            {
              setting: [
                'header||setting.header',
                'save||setting.save',
                'back||setting.back',
                {
                  tabs: [
                    {
                      main_data: [
                        'tab_name||main_data.tab_name',
                        'name||main_data.form.name',
                        'surname||main_data.form.surname',
                        'username||main_data.form.username',
                        'birthday||main_data.form.birthday',
                        'site_url||main_data.form.site_url',
                        'role||main_data.form.role',
                        'affiliate_type||main_data.form.affiliate_type',
                        'chief||main_data.form.chief',
                        'about_affiliate||main_data.form.about_affiliate',
                        'admin_note||main_data.form.admin_note',
                        'mfa_enabled_label||main_data.form.mfa_enabled_label',
                        'mfa_enabled||main_data.form.mfa_enabled',
                        'mfa_disabled||main_data.form.mfa_disabled',
                        {
                          status: [
                            'header||main_data.status.header',
                            'banned||main_data.status.banned',
                            'unbanned||main_data.status.unbanned',
                            'owner||main_data.status.owner'
                          ]
                        }
                      ]
                    },
                    {
                      contact_information: [
                        'tab_name||contact_information.tab_name',
                        'email||contact_information.form.email',
                        'skype||contact_information.form.skype',
                        'telegram||contact_information.form.telegram',
                        'phone_number||contact_information.form.phone_number',
                        'agree_receive_emails||contact_information.form.agree_receive_emails'
                      ]
                    },
                    {
                      payment_information: ['tab_name||payment_information.tab_name']
                    },
                    {
                      manual_subaffiliate: [
                        'tab_name||manual_subaffiliate.tab_name',
                        'affiliate_invitation_id||manual_subaffiliate.form.affiliate_invitation_id',
                        'date||manual_subaffiliate.form.date'
                      ]
                    },
                    {
                      settings_fees: [
                        'tab_name||settings_fees.tab_name',
                        {
                          form: [
                            'percent||settings_fees.percent',
                            'count_from||settings_fees.count_from',
                            'date||settings_fees.date'
                          ]
                        },
                        {
                          history_changes: [
                            {
                              edit: [
                                'header||settings_fees.history_changes.header',
                                'save||settings_fees.history_changes.save',
                                'back||settings_fees.history_changes.back',
                                {
                                  form: [
                                    'percent||settings_fees.history_changes.percent',
                                    'count_from||settings_fees.history_changes.count_from',
                                    'date||settings_fees.history_changes.date'
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              tracker_settings: [
                'header||tracker_settings.header',
                'save||tracker_settings.save',
                'back||tracker_settings.back',
                {
                  tabs: [
                    {
                      main_data: [
                        'tab_name||settings_main_data.tab_name',
                        'max_count_trackers||settings_main_data.form.max_count_trackers',
                        'affiliate_condition||settings_main_data.form.affiliate_condition',
                        'current_count_tracker||settings_main_data.form.current_count_tracker'
                      ]
                    },
                    {
                      trackers: [
                        'tab_name||settings_trackers.tab_name',
                        'button_add_tracker||settings_trackers.button_add_tracker',
                        'edit_tracker_condition||settings_trackers.edit_tracker_condition',
                        'bulk_replacement_deals||settings_trackers.bulk_replacement_deals',
                        {
                          form: [
                            // 'tracker_code||settings_trackers.form.tracker_code',
                            'condition||settings_trackers.form.condition',
                            // 'description||settings_trackers.form.description',
                            'date||settings_trackers.form.date'
                          ]
                        },
                        {
                          modal_window: [
                            'title_for_add||create_tracker.title',
                            'description||create_tracker.description',
                            'answer_yes||create_tracker.button_save',
                            'answer_no||create_tracker.button_cancel',
                            {
                              edit_description: [
                                'title||edit_tracker.title',
                                'description||edit_tracker.description',
                                'answer_yes||edit_tracker.button_save',
                                'answer_no||edit_tracker.button_cancel'
                              ]
                            },
                            {
                              bulk_replacement_deals: [
                                'title||bulk_replacement_deals.title',
                                'cancel||bulk_replacement_deals.cancel',
                                'save||bulk_replacement_deals.save'
                              ]
                            }
                          ]
                        },
                        {
                          history_changes_trackers: [
                            {
                              edit: [
                                'header||history_changes_trackers.edit.header',
                                'save||history_changes_trackers.edit.save',
                                'back||history_changes_trackers.edit.back',
                                {
                                  form: [
                                    'tracker||history_changes_trackers.edit.form.tracker',
                                    'condition||history_changes_trackers.edit.form.condition',
                                    'date||history_changes_trackers.edit.form.date'
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      subaffiliate_condition: [
                        'tab_name||subaffiliate_condition.tab_name',
                        {
                          form: [
                            'subaffiliate_condition_id||subaffiliate_condition.form.subaffiliate_condition_id',
                            'date||subaffiliate_condition.form.date'
                          ]
                        },
                        {
                          history_changes: [
                            {
                              edit: [
                                'header||history_changes_subaffiliate_condition.edit.header',
                                'save||history_changes_subaffiliate_condition.edit.save',
                                'back||history_changes_subaffiliate_condition.edit.back',
                                {
                                  form: [
                                    'subaffiliate_condition_id||history_changes_subaffiliate_condition.edit.form.subaffiliate_condition_id',
                                    'date||history_changes_subaffiliate_condition.edit.form.date'
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              webhooks: [
                'header||admin.webhooks.header',
                'back||admin.webhooks.back',
                {
                  webhook_settings: ['header||admin.webhook_settings.header']
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminPartners', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminPartnerProfileController', AdminPartnerProfileController);

  AdminPartnerProfileController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'partnerApi',
    '$rootScope',
    '_',
    '$mdTranslate',
    '$mdDialog',
    'outputErrors',
    'localesApi',
    'moment',
    'toastsApi',
    'tableEngine',
    'permissionsManager',
    'tabsApi',
    'defaultDateFormat'
  ];

  function AdminPartnerProfileController(
    $scope,
    $state,
    $stateParams,
    partnerApi,
    $rootScope,
    _,
    $mdTranslate,
    $mdDialog,
    outputErrors,
    localesApi,
    moment,
    toastsApi,
    tableEngine,
    permissionsManager,
    tabsApi,
    defaultDateFormat
  ) {
    var vm = this;

    vm.translate_key = 'AdminViewPartner';
    vm.stateData = $state.current.data;
    vm.parentTabState = $stateParams.parentTabState;
    vm.status = {};
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName(vm.stateData.tableName);

    vm.back = function() {
      $state.go(vm.stateData.parentState);
    };

    vm.convertDate = function(value) {
      return moment(value).format('HH:mm ' + defaultDateFormat);
    };

    vm.accept = function(partnerId) {
      partnerApi.approved(partnerId).then(
        function() {
          vm.show_button = false;
          $rootScope.$broadcast('set_count_new_partners');
          vm.status.text = $mdTranslate.instant(vm.translate_key, 'view_partner.status_text_approved');
          vm.status['class'] = 'approved-status';
          vm.table.removeListItem().then(vm.back, vm.back);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.reject = function(partnerId) {
      partnerApi.reject(partnerId).then(
        function() {
          vm.show_button = false;
          $rootScope.$broadcast('set_count_new_partners');
          vm.status.text = $mdTranslate.instant(vm.translate_key, 'view_partner.status_text_denied');
          vm.status['class'] = 'denied-status';
          vm.table.removeListItem().then(vm.back, vm.back);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.openConfirmModal = function(ev, shortcodePart) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant('AdminNewPartners', shortcodePart + '_modal_window.title'))
        .textContent($mdTranslate.instant('AdminNewPartners', shortcodePart + '_modal_window.question'))
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok($mdTranslate.instant('AdminNewPartners', shortcodePart + '_modal_window.answer_yes'))
        .cancel($mdTranslate.instant('AdminNewPartners', shortcodePart + '_modal_window.answer_no'));

      return $mdDialog.show(confirm);
    };

    vm.rejectPartner = function(partner, ev) {
      return vm.openConfirmModal(ev, 'reject').then(function() {
        vm.reject(partner.id);
      });
    };

    vm.acceptPartner = function(partner, ev) {
      if (permissionsManager.checkPermission('api2.admin.affiliatescontroller.select_manager')) {
        $state.go('new_partners.accept_partner', {partnerId: partner.id});
      } else {
        return vm.openConfirmModal(ev, 'accept').then(function() {
          vm.accept(partner.id);
        });
      }
    };

    vm.tabs = tabsApi.init({
      name: 'view_partner',
      translateKey: vm.translate_key,
      list: [
        {
          name: 'main_data',
          shortcode: 'main_data.tab_name',
          state: vm.parentTabState + '.main_data'
        },
        {
          name: 'contact_information',
          shortcode: 'contact_information.tab_name',
          state: vm.parentTabState + '.contact_information'
        },
        {
          name: 'offer',
          shortcode: 'offer.tab_name',
          state: vm.parentTabState + '.offer'
        }
      ]
    });

    partnerApi.get_affiliate($stateParams.partnerId).then(
      function(response) {
        var m = moment(response.data.affiliate.birthday);
        vm.partner = response.data.affiliate;
        vm.partner.birthday = m.isValid() ? m._d : null;

        if (vm.partner.aasm_state === 'awaiting') {
          vm.show_button = true;
          vm.status.text = localesApi.get_locale(vm.translate_key, 'view_partner.status_text_awaiting');
        } else if (vm.partner.aasm_state === 'approved') {
          vm.status.text = localesApi.get_locale(vm.translate_key, 'view_partner.status_text_approved');
          vm.status['class'] = 'approved-status';
        } else if (vm.partner.aasm_state === 'denied') {
          vm.status.text = localesApi.get_locale(vm.translate_key, 'view_partner.status_text_denied');
          vm.status['class'] = 'denied-status';
        }
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.tabs.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          view_partner: [
            {
              tabs: [
                {
                  main_data: [
                    'tab_name||main_data.tab_name',
                    'name||main_data.form.name',
                    'surname||main_data.form.surname',
                    'username||main_data.form.username',
                    'birthday||main_data.form.birthday',
                    'site_url||main_data.form.site_url',
                    'status_label||main_data.form.status_label',
                    'status||main_data.form.status'
                  ]
                },
                {
                  contact_information: [
                    'tab_name||contact_information.tab_name',
                    'email||contact_information.form.email',
                    'skype||contact_information.form.skype',
                    'telegram||contact_information.form.telegram',
                    'phone_number||contact_information.form.phone_number',
                    'agree_receive_emails||contact_information.form.agree_receive_emails'
                  ]
                },
                {
                  offer: ['tab_name||offer.tab_name', 'about_affiliate||offer.form.about_affiliate']
                }
              ]
            },
            'button_view_parter||view_partner.button_view_parter',
            'button_back||view_partner.button_back',
            'header||view_partner.header',
            'status_text_approved||view_partner.status_text_approved',
            'status_text_denied||view_partner.status_text_denied',
            'status_text_awaiting||view_partner.status_text_awaiting'
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminViewPartner', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('new_partners', {
        url: '/new_partners',
        templateUrl: 'app/admin/new_partners/partials/new_partners.html',
        controller: 'NewPartnersController',
        controllerAs: 'new_partners',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.affiliatescontroller.pending_affiliates'])
        }
      })
      .state('new_partners.partner_view', {
        url: '/view/:partnerId',
        templateUrl: 'app/admin/partner/partials/profile.html',
        controller: 'AdminPartnerProfileController',
        controllerAs: 'partner_profile',
        params: {
          partnerId: '',
          parentTabState: 'new_partners.partner_view'
        },
        data: {
          parentState: 'new_partners',
          tableName: 'new_partners'
        }
      })
      .state('new_partners.partner_view.main_data', {
        url: '/general',
        views: {
          'content@new_partners.partner_view': {
            templateUrl: 'app/admin/partner/partials/main_data.html'
          },
          'buttons@new_partners.partner_view': {
            templateUrl: 'app/admin/partner/partials/buttons.html'
          }
        }
      })
      .state('new_partners.partner_view.contact_information', {
        url: '/contacts',
        views: {
          'content@new_partners.partner_view': {
            templateUrl: 'app/admin/partner/partials/contact_information.html'
          },
          'buttons@new_partners.partner_view': {
            templateUrl: 'app/admin/partner/partials/buttons.html'
          }
        }
      })
      .state('new_partners.partner_view.offer', {
        url: '/offer',
        views: {
          'content@new_partners.partner_view': {
            templateUrl: 'app/admin/partner/partials/offer.html'
          },
          'buttons@new_partners.partner_view': {
            templateUrl: 'app/admin/partner/partials/buttons.html'
          }
        }
      })
      .state('new_partners.accept_partner', {
        url: '/accept/:partnerId',
        templateUrl: 'app/admin/new_partners/partials/accept_partner.html',
        controller: 'AdminAcceptPartnerController',
        controllerAs: 'acceptCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.affiliatescontroller.select_manager'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('NewPartnersController', NewPartnersController);

  NewPartnersController.$inject = [
    '$scope',
    '$state',
    '$mdTranslate',
    'newPartnersApi',
    'tableEngine',
    '$q',
    '_',
    '$mdDialog',
    'partnerApi',
    'outputErrors',
    '$rootScope',
    'toastsApi',
    'permissionsManager',
    'downloadReport'
  ];

  function NewPartnersController(
    $scope,
    $state,
    $mdTranslate,
    newPartnersApi,
    tableEngine,
    $q,
    _,
    $mdDialog,
    partnerApi,
    outputErrors,
    $rootScope,
    toastsApi,
    permissionsManager,
    downloadReport
  ) {
    var vm = this;

    vm.affiliateStatusDefer = $q.defer();
    vm.translate_key = 'AdminNewPartners';
    vm.errors = outputErrors.createNew();

    newPartnersApi.new_affiliates().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);

        vm.downloadFormats = data.separators_for_format;
        vm.affiliateStatusDefer.resolve(vm.table.doesColumnExist('status'));
      },
      function() {
        toastsApi.toastError();
      }
    );

    // newPartnersApi.new_affiliates().then(
    //   function(response) {
    //     var data = response.data,
    //       opts = {
    //         locale_key: data.locale_key,
    //         columns: data.columns_for_display_data,
    //         list: data.list,
    //         total_pages: data.total_pages,
    //         total_entries: data.total_entries,
    //         start_row_num: data.start_row_num,
    //         end_row_num: data.end_row_num
    //       };

    //     vm.table.update(opts);

    //     vm.downloadFormats = data.separators_for_format;
    //     vm.affiliateStatusDefer.resolve(vm.table.doesColumnExist('status'));
    //   },
    //   function() {
    //     toastsApi.toastError();
    //   }
    // );

    vm.actionCallback = function() {
      vm.table.removeListItem();
      $rootScope.$broadcast('set_count_new_partners');
      toastsApi.toastSuccess();
    };

    vm.accept = function(partnerId) {
      partnerApi.approved(partnerId).then(
        function() {
          vm.actionCallback();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.reject = function(partnerId) {
      partnerApi.reject(partnerId).then(
        function() {
          vm.actionCallback();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.openConfirmModal = function(ev, shortcodePart) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, shortcodePart + '_modal_window.title'))
        .textContent($mdTranslate.instant(vm.translate_key, shortcodePart + '_modal_window.question'))
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok($mdTranslate.instant(vm.translate_key, shortcodePart + '_modal_window.answer_yes'))
        .cancel($mdTranslate.instant(vm.translate_key, shortcodePart + '_modal_window.answer_no'));

      return $mdDialog.show(confirm);
    };

    vm.rejectPartner = function(partner, ev) {
      return vm.openConfirmModal(ev, 'reject').then(function() {
        vm.reject(partner.id);
      });
    };

    vm.applyDownloadReport = function(data) {
      return newPartnersApi.downloadReport(data, vm.table.getSegmentId());
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.acceptPartner = function(partner, ev) {
      if (permissionsManager.checkPermission('api2.admin.affiliatescontroller.select_manager')) {
        $state.go('.accept_partner', {partnerId: partner.id});
      } else {
        return vm.openConfirmModal(ev, 'accept').then(function() {
          vm.accept(partner.id);
        });
      }
    };

    vm.viewPartner = function(partner) {
      $state.go('new_partners.partner_view.main_data', {partnerId: partner.id});
    };

    vm.table = tableEngine.init({
      api: newPartnersApi,
      name: 'new_partners',
      mobile: {
        defaultColumns: ['email']
      },
      buttons: {
        url: 'app/admin/new_partners/partials/table.html',
        methods: {
          rejectPartner: vm.rejectPartner,
          acceptPartner: vm.acceptPartner,
          viewPartner: vm.viewPartner
        }
      }
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });

    $scope.affiliateStatus = vm.affiliateStatusDefer.promise;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          new_partners: [
            'header||new_partners.header',
            'download_report||new_partners.download_report',
            'reject_btn||new_partners.reject_btn',
            'accept_btn||new_partners.accept_btn',
            {
              reject_partner: [
                {
                  modal_window: [
                    'title||reject_modal_window.title',
                    'question||reject_modal_window.question',
                    'answer_no||reject_modal_window.answer_no',
                    'answer_yes||reject_modal_window.answer_yes'
                  ]
                }
              ]
            },
            {
              accept_partner: [
                'header||accept_partner.header',
                'accept_btn||accept_partner.accept_btn',
                'button_back||accept_partner.button_back',
                'choose_manager||accept_partner.choose_manager',
                {
                  modal_window: [
                    'title||accept_modal_window.title',
                    'question||accept_modal_window.question',
                    'answer_no||accept_modal_window.answer_no',
                    'answer_yes||accept_modal_window.answer_yes'
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminNewPartners', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminAcceptPartnerController', AdminAcceptPartnerController);

  AdminAcceptPartnerController.$inject = [
    '$rootScope',
    '$window',
    '$stateParams',
    'newPartnersApi',
    'partnerApi',
    'tableEngine',
    'outputErrors',
    'toastsApi'
  ];

  function AdminAcceptPartnerController(
    $rootScope,
    $window,
    $stateParams,
    newPartnersApi,
    partnerApi,
    tableEngine,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminNewPartners';
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('new_partners');
    vm.managerId = null;

    vm.back = function() {
      $window.history.back();
    };

    vm.acceptPartner = function() {
      return partnerApi.acceptPartnerWithManager($stateParams.partnerId, vm.managerId).then(
        function() {
          toastsApi.toastSuccess();
          $rootScope.$broadcast('set_count_new_partners');
          vm.table.removeListItem().then(vm.back, vm.back);
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
          toastsApi.toastError();
        }
      );
    };

    newPartnersApi.getManagersList().then(
      function(response) {
        vm.managersList = response.data.list;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('mass_retag', {
      url: '/mass_retag',
      templateUrl: 'app/admin/mass_retag/partials/mass_retag.html',
      controller: 'AdminMassRetagController',
      controllerAs: 'massRetagCtrl',
      data: {
        permissions: permissionsStateAccess.init(['api2.admin.massretagcontroller.retag'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminMassRetagController', AdminMassRetagController);

  AdminMassRetagController.$inject = [
    '$scope',
    '$window',
    '$cookies',
    'AdminMassRetagApi',
    '_',
    'outputErrors',
    'toastsApi',
    'Preloader'
  ];

  function AdminMassRetagController(
    $scope,
    $window,
    $cookies,
    AdminMassRetagApi,
    _,
    outputErrors,
    toastsApi,
    Preloader
  ) {
    var vm = this;

    vm.translate_key = 'AdminMassRetag';
    vm.errors = outputErrors.createNew();
    vm.data = {};

    vm.fileOptions = {
      translate_key: vm.translate_key,
      input_name: 'original_file',
      accept:
        '.csv, text/plain, application/vnd.ms-excel, text/x-csv, application/csv, application/x-csv, text/csv, text/comma-separated-values, text/x-comma-separated-values',
      maxFileSize: 1,
      shortcodes: {
        label: 'mass_retag.choose_file',
        drop_file_here: 'mass_retag.drop_file_here'
      }
    };

    vm.getWindow = function() {
      return $window;
    };

    vm.modifyUrl = function(link) {
      var url = new URL(link);

      url.searchParams.append('authenticity_token', encodeURIComponent($cookies.get('XSRF-TOKEN-X')));

      return url.href;
    };

    vm.buildFormData = function(data) {
      var fd = new FormData();

      _.each(data, function(v, k) {
        fd.append(k, v);
      });

      return fd;
    };

    vm.updateFile = function(data, file) {
      vm.data.file = file;
    };

    vm.uploadFileSuccess = function(link) {
      toastsApi.toastSuccess();

      $scope.$broadcast('clearInputFile');
      vm.massRetagForm.$setUntouched();
      vm.massRetagForm.$setPristine();

      if (link) {
        var windowObj = vm.getWindow();

        windowObj.location.href = vm.modifyUrl(link);
      }
    };

    vm.uploadFileError = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }

      vm.errors.inputErrors(errors);
    };

    vm.massRetagPlayers = function() {
      vm.massRetagForm.$setSubmitted();

      if (vm.massRetagForm.$invalid || !vm.data.file) {
        return;
      }

      var fd = vm.buildFormData(vm.data);

      Preloader.openPreloaderForce();

      return AdminMassRetagApi.massRetagPlayers(fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined,
          'x-xsrf-token': $cookies.get('XSRF-TOKEN-X')
        }
      }).then(
        function(response) {
          Preloader.closePreloaderForce();
          vm.uploadFileSuccess(response.data && response.data.link);
        },
        function(response) {
          Preloader.closePreloaderForce();
          vm.uploadFileError(response.data && response.data.errors);
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        players: {
          mass_retag: [
            'header||mass_retag.header',
            'choose_file||mass_retag.choose_file',
            'drop_file_here||mass_retag.drop_file_here',
            'submit_button||mass_retag.submit_button'
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminMassRetag', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('imported_data', {
      url: '/imported_data',
      templateUrl: 'app/admin/imported_data/partials/imported_data.html',
      controller: 'AdminImportedDataController',
      controllerAs: 'importedDataCtrl',
      data: {
        permissions: permissionsStateAccess.init(['api2.admin.ftpfilescontroller.show'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        settings: {
          imported_data: [
            'header||imported_data.header',
            {
              aasm_state: [
                'downloaded||aasm_state.downloaded',
                'processing||aasm_state.processing',
                'parsed||aasm_state.parsed',
                'error||aasm_state.error'
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminImportedData', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminImportedDataController', AdminImportedDataController);

  AdminImportedDataController.$inject = [
    '$scope',
    '$window',
    'tableEngine',
    'importedDataApi',
    'toastsApi',
    '$cookies',
    'defaultDateFormat'
  ];

  function AdminImportedDataController(
    $scope,
    $window,
    tableEngine,
    importedDataApi,
    toastsApi,
    $cookies,
    defaultDateFormat
  ) {
    var vm = this;

    vm.translate_key = 'AdminImportedData';

    vm.download = function(item) {
      return importedDataApi.download(item.id).then(
        function(response) {
          if (response.data && response.data.link) {
            $window.location.href =
              response.data.link + ('?authenticity_token=' + encodeURIComponent($cookies.get('XSRF-TOKEN-X')));
          }
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.table = tableEngine.init({
      api: importedDataApi,
      name: 'imported_data',
      mobile: {
        defaultColumns: ['name']
      },
      buttons: {
        url: 'app/admin/imported_data/partials/table.html',
        methods: {
          download: vm.download
        }
      }
    });

    importedDataApi.list().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('created_at', {format: defaultDateFormat + ' HH:mm'});
        vm.table.addOptionsToColumn('aasm_state', {
          localizied: true,
          locales: {
            translate_key: vm.translate_key,
            shortcode: 'aasm_state.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('groups_list', {
        url: '/groups',
        templateUrl: 'app/admin/group_of_managers/partials/groups_list.html',
        controller: 'AdminGroupsListController',
        controllerAs: 'groupsCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.admingroupscontroller.edit'])
        }
      })
      .state('groups_list.edit', {
        url: '/edit/:groupId',
        templateUrl: 'app/admin/group_of_managers/partials/edit_group.html',
        controller: 'AdminGroupSettingsController',
        controllerAs: 'editCtrl'
      })
      .state('group_of_managers', {
        url: '/group_of_managers',
        templateUrl: 'app/admin/group_of_managers/partials/group_of_managers.html',
        controller: 'AdminGroupOfManagersController',
        controllerAs: 'groupCtrl',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.admingroupscontroller.show'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        groups_list: [
          'header||groups_list.header',
          'create_btn||groups_list.create_btn',
          {
            remove_modal: [
              'title||remove_modal.title',
              'delete_question||remove_modal.delete_question',
              'answer_yes||remove_modal.answer_yes',
              'answer_no||remove_modal.answer_no'
            ]
          },
          {
            group_settings: [
              'header||group_settings.header',
              'current_owner||group_settings.current_owner',
              'choose_owner||group_settings.choose_owner',
              'choose_participants||group_settings.choose_participants',
              'create_btn||group_settings.create_btn',
              'back||group_settings.back',
              {
                toasts: ['group_has_been_created||group_settings.group_has_been_created']
              }
            ]
          }
        ],
        group_of_managers: [
          'header||group_of_managers.header',
          'group_participants||group_of_managers.group_participants'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminGroupOfManagers', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminGroupsListController', AdminGroupsListController);

  AdminGroupsListController.$inject = [
    '$scope',
    '$state',
    '$mdTranslate',
    '$mdDialog',
    'tableEngine',
    'AdminGroupOfManagersApi',
    '_',
    'toastsApi'
  ];

  function AdminGroupsListController(
    $scope,
    $state,
    $mdTranslate,
    $mdDialog,
    tableEngine,
    AdminGroupOfManagersApi,
    _,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminGroupOfManagers';

    vm.getRemoveTranslate = function() {
      return {
        title: $mdTranslate.instant(vm.translate_key, 'remove_modal.title'),
        question: $mdTranslate.instant(vm.translate_key, 'remove_modal.delete_question'),
        ok: $mdTranslate.instant(vm.translate_key, 'remove_modal.answer_yes'),
        cancel: $mdTranslate.instant(vm.translate_key, 'remove_modal.answer_no')
      };
    };

    vm.openRemoveModal = function(data, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(data.title)
        .textContent(data.question)
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok(data.ok)
        .cancel(data.cancel);

      return $mdDialog.show(confirm);
    };

    vm.applyRemoveGroup = function(groupId) {
      AdminGroupOfManagersApi.deleteGroup(groupId).then(
        function() {
          vm.table.removeListItem();
          toastsApi.toastRemoveSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.removeGroup = function(item, ev) {
      var locales = vm.getRemoveTranslate();

      vm.openRemoveModal(locales, ev).then(function() {
        vm.applyRemoveGroup(item.id);
      });
    };

    vm.editGroup = function(item) {
      $state.go('.edit', {groupId: item.id});
    };

    vm.createGroup = function() {
      $state.go('.edit');
    };

    vm.table = tableEngine.init({
      api: AdminGroupOfManagersApi,
      name: 'admin_groups',
      mobile: {
        defaultColumns: ['admin_name']
      },
      buttons: {
        url: 'app/admin/group_of_managers/partials/table.html',
        methods: {
          edit: vm.editGroup,
          remove: vm.removeGroup
        }
      }
    });

    AdminGroupOfManagersApi.getGroupsList().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminGroupSettingsController', AdminGroupSettingsController);

  AdminGroupSettingsController.$inject = [
    '$state',
    '$stateParams',
    'AdminGroupOfManagersApi',
    '_',
    'toastsApi',
    '$q',
    'outputErrors',
    'tableEngine'
  ];

  function AdminGroupSettingsController(
    $state,
    $stateParams,
    AdminGroupOfManagersApi,
    _,
    toastsApi,
    $q,
    outputErrors,
    tableEngine
  ) {
    var vm = this;

    vm.translate_key = 'AdminGroupOfManagers';
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('admin_groups');
    vm.adminsList = [];
    vm.ownersList = [];
    vm.currentOwner = null;
    vm.group = null;
    vm.ownerId = null;
    vm.disableOwnerSelect = false;
    vm.disableCheckboxes = false;
    vm.showContent = false;

    vm.back = function() {
      $state.go('^');
    };

    vm.getOwnerById = function(id) {
      return _.pick(_.findWhere(vm.ownersList, {id: id}), 'name');
    };

    vm.saveFields = function(fieldName, tabId, direction, searchTerm) {
      var deferred = $q.defer(),
        params = {};

      if (searchTerm && fieldName === 'all') {
        params.search = searchTerm;
        params.value = fieldName;
      } else {
        params.value = fieldName;
      }

      vm.disableOwnerSelect = true;

      vm.saveParticipants(deferred, vm.group.id, params, direction);

      return deferred.promise;
    };

    vm.updateGroupCallback = function(groupId, ownerId, toastParams) {
      vm.currentOwner = vm.getOwnerById(ownerId);
      vm.getManagers(groupId);
      vm.getListAdminsForCreate();
      vm.table.pagination();
      toastsApi.toastSuccess(toastParams);
    };

    vm.saveParticipants = function(deferred, groupId, params, direction) {
      AdminGroupOfManagersApi.saveFields(groupId, params, direction).then(
        function() {
          deferred.resolve();
          vm.getListAdminsForCreate();
        },
        function() {
          vm.disableOwnerSelect = false;
          deferred.reject();
          toastsApi.toastError();
        }
      );
    };

    vm.createGroup = function() {
      AdminGroupOfManagersApi.createGroup(vm.ownerId).then(
        function(response) {
          vm.group = response.data.admin_group;

          vm.updateGroupCallback(vm.group.id, vm.ownerId, {
            translate_key: vm.translate_key,
            shortcode: 'group_of_managers.group_has_been_created'
          });

          $state.go('.', {groupId: vm.group.id}, {notify: false});
        },
        function(response) {
          toastsApi.toastError();
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.updateGroupOwner = function() {
      if (!_.has(vm.group, 'id')) {
        return;
      }

      vm.disableCheckboxes = true;

      AdminGroupOfManagersApi.updateGroupOwner(vm.group.id, vm.ownerId).then(
        function() {
          vm.updateGroupCallback(vm.group.id, vm.ownerId);
        },
        function() {
          vm.disableCheckboxes = false;
          toastsApi.toastError();
        }
      );
    };

    vm.getManagers = function(groupId) {
      AdminGroupOfManagersApi.getManagers(groupId).then(
        function(response) {
          vm.adminsList = response.data;
          vm.disableCheckboxes = false;
        },
        function() {
          vm.disableCheckboxes = false;
          toastsApi.toastError();
        }
      );
    };

    vm.getGroup = function(groupId) {
      AdminGroupOfManagersApi.getGroup(groupId).then(
        function(response) {
          vm.group = response.data.admin_group;
          vm.currentOwner = response.data.root_admin;
          vm.showContent = true;
          vm.getManagers(groupId);
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getListAdminsForCreate = function() {
      AdminGroupOfManagersApi.getListAdminsForCreate().then(
        function(response) {
          vm.ownersList = response.data;
          vm.disableOwnerSelect = false;
        },
        function() {
          toastsApi.toastError();
          vm.disableOwnerSelect = false;
        }
      );
    };

    vm.getListAdminsForCreate();

    if ($stateParams.groupId) {
      vm.getGroup($stateParams.groupId);
    } else {
      vm.showContent = true;
    }
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminGroupOfManagersController', AdminGroupOfManagersController);

  AdminGroupOfManagersController.$inject = ['AdminGroupOfManagersApi', 'toastsApi'];

  function AdminGroupOfManagersController(AdminGroupOfManagersApi, toastsApi) {
    var vm = this;

    vm.translate_key = 'AdminGroupOfManagers';
    vm.adminsList = [];
    vm.readonly = true;

    AdminGroupOfManagersApi.getAdminsOfGroup().then(
      function(response) {
        vm.adminsList = response.data;
      },
      function() {
        toastsApi.toastError();
      }
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('admin_export_data', {
      url: '/admin/export_data',
      templateUrl: 'app/components/export_data/partials/export_data.html',
      controller: 'ExportDataController',
      controllerAs: 'exportCtrl',
      data: {
        translateKey: 'AdminExportData',
        permissions: permissionsStateAccess.init(['api2.admin.csvreportscontroller.create'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        export: {
          export_data: [
            'header||export_data.header',
            'report_type||export_data.report_type',
            'report_period||export_data.report_period',
            'report_name||export_data.report_name',
            'create_report_btn||export_data.create_report_btn'
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminExportData', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('admin_download_csv', {
      url: '/admin/download_csv',
      templateUrl: 'app/components/download_csv/partials/list.html',
      controller: 'DownloadCsvController',
      controllerAs: 'downloadCtrl',
      data: {
        translateKey: 'AdminDownloadCsv',
        deletePermission: 'api2.admin.backgroundreportscontroller.edit',
        permissions: permissionsStateAccess.init(['api2.admin.backgroundreportscontroller.show'])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        export: {
          download_csv: [
            'header||download_csv.header',
            {
              remove_modal: [
                'title||remove_modal.title',
                'question||remove_modal.question',
                'answer_yes||remove_modal.answer_yes',
                'answer_no||remove_modal.answer_no'
              ]
            },
            {
              aasm_state: ['in_progress||aasm_state.in_progress', 'ready||aasm_state.ready']
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminDownloadCsv', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider) {
    $stateProvider.state('admin', {
      url: '/admin/dashboard',
      templateUrl: 'app/admin/dashboard/partials/dashboard.html',
      controller: 'AdminDashboardController',
      controllerAs: '$ctrl'
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        dashboard: [
          {
            stats_block: [
              'registration_count||stats_block.registration_count',
              'first_deposit_count||stats_block.first_deposit_count',
              'ngr||stats_block.ngr',
              'profit||stats_block.profit',
              'deposits||stats_block.deposits',
              'withdrawals||stats_block.withdrawals'
            ],
            top_partners: ['header||top_partners.header'],
            top_trackers: ['header||top_trackers.header'],
            top_players: ['header||top_players.header']
          },
          {
            periods: [
              'today||periods.today',
              'yesterday||periods.yesterday',
              'last_week||periods.last_week',
              'week||periods.week',
              'month||periods.month',
              'last_month||periods.last_month',
              'year||periods.year'
            ]
          },
          {
            charts: [
              {
                by_day: [
                  'header||charts.by_day.header',
                  'month||charts.by_day.month',
                  'last_month||charts.by_day.last_month'
                ]
              },
              {
                by_months: [
                  'header||charts.by_months.header',
                  'old_players||charts.by_months.old_players',
                  'new_players||charts.by_months.new_players'
                ]
              }
            ]
          },
          'last_update||dashboard.last_update',
          'button_reports||dashboard.button_reports'
        ]
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminDashboard', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminDashboardController', AdminDashboardController);

  AdminDashboardController.$inject = [
    '$scope',
    'tableEngine',
    'AdminDashboardApi',
    '_',
    'outputErrors',
    'toastsApi',
    'permissionsManager'
  ];

  function AdminDashboardController(
    $scope,
    tableEngine,
    AdminDashboardApi,
    _,
    outputErrors,
    toastsApi,
    permissionsManager
  ) {
    var vm = this,
      defaultPeriod = 'month';

    vm.translate_key = 'AdminDashboard';
    vm.tableNames = ['top_for_ngr', 'top_trackers', 'top_players'];
    vm.periods = ['today', 'yesterday', 'last_week', 'week', 'month', 'last_month', 'year'];
    vm.statsColumns = ['registration_count', 'first_deposit_count', 'ngr', 'profit', 'deposits', 'withdrawals'];
    vm.dashboardStats = null;
    vm.dashboardTops = null;
    vm.stats = null;
    vm.currentMerchant = null;
    vm.merchantsList = [];
    vm.currentPerionds = {stats: defaultPeriod};
    vm.errors = outputErrors.createNew();
    vm.updateTimePermission = permissionsManager.checkPermission('api2.admin.dashboardcontroller.last_update');
    vm.getStatsPermission = permissionsManager.checkPermission('api2.admin.dashboardcontroller.get_stats');
    vm.getChartsPermission = permissionsManager.checkPermission('api2.admin.dashboardcontroller.chart');
    vm.getTopsPermission = permissionsManager.checkPermission('api2.admin.dashboardcontroller.tops');

    vm.defaultTableColumns = {
      top_for_ngr: ['affiliate_username'],
      top_trackers: ['serial_id'],
      top_players: ['cid']
    };

    vm.chartOptions = {
      translate_key: vm.translate_key,
      namespace: 'admin',
      by_day_header_shortcode: 'charts.by_day.header',
      by_months_header_shortcode: 'charts.by_months.header'
    };

    vm.initTables = function() {
      _.each(vm.tableNames, function(v) {
        vm.currentPerionds[v] = defaultPeriod;
        vm[v] = tableEngine.init({
          api: AdminDashboardApi,
          name: 'dashboard_' + v,
          separate_numbers: true,
          sticky: false,
          mobile: {
            defaultColumns: vm.defaultTableColumns[v]
          }
        });
      });
    };

    vm.changeStats = function() {
      if (!vm.dashboardStats) {
        return;
      }

      vm.stats = vm.dashboardStats[vm.currentPerionds.stats];
    };

    vm.changeTableList = function(tableName) {
      if (!vm.dashboardTops) {
        return;
      }

      vm[tableName].updateList(vm.dashboardTops[tableName][vm.currentPerionds[tableName]] || []);
    };

    vm.updateTables = function() {
      _.each(vm.tableNames, function(v) {
        vm[v].update({
          locale_key: vm.dashboardTops.locale_key + '.' + v,
          columns: vm.dashboardTops.columns_for_display_data[v],
          list: vm.dashboardTops[v][vm.currentPerionds[v]]
        });
      });
    };

    vm.destroyAllTables = function() {
      _.each(vm.tableNames, function(v) {
        vm[v].destroy();
      });
    };

    vm.changeMerchant = function() {
      vm.getLastUpdateTime();
      vm.getStats();
      vm.getCharts();
      vm.getTops();
    };

    vm.setUpCurrentMerchant = function(list) {
      return _.propertyOf(_.findWhere(list, {default: true}))('id');
    };

    vm.getLastUpdateTime = function() {
      if (!vm.updateTimePermission) {
        return;
      }

      AdminDashboardApi.getLastUpdateTime(vm.currentMerchant).then(
        function(response) {
          vm.last_update = response.data.last_update;
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getStats = function() {
      if (!vm.getStatsPermission) {
        return;
      }

      AdminDashboardApi.getStats(vm.currentMerchant).then(
        function(response) {
          vm.dashboardStats = response.data.stats;
          vm.changeStats();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getCharts = function() {
      if (!vm.getChartsPermission) {
        return;
      }

      AdminDashboardApi.getCharts(vm.currentMerchant).then(
        function(response) {
          vm.chartsData = response.data.chart;
          vm.chartOptions.columnsNamespace = response.data.locale_key_chart + '.';
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.getTops = function() {
      if (!vm.getTopsPermission) {
        return;
      }

      AdminDashboardApi.getTops(vm.currentMerchant).then(
        function(response) {
          vm.dashboardTops = response.data;
          vm.updateTables();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    if (vm.getStatsPermission) {
      AdminDashboardApi.getMerchants().then(
        function(response) {
          vm.merchantsList = response.data;
          vm.currentMerchant = vm.setUpCurrentMerchant(vm.merchantsList);

          vm.changeMerchant();
        },
        function() {
          toastsApi.toastError();
        }
      );
    } else {
      vm.changeMerchant();
    }

    vm.initTables();

    $scope.$on('$destroy', function() {
      vm.destroyAllTables();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('SettingsCreativeController', SettingsCreativeController);

  SettingsCreativeController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    'AdminCreativesApi',
    'UserlocalStorage',
    '$q',
    '_',
    'outputErrors',
    '$filter',
    'tableEngine',
    'localesStorage',
    'toastsApi'
  ];

  function SettingsCreativeController(
    $scope,
    $state,
    $stateParams,
    $timeout,
    AdminCreativesApi,
    UserlocalStorage,
    $q,
    _,
    outputErrors,
    $filter,
    tableEngine,
    localesStorage,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminCreatives';
    vm.errors = outputErrors.createNew();
    vm.from_creative_type = UserlocalStorage.get('admin_cs') || 'link';
    vm.main_title = $stateParams.creativeId ? 'settings.edit_title' : 'settings.create_title';
    vm.submit_button = $stateParams.creativeId ? 'settings.edit_submit' : 'settings.create_submit';
    vm.commonFields = [
      'format',
      'title',
      'advertising_company',
      'language',
      'status',
      'at_beginning_show',
      'at_end_show',
      'link'
    ];
    vm.bannerOptions = {};
    vm.creative = {};
    vm.files = [];
    vm.fileErrors = [];
    vm.uploadedBanners = [];
    vm.resolvedBanners = [];
    vm.rejectedBanners = [];
    vm.affiliatesList = [];
    vm.disableChooseFile = false;
    vm.isBulk = $state.current.data.bulk;

    vm.creative.at_beginning_show = null;
    vm.creative.at_end_show = null;

    vm.creativeTypes = [
      {
        type: 'link'
      },
      {
        type: 'jpeg',
        additional_fields: ['banner'],
        banner_options: {
          accept: 'image/jpeg',
          formats: ['jpeg', 'jpg'],
          translate_key: vm.translate_key,
          shortcodes: {
            resolution_file: 'settings.banner_upload.jpeg.resolution_file',
            drop_file_here: 'settings.banner_upload.jpeg.drop_file_here'
          }
        }
      },
      {
        type: 'png',
        additional_fields: ['banner'],
        banner_options: {
          accept: 'image/png',
          formats: ['png'],
          translate_key: vm.translate_key,
          shortcodes: {
            resolution_file: 'settings.banner_upload.png.resolution_file',
            drop_file_here: 'settings.banner_upload.png.drop_file_here'
          }
        }
      },
      {
        type: 'gif',
        additional_fields: ['banner'],
        banner_options: {
          accept: 'image/gif',
          formats: ['gif'],
          translate_key: vm.translate_key,
          shortcodes: {
            resolution_file: 'settings.banner_upload.gif.resolution_file',
            drop_file_here: 'settings.banner_upload.gif.drop_file_here'
          }
        }
      },
      {
        type: 'iframe',
        uniques_fields: ['link'],
        additional_fields: ['body', 'width', 'height']
      },
      {
        type: 'bannerflow_gif',
        uniques_fields: ['link'],
        additional_fields: ['body', 'width', 'height']
      },
      {
        type: 'flash',
        additional_fields: ['banner'],
        banner_options: {
          accept: '.swf',
          translate_key: vm.translate_key,
          shortcodes: {
            drop_file_here: 'settings.banner_upload.flash.drop_file_here'
          }
        }
      }
    ];

    vm.availableFormats = _.filter(vm.creativeTypes, function(v) {
      return _.contains($state.current.data.available_formats, v.type);
    });

    vm.creativeType = _.contains(_.pluck(vm.availableFormats, 'type'), $stateParams.type)
      ? $stateParams.type
      : _.first(vm.availableFormats).type;
    vm.creative.format = $stateParams.creativeId ? null : vm.creativeType;

    vm.creative_statuses = [
      {status: true, label: 'settings.status_active'},
      {status: false, label: 'settings.status_not_active'}
    ];

    vm.language_list = localesStorage.getLanguages();

    vm.back = function(format) {
      var type = vm.creative.id && !$stateParams.type ? vm.creative.format : $stateParams.type;
      $state.go('creatives.' + (format || type || vm.creativeType));
    };

    vm.getUniqueFieldShortcode = function(fieldName) {
      return _.contains(
        _.propertyOf(_.findWhere(vm.availableFormats, {type: vm.creative.format}))('uniques_fields'),
        fieldName
      )
        ? vm.creative.format + '.'
        : '';
    };

    vm.getCurrentCreativeType = function() {
      return vm.creative.format;
    };

    vm.checkFormFields = function(fieldName) {
      return _.contains(
        _.propertyOf(_.findWhere(vm.availableFormats, {type: vm.creative.format}))('additional_fields'),
        fieldName
      );
    };

    vm.filterCreativeFields = function() {
      vm.creative = _.pick(vm.creative, vm.commonFields);
    };

    vm.getBannerOptions = function() {
      return _.propertyOf(_.findWhere(vm.availableFormats, {type: vm.creative.format}))('banner_options') || {};
    };

    vm.clearUploadedFiles = function() {
      vm.fileErrors.length = 0;
      vm.uploadedBanners.length = 0;
      vm.rejectedBanners.length = 0;
      vm.resolvedBanners.length = 0;
    };

    vm.changeBulkUploadOptions = function() {
      var options = vm.getBannerOptions();
      vm.fileFormats = options.formats;
      vm.acceptFiles = options.accept;
      vm.files.length = 0;
      vm.clearUploadedFiles();
    };

    vm.setBannerOptions = function() {
      vm.bannerOptions = vm.getBannerOptions();
    };

    vm.clearFileCallback = function() {
      vm.creative = _.omit(vm.creative, 'width', 'height', 'banner');
    };

    vm.addFileCallback = function(data) {
      if (data) {
        vm.creative.width = data.width;
        vm.creative.height = data.height;
      } else {
        vm.creative = _.omit(vm.creative, 'width', 'height');
      }
    };

    vm.changedCreativeFormat = function() {
      vm.setBannerOptions();
      vm.changeBulkUploadOptions();
      vm.filterCreativeFields();
    };

    vm.querySearch = function(query) {
      var results = $filter('filter')(vm.last_advertising_companies || [], query),
        deferred = $q.defer();

      deferred.resolve(results);
      return deferred.promise;
    };

    vm.saveOneCreative = function() {
      return AdminCreativesApi.save_creative(vm.creative).then(
        function(response) {
          if (vm.creative.id) {
            toastsApi.toastEditSuccess();
            vm.creative.exclusive_affiliates = response.data.creative.exclusive_affiliates;
            vm.creative.creative_exclusive_affiliates_attributes = vm.getUpdatedAffiliatesExclusive();
          } else {
            toastsApi.toastCreateSuccess();
          }
          vm.table = tableEngine.getTableByName('creatives_' + vm.creative.format);

          if (vm.table) {
            vm.table.pagination().then(function() {
              if (!vm.creative.id) {
                vm.back(vm.creative.format);
              }
            });
          } else {
            if (!vm.creative.id) {
              vm.back(vm.creative.format);
            }
          }
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.saveCreative = function() {
      vm.saveCreativeForm.$setSubmitted();

      if (vm.isBulk) {
        if (!_.size(vm.creatives_list) && !_.size(vm.fileErrors)) {
          vm.fileErrors.push({banner: {}, errors: ['common.errors.form.required']});
        } else {
          if (vm.saveCreativeForm.$valid) {
            return vm.bulkUploadCreatives();
          }
        }
      } else {
        if (!vm.creative.id && !vm.creative.banner) {
          vm.errors.inputErrors({banner: ['common.errors.form.required']});
        }

        if (vm.saveCreativeForm.$valid) {
          return vm.saveOneCreative();
        }
      }
    };

    vm.bulkUploadCreatives = function() {
      vm.clearUploadedFiles();

      vm.disableChooseFile = true;

      var allPromises = [];

      _.each(vm.creatives_list, function(creative) {
        vm.updateCreativeItem(creative);
        vm.uploadedBanners.push(creative.banner.ide);

        var promise = vm.uploadCreativeItem(creative).then(
          function() {
            vm.resolvedBanners.push(creative.banner.ide);
            vm.removeBannerIdeFromList(vm.uploadedBanners, creative.banner.ide);
          },
          function(res) {
            var errors = res && res.data && res.data.errors;
            vm.rejectedBanners.push(creative.banner.ide);
            vm.removeBannerIdeFromList(vm.uploadedBanners, creative.banner.ide);
            vm.errors.inputErrors(errors);
            if (errors && (errors.banner || errors.title)) {
              vm.fileErrors.push({banner: creative.banner, errors: errors.banner || errors.title});
            }
          }
        );

        allPromises.push(promise);
      });

      return $q.all(allPromises).then(function() {
        var noErrors = !vm.rejectedBanners.length;
        vm.disableChooseFile = false;
        vm.table = tableEngine.getTableByName('creatives_' + vm.creative.format);

        if (vm.table) {
          vm.table.pagination().then(function() {
            if (noErrors) {
              toastsApi.toastSuccess();
              vm.back(vm.creative.format);
            }
          });
        } else {
          vm.back(vm.creative.format);
        }
      });
    };

    vm.uploadCreativeItem = function(creative) {
      return AdminCreativesApi.save_creative(creative);
    };

    vm.updateCreativeItem = function(creative) {
      _.extend(creative, vm.creative);
    };

    vm.createCreativeItem = function(file) {
      return _.extend({}, vm.creative, {
        title: file.title,
        width: file.width,
        height: file.height,
        banner: _.pick(
          file,
          'lastModified',
          'lastModifiedDate',
          'name',
          'title',
          'size',
          'type',
          'webkitRelativePath',
          'contents',
          'ide'
        )
      });
    };

    vm.getMaxFileSize = function() {
      return _.propertyOf(vm.creative)('format') === 'png' ? 2 : 1;
    };

    vm.showUploadFileDescription = function() {
      return _.contains(['jpeg', 'png', 'gif'], _.propertyOf(vm.creative)('format'));
    };

    vm.getCheckedAffiliates = function() {
      return _.where(vm.affiliatesList, {check: true});
    };

    vm.getUpdatedAffiliatesExclusive = function() {
      var newIds = _.pluck(vm.getCheckedAffiliates(), 'id'),
        affIds = vm.getAffiliateIds(vm.creative.exclusive_affiliates, 'affiliate_id'),
        completeArr = _.union(newIds, affIds),
        result = [];

      _.each(completeArr, function(id) {
        var inOld = _.contains(affIds, id),
          inNew = _.contains(newIds, id),
          bunchId;

        if (inOld && !inNew) {
          bunchId = vm.getBunchId(vm.creative.exclusive_affiliates, id);
          result.push({id: bunchId, affiliate_id: id, _destroy: '1'});
        } else if (!inOld && inNew) {
          result.push({affiliate_id: id});
        }
      });

      return result;
    };

    vm.isExclusive = function() {
      return !_.isEmpty(vm.getCheckedAffiliates());
    };

    vm.changeExclusiveAffiliates = function() {
      $timeout(function() {
        vm.creative.creative_exclusive_affiliates_attributes = vm.getUpdatedAffiliatesExclusive();
        vm.creative.is_exclusive = vm.isExclusive();
      }, 0);

      return $q.when();
    };

    vm.compareAffiliatesList = function() {
      var ids = vm.getAffiliateIds(vm.creative.exclusive_affiliates, 'affiliate_id');
      vm.affiliatesList = _.map(vm.affiliatesList, function(v) {
        v.check = _.contains(ids, v.id);
        return v;
      });
    };

    vm.getAffiliateIds = function(list, prop) {
      return _.pluck(list, prop);
    };

    vm.getBunchId = function(list, affiliateId) {
      return _.propertyOf(_.findWhere(list, {affiliate_id: affiliateId}))('id');
    };

    vm.getAdvertisingCompany = function() {
      AdminCreativesApi.search_advertising_company().then(function(response) {
        vm.last_advertising_companies = response.data.list;
      });
    };

    vm.removeBannerIdeFromList = function(list, ide) {
      var idx = list.indexOf(ide);
      if (idx !== -1) {
        list.splice(idx, 1);
      }
    };

    vm.removeBannerFromErrorList = function(ide) {
      vm.fileErrors = _.reject(vm.fileErrors, function(val) {
        return val.banner.ide === ide;
      });
    };

    vm.removeFileFromList = function(ide) {
      vm.creatives_list = _.reject(vm.creatives_list, function(creative) {
        return creative.banner.ide === ide;
      });
    };

    vm.updateBannerTitle = function(file) {
      _.each(vm.creatives_list, function(creative) {
        if (creative.banner.ide === file.ide) {
          creative.title = file.title;
          creative.banner.title = file.title;
        }
      });
    };

    $scope.$on('files-ready', function(ev, files) {
      vm.clearUploadedFiles();
      vm.creatives_list = _.map(files, vm.createCreativeItem);
    });

    $scope.$on('file-removed', function(ev, file) {
      vm.removeFileFromList(file.ide);
      vm.removeBannerFromErrorList(file.ide);
      vm.removeBannerIdeFromList(vm.rejectedBanners, file.ide);
    });

    $scope.$on('change-file-title', function(ev, file) {
      vm.updateBannerTitle(file);
    });

    AdminCreativesApi.getCreativeLanguages().then(function(response) {
      vm.language_list = response.data.language;
      vm.affiliatesList = response.data.affiliates;
      vm.compareAffiliatesList();
    });

    if ($stateParams.creativeId) {
      AdminCreativesApi.show($stateParams.creativeId).then(
        function(response) {
          vm.creative = response.data.creative;

          vm.setBannerOptions();
          vm.compareAffiliatesList();
          vm.changeExclusiveAffiliates();
        },
        function() {
          toastsApi.toastError();
        }
      );
    } else {
      vm.setBannerOptions();
      vm.changeBulkUploadOptions();
      vm.changeExclusiveAffiliates();

      $scope.$on('$changeMerchantSuccess', function() {
        vm.getAdvertisingCompany();
      });
    }

    vm.getAdvertisingCompany();
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    var tabsList = ['link', 'jpeg', 'png', 'gif', 'bannerflow_gif', 'iframe', 'flash'];

    $stateProvider
      .state('creatives', {
        url: '/creatives',
        templateUrl: 'app/admin/creatives/partials/creatives.html',
        controller: 'CreativesController',
        controllerAs: 'creativesCtrl',
        data: {
          tabsList: tabsList,
          permissions: permissionsStateAccess.init(['api2.admin.creativescontroller.show'])
        }
      })
      .state('creatives.edit', {
        url: '/edit/:creativeId',
        templateUrl: 'app/admin/creatives/partials/settings_creative.html',
        controller: 'SettingsCreativeController',
        controllerAs: 'settingsCtrl',
        params: {
          creativeId: '',
          type: ''
        },
        data: {
          bulk: false,
          available_formats: tabsList,
          permissions: permissionsStateAccess.init(['api2.admin.creativescontroller.edit'])
        }
      })
      .state('creatives.create', {
        url: '/create',
        templateUrl: 'app/admin/creatives/partials/settings_creative.html',
        controller: 'SettingsCreativeController',
        controllerAs: 'settingsCtrl',
        params: {
          type: ''
        },
        data: {
          bulk: false,
          available_formats: tabsList,
          permissions: permissionsStateAccess.init(['api2.admin.creativescontroller.create'])
        }
      })
      .state('creatives.create_bulk', {
        url: '/create_bulk',
        templateUrl: 'app/admin/creatives/partials/settings_creative.html',
        controller: 'SettingsCreativeController',
        controllerAs: 'settingsCtrl',
        params: {
          type: ''
        },
        data: {
          bulk: true,
          available_formats: ['jpeg', 'png', 'gif'],
          permissions: permissionsStateAccess.init(['api2.admin.creativescontroller.create'])
        }
      });

    angular.forEach(tabsList, function(name) {
      $stateProvider.state('creatives.' + name, {
        url: '/' + name,
        data: {
          type: name
        },
        views: {
          'content@creatives': {
            templateUrl: 'app/admin/creatives/partials/list.html',
            controller: 'AdminCreativeTabController',
            controllerAs: 'tabCtrl'
          },
          'search@creatives': {
            templateUrl: 'app/admin/creatives/partials/search.html'
          },
          'pagination@creatives': {
            templateUrl: 'app/admin/creatives/partials/pagination.html'
          }
        }
      });
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminCreativeViewController', AdminCreativeViewController);

  AdminCreativeViewController.$inject = ['$mdDialog'];

  function AdminCreativeViewController($mdDialog) {
    var vm = this;

    vm.closePopup = function() {
      $mdDialog.hide();
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partnership_program: {
          creatives: [
            {
              tabs: [
                'link||creatives_tab.link',
                'jpeg||creatives_tab.jpeg',
                'png||creatives_tab.png',
                'gif||creatives_tab.gif',
                'bannerflow_gif||creatives_tab.bannerflow_gif',
                'iframe||creatives_tab.iframe',
                'flash||creatives_tab.flash'
              ]
            },
            {
              modal_window: [
                {
                  change_creative_state: [
                    'set_active_title||change_creative_state.set_active_title',
                    'set_unactive_title||change_creative_state.set_unactive_title',
                    'list_of_creative_ids||change_creative_state.list_of_creative_ids',
                    'no_one_creative_has_been_chosen||change_creative_state.no_one_creative_has_been_chosen',
                    'apply_changes_button||change_creative_state.apply_changes_button',
                    'cancel_button||change_creative_state.cancel_button'
                  ]
                }
              ]
            },
            {
              settings: [
                {
                  form: [
                    {
                      common: [
                        'format||settings.form.format',
                        'title||settings.form.title',
                        'advertising_company||settings.form.advertising_company',
                        'language||settings.form.language',
                        'status||settings.form.status',
                        'at_beginning_show||settings.form.at_beginning_show',
                        'at_end_show||settings.form.at_end_show',
                        'link||settings.form.link',
                        'exclusive_affiliates||settings.exclusive_affiliates',
                        'choose_file||settings.form.choose_file',
                        'bulk_upload_label||settings.form.bulk_upload_label',
                        {
                          bulk_upload: [
                            'drop_file_here||settings.bulk_upload.drop_file_here',
                            'file_name||settings.bulk_upload.file_name',
                            'file_format||settings.bulk_upload.file_format',
                            'file_size||settings.bulk_upload.file_size',
                            'file_resolution||settings.bulk_upload.file_resolution',
                            'file_ready||settings.bulk_upload.file_ready',
                            'file_status||settings.bulk_upload.file_status',
                            'file_not_valid||settings.bulk_upload.file_not_valid'
                          ]
                        }
                      ]
                    },
                    {
                      bannerflow_gif: [
                        'link||settings.form.bannerflow_gif.link',
                        'iframe_body||settings.form.bannerflow_gif.iframe_body',
                        'iframe_width||settings.form.bannerflow_gif.iframe_width',
                        'iframe_height||settings.form.bannerflow_gif.iframe_height'
                      ]
                    },
                    {
                      iframe: [
                        'link||settings.form.iframe.link',
                        'iframe_body||settings.form.iframe.iframe_body',
                        'iframe_width||settings.form.iframe.iframe_width',
                        'iframe_height||settings.form.iframe.iframe_height'
                      ]
                    },
                    {
                      flash: ['drop_file_here||settings.banner_upload.flash.drop_file_here']
                    },
                    {
                      gif: [
                        'resolution_file||settings.banner_upload.gif.resolution_file',
                        'drop_file_here||settings.banner_upload.gif.drop_file_here'
                      ]
                    },
                    {
                      jpeg: [
                        'resolution_file||settings.banner_upload.jpeg.resolution_file',
                        'drop_file_here||settings.banner_upload.jpeg.drop_file_here'
                      ]
                    },
                    {
                      png: [
                        'resolution_file||settings.banner_upload.png.resolution_file',
                        'drop_file_here||settings.banner_upload.png.drop_file_here'
                      ]
                    }
                  ]
                },
                'edit_title||settings.edit_title',
                'create_title||settings.create_title',
                'status_active||settings.status_active',
                'status_not_active||settings.status_not_active',
                'status_archived||settings.status_archived',
                'status_common||settings.status_common',
                'create_submit||settings.create_submit',
                'edit_submit||settings.edit_submit',
                'bulk_upload_description||settings.bulk_upload_description',
                'upload_file_description||settings.upload_file_description',
                'back||settings.back'
              ]
            },
            'submit||creatives.submit',
            'create_bulk||creatives.create_bulk',
            'set_creatives_activated||creatives.set_activated',
            'set_creatives_unactivated||creatives.set_unactivated',
            'archive_creative||creatives.archive_creative',
            'unarchive_creative||creatives.unarchive_creative',
            'header||creatives.header'
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminCreatives', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('inputUploadFile', inputUploadFile);

  inputUploadFile.$inject = ['$log', '$timeout', '_'];

  function inputUploadFile($log, $timeout, _) {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        options: '=',
        errors: '=?',
        name: '@',
        callbackAddFile: '&?',
        callbackRemoveFile: '&?'
      },
      bindToController: true,
      controllerAs: '$ctrl',
      templateUrl: 'app/admin/creatives/partials/input_upload_file.html',
      controller: function($scope, $element) {
        var vm = this,
          input = _.first($element.find('input'));

        vm.reader = new FileReader();
        vm.preview = new Image();
        vm.file = null;
        vm.imageResolution = {};

        vm.clearFile = function() {
          try {
            input.value = '';
          } catch (err) {
            $log.error('Crear input file is not supported because probably you use IE10-');
          }
        };

        vm.removeFile = function() {
          vm.ngModel = null;
          vm.file = null;
          vm.imageResolution = {};
          vm.clearFile();

          if (vm.callbackRemoveFile) {
            vm.callbackRemoveFile();
          }
        };

        vm.getImageResolution = function(ev) {
          vm.imageResolution.width = vm.preview.width || ev.path[0].width;
          vm.imageResolution.height = vm.preview.height || ev.path[0].height;

          if (vm.callbackAddFile) {
            $timeout(function() {
              vm.callbackAddFile({data: vm.imageResolution});
            }, 0);
          }
        };

        vm.readerLoaded = function() {
          if (_.contains(vm.file.type.split('/'), 'image')) {
            vm.preview.setAttribute('src', ''); // safari fix
            vm.preview.setAttribute('src', vm.reader.result);
          }

          $timeout(function() {
            vm.ngModel = _.pick(
              vm.file,
              'lastModified',
              'lastModifiedDate',
              'name',
              'size',
              'type',
              'webkitRelativePath'
            );
            vm.ngModel.contents = vm.reader.result;
            vm.callbackAddFile({data: null});
          }, 0);
        };

        vm.inputChange = function(ev) {
          vm.file = ev.target.files[0];

          if (vm.file) {
            vm.reader.readAsDataURL(vm.file);
          }
        };

        vm.dragOver = function() {
          input.parentNode.classList.add('drag-over');
        };

        vm.dragEnd = function() {
          input.parentNode.classList.remove('drag-over');
        };

        vm.reader.addEventListener('load', vm.readerLoaded);
        vm.preview.addEventListener('load', vm.getImageResolution);
        input.addEventListener('change', vm.inputChange);
        input.addEventListener('dragenter', vm.dragOver);
        input.addEventListener('dragleave', vm.dragEnd);
        input.addEventListener('drop', vm.dragEnd);

        $scope.$on('$destroy', function() {
          vm.reader.removeEventListener('load', vm.readerLoaded);
          vm.preview.removeEventListener('load', vm.getImageResolution);
          input.removeEventListener('change', vm.inputChange);
          input.removeEventListener('dragenter', vm.dragOver);
          input.removeEventListener('dragleave', vm.dragEnd);
          input.removeEventListener('drop', vm.dragEnd);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminCreativeTabController', AdminCreativeTabController);

  AdminCreativeTabController.$inject = [
    '$scope',
    '$state',
    '$mdDialog',
    'AdminCreativesApi',
    '_',
    '$sce',
    'tableEngine',
    'toastsApi',
    'tabsApi',
    '$mdTranslate',
    'permissionsManager'
  ];

  function AdminCreativeTabController(
    $scope,
    $state,
    $mdDialog,
    AdminCreativesApi,
    _,
    $sce,
    tableEngine,
    toastsApi,
    tabsApi,
    $mdTranslate,
    permissionsManager
  ) {
    var vm = this;

    vm.translate_key = 'AdminCreatives';
    vm.stateData = $state.current.data;
    vm.tabs = tabsApi.getTabsByName('creatives');

    vm.editCreative = function(creative) {
      $state.go('creatives.edit', {creativeId: creative.id, type: vm.stateData.type});
    };

    vm.openModal = function(creative, templateUrl, ev) {
      $mdDialog.show({
        controller: 'AdminCreativeViewController',
        controllerAs: '$ctrl',
        bindToController: true,
        templateUrl: templateUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          creative_title: creative.title,
          creative_src: $sce.trustAsResourceUrl(
            creative[_.contains(['iframe', 'bannerflow_gif'], creative.format) ? 'body' : 'img']
          ),
          creative_width: creative.resolution ? _.first(creative.resolution.split('x')) : 'auto',
          creative_height: creative.resolution ? _.last(creative.resolution.split('x')) : 'auto'
        }
      });
    };

    vm.showCreative = function(creative, ev) {
      vm.openModal(creative, vm.tabs.activeTab.modal_template_url, ev);
    };

    vm.translate = function(shortcode, data) {
      return $mdTranslate.instant(vm.translate_key, shortcode, data);
    };

    vm.getTranslationsForConfirmModal = function(actionPurpose, listOfIds) {
      return {
        title: vm.translate(
          actionPurpose ? 'change_creative_state.set_active_title' : 'change_creative_state.set_unactive_title'
        ),
        content: vm.translate(
          _.size(listOfIds)
            ? 'change_creative_state.list_of_creative_ids'
            : 'change_creative_state.no_one_creative_has_been_chosen',
          {ids: listOfIds ? listOfIds.toString().replace(/,/g, ', ') : ''}
        ),
        ok: vm.translate('change_creative_state.apply_changes_button'),
        cancel: vm.translate('change_creative_state.cancel_button')
      };
    };

    vm.openConfirmChangesModal = function(translations, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(translations.title)
        .textContent(translations.content)
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .ok(translations.ok)
        .cancel(translations.cancel);

      return $mdDialog.show(confirm);
    };

    vm.setUpCreativesStatus = function(selectedItems, filterId, creativeFormat, setActivated, params) {
      AdminCreativesApi.changeCreativesStatus(selectedItems, filterId, creativeFormat, setActivated, params).then(
        function() {
          vm.table.pagination();
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.changeCreativesStatus = function(selectedItems, filterId, paginationParams, setActivated) {
      var creativeFormat = paginationParams.additional_options.format,
        translations = vm.getTranslationsForConfirmModal(setActivated, selectedItems);

      vm.openConfirmChangesModal(translations).then(function() {
        vm.setUpCreativesStatus(selectedItems, filterId, creativeFormat, setActivated, paginationParams);
      });
    };

    vm.setActivated = function(selectedItems, filterId, paginationParams) {
      vm.changeCreativesStatus(selectedItems, filterId, paginationParams, true);
    };

    vm.setUnactivated = function(selectedItems, filterId, paginationParams) {
      vm.changeCreativesStatus(selectedItems, filterId, paginationParams, false);
    };

    vm.changeArchiveStatus = function(selectedItems, filterId, paginationParams, archive) {
      var creativeFormat = paginationParams.additional_options.format;

      AdminCreativesApi.changeArchiveStatus(selectedItems, filterId, creativeFormat, archive, paginationParams).then(
        function() {
          vm.table.pagination();
          toastsApi.toastSuccess();
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.unarchiveCreative = function(selectedItems, filterId, paginationParams) {
      vm.changeArchiveStatus(selectedItems, filterId, paginationParams, false);
    };

    vm.archiveCreative = function(selectedItems, filterId, paginationParams) {
      vm.changeArchiveStatus(selectedItems, filterId, paginationParams, true);
    };

    vm.getTab = function(type) {
      return vm.tabs.findTabByCondition(function(tab) {
        return tab.name === type;
      });
    };

    vm.getMethods = function() {
      var tab = vm.getTab(vm.stateData.type);

      return tab ? _.omit(vm.creativeMethods, tab.excluded_methods || []) : {};
    };

    vm.tableFiliterColumns = [
      {
        name: 'merchant_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'title',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'advertising_company',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'language',
        type: 'checkbox',
        display: true,
        empty: true,
        checkbox_namespace: 'common.languages.'
      },
      {
        name: 'at_beginning_show',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'at_end_show',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'status',
        type: 'checkbox',
        display: true,
        empty: true,
        disable_search: true,
        locales: {
          translate_key: vm.translate_key,
          truth: 'settings.status_active',
          lie: 'settings.status_not_active'
        }
      },
      {
        name: 'aasm_state',
        type: 'checkbox',
        display: true,
        empty: true,
        disable_search: true,
        locales: {
          translate_key: vm.translate_key,
          shortcode: 'settings.status_'
        }
      },
      {
        name: 'created_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'resolution',
        type: 'checkbox',
        display: true,
        empty: true
      }
    ];

    vm.creativeMethods = {
      show: vm.showCreative,
      edit: vm.editCreative
    };

    vm.table = tableEngine.getOrCreate({
      api: AdminCreativesApi,
      name: 'createves_' + vm.stateData.type,
      mobile: {
        defaultColumns: ['title']
      },
      buttons: {
        url: 'app/admin/creatives/partials/table.html',
        methods: vm.getMethods()
      },
      params: {
        data: {
          additional_options: {
            format: vm.stateData.type
          }
        }
      },
      column_checkboxes: {
        enable: true,
        actions: [
          {
            name: 'setActivated',
            action: vm.setActivated,
            display: permissionsManager.checkPermission('api2.admin.creativescontroller.active_or_inactive_creatives'),
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'creatives.set_activated'
            }
          },
          {
            name: 'setUnactivated',
            action: vm.setUnactivated,
            display: permissionsManager.checkPermission('api2.admin.creativescontroller.active_or_inactive_creatives'),
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'creatives.set_unactivated'
            }
          },
          {
            name: 'archiveCreative',
            action: vm.archiveCreative,
            display: permissionsManager.checkPermission('api2.admin.creativescontroller.archivation_creatives'),
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'creatives.archive_creative'
            }
          },
          {
            name: 'unarchiveCreative',
            action: vm.unarchiveCreative,
            display: permissionsManager.checkPermission('api2.admin.creativescontroller.archivation_creatives'),
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'creatives.unarchive_creative'
            }
          }
        ]
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/admin/creatives',
        actionForFilter: 'list',
        byMerchant: true,
        filterName: 'creative_' + vm.stateData.type
      }
    });

    vm.tabs.setUpTable(vm.stateData.type, vm.table);

    if (!vm.table.isRendered()) {
      AdminCreativesApi.get_creatives(vm.stateData.type).then(
        function(response) {
          var data = response.data,
            opts = {
              locale_key: data.locale_key,
              columns: data.columns_for_display_data,
              list: data.list,
              total_pages: data.total_pages,
              total_entries: data.total_entries,
              start_row_num: data.start_row_num,
              end_row_num: data.end_row_num
            };

          vm.table.update(opts);

          vm.table.addOptionsToColumn('status', {
            localizied: true,
            locales: {
              translate_key: vm.translate_key,
              truth: 'settings.status_active',
              lie: 'settings.status_not_active'
            }
          });

          vm.table.addOptionsToColumn('aasm_state', {
            localizied: true,
            locales: {
              translate_key: vm.translate_key,
              shortcode: 'settings.status_{{shortcode_part}}',
              shortcode_part_in_value: true
            }
          });

          vm.table.addOptionsToColumn('language', {
            localizied: true,
            locales: {
              namespace: 'creative.list_locales'
            }
          });
        },
        function() {
          toastsApi.toastError();
        }
      );
    }

    $scope.$on('$changeMerchantSuccess', function() {
      vm.tabs.resetFilterForAllTables();
      vm.table.pagination();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('CreativesController', CreativesController);

  CreativesController.$inject = ['$scope', '$state', '_', 'tableEngine', 'tabsApi'];

  function CreativesController($scope, $state, _, tableEngine, tabsApi) {
    var vm = this;

    vm.translate_key = 'AdminCreatives';
    vm.stateData = $state.current.data;

    vm.options = {
      link: {excluded_methods: ['show']},
      jpeg: {modal_template_url: 'app/admin/creatives/partials/creative_img.html'},
      png: {modal_template_url: 'app/admin/creatives/partials/creative_img.html'},
      gif: {modal_template_url: 'app/admin/creatives/partials/creative_img.html'},
      bannerflow_gif: {modal_template_url: 'app/admin/creatives/partials/view_iframe.html'},
      iframe: {modal_template_url: 'app/admin/creatives/partials/view_iframe.html'},
      flash: {modal_template_url: 'app/admin/creatives/partials/view_flash.html'}
    };

    vm.buildTabs = function(list) {
      return _.map(list, function(val) {
        return {
          name: val,
          shortcode: 'creatives_tab.' + val,
          state: 'creatives.' + val,
          excluded_methods: vm.options[val].excluded_methods || [],
          modal_template_url: vm.options[val].modal_template_url || '',
          table: null
        };
      });
    };

    vm.tabs = tabsApi.init({
      name: 'creatives',
      translateKey: vm.translate_key,
      list: vm.buildTabs(vm.stateData.tabsList)
    });

    vm.createCreative = function() {
      $state.go('creatives.create', {type: vm.tabs.activeTab.name});
    };

    vm.createCreativeBulk = function() {
      $state.go('creatives.create_bulk', {type: vm.tabs.activeTab.name});
    };

    vm.destroyTables = function() {
      _.each(vm.stateData.tabsList, function(val) {
        var table = tableEngine.getTableByName('creatives_' + val);

        if (table) {
          table.destroy();
        }
      });
    };

    $scope.$on('$destroy', function() {
      vm.destroyTables();
      vm.tabs.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('bulkUploadFiles', bulkUploadFiles);

  bulkUploadFiles.$inject = ['$log', '$timeout', '$mdDialog', '_'];

  function bulkUploadFiles($log, $timeout, $mdDialog, _) {
    return {
      restrict: 'E',
      scope: {
        files: '=',
        fileErrors: '=?',
        maxFiles: '=?',
        maxFileSize: '=?',
        fileFormats: '=?',
        accept: '=?',
        uploadedBanners: '=?',
        resolvedBanners: '=?',
        rejectedBanners: '=?'
      },
      bindToController: true,
      controllerAs: '$ctrl',
      templateUrl: 'app/admin/creatives/partials/bulk_upload_files.html',
      controller: function($scope, $element) {
        var vm = this,
          input = $element[0].querySelector('input');

        vm.files = vm.files || [];
        vm.maxFiles = vm.maxFiles || 10;
        vm.maxFileSize = vm.maxFileSize || 1;
        vm.fileFormats = vm.fileFormats || ['jpeg', 'jpg', 'gif'];
        vm.accept = vm.accept || 'image/gif, image/jpg, image/jpeg';
        vm.heightTable = '150px';
        vm.ide = 0;
        vm.fileTitle = '';
        vm.fileContent = '';

        vm.getIde = function() {
          return ++vm.ide;
        };

        vm.outputFileNameWhileError = function(error) {
          return error.banner.ide + '. ' + (error.banner.title ? error.banner.title + ':' : '');
        };

        vm.getTableHeight = function() {
          $timeout(function() {
            var table = $element[0].querySelector('.files-table');

            if (!table) {
              return;
            }

            vm.heightTable = table.offsetHeight > 150 ? table.offsetHeight + 20 + 'px' : '150px';
          }, 0);
        };

        vm.getFileName = function(file) {
          return _.initial((file.name || '').split('.')).join('.');
        };

        vm.getFileSize = function(file) {
          return (file.size / 1024 / 1024).toFixed(2) + ' MB';
        };

        vm.getFileFormat = function(file) {
          return _.last(file.type.split('/'));
        };

        vm.getFileResolution = function(file) {
          return file.width && file.height ? file.width + 'x' + file.height : '';
        };

        vm.removeFile = function(file) {
          vm.files = _.reject(vm.files, {ide: file.ide});
          $scope.$emit('file-removed', file);
          vm.getTableHeight();
        };

        vm.clearInputFile = function() {
          try {
            input.value = '';
          } catch (err) {
            $log.error('Crear input file is not supported because probably you use IE10-');
          }
        };

        vm.closePopup = function() {
          $mdDialog.hide();
        };

        vm.previewFile = function(file, ev) {
          if (!file.isRead) {
            return;
          }

          vm.fileTitle = file.title;
          vm.fileContent = file.contents;

          $mdDialog
            .show({
              scope: $scope,
              preserveScope: true,
              templateUrl: 'app/admin/creatives/partials/file_preview.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true
            })
            .then(function() {
              vm.fileTitle = '';
              vm.fileContent = '';
            });
        };

        vm.emitFilesReadyEvent = function() {
          $scope.$emit('files-ready', vm.getValidFiles());
          vm.getTableHeight();
        };

        vm.changeFileName = function(file) {
          file.ready = vm.validateFile(file);
          $scope.$emit('change-file-title', file);
          $scope.$digest();
        };

        vm.changeFileNameHandler = _.debounce(vm.changeFileName, 300);

        vm.validateFileFormat = function(file) {
          return _.contains(vm.fileFormats, vm.getFileFormat(file));
        };

        vm.validateFileSize = function(file) {
          return file.size / 1024 / 1024 < vm.maxFileSize;
        };

        vm.validateFileTitle = function(file) {
          return file.title.trim();
        };

        vm.getValidFiles = function() {
          return _.reject(vm.files, {ready: false});
        };

        vm.createReadMethod = function(file) {
          return function() {
            var _this = this,
              reader = new FileReader(),
              preview = new Image(),
              checkCallback = _.after(2, vm.readFileCheck);

            reader.readAsDataURL(file);

            reader.addEventListener('load', readerCallback);
            preview.addEventListener('load', previewCallback);

            function readerCallback(event) {
              _this.contents = event.target.result;
              preview.src = _this.contents;
              reader.removeEventListener('load', readerCallback);
              checkCallback();
            }

            function previewCallback(event) {
              _this.width = preview.width || event.path[0].width;
              _this.height = preview.height || event.path[0].height;
              preview.removeEventListener('load', previewCallback);
              checkCallback();
            }
          };
        };

        vm.readFilesAsDataURL = function() {
          _.each(vm.getValidFiles(), function(file) {
            file.isRead = true;
            file.readAsDataURL();
          });
        };

        vm.validateFile = function(file) {
          return _.every([vm.validateFileFormat(file), vm.validateFileSize(file), vm.validateFileTitle(file)]);
        };

        vm.createFile = function(file) {
          var item = _.extend({}, file);

          item.ide = vm.getIde();
          item.title = vm.getFileName(file);
          item.readAsDataURL = vm.createReadMethod(file);
          item.ready = vm.validateFile(item);
          item.isRead = false;

          return item;
        };

        vm.getMaxAllowableQuantityFiles = function(files) {
          return _.first(_.values(files), vm.maxFiles);
        };

        vm.createReadFileCheckMethod = function() {
          return _.after(_.size(vm.getValidFiles()), vm.emitFilesReadyEvent);
        };

        vm.createFiles = function(files) {
          return _.map(vm.getMaxAllowableQuantityFiles(files), vm.createFile);
        };

        vm.fileIsInProcess = function(file) {
          return _.contains(vm.uploadedBanners, file.ide);
        };

        vm.getFileUploadResult = function(file) {
          return {
            success: _.contains(vm.resolvedBanners, file.ide),
            failed: _.contains(vm.rejectedBanners, file.ide),
            wait: _.contains(vm.uploadedBanners, file.ide)
          };
        };

        vm.inputChangeHandler = function(event) {
          vm.files = vm.createFiles(event.target.files);
          vm.readFileCheck = vm.createReadFileCheckMethod();
          vm.readFilesAsDataURL();
          vm.clearInputFile();
          $scope.$digest();

          if (!_.size(vm.getValidFiles())) {
            vm.emitFilesReadyEvent();
          }
        };

        vm.dragOver = function() {
          input.parentNode.classList.add('drag-over');
        };

        vm.dragEnd = function() {
          input.parentNode.classList.remove('drag-over');
        };

        input.addEventListener('change', vm.inputChangeHandler);
        input.addEventListener('dragenter', vm.dragOver);
        input.addEventListener('dragleave', vm.dragEnd);
        input.addEventListener('drop', vm.dragEnd);

        $scope.$on('$destroy', function() {
          input.removeEventListener('change', vm.inputChangeHandler);
          input.removeEventListener('dragenter', vm.dragOver);
          input.removeEventListener('dragleave', vm.dragEnd);
          input.removeEventListener('drop', vm.dragEnd);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('conditions', {
        url: '/conditions',
        templateUrl: 'app/admin/conditions/partials/conditions.html',
        controller: 'AdminConditionsController',
        controllerAs: 'conditions',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.conditionscontroller.show'])
        }
      })
      .state('conditions.settings', {
        url: '/settings/:conditionId',
        templateUrl: 'app/admin/conditions/partials/settings_condition.html',
        controller: 'AdminConditionsSettingsController',
        controllerAs: 'settings',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.conditionscontroller.edit'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider, ProductsStorage) {
    var list = {
      admin: {
        partnership_program: {
          conditions: [
            'header||conditions.header',
            'create_plan||conditions.create_plan',
            {
              modal_window: [
                'remove||remove_condition.remove',
                'remove_question||remove_condition.remove_question',
                'delete||remove_condition.delete',
                'cancel||remove_condition.cancel'
              ]
            },
            {
              create_edit: {
                main_params: [
                  {
                    form: [
                      'title||main_params.form.title',
                      'merchant||main_params.form.merchant',
                      'type_of_transaction||main_params.form.type_of_transaction',
                      'cpa||main_params.form.cpa',
                      'cpl||main_params.form.cpl',
                      'revenue_share||main_params.form.revenue_share',
                      'hybrid||main_params.form.hybrid',
                      'ggr_minus_bonuses||main_params.form.ggr_minus_bonuses',
                      // 'additional_condition||main_params.form.additional_condition',
                      'none||main_params.form.none',
                      'description||main_params.form.description',
                      'for_deposits||main_params.form.for_deposits',
                      'for_withdrawals||main_params.form.for_withdrawals',
                      'for_deduction||main_params.form.for_deduction',
                      'for_reward_program||main_params.form.for_reward_program',
                      'accrual_of_interest_on_the_upper_interval||main_params.form.accrual_of_interest_on_the_upper_interval',
                      'enable_accrual_of_interest_on_the_upper_interval||main_params.form.enable_accrual_of_interest_on_the_upper_interval',
                      'enable_accrual_of_interest_on_the_each_interval||main_params.form.enable_accrual_of_interest_on_the_each_interval',
                      'transferring_a_negative_commission||main_params.form.transferring_a_negative_commission',
                      'transferring_a_negative_commission_casino||main_params.form.transferring_a_negative_commission_casino',
                      'transferring_a_negative_commission_poker||main_params.form.transferring_a_negative_commission_poker',
                      'set_carryover_per_product||main_params.form.set_carryover_per_product',
                      'disable_transferring_a_negative_commission||main_params.form.disable_transferring_a_negative_commission',
                      'enable_transferring_a_negative_commission||main_params.form.enable_transferring_a_negative_commission',
                      'calculating_profit_method||main_params.form.calculating_profit_method',
                      'added||main_params.form.added',
                      'accumulative||main_params.form.accumulative',
                      'sum_by_products||main_params.form.sum_by_products',
                      {
                        sum_by_merchant_all: [
                          'label||main_params.form.sum_by_merchant_all.label',
                          'yes||main_params.form.sum_by_merchant_all.yes',
                          'no||main_params.form.sum_by_merchant_all.no'
                        ]
                      }
                    ]
                  },
                  'header_create||main_params.header_create',
                  'header_edit||main_params.header_edit'
                ],
                common_button: ['save||common_button.save', 'back||common_button.back'],
                filters: [
                  'filter_all_countries||filters.filter_all_countries',
                  'filter_name||filters.no_name',
                  'add_new_filter||filters.add_new_filter',
                  'countries||filters.countries',
                  'label_filter_name_input||filters.label_filter_name_input',
                  'how_to_determine_the_country||filters.how_to_determine_the_country',
                  'based_on_registration||filters.based_on_registration',
                  'based_on_ip_address||filters.based_on_ip_address',
                  {
                    modal_window: [
                      {
                        remove_filter: [
                          'title||remove_filter.title',
                          'remove_question||remove_filter.remove_question',
                          'delete||remove_filter.delete',
                          'cancel||remove_filter.cancel'
                        ]
                      }
                    ]
                  },
                  {
                    validations: [
                      'invalid_some_filter||validations.invalid_some_filter',
                      'country_required||validations.country_required'
                    ]
                  }
                ],
                steps: [
                  'header||steps.header',
                  {
                    condition_items: {
                      cpa: [
                        'title||condition_items.cpa.title',
                        'enter_condition||condition_items.cpa.enter_condition',
                        'add_condition||condition_items.cpa.add_condition'
                      ],
                      validations: [
                        'item_is_absent||validations.item_is_absent',
                        'can_not_remove_all_items||validations.can_not_remove_all_items',
                        'obtained_result_not_unique||validations.obtained_result_not_unique',
                        'obtained_result_accumulative_not_valid||validations.obtained_result_accumulative_not_valid'
                      ]
                    }
                  },
                  {
                    product: {
                      rs: localesApiProvider.create_fragment_array(ProductsStorage.getProducts(), 'product.rs.')
                    }
                  },
                  {
                    steps_and_step_items: [
                      'enter_condition||steps_and_step_items.enter_condition',
                      'payment_size_empty||steps_and_step_items.payment_size_empty',
                      'step||steps_and_step_items.step',
                      'add_step||steps_and_step_items.add_step',
                      'tooltip_any||steps_and_step_items.tooltip_any',
                      {
                        validations: [
                          'step_is_absent||validations.step_is_absent',
                          'invalid_some_product_steps||validations.invalid_some_product_steps',
                          'can_not_remove_all_steps||validations.can_not_remove_all_steps',
                          'step_invalid||validations.step_invalid',
                          'step_accumulative_invalid||validations.step_accumulative_invalid'
                        ]
                      }
                    ]
                  },
                  {
                    modal_window: {
                      set_condition: [
                        'title||set_condition.title',
                        'cancel||set_condition.cancel',
                        'save||set_condition.save',
                        {
                          form: ['value||set_condition.form.value', 'payment_column||set_condition.form.payment_column']
                        }
                      ],
                      set_step_item: [
                        'cancel||set_step_item.cancel',
                        'save||set_step_item.save',
                        {
                          main_title: ['edit||set_step_item.main_title.edit', 'add||set_step_item.main_title.add']
                        },
                        {
                          form: [
                            'obtained_result||set_step_item.form.obtained_result',
                            'condition_for_comparison||set_step_item.form.condition_for_comparison',
                            'desired_value||set_step_item.form.desired_value'
                          ]
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminConditions', list);
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminConditionsSettingsController', AdminConditionsSettingsController);

  AdminConditionsSettingsController.$inject = [
    '$state',
    '$stateParams',
    'ConditionsApi',
    'ConditionInstance',
    '$mdDialog',
    '_',
    'outputErrors',
    '$q',
    'tableEngine',
    'toastsApi',
    'conditionFilter',
    '$mdTranslate'
  ];

  function AdminConditionsSettingsController(
    $state,
    $stateParams,
    ConditionsApi,
    ConditionInstance,
    $mdDialog,
    _,
    outputErrors,
    $q,
    tableEngine,
    toastsApi,
    conditionFilter,
    $mdTranslate
  ) {
    var vm = this;

    vm.server_constant_defer = $q.defer();
    vm.condition_defer = $q.defer();
    vm.get_countries_defer = $q.defer();
    vm.all_promises = [vm.condition_defer.promise, vm.server_constant_defer.promise, vm.get_countries_defer.promise];
    vm.translate_key = 'AdminConditions';
    vm.main_title = 'main_params.header_create';
    vm.condition_url = '';
    vm.condition_id = $stateParams.conditionId || 0;
    vm.errors = outputErrors.createNew();
    vm.table = tableEngine.getTableByName('conditions');
    vm.condition_instance = null;
    vm.condition = null;
    vm.countriesList = [];
    vm.merchantsList = [];
    vm.merchantId = null;
    vm.commissions_attributes = {
      for_deposits: {commission_type: 'for_deposits', value: 0},
      for_withdrawals: {commission_type: 'for_withdrawals', value: 0},
      for_deduction: {commission_type: 'for_deduction', value: 0},
      for_reward_program: {commission_type: 'for_reward_program', value: 0}
    };
    vm.sumByConditionStepsOptions = [
      {value: true, shortcode: 'main_params.form.sum_by_merchant_all.yes'},
      {value: false, shortcode: 'main_params.form.sum_by_merchant_all.no'}
    ];

    vm.determineCountryList = [
      {value: false, shortcode: 'filters.based_on_registration'},
      {value: true, shortcode: 'filters.based_on_ip_address'}
    ];

    vm.calculatingProfitMethodsList = [
      {value: false, shortcode: 'main_params.form.enable_accrual_of_interest_on_the_each_interval'},
      {value: true, shortcode: 'main_params.form.enable_accrual_of_interest_on_the_upper_interval'}
    ];

    vm.transferringNegativeCommissionList = [
      {value: false, shortcode: 'main_params.form.disable_transferring_a_negative_commission'},
      {value: true, shortcode: 'main_params.form.enable_transferring_a_negative_commission'}
    ];

    // Per-product negative carryover (Option A). The master switch governs the whole deal; the
    // per-product Casino/Poker overrides only apply when the master is "Disable" and the
    // "Set carryover per product" checkbox is ticked. Reset the per-product values whenever they
    // can no longer apply (master back to "Enable", or the checkbox unticked) so no stale override
    // is persisted.
    function resetPerProductNegativeCarryover(condition) {
      condition.set_carryover_per_product = false;
      condition.transferring_a_negative_commission_casino = false;
      condition.transferring_a_negative_commission_poker = false;
    }

    vm.onMasterNegativeCarryoverChange = function(condition) {
      if (condition.transferring_a_negative_commission !== false) {
        resetPerProductNegativeCarryover(condition);
      }
    };

    vm.onSetCarryoverPerProductChange = function(condition) {
      if (!condition.set_carryover_per_product) {
        condition.transferring_a_negative_commission_casino = false;
        condition.transferring_a_negative_commission_poker = false;
      }
    };

    vm.showSumByConditionSteps = function() {
      return _.propertyOf(_.findWhere(vm.merchantsList, {id: vm.merchantId}))('value') === 'All';
    };

    vm.errorHandler = function(errors) {
      if (_.isEmpty(errors)) {
        return toastsApi.toastError();
      }

      vm.errors.inputErrors(errors);
      toastsApi.toastError({locale: _.first(_.flatten(_.values(errors)))});
    };

    vm.changeMerchant = function(conditionInstance) {
      if (!vm.showSumByConditionSteps()) {
        delete conditionInstance.condition.sum_by_merchant_all;
      }
    };

    vm.getShortcode = function(list, value) {
      if (_.isUndefined(value)) {
        return;
      }

      return _.propertyOf(_.findWhere(list, {value: value}))('shortcode');
    };

    vm.getMerchantName = function(merchants, merchantId) {
      return _.propertyOf(_.findWhere(merchants, {id: merchantId}))('value');
    };

    vm.back = function() {
      $state.go('conditions');
    };

    vm.update_condition_instant = function(conditionInstance) {
      vm.set_products_list(conditionInstance);
      vm.set_payment_columns(conditionInstance);
      vm.update_condition_url(conditionInstance);
      conditionInstance.fullUpdate();

      if (conditionInstance.condition.id) {
        conditionInstance.preValidateAll();
        conditionInstance.validateCondition();
      }
    };

    vm.open_modal = function(params, ev) {
      return $mdDialog.show({
        controller: 'AdminConditionsModalController',
        controllerAs: 'conditions',
        templateUrl: params.templateUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: params.data || {}
      });
    };

    vm.save_condition = function() {
      vm.conditionForm.$setSubmitted();
      vm.determineCountryForm.$setSubmitted();

      var isAllValid = vm.Filter.isAllFiltersValid(),
        condition;

      if (vm.conditionForm.$valid && vm.determineCountryForm.$valid && isAllValid) {
        condition = vm.prepareConditionToSend();

        return ConditionsApi.create_or_update(condition, vm.merchantId).then(
          function() {
            vm.table.pagination().then(vm.back, vm.back);
            if (condition.id) {
              toastsApi.toastEditSuccess();
            } else {
              toastsApi.toastCreateSuccess();
            }
          },
          function(response) {
            var errors = response.data && response.data.errors;
            vm.errorHandler(errors);
          }
        );
      }
    };

    vm.set_condition = function(step, ev, instant) {
      if (vm.condition_instance.condition.read_only) {
        return;
      }

      var clone = _.defaults(_.clone(step), {payment_size: null, payment_column: null}),
        params = {
          templateUrl: 'app/admin/conditions/partials/set_condition_form.html',
          data: {
            step: step,
            condition_instance: instant,
            server_constants: vm.constants_from_server,
            is_hybrid: vm.condition_instance.isHybrid
          }
        };

      vm.open_modal(params, ev).then(
        function() {
          if (instant.updatePaymentColumn) {
            instant.updatePaymentColumn(step.payment_column);
          }
          instant.validateStep(step);
          vm.accumulative_validation();
        },
        function() {
          _.extend(step, clone);
        }
      );
    };

    vm.edit_step_item = function(step, conditionStepItem, ev, instant) {
      if (vm.condition_instance.condition.read_only) {
        return;
      }

      var clone = _.defaults(_.clone(conditionStepItem), {
          obtained_result: '',
          condition_for_comparison: null,
          desired_value: null
        }),
        params = {
          templateUrl: 'app/admin/conditions/partials/step_condition_item.html',
          data: {
            step: step,
            condition: conditionStepItem,
            condition_instance: instant,
            server_constants: vm.constants_from_server,
            is_hybrid: vm.condition_instance.isHybrid
          }
        };

      vm.open_modal(params, ev).then(
        function() {
          instant.updateObtainedResult(conditionStepItem.obtained_result);
          instant.validateStep(step);
        },
        function() {
          _.extend(conditionStepItem, clone);
        }
      );
    };

    vm.add_condition_for_all = function(ev, instant) {
      var params = {
        templateUrl: 'app/admin/conditions/partials/step_condition_item.html',
        data: {
          condition: {},
          condition_instance: instant,
          server_constants: vm.constants_from_server,
          is_hybrid: vm.condition_instance.isHybrid,
          payment_list: vm.condition_instance.payment_columns,
          is_accumulative: vm.condition_instance.condition.calculating_profit_method === 'accumulative'
        }
      };

      vm.open_modal(params, ev).then(function(conditionItem) {
        instant.addConditionItem(conditionItem);
        instant.validateCondition();
        vm.accumulative_validation();
      });
    };

    vm.edit_item = function(conditionItem, ev, instant) {
      if (conditionItem._destroy === 1 || vm.condition_instance.condition.read_only) {
        return;
      }

      var clone = _.defaults(_.clone(conditionItem), {
          obtained_result: '',
          condition_for_comparison: null,
          desired_value: null
        }),
        params = {
          templateUrl: 'app/admin/conditions/partials/step_condition_item.html',
          data: {
            condition: conditionItem,
            condition_instance: instant,
            server_constants: vm.constants_from_server,
            is_hybrid: vm.condition_instance.isHybrid,
            payment_list: vm.condition_instance.payment_columns,
            is_accumulative: vm.condition_instance.condition.calculating_profit_method === 'accumulative'
          }
        };

      vm.open_modal(params, ev).then(
        function() {
          vm.accumulative_validation();
        },
        function() {
          _.extend(conditionItem, clone);
        }
      );
    };

    vm.create_instant = function(condition) {
      return ConditionInstance.createNew(condition);
    };

    vm.change_type_of_transaction = function() {
      var condition = _.omit(vm.condition_instance.condition, [
        'condition_steps_attributes',
        'condition_items_attributes'
      ]);

      _.each(vm.Filter.filters, function(filter) {
        filter.condition_instance = vm.createConditionInstanceForFilter(filter, angular.copy(condition));
      });

      vm.condition_instance = vm.Filter.currentFilter.condition_instance;
      vm.change_commissions_attributes();
    };

    vm.set_products_list = function(conditionInstance) {
      if (conditionInstance.productsList) {
        conditionInstance.productsList(vm.constants_from_server.condition_steps.obtained_result);
      }
    };

    vm.set_payment_columns = function(conditionInstance) {
      if (conditionInstance.setPaymentColumns) {
        conditionInstance.setPaymentColumns(vm.constants_from_server.condition_steps.payment_column);
      }
    };

    vm.update_condition_url = function(conditionInstance) {
      vm.condition_url = 'app/admin/conditions/partials/' + conditionInstance.condition.type_of_transaction + '.html';
    };

    vm.accumulative_validation = function() {
      var value = vm.condition_instance.condition.calculating_profit_method;

      _.each(vm.Filter.filters, function(filter) {
        filter.condition_instance.condition.calculating_profit_method = value;

        if (filter.condition_instance.validateAccumulative) {
          filter.condition_instance.validateAccumulative();
        }
      });
    };

    vm.filterCommissionsAttrs = function() {
      var type = vm.condition_instance.condition.type_of_transaction;

      return type !== 'revenue_share' && type !== 'hybrid'
        ? _.omit(vm.commissions_attributes, ['for_reward_program', 'for_deduction'])
        : vm.commissions_attributes;
    };

    vm.change_commissions_attributes = function() {
      vm.condition_instance.updateCommissionsAttributes(vm.filterCommissionsAttrs());
    };

    vm.prepareConditionToSend = function() {
      var condition = _.extend(
        {},
        _.omit(vm.condition_instance.condition, ['condition_steps_attributes', 'condition_items_attributes'])
      );

      condition.condition_filters_attributes = vm.Filter.getFilters();

      return condition;
    };

    vm.buildConditionForFilter = function() {
      return _.extend(
        {},
        _.omit(vm.condition_instance.condition, ['condition_steps_attributes', 'condition_items_attributes'])
      );
    };

    vm.buildConditionObject = function(filter) {
      var condition = _.extend({}, _.omit(vm.condition, 'condition_filters_attributes'));

      condition.condition_items_attributes = filter.condition_items_attributes || [];
      condition.condition_steps_attributes = filter.condition_steps_attributes || [];

      return condition;
    };

    vm.conditionDecorator = function(self, method, filterIde) {
      return function() {
        var isValid = method.apply(self, arguments);

        vm.Filter.invalidFiltersControl(isValid, filterIde);

        return isValid;
      };
    };

    vm.createConditionInstanceForFilter = function(filter, condition) {
      var instance = vm.create_instant(condition);

      instance.validateCondition = vm.conditionDecorator(instance, instance.validateCondition, filter.ide);
      vm.update_condition_instant(instance);
      instance.validateCondition();

      return instance;
    };

    vm.filterTemplates = [
      {
        ide: 0,
        _destroy: 0,
        show: false,
        aasm_state: 'default',
        type: 'ConditionFilterCountry',
        name: 'filters.filter_all_countries',
        value: [],
        condition_items_attributes: [],
        condition_steps_attributes: []
      }
    ];

    vm.filterOptions = {
      readOnly: false,
      savedFiled: 'country_code',
      showedField: 'name',
      chooseFilter: function(filter) {
        if (!_.isEmpty(vm.condition_instance) && vm.condition_instance.validateCondition) {
          var commonFields = ['type_of_transaction', 'title', 'description', 'commissions_attributes', 'country_by_ip'];

          if (vm.condition_instance.condition.calculating_profit_method) {
            commonFields.push('calculating_profit_method');
          }

          _.extend(filter.condition_instance.condition, _.pick(vm.condition_instance.condition, commonFields));

          vm.condition_instance.validateCondition();
        }

        vm.condition_instance = filter.condition_instance;
      },
      addFilter: function(filter) {
        filter.condition_instance = vm.createConditionInstanceForFilter(filter, vm.buildConditionForFilter());

        return filter;
      },
      removeFilter: function(filter, ev) {
        var confirm = $mdDialog
          .confirm()
          .title($mdTranslate.instant(vm.translate_key, 'remove_filter.title'))
          .textContent(
            $mdTranslate.instant(vm.translate_key, 'remove_filter.remove_question', {name: filter.name || filter.ide})
          )
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .ok($mdTranslate.instant(vm.translate_key, 'remove_filter.delete'))
          .cancel($mdTranslate.instant(vm.translate_key, 'remove_filter.cancel'));

        return $mdDialog.show(confirm);
      },
      isAllFiltersValid: function(filter) {
        return filter.condition_instance.validateCondition() && !filter.noCountryChoosed;
      },
      getFilters: function(filter) {
        return {
          condition_steps_attributes: filter.condition_instance.condition.condition_steps_attributes || [],
          condition_items_attributes: filter.condition_instance.condition.condition_items_attributes || []
        };
      },
      implementsCondition: function(filter) {
        filter.condition_instance = vm.createConditionInstanceForFilter(filter, vm.buildConditionObject(filter));

        return filter;
      }
    };

    vm.initFilter = function(condition, countriesList, filterOptions) {
      vm.filterOptions.readOnly = condition.read_only;
      vm.Filter = conditionFilter.createNew(condition.condition_filters_attributes, countriesList, filterOptions);

      vm.Filter.implementsCondition();
      vm.Filter.chooseFilter(_.findWhere(vm.Filter.filters, {aasm_state: 'default'}));
    };

    vm.getKeyOfValue = function(value, instant, dataSrc1, dataSrc2) {
      if (!vm.constants_from_server || !vm.condition_instance) {
        return;
      }

      var data = vm.constants_from_server[dataSrc1][dataSrc2],
        list;

      if (instant.current_product) {
        list = vm.condition_instance.isHybrid
          ? data['hybrid'][instant.condition.type_of_transaction][instant.current_product]
          : data[instant.condition.type_of_transaction][instant.current_product];
      }

      if (instant.conditions_for_all) {
        list = vm.condition_instance.isHybrid
          ? data['hybrid'][instant.condition.type_of_transaction]
          : data[instant.condition.type_of_transaction];
      }
      return _.findKey(list, function(v) {
        return v === value;
      });
    };

    vm.methods = {
      set_condition: vm.set_condition,
      edit_step_item: vm.edit_step_item,
      add_condition_for_all: vm.add_condition_for_all,
      edit_item: vm.edit_item,
      getKeyOfValue: vm.getKeyOfValue
    };

    $q.all(vm.all_promises).then(
      function() {
        var defaultCondition = {
          type_of_transaction: _.first(_.values(vm.condition_classes)),
          condition_filters_attributes: vm.filterTemplates
        };

        vm.condition = vm.condition || defaultCondition;
        vm.initFilter(vm.condition, vm.countriesList, vm.filterOptions);
      },
      function() {
        toastsApi.toastError();
      }
    );

    ConditionsApi.getCountries().then(
      function(response) {
        vm.countriesList = response.data;

        vm.get_countries_defer.resolve();
      },
      function() {
        vm.get_countries_defer.reject();
      }
    );

    ConditionsApi.getMerchantsList().then(
      function(response) {
        vm.merchantsList = response.data;
        vm.merchantName = vm.getMerchantName(vm.merchantsList, vm.merchantId);
      },
      function() {
        toastsApi.toastError();
      }
    );

    ConditionsApi.get().then(
      function(response) {
        vm.constants_from_server = response.data.constants;
        vm.condition_classes = vm.constants_from_server.condition.type_of_transaction;
        vm.calculating_profit_methods = vm.constants_from_server.condition.calculating_profit_method_hybrid;

        vm.server_constant_defer.resolve();
      },
      function() {
        vm.server_constant_defer.reject();
      }
    );

    if (vm.condition_id) {
      vm.main_title = 'main_params.header_edit';

      ConditionsApi.edit(vm.condition_id).then(
        function(response) {
          var condition = response.data.condition;

          vm.condition = condition;
          vm.commissions_attributes = _.size(vm.condition.commissions_attributes)
            ? _.extend(vm.commissions_attributes, _.indexBy(vm.condition.commissions_attributes, 'commission_type'))
            : vm.commissions_attributes;
          vm.merchantId = vm.condition.merchant_id;
          vm.merchantName = vm.getMerchantName(vm.merchantsList, vm.merchantId);

          vm.condition_defer.resolve();
        },
        function() {
          vm.condition_defer.reject();
        }
      );
    } else {
      vm.condition_defer.resolve();
    }
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminConditionsModalController', AdminConditionsModalController);

  AdminConditionsModalController.$inject = ['$scope', '$mdTranslate', '$mdDialog', '_', 'outputErrors'];

  function AdminConditionsModalController($scope, $mdTranslate, $mdDialog, _, outputErrors) {
    var vm = this,
      instant = vm.condition_instance,
      instant_cond = instant.condition,
      steps = instant.getCurrentStepsList(),
      obtained_values;

    vm.translate_key = 'AdminConditions';
    vm.title_shortcode =
      vm.condition && vm.condition.id ? 'set_step_item.main_title.edit' : 'set_step_item.main_title.add';
    vm.main_title = $mdTranslate.instant(vm.translate_key, vm.title_shortcode);
    vm.errors = outputErrors.createNew();
    vm.server = vm.step ? vm.server_constants.condition_steps : vm.server_constants.condition_items;
    vm.comparison_list = vm.server.condition_for_comparison;

    if (instant.current_product) {
      vm.payment_columns = vm.is_hybrid
        ? vm.server.payment_column['hybrid'][instant_cond.type_of_transaction][instant.current_product]
        : vm.server.payment_column[instant_cond.type_of_transaction][instant.current_product];

      vm.obtained_list = vm.is_hybrid
        ? vm.server.obtained_result['hybrid'][instant_cond.type_of_transaction][instant.current_product]
        : vm.server.obtained_result[instant_cond.type_of_transaction][instant.current_product];
    }

    if (instant.conditions_for_all) {
      vm.payment_columns = vm.is_hybrid
        ? vm.server.obtained_result['hybrid'][instant_cond.type_of_transaction]
        : vm.server.obtained_result[instant_cond.type_of_transaction];

      vm.obtained_list = vm.is_hybrid
        ? vm.server.obtained_result['hybrid'][instant_cond.type_of_transaction]
        : vm.server.obtained_result[instant_cond.type_of_transaction];
    }

    obtained_values = _.values(vm.obtained_list);

    if (vm.condition && _.size(obtained_values) === 1) {
      vm.condition.obtained_result = vm.condition.obtained_result || _.first(obtained_values);
    }

    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.hide = function(data) {
      $mdDialog.hide(data || vm);
    };

    vm.set = function() {
      vm.setForm.$setSubmitted();

      if (vm.setForm.$valid) {
        vm.hide(vm.step);
      }
    };

    vm.any_controll = function(key) {
      return key === 'any' && vm.step ? !(_.size(steps) > 1) : true;
    };

    vm.check_any_parametr = function() {
      if (vm.condition.condition_for_comparison === 'any') {
        vm.condition.desired_value = null;
      }
    };

    vm.validate_items_obtained_result = function() {
      if (vm.step) {
        return;
      }

      var errors = [],
        mainPart = 'admin.partnership_program.conditions.create_edit.steps.condition_items.validations';

      if (instant.itemsUniqueObtainedResult && instant.itemsUniqueObtainedResult(vm.condition)) {
        errors.push(mainPart + '.obtained_result_not_unique');
      }

      if (
        instant.validateItemsObtainedResult &&
        vm.is_accumulative &&
        instant.validateItemsObtainedResult(vm.condition, vm.payment_list)
      ) {
        errors.push(mainPart + '.obtained_result_accumulative_not_valid');
      }

      if (_.size(errors)) {
        vm.errors.inputErrors({obtained_result: errors});
      }
    };

    vm.save = function() {
      vm.addConditionForm.$setSubmitted();

      if (vm.addConditionForm.$valid) {
        vm.hide(vm.condition);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminConditionsController', AdminConditionsController);

  AdminConditionsController.$inject = [
    '$scope',
    '$state',
    '$mdTranslate',
    'tableEngine',
    'ConditionsApi',
    '$mdDialog',
    '_',
    'outputErrors',
    'toastsApi'
  ];

  function AdminConditionsController(
    $scope,
    $state,
    $mdTranslate,
    tableEngine,
    ConditionsApi,
    $mdDialog,
    _,
    outputErrors,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminConditions';
    vm.errors = outputErrors.createNew();

    vm.edit_condition = function(id) {
      $state.go('conditions.settings', {conditionId: id});
    };

    vm.create_condition = function() {
      $state.go('conditions.settings');
    };

    vm.removeCondition = function(condition_id, ev) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'remove_condition.remove'))
        .textContent($mdTranslate.instant(vm.translate_key, 'remove_condition.remove_question'))
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, 'remove_condition.delete'))
        .cancel($mdTranslate.instant(vm.translate_key, 'remove_condition.cancel'));

      $mdDialog.show(confirm).then(function() {
        ConditionsApi.destroy(condition_id).then(
          function() {
            vm.table.removeListItem();
            toastsApi.toastRemoveSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.table = tableEngine.init({
      api: ConditionsApi,
      name: 'conditions',
      mobile: {
        defaultColumns: ['title']
      },
      buttons: {
        url: 'app/admin/conditions/partials/table.html',
        methods: {
          edit_condition: vm.edit_condition,
          removeCondition: vm.removeCondition
        }
      }
    });

    ConditionsApi.conditions_list().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('type_of_transaction', {
          localizied: true,
          locales: {
            translate_key: 'AdminConditions',
            shortcode: 'main_params.form.{{shortcode_part}}',
            shortcode_part_in_value: true
          }
        });
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('ConditionInstance', ConditionInstance);

  ConditionInstance.$inject = ['projectCurrency', '_'];

  function ConditionInstance(projectCurrency, _) {
    var ConditionInstance = {},
      conditionClasses = {
        cpa: Cpa,
        cpl: Cpl,
        revenue_share: RevenueShare,
        ggr_minus_bonuses: GgrMinusBonuses,
        hybrid: Hybrid
      };

    function Condition(condition) {
      this.condition = condition || {};
      this.filtered_steps = this.condition.condition_steps_attributes || [];
      this.main_obtained_result = null;

      this.condition.commissions_attributes = this.condition.commissions_attributes || [];
      this.condition.condition_steps_attributes = this.condition.condition_steps_attributes || [];
    }

    Condition.prototype.newStepsList = function() {
      this.filtered_steps = this.condition.condition_steps_attributes;
    };

    Condition.prototype.isAnyExist = function() {
      return _.contains(
        _.pluck(
          _.flatten(_.pluck(this.getCurrentStepsList(), 'condition_step_items_attributes')),
          'condition_for_comparison'
        ),
        'any'
      );
    };

    Condition.prototype.clearSteps = function() {
      this.condition.condition_steps_attributes = [];
      this.newStepsList();
    };

    Condition.prototype.getCurrentStepsList = function() {
      return _.reject(this.filtered_steps, {_destroy: 1});
    };

    Condition.prototype.updateObtainedResult = function(obtainedResult) {
      var _this = this,
        steps = this.getCurrentStepsList();

      this.main_obtained_result = obtainedResult || this.main_obtained_result;

      _.each(steps, function(step) {
        if (!_.size(step.condition_step_items_attributes)) {
          step.condition_step_items_attributes.push({});
        }

        _.extend(_.first(step.condition_step_items_attributes), {obtained_result: _this.main_obtained_result});
      });
    };

    Condition.prototype.fullUpdate = function() {
      var _this = this,
        steps;

      this.newStepsList();

      steps = this.getCurrentStepsList();

      this.main_obtained_result = null;

      if (angular.isDefined(this.main_payment_column)) {
        this.main_payment_column = null;
      }

      _.each(steps, function(step) {
        if (angular.isDefined(_this.main_payment_column) && step.payment_column) {
          _this.main_payment_column = step.payment_column;
        }

        _this.main_obtained_result =
          _.propertyOf(_.first(step.condition_step_items_attributes))('obtained_result') || _this.main_obtained_result;
      });

      this.updateObtainedResult();
    };

    Condition.prototype.installDestroyMark = function(item, value) {
      if (_.isObject(item)) {
        item._destroy = value;
      }
      this.fullUpdate();
    };

    Condition.prototype.ideStepItem = function() {
      var item = _.max(this.condition.condition_steps_attributes, function(v) {
        return v.ide;
      });
      return _.isEmpty(item) ? 1 : item.ide + 1;
    };

    Condition.prototype.addStep = function(step) {
      step.ide = this.ideStepItem();
      step.product = this.current_product || null;
      step.payment_column = this.main_payment_column || null;
      step.is_valid = false;
      step._destroy = 0;
      step.type_in_part_condition = this.condition.type_of_transaction;
      step.condition_step_items_attributes.push({obtained_result: this.main_obtained_result});
      this.condition.condition_steps_attributes.push(step);
      this.fullUpdate();
    };

    Condition.prototype.removeStep = function(step) {
      this.condition.condition_steps_attributes = _.reject(
        this.condition.condition_steps_attributes,
        step.id ? {id: step.id} : {ide: step.ide}
      );
      this.fullUpdate();
    };

    Condition.prototype.validateStepItems = function(step) {
      var item = _.first(step.condition_step_items_attributes);

      return !!(
        item.obtained_result &&
        item.condition_for_comparison &&
        (item.condition_for_comparison === 'any' ? _.isNull(item.desired_value) : _.isNumber(item.desired_value))
      );
    };

    Condition.prototype.preValidateAll = function() {
      var _this = this;

      _.each(_this.condition.condition_steps_attributes, function(v) {
        v._destroy = 0;
        _this.validateStep(v);
      });
      _.each(_this.condition.condition_items_attributes, function(v) {
        v._destroy = 0;
      });
    };

    Condition.prototype.validateCondition = function() {
      var result,
        steps = this.condition.condition_steps_attributes,
        steps_count = _.size(steps),
        invalid_steps = _.size(_.where(steps, {is_valid: false, _destroy: 0})),
        acaccum_invalid = _.size(_.where(steps, {is_accumulative_invalid: true, _destroy: 0})),
        destroy_steps = _.size(_.where(steps, {_destroy: 1})),
        destroy_all_steps = steps_count >= 1 ? steps_count === destroy_steps : false,
        items = this.condition.condition_items_attributes,
        items_count = _.size(items),
        destroy_items = _.size(_.where(items, {_destroy: 1})),
        destroy_all_items = items_count >= 1 ? items_count === destroy_items : false;

      result = [steps_count, !invalid_steps, !acaccum_invalid, !destroy_all_steps];

      this.no_steps = !steps_count;
      this.destroy_all_steps = destroy_all_steps;

      if (items) {
        this.no_items = !items_count;
        this.destroy_all_items = destroy_all_items;

        result = result.concat([items_count, !destroy_all_items]);
      }

      return _.every(result);
    };

    Condition.prototype.updateCommissionsAttributes = function(commissionsAttributes) {
      this.condition.commissions_attributes = _.flatten(_.values(_.groupBy(commissionsAttributes, 'commission_type')));
    };

    function Cpa() {
      Condition.apply(this, arguments);

      this.condition.type_of_transaction = this.condition.type_of_transaction || 'cpa';
      this.condition.condition_items_attributes = this.condition.condition_items_attributes || [];
      this.condition_mark = projectCurrency.getCurrency();
      this.conditions_for_all = true;

      this.clearingFields();
    }

    Cpa.prototype = Object.create(Condition.prototype);
    Cpa.prototype.constructor = Cpa;

    Cpa.prototype.clearingFields = function() {
      delete this.condition.accrual_of_interest_on_the_upper_interval;
      delete this.condition.transferring_a_negative_commission;
      delete this.condition.transferring_a_negative_commission_casino;
      delete this.condition.transferring_a_negative_commission_poker;
      delete this.condition.set_carryover_per_product;
      delete this.condition.sum_by_products;
    };

    Cpa.prototype.removeConditionItem = function(condition) {
      this.condition.condition_items_attributes = _.reject(
        this.condition.condition_items_attributes,
        condition.id ? {id: condition.id} : {ide: condition.ide}
      );
    };

    Cpa.prototype.ideItem = function() {
      var item = _.max(this.condition.condition_items_attributes, function(v) {
        return v.ide;
      });
      return _.isEmpty(item) ? 1 : item.ide + 1;
    };

    Cpa.prototype.addConditionItem = function(condition) {
      condition.ide = this.ideItem();
      condition._destroy = 0;
      this.condition.condition_items_attributes.push(condition);
    };

    Cpa.prototype.validateStep = function(step) {
      step.is_valid = _.isNumber(step.payment_size) && this.validateStepItems(step);
    };

    Cpa.prototype.itemsUniqueObtainedResult = function(condition) {
      var isIde = condition.ide ? {ide: condition.ide} : null,
        params = condition.id ? {id: condition.id} : isIde,
        list = _.reject(this.condition.condition_items_attributes, {_destroy: 1}),
        items = params ? _.reject(list, params) : list,
        result = _.isEmpty(_.findWhere(items, {obtained_result: condition.obtained_result}));

      return !result;
    };

    Cpa.prototype.itemsUniqueObtainedResultAll = function() {
      var items = _.reject(this.condition.condition_items_attributes, {_destroy: 1}),
        arr = _.pluck(items, 'obtained_result'),
        unique = _.size(arr) === _.size(_.uniq(arr));

      this.obtained_result_not_unique = !unique;

      return unique;
    };

    Cpa.prototype.validateItemsObtainedResult = function(item, paymentColumns) {
      var isEdit = item.id || item.ide ? _.pick({id: item.id, ide: item.ide}, item.id ? 'id' : 'ide') : false,
        list = _.reject(this.condition.condition_items_attributes, {_destroy: 1}),
        items = isEdit ? _.reject(list, isEdit) : list,
        diff = _.difference(paymentColumns, _.pluck(items, 'obtained_result')),
        result = _.size(paymentColumns) !== _.size(diff) && _.contains(paymentColumns, item.obtained_result);

      return result;
    };

    Cpa.prototype.checkItemsObtainedResult = function(paymentColumns) {
      var items = _.reject(this.condition.condition_items_attributes, {_destroy: 1}),
        diff = _.difference(paymentColumns, _.pluck(items, 'obtained_result')),
        result = _.size(paymentColumns) - _.size(diff) <= 1;

      this.is_accumulative_invalid = !result;

      return result;
    };

    Cpa.prototype.resetItemsAccumulativeValidation = function() {
      this.is_accumulative_invalid = false;
    };

    Cpa.prototype.validateCondition = function() {
      return Condition.prototype.validateCondition.call(this, arguments) && this.itemsUniqueObtainedResultAll();
    };

    function Cpl() {
      Condition.apply(this, arguments);

      this.condition.type_of_transaction = this.condition.type_of_transaction || 'cpl';
      this.condition_mark = projectCurrency.getCurrency();
      this.conditions_for_all = true;

      this.clearingFields();
    }

    Cpl.prototype = Object.create(Condition.prototype);
    Cpl.prototype.constructor = Cpl;

    Cpl.prototype.clearingFields = function() {
      delete this.condition.accrual_of_interest_on_the_upper_interval;
      delete this.condition.transferring_a_negative_commission;
      delete this.condition.transferring_a_negative_commission_casino;
      delete this.condition.transferring_a_negative_commission_poker;
      delete this.condition.set_carryover_per_product;
      delete this.condition.sum_by_products;
      delete this.condition.condition_items_attributes;
    };

    Cpl.prototype.validateStep = function(step) {
      step.is_valid = _.isNumber(step.payment_size) && this.validateStepItems(step);
    };

    Cpl.prototype.resetItemsAccumulativeValidation = function() {
      this.is_accumulative_invalid = false;
    };

    Cpl.prototype.validateCondition = function() {
      return Condition.prototype.validateCondition.call(this, arguments);
    };

    function RevenueShare() {
      Condition.apply(this, arguments);

      this.checkboxes_fields = true;
      this.main_payment_column = null;
      this.condition_mark = '%';
      this.products_list = [];
      this.invalid_products = [];
      this.current_product = '';

      this.condition.type_of_transaction = this.condition.type_of_transaction || 'revenue_share';
      this.condition.accrual_of_interest_on_the_upper_interval = angular.isDefined(
        this.condition.accrual_of_interest_on_the_upper_interval
      )
        ? this.condition.accrual_of_interest_on_the_upper_interval
        : true;
      this.condition.transferring_a_negative_commission = angular.isDefined(
        this.condition.transferring_a_negative_commission
      )
        ? this.condition.transferring_a_negative_commission
        : true;
      // Per-product negative carryover (casino/poker). Default OFF so deals stay on the existing
      // combined-carryover path until an admin explicitly enables a product (opt-in).
      this.condition.transferring_a_negative_commission_casino = angular.isDefined(
        this.condition.transferring_a_negative_commission_casino
      )
        ? this.condition.transferring_a_negative_commission_casino
        : false;
      this.condition.transferring_a_negative_commission_poker = angular.isDefined(
        this.condition.transferring_a_negative_commission_poker
      )
        ? this.condition.transferring_a_negative_commission_poker
        : false;
      // Option A: tick the "Set carryover per product" checkbox (reveals the per-product dropdowns)
      // only when separation was set up — i.e. a product was explicitly Enabled. UI-only, not sent.
      this.condition.set_carryover_per_product =
        this.condition.transferring_a_negative_commission_casino === true ||
        this.condition.transferring_a_negative_commission_poker === true;
      this.condition.sum_by_products = angular.isDefined(this.condition.sum_by_products)
        ? this.condition.sum_by_products
        : true;

      this.clearingFields();
    }

    RevenueShare.prototype = Object.create(Condition.prototype);
    RevenueShare.prototype.constructor = RevenueShare;

    RevenueShare.prototype.clearingFields = function() {
      delete this.condition.condition_items_attributes;
    };

    RevenueShare.prototype.filteredStepsList = function(product) {
      return _.filter(this.condition.condition_steps_attributes, function(item) {
        return item.product === product;
      });
    };

    RevenueShare.prototype.newStepsList = function() {
      this.filtered_steps = this.filteredStepsList(this.current_product);
    };

    RevenueShare.prototype.addClassForCross = function(product) {
      var steps = _.filter(this.condition.condition_steps_attributes, function(item) {
        return item.product === product && item._destroy === 0;
      });

      return !_.size(steps);
    };

    RevenueShare.prototype.fullUpdate = function() {
      Condition.prototype.fullUpdate.apply(this, arguments);
      this.validateProductSteps();
    };

    RevenueShare.prototype.preValidateAll = function() {
      Condition.prototype.preValidateAll.apply(this, arguments);
      this.validateProductSteps();
    };

    RevenueShare.prototype.updatePaymentColumn = function(paymentColumn) {
      var _this = this,
        steps = this.getCurrentStepsList();

      this.main_payment_column = paymentColumn || null;

      _.each(steps, function(v) {
        v.payment_column = _this.main_payment_column;
      });
    };

    RevenueShare.prototype.chooseProduct = function(product) {
      if (this.current_product === product) {
        return;
      }

      this.current_product = product;
      this.fullUpdate();
    };

    RevenueShare.prototype.filterProductsParams = function(params) {
      var isObj = _.isObject(params) ? _.keys(params) : [],
        list = _.isArray(params) ? params : isObj;

      if (this.condition.id && this.condition.read_only) {
        list = _.uniq(_.pluck(this.condition.condition_steps_attributes, 'product'));
      }

      return list;
    };

    RevenueShare.prototype.productsList = function(params) {
      this.products_list = this.filterProductsParams(params[this.condition.type_of_transaction]);
      this.current_product = _.first(this.products_list);
    };

    RevenueShare.prototype.removeProductSteps = function(product) {
      var _this = this;

      this.condition.condition_steps_attributes = _.filter(this.condition.condition_steps_attributes, function(v) {
        if (v.id && v.product === product) {
          _this.installDestroyMark(v, 1);
        }

        return v.id ? true : v.product !== product;
      });

      this.fullUpdate();
    };

    RevenueShare.prototype.validateStep = function(step) {
      step.is_valid = _.isNumber(step.payment_size) && !!step.payment_column && this.validateStepItems(step);
    };

    RevenueShare.prototype.validateProductSteps = function() {
      var acaccumulative_invalid_steps = _.where(this.condition.condition_steps_attributes, {
          is_valid: false,
          _destroy: 0
        }),
        invalid_steps = _.where(this.condition.condition_steps_attributes, {
          is_accumulative_invalid: true,
          _destroy: 0
        }),
        all_invalid_steps = Array.prototype.concat(acaccumulative_invalid_steps, invalid_steps);

      this.invalid_products = _.without(_.uniq(_.pluck(all_invalid_steps, 'product')), this.current_product);
    };

    RevenueShare.prototype.checkStepPaymentColumn = function(paymentColumns, itemAttributes) {
      var intersection = _.intersection(
          _.pluck(_.reject(itemAttributes, {_destroy: 1}), 'obtained_result'),
          paymentColumns
        ),
        steps = this.condition.condition_steps_attributes;

      _.each(steps, function(v) {
        v.is_accumulative_invalid = !!(
          v.payment_column &&
          _.size(intersection) &&
          !_.contains(intersection, v.payment_column)
        );
      });

      this.validateProductSteps();

      return !_.some(_.pluck(steps, 'is_accumulative_invalid'));
    };

    RevenueShare.prototype.resetStepAccumulativeValidation = function() {
      _.each(this.condition.condition_steps_attributes, function(v) {
        v.is_accumulative_invalid = false;
      });

      this.validateProductSteps();
    };

    function GgrMinusBonuses() {
      RevenueShare.apply(this, arguments);

      this.condition.type_of_transaction = this.condition.type_of_transaction || 'ggr_minus_bonuses';
    }

    GgrMinusBonuses.prototype = Object.create(RevenueShare.prototype);
    GgrMinusBonuses.prototype.constructor = GgrMinusBonuses;

    function Hybrid(condition) {
      this.cpa = new Cpa();
      this.revenue_share = new RevenueShare();
      this.condition = condition || {};
      this.payment_columns = [];
      this.checkboxes_fields = true;
      this.isHybrid = true;
      this.cpa.condition.read_only = condition.read_only;
      this.revenue_share.condition.read_only = condition.read_only;

      this.condition.commissions_attributes = this.condition.commissions_attributes || [];
      this.condition.condition_steps_attributes = this.condition.condition_steps_attributes || [];
      this.condition.condition_items_attributes = this.condition.condition_items_attributes || [];
      this.condition.calculating_profit_method = this.condition.calculating_profit_method;
      this.condition.accrual_of_interest_on_the_upper_interval = angular.isDefined(
        this.condition.accrual_of_interest_on_the_upper_interval
      )
        ? this.condition.accrual_of_interest_on_the_upper_interval
        : true;
      this.condition.transferring_a_negative_commission = angular.isDefined(
        this.condition.transferring_a_negative_commission
      )
        ? this.condition.transferring_a_negative_commission
        : true;
      // Per-product negative carryover (casino/poker). Default OFF so deals stay on the existing
      // combined-carryover path until an admin explicitly enables a product (opt-in).
      this.condition.transferring_a_negative_commission_casino = angular.isDefined(
        this.condition.transferring_a_negative_commission_casino
      )
        ? this.condition.transferring_a_negative_commission_casino
        : false;
      this.condition.transferring_a_negative_commission_poker = angular.isDefined(
        this.condition.transferring_a_negative_commission_poker
      )
        ? this.condition.transferring_a_negative_commission_poker
        : false;
      // Option A: tick the "Set carryover per product" checkbox (reveals the per-product dropdowns)
      // only when separation was set up — i.e. a product was explicitly Enabled. UI-only, not sent.
      this.condition.set_carryover_per_product =
        this.condition.transferring_a_negative_commission_casino === true ||
        this.condition.transferring_a_negative_commission_poker === true;
      this.condition.sum_by_products = angular.isDefined(this.condition.sum_by_products)
        ? this.condition.sum_by_products
        : true;

      this.setStepsAndItems();
    }

    Hybrid.prototype.setPaymentColumns = function(params) {
      this.payment_columns = _.uniq(
        _.flatten(
          _.map(_.values(params[this.condition.type_of_transaction]['revenue_share']), function(v) {
            return _.values(v);
          })
        )
      );
    };

    Hybrid.prototype.setStepsAndItems = function() {
      var _this = this;

      this.cpa.condition.condition_items_attributes = this.condition.condition_items_attributes;

      _.each(this.condition.condition_steps_attributes, function(v) {
        _this[v.type_in_part_condition].condition.condition_steps_attributes.push(v);
      });
    };

    Hybrid.prototype.updateStepsAndItems = function() {
      this.condition.condition_items_attributes = this.cpa.condition.condition_items_attributes;
      this.condition.condition_steps_attributes = Array.prototype.concat(
        this.cpa.condition.condition_steps_attributes,
        this.revenue_share.condition.condition_steps_attributes
      );
    };

    Hybrid.prototype.validateCondition = function() {
      this.updateStepsAndItems();

      return _.every([
        this.cpa.validateCondition(),
        this.revenue_share.validateCondition(),
        this.validateAccumulative()
      ]);
    };

    Hybrid.prototype.fullUpdate = function() {
      this.revenue_share.fullUpdate();
      this.cpa.fullUpdate();
    };

    Hybrid.prototype.preValidateAll = function() {
      this.revenue_share.preValidateAll();
      this.cpa.preValidateAll();
    };

    Hybrid.prototype.clearSteps = function() {
      this.revenue_share.clearSteps();
      this.cpa.clearSteps();
    };

    Hybrid.prototype.productsList = function(params) {
      this.revenue_share.productsList(params[this.condition.type_of_transaction]);
    };

    Hybrid.prototype.resetAccumulativeValidation = function() {
      this.revenue_share.resetStepAccumulativeValidation();
      this.cpa.resetItemsAccumulativeValidation();

      return true;
    };

    Hybrid.prototype.executeAccumulativeValidation = function() {
      return _.every([
        this.cpa.checkItemsObtainedResult(this.payment_columns),
        this.revenue_share.checkStepPaymentColumn(this.payment_columns, this.cpa.condition.condition_items_attributes)
      ]);
    };

    Hybrid.prototype.validateAccumulative = function() {
      return this.condition.calculating_profit_method === 'accumulative'
        ? this.executeAccumulativeValidation()
        : this.resetAccumulativeValidation();
    };

    Hybrid.prototype.updateCommissionsAttributes = function(commissionsAttributes) {
      this.condition.commissions_attributes = _.flatten(_.values(_.groupBy(commissionsAttributes, 'commission_type')));
    };

    ConditionInstance.createNew = function(condition) {
      var classFn = condition ? conditionClasses[condition.type_of_transaction] : null;

      return _.isFunction(classFn) ? new classFn(condition) : new Condition(condition);
    };

    return ConditionInstance;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').factory('conditionFilter', conditionFilter);

  conditionFilter.$inject = ['$timeout', '$q', '_'];

  function conditionFilter($timeout, $q, _) {
    var conditionFilterApi = {};

    function ConditionFilter(filtersList, data, options) {
      this.baseData = data;
      this.dataForView = data;
      this.currentFilter = {};
      this.filters = filtersList || [];
      this.options = options || {};
    }

    ConditionFilter.prototype.chooseFilter = function(filter) {
      this.currentFilter = filter;
      this.chooseFilterChange();
    };

    ConditionFilter.prototype.chooseFilterChange = function() {
      this.updateViewData();
      this.countryPickControl(this.currentFilter);

      if (_.isFunction(this.options.chooseFilter)) {
        this.options.chooseFilter(this.currentFilter);
      }
    };

    ConditionFilter.prototype.toggleFilter = function(filter) {
      filter.show = !filter.show;
    };

    ConditionFilter.prototype.implementsCondition = function() {
      var mutateFn = this.options.implementsCondition,
        isFunction = _.isFunction(mutateFn);

      this.filters = _.map(this.filters, function(filter) {
        filter.show = false;
        filter.value = filter.value;
        filter.ide = filter.id || 0;
        filter._destroy = 0;
        filter.aasm_state = filter.aasm_state;

        if (isFunction) {
          return mutateFn(filter) || filter;
        }

        return filter;
      });
    };

    ConditionFilter.prototype.addFilter = function() {
      var ide = _.max(_.pluck(this.filters, 'ide')),
        filter = {
          show: true,
          ide: ide + 1,
          _destroy: 0,
          aasm_state: 'custom',
          type: 'ConditionFilterCountry',
          name: '',
          value: [],
          condition_items_attributes: [],
          condition_steps_attributes: []
        };

      if (_.isFunction(this.options.addFilter)) {
        filter = this.options.addFilter(filter) || filter;
      }

      this.filters.push(filter);
      this.chooseFilter(filter);
    };

    ConditionFilter.prototype.resetBaseData = function(filter, fieldName) {
      _.each(this.baseData, function(v) {
        if (_.contains(filter.value, v[fieldName])) {
          v.check = false;
        }
      });
    };

    ConditionFilter.prototype.applyRemoveFilter = function(filter) {
      this.resetBaseData(filter, this.options.savedFiled);

      filter.value = [];

      this.updateViewData();

      if (filter.id) {
        filter._destroy = 1;
      } else {
        this.filters = _.reject(this.filters, {ide: filter.ide});
      }

      if (filter.ide === this.currentFilter.ide) {
        this.chooseFilter(_.findWhere(this.filters, {aasm_state: 'default'}));
      }
    };

    ConditionFilter.prototype.removeFilter = function(filter, ev) {
      var _this = this,
        promise = $q.when();

      ev.stopPropagation();

      if (_.isFunction(this.options.removeFilter)) {
        promise = this.options.removeFilter(filter, ev);

        if (!promise || !promise.then) {
          promise = $q.when();
        }
      }

      promise.then(function() {
        _this.applyRemoveFilter(filter);
      });

      return promise;
    };

    ConditionFilter.prototype.changeDataCallback = function() {
      var _this = this;

      return $q.when().then(function() {
        $timeout(function() {
          _this.currentFilter.value = _.pluck(_.where(_this.dataForView, {check: true}), _this.options.savedFiled);
          _this.countryPickControl(_this.currentFilter);
        }, 0);
      });
    };

    ConditionFilter.prototype.countryPickControl = function(filter) {
      filter.noCountryChoosed = filter.aasm_state === 'default' ? false : _.size(filter.value) === 0;
    };

    ConditionFilter.prototype.updateViewData = function() {
      var fieldName = this.options.savedFiled,
        currentValue = this.currentFilter.value,
        listIds = _.uniq(
          _.flatten(_.pluck(_.reject(this.getActualityFilters(), {ide: this.currentFilter.ide}), 'value'))
        );

      this.dataForView = _.filter(this.baseData, function(v) {
        v.check = _.contains(currentValue, v[fieldName]);

        return !_.contains(listIds, v[fieldName]);
      });
    };

    ConditionFilter.prototype.getActualityFilters = function() {
      return _.where(this.filters, {_destroy: 0});
    };

    ConditionFilter.prototype.invalidFiltersControl = function(isValidFilter, filterIde) {
      var filter = _.findWhere(this.filters, {ide: filterIde});

      if (filter) {
        filter.isValid = isValidFilter;
      }
    };

    ConditionFilter.prototype.getInvalidFilters = function() {
      var _this = this;

      return _.filter(_.reject(this.getActualityFilters(), {ide: this.currentFilter.ide}), function(filter) {
        return !_this.isFilterValid(filter);
      });
    };

    ConditionFilter.prototype.isAllFiltersValid = function() {
      var _this = this;

      return _.every(
        _.map(this.getActualityFilters(), function(filter) {
          return _.isFunction(_this.options.isAllFiltersValid)
            ? _this.options.isAllFiltersValid(filter)
            : _this.isFilterValid(filter);
        })
      );
    };

    ConditionFilter.prototype.getFilters = function() {
      var mutateFn = this.options.getFilters,
        isFunction = _.isFunction(mutateFn);

      return _.map(this.filters, function(filter) {
        var result = {
          _destroy: filter._destroy,
          value: filter.value,
          name: filter.name,
          type: filter.type,
          aasm_state: filter.aasm_state
        };

        if (!_.isUndefined(filter.id)) {
          result.id = filter.id;
        }

        if (isFunction) {
          _.extend(result, mutateFn(filter));
        }

        return result;
      });
    };

    ConditionFilter.prototype.isFilterValid = function(filter) {
      return filter.isValid && !filter.noCountryChoosed;
    };

    conditionFilterApi.createNew = function(filters, countries, options) {
      return new ConditionFilter(filters, countries, options);
    };

    return conditionFilterApi;
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('conditionFilter', conditionFilter);

  conditionFilter.$inject = ['$timeout', '$mdMedia', 'outputErrors', '$mdTranslate'];

  function conditionFilter($timeout, $mdMedia, outputErrors, $mdTranslate) {
    return {
      restrict: 'E',
      scope: {
        instance: '=',
        translateKey: '='
      },
      templateUrl: 'app/admin/conditions/partials/filter.html',
      controllerAs: '$ctrl',
      bindToController: true,
      controller: function($scope) {
        var vm = this;

        vm.errors = outputErrors.createNew();

        vm.changeDataCallback = function() {
          return vm.instance.changeDataCallback.apply(vm.instance, arguments);
        };

        vm.toggleError = function(noCountryChoosed) {
          $timeout(function() {
            if (noCountryChoosed) {
              vm.errors.inputErrors({value: [$mdTranslate.instant(vm.translateKey, 'validations.country_required')]});
            } else {
              vm.errors.inputErrors({});
            }
          }, 0);
        };

        $scope.$watch(
          function() {
            return vm.instance && vm.instance.currentFilter && vm.instance.currentFilter.noCountryChoosed;
          },
          function(value) {
            if (vm.instance && vm.instance.currentFilter) {
              vm.toggleError(value);
            }
          }
        );

        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            vm.isGtXs = value;
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('condition', condition);

  condition.$inject = ['$mdMedia', '_'];

  function condition($mdMedia, _) {
    return {
      restrict: 'E',
      scope: {
        instant: '=',
        methods: '=',
        callback: '&?'
      },
      templateUrl: function(element, attr) {
        return 'app/admin/conditions/partials/' + attr.type + '_template.html';
      },
      controllerAs: 'ctrl',
      controller: function($scope) {
        var vm = this;

        vm.translate_key = 'AdminConditions';

        vm.remove_product_steps = function(product, ev) {
          ev.stopPropagation();

          $scope.instant.removeProductSteps(product);
          $scope.instant.validateCondition();
        };

        vm.get_step_index = function(step, index) {
          var steps = $scope.instant.getCurrentStepsList(),
            i = index,
            ind = _.indexOf(steps, step),
            num = ind >= 0 ? ++ind : ++i;

          return _.size($scope.instant.filtered_steps) === _.size(steps) ? ++i : num;
        };

        vm.remove_condition_item = function(conditionItem) {
          if (conditionItem.id) {
            $scope.instant.installDestroyMark(conditionItem, 1);
          } else {
            $scope.instant.removeConditionItem(conditionItem);
          }
          $scope.instant.validateCondition();

          if ($scope.callback) {
            $scope.callback();
          }
        };

        vm.remove_step = function(step) {
          if (step.id) {
            $scope.instant.installDestroyMark(step, 1);
          } else {
            $scope.instant.removeStep(step);
          }
          $scope.instant.validateCondition();
        };

        vm.add_step = function() {
          var step = {
            condition_step_items_attributes: [],
            condition_type: 'basic',
            payment_column: null,
            payment_size: null,
            product: null
          };

          $scope.instant.addStep(step);
          $scope.instant.validateCondition();
        };

        $scope.$watch(
          function() {
            return $mdMedia('gt-xs');
          },
          function(value) {
            vm.isGtXs = value;
          }
        );
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('bulk_email_v2', {
        url: '/bulk_email_v2',
        templateUrl: 'app/admin/bulk_email_v2/dashboard/dashboard.html',
        controller: 'AdminBulkEmailV2DashboardController',
        controllerAs: 'dashboard',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.bulkemailcampaignscontroller.all'])
        }
      })
      .state('bulk_email_v2_create', {
        url: '/bulk_email_v2/new',
        templateUrl: 'app/admin/bulk_email_v2/editor/editor.html',
        controller: 'AdminBulkEmailV2EditorController',
        controllerAs: 'editor',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.bulkemailcampaignscontroller.all'])
        }
      })
      .state('bulk_email_v2_edit', {
        url: '/bulk_email_v2/:id/edit',
        templateUrl: 'app/admin/bulk_email_v2/editor/editor.html',
        controller: 'AdminBulkEmailV2EditorController',
        controllerAs: 'editor',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.bulkemailcampaignscontroller.all'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      bulk_email_v2: ['header||bulk_email_v2.header', 'no_campaigns||bulk_email_v2.no_campaigns']
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminBulkEmailV2', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('admin_bookkeeping', {
        url: '/admin/bookkeeping',
        templateUrl: 'app/components/bookkeeping/partials/bookkeeping.html',
        controller: 'BookkeepingController',
        controllerAs: 'bookkeeping',
        data: {
          readonly: false,
          namespace: 'admin',
          api_name: 'AdminBookkeepingApi',
          child_state: 'admin_bookkeeping.bookkeeping_month_report',
          permissions: permissionsStateAccess.init(['api2.admin.bookkeepingscontroller.show'])
        }
      })
      .state('admin_bookkeeping.bookkeeping_month_report', {
        url: '/month_report/:month_payment_date',
        templateUrl: 'app/components/bookkeeping/partials/bookkeeping_month_report.html',
        controller: 'BookkeepingMonthReportController',
        controllerAs: 'bookkeepingMonthReport',
        data: {
          readonly: false,
          checkboxes: true,
          namespace: 'admin',
          api_name: 'AdminBookkeepingApi',
          parent_state: 'admin_bookkeeping'
        }
      })
      .state('deduction', {
        url: '/deduction/:affiliate_id',
        templateUrl: 'app/components/bookkeeping/partials/deduction.html',
        controller: 'BookkeepingDeductionController',
        controllerAs: 'bookkeepingDeduction',
        parent: 'admin_bookkeeping.bookkeeping_month_report',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.bookkeepingscontroller.deduction'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('bonuses', {
        url: '/bonuses',
        templateUrl: 'app/admin/bonuses/partials/bonuses.html',
        controller: 'AdminBonusesController',
        controllerAs: 'bonuses',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.bonusescontroller.show'])
        }
      })
      .state('bonuses.add_bonuses', {
        url: '/add',
        templateUrl: 'app/admin/bonuses/partials/add_bonuses.html',
        controller: 'AddBonusesController',
        controllerAs: 'add_bonuses',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.bonusescontroller.create'])
        }
      })
      .state('bonuses.add_bonuses.manually', {
        url: '/manually',
        views: {
          'content@bonuses.add_bonuses': {
            templateUrl: 'app/admin/bonuses/partials/create_manual.html'
          },
          'buttons@bonuses.add_bonuses': {
            templateUrl: 'app/admin/bonuses/partials/submit_button.html'
          }
        }
      })
      .state('bonuses.add_bonuses.from_file', {
        url: '/file',
        views: {
          'content@bonuses.add_bonuses': {
            templateUrl: 'app/admin/bonuses/partials/create_with_file.html'
          },
          'buttons@bonuses.add_bonuses': {
            templateUrl: 'app/admin/bonuses/partials/submit_button.html'
          }
        }
      })
      .state('bonuses.edit_bonuses', {
        url: '/edit/:bonusId',
        templateUrl: 'app/admin/bonuses/partials/edit_bonuses.html',
        controller: 'EditBonusesController',
        controllerAs: 'edit_bonuses',
        data: {
          permissions: permissionsStateAccess.init(['api2.admin.bonusescontroller.edit'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        players: {
          bonuses: [
            'header||bonuses.header',
            'button_add_bonus||bonuses.button_add_bonus',
            {
              form: [
                'aasm_state||form.aasm_state',
                'cid||form.cid',
                'bonus_amount||form.bonus_amount',
                'date||form.date'
              ]
            },
            {
              add_bonus: [
                'header||add_bonus.header',
                'add_bonus||add_bonus.add_bonus',
                'back||add_bonus.back',
                {
                  tabs: [
                    {
                      manual: ['tab_name||manual.tab_name'],
                      from_file: [
                        'tab_name||from_file.tab_name',
                        'header||from_file.header',
                        'description||from_file.description',
                        'errors_in_file||from_file.errors_in_file'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              edit_bonus: ['header||edit_bonus.header', 'save||edit_bonus.save', 'back||edit_bonus.back']
            },
            {
              modal_window: [
                'destroy||modal_window.destroy',
                'destroy_question||modal_window.destroy_question',
                'answer_yes||modal_window.answer_yes',
                'answer_no||modal_window.answer_no'
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminBonuses', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('EditBonusesController', EditBonusesController);

  EditBonusesController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'AdminBonusesApi',
    '_',
    'outputErrors',
    'moment',
    'tableEngine',
    'toastsApi'
  ];

  function EditBonusesController(
    $scope,
    $state,
    $stateParams,
    AdminBonusesApi,
    _,
    outputErrors,
    moment,
    tableEngine,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminBonuses';
    vm.errors = outputErrors.createNew();
    vm.stateList = $scope.$parent.bonuses.stateList;
    vm.table = tableEngine.getTableByName('bonuses');

    AdminBonusesApi.show($stateParams.bonusId).then(
      function(response) {
        vm.bonus = response.data.bonus;
      },
      function() {
        toastsApi.toastError();
      }
    );

    vm.update_bonus = function() {
      AdminBonusesApi.update(vm.bonus).then(
        function() {
          vm.table.pagination();
          toastsApi.toastEditSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.back = function() {
      $state.go('bonuses');
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AdminBonusesController', AdminBonusesController);

  AdminBonusesController.$inject = [
    '$scope',
    '$state',
    'tableEngine',
    'AdminBonusesApi',
    '_',
    '$mdDialog',
    'outputErrors',
    '$mdTranslate',
    'toastsApi'
  ];

  function AdminBonusesController(
    $scope,
    $state,
    tableEngine,
    AdminBonusesApi,
    _,
    $mdDialog,
    outputErrors,
    $mdTranslate,
    toastsApi
  ) {
    var vm = this;

    vm.translate_key = 'AdminBonuses';
    vm.errors = outputErrors.createNew();
    vm.stateList = {list: []};

    vm.removeBonus = function(bonus_id, ev) {
      var confirm = $mdDialog
        .confirm()
        .title($mdTranslate.instant(vm.translate_key, 'modal_window.destroy'))
        .textContent($mdTranslate.instant(vm.translate_key, 'modal_window.destroy_question'))
        .targetEvent(ev)
        .ok($mdTranslate.instant(vm.translate_key, 'modal_window.answer_yes'))
        .cancel($mdTranslate.instant(vm.translate_key, 'modal_window.answer_no'));

      $mdDialog.show(confirm).then(function() {
        AdminBonusesApi.destroy(bonus_id).then(
          function() {
            vm.table.removeListItem();
            toastsApi.toastRemoveSuccess();
          },
          function() {
            toastsApi.toastError();
          }
        );
      });
    };

    vm.add_bonus = function() {
      $state.go('.add_bonuses.manually');
    };

    vm.edit_bonus = function(id) {
      $state.go('.edit_bonuses', {bonusId: id});
    };

    vm.initialize = function() {
      AdminBonusesApi.get_bonuses().then(
        function(response) {
          var data = response.data,
            opts = {
              locale_key: data.locale_key,
              columns: data.columns_for_display_data,
              list: data.list,
              total_pages: data.total_pages,
              total_entries: data.total_entries,
              start_row_num: data.start_row_num,
              end_row_num: data.end_row_num
            };

          vm.stateList.list = data.stateList;
          vm.table.update(opts);
          vm.table.addOptionsToColumn('aasm_state', {
            localizied: true,
            locales: {
              translate_key: 'AdminConditions',
              shortcode: 'product.rs.{{shortcode_part}}',
              shortcode_part_in_value: true
            }
          });
        },
        function() {
          toastsApi.toastError();
        }
      );
    };

    vm.table = tableEngine.init({
      api: AdminBonusesApi,
      name: 'bonuses',
      mobile: {
        defaultColumns: ['cid']
      },
      buttons: {
        url: 'app/admin/bonuses/partials/table.html',
        methods: {
          edit_bonus: vm.edit_bonus,
          removeBonus: vm.removeBonus
        }
      }
    });

    vm.initialize();

    $scope.$on('$changeMerchantSuccess', function() {
      vm.initialize();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('bonusForm', bonusForm);

  bonusForm.$inject = [];

  function bonusForm() {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: 'app/admin/bonuses/partials/form.html',
      controller: function($scope, $element, $attrs) {
        $scope.parentCtrl = $scope[$attrs.controllerAlias];
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('AddBonusesController', AddBonusesController);

  AddBonusesController.$inject = [
    '$scope',
    '$state',
    'AdminBonusesApi',
    'FileUploader',
    '_',
    'envService',
    '$q',
    'outputErrors',
    '$cookies',
    'tabsApi',
    'tableEngine',
    'merchantStore',
    'toastsApi'
  ];

  function AddBonusesController(
    $scope,
    $state,
    AdminBonusesApi,
    FileUploader,
    _,
    envService,
    $q,
    outputErrors,
    $cookies,
    tabsApi,
    tableEngine,
    merchantStore,
    toastsApi
  ) {
    var vm = this,
      urlBase = envService.read('apiUrl');

    vm.translate_key = 'AdminBonuses';
    vm.errors = outputErrors.createNew();
    vm.stateList = $scope.$parent.bonuses.stateList;
    vm.bonus = {};
    vm.bonus.date = null;
    vm.table = tableEngine.getTableByName('bonuses');
    vm.isError = false;
    vm.fileUploadDeferred = {};

    vm.uploader = new FileUploader({
      url: urlBase + 'admin/bonuses/create_with_file',
      withCredentials: true,
      queueLimit: 1,
      removeAfterUpload: true,
      headers: {
        'x-xsrf-token': $cookies.get('XSRF-TOKEN-X')
      }
    });

    vm.back = function() {
      $state.go('bonuses');
    };

    vm.createBonusManually = function() {
      return AdminBonusesApi.create(vm.bonus).then(
        function() {
          vm.table.pagination();
          vm.bonus.bonus_amount = null;
          vm.bonus.date = null;
          vm.addBonusesForm.$setPristine();
          toastsApi.toastCreateSuccess();
        },
        function(response) {
          vm.errors.inputErrors(response.data.errors);
        }
      );
    };

    vm.createBonusFromFile = function() {
      if (!vm.uploader.queue.length) {
        return $q.when();
      }

      vm.fileUploadDeferred = $q.defer();
      vm.isError = false;
      vm.uploader.uploadAll();

      return vm.fileUploadDeferred.promise;
    };

    vm.tabs = tabsApi.init({
      name: 'bonuses',
      translateKey: vm.translate_key,
      list: [
        {
          name: 'manually',
          shortcode: 'manual.tab_name',
          state: 'bonuses.add_bonuses.manually'
        },
        {
          name: 'from_file',
          shortcode: 'from_file.tab_name',
          state: 'bonuses.add_bonuses.from_file'
        }
      ]
    });

    vm.tabs.setTabSubmitFunction('manually', vm.createBonusManually);
    vm.tabs.setTabSubmitFunction('from_file', vm.createBonusFromFile);

    vm.uploader.onErrorItem = function(fileItem) {
      vm.isError = true;

      toastsApi.toastError({
        translate_key: vm.translate_key,
        shortcode: 'from_file.errors_in_file',
        data: {name: fileItem._file.name}
      });
    };

    vm.uploader.onCompleteAll = function() {
      vm.fileUploadDeferred.resolve();

      if (!vm.isError) {
        vm.table.pagination();
        toastsApi.toastCreateSuccess();
      }
    };

    vm.uploader.onBeforeUploadItem = function(item) {
      item.formData = [{merchant: merchantStore.getCurrentMerchantId()}];
    };

    $scope.$on('$destroy', function() {
      vm.tabs.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider.state('admin_balance_adjustments_history', {
      url: '/adjustments_history',
      templateUrl: 'app/admin/balance_adjustments_history/partials/adjustments_history_list.html',
      controller: 'AdminBalanceAdjustmentsHistoryController',
      controllerAs: 'adjustmentsListCtrl',
      data: {
        permissions: permissionsStateAccess.init([
          'api2.admin.affiliatecashoutscontroller.admin_balance_adjustments_history_show'
        ])
      }
    });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partners: {
          adjustments_history: [
            'header||adjustments_history.header',
            'download_report_button||adjustments_history.download_report_button'
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminAdjustmentsHistory', list);
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .controller('AdminBalanceAdjustmentsHistoryController', AdminBalanceAdjustmentsHistoryController);

  AdminBalanceAdjustmentsHistoryController.$inject = [
    '$scope',
    'tableEngine',
    'AdminAdjustmentsHistoryApi',
    '_',
    'toastsApi',
    'defaultDateFormat',
    'downloadReport'
  ];

  function AdminBalanceAdjustmentsHistoryController(
    $scope,
    tableEngine,
    AdminAdjustmentsHistoryApi,
    _,
    toastsApi,
    defaultDateFormat,
    downloadReport
  ) {
    var vm = this;

    vm.translate_key = 'AdminAdjustmentsHistory';
    vm.downloadFormats = [];
    vm.downloadSeparators = {};

    vm.applyDownloadReport = function(data) {
      return AdminAdjustmentsHistoryApi.downloadReport(data, vm.table.getSegmentId());
    };

    vm.downloadReport = function(ev) {
      downloadReport.openModal(
        {
          downloadReportFunc: vm.applyDownloadReport,
          options: vm.downloadFormats
        },
        ev
      );
    };

    vm.tableFiliterColumns = [
      {
        name: 'merchant_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'created_at',
        type: 'date',
        display: true,
        empty: true
      },
      {
        name: 'id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'admin_id',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'admin_email',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'comment',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_email',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_username',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'amount',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_balance_before',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'affiliate_balance_after',
        type: 'compare',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_name',
        type: 'checkbox',
        display: true,
        empty: true
      },
      {
        name: 'payment_system_details',
        type: 'checkbox',
        display: true,
        empty: true
      }
    ];

    vm.table = tableEngine.init({
      api: AdminAdjustmentsHistoryApi,
      name: 'adjustments_history',
      mobile: {
        defaultColumns: ['affiliate_id']
      },
      filter: {
        enable: true,
        columns: vm.tableFiliterColumns,
        pathForFilter: 'api2/admin/affiliate_cashouts/adjustment_history',
        actionForFilter: 'list',
        byMerchant: true,
        filterName: 'adjustment_history'
      }
    });

    AdminAdjustmentsHistoryApi.getAdjustmentsHistoryList().then(
      function(response) {
        var data = response.data,
          opts = {
            locale_key: data.locale_key,
            columns: data.columns_for_display_data,
            list: data.list,
            table_id: data.report_id,
            total_pages: data.total_pages,
            total_entries: data.total_entries,
            start_row_num: data.start_row_num,
            end_row_num: data.end_row_num
          };

        vm.table.update(opts);
        vm.table.addOptionsToColumn('amount', {separateNumber: true});
        vm.table.addOptionsToColumn('affiliate_balance_before', {separateNumber: true});
        vm.table.addOptionsToColumn('affiliate_balance_after', {separateNumber: true});
        vm.table.addOptionsToColumn('created_at', {format: defaultDateFormat + ' HH:mm:ss'});

        vm.downloadFormats = data.separators_for_format;
      },
      function() {
        toastsApi.toastError();
      }
    );

    $scope.$on('$changeMerchantSuccess', function() {
      vm.table.resetFilter();
      vm.table.pagination();
    });

    $scope.$on('$destroy', function() {
      vm.table.destroy();
    });
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(function($stateProvider, permissionsStateAccess) {
    $stateProvider
      .state('admin_articles', {
        url: '/admin/articles',
        templateUrl: 'app/components/articles/partials/list.html',
        controller: 'ArticlesListController',
        controllerAs: 'ArticlesCtrl',
        data: {
          namespace: 'admin',
          translate_key: 'AdminArticles',
          view_state: 'admin_articles.view',
          buttons: {
            view: true,
            edit: true,
            destroy: true
          },
          permissions: permissionsStateAccess.init(['api2.admin.articlescontroller.show'])
        }
      })
      .state('admin_articles.view', {
        url: '/view/:articleId',
        templateUrl: 'app/components/articles/partials/view.html',
        controller: 'ArticlesViewController',
        controllerAs: 'ViewCtrl',
        data: {
          namespace: 'admin',
          list_state: 'admin_articles',
          translate_key: 'AdminArticles'
        }
      })
      .state('admin_articles.create', {
        url: '/create',
        templateUrl: 'app/components/articles/partials/settings.html',
        controller: 'ArticlesSettingsController',
        controllerAs: 'SettingsCtrl',
        data: {
          list_state: 'admin_articles',
          translate_key: 'AdminArticles',
          permissions: permissionsStateAccess.init(['api2.admin.articlescontroller.create'])
        }
      })
      .state('admin_articles.edit', {
        url: '/edit/:articleId',
        templateUrl: 'app/components/articles/partials/settings.html',
        controller: 'ArticlesSettingsController',
        controllerAs: 'SettingsCtrl',
        data: {
          list_state: 'admin_articles',
          translate_key: 'AdminArticles',
          permissions: permissionsStateAccess.init(['api2.admin.articlescontroller.update'])
        }
      });
  });
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      admin: {
        partnership_program: {
          articles: [
            'header||articles.header',
            'create_article||articles.create_articles_btn',
            {
              languages: ['all||articles.language.all'],
              modal_window: [
                'title||modal_remove.title',
                'question||modal_remove.question',
                'delete||modal_remove.delete',
                'cancel||modal_remove.cancel'
              ],
              view: ['last_update||articles_view.last_update', 'back||articles_view.back'],
              settings: [
                'header_edit||articles_settings.header_edit',
                'header_create||articles_settings.header_create',
                'back||articles_settings.back',
                'save||articles_settings.save',
                {
                  form: [
                    'for_language||articles_settings.form.for_language',
                    'title||articles_settings.form.title',
                    'body||articles_settings.form.body'
                  ]
                }
              ]
            }
          ]
        }
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AdminArticles', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('mdFocus', mdFocus);

  mdFocus.$inject = ['$timeout'];

  function mdFocus($timeout) {
    return {
      restrict: 'A',
      link: function(scope, element) {
        $timeout(function() {
          element.focus();
        }, 0);
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').directive('logoMain', logoMain);

  logoMain.$inject = ['logoUrls'];

  function logoMain(logoUrls) {
    return {
      restrict: 'E',
      replace: true,
      scope: {},
      template:
        '<a ui-sref="home"><img load-logo-controll ng-src="{{getLogoUrl()}}" logo-type="{{::logo_type}}" alt="logo main"></a>',
      link: function(scope) {
        scope.logo_type = 'logo_main';

        scope.getLogoUrl = function() {
          return logoUrls.getLogoMain();
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(translateManagerProviderConfig);

  function translateManagerProviderConfig(translateManagerProvider, localesApiProvider) {
    var list = {
      auth: {
        main_page: ['welcome||main_page.welcome', 'sign_in||main_page.sign_in', 'sign_up||main_page.sign_up']
      }
    };

    translateManagerProvider.add_locals_list(list);
    localesApiProvider.set_locales('AuthMainPage', list);
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').run(runBlock);

  /** @ngInject */
  function runBlock(
    $timeout,
    $translate,
    $window,
    $rootScope,
    $state,
    localesStorage,
    permissionsManager,
    AffiliateBannerRunner,
    User,
    mfaSettings
  ) {
    permissionsManager.setPermissionsFromStorage();

    $translate.use(localesStorage.getCurrentLocale());

    // MFA 체크 가드
    $rootScope.$on('$stateChangeStart', function(event, toState) {
      var currentUser = User.getUserProperty('namespace'),
        isMfaEnabled = mfaSettings && mfaSettings.isEnabled(),
        isMfaSetupPage =
          toState.name === 'admin_settings_profile.two_factor_authentication' ||
          toState.name === 'affiliate_settings_profile.two_factor_authentication',
        isAuthPage =
          toState.name === 'sign_in' ||
          toState.name === 'sign_up' ||
          toState.name === 'home' ||
          toState.name === 'logout' ||
          toState.name === 'check_access',
        mfaState;

      // MFA가 비활성화되어 있고, 로그인된 유저가 있으며, MFA 설정 페이지가 아니고, 인증 페이지가 아닌 경우
      if (!isMfaEnabled && currentUser && !isMfaSetupPage && !isAuthPage) {
        event.preventDefault();
        mfaState =
          currentUser === 'admin'
            ? 'admin_settings_profile.two_factor_authentication'
            : 'affiliate_settings_profile.two_factor_authentication';
        $state.go(mfaState);
      }
    });

    $timeout(
      function() {
        if ($window.location.search) {
          $window.location.href = $window.location.origin;
        } else {
          angular
            .element(document.querySelector('.preloader-wrapper'))
            .removeClass('white-overlay')
            .removeClass('activate');
          AffiliateBannerRunner.checkBanner();
        }
      },
      500,
      false
    );
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/auth/auth.html'
      })
      .state('logout', {
        resolve: {
          logout: [
            'AuthApi',
            '$q',
            function(AuthApi, $q) {
              AuthApi.userLogout();
              return $q.reject();
            }
          ]
        }
      })
      .state('check_access', {
        resolve: {
          checkSupervision: [
            'AuthApi',
            '$stateParams',
            '$q',
            function(AuthApi, $stateParams, $q) {
              AuthApi.checkUserAccess($stateParams.user, $stateParams.isSupervision);
              return $q.reject();
            }
          ]
        },
        params: {
          user: null,
          isSupervision: false
        }
      });

    $urlRouterProvider.otherwise(function($injector) {
      var $state = $injector.get('$state');
      if ($state.current.name) {
        $state.go($state.current.name, null, {reload: true});
      } else {
        $state.go('home');
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .filter('numberSeparate', numberSeparate)
    .filter('filterByObjectProperties', filterByObjectProperties)
    .filter('dateLocaleFilter', dateLocaleFilter)
    .filter('menuItemFilter', menuItemFilter)
    .filter('search', searchFilter)
    .filter('toHtml', toHtmlFilter);

  function numberSeparate() {
    return function(text, separator) {
      if (text) {
        var regExp = new RegExp(',', 'g'),
          separ = separator || ' ',
          result;

        result = text.toString().replace(regExp, separ);
      }
      return result || text;
    };
  }

  function filterByObjectProperties() {
    return function(items) {
      var sorted = {},
        keys = [],
        upperKeys = [],
        key;

      for (key in items) {
        if (items.hasOwnProperty(key)) {
          // if (key == key.toUpperCase()) {
          //   upperKeys.push(key.toLowerCase());
          // }
          // keys.push(_.contains(_.keys(localesStorage.getLanguages()), key) ? key: key.toLowerCase());
          keys.push(key);
        }
      }

      keys.sort();

      for (key = 0; key < keys.length; key++) {
        if (upperKeys.indexOf(keys[key]) !== -1) {
          sorted[keys[key].toUpperCase()] = items[keys[key].toUpperCase()];
        } else {
          sorted[keys[key]] = items[keys[key]];
        }
      }

      return sorted;
    };
  }

  function dateLocaleFilter(localesStorage, $translate, moment) {
    var translateFilter = function(date, opts) {
      if (date) {
        var options = opts || {},
          ln = options.language || localesStorage.getMomentLocale(),
          format = options.format || 'L',
          result,
          m;

        moment.locale(ln);

        m = moment(date);

        result = m.isValid() ? m.format(format) : date;
      }
      return result || date;
    };

    if ($translate.statefulFilter()) {
      translateFilter.$stateful = true;
    }

    return translateFilter;
  }

  function menuItemFilter(permissionsManager, _) {
    return function(list) {
      return _.filter(list, function(v) {
        if (_.isString(v.permission)) {
          return permissionsManager.checkPermission(v.permission);
        } else if (_.isBoolean(v.permission) && !v.permission) {
          return false;
        } else if (_.isFunction(v.permission)) {
          return v.permission();
        } else {
          return v;
        }
      });
    };
  }

  function searchFilter($filter, $translate, $mdTranslate, $interpolate, _) {
    var isFound = function(searchTerm, opts, v, k) {
      var key = opts.find_in_key ? k : '',
        asKey = opts.key_as_shortcode_part ? k : v,
        shortcode_part = opts.prop_for_shortcode ? v[opts.prop_for_shortcode] : asKey,
        value = opts.prop_for_value && _.isObject(v) ? v[opts.prop_for_value] : v,
        shortcode;

      if (opts.search_in_translate) {
        if (opts.translate_key) {
          shortcode = opts.shortcode ? $interpolate(opts.shortcode)({part: shortcode_part}) : shortcode_part;
          value = $mdTranslate.instant(opts.translate_key, shortcode);
        } else {
          value = $translate.instant(opts.translate_namespace + (opts.substitute_key ? k : value));
        }
      }

      if (opts.selective_translate) {
        if (_.isObject(v) && v.locale) {
          value = $translate.instant(v.locale);
        } else if (_.isObject(v) && v.translate_key && v.shortcode) {
          value = $mdTranslate.instant(v.translate_key, v.shortcode);
        }
      }

      return _.size($filter('filter')([key, value], searchTerm));
    };

    return function(list, searchTerm, opts) {
      if (_.isArray(list)) {
        return _.filter(list, function(v, k) {
          return isFound(searchTerm, opts, v, k);
        });
      } else {
        if (_.isObject(list)) {
          return _.pick(list, function(v, k) {
            return isFound(searchTerm, opts, v, k);
          });
        }
        return list;
      }
    };
  }

  function toHtmlFilter($sce) {
    return function(text) {
      return $sce.trustAsHtml(text);
    };
  }
})();

(function() {
  'use strict';

  angular.module('quintessenceAngular').controller('QuintessenceController', QuintessenceController);

  QuintessenceController.$inject = [
    '$scope',
    '$mdBottomSheet',
    '$state',
    '$location',
    'merchantStore',
    'AuthApi',
    'loginAnimation',
    'User',
    '_'
  ];

  function QuintessenceController(
    $scope,
    $mdBottomSheet,
    $state,
    $location,
    merchantStore,
    AuthApi,
    loginAnimation,
    User,
    _
  ) {
    var vm = this;

    vm.startAnimation = loginAnimation.animation;

    vm.statesWithoutHeader = [
      'home',
      'sign_in',
      'affiliate_data',
      'affiliate_data.confirmation',
      'affiliate_data.done',
      'password_new',
      'confirm_email',
      'change_password',
      'save_password',
      'affiliate_registration',
      'affiliate_unsubscribe'
    ];

    // vm.userWasChanged = function(newData) {
    //   var newUser = _.omit(newData, 'supervision');

    //   AuthApi.checkUserAccess(_.isEmpty(newUser) ? null : newUser, newData.supervision);
    // };

    // window.addEventListener('storage', function(event) {
    //   var newData = event.newValue ? JSON.parse(event.newValue) : {};

    //   if (event.key === 'user') {
    //     vm.userWasChanged(newData);
    //   }
    // });

    $scope.$on('$stateChangeSuccess', function(e, toState) {
      var isAuth = _.contains(vm.statesWithoutHeader, toState.name);

      if (!isAuth) {
        $location.search('merchant', merchantStore.getCurrentMerchantName());
      }

      vm.showHeader = _.isEmpty(toState.name) ? false : !isAuth;

      if (toState.name === 'home' && User.getUserProperty('id')) {
        $state.go(User.getUserProperty('namespace'), null, {reload: true});
      }

      $mdBottomSheet.hide();
    });

    $scope.$on('$stateChangeStart', function(e, toState) {
      var namespace = User.getUserProperty('namespace');

      if ((toState.name === 'admin' || toState.name === 'affiliate') && namespace !== toState.name) {
        e.preventDefault();
        $state.go(namespace || 'home', null, {reload: true});
      }
    });
  }
})();

/* global malarkey:false, moment:false, Clipboard:false, Chart:false */
(function() {
  'use strict';

  var permissionsStateAccess = {
    init: function(arrayPermissions) {
      var result = {
        only: arrayPermissions,
        redirectTo: {
          default: 'home'
        }
      };
      angular.forEach(arrayPermissions, function(permission) {
        result.redirectTo[permission] = function(rejectedPermission, transitionProperties) {
          if (transitionProperties.fromState.name) {
            return transitionProperties.fromState.name;
          } else {
            return 'home';
          }
        };
      });

      return result;
    }
  };

  angular
    .module('quintessenceAngular')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('Clipboard', Clipboard)
    .constant('Chart', Chart)
    .constant('regExpEmail', '[-\\w.]+@([A-z0-9][-A-z0-9]+\\.)+[A-z]{2,4}')
    .constant('regExpPassword', '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{3,}$')
    .constant('regExpPhone', '^\\+?([0-9]{12})$')
    .constant(
      'regExpUrl',
      '(http(s)?:\\/\\/.)?(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)'
    )
    .constant('defaultDateFormat', 'L')
    .constant('permissionsStateAccess', permissionsStateAccess);

  angular.module('asyncLoaderConfig').constant('moment', moment);
})();

(function() {
  'use strict';

  angular
    .module('quintessenceAngular')
    .config(envServiceProviderConfig)
    .config(httpProviderConfig)
    .config(AuthProviderConfig)
    .config(translateProviderConfig)
    .config(materialThemeConfig)
    .config(datepickerConfig)
    .config(mdSelectMenuConfig)
    .config(mdAriaConfig)
    .config(textAngularConfig)
    .config(ChartsConfig);

  function envServiceProviderConfig(envServiceProvider, envConfig) {
    // set the domains and variables for each environment
    envServiceProvider.config(envConfig);

    // run the environment check, so the comprobation is made
    // before controllers and services are built
    envServiceProvider.check();
  }

  /** @ngInject */
  function httpProviderConfig($logProvider, $httpProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // delete $httpProvider.defaults.headers.common['X-Requested-With'];
    $httpProvider.defaults.useXDomain = true;
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    $httpProvider.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
    // $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
    // $httpProvider.defaults.headers.common['Pragma'] = 'no-cache';
    $httpProvider.interceptors.push(beautifyInterceptor);
  }

  function beautifyInterceptor($q, Preloader, $cookies, merchantStore) {
    return {
      request: function(config) {
        if (~config.url.indexOf('http')) {
          Preloader.openPreloader(config);
          if (['get', 'delete'].indexOf(config.method.toLowerCase()) !== -1) {
            if (!config.params) {
              config.params = {};
            }
            config.params.authenticity_token = $cookies.get('XSRF-TOKEN-X');
            config.params.merchant = config.params._merchant || merchantStore.getCurrentMerchantId();

            delete config.params._merchant;
          } else {
            if (!config.data) {
              config.data = {};
            }
            config.data.authenticity_token = $cookies.get('XSRF-TOKEN-X');
            config.data.merchant = config.data._merchant || merchantStore.getCurrentMerchantId();

            delete config.data._merchant;
          }
        }
        return config;
      },

      requestError: function(config) {
        if (~config.url.indexOf('http')) {
          Preloader.closePreloader(config);
        }
        return $q.reject(config);
      },

      response: function(res) {
        if (~res.config.url.indexOf('http')) {
          Preloader.closePreloader(res.config);
          $cookies.put('XSRF-TOKEN-X', res.headers('XSRF-TOKEN'));
        }
        return res;
      },

      responseError: function(res) {
        if (~res.config.url.indexOf('http')) {
          Preloader.closePreloader(res.config);
          // 401 Unauthorized 응답 시 페이지 새로고침 (세션 만료)
          if (res.status === 401) {
            window.location.reload();
            return $q.reject(res);
          }
        }
        return $q.reject(res);
      }
    };
  }

  function AuthProviderConfig(AuthProvider, envServiceProvider) {
    var urlBase = envServiceProvider.read('apiUrl');

    AuthProvider.loginMethod('POST');
    AuthProvider.loginPath(urlBase + 'sign_in');

    AuthProvider.logoutMethod('DELETE');
    AuthProvider.logoutPath(urlBase + 'sign_out');

    AuthProvider.resourceName('user');
  }

  function translateProviderConfig($translateProvider, translateManagerProvider, localesStorage) {
    angular.forEach(localesStorage.getStorage(), function(translations, locale) {
      $translateProvider.translations(locale, translations);
    });
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translateProvider.useLoader('asyncLoader');
    $translateProvider.fallbackLanguage(localesStorage.getFallbackLocale());
    // $translateProvider.preferredLanguage(localesStorage.getCurrentLocale());
    $translateProvider.useInterpolation('customInterpolation');

    translateManagerProvider.add_locals_list({});
  }

  function materialThemeConfig($mdThemingProvider, themeColors) {
    var primaryBlueMap = $mdThemingProvider.extendPalette('blue', {
        '500': '#1088DE', // Default
        '600': '#1669b1' // Hover
      }),
      accentGreenMap = $mdThemingProvider.extendPalette('light-green', {
        A200: '#ABD036', // Default
        A700: '#94b725', // Hover
        contrastDefaultColor: 'light'
      }),
      warnRedMap = $mdThemingProvider.extendPalette('red', {
        '500': '#D94740', // Defalt
        '600': '#b32926' // Hover
      }),
      bgGreyMap = $mdThemingProvider.extendPalette('grey', {
        '50': '#f2f2f2' // Default background
      });

    $mdThemingProvider.definePalette('primaryBlue', primaryBlueMap);
    $mdThemingProvider.definePalette('accentGreen', accentGreenMap);
    $mdThemingProvider.definePalette('warnRed', warnRedMap);
    $mdThemingProvider.definePalette('bgGrey', bgGreyMap);

    $mdThemingProvider
      .theme('default')
      .primaryPalette('primaryBlue')
      .accentPalette('accentGreen')
      .warnPalette('warnRed')
      .backgroundPalette('bgGrey');

    themeColors.createStyleForButtons();
  }

  function datepickerConfig($provide, $mdDateLocaleProvider, moment, localesStorage, defaultDateFormat) {
    moment.locale(localesStorage.getMomentLocale());

    $mdDateLocaleProvider.months = moment.months();
    $mdDateLocaleProvider.shortMonths = moment.monthsShort();
    $mdDateLocaleProvider.days = moment.weekdays();
    $mdDateLocaleProvider.shortDays = moment.weekdaysMin();
    $mdDateLocaleProvider.firstDayOfWeek = moment.localeData()._week.dow;

    $mdDateLocaleProvider.formatDate = function(date) {
      var m = moment(date);
      return m.isValid() ? m.format(defaultDateFormat) : date;
    };

    $provide.decorator('mdDatepickerDirective', function($delegate, $rootScope) {
      function decorator(func) {
        return function(ngModelCtrl) {
          var DatePickerCtrl = this,
            listener;

          if (DatePickerCtrl.inputContainer.closest && !DatePickerCtrl.inputContainer.closest('datepicker-formated')) {
            listener = $rootScope.$on('$translateChangeSuccess', function() {
              DatePickerCtrl.onExternalChange.call(DatePickerCtrl, ngModelCtrl.$modelValue);
            });
            DatePickerCtrl.$scope.$on('$destroy', listener);
          }

          func.apply(DatePickerCtrl, arguments);
        };
      }

      $delegate[0].controller.prototype.configureNgModel = decorator(
        $delegate[0].controller.prototype.configureNgModel
      );

      return $delegate;
    });
  }

  function mdSelectMenuConfig($provide) {
    $provide.decorator('mdSelectMenuDirective', function($delegate, _) {
      function decorator(func) {
        return function preLink(scope, element) {
          scope.$watch('list', function(newList) {
            element[_.size(newList) > 5 ? 'addClass' : 'removeClass']('is-search');
          });
          func.apply(this, arguments);
        };
      }

      $delegate[0].link.pre = decorator($delegate[0].link.pre);

      return $delegate;
    });
  }

  function mdAriaConfig($mdAriaProvider) {
    $mdAriaProvider.disableWarnings();
  }

  function textAngularConfig($provide) {
    $provide.decorator('taOptions', [
      'taRegisterTool',
      '$delegate',
      function(taRegisterTool, taOptions) {
        taRegisterTool('dropdown', {
          display: [
            '<md-menu class="btn btn-default dropdown-btn" name="dropdown">',
            '<span class="text" ng-click="$mdMenu.open($event)">',
            'variables',
            '</span>',
            '<md-menu-content width="4">',
            '<md-menu-item ng-repeat="item in variables">',
            '<md-button ng-click="action(item)">',
            '<span ng-bind="item"></span>',
            '</md-button>',
            '</md-menu-item>',
            '</md-menu>'
          ].join(''),
          variables: [],
          action: function(item) {
            this.$editor().displayElements.text.focus();
            this.$editor().wrapSelection('insertHTML', '{' + item + '}');
          }
        });

        taOptions.toolbar.push(['dropdown']);

        return taOptions;
      }
    ]);
  }

  function ChartsConfig(ChartJsProvider) {
    ChartJsProvider.setOptions({colors: ['#1088de', '#f3f3f2', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360']});
  }
})();

angular.module("quintessenceAngular").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/bulk_email_v2/launch_confirmation_modal.html","<md-dialog class=launch-confirmation-modal style=\"min-width: 800px; max-width: 900px\"><md-toolbar class=md-warn><div class=md-toolbar-tools><h2><i class=\"fa fa-exclamation-triangle\"></i> Launch Campaign - Final Verification</h2><span flex></span><md-button class=md-icon-button ng-click=cancel() ng-disabled=launching><i class=\"fa fa-times\"></i></md-button></div></md-toolbar><md-dialog-content style=\"padding: 24px\"><!-- Campaign Details --><div class=well style=\"background: #f9f9f9; padding: 15px; margin-bottom: 20px\"><h4 style=\"margin-top: 0\">Campaign Details</h4><table style=\"width: 100%; font-size: 13px\"><tr><td style=\"width: 120px; font-weight: bold\">Name:</td><td>{{ campaign.Name }}</td></tr><tr><td style=\"font-weight: bold\">Subject:</td><td>{{ campaign.Subject }}</td></tr><tr><td style=\"font-weight: bold\">From:</td><td>{{ campaign.SenderName }} &lt;{{ campaign.SenderEmail }}&gt;</td></tr><tr ng-if=campaign.BodyPreview><td style=\"font-weight: bold; vertical-align: top\">Body Preview:</td><td><div style=\"max-height: 60px; overflow: hidden; color: #666\">{{ campaign.BodyPreview | limitTo:200 }}...</div></td></tr></table></div><!-- Recipients Section --><div><div layout=row layout-align=\"space-between center\" style=\"margin-bottom: 15px\"><h4 style=\"margin: 0\">Recipients: {{ recipientMeta.total || campaign.Recipients }} total <span ng-if=\"campaign.InvalidRecipients > 0\" style=\"color: #d32f2f\">({{ campaign.InvalidRecipients }} invalid)</span></h4></div><!-- Search Box --><div layout=row layout-align=\"start center\" style=\"margin-bottom: 15px\"><md-input-container flex=60 style=\"margin: 0\"><label>Search by username, email, or ID</label><input type=text ng-model=searchQuery ng-keypress=\"$event.keyCode == 13 && searchRecipients()\"></md-input-container><md-button class=\"md-raised md-primary\" ng-click=searchRecipients() style=\"margin-left: 10px\" ng-disabled=loading><i class=\"fa fa-search\"></i> Search</md-button><md-button class=md-raised ng-click=clearSearch() ng-if=searchQuery style=\"margin-left: 10px\" ng-disabled=loading><i class=\"fa fa-times\"></i> Clear</md-button></div><!-- Recipients Table --><div style=\"max-height: 300px; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px\"><table class=\"table table-striped table-bordered\" style=\"margin: 0\"><thead style=\"position: sticky; top: 0; background: #f5f5f5; z-index: 1\"><tr><th style=\"width: 10%\">ID</th><th style=\"width: 30%\">Username</th><th style=\"width: 50%\">Email</th><th style=\"width: 10%\">Status</th></tr></thead><tbody><tr ng-if=loading><td colspan=4 style=\"text-align: center; padding: 20px\"><i class=\"fa fa-spinner fa-spin\"></i> Loading...</td></tr><tr ng-if=\"!loading && recipients.length === 0\"><td colspan=4 style=\"text-align: center; padding: 20px\"><em>No recipients found</em></td></tr><tr ng-repeat=\"recipient in recipients\"><td>{{ recipient.id }}</td><td>{{ recipient.username }}</td><td>{{ recipient.email }}</td><td><span class=\"label label-default\">{{ recipient.status || \'pending\' }}</span></td></tr></tbody></table></div><!-- Pagination --><div layout=row layout-align=\"space-between center\" style=\"margin-top: 15px\"><div style=\"font-size: 13px; color: #666\">Showing {{ (recipientMeta.current_page - 1) * recipientMeta.per_page + 1 }} to {{ recipientMeta.current_page * recipientMeta.per_page > recipientMeta.total ? recipientMeta.total : recipientMeta.current_page * recipientMeta.per_page }} of {{ recipientMeta.total }} recipients</div><div layout=row layout-align=\"end center\"><md-button class=md-raised ng-click=prevPage() ng-disabled=\"recipientMeta.current_page === 1 || loading\"><i class=\"fa fa-chevron-left\"></i> Previous</md-button><span style=\"margin: 0 15px; font-size: 13px\">Page {{ recipientMeta.current_page }} of {{ recipientMeta.total_pages }}</span><md-button class=md-raised ng-click=nextPage() ng-disabled=\"recipientMeta.current_page === recipientMeta.total_pages || loading\">Next <i class=\"fa fa-chevron-right\"></i></md-button></div></div></div><!-- Warning Message --><div class=\"alert alert-danger\" style=\"margin-top: 20px; margin-bottom: 0\"><i class=\"fa fa-exclamation-triangle\"></i> <strong>WARNING:</strong> This will send {{ recipientMeta.total || campaign.Recipients }} emails immediately. This action <strong>CANNOT</strong> be undone.</div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-disabled=launching>Cancel</md-button><span flex></span><md-button class=\"md-raised md-warn\" ng-click=launch() ng-disabled=\"launching || loading || recipientMeta.total === 0\" style=\"min-width: 180px\"><i class=fa ng-class=\"launching ? \'fa-spinner fa-spin\' : \'fa-rocket\'\"></i> {{ launching ? \'Launching...\' : \'🚀 LAUNCH CAMPAIGN\' }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/bulk_email_v2/dashboard/dashboard.html","<style>/* Reduce horizontal spacing between table columns */\n    .table-list-wrap .table-list-head-cell,\n    .table-list-wrap .table-list-body-cell {\n        padding-left: 12px !important;\n        padding-right: 12px !important;\n    }</style><div class=view-content><md-card class=primary-card><div class=card-header layout=row layout-align=\"space-between center\"><div class=card-title><md-translate key=::dashboard.translate_key shortcode=\"\'bulk_email_v2.header\'\"></md-translate></div><md-button class=\"md-raised md-primary btn-primary\" ui-sref=bulk_email_v2_create><i class=\"fa fa-plus\"></i> New Campaign</md-button></div><md-card-content class=padding-content><!-- Table-list directive handles loading, empty states, and pagination automatically --><table-list table=dashboard.table></table-list></md-card-content></md-card></div>");
$templateCache.put("app/admin/bulk_email_v2/dashboard/table_buttons.html","<!-- Edit: Visible in draft, testing --> <a ui-sref=\"bulk_email_v2_edit({id: item.Id})\" ng-if=\"[\'draft\', \'testing\'].indexOf(item.raw_state) !== -1\" style=\"color: #337ab7; font-size: 18px; margin-right: 12px; cursor: pointer; text-decoration: none\" title=Edit><i class=\"fa fa-pencil\"></i> </a><!-- View (Read-only Edit): Visible in ready, sending, sent, failed --> <a ui-sref=\"bulk_email_v2_edit({id: item.Id})\" ng-if=\"[\'ready\', \'sending\', \'sent\', \'failed\'].indexOf(item.raw_state) !== -1\" style=\"color: #337ab7; font-size: 18px; margin-right: 12px; cursor: pointer; text-decoration: none\" title=\"View Campaign\"><i class=\"fa fa-eye\"></i> </a><!-- Send Test: Visible in draft, testing --> <a ng-if=\"[\'draft\', \'testing\'].indexOf(item.raw_state) !== -1\" ng-click=\"table.config.buttons.methods.sendTest(item.Id, $event)\" style=\"color: #337ab7; font-size: 18px; margin-right: 12px; cursor: pointer; text-decoration: none\" title=\"Send Test Email\"><i class=\"fa fa-paper-plane-o\"></i> </a><!-- Reset to Draft: Visible in ready --> <a ng-if=\"item.raw_state === \'ready\'\" ng-click=\"table.config.buttons.methods.resetToDraft(item.Id, $event)\" style=\"color: #337ab7; font-size: 18px; margin-right: 12px; cursor: pointer; text-decoration: none\" title=\"Reset to Draft\"><i class=\"fa fa-undo\"></i> </a><!-- Launch: Visible in testing, ready (only if has recipients) --> <a ng-if=\"[\'testing\', \'ready\'].indexOf(item.raw_state) !== -1 && item.raw_stats.valid_recipients > 0\" ng-click=\"table.config.buttons.methods.launch(item.Id, item.raw_stats.valid_recipients, $event)\" style=\"color: #337ab7; font-size: 18px; margin-right: 12px; cursor: pointer; text-decoration: none\" title=\"Launch Campaign\"><i class=\"fa fa-rocket\"></i> </a><!-- Delete: Visible in draft only --> <a ng-if=\"item.raw_state === \'draft\'\" ng-click=\"table.config.buttons.methods.deleteCampaign(item.Id, $event)\" style=\"color: #337ab7; font-size: 18px; margin-right: 12px; cursor: pointer; text-decoration: none\" title=Delete><i class=\"fa fa-trash\"></i> </a>");
$templateCache.put("app/admin/bulk_email_v2/editor/editor.html","<div class=view-content><md-card class=primary-card><div class=card-header layout=row layout-align=\"space-between center\"><div class=card-title><a ui-sref=bulk_email_v2 style=\"margin-right: 15px; color: #666; font-size: 14px\"><i class=\"fa fa-arrow-left\"></i> Back </a><span ng-if=!editor.campaign.id>New Campaign</span> <span ng-if=\"editor.campaign.id && !editor.isReadOnly()\">Edit Campaign: {{ editor.campaign.name }}</span> <span ng-if=\"editor.campaign.id && editor.isReadOnly()\">View Campaign: {{ editor.campaign.name }}</span></div><div layout=row layout-align=\"end center\"><span class=label ng-if=editor.campaign.state ng-class=\"{\n                        \'label-default\': editor.campaign.state === \'draft\',\n                        \'label-info\': editor.campaign.state === \'testing\',\n                        \'label-primary\': editor.campaign.state === \'ready\',\n                        \'label-warning\': editor.campaign.state === \'sending\',\n                        \'label-success\': editor.campaign.state === \'sent\',\n                        \'label-danger\': editor.campaign.state === \'failed\'\n                      }\" style=\"font-size: 14px; padding: 8px 16px; border-radius: 4px; font-weight: 600; letter-spacing: 0.5px; border: 2px solid; border-color: {{\n                        editor.campaign.state === \'draft\' ? \'#999\' :\n                        editor.campaign.state === \'testing\' ? \'#5bc0de\' :\n                        editor.campaign.state === \'ready\' ? \'#337ab7\' :\n                        editor.campaign.state === \'sending\' ? \'#f0ad4e\' :\n                        editor.campaign.state === \'sent\' ? \'#5cb85c\' :\n                        editor.campaign.state === \'failed\' ? \'#d9534f\' : \'#999\'\n                      }}\" title=\"{{\n                        editor.campaign.state === \'draft\' ? \'Campaign being created. All fields editable.\' :\n                        editor.campaign.state === \'testing\' ? \'Test emails sent. All fields still editable.\' :\n                        editor.campaign.state === \'ready\' ? \'Campaign finalized and locked. Ready to launch.\' :\n                        editor.campaign.state === \'sending\' ? \'Campaign is currently sending emails.\' :\n                        editor.campaign.state === \'sent\' ? \'Campaign completed. All emails sent.\' :\n                        editor.campaign.state === \'failed\' ? \'Campaign failed during sending.\' : \'\'\n                      }}\">{{ editor.campaign.state | uppercase }}</span></div></div><md-card-content class=padding-content><!-- Locked Campaign Warning (Ready State) --><div class=\"alert alert-warning\" ng-if=\"editor.campaign.state === \'ready\'\" style=\"margin-bottom: 20px; border-left: 4px solid #ff9800; padding-left: 20px\"><h4 style=\"margin-top: 0; color: #f57c00\"><i class=\"fa fa-lock\"></i> Campaign Locked - Ready for Launch</h4><p style=\"margin-bottom: 10px\">This campaign is finalized and ready to launch. All fields are locked to prevent accidental changes.</p><p style=\"margin-bottom: 0\"><strong>To make changes:</strong> Return to the Dashboard and click the <strong style=\"color: #f57c00\">\"Reset to Draft\"</strong> button (undo icon). This will unlock all fields for editing, allowing you to modify email content, upload a new CSV, and send new test emails.</p></div><form name=campaignForm><!-- Basic Info --><div row-restrict max-width=800px><div layout=row layout-xs=column><md-input-container flex class=md-block style=\"margin-right: 20px\"><label>Campaign Name</label><input type=text name=campaignName ng-model=editor.campaign.name required ng-disabled=editor.isReadOnly()><div ng-messages=campaignForm.campaignName.$error ng-if=campaignForm.campaignName.$touched><div ng-message=required class=md-input-message-animation>Campaign Name is required</div></div></md-input-container><md-input-container flex class=md-block><label>Email Subject</label><input type=text name=emailSubject ng-model=editor.campaign.subject ng-minlength=10 required ng-disabled=editor.isReadOnly()><div ng-messages=campaignForm.emailSubject.$error ng-if=campaignForm.emailSubject.$touched><div ng-message=required class=md-input-message-animation>Email Subject is required</div><div ng-message=minlength class=md-input-message-animation>Email Subject must be at least 10 characters long</div></div></md-input-container></div><div layout=row layout-xs=column><md-input-container flex class=md-block style=\"margin-right: 20px\"><label>Sender Name</label><input type=text name=senderName ng-model=editor.campaign.sender_name required ng-disabled=editor.isReadOnly()><div ng-messages=campaignForm.senderName.$error ng-if=campaignForm.senderName.$touched><div ng-message=required class=md-input-message-animation>Sender Name is required</div></div></md-input-container><md-input-container flex class=md-block><label>Sender Email</label><input type=email name=senderEmail ng-model=editor.campaign.sender_email ng-pattern=/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/ required ng-disabled=editor.isReadOnly()><div ng-messages=campaignForm.senderEmail.$error ng-if=campaignForm.senderEmail.$touched><div ng-message=required class=md-input-message-animation>Sender Email is required</div><div ng-message=email class=md-input-message-animation>Please enter a valid email address</div><div ng-message=pattern class=md-input-message-animation>Please enter a valid email address</div></div></md-input-container></div></div><!-- Email Body --><div class=\"mt-15 mb-30\"><div class=\"sub-title mb-15\">Email Body <span ng-if=!editor.isReadOnly()>*</span></div><!-- Edit Mode: Template Variables Help + Text Editor --><div ng-if=!editor.isReadOnly()><!-- Template Variables Help --><div style=\"background-color: #e3f2fd; border-left: 4px solid #2196F3; padding: 12px 15px; margin-bottom: 10px; border-radius: 3px\" ng-non-bindable><div style=\"color: #1976d2; font-size: 13px\"><i class=\"fa fa-info-circle\"></i> <strong>Available template variables:</strong> <code style=\"background-color: #fff; padding: 2px 6px; margin: 0 4px; border-radius: 3px\">{{username}}</code> and <code style=\"background-color: #fff; padding: 2px 6px; margin: 0 4px; border-radius: 3px\">{{id}}</code></div><div style=\"color: #555; font-size: 12px; margin-top: 5px\">Example: Hi {{username}}, Your affiliate ID is {{id}}. Thank you for being part of our program!</div></div><text-angular class=text-editor name=body ng-model=editor.campaign.body_html ta-toolbar=editor.customToolbar ta-unsafe-sanitizer=true ng-minlength=10 required></text-angular><div ng-messages=campaignForm.body.$error ng-if=campaignForm.body.$touched style=\"color: #f44336; font-size: 12px; margin-top: 5px\"><div ng-message=required>Email Body is required</div><div ng-message=minlength>Email Body must be at least 20 characters long</div></div></div><!-- View Mode: Read-only Preview --><div ng-if=editor.isReadOnly()><div style=\"border: 1px solid #ddd; border-radius: 4px; padding: 20px; background-color: #fff; min-height: 200px; max-height: 500px; overflow-y: auto\"><div style=\"background-color: #f5f5f5; padding: 10px 15px; margin: -20px -20px 20px -20px; border-bottom: 1px solid #ddd; border-radius: 4px 4px 0 0\"><i class=\"fa fa-envelope-o\" style=\"color: #666; margin-right: 8px\"></i> <span style=\"color: #666; font-size: 13px\">Email Preview</span></div><div ng-bind-html=editor.campaign.body_html></div></div></div></div><!-- CSV Upload Section --><div ng-if=\"editor.campaign.id && (editor.campaign.state === \'draft\' || editor.campaign.state === \'testing\')\" style=\"border: 1px solid #ddd; border-radius: 4px; padding: 20px; margin-top: 20px; background-color: #fafafa\"><h4 style=\"margin-top: 0; margin-bottom: 15px\">Recipient List (CSV)</h4><p style=\"margin-bottom: 5px\">Upload a CSV with headers: <code>ID, Username</code></p><p style=\"margin-bottom: 15px; color: #666; font-size: 13px\"><i class=\"fa fa-info-circle\"></i> Max file size: <strong>500 KB</strong> | Max rows: <strong>3,000</strong></p><div class=\"alert alert-warning\" ng-if=\"editor.recipientMeta.total > 0\" style=\"margin-bottom: 15px\"><i class=\"fa fa-exclamation-triangle\" style=\"color: #f57c00; font-size: 16px; margin-right: 5px\"></i> <strong>Warning:</strong> Uploading a new CSV will replace all {{ editor.recipientMeta.total }} existing recipients.</div><div class=form-group><input type=file id=csvFileUpload class=form-control accept=.csv></div><md-button class=\"md-raised md-warn\" ng-click=editor.uploadCsv() ng-disabled=editor.uploading style=\"margin-top: 10px\"><i class=\"fa fa-upload\"></i> {{ editor.uploading ? \'Uploading...\' : \'Upload & Process CSV\' }}</md-button><div class=\"alert alert-success\" ng-if=editor.campaign.stats.total_csv_rows><strong>CSV Stats:</strong> Valid: {{ editor.campaign.stats.valid_recipients }}, Invalid: {{ editor.campaign.stats.invalid_rows }} (Total: {{ editor.campaign.stats.total_csv_rows }})</div><div class=\"alert alert-danger\" ng-if=editor.campaign.stats.error><strong>Error:</strong> {{ editor.campaign.stats.error }}</div></div><!-- Recipients Section Container --><div ng-if=\"editor.campaign.id && (editor.campaign.state !== \'draft\' && editor.campaign.state !== \'testing\' || editor.campaign.stats.valid_recipients > 0)\" style=\"border: 1px solid #ddd; border-radius: 4px; padding: 20px; margin-top: 20px; background-color: #fafafa\"><!-- CSV Upload Locked Message --><div class=\"alert alert-info\" ng-if=\"editor.campaign.state !== \'draft\' && editor.campaign.state !== \'testing\'\" style=\"margin-top: 0\"><i class=\"fa fa-lock\"></i> <strong>Recipient List Locked:</strong> Campaign is in \'{{ editor.campaign.state | uppercase }}\' state. <span ng-if=\"editor.campaign.state === \'ready\'\">All fields including recipient list are locked. Click <strong>\"Reset to Draft\"</strong> on the Dashboard to make changes. </span><span ng-if=\"editor.campaign.state !== \'ready\'\">Recipient list can only be modified in \'draft\' or \'testing\' states.</span></div><!-- Recipient List Viewer --><div class=well ng-if=\"editor.campaign.stats.valid_recipients > 0\" style=\"margin-top: 20px; margin-bottom: 0\"><h4>Recipients ({{ editor.recipientMeta.total || editor.campaign.stats.valid_recipients }} total)</h4><!-- Search Box --><div class=form-group style=\"margin-bottom: 15px; margin-top: 20px\"><label style=\"display: block; margin-bottom: 10px; font-weight: 500\">Search by Username or ID</label><div layout=row layout-align=\"start center\"><md-input-container flex=70 style=\"margin: 0\"><input type=text ng-model=editor.searchQuery ng-keypress=\"$event.keyCode == 13 && editor.searchRecipients()\"></md-input-container><md-button class=\"md-raised md-primary\" ng-click=editor.searchRecipients() style=\"margin-left: 10px\"><i class=\"fa fa-search\"></i> Search</md-button><md-button class=md-raised ng-click=editor.clearSearch() ng-if=editor.searchQuery style=\"margin-left: 10px\"><i class=\"fa fa-times\"></i> Clear</md-button></div></div><!-- Recipient Table --><table class=\"table table-striped table-bordered\"><thead style=\"background-color: #f5f5f5\"><tr><th style=\"width: 7%; font-weight: bold; padding: 12px 8px\">ID</th><th style=\"width: 38%; font-weight: bold; padding: 12px 8px\">Username</th><th style=\"width: 48%; font-weight: bold; padding: 12px 8px\">Email</th><th style=\"width: 7%; font-weight: bold; padding: 12px 8px\">Status</th></tr></thead><tbody style=\"border-top: 2px solid #ddd\"><tr ng-if=\"editor.recipients.length === 0\"><td colspan=4 style=\"text-align: center; padding: 20px\"><em>No recipients found</em></td></tr><tr ng-repeat=\"recipient in editor.recipients\"><td>{{ recipient.id }}</td><td>{{ recipient.username }}</td><td>{{ recipient.email }}</td><td><span class=label ng-class=\"{\n                                            \'label-default\': recipient.status === \'pending\',\n                                            \'label-success\': recipient.status === \'sent\',\n                                            \'label-danger\': recipient.status === \'failed\'\n                                        }\">{{ recipient.status || \'pending\' }}</span></td></tr></tbody></table><!-- Pagination --><div layout=row layout-align=\"space-between center\" style=\"margin-top: 15px\"><div>Showing {{ (editor.recipientMeta.current_page - 1) * editor.recipientMeta.per_page + 1 }} to {{ editor.recipientMeta.current_page * editor.recipientMeta.per_page > editor.recipientMeta.total ? editor.recipientMeta.total : editor.recipientMeta.current_page * editor.recipientMeta.per_page }} of {{ editor.recipientMeta.total }} recipients</div><div layout=row layout-align=\"end center\"><md-button class=md-raised ng-click=editor.prevPage() ng-disabled=\"editor.recipientMeta.current_page === 1\"><i class=\"fa fa-chevron-left\"></i> Previous</md-button><span style=\"margin: 0 15px\">Page {{ editor.recipientMeta.current_page }} of {{ editor.recipientMeta.total_pages }}</span><md-button class=md-raised ng-click=editor.nextPage() ng-disabled=\"editor.recipientMeta.current_page === editor.recipientMeta.total_pages\">Next <i class=\"fa fa-chevron-right\"></i></md-button></div></div></div></div><!-- End Recipients Section Container --><!-- Audit Trail Section --><div class=well ng-if=editor.campaign.id style=\"margin-top: 20px\"><div layout=row layout-align=\"space-between center\" style=\"cursor: pointer\" ng-click=editor.toggleAuditTrail()><h4 style=\"margin: 0\"><i class=\"fa fa-history\"></i> Campaign History</h4><i class=fa ng-class=\"editor.showAuditTrail ? \'fa-chevron-up\' : \'fa-chevron-down\'\"></i></div><div ng-if=editor.showAuditTrail style=\"margin-top: 15px\"><div ng-if=\"editor.audits.length === 0\" style=\"text-align: center; padding: 20px; color: #999\"><em>No history available yet</em></div><table class=\"table table-striped\" ng-if=\"editor.audits.length > 0\"><thead><tr><th style=\"width: 15%\">Date & Time</th><th style=\"width: 20%\">User</th><th style=\"width: 10%\">Action</th><th style=\"width: 55%\">Details</th></tr></thead><tbody><tr ng-repeat=\"audit in editor.audits\"><td><i class=\"fa {{ editor.getAuditIcon(audit.action) }}\" style=\"margin-right: 5px\" ng-style=\"audit.action.includes(\'error\') && {\'color\': \'#d9534f\'}\"></i> {{ audit.created_at | date:\'short\' }}</td><td>{{ audit.user_email }}</td><td><span class=label ng-class=\"{\n                                            \'label-info\': audit.action === \'create\' || audit.action === \'update\',\n                                            \'label-danger\': audit.action === \'test_send_error\' || audit.action === \'send_error\' || audit.action === \'csv_upload_error\'\n                                        }\">{{ editor.formatAuditAction(audit.action) }}</span></td><td><!-- Show comment if available --><div ng-if=audit.comment style=\"margin-bottom: 5px\"><strong ng-class=\"{\'text-danger\': audit.action.includes(\'error\')}\">{{ audit.comment }}</strong></div><!-- Show error details if present --><div ng-if=\"audit.raw_changes && (audit.raw_changes.error_message || audit.raw_changes.failed_emails)\" class=\"alert alert-danger\" style=\"margin-top: 5px; padding: 8px; font-size: 12px; border-left: 4px solid #d9534f\"><i class=\"fa fa-exclamation-triangle\" style=\"color: #d9534f; font-size: 16px; margin-right: 5px\"></i> <strong style=\"color: #d9534f\">Error Details:</strong><!-- For campaign send errors --><div ng-if=audit.raw_changes.error_message style=\"margin-top: 5px\">{{ audit.raw_changes.error_message }}</div><!-- For test send errors with multiple failed emails --><div ng-if=audit.raw_changes.failed_emails><div ng-repeat=\"failed in audit.raw_changes.failed_emails\" style=\"margin-top: 3px\">{{ failed }}</div></div></div><!-- Show field changes (non-error audits) --><div ng-if=\"audit.changes && audit.changes.length > 0 && !audit.action.includes(\'error\')\"><div ng-repeat=\"change in audit.changes\" style=\"font-size: 12px; color: #666\"><strong>{{ change.field }}:</strong> <span ng-if=change.from><code style=\"background: #ffe6e6\">{{ change.from | limitTo:50 }}</code> </span>→ <code style=\"background: #e6ffe6\">{{ change.to | limitTo:50 }}</code></div></div><!-- Show IP address if available --><div ng-if=\"audit.ip_address && !audit.comment && (!audit.changes || audit.changes.length === 0)\" style=\"font-size: 12px; color: #999\">IP: {{ audit.ip_address }}</div></td></tr></tbody></table></div></div></form></md-card-content><div class=card-footer><div class=\"alert alert-warning\" ng-if=\"campaignForm.$invalid && campaignForm.$dirty\" style=\"margin-bottom: 15px\"><i class=\"fa fa-exclamation-triangle\"></i> <strong>Please complete all required fields before saving.</strong> <span ng-if=campaignForm.campaignName.$invalid>Campaign Name is missing.</span> <span ng-if=campaignForm.emailSubject.$invalid>Email Subject is missing.</span> <span ng-if=campaignForm.senderName.$invalid>Sender Name is missing.</span> <span ng-if=campaignForm.senderEmail.$invalid>Valid Sender Email is required.</span> <span ng-if=campaignForm.body.$invalid>Email Body is missing.</span></div><div class=button-holder ng-if=!editor.isReadOnly()><md-button class=\"md-raised md-primary btn-primary\" ng-click=editor.save(false) ng-disabled=campaignForm.$invalid><i class=\"fa fa-save\"></i> Save Changes</md-button><md-button class=\"md-raised btn-primary\" ng-click=editor.saveAndReturn() ng-disabled=campaignForm.$invalid style=\"margin-left: 10px\"><i class=\"fa fa-save\"></i> Save & Return to Dashboard</md-button><span style=\"margin-left: 15px; color: #666; font-size: 13px\"><i class=\"fa fa-info-circle\"></i> Save to continue editing, or Save & Return when done</span></div></div></md-card></div>");
$templateCache.put("app/auth/auth.html","<div layout=column class=auth-holder><div flex=none class=notification-header-wrap><information-plate show-for=anonym></information-plate><language-toggle fixed=true></language-toggle></div><div flex class=auth-content><div flex layout=column layout-align=\"space-between center\" class=auth-wrapper><div flex class=top-el></div><div class=center-block><div class=logo><logo-main></logo-main></div><div class=\"auth-content medium-text align-center welcome-text\"><p><md-translate key=\"\'AuthMainPage\'\" shortcode=\"\'main_page.welcome\'\"></md-translate></p></div><div class=nav-links><md-button class=\"md-raised md-primary btn-primary\" ui-sref=sign_in><md-translate key=\"\'AuthMainPage\'\" shortcode=\"\'main_page.sign_in\'\"></md-translate></md-button><md-button class=\"md-raised md-accent btn-primary\" ui-sref=affiliate_data><md-translate key=\"\'AuthMainPage\'\" shortcode=\"\'main_page.sign_up\'\"></md-translate></md-button></div></div><div flex layout=column layout-align=\"end center\" class=bottom-el><last-update-control class=auth-page></last-update-control><powered-by-q></powered-by-q></div></div></div></div>");
$templateCache.put("app/components/history_changes/history_changes.html","<md-card class=\"primary-card history-changes\"><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><i class=\"fa fa-clock-o\"></i><md-translate key=::historyCtrl.translate_key shortcode=\"\'history_changes.header\'\"></md-translate></div></div><div class=card-content><div><div class=history-changes-holder><div ng-repeat=\"item in historyChanges track by $index\" class=history-row><div layout-wrap layout=row layout-xs=column layout-align=\"center center\" layout-align-xs=\"start start\"><div flex=none class=changes-time><p date-locale={{item.created_at}} format={{historyCtrl.date_format}}></p></div><div flex class=changes-info><p><translate translate-values={{item.message.data}}>{{item.message.text}}</translate></p></div></div></div><div ng-if=!historyChanges.length class=no-changes-list><md-translate key=::historyCtrl.translate_key shortcode=\"\'history_changes.history_empty\'\"></md-translate></div></div></div></div></md-card>");
$templateCache.put("app/components/sidenav/sidenav.html","<md-sidenav class=md-sidenav-left md-component-id={{::$ctrl.sidenavName}} md-is-locked-open=\"$mdMedia(\'gt-sm\')\"><md-toolbar hide-gt-sm class=sidenav-toolbar ng-style=\"{\'background\': toolbarBg}\"><merchant-toggle ng-if=!$ctrl.isGtSm></merchant-toggle></md-toolbar><navigation></navigation><last-update-control class=navigation-wrap></last-update-control></md-sidenav>");
$templateCache.put("app/auth/rules/rules.html","<md-dialog><div flex=none class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=$ctrl.translateKey shortcode=$ctrl.modalTitle></md-translate></div><md-button class=\"md-icon-button close-btn\" ng-click=$ctrl.closeModal()></md-button></div><md-dialog-content class=md-dialog-content><div ng-bind-html=$ctrl.modalContent class=md-dialog-content-body></div></md-dialog-content></md-dialog>");
$templateCache.put("app/admin/balance_adjustments_history/partials/adjustments_history_list.html","<ui-view><div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::adjustmentsListCtrl.translate_key shortcode=\"\'adjustments_history.header\'\"></md-translate></div><div flex=nogrow class=search-block><table-list-search table=adjustmentsListCtrl.table></table-list-search></div></div></div><div class=card-content><table-list table=adjustmentsListCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.admin_balance_adjustments_history_download\'\" class=\"md-raised md-primary btn-primary\" ng-click=adjustmentsListCtrl.downloadReport($event)><md-translate key=::adjustmentsListCtrl.translate_key shortcode=\"\'adjustments_history.download_report_button\'\"></md-translate></md-button></div><table-list-pagination table=adjustmentsListCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/conditions/partials/conditions.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::conditions.translate_key shortcode=\"\'conditions.header\'\"></md-translate></div><div class=search-block><table-list-search table=conditions.table></table-list-search></div></div><div class=card-content><table-list table=conditions.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.conditionscontroller.edit\'\" class=\"md-raised md-primary btn-primary\" ng-click=conditions.create_condition()><md-translate key=::conditions.translate_key shortcode=\"\'conditions.create_plan\'\"></md-translate></md-button></div><table-list-pagination table=conditions.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/conditions/partials/cpa.html","<condition type=cpa instant=settings.condition_instance methods=settings.methods></condition>");
$templateCache.put("app/admin/conditions/partials/cpa_template.html","<div class=pt-25><div class=\"md-subhead mb-10 space-around condition-settings-title\"><md-translate key=::ctrl.translate_key shortcode=\"::\'main_params.form.cpa\'\"></md-translate><md-translate key=::ctrl.translate_key shortcode=\"::\'steps.header\'\"></md-translate></div><div class=steps-wrap><span class=conditions-all><div layout-wrap layout-gt-xs=row layout=column layout-align=\"start center\" class=\"step condition-item\"><div flex=none class=\"step-count common\"><md-translate key=::ctrl.translate_key shortcode=\"::\'condition_items.cpa.title\'\"></md-translate></div><div flex=none ng-repeat=\"condition_item in instant.condition.condition_items_attributes\" ng-if=\"condition_item._destroy === 0\" ng-class=\"{\'read-only\': instant.condition.read_only}\" class=\"condition-box common read-only-input\"><span class=space-around ng-click=\"methods.edit_item(condition_item, $event, instant)\"><span ng-bind=\"methods.getKeyOfValue(condition_item.obtained_result, instant, \'condition_items\', \'obtained_result\')\"></span><span ng-bind=condition_item.condition_for_comparison ng-show=\"condition_item.condition_for_comparison || condition_item.condition_for_comparison == 0\"></span><span ng-bind=condition_item.desired_value ng-show=\"condition_item.desired_value || condition_item.desired_value == 0\"></span><span ng-hide=\"condition_item.condition_for_comparison || condition_item.desired_value\"><md-translate key=::ctrl.translate_key shortcode=\"::\'condition_items.cpa.enter_condition\'\"></md-translate></span></span><span ng-click=ctrl.remove_condition_item(condition_item) ng-if=!instant.condition.read_only class=remove-condition-box><img src=assets/images/cross.png></span></div><md-button class=\"btn-light md-button common\" ng-click=\"methods.add_condition_for_all($event, instant)\" ng-if=!instant.condition.read_only><i class=\"fa fa-plus\"></i><md-translate key=::ctrl.translate_key shortcode=\"::\'condition_items.cpa.add_condition\'\"></md-translate></md-button><div flex layout=row layout-align=\"start center\" ng-if=\"instant.no_items &amp;&amp; !instant.condition.read_only\" class=alert-validation><div class=alert-msg><md-translate key=::ctrl.translate_key shortcode=\"::\'validations.item_is_absent\'\"></md-translate></div></div><div flex layout=row layout-align=\"start center\" ng-if=\"instant.destroy_all_items &amp;&amp; !instant.condition.read_only\" class=alert-validation><div class=alert-msg><md-translate key=::ctrl.translate_key shortcode=\"::\'validations.can_not_remove_all_items\'\"></md-translate></div></div><div flex layout=row layout-align=\"start center\" ng-if=\"(instant.is_accumulative_invalid || instant.obtained_result_not_unique) &amp;&amp; !instant.condition.read_only\" class=alert-validation><div class=alert-msg><div ng-if=instant.is_accumulative_invalid class=msg-text><md-translate key=::ctrl.translate_key shortcode=\"::\'validations.obtained_result_accumulative_not_valid\'\"></md-translate></div><div ng-if=instant.obtained_result_not_unique class=msg-text><md-translate key=::ctrl.translate_key shortcode=\"::\'validations.obtained_result_not_unique\'\"></md-translate></div></div></div></div></span></div></div><div ng-include=\"\'app/admin/conditions/partials/steps_part.html\'\"></div>");
$templateCache.put("app/admin/conditions/partials/cpl.html","<condition type=cpl instant=settings.condition_instance methods=settings.methods></condition>");
$templateCache.put("app/admin/conditions/partials/cpl_template.html","<div class=pt-25><div class=\"md-subhead mb-10 space-around condition-settings-title\"><md-translate key=::ctrl.translate_key shortcode=\"\'main_params.form.cpl\'\"></md-translate><md-translate key=::ctrl.translate_key shortcode=\"\'steps.header\'\"></md-translate></div></div><div ng-include=\"\'app/admin/conditions/partials/steps_part.html\'\"></div>");
$templateCache.put("app/admin/conditions/partials/filter.html","<div class=condition-filters><div layout-wrap layout-gt-xs=row layout-align-gt-xs=\"start center\" layout=column layout-align=\"start start\"><!--Desktop filters--><div flex=none ng-if=$ctrl.isGtXs class=filters-list><md-button ng-repeat=\"temp in $ctrl.instance.filters | orderBy:[\'ide\'] track by temp.ide\" ng-click=$ctrl.instance.chooseFilter(temp) class=btn-set-params ng-class=\"{\'current\': temp.ide === $ctrl.instance.currentFilter.ide}\" ng-if=\"temp._destroy === 0\" ng-disabled=\"temp.ide === $ctrl.instance.currentFilter.ide\"><div layout-wrap layout=row layout-align=\"center center\"><span flex ng-if=\"temp.aasm_state === \'default\'\"><md-translate key=::$ctrl.translateKey shortcode=\"\'filters.filter_all_countries\'\"></md-translate></span><span flex ng-if=\"!temp.name &amp;&amp; temp.aasm_state !== \'default\'\"><md-translate key=::$ctrl.translateKey shortcode=\"\'filters.no_name\'\" translate-values=\"{ id: temp.ide }\"></md-translate></span><span flex ng-if=\"temp.name &amp;&amp; temp.aasm_state !== \'default\'\"><span ng-bind=temp.name></span></span><span flex=none class=btn-toggle ng-if=\"temp.aasm_state !== \'default\'\" ng-click=\"$ctrl.instance.toggleFilter(temp, $event)\" ng-class=\"{\'open\': temp.show}\"></span><span flex=none class=btn-remove ng-class=\"{\'disabled\': $ctrl.instance.options.readOnly}\" ng-click=\"$ctrl.instance.removeFilter(temp, $event)\" ng-if=\"temp.aasm_state !== \'default\' &amp;&amp; !$ctrl.instance.options.readOnly\"><img src=assets/images/cross.png></span></div></md-button></div><!--Mobile filters--><div flex=none ng-if=!$ctrl.isGtXs class=filters-list><div layout=row class=templates-list-mobile><md-input-container flex class=md-block><md-select md-select-label-translate ng-model=$ctrl.instance.currentFilter ng-change=$ctrl.instance.chooseFilterChange()><md-option ng-value=temp ng-repeat=\"temp in $ctrl.instance.filters | orderBy:[\'ide\'] track by temp.ide\" ng-if=\"temp._destroy === 0\"><span flex ng-if=\"temp.aasm_state === \'default\'\"><md-translate key=::$ctrl.translateKey shortcode=\"\'filters.filter_all_countries\'\"></md-translate></span><span flex ng-if=\"!temp.name &amp;&amp; temp.aasm_state !== \'default\'\"><md-translate key=::$ctrl.translateKey shortcode=\"\'filters.no_name\'\" translate-values=\"{ id: temp.ide }\"></md-translate></span><span flex ng-if=\"temp.name &amp;&amp; temp.aasm_state !== \'default\'\"><span ng-bind=temp.name></span></span></md-option></md-select></md-input-container><md-button layout=column layout-align=\"center center\" class=md-icon-button ng-if=\"$ctrl.instance.currentFilter.aasm_state !== \'default\'\" ng-click=\"$ctrl.instance.toggleFilter($ctrl.instance.currentFilter, $event)\" ng-class=\"{\'open\': $ctrl.instance.currentFilter.show}\"><i class=\"fa fa-chevron-down\"></i></md-button><md-button class=md-icon-button ng-class=\"{\'disabled\': $ctrl.instance.options.readOnly}\" ng-click=\"$ctrl.instance.removeFilter($ctrl.instance.currentFilter, $event)\" ng-if=\"$ctrl.instance.currentFilter.aasm_state !== \'default\' &amp;&amp; !$ctrl.instance.options.readOnly\"><img src=assets/images/cross.png></md-button></div></div><md-button ng-click=$ctrl.instance.addFilter() class=\"btn-set-params btn-light\" ng-if=!$ctrl.instance.options.readOnly><i class=\"fa fa-plus\"></i><md-translate key=::$ctrl.translateKey shortcode=\"\'filters.add_new_filter\'\"></md-translate></md-button><div flex layout=row layout-align=\"start center\" ng-if=\"$ctrl.instance.getInvalidFilters().length &amp;&amp; !$ctrl.instance.options.readOnly\" class=alert-validation><div class=\"alert-msg space-around\"><span><md-translate key=::$ctrl.translateKey shortcode=\"\'validations.invalid_some_filter\'\"></md-translate></span><span ng-repeat=\"temp in $ctrl.instance.getInvalidFilters()\"><span ng-if=\"temp.aasm_state === \'default\'\"><md-translate key=::$ctrl.translateKey shortcode=\"\'filters.filter_all_countries\'\"></md-translate></span><span ng-if=\"!temp.name &amp;&amp; temp.aasm_state !== \'default\'\"><md-translate key=::$ctrl.translateKey shortcode=\"\'filters.no_name\'\" translate-values=\"{ id: temp.ide }\"></md-translate></span><span ng-if=\"temp.name &amp;&amp; temp.aasm_state !== \'default\'\"><span ng-bind=temp.name></span></span><span ng-bind=\"\',\'\" ng-if=!$last></span></span></div></div></div></div><div ng-if=\"$ctrl.instance.currentFilter.aasm_state !== \'default\'\" ng-show=$ctrl.instance.currentFilter.show class=condition-filters><div class=condition-filters-content-wrap><!--Desktop tabs--><div ng-if=$ctrl.isGtXs class=filters-tabs-list><md-button class=\"filters-tab btn-set-params current\"><span md-translate key=::$ctrl.translateKey shortcode=\"\'filters.countries\'\"></span></md-button></div><!--Mobile tabs--><div ng-if=!$ctrl.isGtXs class=\"filters-tabs-list tabs-list-mobile\"><md-tabs><md-tab></md-tab><md-tab md-active=true><span md-translate key=::$ctrl.translateKey shortcode=\"\'filters.countries\'\"></span></md-tab></md-tabs></div><div class=filter-template><checkbox-list list=$ctrl.instance.dataForView field-name=name field-to-server=country_code callback=$ctrl.changeDataCallback all-disabled=$ctrl.instance.options.readOnly></checkbox-list></div><div class=filter-name-wrap><md-input-container><label><md-translate key=::$ctrl.translateKey shortcode=\"\'filters.label_filter_name_input\'\"></md-translate></label><input type=text ng-model=$ctrl.instance.currentFilter.name ng-disabled=$ctrl.instance.options.readOnly></md-input-container></div></div><form name=$ctrl.countryForm><md-input-container class=\"md-block fake-input-error\"><input input-errors type=text name=value ng-model=$ctrl.placeholderValue><md-error-messages errors=$ctrl.errors input-name=value></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/admin/conditions/partials/filter_template.html","<condition-filter instance=settings.Filter translate-key=settings.translate_key></condition-filter><div row-restrict max-width=450px class=\"mt-30 last-item-no-margin\"><form name=settings.determineCountryForm><md-input-container class=md-block ng-if=!settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"\'filters.how_to_determine_the_country\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=country_by_ip ng-model=settings.condition_instance.condition.country_by_ip ng-disabled=settings.condition_instance.condition.read_only ng-class=\"{\'read-only\': settings.condition_instance.condition.read_only}\"><md-option ng-value=item.value ng-repeat=\"item in settings.determineCountryList\"><md-translate key=::settings.translate_key shortcode=item.shortcode></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=country_by_ip></md-error-messages></md-input-container><md-input-container class=md-block ng-if=settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"\'filters.how_to_determine_the_country\'\"></md-translate></label><textarea name=country_by_ip ng-readonly=settings.condition_instance.condition.read_only>{{settings.getShortcode(settings.determineCountryList, settings.condition_instance.condition.country_by_ip) | mdTranslate: settings.translate_key}}</textarea></md-input-container></form></div>");
$templateCache.put("app/admin/conditions/partials/form.html","<form name=settings.conditionForm><div row-restrict max-width=450px class=last-item-no-margin><md-input-container class=md-block ng-if=!settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.merchant\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=merchant ng-model=settings.merchantId ng-disabled=settings.condition_instance.condition.id ng-change=settings.changeMerchant(settings.condition_instance)><md-option ng-value=item.id ng-repeat=\"item in settings.merchantsList\"><span ng-bind=item.value></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=merchant></md-error-messages></md-input-container><md-input-container class=md-block ng-if=settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.merchant\'\"></md-translate></label><input name=merchant ng-value=settings.merchantName ng-readonly=settings.condition_instance.condition.read_only></md-input-container><md-input-container class=md-block ng-if=!settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.type_of_transaction\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=type_of_transaction ng-model=settings.condition_instance.condition.type_of_transaction ng-disabled=settings.condition_instance.condition.id ng-change=settings.change_type_of_transaction()><md-option ng-value=value ng-repeat=\"(key, value) in settings.condition_classes\"><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.\' + value\"></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=type_of_transaction></md-error-messages></md-input-container><md-input-container class=md-block ng-if=settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.type_of_transaction\'\"></md-translate></label><textarea name=type_of_transaction ng-readonly=settings.condition_instance.condition.read_only>{{\'main_params.form.\' + settings.condition_instance.condition.type_of_transaction | mdTranslate: settings.translate_key}}</textarea></md-input-container><md-input-container class=md-block><label><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.title\'\"></md-translate></label><textarea required md-no-asterisk input-errors name=title ng-model=settings.condition_instance.condition.title ng-readonly=settings.condition_instance.condition.read_only></textarea><md-error-messages errors=settings.errors input-name=title></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.description\'\"></md-translate></label><textarea required md-no-asterisk input-errors name=description ng-model=settings.condition_instance.condition.description ng-readonly=settings.condition_instance.condition.read_only></textarea><md-error-messages errors=settings.errors input-name=description></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"!settings.condition_instance.condition.hide_commissions_attributes &amp;&amp; (settings.condition_instance.condition.type_of_transaction === \'revenue_share\' || settings.condition_instance.condition.type_of_transaction === \'hybrid\')\"><label><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.for_deduction\'\"></md-translate></label><input input-errors name=for_deduction type=number ng-model=settings.commissions_attributes.for_deduction.value ng-change=settings.change_commissions_attributes() ng-readonly=settings.condition_instance.condition.read_only><md-error-messages errors=settings.errors input-name=for_deduction></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"!settings.condition_instance.condition.hide_commissions_attributes &amp;&amp; (settings.condition_instance.condition.type_of_transaction === \'revenue_share\' || settings.condition_instance.condition.type_of_transaction === \'hybrid\')\"><label><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.for_reward_program\'\"></md-translate></label><input input-errors name=for_reward_program type=number ng-model=settings.commissions_attributes.for_reward_program.value ng-change=settings.change_commissions_attributes() ng-readonly=settings.condition_instance.condition.read_only><md-error-messages errors=settings.errors input-name=for_reward_program></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"settings.condition_instance.condition.type_of_transaction === \'hybrid\'\"><label><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.calculating_profit_method\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=calculating_profit_method ng-model=settings.condition_instance.condition.calculating_profit_method ng-change=settings.accumulative_validation() ng-disabled=settings.condition_instance.condition.read_only ng-class=\"{\'read-only\': settings.condition_instance.condition.read_only}\"><md-option ng-selected=\"settings.condition_instance.condition.calculating_profit_method === value || $first\" ng-value=value ng-repeat=\"value in settings.calculating_profit_methods\"><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.\' + value\"></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=calculating_profit_method></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"!settings.condition_instance.condition.read_only &amp;&amp; settings.showSumByConditionSteps()\"><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.sum_by_merchant_all.label\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=sum_by_merchant_all ng-model=settings.condition_instance.condition.sum_by_merchant_all ng-disabled=settings.condition_instance.condition.read_only ng-class=\"{\'read-only\': settings.condition_instance.condition.read_only}\"><md-option ng-value=item.value ng-repeat=\"item in settings.sumByConditionStepsOptions\"><md-translate key=::settings.translate_key shortcode=item.shortcode></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=sum_by_merchant_all></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"settings.condition_instance.condition.read_only &amp;&amp; settings.showSumByConditionSteps()\"><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.sum_by_merchant_all.label\'\"></md-translate></label><textarea name=sum_by_merchant_all ng-readonly=settings.condition_instance.condition.read_only>{{\'main_params.form.sum_by_merchant_all.\' + (settings.condition_instance.condition.sum_by_merchant_all ? \'yes\' : \'no\') | mdTranslate: settings.translate_key}}</textarea></md-input-container></div><div row-restrict max-width=450px ng-if=settings.condition_instance.checkboxes_fields><md-input-container class=md-block ng-if=!settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.accrual_of_interest_on_the_upper_interval\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=accrual_of_interest_on_the_upper_interval ng-model=settings.condition_instance.condition.accrual_of_interest_on_the_upper_interval ng-disabled=settings.condition_instance.condition.read_only ng-class=\"{\'read-only\': settings.condition_instance.condition.read_only}\"><md-option ng-selected=\"settings.condition_instance.condition.accrual_of_interest_on_the_upper_interval === item.value || $first\" ng-value=item.value ng-repeat=\"item in settings.calculatingProfitMethodsList\"><md-translate key=::settings.translate_key shortcode=item.shortcode></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=accrual_of_interest_on_the_upper_interval></md-error-messages></md-input-container><md-input-container class=md-block ng-if=settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.accrual_of_interest_on_the_upper_interval\'\"></md-translate></label><textarea name=accrual_of_interest_on_the_upper_interval ng-readonly=settings.condition_instance.condition.read_only>{{settings.getShortcode(settings.calculatingProfitMethodsList, settings.condition_instance.condition.accrual_of_interest_on_the_upper_interval) | mdTranslate: settings.translate_key}}</textarea></md-input-container><md-input-container class=md-block ng-if=!settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.transferring_a_negative_commission\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=transferring_a_negative_commission ng-model=settings.condition_instance.condition.transferring_a_negative_commission ng-change=settings.onMasterNegativeCarryoverChange(settings.condition_instance.condition) ng-disabled=settings.condition_instance.condition.read_only ng-class=\"{\'read-only\': settings.condition_instance.condition.read_only}\"><md-option ng-selected=\"settings.condition_instance.condition.transferring_a_negative_commission === item.value || $first\" ng-value=item.value ng-repeat=\"item in settings.transferringNegativeCommissionList\"><md-translate key=::settings.translate_key shortcode=item.shortcode></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=transferring_a_negative_commission></md-error-messages></md-input-container><md-input-container class=md-block ng-if=settings.condition_instance.condition.read_only><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.transferring_a_negative_commission\'\"></md-translate></label><textarea name=transferring_a_negative_commission ng-readonly=settings.condition_instance.condition.read_only>{{settings.getShortcode(settings.transferringNegativeCommissionList, settings.condition_instance.condition.transferring_a_negative_commission) | mdTranslate: settings.translate_key}}</textarea></md-input-container><!--Per-product negative carryover (Option A): the Set-carryover-per-product checkbox shows only--><!--when the master is set to Disable; ticking it reveals the Casino and Poker dropdowns so one--><!--product can keep carrying while the master disables the rest.--><div class=md-block ng-if=\"!settings.condition_instance.condition.read_only &amp;&amp; settings.condition_instance.condition.transferring_a_negative_commission === false\"><md-checkbox md-select-label-translate class=\"primary-checkbox md-primary\" ng-model=settings.condition_instance.condition.set_carryover_per_product ng-change=settings.onSetCarryoverPerProductChange(settings.condition_instance.condition) ng-disabled=settings.condition_instance.condition.read_only><md-translate key=::settings.translate_key shortcode=\"::\'main_params.form.set_carryover_per_product\'\"></md-translate></md-checkbox></div><md-input-container class=md-block ng-if=\"!settings.condition_instance.condition.read_only &amp;&amp; settings.condition_instance.condition.transferring_a_negative_commission === false &amp;&amp; settings.condition_instance.condition.set_carryover_per_product\"><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.transferring_a_negative_commission_casino\'\"></md-translate></label><md-select md-no-asterisk input-errors md-select-label-translate name=transferring_a_negative_commission_casino ng-model=settings.condition_instance.condition.transferring_a_negative_commission_casino ng-disabled=settings.condition_instance.condition.read_only ng-class=\"{\'read-only\': settings.condition_instance.condition.read_only}\"><md-option ng-selected=\"settings.condition_instance.condition.transferring_a_negative_commission_casino === item.value || $first\" ng-value=item.value ng-repeat=\"item in settings.transferringNegativeCommissionList\"><md-translate key=::settings.translate_key shortcode=item.shortcode></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=transferring_a_negative_commission_casino></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"settings.condition_instance.condition.read_only &amp;&amp; settings.condition_instance.condition.transferring_a_negative_commission === false &amp;&amp; settings.condition_instance.condition.set_carryover_per_product\"><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.transferring_a_negative_commission_casino\'\"></md-translate></label><textarea name=transferring_a_negative_commission_casino ng-readonly=settings.condition_instance.condition.read_only>{{settings.getShortcode(settings.transferringNegativeCommissionList, settings.condition_instance.condition.transferring_a_negative_commission_casino) | mdTranslate: settings.translate_key}}</textarea></md-input-container><md-input-container class=md-block ng-if=\"!settings.condition_instance.condition.read_only &amp;&amp; settings.condition_instance.condition.transferring_a_negative_commission === false &amp;&amp; settings.condition_instance.condition.set_carryover_per_product\"><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.transferring_a_negative_commission_poker\'\"></md-translate></label><md-select md-no-asterisk input-errors md-select-label-translate name=transferring_a_negative_commission_poker ng-model=settings.condition_instance.condition.transferring_a_negative_commission_poker ng-disabled=settings.condition_instance.condition.read_only ng-class=\"{\'read-only\': settings.condition_instance.condition.read_only}\"><md-option ng-selected=\"settings.condition_instance.condition.transferring_a_negative_commission_poker === item.value || $first\" ng-value=item.value ng-repeat=\"item in settings.transferringNegativeCommissionList\"><md-translate key=::settings.translate_key shortcode=item.shortcode></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settings.errors input-name=transferring_a_negative_commission_poker></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"settings.condition_instance.condition.read_only &amp;&amp; settings.condition_instance.condition.transferring_a_negative_commission === false &amp;&amp; settings.condition_instance.condition.set_carryover_per_product\"><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.transferring_a_negative_commission_poker\'\"></md-translate></label><textarea name=transferring_a_negative_commission_poker ng-readonly=settings.condition_instance.condition.read_only>{{settings.getShortcode(settings.transferringNegativeCommissionList, settings.condition_instance.condition.transferring_a_negative_commission_poker) | mdTranslate: settings.translate_key}}</textarea></md-input-container></div></form>");
$templateCache.put("app/admin/conditions/partials/ggr_minus_bonuses.html","<condition type=revenue_share instant=settings.condition_instance methods=settings.methods></condition>");
$templateCache.put("app/admin/conditions/partials/hybrid.html","<condition type=cpa instant=settings.condition_instance.cpa methods=settings.methods callback=settings.accumulative_validation()></condition><condition type=revenue_share instant=settings.condition_instance.revenue_share methods=settings.methods></condition>");
$templateCache.put("app/admin/conditions/partials/revenue_share.html","<condition type=revenue_share instant=settings.condition_instance methods=settings.methods></condition>");
$templateCache.put("app/admin/conditions/partials/revenue_share_template.html","<div class=pt-25><div class=\"md-subhead mb-25 space-around condition-settings-title\"><md-translate key=::ctrl.translate_key shortcode=\"::\'main_params.form.revenue_share\'\"></md-translate><md-translate key=::ctrl.translate_key shortcode=\"::\'steps.header\'\"></md-translate></div><div layout-wrap layout-gt-xs=row layout-align-gt-xs=\"start center\" layout=column layout-align=\"start center\" class=\"tabs-wrap products-wrap\"><!--Desktop tabs--><ul flex=none ng-if=ctrl.isGtXs class=\"tabs-list products-list\"><div ng-repeat=\"product in instant.products_list\" ng-class=\"{\'active\': product === instant.current_product, \'without-cross\': instant.addClassForCross(product) || instant.condition.read_only}\" ng-click=instant.chooseProduct(product) class=tab-list-item><md-translate key=ctrl.translate_key shortcode=\"\'product.rs.\' + product\"></md-translate><span ng-click=\"ctrl.remove_product_steps(product, $event)\" ng-if=\"!instant.addClassForCross(product) &amp;&amp; !instant.condition.read_only\" class=remove-product><i class=\"fa fa-times\"></i></span></div></ul><!--Mobile tabs--><div ng-if=!ctrl.isGtXs class=\"tabs-list products-list\"><md-tabs md-center-tabs=true md-stretch-tabs=never><!--Empty tab for not trigering request until user click to other tab--><md-tab></md-tab><md-tab ng-repeat=\"product in instant.products_list\" md-active=\"product === instant.current_product\" md-on-select=instant.chooseProduct(product)><md-translate key=ctrl.translate_key shortcode=\"\'product.rs.\' + product\"></md-translate></md-tab></md-tabs></div><div flex layout=row layout-align=\"start center\" ng-if=\"instant.invalid_products.length &amp;&amp; !instant.condition.read_only\" class=alert-validation><div class=\"alert-msg space-around\"><span><md-translate key=::ctrl.translate_key shortcode=\"::\'validations.invalid_some_product_steps\'\"></md-translate></span><span ng-repeat=\"product in instant.invalid_products\"><md-translate key=::ctrl.translate_key shortcode=\"::\'product.rs.\' + product\"></md-translate><span ng-bind=\"\',\'\" ng-if=!$last></span></span></div></div></div></div><div ng-include=\"\'app/admin/conditions/partials/steps_part.html\'\"></div>");
$templateCache.put("app/admin/conditions/partials/set_condition_form.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=conditions.translate_key shortcode=\"\'set_condition.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><form name=conditions.setForm><md-input-container class=md-block><label><md-translate key=conditions.translate_key shortcode=\"\'set_condition.form.value\'\"></md-translate></label><input required md-no-asterisk input-errors name=payment_size ng-model=conditions.step.payment_size type=number><md-error-messages errors=conditions.errors input-name=payment_size></md-error-messages></md-input-container><md-input-container class=md-block ng-if=conditions.condition_instance.current_product><label><md-translate key=conditions.translate_key shortcode=\"\'set_condition.form.payment_column\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=payment_column ng-model=conditions.step.payment_column><md-option ng-value=value ng-repeat=\"(key, value)  in conditions.payment_columns\"><span ng-bind=key></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=conditions.errors input-name=payment_column></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=conditions.cancel()><md-translate key=conditions.translate_key shortcode=\"\'set_condition.cancel\'\"></md-translate></md-button><md-button class=md-primary ng-click=conditions.set()><md-translate key=conditions.translate_key shortcode=\"\'set_condition.save\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/conditions/partials/settings_condition.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::settings.translate_key shortcode=::settings.main_title></md-translate></div></div><md-card-content class=padding-content><div ng-include=\"\'app/admin/conditions/partials/form.html\'\"></div><div ng-include=\"\'app/admin/conditions/partials/filter_template.html\'\"></div><div ng-include=settings.condition_url></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=settings.save_condition() ng-if=!settings.condition_instance.condition.read_only><md-translate key=::settings.translate_key shortcode=\"::\'common_button.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=settings.back()><md-translate key=::settings.translate_key shortcode=\"::\'common_button.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/conditions/partials/step_condition_item.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=conditions.main_title class=dialog-title></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><form name=conditions.addConditionForm><md-input-container class=md-block><label><md-translate key=conditions.translate_key shortcode=\"\'set_step_item.form.obtained_result\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=obtained_result ng-model=conditions.condition.obtained_result ng-change=conditions.validate_items_obtained_result()><md-option ng-value=value ng-repeat=\"(key , value) in conditions.obtained_list\"><span ng-bind=key></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=conditions.errors input-name=obtained_result></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=conditions.translate_key shortcode=\"\'set_step_item.form.condition_for_comparison\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=condition_for_comparison ng-model=conditions.condition.condition_for_comparison ng-change=conditions.check_any_parametr()><md-option ng-value=key ng-repeat=\"(key , value) in conditions.comparison_list\" ng-if=conditions.any_controll(key)><span ng-bind=value></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=conditions.errors input-name=condition_for_comparison></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"conditions.condition.condition_for_comparison !== \'any\'\"><label><md-translate key=conditions.translate_key shortcode=\"\'set_step_item.form.desired_value\'\"></md-translate></label><input required md-no-asterisk input-errors name=desired_value ng-model=conditions.condition.desired_value type=number><md-error-messages errors=conditions.errors input-name=desired_value></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=conditions.cancel()><md-translate key=conditions.translate_key shortcode=\"\'set_step_item.cancel\'\"></md-translate></md-button><md-button class=md-primary ng-click=conditions.save()><md-translate key=conditions.translate_key shortcode=\"\'set_step_item.save\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/conditions/partials/steps_part.html","<div class=\"steps-wrap mt-30\"><div ng-repeat=\"step in instant.filtered_steps track by $index\" layout=column layout-gt-xs=row layout-align=\"start center\" ng-if=\"step._destroy === 0\" class=step><div flex=none class=\"step-count common\"><md-translate key=::ctrl.translate_key shortcode=\"::\'steps_and_step_items.step\'\" translate-values=\"{ index: ctrl.get_step_index(step, $index) }\"></md-translate></div><div layout-wrap layout-gt-xs=row layout=column class=step-condition-holder ng-class=\"{\'read-only\': instant.condition.read_only}\"><div flex=none ng-click=\"methods.set_condition(step, $event, instant)\" ng-class=\"{\'read-only\': instant.condition.read_only}\" class=\"type-condition common space-around read-only-input\"><span ng-show=\"step.payment_size == 0 || step.payment_size\"><span ng-bind=\"step.payment_size + instant.condition_mark\" class=type></span></span><span ng-hide=\"step.payment_size == 0 || step.payment_size\" class=type-value><span><md-translate key=::ctrl.translate_key shortcode=\"::\'steps_and_step_items.payment_size_empty\'\" translate-values=\"{ mark: instant.condition_mark }\"></md-translate></span></span><span ng-bind=\"methods.getKeyOfValue(step.payment_column, instant, \'condition_steps\', \'payment_column\')\"></span></div><div flex=none ng-repeat=\"condition_step_item in step.condition_step_items_attributes\" ng-click=\"methods.edit_step_item(step, condition_step_item, $event, instant)\" ng-class=\"{\'read-only\': instant.condition.read_only}\" class=\"condition-box common read-only-input\"><span class=space-around><span ng-bind=\"methods.getKeyOfValue(condition_step_item.obtained_result, instant, \'condition_steps\', \'obtained_result\')\"></span><span ng-bind=condition_step_item.condition_for_comparison ng-show=\"condition_step_item.condition_for_comparison || condition_step_item.condition_for_comparison == 0\"></span><span ng-bind=condition_step_item.desired_value ng-show=\"condition_step_item.desired_value || condition_step_item.desired_value == 0\"></span><span ng-hide=\"condition_step_item.condition_for_comparison || condition_step_item.desired_value\"><md-translate key=::ctrl.translate_key shortcode=\"::\'steps_and_step_items.enter_condition\'\"></md-translate></span></span></div><md-button ng-if=!instant.condition.read_only class=\"md-icon-button remove-step-btn\" ng-click=ctrl.remove_step(step)><img src=assets/images/cross.png></md-button></div><div flex layout-gt-xs=row layout=column layout-align=\"start center\" ng-if=\"(!step.is_valid || step.is_accumulative_invalid) &amp;&amp; step._destroy === 0 &amp;&amp; !instant.condition.read_only\" class=alert-validation><div class=alert-msg><div ng-if=\"!step.is_valid &amp;&amp; step._destroy === 0\" class=msg-text><md-translate key=::ctrl.translate_key shortcode=\"::\'validations.step_invalid\'\"></md-translate></div><div ng-if=\"step.is_accumulative_invalid &amp;&amp; step._destroy === 0\" class=msg-text><md-translate ng-if=\"step.is_accumulative_invalid &amp;&amp; step._destroy === 0\" key=::ctrl.translate_key shortcode=\"::\'validations.step_accumulative_invalid\'\"></md-translate></div></div></div></div><div layout-gt-xs=row layout=column layout-align=\"start center\" class=add-button-wrap ng-if=!instant.condition.read_only><md-button class=\"btn-light md-button common\" ng-click=ctrl.add_step() ng-if=!instant.isAnyExist()><i class=\"fa fa-plus\"></i><md-translate key=::ctrl.translate_key shortcode=\"::\'steps_and_step_items.add_step\'\"></md-translate></md-button><md-button hide show-gt-xs ng-if=instant.isAnyExist() class=\"md-fab md-primary primary-tooltip\" aria-label=tooltip><md-tooltip md-direction=right md-autohide=false><md-translate key=::ctrl.translate_key shortcode=\"::\'steps_and_step_items.tooltip_any\'\"></md-translate></md-tooltip><i class=\"fa fa-question-circle\"></i></md-button><md-translate hide-gt-xs ng-if=instant.isAnyExist() key=::ctrl.translate_key shortcode=\"::\'steps_and_step_items.tooltip_any\'\" class=align-center></md-translate><div flex layout=row layout-align=\"start center\" ng-if=instant.no_steps class=alert-validation><div class=alert-msg><md-translate key=::ctrl.translate_key shortcode=\"::\'validations.step_is_absent\'\"></md-translate></div></div><div flex layout=row layout-align=\"start center\" ng-if=instant.destroy_all_steps class=alert-validation><div class=alert-msg><md-translate key=::ctrl.translate_key shortcode=\"::\'validations.can_not_remove_all_steps\'\"></md-translate></div></div></div></div>");
$templateCache.put("app/admin/conditions/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.conditionscontroller.edit\'\" class=md-icon-button ng-click=table.config.buttons.methods.edit_condition(item.id)><i class=\"fa fa-pencil-square-o\" ng-if=!item.read_only></i><i class=\"fa fa-eye\" ng-if=item.read_only></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.conditionscontroller.delete\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.removeCondition(item.id, $event)\"><i class=\"fa fa-trash-o\"></i></md-button>");
$templateCache.put("app/admin/creatives/partials/bulk_upload_files.html","<div ng-style=\"{height: $ctrl.heightTable}\" class=bulk-upload-wrap><input type=file name=banners accept={{$ctrl.accept}} multiple class=upload-input><div ng-if=!$ctrl.files.length layout=column layout-align=\"center center\" class=no-files><i class=\"fa fa-cloud-download\"></i><div class=ligth-color><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'settings.bulk_upload.drop_file_here\'\"></md-translate></div></div><div ng-if=$ctrl.files.length class=files-holder><div class=files-table><div class=files-table-head><div class=files-table-head-row><div class=files-table-head-cell>#</div><div class=\"files-table-head-cell name\"><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'settings.bulk_upload.file_name\'\"></md-translate></div><div class=\"files-table-head-cell format\"><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'settings.bulk_upload.file_format\'\"></md-translate></div><div class=\"files-table-head-cell size\"><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'settings.bulk_upload.file_size\'\"></md-translate></div><div class=\"files-table-head-cell resolution\"><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'settings.bulk_upload.file_resolution\'\"></md-translate></div><div class=\"files-table-head-cell ready\"><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'settings.bulk_upload.file_ready\'\"></md-translate></div><div class=\"files-table-head-cell status\"><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'settings.bulk_upload.file_status\'\"></md-translate></div><div class=files-table-body-cell></div><div class=files-table-body-cell></div></div></div><div class=files-table-body><div ng-repeat=\"file in $ctrl.files track by $index\" class=files-table-body-row><div ng-bind=\"$index + 1\" class=files-table-body-cell></div><div class=files-table-body-cell><div class=change-name-input><input type=text ng-model=file.title ng-change=$ctrl.changeFileNameHandler(file) ng-class=\"{\'disabled\': $ctrl.fileIsInProcess(file)}\"></div></div><div ng-bind=::$ctrl.getFileFormat(file) class=files-table-body-cell></div><div ng-bind=::$ctrl.getFileSize(file) class=files-table-body-cell></div><div ng-bind=$ctrl.getFileResolution(file) class=files-table-body-cell></div><div class=files-table-body-cell><div ng-if=file.ready class=is-ready><i class=\"fa fa-check\"></i></div><div ng-if=!file.ready class=no-ready><md-button class=\"md-fab md-primary\"><md-tooltip md-direction=top><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'settings.bulk_upload.file_not_valid\'\"></md-translate></md-tooltip><i class=\"fa fa-exclamation\"></i></md-button></div></div><div class=files-table-body-cell><span class=upload-proccess ng-class=$ctrl.getFileUploadResult(file)></span></div><div class=files-table-body-cell><md-button class=\"md-icon-button preview-file-btn\" ng-if=file.isRead ng-click=\"$ctrl.previewFile(file, $event)\" ng-class=\"{\'disabled\': $ctrl.fileIsInProcess(file)}\"><i class=\"fa fa-eye\"></i></md-button></div><div class=files-table-body-cell><md-button class=\"md-icon-button remove-file-btn\" ng-click=$ctrl.removeFile(file) ng-class=\"{\'disabled\': $ctrl.fileIsInProcess(file)}\"><i class=\"fa fa-trash-o\"></i></md-button></div></div></div></div></div></div><div ng-if=$ctrl.fileErrors.length class=bulk-custom-file-errors><div ng-repeat=\"value in $ctrl.fileErrors\" class=file-error><div ng-if=value.banner.ide class=file-name><span ng-bind=$ctrl.outputFileNameWhileError(value)></span></div><div ng-repeat=\"error in value.errors track by $index\" class=errors><translate>{{error}}</translate></div></div></div>");
$templateCache.put("app/admin/creatives/partials/creative_img.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=$ctrl.creative_title class=dialog-title></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=$ctrl.closePopup()></md-button></span></div><md-dialog-content class=\"md-dialog-content align-center\"><div class=md-dialog-content-body><img ng-src={{$ctrl.creative_src}} alt=\"creative image\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/admin/creatives/partials/creatives.html","<ui-view><div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::creativesCtrl.translate_key shortcode=\"\'creatives.header\'\"></md-translate></div><div flex=nogrow class=search-block><tabs-content tabs-name=creatives view-name=search></tabs-content></div></div><div flex=100 class=\"tabs-wrap mt-30\"><tabs-list tabs-name=creatives></tabs-list></div></div><div class=card-content><tabs-content tabs-name=creatives view-name=content></tabs-content></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.creativescontroller.create\'\" class=\"md-raised md-primary btn-primary\" ng-click=creativesCtrl.createCreative()><md-translate key=::creativesCtrl.translate_key shortcode=\"\'creatives.submit\'\"></md-translate></md-button><md-button has-permission permission permission-only=\"\'api2.admin.creativescontroller.create\'\" class=\"md-raised md-primary btn-primary\" ng-click=creativesCtrl.createCreativeBulk()><md-translate key=::creativesCtrl.translate_key shortcode=\"\'creatives.create_bulk\'\"></md-translate></md-button></div><tabs-content tabs-name=creatives view-name=pagination></tabs-content></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/creatives/partials/file_preview.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=$ctrl.fileTitle class=dialog-title></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=$ctrl.closePopup()></md-button></span></div><md-dialog-content class=\"md-dialog-content align-center\"><div class=md-dialog-content-body><img ng-src={{$ctrl.fileContent}} alt=\"file image\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/admin/creatives/partials/form.html","<div row-restrict max-width=450px class=last-item-no-margin><md-input-container class=md-block><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.format\'\"></md-translate></label><md-select input-errors md-select-label-translate required md-no-asterisk name=format ng-model=settingsCtrl.creative.format ng-disabled=\"settingsCtrl.creative.id || settingsCtrl.disableChooseFile\" ng-change=settingsCtrl.changedCreativeFormat()><md-option ng-value=item.type ng-repeat=\"item in settingsCtrl.availableFormats\"><md-translate key=::settingsCtrl.translate_key shortcode=\"\'creatives_tab.\' + item.type\"></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settingsCtrl.errors input-name=format></md-error-messages></md-input-container><md-input-container class=md-block ng-if=!settingsCtrl.isBulk><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.title\'\"></md-translate></label><input input-errors required md-no-asterisk type=text name=title ng-model=settingsCtrl.creative.title><md-error-messages errors=settingsCtrl.errors input-name=title></md-error-messages></md-input-container><md-autocomplete input-errors name=advertising_company model-delay=true md-input-name=advertising_company md-search-text=settingsCtrl.creative.advertising_company md-items=\"item in settingsCtrl.querySearch(settingsCtrl.creative.advertising_company)\" md-item-text=item.advertising_company md-min-length=0 md-floating-label=\"{{\'settings.form.advertising_company\' | mdTranslate: settingsCtrl.translate_key }}\" md-no-cache=true><md-item-template><span md-highlight-text=settingsCtrl.creative.advertising_company md-highlight-flags=^i>{{item.advertising_company}}</span></md-item-template><md-error-messages errors=settingsCtrl.errors input-name=advertising_company></md-error-messages></md-autocomplete><md-input-container class=md-block><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.language\'\"></md-translate></label><select-with-search list=settingsCtrl.language_list ng-model=settingsCtrl.creative.language errors=settingsCtrl.errors name=language options=\"{translate_namespace: \'creative.list_locales.\', search_in_translate: true}\"><translate>{{\'creative.list_locales.\' + value}}</translate></select-with-search><span class=errors-reserve></span><md-error-messages errors=settingsCtrl.errors input-name=language></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.status\'\"></md-translate></label><md-select input-errors md-select-label-translate name=status ng-model=settingsCtrl.creative.status><md-option ng-value=item.status ng-repeat=\"item in settingsCtrl.creative_statuses\"><md-translate key=::settingsCtrl.translate_key shortcode=item.label></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=settingsCtrl.errors input-name=status></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.at_beginning_show\'\"></md-translate></label><mod-datepicker ng-model=settingsCtrl.creative.at_beginning_show errors=settingsCtrl.errors is-required=true name=at_beginning_show></mod-datepicker></md-input-container><md-input-container class=md-block><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.at_end_show\'\"></md-translate></label><mod-datepicker ng-model=settingsCtrl.creative.at_end_show errors=settingsCtrl.errors is-required=true name=at_end_show></mod-datepicker></md-input-container><md-input-container class=md-block><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.\' + settingsCtrl.getUniqueFieldShortcode(\'link\') + \'link\'\" watch-shortcode=true></md-translate></label><textarea input-errors required md-no-asterisk name=link ng-model=settingsCtrl.creative.link></textarea><md-error-messages errors=settingsCtrl.errors input-name=link></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"settingsCtrl.checkFormFields(\'body\')\"><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.\' + settingsCtrl.getCurrentCreativeType() + \'.iframe_body\'\"></md-translate></label><textarea input-errors name=body ng-model=settingsCtrl.creative.body></textarea><md-error-messages errors=settingsCtrl.errors input-name=body></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"settingsCtrl.checkFormFields(\'width\')\"><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.\' + settingsCtrl.getCurrentCreativeType() + \'.iframe_width\'\"></md-translate></label><input input-errors name=width type=number ng-model=settingsCtrl.creative.width><md-error-messages errors=settingsCtrl.errors input-name=width></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"settingsCtrl.checkFormFields(\'height\')\"><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.\' + settingsCtrl.getCurrentCreativeType() + \'.iframe_height\'\"></md-translate></label><input input-errors name=height type=number ng-model=settingsCtrl.creative.height><md-error-messages errors=settingsCtrl.errors input-name=height></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"settingsCtrl.checkFormFields(\'banner\') &amp;&amp; !settingsCtrl.isBulk\"><div class=label-top><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.choose_file\'\"></md-translate></div><input-upload-file ng-model=settingsCtrl.creative.banner options=settingsCtrl.bannerOptions name=banner errors=settingsCtrl.errors callback-add-file=settingsCtrl.addFileCallback(data) callback-remove-file=settingsCtrl.clearFileCallback()></input-upload-file></md-input-container><div class=\"mb-30 mt-30\"><label class=top-label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.exclusive_affiliates\'\"></md-translate></label><checkbox-list list=settingsCtrl.affiliatesList field-name=value callback=settingsCtrl.changeExclusiveAffiliates></checkbox-list></div><div class=mb-30></div></div><div ng-if=settingsCtrl.isBulk class=mb-20><div class=bulk-upload-holder><div class=label-top><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.form.bulk_upload_label\'\"></md-translate></div><bulk-upload-files max-file-size=settingsCtrl.getMaxFileSize() files=settingsCtrl.files file-errors=settingsCtrl.fileErrors file-formats=settingsCtrl.fileFormats accept=settingsCtrl.acceptFiles uploaded-banners=settingsCtrl.uploadedBanners resolved-banners=settingsCtrl.resolvedBanners rejected-banners=settingsCtrl.rejectedBanners ng-class=\"{\'disabled\': settingsCtrl.disableChooseFile}\"></bulk-upload-files></div><div class=bulk-uload-description><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.bulk_upload_description\'\"></md-translate></div></div><div ng-if=\"!settingsCtrl.isBulk &amp;&amp; settingsCtrl.showUploadFileDescription()\" class=mb-20><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.upload_file_description\'\"></md-translate></div>");
$templateCache.put("app/admin/creatives/partials/input_upload_file.html","<div layout=row layout-align=\"center center\" class=bunner-upload-wrap><input input-errors name={{$ctrl.name}} ng-model=$ctrl.file type=file accept={{$ctrl.options.accept}}><div ng-if=!$ctrl.ngModel class=no-file><i class=\"fa fa-cloud-download\"></i><div class=ligth-color><md-translate key=$ctrl.options.translate_key shortcode=$ctrl.options.shortcodes.drop_file_here watch-shortcode=true></md-translate></div></div><span ng-if=$ctrl.ngModel class=md-text><div><span class=file-name ng-bind=$ctrl.ngModel.name></span>(<span class=file-size ng-bind=\"$ctrl.ngModel.size/1024/1024 | number:2\"></span>MB)<span class=delete-file><md-button class=md-icon-button ng-click=$ctrl.removeFile()><i class=\"fa fa-trash-o\"></i></md-button></span></div><div ng-if=$ctrl.options.shortcodes.resolution_file class=\"file-resolution ligth-color\"><md-translate key=$ctrl.options.translate_key shortcode=$ctrl.options.shortcodes.resolution_file watch-shortcode=true translate-values=\"{width: $ctrl.imageResolution.width, height: $ctrl.imageResolution.height}\"></md-translate></div></span></div><span class=errors-reserve></span><md-error-messages errors=$ctrl.errors input-name={{$ctrl.name}}></md-error-messages>");
$templateCache.put("app/admin/creatives/partials/list.html","<table-list table=tabCtrl.table></table-list>");
$templateCache.put("app/admin/creatives/partials/pagination.html","<table-list-pagination table=creativesCtrl.tabs.activeTab.table></table-list-pagination>");
$templateCache.put("app/admin/creatives/partials/search.html","<table-list-search table=creativesCtrl.tabs.activeTab.table></table-list-search>");
$templateCache.put("app/admin/creatives/partials/settings_creative.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=none class=card-title><md-translate key=::settingsCtrl.translate_key shortcode=settingsCtrl.main_title></md-translate></div></div><md-card-content class=padding-content><form name=settingsCtrl.saveCreativeForm><div ng-include=\"\'app/admin/creatives/partials/form.html\'\"></div></form></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=settingsCtrl.saveCreative($event)><md-translate key=::settingsCtrl.translate_key shortcode=settingsCtrl.submit_button></md-translate></md-button><md-button class=btn-transparent ng-click=settingsCtrl.back()><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/creatives/partials/table.html","<md-button class=md-icon-button ng-click=\"table.config.buttons.methods.show(item, $event)\" ng-if=table.config.buttons.methods.show><i class=\"fa fa-eye\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.creativescontroller.edit\'\" class=md-icon-button ng-click=table.config.buttons.methods.edit(item)><i class=\"fa fa-pencil-square-o\"></i></md-button>");
$templateCache.put("app/admin/creatives/partials/view_flash.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=$ctrl.creative_title class=dialog-title></div><span flex=none><md-button aria-label=close class=\"md-icon-button close-btn\" ng-click=$ctrl.closePopup()></md-button></span></div><md-dialog-content class=\"md-dialog-content align-center\"><div class=md-dialog-content-body><object classid=clsid:d27cdb6e-ae6d-11cf-96b8-444553540000 codebase=\"http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=8,5,0,175\" width={{$ctrl.creative_width}} height={{$ctrl.creative_height}}><param name=movie value={{$ctrl.creative_src}}><param name=allowScriptAccess value=always><param name=flashvars value=\"creativeURL=\"><embed ng-src={{$ctrl.creative_src}} width={{$ctrl.creative_width}} height={{$ctrl.creative_height}} allowscriptaccess=always type=application/x-shockwave-flash pluginspage=http://www.macromedia.com/go/getflashplayer flashvars=\"creativeURL=\"></object></div></md-dialog-content></md-dialog>");
$templateCache.put("app/admin/creatives/partials/view_iframe.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=$ctrl.creative_title class=dialog-title></div><span flex=none><md-button aria-label=close class=\"md-icon-button close-btn\" ng-click=$ctrl.closePopup()></md-button></span></div><md-dialog-content class=\"md-dialog-content align-center\"><div class=md-dialog-content-body><iframe ng-src={{$ctrl.creative_src}} width={{$ctrl.creative_width}} height={{$ctrl.creative_height}} frameborder=0></iframe></div></md-dialog-content></md-dialog>");
$templateCache.put("app/admin/dashboard/partials/dashboard.html","<div class=\"view-content dashboard\"><!--Stats--><div layout=row layout-xs=column layout-align=\"space-between center\" layout-align-xs=\"space-between stretch\" ng-if=\"$ctrl.updateTimePermission || $ctrl.getStatsPermission\" class=grid-row><div class=\"last-update font-size-medium\"><div ng-if=$ctrl.updateTimePermission><md-translate key=::$ctrl.translate_key shortcode=\"\'dashboard.last_update\'\"></md-translate><span date-locale={{$ctrl.last_update}} format=LLL class=font-bold></span></div></div><div layout=row layout-align=space-between class=column-with-select><md-input-container ng-if=$ctrl.getStatsPermission class=select-wrap><md-select ng-model=$ctrl.currentMerchant ng-change=$ctrl.changeMerchant() md-container-class=select-period><md-option ng-repeat=\"merchant in $ctrl.merchantsList\" ng-value=merchant.id><span ng-bind=merchant.value></span></md-option></md-select></md-input-container><md-input-container class=\"no-margin select-wrap\" ng-if=$ctrl.getStatsPermission><md-select ng-model=$ctrl.currentPerionds.stats ng-change=$ctrl.changeStats() md-container-class=select-period><md-option ng-repeat=\"period in $ctrl.periods\" ng-value=period ng-class=\"{\'is-choosed\': $ctrl.currentPerionds.stats === period}\"><i class=\"fa fa-check\"></i><md-translate key=::$ctrl.translate_key shortcode=\"::\'periods.\' + period\"></md-translate></md-option></md-select></md-input-container></div></div><div layout-wrap layout=row layout-xs=row layout-align-sm=space-between layout-align-gt-sm=space-between class=\"grid-row stats-card\" ng-if=$ctrl.getStatsPermission><md-card flex class=primary-card ng-repeat=\"column in $ctrl.statsColumns\"><md-card-content><div md-translate key=::$ctrl.translate_key shortcode=\"::\'stats_block.\' + column\" class=content-key></div><div ng-bind=\"$ctrl.stats[column] | number | numberSeparate: \' \'\" class=content-value></div></md-card-content></md-card></div><div ng-if=$ctrl.getChartsPermission><!--Charts--><charts data=$ctrl.chartsData options=$ctrl.chartOptions layout=column layout-gt-sm=row class=\"grid-row charts-holder\"></charts></div><div ng-if=$ctrl.getTopsPermission><!--Top 5 partners--><div layout=row layout-align=\"space-between center\"><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::$ctrl.translate_key shortcode=\"\'top_partners.header\'\"></md-translate></div><div layout=row layout-align=\"end center\"><md-input-container class=\"no-margin select-wrap\"><md-select ng-model=$ctrl.currentPerionds.top_for_ngr ng-change=\"$ctrl.changeTableList(\'top_for_ngr\')\" md-container-class=select-period><md-option ng-repeat=\"period in $ctrl.periods\" ng-value=period ng-class=\"{\'is-choosed\': $ctrl.currentPerionds.top_for_ngr === period}\"><i class=\"fa fa-check\"></i><md-translate key=::$ctrl.translate_key shortcode=\"::\'periods.\' + period\"></md-translate></md-option></md-select></md-input-container></div></div><div class=card-content><table-list table=$ctrl.top_for_ngr></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.reportscontroller.generate_report\'\" class=\"md-raised md-primary btn-primary\" ui-sref=reports><md-translate key=::$ctrl.translate_key shortcode=\"\'dashboard.button_reports\'\"></md-translate></md-button></div></div></div></md-card></div><!--Top 5 trackers--><div layout=row layout-align=\"space-between center\"><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::$ctrl.translate_key shortcode=\"\'top_trackers.header\'\"></md-translate></div><div layout=row layout-align=\"end center\"><md-input-container class=\"no-margin select-wrap\"><md-select ng-model=$ctrl.currentPerionds.top_trackers ng-change=\"$ctrl.changeTableList(\'top_trackers\')\" md-container-class=select-period><md-option ng-repeat=\"period in $ctrl.periods\" ng-value=period ng-class=\"{\'is-choosed\': $ctrl.currentPerionds.top_trackers === period}\"><i class=\"fa fa-check\"></i><md-translate key=::$ctrl.translate_key shortcode=\"::\'periods.\' + period\"></md-translate></md-option></md-select></md-input-container></div></div><div class=card-content><table-list table=$ctrl.top_trackers></table-list></div><div class=card-footer></div></md-card></div><!--Top 5 players--><div layout=row layout-align=\"space-between center\"><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::$ctrl.translate_key shortcode=\"\'top_players.header\'\"></md-translate></div><div layout=row layout-align=\"end center\"><md-input-container class=\"no-margin select-wrap\"><md-select ng-model=$ctrl.currentPerionds.top_players ng-change=\"$ctrl.changeTableList(\'top_players\')\" md-container-class=select-period><md-option ng-repeat=\"period in $ctrl.periods\" ng-value=period ng-class=\"{\'is-choosed\': $ctrl.currentPerionds.top_players === period}\"><i class=\"fa fa-check\"></i><md-translate key=::$ctrl.translate_key shortcode=\"::\'periods.\' + period\"></md-translate></md-option></md-select></md-input-container></div></div><div class=card-content><table-list table=$ctrl.top_players></table-list></div><div class=card-footer></div></md-card></div></div></div>");
$templateCache.put("app/admin/group_of_managers/partials/edit_group.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::editCtrl.translate_key shortcode=\"\'group_settings.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px ng-if=editCtrl.showContent><form name=editCtrl.groupForm><md-input-container class=md-block ng-if=editCtrl.currentOwner><label><md-translate key=::editCtrl.translate_key shortcode=\"\'group_settings.current_owner\'\"></md-translate></label><input type=text ng-value=editCtrl.currentOwner.name ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::editCtrl.translate_key shortcode=\"\'group_settings.choose_owner\'\"></md-translate></label><select-with-search list=editCtrl.ownersList ng-model=editCtrl.ownerId ng-change=editCtrl.updateGroupOwner() name=admin_id errors=editCtrl.errors save-prop=id options=\"{prop_for_value: \'name\'}\" ng-disabled=editCtrl.disableOwnerSelect><span ng-bind=value.name></span></select-with-search></md-input-container><div ng-if=editCtrl.group class=mb-20><label class=top-label><md-translate key=::editCtrl.translate_key shortcode=\"\'group_settings.choose_participants\'\"></md-translate></label><checkbox-list list=editCtrl.adminsList field-name=value callback=editCtrl.saveFields all-disabled=editCtrl.disableCheckboxes></checkbox-list></div></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button ng-if=\"!editCtrl.group &amp;&amp; editCtrl.showContent\" class=\"md-raised md-primary btn-primary\" ng-click=editCtrl.createGroup()><md-translate key=::editCtrl.translate_key shortcode=\"\'group_settings.create_btn\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=editCtrl.back()><md-translate key=::editCtrl.translate_key shortcode=\"\'group_settings.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/group_of_managers/partials/group_of_managers.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::groupCtrl.translate_key shortcode=\"\'group_of_managers.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><div class=mb-20><label class=top-label><md-translate key=groupCtrl.translate_key shortcode=\"\'group_of_managers.group_participants\'\"></md-translate></label><checkbox-list list=groupCtrl.adminsList field-name=value all-disabled=groupCtrl.readonly></checkbox-list></div></div></md-card-content><div class=card-footer><div class=button-holder></div></div></md-card></div>");
$templateCache.put("app/admin/group_of_managers/partials/groups_list.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::groupsCtrl.translate_key shortcode=\"\'groups_list.header\'\"></md-translate></div><div class=search-block><table-list-search table=groupsCtrl.table></table-list-search></div></div><div class=card-content><table-list table=groupsCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.admingroupscontroller.edit\'\" class=\"md-raised md-primary btn-primary\" ng-click=groupsCtrl.createGroup()><md-translate key=::groupsCtrl.translate_key shortcode=\"\'groups_list.create_btn\'\"></md-translate></md-button></div><table-list-pagination table=groupsCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/group_of_managers/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.admingroupscontroller.edit\'\" class=md-icon-button ng-click=table.config.buttons.methods.edit(item)><i class=\"fa fa-pencil-square-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.admingroupscontroller.delete\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.remove(item, $event)\"><i class=\"fa fa-trash-o\"></i></md-button>");
$templateCache.put("app/admin/imported_data/partials/imported_data.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::importedDataCtrl.translate_key shortcode=\"\'imported_data.header\'\"></md-translate></div><div class=search-block><table-list-search table=importedDataCtrl.table></table-list-search></div></div><div class=card-content><table-list table=importedDataCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder></div><table-list-pagination table=importedDataCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/imported_data/partials/table.html","<md-button class=md-icon-button md-click=table.config.buttons.methods.download(item)><i class=\"fa fa-download\"></i></md-button>");
$templateCache.put("app/admin/mass_retag/partials/mass_retag.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::massRetagCtrl.translate_key shortcode=\"\'mass_retag.header\'\"></md-translate></div><div class=search-block></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=massRetagCtrl.massRetagForm><input-file-area ng-model=massRetagCtrl.file is-required=true options=massRetagCtrl.fileOptions errors=massRetagCtrl.errors callback=\"massRetagCtrl.updateFile(data, file)\"></input-file-area></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=massRetagCtrl.massRetagPlayers()><md-translate key=::massRetagCtrl.translate_key shortcode=\"\'mass_retag.submit_button\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/new_partners/partials/accept_partner.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::acceptCtrl.translate_key shortcode=\"\'accept_partner.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=acceptCtrl.acceptPartnerForm><md-input-container class=md-block><label><md-translate key=::acceptCtrl.translate_key shortcode=\"\'accept_partner.choose_manager\'\"></md-translate></label><select-with-search list=acceptCtrl.managersList ng-model=acceptCtrl.managerId errors=acceptCtrl.errors name=manager_id save-prop=id options=\"{prop_for_value: \'name\'}\"><span ng-bind=value.name></span></select-with-search></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=acceptCtrl.acceptPartner()><md-translate key=::acceptCtrl.translate_key shortcode=\"\'accept_partner.accept_btn\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=acceptCtrl.back()><md-translate key=::acceptCtrl.translate_key shortcode=\"\'accept_partner.button_back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/new_partners/partials/new_partners.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=new_partners.translate_key shortcode=\"\'new_partners.header\'\"></md-translate></div><div class=search-block><table-list-search table=new_partners.table></table-list-search></div></div><div class=card-content><table-list table=new_partners.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.download_list_approved\'\" class=\"md-raised md-primary btn-primary\" ng-click=new_partners.downloadReport($event)><md-translate key=::new_partners.translate_key shortcode=\"\'new_partners.download_report\'\"></md-translate></md-button></div><table-list-pagination table=new_partners.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/new_partners/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.request\'\" class=\"md-button md-primary btn-primary\" md-click=\"table.config.buttons.methods.rejectPartner(item, $event)\"><md-translate key=\"\'AdminNewPartners\'\" shortcode=\"\'new_partners.reject_btn\'\"></md-translate></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.request\'\" class=\"md-button md-primary btn-primary\" md-click=\"table.config.buttons.methods.acceptPartner(item, $event)\"><md-translate key=\"\'AdminNewPartners\'\" shortcode=\"\'new_partners.accept_btn\'\"></md-translate></md-button><md-button class=md-icon-button ng-click=table.config.buttons.methods.viewPartner(item)><i class=\"fa fa-eye\"></i></md-button>");
$templateCache.put("app/admin/partner/partials/buttons.html","<md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.request\'\" class=\"md-raised md-primary btn-primary\" md-click=\"partner_profile.acceptPartner(partner_profile.partner, $event)\" ng-if=partner_profile.show_button><md-translate key=\"\'AdminNewPartners\'\" shortcode=\"\'new_partners.accept_btn\'\"></md-translate></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.request\'\" class=\"md-raised md-primary btn-primary\" md-click=\"partner_profile.rejectPartner(partner_profile.partner, $event)\" ng-if=partner_profile.show_button><md-translate key=\"\'AdminNewPartners\'\" shortcode=\"\'new_partners.reject_btn\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=partner_profile.back()><md-translate key=::partner_profile.translate_key shortcode=\"\'view_partner.button_back\'\"></md-translate></md-button>");
$templateCache.put("app/admin/partner/partials/contact_information.html","<div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'contact_information.form.email\'\"></md-translate></label><input type=email ng-value=partner_profile.partner.email ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'contact_information.form.skype\'\"></md-translate></label><input type=text ng-value=partner_profile.partner.skype ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'contact_information.form.telegram\'\"></md-translate></label><input type=text ng-value=partner_profile.partner.telegram ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'contact_information.form.phone_number\'\"></md-translate></label><input type=tel ng-value=partner_profile.partner.phone_number ng-readonly=true></md-input-container><md-input-container class=md-block><md-checkbox class=\"md-primary primary-checkbox md-align-top-left disabled-as-readonly\" ng-model=partner_profile.partner.agree_receive_emails ng-disabled=true><md-translate key=::partner_profile.translate_key shortcode=\"\'contact_information.form.agree_receive_emails\'\"></md-translate></md-checkbox></md-input-container></div>");
$templateCache.put("app/admin/partner/partials/main_data.html","<div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'main_data.form.name\'\"></md-translate></label><input type=text ng-value=partner_profile.partner.name ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'main_data.form.surname\'\"></md-translate></label><input type=text ng-value=partner_profile.partner.surname ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'main_data.form.username\'\"></md-translate></label><input type=text ng-value=partner_profile.partner.username ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'main_data.form.birthday\'\"></md-translate></label><input type=text ng-value=\"partner_profile.partner.birthday | dateLocaleFilter\" ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'main_data.form.site_url\'\"></md-translate></label><input type=url ng-value=partner_profile.partner.site_url ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'main_data.form.status_label\'\"></md-translate></label><input translate type=text ng-value=partner_profile.status.text translate-attr-value={{partner_profile.status.text}} ng-readonly=true><div ng-if=partner_profile.partner.chief_name class=signature><div md-translate key=::partner_profile.translate_key shortcode=\"\'main_data.form.status\'\" translate-values=\"{name: partner_profile.partner.chief_name, date: partner_profile.convertDate(partner_profile.partner.decision_time)}\"></div></div></md-input-container></div>");
$templateCache.put("app/admin/partner/partials/offer.html","<div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::partner_profile.translate_key shortcode=\"\'offer.form.about_affiliate\'\"></md-translate></label><textarea ng-readonly=true ng-model=partner_profile.partner.about_affiliate></textarea></md-input-container></div>");
$templateCache.put("app/admin/partner/partials/profile.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::partner_profile.translate_key shortcode=\"\'view_partner.header\'\"></md-translate></div></div><div flex=100 class=mt-30><tabs-list tabs-name=view_partner></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=view_partner view-name=content></tabs-content></md-card-content><div class=card-footer><div class=button-holder><tabs-content tabs-name=view_partner view-name=buttons></tabs-content></div></div></md-card></div>");
$templateCache.put("app/admin/bonuses/partials/add_bonuses.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::add_bonuses.translate_key shortcode=\"\'add_bonus.header\'\"></md-translate></div></div><div flex=100 class=mt-30><tabs-list tabs-name=bonuses></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=bonuses view-name=content></tabs-content></md-card-content><div class=card-footer><div class=button-holder><tabs-content tabs-name=bonuses view-name=buttons></tabs-content><md-button class=btn-transparent ng-click=add_bonuses.back()><md-translate key=::add_bonuses.translate_key shortcode=\"\'add_bonus.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/bonuses/partials/bonuses.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::bonuses.translate_key shortcode=\"\'bonuses.header\'\"></md-translate></div><div class=search-block><table-list-search table=bonuses.table></table-list-search></div></div><div class=card-content><table-list table=bonuses.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.bonusescontroller.create\'\" class=\"md-raised md-primary btn-primary\" ng-click=bonuses.add_bonus()><md-translate key=::bonuses.translate_key shortcode=\"\'bonuses.button_add_bonus\'\"></md-translate></md-button></div><table-list-pagination table=bonuses.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/bonuses/partials/create_manual.html","<div row-restrict max-width=450px><form name=add_bonuses.addBonusesForm><bonus-form controller-alias=add_bonuses></bonus-form></form></div>");
$templateCache.put("app/admin/bonuses/partials/create_with_file.html","<div row-restrict max-width=450px class=last-item-no-margin><div class=file-uploader-wrap><div class=label-top><md-translate key=::add_bonuses.translate_key shortcode=\"\'from_file.header\'\"></md-translate></div><div nv-file-drop uploader=add_bonuses.uploader class=file-drop-area><div nv-file-over uploader=add_bonuses.uploader over-class=file-is-over class=file-drop-zone layout=row layout-align=\"center center\"><div ng-if=!add_bonuses.uploader.queue.length class=no-file><i class=\"fa fa-cloud-download\"></i><div><md-translate key=::add_bonuses.translate_key shortcode=\"\'from_file.description\'\"></md-translate></div><input nv-file-select type=file multiple uploader=add_bonuses.uploader class=upload-input></div><div ng-if=add_bonuses.uploader.queue.length class=files-wrap><div ng-repeat=\"item in add_bonuses.uploader.queue\" class=file-list-item><span ng-bind=item.file.name class=file-name></span><span class=file-size>(<span ng-bind=\"item.file.size/1024/1024 | number:2\"></span>MB)<div style=\"margin-bottom: 0\" class=progress><div ng-style=\"{ \'width\': item.progress + \'%\' }\" role=progressbar class=progress-bar></div><div ng-show=item.progress class=percent-progress>{{ item.progress }} %</div></div></span><span class=delete-file><md-button class=md-icon-button ng-click=item.remove()><i class=\"fa fa-trash-o\"></i></md-button></span></div></div></div></div></div></div>");
$templateCache.put("app/admin/bonuses/partials/edit_bonuses.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::edit_bonuses.translate_key shortcode=\"\'edit_bonus.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=edit_bonuses.editBonusForm><bonus-form controller-alias=edit_bonuses></bonus-form></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=edit_bonuses.update_bonus()><md-translate key=::edit_bonuses.translate_key shortcode=\"\'edit_bonus.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=edit_bonuses.back()><md-translate key=::edit_bonuses.translate_key shortcode=\"\'edit_bonus.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/bonuses/partials/form.html","<md-input-container class=md-block><label><md-translate key=::parentCtrl.translate_key shortcode=\"\'form.aasm_state\'\"></md-translate></label><md-select input-errors md-select-label-translate name=aasm_state ng-model=parentCtrl.bonus.aasm_state><md-option ng-value=item ng-selected=\"parentCtrl.bonus.aasm_state === item || $first\" ng-repeat=\"item in parentCtrl.stateList.list\"><md-translate key=\"\'AdminConditions\'\" shortcode=\"\'product.rs.\' + item\"></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=parentCtrl.errors input-name=aasm_state></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parentCtrl.translate_key shortcode=\"\'form.cid\'\"></md-translate></label><input input-errors name=cid type=text ng-model=parentCtrl.bonus.cid><md-error-messages errors=parentCtrl.errors input-name=cid></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parentCtrl.translate_key shortcode=\"\'form.bonus_amount\'\"></md-translate></label><input input-errors name=bonus_amount type=number ng-model=parentCtrl.bonus.bonus_amount><md-error-messages errors=parentCtrl.errors input-name=bonus_amount></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parentCtrl.translate_key shortcode=\"\'form.date\'\"></md-translate></label><mod-datepicker name=date ng-model=parentCtrl.bonus.date model-format=\"\'YYYY-MM-DD\'\" errors=parentCtrl.errors></mod-datepicker></md-input-container>");
$templateCache.put("app/admin/bonuses/partials/submit_button.html","<md-button class=\"md-raised md-primary btn-primary\" md-click=add_bonuses.tabs.activeTab.submitFn()><md-translate key=::add_bonuses.translate_key shortcode=\"\'add_bonus.add_bonus\'\"></md-translate></md-button>");
$templateCache.put("app/admin/bonuses/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.bonusescontroller.edit\'\" class=md-icon-button ng-click=table.config.buttons.methods.edit_bonus(item.id)><i class=\"fa fa-pencil-square-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.bonusescontroller.delete\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.removeBonus(item.id, $event)\"><i class=\"fa fa-trash-o\"></i></md-button>");
$templateCache.put("app/admin/partners_request_history/partials/request_history.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::orders.translate_key shortcode=\"\'request_history.header\'\"></md-translate></div><div class=search-block><table-list-search table=orders.table></table-list-search></div></div><div class=card-content><table-list table=orders.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.download_list_requests_history\'\" class=\"md-raised md-primary btn-primary\" ng-click=orders.downloadReport($event)><md-translate key=::orders.translate_key shortcode=\"\'request_history.download_report\'\"></md-translate></md-button></div><table-list-pagination table=orders.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/partners_request_history/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.withdraw_from_status_denied\'\" class=md-icon-button ng-if=\"item.aasm_state === \'denied\'\" ng-click=\"table.config.buttons.methods.changeStatus(item, $event)\"><i class=\"fa fa-check color-green\"></i></md-button><md-button class=md-icon-button ng-click=table.config.buttons.methods.next(item.id)><i class=\"fa fa-address-card-o\"></i></md-button>");
$templateCache.put("app/admin/partners_with_unconfirmed_emails/partials/table.html","<md-button class=md-icon-button ng-click=table.config.buttons.methods.sendEmailAgain(item)><i class=\"fa fa-paper-plane\"></i></md-button><md-button class=md-icon-button ng-click=\"table.config.buttons.methods.getPartnerToken(item, $event)\"><i class=\"fa fa-eye\"></i></md-button>");
$templateCache.put("app/admin/partners_with_unconfirmed_emails/partials/unconfirmed_partners.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=UnconfirmedCtrl.translate_key shortcode=\"\'partners_with_unconfirmed_emails.header\'\"></md-translate></div><div class=search-block><table-list-search table=UnconfirmedCtrl.table></table-list-search></div></div><div class=card-content><table-list table=UnconfirmedCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder></div><table-list-pagination table=UnconfirmedCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/partners_with_unconfirmed_emails/partials/view_token.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::UnconfirmedCtrl.translate_key shortcode=\"\'modal_window.header\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=md-dialog-content-body><md-input-container class=md-block><label><md-translate key=::UnconfirmedCtrl.translate_key shortcode=\"\'modal_window.url_for_confirming_email\'\"></md-translate></label><textarea id=confirming-email-url ng-model=UnconfirmedCtrl.resultUrl ng-readonly=true></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=UnconfirmedCtrl.closeModal()><md-translate key=::UnconfirmedCtrl.translate_key shortcode=\"\'modal_window.cancel\'\"></md-translate></md-button><md-button clipboard data-clipboard-target=#confirming-email-url success=UnconfirmedCtrl.copySuccess() class=md-primary><md-translate key=::UnconfirmedCtrl.translate_key shortcode=\"\'modal_window.copy\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/pending_withdrawals/partials/pending_withdrawals.html","<ui-view><div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::withdrawalsCtrl.translate_key shortcode=\"\'pending_withdrawals.header\'\"></md-translate></div><div flex=nogrow class=search-block><table-list-search table=withdrawalsCtrl.table></table-list-search></div></div></div><div class=card-content><table-list table=withdrawalsCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.pending_withdrawals_download\'\" class=\"md-raised md-primary btn-primary\" ng-click=withdrawalsCtrl.downloadReport($event)><md-translate key=::withdrawalsCtrl.translate_key shortcode=\"\'pending_withdrawals.download_report_button\'\"></md-translate></md-button></div><table-list-pagination table=withdrawalsCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/pending_withdrawals/partials/reason_for_denial.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::withdrawalsCtrl.translate_key shortcode=\"\'reason_for_denial.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=md-dialog-content-body><md-input-container class=md-block><label><md-translate key=::withdrawalsCtrl.translate_key shortcode=\"\'reason_for_denial.message\'\"></md-translate></label><input type=text ng-model=withdrawalsCtrl.reasonForDenial></md-input-container></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=withdrawalsCtrl.cancelDialog()><md-translate key=::withdrawalsCtrl.translate_key shortcode=\"\'reason_for_denial.cancel\'\"></md-translate></md-button><md-button class=md-primary ng-click=withdrawalsCtrl.applyDenialWithdrawal()><md-translate key=::withdrawalsCtrl.translate_key shortcode=\"\'reason_for_denial.ok\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/pending_withdrawals/partials/table.html","<md-button class=md-icon-button ng-click=\"table.config.buttons.methods.viewWithdrawal(item, $event)\"><i class=\"fa fa-eye\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.pending_withdrawals_edit\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.approveWithdrawal(item, $event)\"><i class=\"fa fa-check-circle\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.pending_withdrawals_edit\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.denialWithdrawal(item, $event)\"><i class=\"fa fa-ban\"></i></md-button>");
$templateCache.put("app/admin/pending_withdrawals/partials/view_withdrawal.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><md-input-container class=md-block ng-if=viewCtrl.withdrawal.merchant_name><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.merchant_name\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.merchant_name ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.affiliate_id><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.affiliate_id\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.affiliate_id ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.amount><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.amount\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.amount ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.created_at><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.created_at\'\"></md-translate></label><input date-locale-input format=\"L HH:mm:ss\" type=text ng-model=viewCtrl.withdrawal.created_at ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.creator_type><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.creator_type\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.creator_type ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.creator_id><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.creator_id\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.creator_id ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.creator_email><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.creator_email\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.creator_email ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.payment_system_name><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.payment_system_name\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.payment_system_name ng-readonly=true></md-input-container><md-input-container ng-repeat=\"field in viewCtrl.allFields\" class=md-block ng-if=viewCtrl.withdrawal.payment_system_details_json[field]><label><md-translate key=\"\'AffiliateBalance\'\" shortcode=viewCtrl.findFieldShortcode(field)></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.payment_system_details_json[field] ng-readonly=true></md-input-container></div></md-card-content><div class=card-footer><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.pending_withdrawals_edit\'\" class=\"md-raised md-primary btn-primary\" ng-click=viewCtrl.approveWithdrawal($event)><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.approve_withdrawal_button\'\"></md-translate></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.pending_withdrawals_edit\'\" class=\"md-raised md-primary btn-primary\" ng-click=viewCtrl.denialWithdrawal($event)><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.denial_withdrawal_button\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=viewCtrl.back()><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/permissions_manager/partials/create.html","<div row-restrict max-width=450px class=mt-20><form name=permissions_manager.addRoleForm md-submit=permissions_manager.tabs.activeTab.submitFn()><md-input-container class=md-block><label><md-translate key=::permissions_manager.translate_key shortcode=\"\'create.role_name\'\"></md-translate></label><input input-errors md-no-asterisk ng-required=true name=name type=text ng-model=permissions_manager.new_role><md-error-messages errors=permissions_manager.errors input-name=name></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::permissions_manager.translate_key shortcode=\"\'create.copy_role\'\"></md-translate></label><select-with-search list=permissions_manager.roles_for_copy ng-model=permissions_manager.copyRoleId save-prop=id options=permissions_manager.rolesSelectOptions><span ng-if=\"value.translate_key &amp;&amp; value.shortcode\"><md-translate key=value.translate_key shortcode=value.shortcode></md-translate></span><span ng-if=\"!(value.translate_key || value.shortcode)\"><span ng-bind=value.name></span></span></select-with-search></md-input-container><div class=button-holder><md-button type=submit class=\"md-raised md-primary btn-primary\"><md-translate key=::permissions_manager.translate_key shortcode=\"\'create.add_role\'\"></md-translate></md-button></div></form></div>");
$templateCache.put("app/admin/permissions_manager/partials/edit.html","<div row-restrict max-width=450px class=mt-20><md-input-container class=md-block><label><md-translate key=::permissions_manager.translate_key shortcode=\"\'edit.choose_role\'\"></md-translate></label><select-with-search list=permissions_manager.roles_list ng-model=permissions_manager.choosed_role ng-change=permissions_manager.change_role() options=\"{prop_for_value: \'name\'}\"><span ng-bind=value.name></span></select-with-search></md-input-container></div><div has-permission permission permission-only=permissions_manager.fields_permission><div row-restrict max-width=450px ng-if=permissions_manager.showSelect()><md-input-container class=md-block><label><md-translate key=::permissions_manager.translate_key shortcode=\"\'create.fields_settings_type\'\"></md-translate></label><select-with-search list=permissions_manager.fieldsSettingsList ng-model=permissions_manager.fieldsSettingsType ng-change=permissions_manager.changeFieldsSettingsType() options=permissions_manager.fieldsSelectOptions><md-translate key=\"\'AdminPermissionsManager\'\" shortcode=\"\'columns_for_permit.\' + value\"></md-translate></select-with-search></md-input-container></div><div row-restrict max-width=450px ng-if=permissions_manager.showCheckboxList()><div class=\"md-subhead sub-title\"><md-translate key=::permissions_manager.translate_key shortcode=\"\'edit.sub_header_fields\'\"></md-translate></div><checkbox-list list=permissions_manager.fields_list field-name=value callback=permissions_manager.save_fields value-translate-namespace=permissions_manager.columnsNamespace></checkbox-list></div></div><div ng-if=permissions_manager.permissions_block class=\"md-subhead sub-title mt-30\"><md-translate key=::permissions_manager.translate_key shortcode=\"\'edit.sub_header_permissions\'\"></md-translate></div><div class=angular-tree><ol><li permissions-template ng-repeat=\"(key, value) in permissions_manager.list | filterByObjectProperties\" data-collapsed=true></li></ol></div>");
$templateCache.put("app/admin/permissions_manager/partials/permissions_manager.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::permissions_manager.translate_key shortcode=\"\'permissions_manager.page_title\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::permissions_manager.translate_key shortcode=\"\'permissions_manager.namespace\'\"></md-translate></label><md-select md-select-label-translate ng-model=permissions_manager.namespace ng-change=permissions_manager.change_namespace() ng-disabled=!permissions_manager.enableNamespaceSelect><md-option ng-value=option ng-repeat=\"option in permissions_manager.namespace_list\"><span ng-bind=option></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div ng-if=permissions_manager.namespace><tabs-list tabs-name=permissions mobile-center-tabs=true mobile-stretch-tabs=never></tabs-list><div class=pt-25><tabs-content tabs-name=permissions view-name=content></tabs-content></div></div></md-card-content><div class=card-footer></div></md-card></div>");
$templateCache.put("app/admin/personal/partials/create_profile.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::createCtrl.translate_key shortcode=\"\'create_admin.main_title\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=createCtrl.createAdminForm><md-input-container class=md-block><label><md-translate key=::createCtrl.translate_key shortcode=\"\'create_admin.name\'\"></md-translate></label><input input-errors type=text name=name ng-model=createCtrl.personal.name><md-error-messages errors=createCtrl.errors input-name=name></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::createCtrl.translate_key shortcode=\"\'create_admin.email\'\"></md-translate></label><input input-errors type=email name=email ng-model=createCtrl.personal.email><md-error-messages errors=createCtrl.errors input-name=email></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::createCtrl.translate_key shortcode=\"\'create_admin.role\'\"></md-translate></label><select-with-search list=createCtrl.roles_list ng-model=createCtrl.personal.role_id name=role_id errors=createCtrl.errors save-prop=id options=\"{prop_for_value: \'name\'}\"><span ng-bind=value.name></span></select-with-search></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=createCtrl.create()><md-translate key=::createCtrl.translate_key shortcode=\"\'create_admin.create\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=createCtrl.back()><md-translate key=::createCtrl.translate_key shortcode=\"\'create_admin.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/personal/partials/edit_profile.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.main_title\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=editCtrl.updateAdminForm><md-input-container class=md-block><label><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.name\'\"></md-translate></label><input input-errors type=text name=name ng-model=editCtrl.personal.name><md-error-messages errors=editCtrl.errors input-name=name></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.skype\'\"></md-translate></label><input input-errors type=text name=skype ng-model=editCtrl.personal.skype><md-error-messages errors=editCtrl.errors input-name=skype></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.email\'\"></md-translate></label><input input-errors type=email name=email ng-model=editCtrl.personal.email><md-error-messages errors=editCtrl.errors input-name=email></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.role\'\"></md-translate></label><select-with-search list=editCtrl.roles_list ng-model=editCtrl.personal.role_id name=role_id errors=editCtrl.errors save-prop=id options=\"{prop_for_value: \'name\'}\"><span ng-bind=value.name></span></select-with-search></md-input-container><md-input-container class=\"md-block md-input-has-value\" ng-if=editCtrl.mayResetAuth><label class=md-switch-label><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.mfa_enabled_label\'\"></md-translate></label><md-switch input-errors class=\"md-primary md-switch-input mb-none switch-banned\" name=mfa_enabled ng-model=editCtrl.personal.mfa_enabled ng-disabled=!editCtrl.twoFactorEnabled><div ng-if=editCtrl.personal.mfa_enabled><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.mfa_enabled\'\"></md-translate></div><div ng-if=!editCtrl.personal.mfa_enabled><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.mfa_disabled\'\"></md-translate></div></md-switch><div class=md-errors-spacer></div><md-error-messages errors=editCtrl.errors input-name=mfa_enabled></md-error-messages></md-input-container><md-input-container class=\"md-block md-input-has-value\"><label class=md-switch-label><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.status\'\"></md-translate></label><md-switch input-errors class=\"md-primary md-switch-input mb-none switch-banned\" name=banned ng-model=editCtrl.personal.banned aria-label=status><div ng-if=editCtrl.personal.banned><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.lock\'\"></md-translate></div><div ng-if=!editCtrl.personal.banned><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.unlock\'\"></md-translate></div></md-switch><md-error-messages errors=editCtrl.errors input-name=banned></md-error-messages><div ng-show=editCtrl.personal.ban_status_name class=signature><div md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.status_description\'\" translate-values=\"{name: editCtrl.personal.ban_status_name, date: editCtrl.personal.ban_status_chaged_at}\"></div></div></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=editCtrl.save()><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=editCtrl.back()><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_admin.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/personal/partials/personal.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::personal.translate_key shortcode=\"\'list_personal.header\'\"></md-translate></div><div class=search-block><table-list-search table=personal.table></table-list-search></div></div><div class=card-content><table-list table=personal.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.personalscontroller.create\'\" class=\"md-raised md-primary btn-primary\" ng-click=personal.addAdmin()><md-translate key=::personal.translate_key shortcode=\"\'list_personal.add_admin\'\"></md-translate></md-button></div><table-list-pagination table=personal.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/personal/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.personalscontroller.edit\'\" class=md-icon-button ng-click=table.config.buttons.methods.editProfile(item)><i class=\"fa fa-address-card-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.personalscontroller.change_ban_status\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.changeStatus(item, $event)\"><i class=fa ng-class=\"{\'fa-lock\': item.banned, \'fa-unlock-alt\': !item.banned}\"></i></md-button>");
$templateCache.put("app/admin/players/partials/buttons.html","<md-button class=\"md-raised md-primary btn-primary\" ng-if=view_player.tabs.activeTab.submitFn md-click=view_player.tabs.activeTab.submitFn()><md-translate key=::view_player.translate_key shortcode=\"\'view_player.save\'\"></md-translate></md-button>");
$templateCache.put("app/admin/players/partials/history_changes.html","<history-changes history-changes=view_player.historyChanges options-change=view_player.optionsChange></history-changes>");
$templateCache.put("app/admin/players/partials/history_changes_players.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::history.translate_key shortcode=\"\'history_changes_players.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=history.historyCnahgeForm><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'history_changes_players.serial_id\'\"></md-translate></label><input input-errors name=serial_id type=number ng-model=history.history_item.serial_id><md-error-messages errors=history.errors input-name=serial_id></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'history_changes_players.anid\'\"></md-translate></label><input input-errors name=anid type=text ng-model=history.history_item.anid><md-error-messages errors=history.errors input-name=anid></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'history_changes_players.date\'\"></md-translate></label><mod-datepicker name=date ng-model=history.history_item.date model-format=\"\'YYYY-MM-DD\'\" errors=history.errors></mod-datepicker></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=history.save_history()><md-translate key=::history.translate_key shortcode=\"\'history_changes_players.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=history.back()><md-translate key=::history.translate_key shortcode=\"\'history_changes_players.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/players/partials/main_player_info.html","<div row-restrict max-width=450px class=last-item-no-margin><md-input-container class=md-block ng-repeat=\"field in view_player.playerProfileColumns\"><label><translate>{{view_player.profileColumnsLocale + \'.\' + field}}</translate></label><input type=text ng-value=view_player.player[field] ng-readonly=true></md-input-container></div>");
$templateCache.put("app/admin/players/partials/player_activity.html","<div row-restrict max-width=450px class=last-item-no-margin><md-input-container class=md-block><label><md-translate key=::view_player.translate_key shortcode=\"\'activities_player.registrationdate\'\"></md-translate></label><input type=text ng-value=\"view_player.player.registrationdate | dateLocaleFilter\" ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::view_player.translate_key shortcode=\"\'activities_player.date_of_first_deposit\'\"></md-translate></label><input type=text ng-value=\"view_player.player.date_of_first_deposit | dateLocaleFilter\" ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::view_player.translate_key shortcode=\"\'activities_player.date_of_last_activity\'\"></md-translate></label><input type=text ng-value=\"view_player.player.date_of_last_activity | dateLocaleFilter\" ng-readonly=true></md-input-container></div>");
$templateCache.put("app/admin/players/partials/player_trackers.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=view_player.editPlayerTrackersForm><md-input-container class=md-block><label><md-translate key=::view_player.translate_key shortcode=\"\'tracker_player.serial_id\'\"></md-translate></label><input input-errors type=number name=serial_id ng-model=view_player.player.serial_id ng-readonly=true><md-error-messages errors=view_player.errors input-name=serial_id></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::view_player.translate_key shortcode=\"\'tracker_player.anid\'\"></md-translate></label><input input-errors type=text name=anid ng-model=view_player.player.anid ng-readonly=true><md-error-messages errors=view_player.errors input-name=anid></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/admin/players/partials/players.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::players.translate_key shortcode=\"\'list_players.header\'\"></md-translate></div><div class=search-block><table-list-search table=players.table></table-list-search></div></div><div class=card-content><table-list table=players.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.observingofdailystatisticsplayerscontroller.download_list\'\" class=\"md-raised md-primary btn-primary\" ng-click=players.downloadReport($event)><md-translate key=::players.translate_key shortcode=\"\'list_players.download_report\'\"></md-translate></md-button></div><table-list-pagination table=players.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/players/partials/table.html","<md-button class=md-icon-button ng-click=table.config.buttons.methods.view_player(item)><i class=\"fa fa-address-card-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.observingofdailystatisticsplayerscontroller.trackers\'\" class=md-icon-button ng-click=table.config.buttons.methods.edit_player(item)><i class=\"fa fa-pencil-square-o\"></i></md-button>");
$templateCache.put("app/admin/players/partials/view_player.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::view_player.translate_key shortcode=\"\'view_player.header\'\"></md-translate></div></div><div flex=100 class=mt-30><tabs-list tabs-name=view_player></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=view_player view-name=content></tabs-content></md-card-content><div class=card-footer><div class=\"button-holder with-condition-btn\"><md-button class=btn-transparent ng-click=view_player.back()><md-translate key=::view_player.translate_key shortcode=\"\'view_player.back\'\"></md-translate></md-button></div></div></md-card><tabs-content tabs-name=view_player view-name=history_changes></tabs-content></div>");
$templateCache.put("app/admin/profile_settings/partials/buttons.html","<md-button class=\"md-raised md-primary btn-primary\" ng-if=profile_admin.tabs.activeTab.submitFn ng-disabled=\"profile_admin.tabs.activeTab.name === \'two_factor_authentication\' &amp;&amp; profileTwoFactorAuth &amp;&amp; profileTwoFactorAuth.isSubmitDisabled()\" md-click=profile_admin.tabs.activeTab.submitFn()><md-translate key=::profile_admin.translate_key shortcode=\"\'profile_settings.save\'\"></md-translate></md-button>");
$templateCache.put("app/admin/profile_settings/partials/settings.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::profile_admin.translate_key shortcode=\"\'profile_settings.main_title\'\"></md-translate></div></div><div flex=100 class=mt-30><tabs-list tabs-name=admin_profile></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=admin_profile view-name=content></tabs-content></md-card-content><div class=card-footer><div class=button-holder><tabs-content tabs-name=admin_profile view-name=buttons></tabs-content></div></div></md-card></div>");
$templateCache.put("app/admin/promo_codes/partials/create.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::$ctrlCreate.translate_key shortcode=\"\'create.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=$ctrlCreate.createPromoCodeForm><md-input-container class=md-block><label><md-translate key=::$ctrlCreate.translate_key shortcode=\"\'create.form.promo_code\'\"></md-translate></label><input input-errors type=text name=code ng-model=$ctrlCreate.promoCode.promo_code><md-error-messages errors=$ctrlCreate.errors input-name=code></md-error-messages></md-input-container><virtual-select list=$ctrlCreate.trackersList ng-model=$ctrlCreate.promoCode.tracker errors=$ctrlCreate.errors name=serial_id><label><md-translate key=\"\'AdminPromoCodes\'\" shortcode=\"\'create.form.tracker\'\"></md-translate></label><virtual-item-content><span ng-bind=item></span></virtual-item-content></virtual-select></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=$ctrlCreate.createPromoCode()><md-translate key=::$ctrlCreate.translate_key shortcode=\"\'create.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=$ctrlCreate.back()><md-translate key=::$ctrlCreate.translate_key shortcode=\"\'create.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/promo_codes/partials/history_modal.html","<md-dialog class=\"custom-dialog dialog-content promo-code-history-dialog\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::$ctrl.translate_key shortcode=\"\'history_modal.title\'\" translate-values=\"{code: $ctrl.promoCode.code}\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><div layout=column layout-align=\"center center\" class=preloader-wrap ng-show=$ctrl.loading><md-progress-circular md-diameter=30px></md-progress-circular></div><div ng-if=\"!$ctrl.loading &amp;&amp; $ctrl.audits.length === 0\"><md-translate key=::$ctrl.translate_key shortcode=\"\'history_modal.no_history\'\"></md-translate></div><div ng-if=\"!$ctrl.loading &amp;&amp; $ctrl.audits.length &gt; 0\" class=promo-code-history-list><div ng-repeat=\"audit in $ctrl.audits\" class=promo-code-history-row><div layout=row layout-align=\"space-between center\" class=promo-code-history-row-header><span class=promo-code-history-action><md-translate key=::$ctrl.translate_key shortcode=\"\'history_modal.actions.\' + audit.action\"></md-translate></span><span class=promo-code-history-meta>{{audit.user_email || \'--\'}} - {{audit.created_at | date:\'medium\'}} - {{audit.ip_address || \'--\'}}</span></div><ul class=promo-code-history-changes ng-if=\"audit.changes.length &gt; 0\"><li ng-repeat=\"change in audit.changes\">{{change.field}}: {{change.from}} -> {{change.to}}</li></ul></div></div></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=$ctrl.hide()><md-translate key=::$ctrl.translate_key shortcode=\"\'history_modal.close\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/promo_codes/partials/promo_codes.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::$ctrlList.translate_key shortcode=\"\'promo_codes.header\'\"></md-translate></div><div class=search-block><table-list-search table=$ctrlList.table></table-list-search></div></div><div class=card-content><table-list table=$ctrlList.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=$ctrlList.createPromoCode()><md-translate key=::$ctrlList.translate_key shortcode=\"\'promo_codes.create_button\'\"></md-translate></md-button></div><table-list-pagination table=$ctrlList.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/promo_codes/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.promocodescontroller.delete\'\" class=md-icon-button ng-if=!item.deleted ng-click=\"table.config.buttons.methods.removePromoCode(item, $event)\"><i class=\"fa fa-trash\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.promocodescontroller.delete\'\" class=md-icon-button ng-if=item.deleted ng-click=\"table.config.buttons.methods.restorePromoCode(item, $event)\"><i class=\"fa fa-undo\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.promocodescontroller.delete\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.showHistory(item, $event)\"><i class=\"fa fa-history\"></i></md-button>");
$templateCache.put("app/admin/quints_api/partials/quints_api.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::quintsApiCtrl.translate_key shortcode=\"\'quints_api.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::quintsApiCtrl.translate_key shortcode=\"\'quints_api.affiliates_api_link\'\"></md-translate></label><textarea id=affiliates-api ng-model=quintsApiCtrl.affiliatesApiLink ng-readonly=true></textarea></md-input-container><md-input-container class=md-block><label><md-translate key=::quintsApiCtrl.translate_key shortcode=\"\'quints_api.trackers_api_link\'\"></md-translate></label><textarea id=trackers-api ng-model=quintsApiCtrl.trackersApiLink ng-readonly=true></textarea></md-input-container></div></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button clipboard data-clipboard-target=#affiliates-api class=\"md-raised md-primary btn-primary\" success=quintsApiCtrl.copySuccess()><md-translate key=::quintsApiCtrl.translate_key shortcode=\"\'quints_api.copy_affiliates_api_link\'\"></md-translate></md-button><md-button clipboard data-clipboard-target=#trackers-api class=\"md-raised md-primary btn-primary\" success=quintsApiCtrl.copySuccess()><md-translate key=::quintsApiCtrl.translate_key shortcode=\"\'quints_api.copy_trackers_api_link\'\"></md-translate></md-button><md-button has-permission permission permission-only=\"\'api2.admin.apitokensrefreshcontroller.edit\'\" class=\"md-raised md-primary btn-primary\" ng-click=quintsApiCtrl.resetApiToken($event)><md-translate key=::quintsApiCtrl.translate_key shortcode=\"\'quints_api.reset_api_token_button\'\"></md-translate></md-button></div></div></div></md-card></div>");
$templateCache.put("app/admin/subaffiliate_conditions/partials/conditions.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::conditions.translate_key shortcode=\"\'conditions.header\'\"></md-translate></div><div class=search-block><table-list-search table=conditions.table></table-list-search></div></div><div class=card-content><table-list table=conditions.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.conditionscontroller.edit\'\" class=\"md-raised md-primary btn-primary\" ng-click=conditions.create_condition()><md-translate key=::conditions.translate_key shortcode=\"\'conditions.create_plan\'\"></md-translate></md-button></div><table-list-pagination table=conditions.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/subaffiliate_conditions/partials/set_condition_form.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=conditions.translate_key shortcode=\"\'set_condition.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><form name=conditions.setForm><md-input-container class=md-block><label><md-translate key=conditions.translate_key shortcode=\"\'set_condition.form.value\'\"></md-translate></label><input required md-no-asterisk input-errors name=payment_size ng-model=conditions.step.payment_size type=number><md-error-messages errors=conditions.errors input-name=payment_size></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=conditions.translate_key shortcode=\"\'set_condition.form.payment_column\'\"></md-translate></label><md-select required md-no-asterisk input-errors md-select-label-translate name=payment_column ng-model=conditions.step.payment_column><md-option ng-value=value ng-repeat=\"(key, value)  in conditions.payment_columns\"><span ng-bind=key></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=conditions.errors input-name=payment_column></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=conditions.cancel()><md-translate key=conditions.translate_key shortcode=\"\'set_condition.cancel\'\"></md-translate></md-button><md-button class=md-primary ng-click=conditions.set()><md-translate key=conditions.translate_key shortcode=\"\'set_condition.save\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/subaffiliate_conditions/partials/settings_condition.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::settings.translate_key shortcode=settings.main_title></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=settings.conditionForm><md-input-container class=md-block><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.title\'\"></md-translate></label><textarea required md-no-asterisk input-errors name=title ng-model=settings.condition.title ng-readonly=settings.condition.read_only></textarea><md-error-messages errors=settings.errors input-name=title></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::settings.translate_key shortcode=\"\'main_params.form.description\'\"></md-translate></label><textarea required md-no-asterisk input-errors name=description ng-model=settings.condition.description ng-readonly=settings.condition.read_only></textarea><md-error-messages errors=settings.errors input-name=description></md-error-messages></md-input-container></form></div><div class=subaffiliate-step-settings><div class=\"md-subhead mb-10 space-around\"><md-translate key=::settings.translate_key shortcode=\"\'step_settings_header\'\"></md-translate></div><div class=\"steps-wrap mt-30\"><div ng-repeat=\"step in settings.condition.subaffiliate_condition_steps_attributes track by $index\" layout=column layout-gt-xs=row layout-align=\"center center\" layout-align-gt-xs=\"start center\" class=step><div flex=none class=\"step-count common\"><md-translate key=::settings.translate_key shortcode=\"\'steps_and_step_items.step\'\" translate-values=\"{ index: $index+1 }\"></md-translate></div><div layout=row layout-align=\"center center\" layout-align-gt-xs=\"start center\" class=step-condition-holder><div flex=100 flex-gt-xs=none ng-click=\"settings.set_condition(step, $event)\" ng-class=\"{\'read-only\': settings.condition.read_only}\" class=\"type-condition common space-around read-only-input\"><span ng-show=\"step.payment_size == 0 || step.payment_size\"><span ng-bind=\"step.payment_size + settings.markFor(step)\" class=type></span></span><span ng-hide=\"step.payment_size == 0 || step.payment_size\" class=type-value><span><md-translate key=::settings.translate_key shortcode=\"::\'steps_and_step_items.payment_size_empty\'\" translate-values=\"{ mark: settings.markFor(step) }\"></md-translate></span></span><span ng-bind=settings.labelFor(step)></span></div></div><div flex layout=row layout-align=\"start center\" ng-if=\"step.is_invalid &amp;&amp; !settings.condition.read_only\" class=alert-validation><div class=alert-msg><div class=msg-text><md-translate key=::settings.translate_key shortcode=\"\'validations.step_invalid\'\"></md-translate></div></div></div></div></div></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=settings.save_condition() ng-if=!settings.condition.read_only><md-translate key=::settings.translate_key shortcode=\"\'common_button.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=settings.back()><md-translate key=::settings.translate_key shortcode=\"\'common_button.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/subaffiliate_conditions/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.subaffiliateconditionscontroller.edit\'\" class=md-icon-button ng-click=table.config.buttons.methods.edit_condition(item.id)><i class=\"fa fa-pencil-square-o\" ng-if=!item.read_only></i><i class=\"fa fa-eye\" ng-if=item.read_only></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.subaffiliateconditionscontroller.delete\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.removeCondition(item.id, $event)\"><i class=\"fa fa-trash-o\"></i></md-button>");
$templateCache.put("app/admin/trackers/partials/trackers.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::trackers.translate_key shortcode=\"\'trackers.header\'\"></md-translate></div><div class=search-block><table-list-search table=trackers.table></table-list-search></div></div><div class=card-content><table-list table=trackers.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.trackerscontroller.download_list\'\" class=\"md-raised md-primary btn-primary\" ng-click=trackers.downloadReport($event)><md-translate key=::trackers.translate_key shortcode=\"\'trackers.download_report\'\"></md-translate></md-button></div><table-list-pagination table=trackers.table></table-list-pagination></div></div></md-card></div>");
$templateCache.put("app/admin/tracking_mirrors/partials/add_tracking.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::addCtrl.translate_key shortcode=\"\'add_tracking.header\'\"></md-translate></div></div><div flex=100 class=mt-30><tabs-list tabs-name=tracking_mirrors></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=tracking_mirrors view-name=content></tabs-content></md-card-content><div class=card-footer><div class=button-holder><tabs-content tabs-name=tracking_mirrors view-name=buttons></tabs-content><md-button class=btn-transparent ng-click=addCtrl.back()><md-translate key=::addCtrl.translate_key shortcode=\"\'add_tracking.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/tracking_mirrors/partials/buttons.html","<md-button class=\"md-raised md-primary btn-primary\" md-click=addCtrl.tabs.activeTab.submitFn()><md-translate key=::addCtrl.translate_key shortcode=\"\'add_tracking.save\'\"></md-translate></md-button>");
$templateCache.put("app/admin/tracking_mirrors/partials/create_manual.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=addCtrl.addForm><md-input-container class=md-block><label><md-translate key=::addCtrl.translate_key shortcode=\"\'form.link\'\"></md-translate></label><input input-errors type=text name=domain ng-model=addCtrl.mirror.link><md-error-messages errors=addCtrl.errors input-name=domain></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::addCtrl.translate_key shortcode=\"\'form.priority\'\"></md-translate></label><input input-errors type=number name=priority ng-model=addCtrl.mirror.priority><md-error-messages errors=addCtrl.errors input-name=priority></md-error-messages></md-input-container><md-input-container class=md-block><md-checkbox md-select-label-translate class=\"primary-checkbox md-primary\" ng-model=addCtrl.mirror.enabled><md-translate key=::addCtrl.translate_key shortcode=\"\'form.enabled\'\"></md-translate></md-checkbox></md-input-container></form></div>");
$templateCache.put("app/admin/tracking_mirrors/partials/create_with_file.html","<div row-restrict max-width=450px class=last-item-no-margin><div class=\"file-uploader-wrap with-errors\"><div class=label-top><md-translate key=::addCtrl.translate_key shortcode=\"\'from_file.header\'\"></md-translate></div><div nv-file-drop uploader=addCtrl.uploader class=file-drop-area><div nv-file-over uploader=addCtrl.uploader over-class=file-is-over class=file-drop-zone layout=row layout-align=\"center center\"><div ng-if=!addCtrl.uploader.queue.length class=no-file><i class=\"fa fa-cloud-download\"></i><div><md-translate key=::addCtrl.translate_key shortcode=\"\'from_file.description\'\"></md-translate></div><input nv-file-select type=file multiple uploader=addCtrl.uploader class=upload-input></div><div ng-if=addCtrl.uploader.queue.length class=files-wrap><div ng-repeat=\"item in addCtrl.uploader.queue\" class=file-list-item><span ng-bind=item.file.name class=file-name></span><span class=file-size>(<span ng-bind=\"item.file.size/1024/1024 | number:2\"></span>MB)<div style=\"margin-bottom: 0\" class=progress><div ng-style=\"{ \'width\': item.progress + \'%\' }\" role=progressbar class=progress-bar></div><div ng-show=item.progress class=percent-progress>{{ item.progress }} %</div></div></span><span class=delete-file><md-button class=md-icon-button ng-click=item.remove()><i class=\"fa fa-trash-o\"></i></md-button></span></div></div></div></div><form name=parent.uploadFileForm><md-input-container class=\"md-block mg-none input-hidden\"><input input-errors type=text name=file ng-model=parent._file><md-error-messages errors=parent.errors input-name=file></md-error-messages></md-input-container></form></div></div>");
$templateCache.put("app/admin/tracking_mirrors/partials/edit_tracking.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_tracking.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=editCtrl.editForm><md-input-container class=md-block><label><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_form.link\'\"></md-translate></label><input input-errors type=text name=domain ng-model=editCtrl.mirror.link><md-error-messages errors=editCtrl.errors input-name=domain></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_form.priority\'\"></md-translate></label><input input-errors type=number name=priority ng-model=editCtrl.mirror.priority><md-error-messages errors=editCtrl.errors input-name=priority></md-error-messages></md-input-container><md-input-container class=md-block><md-checkbox md-select-label-translate class=\"primary-checkbox md-primary\" ng-model=editCtrl.mirror.enabled><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_form.enabled\'\"></md-translate></md-checkbox></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=editCtrl.save()><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_tracking.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=editCtrl.back()><md-translate key=::editCtrl.translate_key shortcode=\"\'edit_tracking.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/tracking_mirrors/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.mirrorscontroller.edit\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.editMirror(item, $event)\"><i class=\"fa fa-pencil-square-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.mirrorscontroller.delete\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.removeMirror(item, $event)\"><i class=\"fa fa-trash\"></i></md-button>");
$templateCache.put("app/admin/tracking_mirrors/partials/tracking_mirrors.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::trackersCtrl.translate_key shortcode=\"\'tracking.header\'\"></md-translate></div><div class=search-block><table-list-search table=trackersCtrl.table></table-list-search></div></div><div class=card-content><table-list table=trackersCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.creativemirrorscontroller.create\'\" class=\"md-raised md-primary btn-primary\" ng-click=trackersCtrl.add()><md-translate key=::trackersCtrl.translate_key shortcode=\"\'tracking.button_add_tracking\'\"></md-translate></md-button></div><table-list-pagination table=trackersCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/tracking_mirrors_notifications/partials/mirrors_notifications.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::mirrorsCtrl.translate_key shortcode=\"\'mirrors_notifications.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=mirrorsCtrl.saveForm><md-input-container class=md-block><label><md-translate key=::mirrorsCtrl.translate_key shortcode=\"\'form.errors_per_hour_limit\'\"></md-translate></label><input input-errors type=text name=errors_per_hour_limit ng-model=mirrorsCtrl.notify.errors_per_hour_limit><md-error-messages errors=mirrorsCtrl.errors input-name=errors_per_hour_limit></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::mirrorsCtrl.translate_key shortcode=\"\'form.errors_per_day_limit\'\"></md-translate></label><input input-errors type=text name=errors_per_day_limit ng-model=mirrorsCtrl.notify.errors_per_day_limit><md-error-messages errors=mirrorsCtrl.errors input-name=errors_per_day_limit></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::mirrorsCtrl.translate_key shortcode=\"\'form.receive_email_restriction\'\"></md-translate></label><input input-errors type=text name=receive_email_restriction ng-model=mirrorsCtrl.notify.receive_email_restriction><md-error-messages errors=mirrorsCtrl.errors input-name=receive_email_restriction></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::mirrorsCtrl.translate_key shortcode=\"\'form.email\'\"></md-translate></label><input input-errors type=text name=email ng-model=mirrorsCtrl.notify.email><md-error-messages errors=mirrorsCtrl.errors input-name=email></md-error-messages></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=mirrorsCtrl.save()><md-translate key=::mirrorsCtrl.translate_key shortcode=\"\'mirrors_notifications.save\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/translate_manager/partials/translate_manager.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.title\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.title\')}}\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.language\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.language\')}}\"></md-translate></label><select-with-search list=translate_manager.language_list ng-model=translate_manager.language ng-change=translate_manager.init() set-key-as-value=true options=\"{translate_key: \'Languages\', shortcode: \'language.{{part}}\', key_as_shortcode_part: true, search_in_translate: true}\"><md-translate key=\"\'Languages\'\" shortcode=\"\'language.\' + key\" translate-default=\"{{::translate_manager.getTranslateDefault(\'language.\' + key, \'Languages\') || key}}\"></md-translate></select-with-search><span class=errors-reserve></span></md-input-container><md-input-container class=\"md-block with-clear-btn\"><label><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.search_locales\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.search_locales\')}}\"></md-translate></label><input type=text ng-model=translate_manager.search_term ng-change=translate_manager.init() ng-disabled=translate_manager.only_empty ng-model-options=\"{debounce: 500}\"><span ng-if=translate_manager.search_term ng-click=translate_manager.clear_search() ng-class=\"{\'disabled\': translate_manager.only_empty}\" class=clear-search><img src=assets/images/cross.png></span></md-input-container><md-input-container class=md-block><md-checkbox class=\"md-primary primary-checkbox\" ng-model=translate_manager.only_empty ng-change=translate_manager.init()><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.empty_locales\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.empty_locales\')}}\"></md-translate></md-checkbox></md-input-container></div><div class=mb-30><label class=top-label><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.front_end\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.front_end\')}}\"></md-translate></label><translate-list class=angular-tree list=translate_manager.frontend_list to-save=translate_manager.dataToSave language=translate_manager.language save-func=translate_manager.save(data)></translate-list></div><div class=mb-30><label class=top-label><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.back_end\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.back_end\')}}\"></md-translate></label><translate-list class=angular-tree list=translate_manager.backend_list to-save=translate_manager.dataToSave language=translate_manager.language save-func=translate_manager.save(data)></translate-list></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=translate_manager.exportFile()><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.export_file_button\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.export_file_button\')}}\"></md-translate></md-button><md-menu md-offset=\"0 -7\" class=upload-locale-btn><md-button class=\"md-raised md-primary btn-primary\" ng-click=$mdOpenMenu($event)><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.import_file_button\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.import_file_button\')}}\"></md-translate></md-button><md-menu-content width=6><md-menu-item><md-button ng-click=\"translate_manager.importFile(true, $event)\"><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.force_write\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.force_write\')}}\"></md-translate></md-button></md-menu-item><md-menu-item><md-button ng-click=\"translate_manager.importFile(false, $event)\"><md-translate key=::translate_manager.translate_key shortcode=\"\'translate_manager.write_only_empty\'\" translate-default=\"{{::translate_manager.getTranslateDefault(\'translate_manager.write_only_empty\')}}\"></md-translate></md-button></md-menu-item></md-menu-content></md-menu></div></div></md-card></div>");
$templateCache.put("app/admin/withdrawals_history/partials/table.html","<md-button class=md-icon-button ng-click=\"table.config.buttons.methods.viewWithdrawal(item, $event)\"><i class=\"fa fa-eye\"></i></md-button>");
$templateCache.put("app/admin/withdrawals_history/partials/view_withdrawal.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.merchant_name\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.merchant_name ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.affiliate_email\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.affiliate_email ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.affiliate_id\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.affiliate_id ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.affiliate_username\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.affiliate_username ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.amount\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.amount ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.created_at\'\"></md-translate></label><input date-locale-input format=\"L HH:mm:ss\" type=text ng-model=viewCtrl.withdrawal.created_at ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.creator_type><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.creator_type\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.creator_type ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.creator_id><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.creator_id\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.creator_id ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.creator_email><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.creator_email\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.creator_email ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.admin_email><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.admin_email\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.admin_email ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.state><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.state\'\"></md-translate></label><input type=text ng-value=\"viewCtrl.stateShortcodePart + viewCtrl.withdrawal.state | mdTranslate: viewCtrl.translate_key\" ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=viewCtrl.withdrawal.payment_system_name><label><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.form.payment_system_name\'\"></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.payment_system_name ng-readonly=true></md-input-container><md-input-container ng-repeat=\"field in viewCtrl.allFields\" class=md-block ng-if=viewCtrl.withdrawal.payment_system_details_json[field]><label><md-translate key=\"\'AffiliateBalance\'\" shortcode=viewCtrl.findFieldShortcode(field)></md-translate></label><input type=text ng-value=viewCtrl.withdrawal.payment_system_details_json[field] ng-readonly=true></md-input-container></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=btn-transparent ng-click=viewCtrl.back()><md-translate key=::viewCtrl.translate_key shortcode=\"\'view_withdrawal.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/withdrawals_history/partials/withdrawals_history.html","<ui-view><div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::withdrawalsCtrl.translate_key shortcode=\"\'withdrawals_history.header\'\"></md-translate></div><div flex=nogrow class=search-block><table-list-search table=withdrawalsCtrl.table></table-list-search></div></div></div><div class=card-content><table-list table=withdrawalsCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.withdrawals_history_download\'\" class=\"md-raised md-primary btn-primary\" ng-click=withdrawalsCtrl.downloadReport($event)><md-translate key=::withdrawalsCtrl.translate_key shortcode=\"\'withdrawals_history.download_report_button\'\"></md-translate></md-button></div><table-list-pagination table=withdrawalsCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/components/articles/partials/last_articles.html","<div class=last-articles-list><div ng-repeat=\"item in $ctrl.articlesList\" layout-gt-xs=row layout-xs=column layout-align=\"space-between start\" class=last-articles-item><span ng-bind=item.title ng-click=$ctrl.view(item) class=articles-title></span><span flex=none date-locale={{item.created_at}} format=\"{{$ctrl.options.date_format || $ctrl.defaultDateFormat}}\" class=articles-create-date></span></div><div ng-if=$ctrl.noArticles($ctrl.articlesList) class=no-articles><md-translate key=$ctrl.options.translate_key shortcode=$ctrl.options.no_articles_shortcode></md-translate></div></div>");
$templateCache.put("app/components/articles/partials/list.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::ArticlesCtrl.translate_key shortcode=\"\'articles.header\'\"></md-translate></div><div class=search-block><table-list-search table=ArticlesCtrl.table></table-list-search></div></div><div class=card-content><table-list table=ArticlesCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button ng-if=ArticlesCtrl.showCreateArticleBtn() class=\"md-raised md-primary btn-primary\" ng-click=ArticlesCtrl.createArticle()><md-translate key=::ArticlesCtrl.translate_key shortcode=\"\'articles.create_articles_btn\'\"></md-translate></md-button></div><table-list-pagination table=ArticlesCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/components/articles/partials/settings.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::SettingsCtrl.translate_key shortcode=SettingsCtrl.titleShortcode></md-translate></div></div><md-card-content class=padding-content><form name=SettingsCtrl.articleForm><md-input-container row-restrict max-width=450px class=md-block><label><md-translate key=::SettingsCtrl.translate_key shortcode=\"\'articles_settings.form.for_language\'\"></md-translate></label><select-with-search list=SettingsCtrl.languagesList ng-model=SettingsCtrl.article.locale name=locale errors=SettingsCtrl.errors save-prop=id><span ng-bind=value.translate></span></select-with-search></md-input-container><md-input-container row-restrict max-width=450px class=md-block><label><md-translate key=::SettingsCtrl.translate_key shortcode=\"\'articles_settings.form.title\'\"></md-translate></label><input input-errors type=text name=title ng-model=SettingsCtrl.article.title><md-error-messages errors=SettingsCtrl.errors input-name=title></md-error-messages></md-input-container><div class=sub-title><md-translate key=::SettingsCtrl.translate_key shortcode=\"\'articles_settings.form.body\'\"></md-translate></div><text-angular ng-model=SettingsCtrl.article.body name=body ta-unsafe-sanitizer=true class=text-editor></text-angular><md-input-container class=\"md-block fake-input-error\"><input input-errors type=text name=body ng-model=SettingsCtrl.fake_body><md-error-messages errors=SettingsCtrl.errors input-name=body></md-error-messages></md-input-container></form></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=SettingsCtrl.saveArticle()><md-translate key=::SettingsCtrl.translate_key shortcode=\"\'articles_settings.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=SettingsCtrl.back()><md-translate key=::SettingsCtrl.translate_key shortcode=\"\'articles_settings.back\'\"></md-translate></md-button></div></div></div></md-card></div>");
$templateCache.put("app/components/articles/partials/table.html","<md-button class=md-icon-button ng-click=table.config.buttons.methods.viewNews(item) ng-if=table.config.buttons.methods.viewNews><i class=\"fa fa-eye\"></i></md-button><md-button class=md-icon-button ng-click=table.config.buttons.methods.editNews(item) ng-if=table.config.buttons.methods.editNews><i class=\"fa fa-pencil-square-o\"></i></md-button><md-button class=md-icon-button ng-click=\"table.config.buttons.methods.destroyNews(item, $event)\" ng-if=table.config.buttons.methods.destroyNews><i class=\"fa fa-trash-o\"></i></md-button>");
$templateCache.put("app/components/articles/partials/view.html","<div class=view-content><md-card class=primary-card><div layout-gt-xs=row layout=column layout-align=\"space-between start\" class=card-header><div class=card-title><span ng-bind=ViewCtrl.articleTitle></span></div><div flex=none class=\"last-update-wrap space-around\"><md-translate key=::ViewCtrl.translate_key shortcode=\"\'articles_view.last_update\'\"></md-translate><strong date-locale={{ViewCtrl.articleLastUpdate}} format=LLL></strong></div></div><md-card-content class=padding-content><div ng-bind-html=ViewCtrl.articleContent class=text-editor></div></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=btn-transparent ng-click=ViewCtrl.back()><md-translate key=::ViewCtrl.translate_key shortcode=\"\'articles_view.back\'\"></md-translate></md-button></div></div></div></md-card></div>");
$templateCache.put("app/components/bookkeeping/partials/bookkeeping.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::bookkeeping.translate_key shortcode=\"\'bookkeeping.header\'\"></md-translate></div><div class=search-block><table-list-search table=bookkeeping.table></table-list-search></div></div><div class=card-content><table-list table=bookkeeping.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder></div><table-list-pagination table=bookkeeping.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/components/bookkeeping/partials/bookkeeping_month_report.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><span date-locale={{bookkeepingMonthReport.title}} format=\"MMMM YYYY\"></span></div><div class=search-block><table-list-search table=bookkeepingMonthReport.table></table-list-search></div></div><div ng-if=bookkeepingMonthReport.recalculating class=recalculating-note><md-translate key=::bookkeepingMonthReport.translate_key shortcode=\"\'bookkeeping_month_report.recalculating\'\"></md-translate></div><div class=card-content><table-list table=bookkeepingMonthReport.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.bookkeepingscontroller.change_status_month_payment\'\" class=\"md-raised md-primary btn-primary\" ng-click=bookkeepingMonthReport.approveMonth($event) ng-if=\"bookkeepingMonthReport.month_payments_aasm_state === \'in_process\'\" ng-disabled=!bookkeepingMonthReport.close_month_available title={{bookkeepingMonthReport.getInfo()}}><md-translate key=::bookkeepingMonthReport.translate_key shortcode=\"\'bookkeeping_month_report.approved\'\"></md-translate></md-button><md-button has-permission permission permission-only=\"\'api2.admin.bookkeepingscontroller.change_status_month_payment\'\" class=\"md-raised md-primary btn-primary\" ng-click=bookkeepingMonthReport.paidMonth($event) ng-if=\"bookkeepingMonthReport.month_payments_aasm_state === \'approved\'\"><md-translate key=::bookkeepingMonthReport.translate_key shortcode=\"\'bookkeeping_month_report.paid\'\"></md-translate></md-button><md-button has-permission permission permission-only=\"[\'api2.admin.bookkeepingscontroller.download_report\', \'api2.affiliate.bookkeepingscontroller.download_report\']\" class=\"md-raised md-primary btn-primary\" ng-click=bookkeepingMonthReport.downloadReport($event)><md-translate key=::bookkeepingMonthReport.translate_key shortcode=\"\'bookkeeping_month_report.download_report\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=bookkeepingMonthReport.back()><md-translate key=::bookkeepingMonthReport.translate_key shortcode=\"\'bookkeeping_month_report.back\'\"></md-translate></md-button></div><table-list-pagination table=bookkeepingMonthReport.table></table-list-pagination></div><div ng-if=bookkeepingMonthReport.cannotCloseMonth class=cannot-close-month-errors><translate translate-values=bookkeepingMonthReport.unclosedMerchants>{{bookkeepingMonthReport.cannotCloseMonthLocale}}</translate><span class=close-month-error ng-click=bookkeepingMonthReport.closeMonthError()><i class=\"fa fa-times\"></i></span></div></div></md-card></div></ui-view>");
$templateCache.put("app/components/bookkeeping/partials/deduction.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::bookkeepingDeduction.translate_key shortcode=bookkeepingDeduction.title watch-shortcode=true></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=bookkeepingDeduction.addRecoupmentForm><md-input-container class=md-block><label><md-translate key=::bookkeepingDeduction.translate_key shortcode=\"\'form.affiliate\'\"></md-translate></label><input type=text name=affiliate_username ng-model=bookkeepingDeduction.deduction.affiliate_username ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::bookkeepingDeduction.translate_key shortcode=\"\'form.deduction_size\'\"></md-translate></label><input input-errors type=number name=deduction ng-model=bookkeepingDeduction.deduction.deduction ng-readonly=!bookkeepingDeduction.canBeUpdated><md-error-messages errors=bookkeepingDeduction.errors input-name=deduction></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::bookkeepingDeduction.translate_key shortcode=\"\'form.deduction_comment\'\"></md-translate></label><textarea input-errors name=deduction_commit ng-model=bookkeepingDeduction.deduction.deduction_commit ng-readonly=!bookkeepingDeduction.canBeUpdated></textarea><md-error-messages errors=bookkeepingDeduction.errors input-name=deduction_commit></md-error-messages></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=bookkeepingDeduction.save_deduction() ng-if=bookkeepingDeduction.canBeUpdated><md-translate key=::bookkeepingDeduction.translate_key shortcode=\"\'deduction.save\'\"></md-translate></md-button><md-button class=\"md-raised md-warn btn-primary\" ng-click=bookkeepingDeduction.remove_deduction() ng-if=\"bookkeepingDeduction.remove_btn &amp;&amp; bookkeepingDeduction.canBeUpdated\"><md-translate key=::bookkeepingDeduction.translate_key shortcode=\"\'deduction.delete\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=bookkeepingDeduction.back()><md-translate key=::bookkeepingDeduction.translate_key shortcode=\"\'deduction.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/components/bookkeeping/partials/table.html","<md-button class=md-icon-button ng-click=table.config.buttons.methods.show_month(item)><i class=\"fa fa-eye\"></i></md-button>");
$templateCache.put("app/components/bookkeeping/partials/table_month_report.html","<md-button has-permission permission permission-only=\"\'api2.admin.bookkeepingscontroller.deduction\'\" class=md-icon-button ng-click=table.config.buttons.methods.add_deduction(item)><img src=assets/images/dollar.png style=\"margin: 0 auto\"></md-button>");
$templateCache.put("app/components/download_csv/partials/list.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::downloadCtrl.translate_key shortcode=\"\'download_csv.header\'\"></md-translate></div><div class=search-block><table-list-search table=downloadCtrl.table></table-list-search></div></div><div class=card-content><table-list table=downloadCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder></div><table-list-pagination table=downloadCtrl.table></table-list-pagination></div></div></md-card></div>");
$templateCache.put("app/components/download_csv/partials/table.html","<md-button class=md-icon-button ng-if=\"item.aasm_state === \'ready\'\" ng-click=table.config.buttons.methods.download(item)><i class=\"fa fa-download\"></i></md-button><md-button class=md-icon-button ng-if=table.config.buttons.methods.remove ng-click=\"table.config.buttons.methods.remove(item, $event)\"><i class=\"fa fa-trash-o\"></i></md-button>");
$templateCache.put("app/components/export_data/partials/export_data.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::exportCtrl.translate_key shortcode=\"\'export_data.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=exportCtrl.createReportForm><md-input-container class=md-block><label><md-translate key=::exportCtrl.translate_key shortcode=\"\'export_data.report_type\'\"></md-translate></label><md-select required input-errors md-select-label-translate name=report_type ng-model=exportCtrl.reportType><md-option ng-value=item ng-selected=\"exportCtrl.reportType === item || $first\" ng-repeat=\"item in exportCtrl.reportTypesList\"><span ng-bind=item></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=exportCtrl.errors input-name=report_type></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::exportCtrl.translate_key shortcode=\"\'export_data.report_period\'\"></md-translate></label><mod-datepicker ng-model=exportCtrl.reportPeriod errors=exportCtrl.errors name=date md-mode=month md-max-date=exportCtrl.maxDate ng-change=exportCtrl.changeReportPeriod() is-required=true></mod-datepicker></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=exportCtrl.createReport()><md-translate key=::exportCtrl.translate_key shortcode=\"\'export_data.create_report_btn\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/components/extensions/charts/charts.html","<md-card class=\"line-chart primary-card\"><div layout=row layout-align=\"space-between start\" class=card-header><div class=card-title><md-translate key=::$ctrl.options.translate_key shortcode=$ctrl.options.by_day_header_shortcode></md-translate></div><div layout=row layout-align=\"end center\"><md-input-container class=\"no-margin select-wrap\"><md-select ng-model=$ctrl.chartByDay.currentKey ng-change=$ctrl.changeByDayData() md-container-class=select-period><md-option ng-repeat=\"(key, value) in $ctrl.chartByDay.chartList\" ng-value=key ng-class=\"{\'is-choosed\': $ctrl.chartByDay.currentKey === key}\"><i class=\"fa fa-check\"></i><translate>{{$ctrl.options.columnsNamespace + key}}</translate></md-option></md-select></md-input-container></div></div><md-card-content class=padding-content><canvas id=line class=\"chart chart-line\" chart-data=$ctrl.chartByDay.data chart-labels=$ctrl.chartByDay.labels chart-series=$ctrl.chartByDay.series chart-options=$ctrl.chartByDay.options chart-dataset-override=$ctrl.chartByDay.datasetOverride chart-colors=$ctrl.chartByDay.colors></canvas></md-card-content><div class=card-footer></div></md-card><md-card class=\"pie-chart primary-card\"><div layout=row layout-align=\"space-between start\" class=card-header><div class=card-title><md-translate key=::$ctrl.options.translate_key shortcode=$ctrl.options.by_months_header_shortcode></md-translate></div><div layout=row layout-align=\"end center\"><md-input-container class=\"no-margin select-wrap\"><md-select ng-model=$ctrl.chartByMonth.currentKey ng-change=$ctrl.changeByMonthData() md-container-class=select-period><md-option ng-repeat=\"(key, value) in $ctrl.chartByMonth.chartList\" ng-value=key ng-class=\"{\'is-choosed\': $ctrl.chartByMonth.currentKey === key}\"><i class=\"fa fa-check\"></i><translate>{{$ctrl.options.columnsNamespace + key}}</translate></md-option></md-select></md-input-container></div></div><md-card-content flex layout=row layout-align=\"center center\" class=padding-content><div flex layout=row layout-align=\"center center\"><canvas id=pie class=\"chart chart-pie\" chart-data=$ctrl.chartByMonth.data chart-labels=$ctrl.chartByMonth.labels chart-options=$ctrl.chartByMonth.options chart-colors=$ctrl.chartByMonth.colors></canvas></div></md-card-content><div class=card-footer></div></md-card>");
$templateCache.put("app/components/extensions/daterangepicker/daterangepicker.html","<div layout=row><div flex=none ng-class=\"{\'disabled\': allDisabled}\" class=date-template><i class=\"fa fa-calendar\"></i><div class=picker-date><div ng-bind=picker.display_start class=over-picker></div><md-datepicker ng-model=start md-hide-icons=calendar ng-change=picker.change_start_date() md-max-date=startMax ng-disabled=allDisabled></md-datepicker></div><span ng-bind-html=\"\'&amp;ndash;\'\" class=dash></span><div class=picker-date><div ng-bind=picker.display_end class=over-picker></div><md-datepicker ng-model=end md-hide-icons=calendar ng-change=picker.change_end_date() md-min-date=endMin ng-disabled=allDisabled></md-datepicker></div></div><md-button class=\"md-icon-button clear-date-btn\" ng-disabled=allDisabled ng-click=picker.clear() ng-if=\"clearBtn &amp;&amp; (start || end)\"><img src=assets/images/cross.png></md-button></div>");
$templateCache.put("app/components/extensions/mod_datepicker/mod_datepicker.html","<div class=datepicker-wrap><div ng-click=$ctrl.openPiker() class=datepicker-toggle></div><md-datepicker input-errors md-no-asterisk name={{::$ctrl.name}} ng-required=$ctrl.isRequired ng-disabled=$ctrl.disabled md-is-open=$ctrl.isOpen md-hide-icons=calendar md-current-view={{::$ctrl.mdCurrentView}} md-mode={{::$ctrl.mdMode}} ng-model=$ctrl.pikerModel ng-change=$ctrl.pickerModelChanged($ctrl.pikerModel) md-date-locale=$ctrl.options md-min-date=$ctrl.mdMinDate md-max-date=$ctrl.mdMaxDate md-date-filter=$ctrl.dateFilter format={{::ctrl.format}} model-format={{::ctrl.modelFormat}} onkeydown=\"return false\"></md-datepicker><md-error-messages errors=$ctrl.errors input-name={{::$ctrl.name}}></md-error-messages></div>");
$templateCache.put("app/components/extensions/text_angular_advanced/text_angular_advanced.html","<div ng-if=!$ctrl.only class=mb-30><md-input-container row-restrict max-width=450px class=\"md-block md-input-has-value\"><label><md-translate key=::$ctrl.translateKey shortcode=::$ctrl.shortcodes.switcherLabel></md-translate></label><md-switch class=\"md-primary md-switch-input mb-none switch-banned\" ng-model=$ctrl.mode ng-true-value=\"\'html\'\" ng-false-value=\"\'editor\'\" ng-change=$ctrl.switchMode()><md-translate key=::$ctrl.translateKey shortcode=\"$ctrl.mode === \'html\' ? $ctrl.shortcodes.modeHtml : $ctrl.shortcodes.modeEditor\" watch-shortcode=true></md-translate></md-switch></md-input-container></div><div ng-if=\"$ctrl.mode === \'html\'\" class=text-area-wrap><md-input-container row-restrict max-width=450px class=\"text-area-input md-block\" ng-class=\"{\'md-input-invalid\': $ctrl.errors.errors[$ctrl.name]}\"><label><md-translate key=::$ctrl.translateKey shortcode=::$ctrl.shortcodes.textareaLabel></md-translate></label><textarea name=html class=html-area></textarea></md-input-container><md-input-container row-restrict max-width=450px class=\"text-area-error md-block fake-input-error\"><input input-errors type=text name={{$ctrl.name}} ng-model=$ctrl.fake_body><md-error-messages errors=$ctrl.errors input-name={{$ctrl.name}} variables=$ctrl.variablesForError></md-error-messages></md-input-container><div ng-if=$ctrl.textAreaModel class=sub-title><md-translate key=::$ctrl.translateKey shortcode=::$ctrl.shortcodes.previewLabel></md-translate></div><iframe width=100% height=0 class=html-view></iframe></div><div ng-if=\"$ctrl.mode === \'editor\'\"><text-angular text-angular-event vm=$ctrl name={{$ctrl.name}} ng-class=\"{\'show-dropdown\': $ctrl.showDropdown}\" ta-show-html={{$ctrl.taShowHtml}} ta-toolbar=$ctrl.taToolbar ng-model=$ctrl.editorModel ta-unsafe-sanitizer={{$ctrl.taUnsafeSanitizer}} ng-change=$ctrl.editorChange() class=text-editor></text-angular><md-input-container class=\"md-block fake-input-error\"><input input-errors type=text name={{$ctrl.name}} ng-model=$ctrl.fake_body><md-error-messages errors=$ctrl.errors input-name={{$ctrl.name}} variables=$ctrl.variablesForError></md-error-messages></md-input-container></div>");
$templateCache.put("app/components/extensions/toasts/toasts.html","<md-toast toast-big-content class=custom-toast><div layout=row layout-align=\"space-between center\" class=toast-content-holder><div class=toast-content><div ng-if=$ctrl.text><span style=\"white-space: pre-line\" ng-bind=$ctrl.text></span></div><div ng-if=$ctrl.locale><translate translate-values=$ctrl.data>{{$ctrl.locale}}</translate></div><div ng-if=\"$ctrl.translate_key &amp;&amp; $ctrl.shortcode\"><md-translate key=$ctrl.translate_key shortcode=$ctrl.shortcode translate-values=$ctrl.data></md-translate></div><div ng-if=$ctrl.status><md-translate key=$ctrl.conformity[$ctrl.status].translate_key shortcode=$ctrl.conformity[$ctrl.status].shortcode></md-translate></div><div ng-if=$ctrl.defaultContent><md-translate key=$ctrl.defaultContent.translate_key shortcode=$ctrl.defaultContent.shortcode></md-translate></div></div><md-button class=\"md-icon-button close-toast\" ng-click=$ctrl.closeToast()><i class=\"fa fa-times\"></i></md-button></div><expand-toast-button callback=$ctrl.cancelTimeout()></expand-toast-button></md-toast>");
$templateCache.put("app/components/last_update/partials/last_update.html","<md-button ng-if=$ctrl.showUpdateButton class=\"md-raised md-primary btn-primary reload-btn\" ng-click=$ctrl.update()><md-translate key=\"\'AvailableNewVersion\'\" shortcode=\"\'available_new_version\'\"></md-translate></md-button>");
$templateCache.put("app/components/reports/partials/checkbox_template.html","<checkbox-list list=template.current_temp.template_data[tab.id] field-name={{tab.field_name}} callback=template.save_tab_data all-disabled=template.current_temp.read_only import-file=template.import_from_csv($event) show-btn=template.current_tab.upload_from_file value-translate-namespace=columnsNamespace></checkbox-list>");
$templateCache.put("app/components/reports/partials/reports.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::reports.translate_key shortcode=\"\'reports.header\'\"></md-translate></div></div><md-card-content class=padding-content><div class=report-filter-wrap><!--Date filter--><div class=report-filter-row><date-period translate-key=::reports.translate_key list=reports.periods datepicker-range-period=::reports.datepicker_range_period></date-period></div><!--Group by filter--><div layout-xs=column layout-align-xs=\"start start\" class=report-filter-row><md-input-container flex-xs=auto class=btn-container ng-repeat=\"obj in reports.group_by | orderBy: \'order\'\"><md-select ng-model=reports.report_information[obj.model] class=\"select-icon reports-select\" md-container-class=reports-select><md-option ng-value=item ng-repeat=\"item in obj.value track by $index\" ng-selected=\"{{reports.report_information[obj.model] === item}}\"><md-translate key=::reports.translate_key shortcode=\"\'group_by.\' + (obj.item_locale ? obj.item_locale : item)\" translate-values=\"{ item: (obj.item_locale ? item : \'\') }\" shortcode-id=\"{{::\'group_by.\' + (obj.item_locale ? obj.item_locale : item)}}\"></md-translate></md-option></md-select></md-input-container></div><!--Segments template--><reports-template template=reports.segments ng-if=reports.segments namespace=.segments translate-key=::reports.translate_key></reports-template><!--Structure template--><reports-template template=reports.structures ng-if=reports.structures namespace=.structures translate-key=::reports.translate_key aasm-states=reports.aasm_states_list columns-namespace=reports.columns_namespace></reports-template></div><div ng-if=reports.segmentsOrStructuresNotLoaded class=reports-error-holder><span><md-translate key=::reports.translate_key shortcode=\"\'reports.some_error_occured\'\"></md-translate></span><md-button class=\"md-primary md-button md-warn\" ng-click=reports.refreshPage()><md-translate key=::reports.translate_key shortcode=\"\'reports.refresh_page_button\'\"></md-translate></md-button></div></md-card-content><div class=card-footer><div class=button-holder><md-button has-permission permission permission-only=reports.permissions.generate class=\"md-raised md-primary btn-primary\" md-click=reports.generate_report()><md-translate key=::reports.translate_key shortcode=\"\'reports.generate_report\'\"></md-translate></md-button><md-button has-permission permission permission-only=reports.permissions.download class=\"md-raised md-primary btn-primary\" ng-click=reports.downloadReport($event)><md-translate key=::reports.translate_key shortcode=\"\'reports.download_report\'\"></md-translate></md-button></div></div></md-card><md-card class=primary-card ng-if=reports.table.isRendered() id=report-table-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::reports.translate_key shortcode=\"\'result.header\'\"></md-translate></div><div class=search-block><table-list-search table=reports.table></table-list-search></div></div><div class=card-content><table-list table=reports.table on-rendered=reports.tableRenderedCallback()></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder></div><table-list-pagination table=reports.table></table-list-pagination></div></div></md-card></div>");
$templateCache.put("app/components/reports/partials/stats_block.html","<div layout-wrap layout=row class=stats-wrap><div flex=none class=stats-columns-tab-wrap><div class=column-tabs-list><div ng-repeat=\"column in stats.all_stats_list\" ng-if=column.display class=column-tab-item><md-button layout=row class=stats-column ng-click=\"stats.choose_column(column, $event)\" ng-class=\"{\'current\': stats.current_column.id === column.id}\" ng-disabled=\"stats.current_column.id === column.id\"><span class=not-empty ng-if=!column.empty></span><span flex md-translate key=::translateKey shortcode=column.shortcode shortcode-id={{::column.shortcode}}></span><span flex=none class=btn-clear ng-click=\"stats.clear(column, $event)\" ng-if=!column.empty><img src=assets/images/cross.png></span></md-button></div></div></div><div flex class=stats-columns-tab-content ng-if=stats.isGtXs><div ng-include=stats.type_template_url></div></div></div>");
$templateCache.put("app/components/reports/partials/stats_block_mobile.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=translateKey shortcode=stats.current_column.shortcode></md-translate></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=stats.closeMobilePopup()></md-button></span></div><md-dialog-content class=md-dialog-content><div class=stats-columns-tab-content><div ng-include=stats.type_template_url></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/reports/partials/stats_template.html","<stats-block list=tab.all_stats_list stats-data=template.current_temp.template_data[tab.id] template-url={{tab.stats_column_template_url}} callback=template.save_tab_data translate-key=::translateKey all-disabled=template.current_temp.read_only></stats-block>");
$templateCache.put("app/components/reports/partials/templates.html","<div class=report-filter-row><div><!--Desktop segments/structures--><div ng-if=tempObj.isGtXs class=templates-list><md-button ng-repeat=\"temp in template.templates | orderBy:[\'-read_only\',\'id\'] track by temp.id\" ng-click=template.choose_template(temp) class=btn-set-params ng-class=\"{\'current\': temp.id === template.current_temp.id}\" ng-disabled=\"temp.id === template.current_temp.id || template.all_disabled\"><div layout-wrap layout=row layout-align=\"center center\"><span flex md-translate key=::translateKey shortcode=\"temp.name || \'segments.no_name\'\" watch-shortcode=true translate-values=\"{ id: temp.id }\" ng-if=\"temp.id === 0 || !temp.name\"></span><span flex ng-bind=temp.name ng-if=\"temp.id !== 0 &amp;&amp; temp.name\"></span><span flex=none class=btn-toggle ng-if=\"temp.id !== 0\" ng-click=\"template.toggle_constructor(temp, $event)\" ng-class=\"{\'open\': temp.show}\"></span><span flex=none class=btn-remove ng-class=\"{\'disabled\': template.all_disabled}\" ng-click=\"template.remove_template(temp, $event)\" ng-if=!temp.read_only><img src=assets/images/cross.png></span></div></md-button><md-button md-click=template.add_template() class=\"btn-set-params btn-light\" ng-disabled=template.all_disabled><i class=\"fa fa-plus\"></i><md-translate key=::translateKey shortcode=\"template.save_key + \'.add_new_element\'\"></md-translate></md-button></div><!--Mobile segments/structures--><div ng-if=!tempObj.isGtXs class=templates-list><div layout=row class=templates-list-mobile><md-input-container flex class=md-block><md-select md-select-label-translate ng-model=template.current_temp ng-change=template.get_tab_data()><md-option ng-value=temp ng-repeat=\"temp in template.templates | orderBy:[\'-read_only\',\'id\'] track by temp.id\"><md-translate key=::translateKey shortcode=\"temp.name || \'segments.no_name\'\" watch-shortcode=true translate-values=\"{ id: temp.id }\" ng-if=\"temp.id === 0 || !temp.name\"></md-translate><span flex ng-bind=temp.name ng-if=\"temp.id !== 0 &amp;&amp; temp.name\"></span></md-option></md-select></md-input-container><md-button layout=column layout-align=\"center center\" class=md-icon-button ng-if=\"template.current_temp.id !== 0\" ng-click=template.toggleAllConstructors() ng-class=\"{\'open\': template.showAll}\"><i class=\"fa fa-chevron-down\"></i></md-button><md-button class=md-icon-button ng-class=\"{\'disabled\': template.all_disabled}\" ng-click=\"template.remove_template(template.current_temp, $event)\" ng-if=!template.current_temp.read_only><img src=assets/images/cross.png></md-button></div><md-button md-click=template.add_template() class=\"btn-set-params btn-light\" ng-disabled=template.all_disabled><i class=\"fa fa-plus\"></i><md-translate key=::translateKey shortcode=\"template.save_key + \'.add_new_element\'\"></md-translate></md-button></div></div></div><div ng-if=\"template.current_temp.id !== 0\" ng-show=template.current_temp.show class=\"report-filter-row custom-scroll overflow-auto\"><div translate-namespace=.tabs class=templates-tabs-content-wrap><!--Desktop tabs--><div ng-if=tempObj.isGtXs class=templates-tabs-list><md-button ng-repeat=\"tab in template.tabs | orderBy: $index track by tab.id\" ng-click=template.choose_tab(tab) class=\"template-tab btn-set-params\" ng-class=\"{\'current\': tab.id === template.current_tab.id}\" ng-disabled=\"tab.id === template.current_tab.id || template.all_disabled\" ng-if=tab.display><span md-translate key=::translateKey shortcode=tab.shortcode shortcode-id={{::tab.shortcode}}></span></md-button></div><!--Mobile tabs--><div ng-if=!tempObj.isGtXs class=templates-tabs-list><md-tabs><!--Empty tab for not trigering request until user click to other tab--><md-tab></md-tab><md-tab ng-repeat=\"tab in template.tabs | orderBy: $index track by tab.id\" md-active=\"tab.id === template.current_tab.id\" md-on-select=template.choose_tab(tab) ng-disabled=\"tab.id !== template.current_tab.id &amp;&amp; template.all_disabled\" ng-if=tab.display><span md-translate key=::translateKey shortcode=tab.shortcode shortcode-id={{::tab.shortcode}}></span></md-tab></md-tabs></div><div ng-class=\"{\'is-empty\': template.current_tab.id === tab.id}\" class=tab-templates><div layout=column layout-align=\"center center\" class=preloader-wrap ng-show=template.preloader><md-progress-circular md-diameter=30px></md-progress-circular></div><div ng-cloak class=templates-tabs-wrap><div ng-repeat=\"tab in template.tabs | orderBy: \'id\' track by tab.id\" ng-if=\"template.current_tab.id === tab.id\"><div ng-include=tab.templateUrl></div></div></div></div><div ng-if=template.current_temp.id layout-xs=column class=templates-name-wrap><md-input-container flex-xs=50><label><md-translate key=::translateKey shortcode=\"template.save_key + \'.name\'\"></md-translate></label><input type=text ng-model=template.current_temp.name ng-disabled=template.current_temp.read_only ng-change=template.change_template_name()></md-input-container><span flex-xs=50 class=visibility-types-wrap><md-input-container ng-if=template.is_permit><label><md-translate key=::translateKey shortcode=\"template.save_key + \'.aasm_state\'\"></md-translate></label><md-select ng-model=template.current_temp.aasm_state ng-disabled=template.current_temp.read_only ng-change=template.change_aasm_state()><md-option ng-value=state ng-repeat=\"state in aasmStates\"><md-translate key=::translateKey shortcode=\"template.save_key + \'.\' + state\"></md-translate></md-option></md-select><span class=errors-reserve></span></md-input-container></span></div></div></div>");
$templateCache.put("app/components/shared/accordion/accordion_group.html","<div layout=column class=accordion-group><div ng-transclude=headingSlot class=accordion-group-heading></div><div class=accordion-group-content><div ng-transclude=contentSlot class=accordion-group-content-holder></div></div></div>");
$templateCache.put("app/components/shared/affiliate_banner/affiliate_banner.html","<md-dialog class=dialog-banner><div class=dialog-header><md-button class=\"md-icon-button close-btn\" ng-click=$ctrl.closePopup()><span class=slash></span><span class=slash></span></md-button></div><md-dialog-content class=banner-content><a ng-href={{$ctrl.banner.link}} target=_blank class=dialog-banner-link><img ng-src={{$ctrl.banner.image}}></a></md-dialog-content></md-dialog>");
$templateCache.put("app/components/shared/checkbox_list/checkbox_list.html","<div class=checkbox-list-wrap><div class=list-header><md-input-container md-no-float class=\"md-block cross-btn\"><md-icon><i class=\"fa fa-search\"></i></md-icon><input type=text ng-model=checkbox_list.search_field name=search aria-label=search ng-change=checkbox_list.update_selected() ng-disabled=disableSearch autocomplete=off><span ng-if=checkbox_list.search_field ng-click=checkbox_list.clear() class=clear-search><img src=assets/images/cross.png></span></md-input-container><md-input-container md-no-float class=\"md-block cross-btn\"><div ng-if=checkbox_list.groupedItems class=group-section><div class=group-header>Country Group</div><div ng-repeat=\"(groupName, groupItems) in checkbox_list.groupedItems\" class=repeat-item><md-checkbox ng-disabled=allDisabled ng-model=checkbox_list.groupSelections[groupName] ng-change=\"checkbox_list.choose_group(groupName, checkbox_list.groupSelections[groupName])\" aria-label={{groupName}} class=\"md-primary primary-checkbox\">{{groupName}}</md-checkbox></div></div></md-input-container></div><div class=list-holder><md-virtual-repeat-container class=virtual-repeat><div md-on-demand=true md-virtual-repeat=\"item in checkbox_list.virtual_repeat\" class=repeated-item><md-checkbox ng-checked=item.check ng-click=checkbox_list.toggle(item) class=\"md-primary primary-checkbox\" aria-label={{item[checkbox_list.field_name]}} ng-disabled=\"allDisabled || checkbox_list.preventMultiClicks\"><span ng-bind=item[checkbox_list.field_name] ng-if=\"!valueTranslateNamespace &amp;&amp; !locales\" class=checkbox-item-value></span><span ng-if=valueTranslateNamespace class=checkbox-item-value><translate>{{valueTranslateNamespace + item[checkbox_list.field_name]}}</translate></span><span ng-if=locales class=checkbox-item-value><md-translate ng-if=locales.shortcode key=locales.translate_key shortcode=\"locales.shortcode + item[checkbox_list.field_name]\"></md-translate><md-translate ng-if=!locales.shortcode key=locales.translate_key shortcode=\"item[checkbox_list.field_name] ? locales.truth : locales.lie\"></md-translate></span></md-checkbox></div></md-virtual-repeat-container><div ng-if=!checkbox_list.virtual_repeat.items.length class=no-data><md-translate key=translate_key shortcode=\"\'checkboxes_list.no_data\'\"></md-translate></div></div><div layout-wrap layout=row layout-xs=column layout-align-gt-xs=\"space-between start\" class=list-footer><div flex=none class=\"list-length space-around\"><span md-translate key=translate_key shortcode=\"\'checkboxes_list.selected\'\"></span><span ng-bind=checkbox_list.virtual_repeat.selected.length class=font-medium></span><span md-translate key=translate_key shortcode=\"\'checkboxes_list.from\'\"></span><span ng-bind=\"checkbox_list.virtual_repeat.items.length || 0\" class=font-medium></span></div><div layout-wrap flex=nogrow layout-xs=row layout-align-xs=\"end start\" class=btn-wrap><md-button ng-disabled=\"allDisabled || checkbox_list.preventMultiClicks\" class=md-primary ng-click=\"importFile({$event: $event})\" ng-if=showBtn><md-translate key=translate_key shortcode=\"\'checkboxes_list.import_from_csv\'\"></md-translate></md-button><md-button ng-disabled=\"!checkbox_list.virtual_repeat.selected.length || allDisabled || checkbox_list.preventMultiClicks\" class=md-primary ng-click=checkbox_list.reset_all()><md-translate key=translate_key shortcode=\"\'checkboxes_list.clear_all\'\"></md-translate></md-button><md-button ng-disabled=\"checkbox_list.virtual_repeat.selected &amp;&amp; checkbox_list.virtual_repeat.selected.length === (checkbox_list.virtual_repeat.items.length || 0) || allDisabled || checkbox_list.preventMultiClicks\" class=md-primary ng-click=checkbox_list.choose_all()><md-translate key=translate_key shortcode=\"\'checkboxes_list.check_all\'\"></md-translate></md-button></div></div></div>");
$templateCache.put("app/components/shared/date_period/date_period.html","<span ng-if=$ctrl.isGtXs><md-button ng-repeat=\"item in $ctrl.periods\" ng-click=$ctrl.choosePeriod(item) class=btn-set-params ng-class=\"{\'active\': $ctrl.activeDatePeriod.type === item.type}\" ng-disabled=\"$ctrl.activeDatePeriod.type === item.type\"><span md-translate key=::$ctrl.translateKey shortcode=::item.shortcode shortcode-id={{::item.shortcode}}></span></md-button></span><span ng-if=!$ctrl.isGtXs><md-select md-select-label-translate name=period class=date-period-select ng-model=$ctrl.activeDatePeriod ng-change=$ctrl.choosePeriod()><md-option ng-value=item ng-repeat=\"item in $ctrl.periods\"><span md-translate key=::$ctrl.translateKey shortcode=::item.shortcode shortcode-id={{::item.shortcode}}></span></md-option></md-select></span><div class=set-custom-date><daterange-picker start=$ctrl.daterangeStart end=$ctrl.daterangeEnd start-max=$ctrl.daterangeEnd end-min=$ctrl.daterangeStart format=ll callback=$ctrl.customReportPeriod max-range=$ctrl.datepickerRangePeriod></daterange-picker></div>");
$templateCache.put("app/components/shared/header/header.html","<div ng-style=\"{background: header.getHeaderColor()}\" class=site-header><div layout=row layout-align=\"space-between center\" class=container><div flex-gt-sm=40 class=left-nav><md-button hide-gt-sm class=\"mobile-sidebar-button md-icon-button small-icon-btn\" ng-click=header.mdSidenav.toggle() ng-class=\"{\'sidenav-is-open\': header.mdSidenav.isOpen()}\" style=\"z-index: 62\"><div class=stroke-wrapper><span></span><span></span><span></span></div></md-button><merchant-toggle ng-if=header.isGtSm></merchant-toggle></div><div flex-gt-sm=20 layout=row layout-align=\"center center\" class=header-logo><a flex=none layout=row layout-align=\"center center\" class=logo-holder ui-sref={{header.getUserNamespace()}}><img flex load-logo-controll ng-src={{header.getLogoUrl()}} logo-type={{::header.logo_type}} alt=\"logo mini\"></a></div><div flex-gt-sm=40 layout=row layout-align=\"end center\" class=right-nav><div hide show-gt-sm ng-if=\"!header.isAdmin() &amp;&amp; header.balancePermitted\" class=header-balance-wrap><balance placed=header watch-merchant=true></balance></div><div hide show-gt-sm ng-bind=header.getUserEmail() class=user-name></div><language-toggle hide show-gt-sm aria-label=\"language toggler\"></language-toggle><information-plate show-for=affiliate></information-plate><span hide show-gt-sm ng-if=header.isAdmin()><md-button has-permission permission permission-only=\"\'api2.admin.profilecontroller.edit\'\" class=\"md-icon-button small-icon-btn\" ui-sref=admin_settings_profile.main><i class=\"icon icon-settings\"></i></md-button></span><span hide show-gt-sm ng-if=!header.isAdmin()><md-button has-permission permission permission-only=\"\'api2.affiliate.settingscontroller.show\'\" class=\"md-icon-button small-icon-btn\" ui-sref=affiliate_settings_profile.main><i class=\"icon icon-settings\"></i></md-button></span><md-button hide show-gt-sm class=\"md-icon-button small-icon-btn\" aria-label=logout ui-sref=logout><i class=\"icon icon-logout\"></i></md-button><md-button hide-gt-sm class=\"mobile-menu-button md-icon-button small-icon-btn\" ng-click=header.toggleProfileMenu()><i class=\"fa fa-user\"></i></md-button></div></div><linear-preloader header-color=header.getHeaderColor()></linear-preloader></div>");
$templateCache.put("app/components/shared/header/profile_menu.html","<md-bottom-sheet class=\"md-grid profile-sheet-menu\" layout=column><div layout=row layout-align=\"center center\" class=profile-row-top><div ng-bind=header.getUserEmail() class=user-name></div><div ng-if=\"!header.isAdmin() &amp;&amp; header.balancePermitted\" class=header-balance-wrap><balance placed=header watch-merchant=true></balance></div></div><md-divider></md-divider><div layout=row layout-align=\"space-between center\" class=profile-row-bottom><div flex=33 layout=row layout-align=\"start center\" class=\"col col-1 language-toggler-wrap\"><i flex=none class=\"fa fa-globe\"></i><language-toggle flex aria-label=\"language toggler\"></language-toggle></div><div flex=33 aria-label=\"profile settings\" class=\"col col-2\"><span ng-if=header.isAdmin()><md-button has-permission permission permission-only=\"\'api2.admin.profilecontroller.edit\'\" class=\"md-icon-button small-icon-btn\" ui-sref=admin_settings_profile.main><i class=\"fa fa-cog\"></i></md-button></span><span ng-if=!header.isAdmin()><md-button has-permission permission permission-only=\"\'api2.affiliate.settingscontroller.show\'\" class=\"md-icon-button small-icon-btn\" ui-sref=affiliate_settings_profile.main><i class=\"fa fa-cog\"></i></md-button></span></div><div flex=33 aria-label=logout class=\"col col-3\"><md-button class=\"md-icon-button small-icon-btn\" aria-label=logout ui-sref=logout><i class=\"fa fa-sign-out\"></i></md-button></div></div></md-bottom-sheet>");
$templateCache.put("app/components/shared/input_file_area/input_file_area.html","<md-input-container class=md-block><div class=label-top><md-translate key=::fileCtrl.options.translate_key shortcode=::fileCtrl.options.shortcodes.label></md-translate></div><div layout=row layout-align=\"center center\" class=bunner-upload-wrap><input input-errors name={{::fileCtrl.options.input_name}} type=file ng-model=ngModel accept={{::fileCtrl.options.accept}} ng-required=isRequired><div ng-if=!ngModel class=no-file><i class=\"fa fa-cloud-download\"></i><div class=ligth-color><md-translate key=::fileCtrl.options.translate_key shortcode=::fileCtrl.options.shortcodes.drop_file_here></md-translate></div></div><span ng-if=ngModel class=md-text><div><span class=file-name ng-bind=ngModel.name></span><span>(<span class=file-size ng-bind=\"ngModel.size/1024/1024 | number:2\"></span>MB)</span><span class=delete-file><md-button aria-label=\"remove file\" class=md-icon-button ng-click=fileCtrl.clear()><i class=\"fa fa-trash-o\"></i></md-button></span></div><div ng-if=fileCtrl.options.shortcodes.resolution_file class=\"file-resolution ligth-color\"><md-translate key=::fileCtrl.options.translate_key shortcode=::fileCtrl.options.shortcodes.resolution_file translate-values=\"{width: fileCtrl.resolutions.width, height: fileCtrl.resolutions.height}\"></md-translate></div></span></div><span class=errors-reserve></span><md-error-messages errors=errors input-name={{fileCtrl.options.input_name}}></md-error-messages></md-input-container>");
$templateCache.put("app/components/shared/language_toggle/language_toggle.html","<div ng-class=\"{\'fixed-toggle\': $ctrl.fixed}\" class=language-wrap><md-menu md-offset=\"0 0\" md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=\"$ctrl.openMenu($mdMenu, $event)\"><div class=current-language><md-translate key=\"\'Languages\'\" shortcode=\"\'language.\' + $ctrl.currentLocale\" watch-shortcode=true translate-default={{$ctrl.currentLocale}}></md-translate></div></md-button><md-menu-content width=2 class=custom-menu-content><div ng-if=$ctrl.showSearchInput() class=languages-list-search><md-input-container class=md-block><md-icon><i class=\"fa fa-search\"></i></md-icon><input type=text ng-model=$ctrl.query></md-input-container></div><div ng-if=$ctrl.showList class=languages-list><md-menu-item class=language-key-wrap ng-repeat=\"(key, value) in $ctrl.getLanguages()\" ng-if=\"key !== $ctrl.currentLocale\" ng-click=\"$ctrl.changeLanguage(key, value)\"><md-button class=language-key><span md-menu-align-target class=menu-item-locale><md-translate key=\"\'Languages\'\" shortcode=\"::\'language.\' + key\" translate-default={{::key}}></md-translate></span></md-button></md-menu-item></div></md-menu-content></md-menu></div>");
$templateCache.put("app/components/shared/merchant_toggle/merchant_toggle.html","<md-menu class=merchant-toggle md-position-mode=\"target-left target\"><md-button ng-click=\"$ctrl.openList($mdMenu, $event)\" class=md-icon-button><span class=font-bold ng-bind=$ctrl.currentMerchant.value></span><i class=\"fa fa-angle-down\"></i></md-button><md-menu-content class=merchant-toggle-list><md-menu-item class=merchant-toggle-list-item ng-repeat=\"merchant in $ctrl.merchantList\" ng-class=\"{\'merchant-toggle-list-selected\': $ctrl.isSelected(merchant.id)}\"><md-button ng-click=$ctrl.chooseMerchant(merchant)><span ng-bind=merchant.value></span></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/components/shared/navigation/item_label.html","<span class=icon-label><i class={{::item.icon}} aria-hidden=true></i></span><span flex md-translate class=item-btn-label key=::translateKey shortcode=::item.shortcode translate-default=\"{{::getTranslateDefault({item: item})}}\"></span><span ng-if=::item.states.length class=icon-indicator><i class=\"fa fa-angle-right\" aria-hidden=true></i></span>");
$templateCache.put("app/components/shared/navigation/navigation.html","<div class=navigation-list><!--Dashboard admin & affiliate--><item-label class=\"list-item-btn list-item-heading\" item=$ctrl.dashboard translate-key=::$ctrl.translate_key get-translate-default=::$ctrl.getTranslateDefault(item) ng-click=$ctrl.goToDashboard() ng-class=\"{active: $ctrl.isActiveDashboard()}\" layout=row layout-align=\"space-between center\" md-ink-ripple=true></item-label><!--Affiliate Guide (top-level, affiliate only)--><item-label has-permission permission permission-only=::$ctrl.affiliateGuide.permission ng-if=$ctrl.affiliateGuide class=\"list-item-btn list-item-heading\" item=$ctrl.affiliateGuide translate-key=::$ctrl.translate_key get-translate-default=::$ctrl.getTranslateDefault(item) ng-click=$ctrl.goToAffiliateGuide() ng-class=\"{active: $ctrl.isActiveAffiliateGuide()}\" layout=row layout-align=\"space-between center\" md-ink-ripple=true></item-label><!--Collapsable menu--><accordion duration=325><accordion-group ng-repeat=\"item in $ctrl.menu\" class=list-item open-item=item.open layout=column><accordion-group-heading><item-label class=\"list-item-btn list-item-heading\" item=::item translate-key=::$ctrl.translate_key get-translate-default=::$ctrl.getTranslateDefault(item) layout=row layout-align=\"space-between center\" md-ink-ripple=true ng-click=$ctrl.toggle(item)></item-label></accordion-group-heading><accordion-group-content layout=column><a flex has-permission permission permission-only=::subItem.permission class=\"list-item-btn link-label\" ng-repeat=\"subItem in item.states\" layout=row layout-align=\"space-between center\" md-ink-ripple=true ui-sref={{::subItem.state}} ng-class=\"{\'active\': subItem.active}\"><md-translate key=::$ctrl.translate_key shortcode=::subItem.shortcode translate-default={{::$ctrl.getTranslateDefault(subItem)}}></md-translate><span class=link-label-data ng-if=::subItem.budge ng-bind=subItem.budge.data></span></a></accordion-group-content></accordion-group></accordion></div>");
$templateCache.put("app/components/shared/output_errors/messages.html","<div ng-if=form><div ng-messages=form[inputName].$error><div ng-message=required translate-namespace=common.errors.form><md-translate key=\"\'OutputErrors\'\" shortcode=\"\'errors.required\'\"></md-translate></div><div ng-message={{errorKey}} ng-repeat=\"(errorKey, errorValue) in errors.errors\"><div ng-repeat=\"value in errorValue track by $index\"><translate>{{value}}</translate></div><span ng-if=variables ng-bind=variables_list()></span></div></div></div>");
$templateCache.put("app/components/shared/powered_by_q/powered_by_q.html","<div class=powered-by-q>Powered by <i class=\"fa fa-quora\" aria-hidden=true></i></div>");
$templateCache.put("app/components/shared/select_with_search/select_with_search.html","<md-select input-errors md-no-asterisk md-select-label-translate name={{::name}} ng-model=ngModel md-on-close=select.clearSearchTerm() md-container-class={{::select.mdContainerClass}} ng-change=select.ngChange() ng-class=ngClass ng-disabled=ngDisabled ng-required=ngRequired autocomplete=off><md-select-header layout=row layout-align=\"start center\" class=search-select-header ng-if=\"select.getLength() &gt; 5\"><md-input-container flex md-no-float class=md-block><md-icon><i class=\"fa fa-search\"></i></md-icon><input stop-event event-name=keydown type=text placeholder=\"{{\'search_placeholder\' | mdTranslate: select.translate_key}}\" ng-model=select.search_term autocomplete=off><md-button ng-if=select.search_term class=md-icon-button ng-click=select.clearSearchTerm()><img src=assets/images/cross.png></md-button></md-input-container></md-select-header><md-option ng-value=\"saveProp ? value[saveProp] : (setKeyAsValue ? key : value)\" ng-repeat=\"(key, value) in list | search: select.search_term:select.options as filtered_list\"><md-option-content options=select.options></md-option-content></md-option><div ng-if=select.noMatches() class=no-matches><md-translate key=::select.translate_key shortcode=\"\'no_matches\'\" translate-values=\"{search_term: select.search_term}\"></md-translate></div><div ng-if=!select.getLength() class=no-data><md-translate key=::select.translate_key shortcode=\"\'no_data\'\"></md-translate></div></md-select><span class=errors-reserve></span><md-error-messages errors=errors input-name={{::name}}></md-error-messages>");
$templateCache.put("app/components/shared/upload_file/upload_file.html","<md-dialog class=\"custom-dialog dialog-content upload-wrap\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=uploadCtrl.translate_key shortcode=\"\'upload_file.title\'\" translate-default=\"{{::uploadCtrl.getTranslateDefault(\'upload_file.title\')}}\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><form name=uploadCtrl.uploadForm><div class=file-uploader-wrap><div nv-file-drop uploader=uploadCtrl.uploader class=file-drop-area><div nv-file-over uploader=uploadCtrl.uploader over-class=file-is-over class=\"file-drop-zone mb-none\" layout=row layout-align=\"center center\"><div ng-if=!uploadCtrl.uploader.queue.length class=no-file><i class=\"fa fa-cloud-download\"></i><div><span ng-bind=uploadCtrl.input_placeholder></span></div><input multiple nv-file-select type=file name=file uploader=uploadCtrl.uploader accept={{uploadCtrl.accept_formats}} class=upload-input></div><div ng-if=uploadCtrl.uploader.queue.length class=files-wrap><div ng-repeat=\"item in uploadCtrl.uploader.queue\" class=file-list-item><span ng-bind=item.file.name class=file-name></span><span class=file-size>(<span ng-bind=\"item.file.size/1024/1024 | number:2\"></span>MB)</span><span class=delete-file><md-button aria-label=\"remove file\" class=md-icon-button ng-click=uploadCtrl.remove_file(item)><i class=\"fa fa-trash-o\"></i></md-button></span></div></div></div></div></div><md-input-container class=\"md-block mg-none input-hidden\"><input input-errors type=text name=file ng-model=uploadCtrl.file><md-error-messages errors=uploadCtrl.errors input-name=file></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=uploadCtrl.cancel()><md-translate key=uploadCtrl.translate_key shortcode=\"\'upload_file.cancel\'\" translate-default=\"{{::uploadCtrl.getTranslateDefault(\'upload_file.cancel\')}}\"></md-translate></md-button><md-button class=md-primary md-click=uploadCtrl.upload() ng-disabled=!uploadCtrl.uploader.queue.length><md-translate key=uploadCtrl.translate_key shortcode=\"\'upload_file.upload\'\" translate-default=\"{{::uploadCtrl.getTranslateDefault(\'upload_file.upload\')}}\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/table/partials/checkbox_template.html","<checkbox-list list=$ctrl.currentData[$ctrl.currentColumn.name] field-name=value callback=$ctrl.checkboxCallback class=no-border all-disabled=$ctrl.allDisabled value-translate-namespace=$ctrl.currentColumn.checkbox_namespace locales=$ctrl.currentColumn.locales disable-search=$ctrl.currentColumn.disable_search></checkbox-list>");
$templateCache.put("app/components/table/partials/compare.html","<div class=compare-wrap><!--First condition--><div class=compare-condition-wrap><div layout=row><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.condition_selector\'\"></md-translate></label><md-select md-select-label-translate ng-model=CompareCtrl.columnData.first_condition.first.mark ng-change=CompareCtrl.compareCallback() ng-disabled=CompareCtrl.allDisabled><md-option ng-value=item.mark ng-repeat=\"item in CompareCtrl.compareConditions\"><span md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare\' + item.label\"></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.compare_value\'\"></md-translate></label><input type=number ng-model=CompareCtrl.columnData.first_condition.first.value ng-model-options=\"{debounce: 300}\" ng-change=CompareCtrl.compareCallback() ng-disabled=CompareCtrl.allDisabled></md-input-container></div><div flex=none class=btn-clear-wrap><md-button class=\"md-icon-button clear-row-btn\" ng-disabled=CompareCtrl.allDisabled ng-click=CompareCtrl.clearConditionPart(CompareCtrl.columnData.first_condition.first) ng-if=CompareCtrl.showClearCompareBtn(CompareCtrl.columnData.first_condition.first)><img src=assets/images/cross.png></md-button></div></div><div layout=row><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.condition_selector\'\"></md-translate></label><md-select md-select-label-translate ng-model=CompareCtrl.columnData.first_condition.second.mark ng-change=CompareCtrl.compareCallback() ng-disabled=CompareCtrl.allDisabled><md-option ng-value=item.mark ng-repeat=\"item in CompareCtrl.compareConditions\"><span md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare\' + item.label\"></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.compare_value\'\"></md-translate></label><input type=number ng-model=CompareCtrl.columnData.first_condition.second.value ng-model-options=\"{debounce: 300}\" ng-change=CompareCtrl.compareCallback() ng-disabled=CompareCtrl.allDisabled></md-input-container></div><div flex=none class=btn-clear-wrap><md-button class=\"md-icon-button clear-row-btn\" ng-disabled=CompareCtrl.allDisabled ng-click=CompareCtrl.clearConditionPart(CompareCtrl.columnData.first_condition.second) ng-if=CompareCtrl.showClearCompareBtn(CompareCtrl.columnData.first_condition.second)><img src=assets/images/cross.png></md-button></div></div></div><!--Compare separator--><div layout=row ng-if=CompareCtrl.columnData.second_condition class=compare-separator><md-radio-group ng-model=CompareCtrl.columnData.compare_separator class=md-primary ng-change=CompareCtrl.compareCallback()><md-radio-button ng-repeat=\"item in CompareCtrl.compareSeparators\" ng-value=item.mark ng-disabled=CompareCtrl.allDisabled><span md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare\' + item.label\"></span></md-radio-button></md-radio-group></div><!--Second condition--><div ng-if=CompareCtrl.columnData.second_condition class=compare-condition-wrap><div layout=row><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.condition_selector\'\"></md-translate></label><md-select md-select-label-translate ng-model=CompareCtrl.columnData.second_condition.first.mark ng-change=CompareCtrl.compareCallback() ng-disabled=CompareCtrl.allDisabled><md-option ng-value=item.mark ng-repeat=\"item in CompareCtrl.compareConditions\"><span md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare\' + item.label\"></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.compare_value\'\"></md-translate></label><input type=number ng-model=CompareCtrl.columnData.second_condition.first.value ng-model-options=\"{debounce: 300}\" ng-change=CompareCtrl.compareCallback() ng-disabled=CompareCtrl.allDisabled></md-input-container></div><div flex=none class=btn-clear-wrap><md-button class=\"md-icon-button clear-row-btn\" ng-disabled=CompareCtrl.allDisabled ng-click=CompareCtrl.clearConditionPart(CompareCtrl.columnData.second_condition.first) ng-if=CompareCtrl.showClearCompareBtn(CompareCtrl.columnData.second_condition.first)><img src=assets/images/cross.png></md-button></div></div><div layout=row><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.condition_selector\'\"></md-translate></label><md-select md-select-label-translate ng-model=CompareCtrl.columnData.second_condition.second.mark ng-change=CompareCtrl.compareCallback() ng-disabled=CompareCtrl.allDisabled><md-option ng-value=item.mark ng-repeat=\"item in CompareCtrl.compareConditions\"><span md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare\' + item.label\"></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.compare_value\'\"></md-translate></label><input type=number ng-model=CompareCtrl.columnData.second_condition.second.value ng-model-options=\"{debounce: 300}\" ng-change=CompareCtrl.compareCallback() ng-disabled=CompareCtrl.allDisabled></md-input-container></div><div flex=none class=btn-clear-wrap><md-button class=\"md-icon-button clear-row-btn\" ng-disabled=CompareCtrl.allDisabled ng-click=CompareCtrl.clearConditionPart(CompareCtrl.columnData.second_condition.second) ng-if=CompareCtrl.showClearCompareBtn(CompareCtrl.columnData.second_condition.second)><img src=assets/images/cross.png></md-button></div></div></div><!--Buttons--><div layout=row><md-button ng-click=CompareCtrl.addSecondCondition() class=\"btn-set-params btn-light\" ng-if=!CompareCtrl.columnData.second_condition ng-disabled=CompareCtrl.allDisabled><i class=\"fa fa-plus\"></i><span md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.add_condition\'\"></span></md-button><md-button ng-click=CompareCtrl.removeSecondCondition() class=\"btn-set-params btn-light\" ng-if=CompareCtrl.columnData.second_condition ng-disabled=CompareCtrl.allDisabled><i class=\"fa fa-minus\"></i><span md-translate key=::CompareCtrl.translateKey shortcode=\"\'compare.remove_condition\'\"></span></md-button></div></div>");
$templateCache.put("app/components/table/partials/compare_template.html","<table-filter-compare column-data=$ctrl.currentData[$ctrl.currentColumn.name] save-callback=$ctrl.compareCallback() translate-key=$ctrl.compareTranslateKey all-disabled=$ctrl.allDisabled clear-btn=$ctrl.clearBtn></table-filter-compare>");
$templateCache.put("app/components/table/partials/date_template.html","<div class=\"set-custom-date stats-date\"><daterange-picker start=$ctrl.currentData[$ctrl.currentColumn.name].start end=$ctrl.currentData[$ctrl.currentColumn.name].end start-max=$ctrl.currentData[$ctrl.currentColumn.name].end end-min=$ctrl.currentData[$ctrl.currentColumn.name].start format=ll callback=$ctrl.dateCallback all-disabled=$ctrl.allDisabled clear-btn=true></daterange-picker></div>");
$templateCache.put("app/components/table/partials/filter_dialog.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=FilterCtrl.translate_key shortcode=\"\'main_table.filter.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=table-filters-list><div class=templates-list><md-button ng-repeat=\"item in FilterCtrl.filtersList\" ng-click=FilterCtrl.selectFilter(item) class=\"btn-set-params table-filter-button\" ng-class=\"{\'current\': item === FilterCtrl.currentFilterId, \'is-activated\': FilterCtrl.isActivatedFilter(item)}\"><div layout-wrap layout=row layout-align=\"center center\"><span flex=none class=active-filter-set-icon><i class=\"fa fa-check\"></i></span><span flex md-translate key=::FilterCtrl.translate_key shortcode=\"\'main_table.filter.no_name\'\" watch-shortcode=true translate-values=\"{id: item}\"></span></div></md-button><md-button ng-click=FilterCtrl.addNewFilter() class=\"btn-set-params btn-light\"><i class=\"fa fa-plus\"></i><md-translate key=::FilterCtrl.translate_key shortcode=\"\'main_table.filter.add_new_filter\'\"></md-translate></md-button></div></div><table-filter columns=FilterCtrl.table.config.filter.columns get-data-function=FilterCtrl.getColumnData(columnName) save-data-function=FilterCtrl.saveColumnData(data) columns-namespace=FilterCtrl.table.config.columns_namespace></table-filter></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=FilterCtrl.cancelFilter()><md-translate key=FilterCtrl.translate_key shortcode=\"\'main_table.filter.cancel_filter\'\"></md-translate></md-button><md-button class=md-primary ng-click=FilterCtrl.applyFilter()><md-translate key=FilterCtrl.translate_key shortcode=\"\'main_table.filter.apply_filter\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/table/partials/filter_temp_mobile.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><translate>{{$ctrl.columnsNamespace + $ctrl.currentColumn.name}}</translate></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=$ctrl.closeMobilePopup()></md-button></span></div><md-dialog-content class=md-dialog-content><div flex class=filter-columns-tab-content><div ng-include=$ctrl.typeTemplateUrl></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/table/partials/filter_template.html","<div layout-wrap layout=row class=table-filter-holder><div flex=none class=filter-columns-tab-wrap><div class=column-tabs-list><div ng-repeat=\"column in $ctrl.columns\" ng-if=column.display class=column-tab-item><md-button layout=row class=filter-column ng-click=\"$ctrl.chooseColumn(column, $event)\" ng-class=\"{\'current\': $ctrl.currentColumn.name === column.name}\"><span class=not-empty ng-if=!column.empty></span><span flex class=column-name><translate>{{$ctrl.columnsNamespace + column.name}}</translate></span><span flex=none class=btn-clear ng-click=\"$ctrl.clearData(column, $event)\" ng-if=!column.empty><img src=assets/images/cross.png></span></md-button></div></div></div><div flex class=filter-columns-tab-content ng-if=!$ctrl.isXs><div layout=column layout-align=\"center center\" class=column-preloader ng-show=$ctrl.preloader><md-progress-circular md-diameter=30px></md-progress-circular></div><div ng-include=$ctrl.typeTemplateUrl></div></div></div>");
$templateCache.put("app/components/table/partials/no_data.html","<div class=no-table-data><div class=\"font-medium no-data-title\"><md-translate key=\"\'MainTable\'\" shortcode=\"\'main_table.no_data\'\"></md-translate></div><div class=no-data-holder><i class=\"fa fa-database\" aria-hidden=true></i><i class=\"fa fa fa-ban\" aria-hidden=true></i></div></div>");
$templateCache.put("app/components/table/partials/table_actions.html","<div ng-if=::table.config.column_checkboxes.enable class=checkbox-wrap><md-checkbox class=\"md-primary primary-checkbox\" ng-checked=table.isCheckedAll() ng-click=table.tpggleAll()></md-checkbox><md-menu md-position-mode=\"target-left target\" class=checkbox-actions-menu ng-if=table.checkAvailableActions()><md-button class=md-icon-button ng-click=$mdMenu.open($event) ng-class=\"{\'selected\': table.isChoosedAnyItem()}\"><i class=\"fa fa-ellipsis-v\"></i></md-button><md-menu-content width=\"{{::table.config.column_checkboxes.menu_width || 4}}\"><md-menu-item class=actions-for-checked ng-repeat=\"item in table.config.column_checkboxes.actions\" ng-if=table.displayAction(item) ng-click=table.applyAction(item)><md-button><md-translate md-menu-align-target key=::item.locales.translate_key shortcode=::item.locales.shortcode></md-translate></md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/components/table/partials/table_list.html","<table-list-mobile table=table on-rendered=onRendered() ng-if=!isGtXs></table-list-mobile><table-list-desktop table=table on-rendered=onRendered() ng-if=isGtXs></table-list-desktop>");
$templateCache.put("app/components/table/partials/table_list_desktop.html","<div class=table-list-wrap><div class=duplicate-list-header><div class=table-list-head-row><div render-list-item class=table-list-head-cell ng-if=::table.config.column_checkboxes.enable><table-actions table=table></table-actions></div><div render-list-item ng-repeat=\"column in table.columns\" data-cell-type={{::column.column_type}} class=table-list-head-cell><span class=column-name></span><span ng-if=::column.sort class=icons-wrap ng-click=table.sort(column) ng-class=\"{\'desc\': table.config.params.data.order[column.name] === \'desc\', \'asc\': table.config.params.data.order[column.name] === \'asc\'}\"><i class=\"fa fa-long-arrow-down\"></i><i class=\"fa fa-long-arrow-up\"></i></span></div><div ng-if=::table.config.buttons class=table-list-head-cell></div></div></div><div class=table-list-holder><div class=table-list><div class=table-list-head><div class=table-list-head-row><div render-list-item ng-if=::table.config.column_checkboxes.enable class=table-list-head-cell><md-checkbox class=\"md-primary primary-checkbox\"></md-checkbox></div><div ng-repeat=\"column in table.columns\" data-cell-type={{::column.column_type}} class=table-list-head-cell><translate translate-default={{::column.name}}>{{table.config.columns_namespace + column.name}}</translate><span ng-if=::column.sort class=icons-wrap><i class=\"fa fa-long-arrow-down\"></i><i class=\"fa fa-long-arrow-up\"></i></span></div><div ng-if=::table.config.buttons class=table-list-head-cell></div></div></div><div class=table-list-body><div render-list-item ng-repeat=\"item in table.list\" ng-class=\"table.config.rowClass ? table.config.rowClass(item) : \'\'\" class=table-list-body-row><div ng-if=::table.config.column_checkboxes.enable class=table-list-body-cell><md-checkbox class=\"md-primary primary-checkbox\" ng-checked=table.isCheckedItem(item) ng-click=table.toggleItem(item)></md-checkbox></div><div ng-repeat=\"column in table.columns\" data-cell-type={{::column.column_type}} class=table-list-body-cell><table-list-cell item=::item column=::column data-copy=\"{{::column.copy || false}}\" data-clipboard-text=\"{{::column.copy ? item[column.name] : \'\'}}\"></table-list-cell></div><div ng-if=::table.config.buttons ng-include=table.config.buttons.url onload=tableList.load_buttons() class=\"table-list-body-cell actions-box\"></div></div><div ng-if=\"table.config.total &amp;&amp; table.list.length &gt; 0 &amp;&amp; table.isRendered()\" class=\"table-list-body-row total-row\"><div class=table-list-body-cell><md-translate key=::table.config.total.translate_key shortcode=::table.config.total.shortcode></md-translate></div><div ng-repeat=\"column in table.config.total.data.columns\" data-cell-type={{::column.column_type}} class=table-list-body-cell><span ng-bind=\"::table.config.total.data.total_columns[column.name] | number | numberSeparate\"></span></div></div></div></div></div></div><no-table-data ng-if=\"table.list.length === 0 &amp;&amp; table.isRendered()\"></no-table-data>");
$templateCache.put("app/components/table/partials/table_list_mobile.html","<div class=table-list-mobile-wrap><!--Main nav table row--><div class=table-mobile-head><div layout=row layout-align=\"space-between center\" ng-class=\"{\'all-collapsed\': table.config.mobile.collapseAll}\" class=\"table-mobile-body-item-row item-head-row\"><div layout=row class=actions-box><div class=action-item><table-actions table=table></table-actions></div><div ng-if=table.isSortAvailable class=action-item><table-mobile-sort table=table></table-mobile-sort></div><div ng-if=\"table.isFilterEnabled() || table.isMatchAvailable\" class=action-item><table-list-search table=table></table-list-search></div><div class=action-item><table-mobile-default-columns-list table=table></table-mobile-default-columns-list></div></div><div class=\"actions-box collapse-btn\"><md-button class=md-icon-button ng-hide=\"table.list.length === 0 &amp;&amp; table.isRendered()\" ng-click=table.toggleAll()><i class=\"fa fa-chevron-up\"></i></md-button></div></div></div><accordion class=table-mobile-body one-opened=false collapse-all=table.config.mobile.collapseAll><!--Block rows--><accordion-group ng-repeat=\"item in table.list\" class=table-mobile-body-item ng-class=\"table.config.rowClass ? table.config.rowClass(item) : \'\'\" default-open=::!table.config.mobile.collapseAll on-toggle-start=\"tableList.changeHeadingHeight(isOpen, getRefElement)\"><!--Heading row with buttons--><accordion-group-heading class=\"table-mobile-body-item-row item-head-row item-nav-row\" layout=row layout-align=\"space-between start\"><div layout=row layout-align=\"start center\" class=\"actions-box info-when-opened\"><span ng-if=::table.config.column_checkboxes.enable class=checkbox-wrap><md-checkbox class=\"md-primary primary-checkbox\" ng-checked=table.isCheckedItem(item) ng-click=table.toggleItem(item)></md-checkbox></span><span ng-if=::table.config.buttons class=outer-buttons-wrap ng-include=table.config.buttons.url onload=tableList.load_buttons()></span></div><div layout=column layout-align=\"start stretch\" class=\"actions-box info-when-collapsed\"><table-mobile-content-row flex ng-repeat=\"column in table.columnsShowedWhenCollapsed\" item=::item column=::column namespace=::table.config.columns_namespace layout=row></table-mobile-content-row></div><div class=actions-box><accordion-group-button class=collapse-btn><i class=\"fa fa-chevron-up\"></i></accordion-group-button></div></accordion-group-heading><!--Content rows--><accordion-group-content layout=column><table-mobile-content-row flex class=table-mobile-body-item-row ng-repeat=\"column in table.columns\" data-cell-type={{::column.column_type}} item=::item column=::column namespace=::table.config.columns_namespace layout=row></table-mobile-content-row></accordion-group-content></accordion-group><!--Total row for reports--><accordion-group class=\"table-mobile-body-item total-row\" default-open=::!table.config.mobile.collapseAll ng-if=\"table.config.total &amp;&amp; table.list.length &gt; 0 &amp;&amp; table.isRendered()\"><accordion-group-heading class=\"table-mobile-body-item-row item-head-row item-nav-row\" layout=row layout-align=\"space-between center\"><div layout=row layout-align=\"start center\" class=\"actions-box total-heading\"><md-translate key=::table.config.total.translate_key shortcode=::table.config.total.shortcode></md-translate></div><div class=actions-box><accordion-group-button class=collapse-btn><i class=\"fa fa-chevron-up\"></i></accordion-group-button></div></accordion-group-heading><accordion-group-content layout=column><table-mobile-content-row flex class=table-mobile-body-item-row ng-repeat=\"column in table.config.total.data.columns\" data-cell-type={{::column.column_type}} item=::table.config.total.data.total_columns column=::column namespace=::table.config.columns_namespace layout=row></table-mobile-content-row></accordion-group-content></accordion-group></accordion></div><no-table-data ng-if=\"table.list.length === 0 &amp;&amp; table.isRendered()\"></no-table-data>");
$templateCache.put("app/components/table/partials/table_list_pagination.html","<div ng-if=\"table.config.params.total_pages &gt; 1\" layout-xs=row layout-align-xs=\"space-between center\" class=pagination-list><md-input-container class=page-input><input type=number ng-change=paginationCtrl.set_page() ng-model=table.config.params.data.page ng-model-options=\"{debounce: 500}\" min=1 max={{table.config.params.total_pages}} ng-readonly=paginationCtrl.disabled></md-input-container><span class=count-box><span ng-bind=table.config.params.start_row_num></span><span>&ndash;</span><span ng-bind=table.config.params.end_row_num></span><span>&ensp;<md-translate key=\"\'MainTable\'\" shortcode=\"\'main_table.pagination.from\'\"></md-translate>&ensp;</span><span ng-bind=table.config.params.total_entries class=all></span></span><md-button class=\"md-icon-button prev-btn\" ng-click=paginationCtrl.prev() ng-disabled=\"table.config.params.data.page === 1 || paginationCtrl.disabled\"><i class=\"fa fa-chevron-left\"></i></md-button><md-button class=\"md-icon-button next-btn\" ng-click=paginationCtrl.next() ng-disabled=\"table.config.params.data.page &gt;= table.config.params.total_pages || paginationCtrl.disabled\"><i class=\"fa fa-chevron-right\"></i></md-button><md-button class=\"md-icon-button scroll-to-top-btn\" data-purpose=back-to-top ng-click=paginationCtrl.scrollTop()><i class=\"fa fa-chevron-up\"></i></md-button></div>");
$templateCache.put("app/components/table/partials/table_list_search.html","<div layout=row ng-class=\"{\'with-filter\': table.isFilterEnabled()}\" class=table-header-search-wrap><md-input-container md-no-float ng-if=\"isGtXs &amp;&amp; table.isMatchAvailable\" class=\"md-icon-left md-block table-search-wrap\"><md-icon><i class=\"fa fa-search\"></i></md-icon><input type=text class=table-search-input ng-model=table.config.params.data.search.keyword ng-model-options=\"{debounce: 500}\" placeholder=\"{{\'main_table.search.placeholder\' | mdTranslate: \'MainTable\'}}\" ng-change=table.search()><span ng-if=table.config.params.data.search.keyword ng-click=searchCtrl.clear() class=\"clear-search cross-icon\"><img src=assets/images/cross.png></span></md-input-container><md-menu ng-if=\"!isGtXs &amp;&amp; table.isMatchAvailable\"><md-button ng-click=$mdMenu.open($event) class=md-icon-button ng-class=\"{\'active\': table.config.params.data.search.keyword !== \'\'}\"><i class=\"fa fa-search\"></i></md-button><md-menu-content width=6><md-menu-item md-prevent-menu-close=md-prevent-menu-close class=mobile-table-search><div class=search-icon><i class=\"fa fa-search\"></i></div><input md-autofocus ng-keydown=$event.stopPropagation() type=text class=table-search-input ng-model=table.config.params.data.search.keyword ng-model-options=\"{debounce: 500}\" placeholder=\"{{\'main_table.search.placeholder\' | mdTranslate: \'MainTable\'}}\" ng-change=table.search()><button md-prevent-menu-close=md-prevent-menu-close ng-click=\"searchCtrl.clearMobile($event, $mdMenu)\" class=cancel-search-icon><i class=\"fa fa-times\"></i></button></md-menu-item></md-menu-content></md-menu><div flex=auto class=table-filter-btn ng-if=\"table.isFilterEnabled() &amp;&amp; table.isRendered()\"><md-button class=md-icon-button ng-click=table.openFilter($event) ng-class=\"{\'active\': table.filterIsActivated()}\"><i class=\"fa fa-filter\"></i></md-button></div></div>");
$templateCache.put("app/components/table/partials/table_mobile_content_row.html","<div flex=nogrow layout=row layout-align=\"start center\" class=\"table-mobile-body-item-col font-bold\"><translate translate-default={{::column.name}}>{{::namespace + column.name}}</translate></div><div flex=auto layout=row layout-align=\"end center\" class=table-mobile-body-item-col><table-list-cell item=::item column=::column></table-list-cell></div>");
$templateCache.put("app/components/table/partials/table_mobile_default_columns_list.html","<md-menu><md-button ng-click=$mdMenu.open($event) class=md-icon-button><i class=\"fa fa-list\"></i></md-button><md-menu-content class=table-columns-search-menu><md-menu-item md-prevent-menu-close=md-prevent-menu-close class=mobile-search-columns ng-if=\"$ctrl.table.columns.length &gt; 6\"><div class=search-icon><i class=\"fa fa-search\"></i></div><input ng-keydown=$event.stopPropagation() type=text class=table-search-input ng-model=$ctrl.searchQuery placeholder=\"{{\'main_table.search.placeholder\' | mdTranslate: \'MainTable\'}}\"><button md-prevent-menu-close=md-prevent-menu-close ng-click=$ctrl.clearSearch($event) ng-if=$ctrl.searchQuery class=cancel-search-icon><i class=\"fa fa-times\"></i></button></md-menu-item><md-menu-item md-prevent-menu-close=md-prevent-menu-close class=search-columns-no-data ng-if=\"!filteredList.length &amp;&amp; $ctrl.searchQuery\"><md-translate key=\"\'MainTable\'\" shortcode=\"\'main_table.no_data\'\"></md-translate></md-menu-item><md-menu-item md-prevent-menu-close=md-prevent-menu-close class=menu-item-column ng-click=controlDefaultColumn(column) ng-repeat=\"column in $ctrl.table.columns | search: $ctrl.searchQuery:{search_in_translate: true, translate_namespace: $ctrl.table.config.columns_namespace, prop_for_value: \'name\'} as filteredList\"><md-button md-prevent-menu-close=md-prevent-menu-close><md-checkbox class=\"md-primary primary-checkbox\" ng-checked=column.showWhenCollapsed><translate translate-default={{::column.name}}>{{::$ctrl.table.config.columns_namespace + column.name}}</translate></md-checkbox></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/components/table/partials/table_mobile_sort.html","<md-menu><md-button ng-click=$mdMenu.open($event) class=md-icon-button ng-class=\"{\'selected\': $ctrl.table.isSortActivated()}\"><i class=\"fa fa-sort\"></i></md-button><md-menu-content class=table-columns-search-menu><md-menu-item md-prevent-menu-close=md-prevent-menu-close class=mobile-search-columns ng-if=\"$ctrl.table.columns.length &gt; 6\"><div class=search-icon><i class=\"fa fa-search\"></i></div><input ng-keydown=$event.stopPropagation() type=text class=table-search-input ng-model=$ctrl.searchSortQuery placeholder=\"{{\'main_table.search.placeholder\' | mdTranslate: \'MainTable\'}}\"><button md-prevent-menu-close=md-prevent-menu-close ng-click=$ctrl.clearSortSearch($event) ng-if=$ctrl.searchSortQuery class=cancel-search-icon><i class=\"fa fa-times\"></i></button></md-menu-item><md-menu-item md-prevent-menu-close=md-prevent-menu-close class=search-columns-no-data ng-if=\"!filteredList.length &amp;&amp; $ctrl.searchSortQuery\"><md-translate key=\"\'MainTable\'\" shortcode=\"\'main_table.no_data\'\"></md-translate></md-menu-item><md-menu-item ng-if=::column.sort class=menu-item-column ng-repeat=\"column in $ctrl.table.columns | search: $ctrl.searchSortQuery:{search_in_translate: true, translate_namespace: $ctrl.table.config.columns_namespace, prop_for_value: \'name\'} as filteredList\"><md-button ng-click=\"$ctrl.sort(column, $event)\" md-prevent-menu-close=md-prevent-menu-close class=sort-mobile-icons><div layout=row layout-align=\"space-between center\"><span flex class=column-name><translate translate-default={{::column.name}}>{{::$ctrl.table.config.columns_namespace + column.name}}</translate></span><span flex=none class=sort-icons-wrap><i class=\"fa fa-sort-amount-desc\"></i><i class=\"fa fa-sort-amount-asc\"></i></span></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/components/tabs/partials/tabs_content.html","<ui-view name={{::$ctrl.viewName}} ng-if=::$ctrl.tabs.config.nav></ui-view><ng-include src=$ctrl.tabs.activeTab[$ctrl.viewName] ng-if=::!$ctrl.tabs.config.nav></ng-include>");
$templateCache.put("app/components/tabs/partials/tabs_list.html","<div ng-if=$ctrl.isGtSm class=tabs-list><div ng-repeat=\"tab in $ctrl.tabs.list\" ng-if=!tab.hide ng-class=\"{\'active\': $ctrl.tabs.activeTab.name === tab.name, \'disabled\': tab.disabled}\" ng-click=\"$ctrl.chooseTab(tab, $event)\" class=tab-list-item><md-translate key=::$ctrl.tabs.config.translateKey shortcode=::tab.shortcode></md-translate></div></div><div ng-if=!$ctrl.isGtSm class=tabs-list-mobile><md-tabs md-center-tabs={{$ctrl.centerMobileTabs}} md-stretch-tabs={{$ctrl.stretchMobileTabs}}><!--Add one empty tab to prevent changing active tab after reloading page in child states--><md-tab></md-tab><md-tab ng-repeat=\"tab in $ctrl.tabs.list\" md-active=\"$ctrl.tabs.activeTab.name === tab.name\" md-on-select=\"$ctrl.chooseTab(tab, $event)\" ng-disabled=tab.disabled ng-if=!tab.hide><md-translate key=::$ctrl.tabs.config.translateKey shortcode=::tab.shortcode></md-translate></md-tab></md-tabs></div>");
$templateCache.put("app/auth/change_password/partials/change_password.html","<div layout=column class=auth-holder><div flex=none class=notification-header-wrap><information-plate show-for=anonym></information-plate><language-toggle fixed=true></language-toggle></div><div flex class=auth-content><div flex layout=column layout-align=\"space-between center\" class=auth-wrapper><div flex class=top-el></div><div class=center-block><div class=\"logo little\"><logo-main></logo-main></div><h2 class=auth-title><md-translate key=changePassword.translate_key shortcode=\"\'change_password.header\'\"></md-translate></h2><div class=content-wrap><form name=changePassword.newPasswordForm md-submit=changePassword.submitPasswordForm()><md-input-container class=md-block><label><md-translate key=changePassword.translate_key shortcode=\"\'change_password.password\'\"></md-translate></label><input input-errors required md-no-asterisk name=password type=password ng-model=changePassword.password><md-error-messages errors=changePassword.errors input-name=password></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=changePassword.translate_key shortcode=\"\'change_password.password_confirmation\'\"></md-translate></label><input input-errors required md-no-asterisk name=password_confirmation type=password ng-model=changePassword.password_confirmation><md-error-messages errors=changePassword.errors input-name=password_confirmation></md-error-messages></md-input-container><div class=align-center><md-button type=submit class=\"md-raised md-primary btn-primary\" ng-disabled=changePassword.newPasswordForm.$invalid><md-translate key=changePassword.translate_key shortcode=\"\'change_password.submit\'\"></md-translate></md-button></div></form></div></div><div flex layout=column layout-align=\"end center\" class=bottom-el><last-update-control class=auth-page></last-update-control><powered-by-q></powered-by-q></div></div></div></div>");
$templateCache.put("app/auth/change_password/partials/confirm_email.html","<div layout=column class=auth-holder><div flex=none class=notification-header-wrap><information-plate show-for=anonym></information-plate><language-toggle fixed=true></language-toggle></div><div flex class=auth-content><div flex layout=column layout-align=\"space-between center\" class=auth-wrapper><div flex class=top-el></div><div class=center-block><div class=\"logo little\"><logo-main></logo-main></div><h2 class=auth-title><md-translate key=changePassword.translate_key shortcode=\"\'confirm_email.header\'\"></md-translate></h2><div class=\"auth-content medium-text align-center change-password\"><p><md-translate key=changePassword.translate_key shortcode=\"\'confirm_email.text\'\"></md-translate></p><div class=content-wrap><form name=changePassword.confirmEmailForm md-submit=changePassword.confirmationChange()><md-input-container class=md-block><label><md-translate key=changePassword.translate_key shortcode=\"\'confirm_email.token\'\"></md-translate></label><input input-errors required md-no-asterisk name=reset_password_token type=text ng-model-options=\"{debounce: 300}\" ng-model=changePassword.confirmation ng-change=changePassword.dispatchSubmitEvent()><md-error-messages errors=changePassword.errors input-name=reset_password_token></md-error-messages></md-input-container><div class=align-center><md-button type=submit class=\"md-raised md-primary btn-primary\" ng-disabled=!changePassword.confirmEmailForm.$valid><md-translate key=changePassword.translate_key shortcode=\"\'confirm_email.submit\'\"></md-translate></md-button></div></form></div></div></div><div flex layout=column layout-align=\"end center\" class=bottom-el><last-update-control class=auth-page></last-update-control><powered-by-q></powered-by-q></div></div></div></div>");
$templateCache.put("app/auth/change_password/partials/password_new.html","<div layout=column class=auth-holder><div flex=none class=notification-header-wrap><information-plate show-for=anonym></information-plate><language-toggle fixed=true></language-toggle></div><div flex class=auth-content><div flex layout=column layout-align=\"space-between center\" class=auth-wrapper><div flex class=top-el></div><div class=center-block><div class=\"logo little\"><logo-main></logo-main></div><h2 class=auth-title><md-translate key=changePassword.translate_key shortcode=\"\'new_password.header\'\"></md-translate></h2><div class=\"auth-content medium-text align-center change-password\"><p><md-translate key=changePassword.translate_key shortcode=\"\'new_password.text\'\"></md-translate></p></div><div class=content-wrap><form name=changePassword.userEmailForm md-submit=changePassword.submitForm()><md-input-container class=md-block><label><md-translate key=changePassword.translate_key shortcode=\"\'new_password.email\'\"></md-translate></label><input input-errors required md-no-asterisk autofocus name=email type=email ng-model=changePassword.email><md-error-messages errors=changePassword.errors input-name=email></md-error-messages></md-input-container><div class=align-center><md-button type=submit class=\"md-raised md-primary btn-primary\" ng-disabled=!changePassword.userEmailForm.$valid><md-translate key=changePassword.translate_key shortcode=\"\'new_password.submit\'\"></md-translate></md-button></div></form></div></div><div flex layout=column layout-align=\"end center\" class=bottom-el><last-update-control class=auth-page></last-update-control><powered-by-q></powered-by-q></div></div></div></div>");
$templateCache.put("app/auth/change_password/partials/save_password.html","<div layout=column class=auth-holder><div flex=none class=notification-header-wrap><information-plate show-for=anonym></information-plate><language-toggle fixed=true></language-toggle></div><div flex class=auth-content><div flex layout=column layout-align=\"space-between center\" class=auth-wrapper><div flex class=top-el></div><div class=center-block><div class=\"logo little\"><logo-main></logo-main></div><h2 class=auth-title><md-translate key=changePassword.translate_key shortcode=\"\'save_password.header\'\"></md-translate></h2><div class=\"auth-content medium-text align-center change-password\"><p><md-translate key=changePassword.translate_key shortcode=\"\'save_password.text\'\"></md-translate></p><div class=next-btn-wrap><md-button class=\"md-raised md-primary btn-primary\" ui-sref=sign_in><md-translate key=changePassword.translate_key shortcode=\"\'save_password.log_in\'\"></md-translate></md-button></div></div></div><div flex layout=column layout-align=\"end center\" class=bottom-el><last-update-control class=auth-page></last-update-control><powered-by-q></powered-by-q></div></div></div></div>");
$templateCache.put("app/auth/registration/partials/affiliate_data.html","<div layout=column class=auth-holder><div flex=none class=notification-header-wrap><information-plate show-for=anonym></information-plate><language-toggle fixed=true></language-toggle></div><div flex class=auth-content><div flex layout=column layout-align=\"space-between center\" class=auth-wrapper><div flex class=top-el></div><div class=center-block><div class=\"logo little\"><logo-main></logo-main></div><ui-view><h2 class=auth-title><md-translate key=registration.translate_key shortcode=\"\'registration.header\'\"></md-translate></h2><div row-restrict max-width=450px class=sign-up-wrap><form name=registration.signUpForm><md-input-container class=md-block ng-if=registration.fields_map.name><label><md-translate key=registration.translate_key shortcode=\"\'form.name\'\"></md-translate></label><input input-errors md-no-asterisk name=name type=text ng-model=registration.new_user.name><md-error-messages errors=registration.errors input-name=name></md-error-messages></md-input-container><md-input-container class=md-block ng-if=registration.fields_map.surname><label><md-translate key=registration.translate_key shortcode=\"\'form.surname\'\"></md-translate></label><input input-errors md-no-asterisk name=surname type=text ng-model=registration.new_user.surname><md-error-messages errors=registration.errors input-name=surname></md-error-messages></md-input-container><md-input-container class=md-block ng-if=registration.fields_map.username><label><md-translate key=registration.translate_key shortcode=\"\'form.username\'\"></md-translate></label><input input-errors md-no-asterisk name=username type=text ng-model=registration.new_user.username ng-model-options=\"{ debounce: 500 }\" ng-change=registration.checkUsername()><md-error-messages errors=registration.errors input-name=username></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=registration.translate_key shortcode=\"\'form.email\'\"></md-translate></label><input input-errors md-no-asterisk name=email type=email ng-model=registration.new_user.email><md-error-messages errors=registration.errors input-name=email></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=registration.translate_key shortcode=\"\'form.password\'\"></md-translate></label><input input-errors md-no-asterisk name=password type=password ng-model=registration.new_user.password><md-error-messages errors=registration.errors input-name=password></md-error-messages></md-input-container><md-input-container class=md-block ng-if=registration.fields_map.phone_number><label><md-translate key=registration.translate_key shortcode=\"\'form.phone_number\'\"></md-translate></label><input input-errors md-no-asterisk name=phone_number type=tel ng-model=registration.new_user.phone_number><md-error-messages errors=registration.errors input-name=phone_number></md-error-messages></md-input-container><md-input-container class=md-block ng-if=registration.fields_map.skype><label><md-translate key=registration.translate_key shortcode=\"\'form.skype\'\"></md-translate></label><input input-errors md-no-asterisk name=skype type=text ng-model=registration.new_user.skype><md-error-messages errors=registration.errors input-name=skype></md-error-messages></md-input-container><md-input-container class=md-block ng-if=registration.fields_map.telegram><label><md-translate key=registration.translate_key shortcode=\"\'form.telegram\'\"></md-translate></label><input input-errors md-no-asterisk name=telegram type=text ng-model=registration.new_user.telegram><md-error-messages errors=registration.errors input-name=telegram></md-error-messages></md-input-container><md-input-container class=md-block ng-if=registration.fields_map.birthday><label><md-translate key=registration.translate_key shortcode=\"\'form.birthday\'\"></md-translate></label><mod-datepicker name=birthday ng-model=registration.new_user.birthday errors=registration.errors md-current-view=year md-max-date=registration.maxDate></mod-datepicker></md-input-container><md-input-container class=md-block ng-if=registration.fields_map.site_url><label><md-translate key=registration.translate_key shortcode=\"\'form.site_url\'\"></md-translate></label><input input-errors md-no-asterisk name=site_url type=text ng-model=registration.new_user.site_url><md-error-messages errors=registration.errors input-name=site_url></md-error-messages></md-input-container><md-input-container class=md-block ng-if=registration.fields_map.about_affiliate><label><md-translate key=registration.translate_key shortcode=\"\'form.about_affiliate\'\"></md-translate></label><textarea input-errors md-no-asterisk name=about_affiliate ng-model=registration.new_user.about_affiliate></textarea><md-error-messages errors=registration.errors input-name=about_affiliate></md-error-messages></md-input-container><div><md-checkbox class=\"md-primary primary-checkbox md-align-top-left\" ng-model=registration.accept_terms_and_conditions><span class=space-around><md-translate key=registration.translate_key shortcode=\"\'registration.attention_first_part\'\"></md-translate><span class=show-rules-btn ng-click=registration.getTariffs($event)><md-translate key=registration.translate_key shortcode=\"\'registration.attention_second_part\'\"></md-translate></span><span class=show-rules-btn ng-click=registration.getRules($event)><md-translate key=registration.translate_key shortcode=\"\'registration.attention_last_part\'\"></md-translate></span></span></md-checkbox></div><div><md-checkbox class=\"md-primary primary-checkbox md-align-top-left\" ng-model=registration.new_user.agree_receive_emails><md-translate key=registration.translate_key shortcode=\"\'form.agree_receive_emails\'\"></md-translate></md-checkbox></div><div class=\"align-center mt-30\"><md-button type=submit class=\"md-raised md-primary btn-primary\" md-click=registration.registration() ng-disabled=!registration.accept_terms_and_conditions><md-translate key=registration.translate_key shortcode=\"\'registration.submit_btn\'\"></md-translate></md-button></div></form></div></ui-view></div><div flex layout=column layout-align=\"end center\" class=bottom-el><last-update-control class=auth-page></last-update-control><powered-by-q></powered-by-q></div></div></div></div>");
$templateCache.put("app/auth/registration/partials/confirmation.html","<h2 class=auth-title><md-translate key=confirmCtrl.translate_key shortcode=\"\'confirmation.header\'\"></md-translate></h2><div class=\"auth-content align-center medium-text mg-top\"><p><md-translate key=confirmCtrl.translate_key shortcode=\"\'confirmation.hint\'\"></md-translate></p></div><div class=content-wrap><form name=confirmCtrl.confirmationForm md-submit=confirmCtrl.confirmation()><md-input-container class=md-block><label><md-translate key=confirmCtrl.translate_key shortcode=\"\'confirmation.token\'\"></md-translate></label><input input-errors required md-no-asterisk name=confirmation_token type=text ng-model=confirmCtrl.confirmation_token ng-model-options=\"{debounce: 300}\" ng-change=confirmCtrl.dispatchSubmitEvent()><md-error-messages errors=confirmCtrl.errors input-name=confirmation_token></md-error-messages></md-input-container><div class=\"next-btn-wrap align-center\"><md-button class=\"md-raised md-primary btn-primary\" type=submit ng-disabled=confirmCtrl.confirmationForm.$invalid><md-translate key=confirmCtrl.translate_key shortcode=\"\'confirmation.next\'\"></md-translate></md-button></div></form></div>");
$templateCache.put("app/auth/registration/partials/done.html","<h2 class=auth-title><md-translate key=registration.translate_key shortcode=\"\'done.header\'\"></md-translate></h2><div class=auth-content><div class=check-done><img alt=\"Check done\" src=assets/images/check-done.png></div><div class=medium-text><p><md-translate key=registration.translate_key shortcode=\"\'done.description\'\"></md-translate></p></div></div><div class=btn-holder><div class=next-btn-wrap><md-button class=\"md-raised md-primary btn-primary\" ui-sref=sign_in><md-translate key=registration.translate_key shortcode=\"\'done.finish\'\"></md-translate></md-button></div></div>");
$templateCache.put("app/auth/registration/partials/modal.html","<md-dialog><div flex=none class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=registration.translate_key shortcode=registration.modal_header></md-translate></div><md-button class=\"md-icon-button close-btn\" ng-click=registration.close_modal()></md-button></div><md-dialog-content class=md-dialog-content><div ng-bind-html=registration.modal_content class=md-dialog-content-body></div></md-dialog-content></md-dialog>");
$templateCache.put("app/auth/sign_in/partials/sign_in.html","<div layout=column class=auth-holder><div flex=none class=notification-header-wrap><information-plate show-for=anonym></information-plate><language-toggle fixed=true></language-toggle></div><div flex class=auth-content><div flex layout=column layout-align=\"space-between center\" class=auth-wrapper><div flex class=top-el></div><div class=center-block><div class=\"logo little\"><logo-main></logo-main></div><h2 class=auth-title><md-translate key=signIn.translate_key shortcode=\"\'sign_in.title\'\"></md-translate></h2><div ng-if=signIn.requireMfaCode class=\"auth-content align-center medium-text mg-top\"><p><md-translate key=signIn.translate_key shortcode=\"\'sign_in.two_factor_auth_description\'\"></md-translate></p></div><div class=content-wrap><form name=signIn.loginForm md-submit=signIn.login() ng-if=!signIn.requireMfaCode><md-input-container class=md-block><label><md-translate key=signIn.translate_key shortcode=\"\'sign_in.email\'\"></md-translate></label><input input-errors md-no-asterisk required autofocus name=email type=email ng-model=signIn.user.email><md-error-messages errors=signIn.errors input-name=email></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=signIn.translate_key shortcode=\"\'sign_in.password\'\"></md-translate></label><input input-errors md-no-asterisk required autocomplete=off name=password type=password ng-model=signIn.user.password><md-error-messages errors=signIn.errors input-name=password></md-error-messages></md-input-container><div class=\"new-password font-medium align-center\"><a ui-sref=password_new><md-translate key=signIn.translate_key shortcode=\"\'sign_in.password_new\'\"></md-translate></a><a ui-sref=affiliate_data><md-translate key=\"\'AuthMainPage\'\" shortcode=\"\'main_page.sign_up\'\"></md-translate></a></div><div class=\"next-btn-wrap align-center\"><md-button type=submit class=\"md-raised md-primary btn-primary\"><md-translate key=signIn.translate_key shortcode=\"\'sign_in.submit\'\"></md-translate></md-button></div><div class=\"next-btn-wrap align-center show-rules-btn terms-on-login\" ng-click=signIn.getTerms($event)><md-translate key=\"\'AuthRegistration\'\" shortcode=\"\'registration.attention_last_part\'\"></md-translate></div></form><form class=confirm-mfa-code-form name=signIn.confirmMfaCodeForm md-submit=signIn.login() ng-if=signIn.requireMfaCode><md-checkbox ng-model=signIn.user.remember_me name=remember_me class=remember-device><md-translate key=signIn.translate_key shortcode=\"\'sign_in.remember_device\'\"></md-translate></md-checkbox><md-input-container class=md-block><label><md-translate key=signIn.translate_key shortcode=\"\'sign_in.mfa_code\'\"></md-translate></label><input input-errors md-no-asterisk required md-focus autocomplete=off name=mfa_code type=text ng-model=signIn.user.mfa_code class=mfa-code><md-error-messages errors=signIn.errors input-name=mfa_code></md-error-messages></md-input-container><div class=\"next-btn-wrap align-center\"><md-button type=submit class=\"md-raised md-primary btn-primary\"><md-translate key=signIn.translate_key shortcode=\"\'sign_in.submit\'\"></md-translate></md-button></div></form></div></div><div flex layout=column layout-align=\"end center\" class=bottom-el><last-update-control class=auth-page></last-update-control><powered-by-q></powered-by-q></div><login-animation-controll></login-animation-controll></div></div></div>");
$templateCache.put("app/auth/unsubscribe/partials/unsubscribe.html","<div layout=column class=auth-holder><div flex=none class=notification-header-wrap><language-toggle fixed=true></language-toggle></div><div flex class=auth-content><div flex layout=column layout-align=\"space-between center\" class=auth-wrapper><div flex class=top-el></div><div class=center-block><div class=logo><logo-main></logo-main></div><div ng-show=UnsubscribeCtrl.showText class=\"auth-content medium-text align-center welcome-text\"><div ng-if=UnsubscribeCtrl.isSubscribed><md-translate key=::UnsubscribeCtrl.translate_key shortcode=\"\'affiliate_unsubscribe.want_to_unsubscribe\'\"></md-translate></div><div ng-if=!UnsubscribeCtrl.isSubscribed><md-translate key=::UnsubscribeCtrl.translate_key shortcode=\"\'affiliate_unsubscribe.have_been_unsubscribed\'\"></md-translate></div></div><div ng-if=\"UnsubscribeCtrl.isSubscribed &amp;&amp; UnsubscribeCtrl.showText\" class=nav-links><md-button class=\"md-raised md-primary btn-primary\" ng-click=UnsubscribeCtrl.unsubscribe()><md-translate key=::UnsubscribeCtrl.translate_key shortcode=\"\'affiliate_unsubscribe.unsubscribe_button\'\"></md-translate></md-button></div></div><div flex layout=column layout-align=\"end center\" class=bottom-el><powered-by-q></powered-by-q></div></div></div></div>");
$templateCache.put("app/affiliate/affiliate_api/partials/affiliate_api.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::affiliateApi.translate_key shortcode=\"\'affiliate_api.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::affiliateApi.translate_key shortcode=\"\'affiliate_api.link\'\"></md-translate></label><textarea id=affiliate-api ng-model=affiliateApi.apiUri ng-readonly=true></textarea></md-input-container></div></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button clipboard data-clipboard-target=#affiliate-api class=\"md-raised md-primary btn-primary\" success=affiliateApi.copySuccess()><md-translate key=::affiliateApi.translate_key shortcode=\"\'affiliate_api.copy\'\"></md-translate></md-button><md-button has-permission permission permission-only=\"\'api2.affiliate.apitokensrefreshcontroller.edit\'\" class=\"md-raised md-primary btn-primary\" ng-click=affiliateApi.resetApiToken($event)><md-translate key=::affiliateApi.translate_key shortcode=\"\'quints_api.reset_api_token_button\'\"></md-translate></md-button></div></div></div></md-card></div>");
$templateCache.put("app/affiliate/affiliate_reference/partials/affiliate_reference.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::ref.translate_key shortcode=\"\'registration_reference.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::ref.translate_key shortcode=\"\'registration_reference.link\'\"></md-translate></label><textarea id=affiliate-reference ng-model=ref.link ng-readonly=true></textarea></md-input-container></div></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button clipboard data-clipboard-target=#affiliate-reference class=\"md-raised md-primary btn-primary\" success=ref.copySuccess()><md-translate key=::ref.translate_key shortcode=\"\'registration_reference.copy\'\"></md-translate></md-button><md-button class=\"md-raised md-primary btn-primary\" ng-click=ref.showCondition()><md-translate key=::ref.translate_key shortcode=\"\'registration_reference.show_condition_btn\'\"></md-translate></md-button></div></div></div></md-card></div></ui-view>");
$templateCache.put("app/affiliate/affiliate_reference/partials/condition.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::$ctrl.translate_key shortcode=\"\'condition.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><div class=\"condition-holder mb-30\"><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'condition.form.title\'\"></md-translate></label><textarea name=title ng-model=$ctrl.condition.title ng-readonly=true></textarea></md-input-container><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'condition.form.description\'\"></md-translate></label><textarea name=description ng-model=$ctrl.condition.description ng-readonly=true></textarea></md-input-container><div class=\"steps-wrap mt-30\"><div ng-repeat=\"step in $ctrl.condition.subaffiliate_condition_steps_attributes track by $index\" layout=row class=step><div flex=none class=\"step-count common\"><md-translate key=::$ctrl.translate_key shortcode=\"\'condition.step.step\'\" translate-values=\"{ index: $index+1 }\"></md-translate></div><div layout-wrap layout=row class=step-condition-holder><div flex=none class=\"type-condition common space-around read-only-input read-only\"><span ng-bind=\"step.payment_size + $ctrl.markFor(step)\" class=type></span><span ng-bind=$ctrl.labelFor(step)></span></div></div></div></div></div></div></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=btn-transparent ng-click=$ctrl.back()><md-translate key=::$ctrl.translate_key shortcode=\"\'condition.back\'\"></md-translate></md-button></div></div></div></md-card></div>");
$templateCache.put("app/affiliate/balance/partials/balance.html","<ui-view><div class=view-content><balance has-permission permission permission-only=\"\'api2.affiliate.cashoutscontroller.show_balance\'\" placed=affiliate withdrawal-func=balanceCtrl.balanceWithdrawal(data) withdrawal-permission=\"\'api2.affiliate.cashoutscontroller.withdraw\'\"></balance><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::balanceCtrl.translate_key shortcode=\"\'affiliate_balance.header\'\"></md-translate></div><div class=search-block><table-list-search table=balanceCtrl.table></table-list-search></div></div><div class=card-content><table-list table=balanceCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.affiliate.cashoutscontroller.download_report\'\" class=\"md-raised md-primary btn-primary\" ng-click=balanceCtrl.downloadReport($event)><md-translate key=::balanceCtrl.translate_key shortcode=\"\'affiliate_balance.download_report_button\'\"></md-translate></md-button></div><table-list-pagination table=balanceCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/affiliate/balance/partials/withdrawal.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::withdrawalCtrl.translate_key shortcode=\"\'affiliate_balance.withdrawal.header\'\"></md-translate></div></div><md-card-content class=padding-content><div class=withdrawal-balance-item-wrap><span ng-bind=withdrawalCtrl.getCurrency() class=currency></span><span ng-bind=\"withdrawalCtrl.getBalance() | number | numberSeparate: \' \'\" class=balance></span></div><form name=withdrawalCtrl.paymentDetailsForm><payment-systems-details type=\"\'tabs\'\" payment-systems=withdrawalCtrl.paymentSystems countries-list=withdrawalCtrl.countriesList current-system=withdrawalCtrl.currentSystem default-system-checkbox=false errors=withdrawalCtrl.errors></payment-systems-details></form></md-card-content><div class=card-footer><div class=button-holder><md-button has-permission permission permission-only=withdrawalCtrl.withdrawalPermission class=\"md-raised md-primary btn-primary\" md-click=withdrawalCtrl.submitWithdrawal() ng-if=withdrawalCtrl.paymentSystems.length><md-translate key=::withdrawalCtrl.translate_key shortcode=\"\'affiliate_balance.withdrawal.submit_button\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=withdrawalCtrl.back()><md-translate key=::withdrawalCtrl.translate_key shortcode=\"\'affiliate_balance.withdrawal.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/affiliate/creatives/partials/creative_code_tmp.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=creative_code.creative.title class=dialog-title></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><md-input-container class=md-block ng-if=\"creative_code.click_url_formats.length &gt; 1\"><label><md-translate key=::creative_code.translate_key shortcode=\"\'modal_window.integration_format.label\'\"></md-translate></label><md-select md-select-label-translate ng-model=creative_code.integration_format ng-change=creative_code.change_click_url_format()><md-option ng-value=format ng-repeat=\"format in creative_code.click_url_formats\"><md-translate key=::creative_code.translate_key shortcode=\"::\'modal_window.integration_format.\' + format\"></md-translate></md-option></md-select><span class=errors-reserve></span></md-input-container><md-input-container md-no-float class=md-block><label><md-translate key=::creative_code.translate_key shortcode=\"\'modal_window.banner_code\'\"></md-translate></label><textarea id=creative-code-area ng-model=creative_code.click_url[creative_code.integration_format] ng-readonly=true></textarea></md-input-container><md-input-container class=md-block><label><md-translate key=::creative_code.translate_key shortcode=\"\'modal_window.zone_id\'\"></md-translate></label><input ng-model=creative_code.zone_id type=text ng-change=creative_code.set_zone_id()></md-input-container></div></md-dialog-content><md-dialog-actions layout=row class=\"button-holder overflow-visible\"><md-button class=md-primary ng-click=creative_code.close()><md-translate key=::creative_code.translate_key shortcode=\"\'modal_window.button_cancel\'\"></md-translate></md-button><md-button clipboard data-clipboard-target=#creative-code-area success=creative_code.copySuccess() error=creative_code.copyError() class=md-primary><md-translate key=::creative_code.translate_key shortcode=\"\'modal_window.button_copy\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/affiliate/creatives/partials/creative_img.html","<md-dialog aria-label=\"creative image\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=viewCtrl.title class=dialog-title></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=viewCtrl.closePopup()></md-button></span></div><md-dialog-content class=\"md-dialog-content align-center\"><div class=md-dialog-content-body><img ng-src={{viewCtrl.src}} alt=\"creative image\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/affiliate/creatives/partials/creatives.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::$ctrl.translate_key shortcode=\"\'creatives.header\'\"></md-translate></div><div flex=nogrow class=search-block><tabs-content tabs-name=affiliate_creatives view-name=search></tabs-content></div></div><div flex=100 class=\"tabs-wrap mt-30\" ng-class=\"{\'hide-tabs\': !$ctrl.dataReceived}\"><tabs-list tabs-name=affiliate_creatives></tabs-list></div></div><div class=card-content><div ng-if=\"!$ctrl.noCreatives &amp;&amp; $ctrl.dataReceived\"><tabs-content tabs-name=affiliate_creatives view-name=content></tabs-content></div><div ng-if=\"$ctrl.noCreatives &amp;&amp; $ctrl.dataReceived\" class=no-content-wrap><md-translate key=::$ctrl.translate_key shortcode=\"\'creatives.no_creatives\'\"></md-translate></div></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=btn-transparent ng-click=$ctrl.backToTrackers()><md-translate key=::$ctrl.translate_key shortcode=\"\'creatives.back\'\"></md-translate></md-button></div><tabs-content tabs-name=affiliate_creatives view-name=pagination></tabs-content></div></div></md-card></div>");
$templateCache.put("app/affiliate/creatives/partials/list.html","<table-list table=tabCtrl.table></table-list>");
$templateCache.put("app/affiliate/creatives/partials/pagination.html","<table-list-pagination table=$ctrl.tabs.activeTab.table></table-list-pagination>");
$templateCache.put("app/affiliate/creatives/partials/search.html","<table-list-search table=$ctrl.tabs.activeTab.table></table-list-search>");
$templateCache.put("app/affiliate/creatives/partials/table.html","<md-button class=md-icon-button ng-click=\"table.config.buttons.methods.show(item, $event)\" ng-if=table.config.buttons.methods.show><i class=\"fa fa-eye\"></i></md-button><md-button class=md-icon-button ng-click=\"table.config.buttons.methods.showCode(item, $event)\"><i class=\"fa fa-clone\"></i></md-button>");
$templateCache.put("app/affiliate/creatives/partials/view_flash.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=viewCtrl.title class=dialog-title></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=viewCtrl.closePopup()></md-button></span></div><md-dialog-content class=\"md-dialog-content align-center\"><div class=md-dialog-content-body><object classid=clsid:d27cdb6e-ae6d-11cf-96b8-444553540000 codebase=\"http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=8,5,0,175\" width={{viewCtrl.width}} height={{viewCtrl.height}}><param name=movie value={{viewCtrl.src}}><param name=allowScriptAccess value=always><param name=flashvars value=\"creativeURL=\"><embed ng-src={{viewCtrl.src}} width={{viewCtrl.width}} height={{viewCtrl.height}} allowscriptaccess=always type=application/x-shockwave-flash pluginspage=http://www.macromedia.com/go/getflashplayer flashvars=\"creativeURL=\"></object></div></md-dialog-content></md-dialog>");
$templateCache.put("app/affiliate/creatives/partials/view_iframe.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=viewCtrl.title class=dialog-title></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=viewCtrl.closePopup()></md-button></span></div><md-dialog-content class=\"md-dialog-content align-center\"><div class=md-dialog-content-body><iframe ng-src={{viewCtrl.src}} width={{viewCtrl.width}} height={{viewCtrl.height}} frameborder=0></iframe></div></md-dialog-content></md-dialog>");
$templateCache.put("app/affiliate/dashboard/partials/dashboard.html","<div class=\"view-content dashboard\"><div layout=row layout-xs=column layout-align=\"space-between center\" layout-align-xs=\"space-between stretch\" ng-if=\"affiliateCtrl.lastUpdatePermission || affiliateCtrl.getStatsPermission\" class=grid-row><div class=\"last-update font-size-medium\"><div ng-if=affiliateCtrl.lastUpdatePermission><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'dashboard.last_update\'\"></md-translate><span date-locale={{affiliateCtrl.date_update_statistic}} format=LLL class=font-bold></span></div></div><div layout=row layout-align=space-between class=column-with-select><md-input-container ng-if=affiliateCtrl.getStatsPermission class=select-wrap><md-select ng-model=affiliateCtrl.currentMerchant ng-change=affiliateCtrl.changeMerchant() md-container-class=select-period><md-option ng-repeat=\"merchant in affiliateCtrl.merchantsList\" ng-value=merchant.id><span ng-bind=merchant.value></span></md-option></md-select></md-input-container><md-input-container ng-if=affiliateCtrl.getStatsPermission class=\"no-margin select-wrap\"><md-select aria-label=period ng-model=affiliateCtrl.month ng-change=affiliateCtrl.changeMonthInfo() md-container-class=select-period><md-option ng-repeat=\"period in affiliateCtrl.periods\" ng-value=period ng-class=\"{\'is-choosed\': affiliateCtrl.month == period}\"><i class=\"fa fa-check\"></i><md-translate key=::affiliateCtrl.translate_key shortcode=\"::\'periods.\' + period\" translate-default={{period}}></md-translate></md-option></md-select></md-input-container></div></div><!--Stats--><div ng-if=affiliateCtrl.getStatsPermission layout-wrap layout=row layout-xs=row layout-align-sm=space-between layout-align-gt-sm=space-between class=\"grid-row stats-card affiliate-stats\"><md-card flex ng-if=\"affiliateCtrl.affiliate_current_data.hasOwnProperty(\'views_count\')\" class=primary-card><md-card-content><div class=content-key><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'stats_block.views_count\'\"></md-translate></div><div ng-bind=\"affiliateCtrl.affiliate_current_data.views_count | number | numberSeparate: \' \'\" class=content-value></div></md-card-content></md-card><md-card flex ng-if=\"affiliateCtrl.affiliate_current_data.hasOwnProperty(\'clicks_count\')\" class=primary-card><md-card-content><div class=content-key><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'stats_block.clicks_count\'\"></md-translate></div><div ng-bind=\"affiliateCtrl.affiliate_current_data.clicks_count | number | numberSeparate: \' \'\" class=content-value></div></md-card-content></md-card><md-card flex ng-if=\"affiliateCtrl.affiliate_current_data.hasOwnProperty(\'registration_count\')\" class=primary-card><md-card-content><div class=content-key><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'stats_block.number_of_registrations\'\"></md-translate></div><div ng-bind=\"affiliateCtrl.affiliate_current_data.registration_count | number | numberSeparate: \' \'\" class=content-value></div></md-card-content></md-card><md-card flex ng-if=\"affiliateCtrl.affiliate_current_data.hasOwnProperty(\'client_count\')\" class=primary-card><md-card-content><div class=content-key><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'stats_block.number_of_depositaries\'\"></md-translate></div><div ng-bind=\"affiliateCtrl.affiliate_current_data.client_count | number | numberSeparate: \' \'\" class=content-value></div></md-card-content></md-card><md-card flex ng-if=\"affiliateCtrl.affiliate_current_data.hasOwnProperty(\'profit\')\" class=primary-card><md-card-content><div class=content-key><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'stats_block.partner_commission\'\"></md-translate></div><div ng-bind=\"affiliateCtrl.affiliate_current_data.profit | number | numberSeparate: \' \'\" class=content-value></div></md-card-content></md-card><md-card flex ng-if=\"affiliateCtrl.affiliate_current_data.hasOwnProperty(\'cpa_qualified\')\" class=primary-card><md-card-content><div class=content-key><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'stats_block.cpa_qualified\'\"></md-translate></div><div ng-bind=\"affiliateCtrl.affiliate_current_data.cpa_qualified | number | numberSeparate: \' \'\" class=content-value></div></md-card-content></md-card></div><div ng-if=affiliateCtrl.chartsPermission><charts data=affiliateCtrl.chartsData options=affiliateCtrl.chartOptions layout=column layout-gt-sm=row class=\"grid-row charts-holder\"></charts></div><div ng-if=affiliateCtrl.articlesPermission layout=row layout-align=\"space-between center\"><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'last_articles.title\'\"></md-translate></div></div><md-card-content><div class=last-news-wrap><articles-last options=affiliateCtrl.articlesOptions></articles-last></div><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=affiliateCtrl.showAllArticles()><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'last_articles.see_more\'\"></md-translate></md-button></div></md-card-content></md-card></div><div layout-gt-xs=row layout-xs=column layout-align=\"space-between start\" class=\"grid-row stats-card\"><md-card flex ng-if=affiliateCtrl.chiefPermission class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'manager_block.header\'\"></md-translate></div></div><md-card-content><div row-restrict max-width=450px class=\"last-item-no-margin pt-25\"><md-input-container md-no-float class=md-block><label><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'manager_block.name\'\"></md-translate></label><input type=text ng-value=affiliateCtrl.chief.name ng-readonly=true></md-input-container><md-input-container md-no-float class=md-block><label><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'manager_block.skype\'\"></md-translate></label><input type=text ng-value=affiliateCtrl.chief.skype ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'manager_block.email\'\"></md-translate></label><input type=text ng-value=affiliateCtrl.chief.email ng-readonly=true></md-input-container></div></md-card-content></md-card><md-card flex ng-if=affiliateCtrl.playersCheckPermission class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'checking_player.header\'\"></md-translate></div></div><md-card-content><div class=pt-25><form name=affiliateCtrl.PlayerCheckForm ng-submit=affiliateCtrl.players_check()><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'checking_player.players_name\'\"></md-translate></label><input input-errors required md-no-asterisk ng-model=affiliateCtrl.players_name type=text name=players_name><md-error-messages errors=affiliateCtrl.errors input-name=players_name></md-error-messages></md-input-container></div><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" type=submit><md-translate key=::affiliateCtrl.translate_key shortcode=\"\'checking_player.check_button\'\"></md-translate></md-button></div></form></div></md-card-content></md-card></div></div>");
$templateCache.put("app/affiliate/faq_handbook/partials/faq_handbook.html","<div class=view-content><md-card class=\"primary-card faq-handbook\"><div class=card-header><div class=card-title>GGPartners Affiliate Guide</div></div><md-card-content class=padding-content><div ng-repeat=\"section in $ctrl.sections track by $index\" class=faq-section><h2 class=faq-section-title>{{section.title}}</h2><accordion one-opened=false><accordion-group ng-repeat=\"faq in section.faqs track by $index\"><accordion-group-heading><accordion-group-button><div class=faq-question><i class=\"fa fa-chevron-right\"></i><span>{{faq.question}}</span></div></accordion-group-button></accordion-group-heading><accordion-group-content><div ng-bind-html=\"faq.answerHtml | toHtml\" class=faq-answer></div></accordion-group-content></accordion-group></accordion></div><h2 class=faq-section-title>Marketing Guidelines</h2><accordion one-opened=false><accordion-group><accordion-group-heading><accordion-group-button><div class=faq-question><i class=\"fa fa-chevron-right\"></i><span>NL - Netherlands</span></div></accordion-group-button></accordion-group-heading><accordion-group-content><div class=faq-answer><h3 class=faq-subsection-title>1. Dutch Compliance Requirements</h3><p><strong>Responsible Gambling Messages</strong></p><ol class=faq-alpha-list><li>Affiliates must include clear, visible statements promoting responsible gambling in all promotional materials.</li><li>The slogan: Wat kost gokken jou? Stop op tijd. 18+ must be visible at all times.</li></ol><p><strong>No Targeting of Minors or Vulnerable Groups</strong></p><ol class=faq-alpha-list><li>Any marketing channel or content explicitly aimed at individuals under 18 is strictly prohibited.</li><li>Visuals, language, and placement must avoid appealing to minors.</li></ol><p><strong>Advertising Restriction Compliance</strong></p><ol class=faq-alpha-list><li>Affiliates must follow all KSA guidelines regarding gambling ads.</li><li>Ads must not mislead in any way shape or form.</li></ol><h3 class=faq-subsection-title>2. ORKA Law Restrictions (Ban on Untargeted Advertising)</h3><p><strong>5% Maximum 18-23 Audience</strong></p><ol class=faq-alpha-list><li>The law permits a maximum of 5% of known visitors to be aged 18-23.</li><li>Affiliates must regularly verify this demographic data (for instance, via Google Analytics) to ensure compliance.</li></ol><p><strong>Age Gate Implementation</strong></p><ol class=faq-alpha-list><li>Websites should include an age verification step before granting access to gambling-related content.</li><li>This gate can be a pop-up, banner, or overlay clearly asking for confirmation that the user is 24+.</li></ol><p><strong>Opt-Out Functionality</strong></p><ol class=faq-alpha-list><li>Clear instructions allowing users to opt out of gambling promotions must be accessible.</li><li>The unsubscribe or opt-out process should be straightforward and promptly respected.</li></ol><h3 class=faq-subsection-title>3. Privacy & Data Protection (GDPR)</h3><p><strong>Lawful Data Processing</strong></p><ol class=faq-alpha-list><li>Affiliates must collect and process personal data under valid legal grounds (e.g., user consent).</li><li>Transparency in data usage is crucial; privacy policies must detail what data is gathered and why.</li></ol><p><strong>Secure Data Handling</strong></p><ol class=faq-alpha-list><li>Adequate security measures (encryption, restricted access) to protect user data from unauthorized access.</li><li>Quick response protocols for any data breaches or user requests concerning their data.</li></ol><p><strong>Cookie Consent</strong></p><ol class=faq-alpha-list><li>If employing cookies for tracking or analytics, explicit user consent is required.</li><li>Clear, user-friendly cookie policies outlining the purpose and duration of cookies.</li></ol><h3 class=faq-subsection-title>4. Reclame Code Commissie (Advertising Standards)</h3><p><strong>Honest & Non-Misleading Promotions</strong></p><ol class=faq-alpha-list><li>All marketing materials must accurately reflect actual offers, odds, terms, and conditions.</li><li>Overstating possible winnings or downplaying risks is not permitted.</li></ol><p><strong>Disclosure of Affiliate Relationships</strong></p><ol class=faq-alpha-list><li>Affiliates need to inform users that clicks or registrations might earn the affiliate a commission.</li><li>Transparent labeling of \"advertorial\" or \"sponsored content\" as appropriate.</li></ol><p><strong>Appropriate Tone & Imagery</strong></p><ol class=faq-alpha-list><li>Avoid content that glamorizes gambling or trivializes its potential harms.</li><li>No depiction suggests gambling as a solution to financial or personal difficulties.</li></ol><h3 class=faq-subsection-title>5. Additional Key Points</h3><p><strong>Regular Reporting & Monitoring</strong></p><ol class=faq-alpha-list><li>Affiliates should submit analytics to the operator upon request, verifying compliance with the 5% youth audience threshold.</li><li>Immediate corrective measures are expected if any non-compliance is detected.</li></ol><p><strong>Compliance Audits</strong></p><ol class=faq-alpha-list><li>Operators or third-party assessors may carry out audits. Affiliates must provide documentation (e.g., Google Analytics reports, promotional materials) promptly.</li></ol><p><strong>Penalties & Termination</strong></p><ol class=faq-alpha-list><li>Non-compliance can lead to steep fines, legal repercussions, and immediate termination of affiliate agreements.</li><li>In severe cases, KSA may blacklist the affiliate or enforce stricter sanctions against the operator.</li></ol></div></accordion-group-content></accordion-group><accordion-group><accordion-group-heading><accordion-group-button><div class=faq-question><i class=\"fa fa-chevron-right\"></i><span>DE - Germany</span></div></accordion-group-button></accordion-group-heading><accordion-group-content><div class=faq-answer><h3 class=faq-subsection-title>Affiliates - Regulatory Requirements</h3><p>Regulatory Requirements for Affiliates. 13 of the German License Condition can be seen as the \"Marketing Guideline\" for DE, see <a href=\"https://docs.google.com/document/d/1IN_ozHM4toPyDKTveetr_KKQNgKZdory3T8YHm8m9hg/edit?tab=t.0\" target=_blank>here.</a></p><h3 class=faq-subsection-title>1) License Conditions</h3><p><strong>B. 13 s.</strong></p><p>Third parties commissioned with advertising must be obligated to comply with the statutory provisions and the provisions of this notice, particularly in the case of online advertising on third-party websites. These obligations must be passed on to those responsible for the individual advertising, especially in the case of affiliate marketing.</p><p><strong>Explanation</strong></p><p>This ancillary provision ensures that the advertising guidelines are also observed on websites where the license holder is not itself the content provider; in these situations, the license holder must oblige contractual partners accordingly, and these partners must also pass on the obligation if necessary. Given the diverse contractual interrelationships in online advertising, this requirement is necessary to ensure compliance with the provisions of the decision, particularly those concerning the protection of minors and at-risk players. Regarding the term \"affiliate marketing,\" see the explanatory note for the immediately following regulation.</p><p><strong>B. 13 t.</strong></p><p>Affiliate marketing is only permitted under the condition that the affiliate\'s website only links to gambling offers from operators who hold a corresponding license under the 2021 State Treaty on Gambling.</p><p><strong>Explanation</strong></p><p>t. This ancillary provision regulates the use of so-called affiliate marketing. This refers to a marketing agreement whereby an organizer or agent of public gambling pays an operator or controller of an external website a fee for visits to their (organizer\'s or agent\'s) website, for registrations, or for concluded contracts generated through the VenNeise of the external website.</p><p>This ancillary provision ensures that advertising for public gambling does not contravene the state treaty objective of channeling gambling under Section 1, Sentence 1, No. 2 of the Gambling Ordinance 2021. Advertising for illegal gambling is punishable under Section 284, Paragraph 4 of the German Criminal Code (StGB). Advertising for legal gambling serves the purpose of raising awareness of this legal gambling offering and thus directing the population\'s natural urge to gamble there. Advertising on affiliate websites that present both legal and illegal gambling offerings in Germany runs counter to the objective of providing interested players with information about the possibility of participating in legal gambling and thus violates the objective of channeling gambling.</p><p><strong>B. 13 u.</strong></p><p>All advertising content (text, images, audio, and video) of the license holder on affiliate partners\' websites must be clearly marked as such. This does not apply to editorial content created independently by the affiliate, such as reviews on comparison portals.</p><p>When accessing the website, a notice regarding the affiliate\'s compensation upon registration with the listed gambling providers must appear in a clear, easily visible format and size. The notice must be displayed for a length of time sufficient for an average user to fully absorb this information.</p><p><strong>Explanation</strong></p><p>u. The ancillary provision represents a concretization of Section 5 Paragraph 2 Sentence 8 GlüStV 2021 for the area of affiliate marketing and is intended to ensure that advertising is recognizable as such for users.</p><p><strong>B. 13 x.</strong></p><p>A recording of the broadcast radio and internet advertising must be kept for the duration of the licence and presented to the licensing authority upon request.</p><p>With regard to broadcast advertising, the broadcast times and slots; with regard to online advertising, the third-party websites, affiliates, and social networks on which advertising is carried out, the advertising partners, the distribution of newsletters, and the respective advertising times must be continuously documented in an electronic table and retained for the duration of the license. The tables must be submitted to the supervisory authority upon request.</p><p><strong>Explanation</strong></p><p>x. The recording, storage, documentation, and submission obligations constitute a measure within the scope of the gaming supervisory authority\'s responsibilities in its function as a licensing authority (Section 9 (1) Sentence 1, Clause 1 of the Gaming Regulations 2021) and are necessary for the comprehensive fulfillment of supervisory duties, in particular the monitoring of the advertising regulations of Section 5 of the Gaming Regulations 2021, as well as for evaluation purposes. It thus also serves, in particular, the objectives of the State Treaty on Gaming pursuant to Section 1 Sentence 1 Nos. 1 and 3 of the Gaming Regulations 2021.</p><p>The recording, storage, documentation, and submission requirements apply to advertising on radio and the internet. It also covers advertising on third-party websites, affiliates, and social networks.</p><p>In this context, \"third-party sites\" refers to websites of providers that are not affiliated with the license holder. The definition of affiliates can be found in Section 13, Letter t.</p><h3 class=faq-subsection-title>2) German Gambling Law</h3><p><strong>§ 5 Abs. 3 S.1 GlüStV</strong></p><p>No advertising for virtual slot machines, online poker, or online casino games is permitted on radio or the Internet between 6 a.m. and 9 p.m. every day.</p><p><strong>Explanations to Section 5 Paragraph 3 Sentence 1 GlüStV</strong></p><p>Advertising for purely internet-based forms of gambling is prohibited daily between 6:00 a.m. and 9:00 p.m. on broadcast (television and radio) and on the internet. This regulation takes into account the increased risk of addiction compared to other forms of gambling such as lotteries, particularly due to the easier availability and permanent accessibility of such offers. The regulation thus pursues a similar intention to Section 26 Paragraph 1 and supplementary state law provisions for the area of arcades. At the same time, the time restriction represents a milder measure than a complete advertising ban, as prescribed in other European countries (e.g., Italy) and currently being discussed in other European countries (e.g., Spain and Belgium). Despite the increased danger of these forms of gambling, such a complete advertising ban will be avoided for reasons of channeling them into the permitted market. In the event of a complete advertising ban, there would be a risk that players would become aware of these offers through marketing measures by black market providers that could not be stopped or could only be stopped with a delay, while players would have difficulty finding legal online offers. To balance these conflicting goals, the states consider an advertising option starting at 9 p.m. sufficient to achieve a sufficient channeling effect while also adequately limiting the scope of advertising.</p><p>One of the goals is to minimize the exposure of minors to gambling advertising for these types of games. Uniform regulation for the internet and broadcasting, especially television, is necessary because both media are increasingly converging and overlap in content in certain areas (e.g., live streaming on the internet; displaying advertisements for online services on smart TVs).</p><p>If an organizer or agent offers other types of games in addition to those listed in sentence 1 on the basis of a validly granted permit, advertising may only be carried out for these other types of games between 6:00 a.m. and 9:00 p.m. However, the sole advertising of an umbrella brand under which types of games are also offered that may not be advertised between 6:00 a.m. and 9:00 p.m. is inadmissible, as the umbrella brand is influenced by these types of games and would thereby undermine sentence 1.</p><p>However, as a game-specific advertisement, advertising using the umbrella brand with the clear and permanent addition \"Sports Betting\" would be permitted between 6:00 a.m. and 9:00 p.m.</p><p><strong>§ 5 Abs. 6 S. 1GlüStV 2021</strong></p><p>No variable remuneration, particularly remuneration dependent on turnover, deposits or stakes, may be agreed or paid for advertising on the Internet for games of chance in which banned players are not permitted to participate pursuant to Section 8 Paragraph 2, particularly in the form of affiliate links.</p><p><strong>Explanations to Section 5 Paragraph 6 Sentence 1 GlüStV</strong></p><p>Paragraph 6 contains specific provisions for advertising on the Internet.</p><p>According to sentence 1, no variable remuneration may be paid for online advertising, in particular for so-called affiliate links. As can be seen from the wording of the list of sales-, deposit-, or stake-dependent remuneration, the ban essentially covers variable remuneration that is linked to the registration of the (referred) player or to the conclusion of a gaming contract between the (referred) player and the gambling provider. Such variable remuneration, which is based on the amount of stakes, deposits, or losses of the referred player, carries the risk that the third party recruiting the player will encourage the player to make the highest possible stakes, deposits, or losses, thereby enticing them to spend excessively on gambling. Remuneration models in which the third party receives a previously agreed fixed amount from the provider for each customer who is shown an advertisement, clicks on the advertisement, or registers with the provider after clicking on the advertisement, therefore remain permissible in accordance with their spirit and purpose. Exempt from the ban is advertising for games of chance in which banned players are permitted to participate. This is likely to apply exclusively to lotteries with low event frequency. This is intended to channel players to safer offerings.</p></div></accordion-group-content></accordion-group><accordion-group><accordion-group-heading><accordion-group-button><div class=faq-question><i class=\"fa fa-chevron-right\"></i><span>UK - United Kingdom</span></div></accordion-group-button></accordion-group-heading><accordion-group-content><div class=faq-answer><h3 class=faq-subsection-title>Marketing and Advertising for UK ASA Guidelines</h3><ol><li>All marketing communications referring to promotions must contain the significant terms and conditions for the promotion (depending on the promotion, significant T&Cs may include: (i) how to participate, (ii) start and closing dates, (iii) information on prizes/gifts, (iv) restrictions, (v) availability, (vi) promoter\'s name and address)</li><li>For marketing messages sent via SMS, a recognizable abbreviation can be used with a short code reply for opt-out</li><li>Gambling ads must not be placed in media for under-18\'s and that under-18\'s comprise no more than 25% of the audience for that media. For example - an ambassador promoting about GGPoker should not have more than 25% of their followers on their social media account. Same goes for influencers.</li><li>If applicable, closing dates must be displayed in the promotion terms and conditions</li><li>Avoid unrealistic portrayal of winners, such as \"first time winner won $10M\", and must not imply players are luckier than they are, or that they have already won</li><li>For pop-up ads within game to buy more resources to complete or retry a level/game, should avoid using mechanics that may place undue pressure onto players</li><li>Must not be misleading in any way. Page design, layout or format, & market conditions must not be misleading.</li><li>Testimonials/Endorsements must relate to the advertised product and cannot be featured without permission</li><li>Marketing communications sent via email must contain marketer\'s full name and a valid address, customers should have a way to opt out of marketing emails.</li><li>Must avoid unnecessary complex language, and must clearly state significant limitations and qualifications</li><li>Must avoid portrays that could be interpreted as reckless gambling behaviour</li><li>Must be decent, honest and truthful</li><li>Must hold documentary evidence for a claim, testimonial or endorsement in our advertisement</li><li>Must not feature gambling in a work environment</li><li>Must not contain anything that is likely to cause widespread offence, or exploits cultural beliefs or traditions about gambling or luck</li><li>Must not claim our product can facilitate winning in a game of chance</li><li>Must not contain anything to promote or condone violence or anti-social behaviour, or that solitary gaming is preferable to social gaming</li><li>Must not imply that an activity is without risk, or use humor to downplay the risks of gambling</li><li>Must not encourage repetitive or frequent participation, or more than they normally should</li><li>Must not play on people\'s fear of financial pressures, or refer to salary/debts</li><li>Must not make persistent and unwanted communications via email and other remote media</li><li>Must not include visual effects that are likely to adversely affect people with photosensitive epilepsy</li><li>Must not include gender stereotypes that are likely to cause harm or offence</li><li>Must not exploit susceptibilities, aspirations, credulity, inexperience or lack of knowledge of young persons or other vulnerable persons</li><li>Must not portray, condone or encourage anti-social behaviour or gambling behaviour that is socially irresponsible or could lead to financial, social or emotional harm</li><li>Must not suggest that gambling can provide an escape from professional, personal or educational problems</li><li>Must not suggest that gambling can be a solution to financial concerns, an alternative to employment or a way to achieve financial security</li><li>Must not portray gambling as indispensable or as taking priority in life, for example, over family, friends, profession or education</li><li>Must not link gambling to seduction, sexual success, enhanced attractiveness, rite of passage, peer pressure, toughness, resilience or recklessness, or that it can enhance personal qualities</li><li>Must not exaggerate or make claims that an average viewer might take literally</li></ol><h3 class=faq-subsection-title>Minors - Specific Guidelines (ASA\'s Guidance on \"Gambling and Lotteries Advertising: Protecting Under -18s\" - effective October 1st, 2022)</h3><ol><li>Must not have a \"Strong\" appeal to underage (ASA has explained what constitutes \'strong\'. Please see the file attached to the word \'strong\'.)</li><li>Avoid following high risk content:<ol class=faq-alpha-list><li>Animated child oriented cartoon content or animated styles, including cute / cuddly characters, common fairy tales, and cultural characters like santa Claus.</li><li>Video gaming (popular with -18s) references, including their characters and graphic styles, content related to eSports and features/themes like loot boxes or skins</li><li>Youth oriented content, including clothing, music by younger artists or those popular with -18s, and cultural themes like teenage rebelliousness</li></ol></li><li>Must not have characteristics of online games popular with -18s</li><li>References to our activities in the marketing material must be restricted to:<ol class=faq-alpha-list><li>Text / audio reference</li><li>Generic depictions of the sport or game</li><li>Our brand logos / identifiers</li><li>Limited use of persons or characters who pass the strong-appeal test provided in the google doc linked above</li></ol></li><li>Consider the following for casting / showing persons or characters:<ol class=faq-alpha-list><li>Their roles or activities - are they aspirational or influential for -18s?</li><li>Personal profile and their following / audience</li></ol></li><li>Marketing material cannot:<ol class=faq-alpha-list><li>Feature, and who appear to be or act like, -25s (including sportspeople and others used to illustrate subject of a product)</li><li>Directed at -18s by media placement, or addressed directly through content</li><li>Encourage -18s to engage in harmful behaviour</li></ol></li><li>Cannot provide news and updates on our social media accounts about persons under 25.</li><li>Must not feature an underage (-25s) in any way to promote gambling in general or our brand</li><li>Must not feature popular personalities who are likely to influence -18s, including sportspersons and celebrities</li><li>Must not feature characteristics and behaviour of persons or characters appearing in advertising, like humour, language or dress, that are linked to younger people</li><li>Must not use creative techniques like music, graphics and animation styles closely connected to youth culture</li><li>Must not use content linked to activities that are very popular or common among younger people (both in terms of direct participation and viewing)</li><li>Must not feature a sportsperson who has a leading role in their sport or a retired sportsperson who has moved to youth associated programs</li><li>Must not feature a personality with either appeal to younger children or adolescents</li><li>In short, do not feature any sportsperson (especially a footballer), if possible</li><li>Must not dress characters, persons and cartoons as children</li><li>Must not use cartoons, animated characters and puppets that \"audience will perceive\" as -18s</li><li>Must not have generic characters (such as Snow White or characters from Pingu)</li><li>Must not have themes that are popular among -18s (such as pirates, easter bunny, christmas, and fairies)</li><li>Must not use youth-oriented language (such as slangs or text abbreviations: like LMFAO, basic, drag, and ghosted)</li><li>Must not use humour associated with -18s (such as slapstick)</li><li>Must not have childlike background imagery (such as background from Alice in Wonderland)</li><li>Must not use child-like phrases in names (such as Pirate Princess, Piggy Payout, and Jack and the Beanstalk)</li><li>Must not have musical pieces associated with -18s</li><li>Actors in advertisements cannot prominently be wearing clothing, accessories, jewellery, body art or hair styles that are associated with -18s</li><li>Actors cannot behave juvenile or -18s</li></ol></div></accordion-group-content></accordion-group><accordion-group><accordion-group-heading><accordion-group-button><div class=faq-question><i class=\"fa fa-chevron-right\"></i><span>LATAM - Latin America</span></div></accordion-group-button></accordion-group-heading><accordion-group-content><div class=faq-answer><h3 class=faq-subsection-title>1. General Compliance Principles</h3><p>All marketing activities conducted in LATAM markets must comply with local regulations and internal brand policies. Affiliates and partners are responsible for ensuring that all promotional materials follow these guidelines.</p><p>Failure to comply may result in suspension of campaigns or termination of partnership.</p><h3 class=faq-subsection-title>2. Prohibited Practices</h3><p>The following practices are strictly prohibited:</p><p><strong>2.1 Cashback Offers</strong></p><ul><li>No cashback may be offered directly to players unless explicitly approved by the company.</li><li>Affiliates may not create independent financial incentives that alter the official promotional structure.</li></ul><p><strong>2.2 Sensitive Content Restrictions</strong></p><p>Marketing materials must NOT include or reference:</p><ul><li>Sexual content</li><li>Political subjects</li><li>Religious topics</li><li>Controversial or discriminatory themes</li></ul><p>All communications must remain neutral, professional, and brand-aligned.</p><h3 class=faq-subsection-title>3. Responsible Gaming Requirements</h3><p>All communications must clearly include:</p><ul><li><strong>\"18+ Only\"</strong></li><li><strong>\"Play Responsibly\"</strong></li></ul><p>These disclaimers must be visible in:</p><ul><li>Landing pages</li><li>Banners</li><li>Email campaigns</li><li>Social media promotions</li><li>Any paid advertising creatives</li></ul><p>Additional responsible gaming messaging may be required depending on the specific LATAM country.</p><h3 class=faq-subsection-title>4. Brand & Logo Usage</h3><ul><li>Only official logos and approved brand assets may be used.</li><li>Logos may not be altered, stretched, recolored, or modified.</li><li>Affiliates must follow official brand guidelines regarding:<ul><li>Font usage</li><li>Color schemes</li><li>Image positioning</li><li>Clear space requirements</li></ul></li></ul><p>Unauthorized brand representation is not permitted.</p><h3 class=faq-subsection-title>5. Ethical Messaging & Positioning</h3><p>Marketing materials must NOT:</p><ul><li>Imply that poker is a way out of debt</li><li>Suggest that poker will improve a player\'s financial situation</li><li>Promote poker as a guaranteed income source</li><li>Claim that poker will make someone more successful or a \"better person\"</li><li>Use messaging suggesting financial security, luxury lifestyle guarantees, or life transformation</li></ul><p>Poker must be presented as:</p><ul><li>Entertainment</li><li>A competitive skill-based game</li><li>A form of recreational gaming</li></ul><h3 class=faq-subsection-title>6. Additional Recommended Guidelines (Added for Clarity)</h3><p><strong>6.1 No Misleading Claims</strong></p><ul><li>Do not advertise unrealistic winnings.</li><li>Do not use fake testimonials.</li><li>Do not guarantee profits or jackpots.</li></ul><p><strong>6.2 Traffic Quality</strong></p><ul><li>No incentivized traffic unless pre-approved.</li><li>No spam (email, SMS, or social media).</li><li>No brand bidding without authorization.</li><li>No impersonation of official brand accounts.</li></ul><p><strong>6.3 Content Transparency</strong></p><ul><li>Affiliates must clearly disclose promotional relationships where required by local law.</li><li>All bonus terms must be transparent and not misleading.</li></ul><h3 class=faq-subsection-title>7. Approval Process</h3><ul><li>Creatives may require prior approval before launch.</li><li>Any custom promotions must be validated by the marketing team.</li><li>When in doubt, consult the affiliate manager before publishing.</li></ul><h3 class=faq-subsection-title>8. Enforcement</h3><p>Non-compliance may result in:</p><ul><li>Immediate campaign suspension</li><li>Withheld commissions</li><li>Termination of affiliate agreement</li></ul><h3 class=faq-subsection-title>Conclusion</h3><p>These LATAM Marketing Guidelines are designed to:</p><ul><li>Protect the brand</li><li>Ensure regulatory compliance</li><li>Promote responsible gaming</li><li>Maintain long-term sustainable growth</li></ul><p>All affiliates and partners must adhere strictly to these rules.</p></div></accordion-group-content></accordion-group><accordion-group><accordion-group-heading><accordion-group-button><div class=faq-question><i class=\"fa fa-chevron-right\"></i><span>MGA - Malta</span></div></accordion-group-button></accordion-group-heading><accordion-group-content><div class=faq-answer><p><em><a href=https://www.mga.org.mt/app/uploads/Commercial-Communications-Committee-Guidelines-1.pdf target=_blank>Commercial Communications Committee Guidelines</a> issued by the Malta Gaming Authority (MGA) provide detailed rules and standards for commercial communications in the gaming sector. These guidelines apply to any person offering licensable game/s and those collaborating with or providing service (including marketing or promotional service) on behalf of such persons, regardless of the channel used to convey the communication, unless specified otherwise.</em></p><h3 class=faq-subsection-title>General Obligations and Limitations</h3><p><strong>Social Responsibility</strong></p><ul><li>DO ensure commercial communications are socially responsible, especially regarding the need to protect minors and other vulnerable persons from harm or exploitation.</li><li>DO be diligent when publishing any commercial communication so as not to promote the wrong idea of enhanced attractiveness. For example, a picture of a famous football player playing football may be acceptable, but a picture of the same player placing bets on a football game or engaging in any form of gambling activity would not be.</li><li>DON\'T use popular characters and personalities that are predominantly attractive to minors and vulnerable persons, such as Bob the Builder, Dora the Explorer, and Tinkerbell.</li></ul><p><strong>Limitations (Commercial communications must NOT):</strong></p><ul><li>DON\'T portray, condone, or encourage behaviour that is criminal or socially irresponsible or could lead to financial, social, or emotional harm. Examples of prohibited behaviour include the use of iconic drug-related imagery and associated paraphernalia, persons known for their drug use and/or violence, individuals drinking alcohol while playing any type of casino game, or depicting a player chasing losses, gambling recklessly, or gambling reclusively. Displaying marijuana-related symbols or alcohol and/or other illicit substances with gambling is likely a breach.</li><li>DON\'T suggest that gaming can be a resolution to social, educational, professional, or personal problems.</li><li>DON\'T suggest that gaming can be an alternative to employment, a solution to financial concerns, or a form of financial investment. Example: Showing individuals in a workplace or office context, suggesting that gaming can substitute employment or assure financial gain.</li><li>DON\'T portray gaming as socially attractive or suggest it can enhance personal and/or professional qualities (e.g., improving self-image or self-esteem, or as a way to gain control, superiority, recognition, or admiration).</li><li>DON\'T portray gaming in a context of toughness or link it to resilience or recklessness.</li><li>DON\'T portray gaming as indispensable or as taking priority in life (e.g., over family, friends, or professional or educational commitments).</li><li>DON\'T suggest that solitary gaming is preferable to social gaming.</li><li>DON\'T suggest peer pressure to game or disparage abstention from gaming. Slogans like \"Bet Now!\" or placing some sort of time limitation on gambling opportunities may incite undue pressure. Offers on live odds, in-play betting, or promotions with time limits due to the nature of the event should not create an indefensible sense of urgency.</li><li>DON\'T suggest that skill can influence the outcome of a game that is purely a game of chance.</li><li>DON\'T provide false or untruthful information about the chances of winning or expected return from gaming.</li><li>DON\'T exploit cultural beliefs or traditions about gaming or luck.</li><li>DON\'T make reference to instantly available consumer credit services or any other ways of providing credit to players. Authorised persons (licensed operators) are prohibited from distributing credit to players in cash, cash bonus, or any other token.</li><li>DON\'T tarnish the goodwill and privilege associated with an authorised person (licensed Operator) or tarnish the image or reputation of another authorised person (licensed Operator).</li></ul><p><strong>Unsolicited Communications and Self-Excluded Players</strong></p><ul><li>DON\'T engage in any activity that involves the sending of unsolicited commercial communications, either through your own operation or through third parties.</li><li>DO comply with a request from any person to stop receiving solicited commercial communications as soon as reasonably practicable, but no later than three days from receipt of the request.</li><li>DON\'T target or send commercial communications to players who you know, or reasonably should have known, are undergoing a period of self-exclusion. This restriction is applicable 24 hours after the player has self-excluded.</li></ul><p><em>Note: Both the affiliate and NSUS Malta Ltd, may be held in breach if an affiliate compiles a mailing list and sends promotional material on behalf of NSUS Malta Ltd to a self-excluded player.</em></p><p><strong>Data Protection</strong></p><ul><li>DON\'T use statistical data gathered about players to urge or induce any person fitting the profile of a person with a gaming problem to play.</li><li>DO adhere to applicable data protection legislation (e.g., Data Protection Act (Cap. 440 of the Laws of Malta) and General Data Protection Regulation (EU 2016/679)).</li><li>DO take the necessary responsible gaming action deemed most suitable when analytical tools or behaviour-monitoring systems identify a problem gambler, instead of using the analysis to urge them to play.</li></ul><p><strong>No Attempt to Induce</strong></p><ul><li>DON\'T attempt to induce any player to continue playing when they have shown the intention to stop the gaming session.</li><li>Inducements such as free spins, bonus credit, or freebies of any kind cannot be offered upon showing the intention to stop.</li><li>This includes personal contact or electronic communications, but excludes pop-ups intended only for the player to confirm termination of the session.</li></ul><p><strong>Social Media</strong></p><ul><li>DO ensure all commercial communications on, within, or via social media account portals held by authorised persons (Licensed operators) or collaborating third parties are subject to the Regulations in their entirety.</li><li>DO consider using tools like age-gating, where available on the platform, to further protect minors and mitigate exposure to underage players. Failure to use such age-gating facilities, shall be a breach.</li></ul><p><strong>Public Places</strong></p><ul><li>DON\'T issue or distribute commercial communications in any public place, or in or on any means of public transportation in Malta. A \"public place\" is a physical space generally open and accessible to the general public, including public squares, parks, beaches, roads, streets, and privately owned buildings or property visible from public thoroughfares. \"Public transportation\" includes adverts displayed in and/or on buses, taxis, and other public transport vehicles. The use of vehicle wrapping measures is prohibited for public transportation vehicles.</li></ul><p><strong>Exceptions (Where the restriction does NOT apply):</strong></p><ul><li>Within authorised gaming premises or any work environment used by an authorised person (licensed operator)</li><li>Locations frequented mainly by tourists (airports, seaports, hotels, and holiday complexes - not including bars and restaurants).</li><li>Conferences or events specifically organised in relation to the gaming sector.</li><li>Premises of operators.</li><li>Premises of organisers or beneficiaries of authorised low-risk games.</li><li>Newspapers or magazines.</li><li>Sponsored events.</li></ul><h3 class=faq-subsection-title>Responsible Gaming</h3><p><strong>Responsible Gaming Messages</strong></p><ul><li>DO prominently include educational responsible gaming messaging within all commercial communications related to gaming.</li><li>DO clearly display the message \'Play Responsibly\' (or similar meaning).</li><li>DO ensure the message amounts to a minimum of 10% of the advertisement.</li><li>DO use alternative means, such as click-throughs, when the message\'s inclusion is impractical due to spatial limitation (e.g., on screens of portable communications devices).</li></ul><p><strong>Web-portal of Entity Devoted to Responsible Gaming</strong></p><ul><li>DO carry the web-portal address of any entity devoted to responsible gaming on all commercial communications.</li><li>DO present the address in a manner that is clearly legible.</li><li>DO use alternative means (e.g., click-throughs) when impractical due to spatial limitation (e.g., on screens of portable communications devices). If using click-throughs, the landing page should be no further than two clicks away. The landing page should be either the operator\'s own page for responsible gaming or a web-portal of an entity with a related objective.</li></ul><p><em>Note: If the responsible gaming entity\'s website includes a clear responsible gaming message, the \'responsible gaming message\' requirement can be substituted by the \'reference to a website of an entity devoted to responsible gaming\' requirement, provided the website address is displayed or read out clearly. In such a case, the website reference must amount to a minimum of 10% of the advertisement.</em></p><h3 class=faq-subsection-title>Protection of Minors and Vulnerable Persons</h3><p><strong>Minimum Age</strong></p><ul><li>DO prominently display a sign indicating the minimum age (18) to participate in the game being promoted for the entire duration of all commercial communications (except sponsorships).</li><li>DO ensure the minimum age sign is easily seen and not unnoticed to the naked eye.</li></ul><p><em>Note: This requirement must be considered when allocating the minimum 10% spatial requirement for the responsible gambling message.</em></p><p><strong>Restrictions</strong></p><ul><li>DON\'T direct commercial communications towards minors or vulnerable persons.</li><li>DON\'T encourage or target minors or vulnerable persons to play a game.</li><li>DON\'T feature minors.</li><li>DON\'T appeal to minors or vulnerable persons in any way.</li><li>DON\'T exploit the susceptibilities, aspirations, credibility, inexperience, or lack of knowledge of minors or vulnerable persons.</li><li>DON\'T present gaming as a sign of maturity or a move to adulthood.</li><li>DON\'T include material that could cause psychological, moral, or physical harm to vulnerable persons.</li></ul><h3 class=faq-subsection-title>Sponsorships</h3><p><strong>General</strong></p><ul><li>DO limit sponsorship to text, logo, or imagery that serves the exclusive purpose of identifying the authorised person (licensed operator).</li><li>DON\'T include product placement. Sponsorship graphics should exclusively include the authorised person\'s (licensed operator) official logo, not specific product offerings, characters, or game types.</li></ul><p><strong>Sponsorships and Related Services</strong></p><p>Where the gaming service is related to the sponsored party or event:</p><ul><li>DON\'T exert undue influence on representatives of the sponsored party or persons who can influence or have insider knowledge about the sponsored event.</li><li>DON\'T imply any involvement in the management of the sponsored activities as a result of the sponsorship.</li></ul><p><strong>Prohibited Sponsorships</strong></p><ul><li>DON\'T sponsor activities where the majority of the audience is reasonably expected to be composed of minors or vulnerable persons, or which have particular appeal to them (e.g., Junior Eurovision Song Contest pre-party, festivals predominantly for minors, or children\'s movie premieres).</li><li>DON\'T sponsor minors or persons of legal gaming age portrayed as minors.</li></ul><p><em>Note: Sponsoring events predominantly attended by adults, or teams composed of adults, which might include the involvement of one or more minors (e.g., a minor playing in a water polo senior team) is lawful.</em></p><p><strong>Merchandising</strong></p><ul><li>DON\'T cause any promotional material (including logos or text) to appear in merchandising designed for or mainly aimed at minors. Examples include children\'s clothing, soft toys, and pacifiers. While adult merchandise may feature the logo, it shall not be displayed on the version intended for minors (e.g., sports kits/uniforms).</li></ul><p><strong>Televised Programmes</strong></p><ul><li>DON\'T sponsor or advertise in televised programmes that have or are expected to have particular appeal to minors or vulnerable persons.</li><li>DO make a careful assessment as to whether televised programmes have particular appeal to minors before carrying out sponsorship or advertising.</li></ul><h3 class=faq-subsection-title>Misleading and Unfair Promotional Schemes</h3><p><strong>Promotional Schemes</strong></p><ul><li>DO ensure promotional schemes operated by authorised persons (licensed operators) are subject to the Consumers Affairs Act.</li><li>DO ensure any promotional scheme alleging to grant an advantage or opportunity is not misleading.</li><li>DO ensure the scheme is clear about the extent of the commitment the consumer must make to take advantage of any offer.</li><li>DON\'T omit or hide material information, or present it in a manner that is unclear, unintelligible, or ambiguous.</li><li>DO delineate with sufficient prominence all material information, including wagering and/or deposit requirements, using examples for clarity, and all applicable restrictions or other conditions in a clear and unambiguous manner.</li><li>DO include terms and conditions referring to all material information. DO ensure players expressly agree to the terms and conditions before being enrolled (e.g., by entering a bonus code or accepting a pop-up prompt). DO ensure terms and conditions are always readily available and accessible to the subscribed player. DO inform the subscribed player of newly revised terms and conditions after notifying the Authority (MGA) of material changes, providing the player a choice to accept or reject them.</li><li>DO ensure players can constantly view their progress in fulfilling the requirements to benefit from the opportunity or advantage.</li></ul><p><strong>Promotion or Advertisement Limited by Time or Space</strong></p><ul><li>DO include as much material information as is practical when the promotion or advertisement is limited by time or space.</li><li>DO direct players to an easily accessible alternative source where all the material information is prominently displayed. For digital advertisements, the material information should be displayed no further than one click away from the advertisement itself.</li></ul><p><em>Note: This one-click proviso does not apply to commercial communications conveyed via broadcasting means.</em></p><h3 class=faq-subsection-title>Exemptions</h3><ul><li>Commercial communications whose sole purpose is to inform the public of an opportunity for employment or for an educational purpose are exempt from the Regulations.</li><li>DON\'T include any reference to a gaming service in the exempt commercial communications.</li><li>DO ensure it is clear to the public that the sole purpose is recruitment and/or educational purposes, and the communication cannot be construed as having marketing or promotional connotations.</li><li>DO ensure at least seventy-five (75%) of the text and/or imagery and/or time (as applicable) of the commercial communication relates solely to such employment or educational information.</li></ul></div></accordion-group-content></accordion-group><accordion-group><accordion-group-heading><accordion-group-button><div class=faq-question><i class=\"fa fa-chevron-right\"></i><span>BR - Brazil</span></div></accordion-group-button></accordion-group-heading><accordion-group-content><div class=faq-answer><h3 class=faq-subsection-title>1. Overview and Governance</h3><p>The purpose of these guidelines is to reduce legal and reputational risks, ensuring that the entire affiliate network in Brazil operates in compliance with local regulations and brand values.</p><dl class=faq-params-list><dt>Responsibility</dt><dd>The partner is fully responsible for all published content.</dd><dt>Consequences</dt><dd>Non-compliance may result in immediate campaign suspension, commission withholding, or termination of the agreement.</dd></dl><h3 class=faq-subsection-title>2. Content Standards and Responsible Gaming</h3><p>In Brazil, all communication must be guided by transparency and user protection. All materials, including landing pages, banners, social media, and emails, must clearly include:</p><dl class=faq-params-list><dt>Age Notice</dt><dd>\"For players aged 18 and over only.\"</dd><dt>Responsible Gaming Message</dt><dd>\"Play responsibly.\"</dd><dt>Product Positioning</dt><dd>Poker must be presented strictly as entertainment, recreation, or a skill-based game.</dd></dl><h3 class=faq-subsection-title>3. Ethical and Promotional Restrictions</h3><p>To protect the integrity of the ecosystem, the following practices are prohibited:</p><dl class=faq-params-list><dt>Financial Claims</dt><dd>It is strictly prohibited to suggest that poker is a solution for debt, a guaranteed source of income, or a path to a luxury lifestyle.</dd><dt>Direct Incentives</dt><dd>Offering cashback or other independent financial incentives without prior approval is not allowed.</dd><dt>Neutrality</dt><dd>Content must not include political, religious, sexual, or discriminatory topics.</dd></dl><h3 class=faq-subsection-title>4. Brand Protection and Assets</h3><p>Visual consistency is essential for strong brand recognition in the Brazilian market:</p><dl class=faq-params-list><dt>Logo Usage</dt><dd>Only official files may be used, with no distortion, color changes, or typography modifications.</dd><dt>Spacing</dt><dd>Clear space requirements and official element positioning must be respected.</dd><dt>Brand Integrity</dt><dd>Impersonating official accounts or running brand bidding without authorization is strictly prohibited.</dd></dl><p>Link to brand guidelines, logos, and assets: <a href=\"https://drive.google.com/drive/folders/1yUVpE8v-w5YCkhdZtdW_nx4-yqf3Pg15?usp=sharing\" target=_blank>https://drive.google.com/drive/folders/1yUVpE8v-w5YCkhdZtdW_nx4-yqf3Pg15?usp=sharing</a></p><h3 class=faq-subsection-title>5. Quality and Transparency</h3><dl class=faq-params-list><dt>Accuracy</dt><dd>The use of false testimonials, unrealistic earnings claims, or guaranteed prizes is prohibited.</dd><dt>Traffic Practices</dt><dd>Unauthorized incentivized traffic and spam, including email and SMS, are not allowed.</dd><dt>Bonus Clarity</dt><dd>All bonus terms and conditions must be presented clearly and without misleading information.</dd></dl><h3 class=faq-subsection-title>6. Approval Process</h3><p>To ensure proper alignment before going live:</p><ul><li>Creative materials and custom promotions must be approved by the marketing team.</li><li>Any questions should be addressed directly with your Affiliate Manager.</li></ul></div></accordion-group-content></accordion-group></accordion></md-card-content><div class=card-footer></div></md-card></div>");
$templateCache.put("app/affiliate/get_ref_link/partials/creative_code_tmp.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div ng-bind=$ctrl.creativeTitle class=dialog-title></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'list.modal_window.creative_code\'\"></md-translate></label><textarea id=creative-code-area ng-model=$ctrl.clickUrl ng-readonly=true></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=$ctrl.closePopup()><md-translate key=::$ctrl.translate_key shortcode=\"\'list.modal_window.button_cancel\'\"></md-translate></md-button><md-button clipboard data-clipboard-target=#creative-code-area class=md-primary success=$ctrl.copySuccess()><md-translate key=::$ctrl.translate_key shortcode=\"\'list.modal_window.button_copy\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/affiliate/get_ref_link/partials/form.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::$ctrl.translate_key shortcode=\"\'get_creatives_link.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px ng-if=$ctrl.showFilter><form name=$ctrl.refParamsForm><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'get_creatives_link.form.merchant\'\"></md-translate></label><md-select input-errors md-select-label-translate name=merchant ng-model=$ctrl.params.merchant ng-change=\"$ctrl.changeFilterParams(\'merchant\')\"><md-option ng-value=item.id ng-repeat=\"item in $ctrl.merchantsList\"><span ng-bind=item.value></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=$ctrl.errors input-name=merchant></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'get_creatives_link.form.condition_type\'\"></md-translate></label><md-select input-errors md-select-label-translate name=condition_type ng-model=$ctrl.params.condition_type ng-change=\"$ctrl.changeFilterParams(\'condition_type\')\" ng-disabled=\"$ctrl.disableField(\'condition_type\')\"><md-option ng-value=item ng-repeat=\"item in $ctrl.conditionTypes\"><md-translate key=\"\'AdminConditions\'\" shortcode=\"\'main_params.form.\' + item\"></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=$ctrl.errors input-name=condition_type></md-error-messages></md-input-container><virtual-select list=$ctrl.trackersList ng-model=$ctrl.params.tracker errors=$ctrl.errors name=tracker ng-change=\"$ctrl.changeFilterParams(\'tracker\')\" ng-disabled=\"$ctrl.disableField(\'tracker\')\" save-prop=value show-prop=label><label><md-translate key=\"\'AffiliateRefLink\'\" shortcode=\"\'get_creatives_link.form.tracker\'\"></md-translate></label><virtual-item-content><span ng-bind=item.label></span></virtual-item-content></virtual-select><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'get_creatives_link.form.creative_type\'\"></md-translate></label><md-select input-errors md-select-label-translate name=creative_type ng-model=$ctrl.params.creative_type ng-change=\"$ctrl.changeFilterParams(\'creative_type\')\" ng-disabled=\"$ctrl.disableField(\'creative_type\')\"><md-option ng-value=item ng-repeat=\"item in $ctrl.creativeTypes\"><md-translate key=\"\'AdminCreatives\'\" shortcode=\"\'creatives_tab.\' + item\"></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=$ctrl.errors input-name=creative_type></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'get_creatives_link.form.language\'\"></md-translate></label><md-select input-errors md-select-label-translate name=language ng-model=$ctrl.params.language ng-change=\"$ctrl.changeFilterParams(\'language\')\" ng-disabled=\"$ctrl.disableField(\'language\')\"><md-option ng-value=item ng-repeat=\"item in $ctrl.languagesList\"><translate>{{\'creative.list_locales.\' + item}}</translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=$ctrl.errors input-name=language></md-error-messages></md-input-container><virtual-select list=$ctrl.sizesList ng-model=$ctrl.params.size errors=$ctrl.errors name=size ng-change=\"$ctrl.changeFilterParams(\'size\')\" save-prop=creative_resolution_id show-prop=value options=$ctrl.virtualSelectOpts ng-disabled=\"$ctrl.disableField(\'size\')\" ng-if=!$ctrl.hideSizeField><label><md-translate key=\"\'AffiliateRefLink\'\" shortcode=\"\'get_creatives_link.form.size\'\"></md-translate></label><virtual-item-content><span ng-if=\"item.translate_key &amp;&amp; item.shortcode\"><md-translate key=item.translate_key shortcode=item.shortcode></md-translate></span><span ng-if=\"!(item.translate_key &amp;&amp; item.shortcode)\"><span ng-bind=item.value></span></span></virtual-item-content></virtual-select><virtual-select list=$ctrl.campaignesList ng-model=$ctrl.params.campaign errors=$ctrl.errors name=campaign save-prop=creative_advertising_company_id show-prop=value options=$ctrl.virtualSelectOpts ng-disabled=\"$ctrl.disableField(\'campaign\')\"><label><md-translate key=\"\'AffiliateRefLink\'\" shortcode=\"\'get_creatives_link.form.campaign\'\"></md-translate></label><virtual-item-content><span ng-if=\"item.translate_key &amp;&amp; item.shortcode\"><md-translate key=item.translate_key shortcode=item.shortcode></md-translate></span><span ng-if=\"!(item.translate_key &amp;&amp; item.shortcode)\"><span ng-bind=item.value></span></span></virtual-item-content></virtual-select></form></div></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=$ctrl.goToListPage() ng-disabled=$ctrl.isNotValidSomeField()><md-translate key=::$ctrl.translate_key shortcode=\"\'get_creatives_link.get_link_button\'\"></md-translate></md-button></div></div></div></md-card></div></ui-view>");
$templateCache.put("app/affiliate/get_ref_link/partials/list.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::$ctrl.translate_key shortcode=\"\'get_creatives_link.list.header\'\"></md-translate></div><div flex=nogrow class=search-block><table-list-search table=$ctrl.table></table-list-search></div></div></div><div class=card-content><table-list table=$ctrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=btn-transparent ng-click=$ctrl.back()><md-translate key=::$ctrl.translate_key shortcode=\"\'get_creatives_link.list.back\'\"></md-translate></md-button></div><table-list-pagination table=$ctrl.table></table-list-pagination></div></div></md-card></div>");
$templateCache.put("app/affiliate/get_ref_link/partials/table.html","<md-button hide show-gt-xs class=\"md-button md-primary btn-primary\" ng-click=\"table.config.buttons.methods.viewCreativeImage(item, $event)\" ng-if=table.config.buttons.methods.viewCreativeImage><md-translate key=\"\'AffiliateRefLink\'\" shortcode=\"\'get_creatives_link.list.preview_button\'\"></md-translate></md-button><md-button hide-gt-xs class=md-icon-button ng-click=\"table.config.buttons.methods.viewCreativeImage(item, $event)\" ng-if=table.config.buttons.methods.viewCreativeImage><i class=\"fa fa-eye\"></i></md-button><md-button hide show-gt-xs class=\"md-button md-primary btn-primary\" ng-click=\"table.config.buttons.methods.viewCreativeCode(item, $event)\"><md-translate key=\"\'AffiliateRefLink\'\" shortcode=\"\'get_creatives_link.list.view_code_button\'\"></md-translate></md-button><md-button hide-gt-xs class=md-icon-button ng-click=\"table.config.buttons.methods.viewCreativeCode(item, $event)\"><i class=\"fa fa-code\"></i></md-button><md-button hide show-gt-xs clipboard data-clipboard-text=\"{{item.url || item.url_js}}\" success=table.config.buttons.methods.copySuccess() class=\"md-button md-primary btn-primary\"><md-translate key=\"\'AffiliateRefLink\'\" shortcode=\"\'get_creatives_link.list.copy_code_button\'\"></md-translate></md-button><md-button hide-gt-xs clipboard data-clipboard-text=\"{{item.url || item.url_js}}\" success=table.config.buttons.methods.copySuccess() class=md-icon-button><i class=\"fa fa-clone\"></i></md-button>");
$templateCache.put("app/affiliate/info_pages/partials/info_page.html","<div class=view-content><md-card class=primary-card><div layout-gt-xs=row layout=column layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::$ctrl.translate_key shortcode=\"::$ctrl.currentPage + \'.header\'\"></md-translate></div><div class=\"space-around last-update-info-page\"><md-translate key=::$ctrl.translate_key shortcode=\"::$ctrl.currentPage + \'.last_update\'\"></md-translate><strong date-locale={{$ctrl.updatedAt}} format=LLL></strong></div></div><md-card-content class=padding-content><div ng-bind-html=$ctrl.contentPage class=text-editor></div></md-card-content><div class=card-footer></div></md-card></div>");
$templateCache.put("app/affiliate/profile_settings/partials/buttons.html","<md-button has-permission permission permission-only=\"\'api2.affiliate.settingscontroller.edit\'\" class=\"md-raised md-primary btn-primary\" ng-if=profile_affiliate.tabs.activeTab.submitFn md-click=profile_affiliate.tabs.activeTab.submitFn()><md-translate key=::profile_affiliate.translate_key shortcode=\"\'profile_settings.save\'\"></md-translate></md-button>");
$templateCache.put("app/affiliate/profile_settings/partials/settings.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::profile_affiliate.translate_key shortcode=\"\'profile_settings.header\'\"></md-translate></div></div><div flex=100 class=mt-30><tabs-list tabs-name=affiliate_profile></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=affiliate_profile view-name=content></tabs-content></md-card-content><div class=card-footer><div class=button-holder><tabs-content tabs-name=affiliate_profile view-name=buttons></tabs-content></div></div></md-card></div>");
$templateCache.put("app/affiliate/trackers/partials/condition.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=\"\'AffiliateTrackers\'\" shortcode=\"\'condition.header\'\"></md-translate></div></div><md-card-content class=padding-content><div ng-if=\"settings.condition_instance &amp;&amp; settings.show_content\"><div ng-include=\"\'app/admin/conditions/partials/form.html\'\"></div><div ng-include=\"\'app/admin/conditions/partials/filter_template.html\'\"></div><div ng-include=settings.condition_url></div></div><div ng-if=\"!settings.condition_instance &amp;&amp; settings.show_content\"><div class=font-size-large><md-translate key=\"\'AffiliateTrackers\'\" shortcode=\"\'condition.condition_is_absent\'\"></md-translate></div></div></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=btn-transparent ng-click=settings.back()><md-translate key=\"\'AffiliateTrackers\'\" shortcode=\"\'condition.back\'\"></md-translate></md-button></div></div></div></md-card></div>");
$templateCache.put("app/affiliate/trackers/partials/form.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::$ctrl.translate_key shortcode=\"::$ctrl.shortcodePart + \'.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><form name=$ctrl.saveTrackerForm><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"::$ctrl.shortcodePart + \'.description\'\"></md-translate></label><textarea input-errors required md-no-asterisk ng-model=$ctrl.tracker.description name=description></textarea><md-error-messages errors=$ctrl.errors input-name=description></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=$ctrl.cancel()><md-translate key=::$ctrl.translate_key shortcode=\"::$ctrl.shortcodePart + \'.button_cancel\'\"></md-translate></md-button><md-button class=md-primary md-click=$ctrl.saveTracker()><md-translate key=::$ctrl.translate_key shortcode=\"::$ctrl.shortcodePart + \'.button_save\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/affiliate/trackers/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.affiliate.creativescontroller.show\'\" class=md-icon-button ng-click=table.config.buttons.methods.affiliateCreatives(item)><i class=\"fa fa-link\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.affiliate.trackerscontroller.edit\'\" class=md-icon-button ng-click=\"table.config.buttons.methods.editDescription(item, $event)\"><i class=\"fa fa-pencil-square-o\"></i></md-button>");
$templateCache.put("app/affiliate/trackers/partials/trackers.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::affiliate_tracker.translate_key shortcode=\"\'trackers.header\'\"></md-translate></div><div class=search-block><table-list-search table=affiliate_tracker.table></table-list-search></div></div><div class=card-content><table-list table=affiliate_tracker.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button ng-disabled=affiliate_tracker.disabledCreateBtn() class=\"md-raised md-primary btn-primary\" ng-click=affiliate_tracker.addTracker($event)><md-translate key=::affiliate_tracker.translate_key shortcode=\"\'trackers.button_add_tracker\'\"></md-translate></md-button><span class=\"additional-info align-center space-around\"><span class=color-grey><md-translate key=::affiliate_tracker.translate_key shortcode=\"\'trackers.available_tracker\'\"></md-translate></span><strong><span ng-bind=affiliate_tracker.available_trackers></span></strong></span></div><table-list-pagination table=affiliate_tracker.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/affiliate/webhooks/partials/condition_modal.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::modal.translate_key shortcode=\"\'condition.modal.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><form name=modal.addConditionForm><md-input-container class=md-block><label><md-translate key=::modal.translate_key shortcode=\"\'condition.modal.form.obtained_result\'\"></md-translate></label><md-select input-errors md-select-label-translate name=obtained_result ng-model=modal.condition.obtained_result><md-option ng-value=key ng-repeat=\"(key, value) in modal.options_for_conditions.obtained_result\"><span ng-bind=value></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=modal.errors input-name=obtained_result></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::modal.translate_key shortcode=\"\'condition.modal.form.condition_for_comparison\'\"></md-translate></label><md-select input-errors md-select-label-translate name=condition_for_comparison ng-model=modal.condition.condition_for_comparison ng-change=modal.check_any_parametr()><md-option ng-value=value ng-repeat=\"value in modal.options_for_conditions.condition_for_comparison[modal.condition.obtained_result]\"><span ng-bind=value></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=modal.errors input-name=condition_for_comparison></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"modal.condition.condition_for_comparison !== \'any\'\"><label><md-translate key=::modal.translate_key shortcode=\"\'condition.modal.form.desired_value\'\"></md-translate></label><input input-errors name=desired_value ng-model=modal.condition.desired_value type=number><md-error-messages errors=modal.errors input-name=desired_value></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=modal.cancel()><md-translate key=::modal.translate_key shortcode=\"\'condition.modal.cancel\'\"></md-translate></md-button><md-button class=md-primary ng-click=modal.save()><md-translate key=::modal.translate_key shortcode=\"\'condition.modal.save\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/affiliate/webhooks/partials/create_webhook_modal.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::createCtrl.translate_key shortcode=\"\'create_modal.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><form name=createCtrl.createWebhookForm><md-input-container class=md-block><label><md-translate key=::createCtrl.translate_key shortcode=\"\'create_modal.webhook_type\'\"></md-translate></label><md-select input-errors md-select-label-translate name=webhook_type ng-model=createCtrl.webhook_type><md-option ng-value=type ng-repeat=\"type in createCtrl.types_list\"><md-translate key=::createCtrl.translate_key shortcode=\"::type +\'.tab_name\'\"></md-translate></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=createCtrl.errors input-name=webhook_type></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=createCtrl.cancel()><md-translate key=::createCtrl.translate_key shortcode=\"\'create_modal.cancel\'\"></md-translate></md-button><md-button class=md-primary md-click=createCtrl.save()><md-translate key=::createCtrl.translate_key shortcode=\"\'create_modal.save\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/affiliate/webhooks/partials/list.html","<table-list table=tabCtrl.table></table-list>");
$templateCache.put("app/affiliate/webhooks/partials/pagination.html","<table-list-pagination table=$ctrl.tabs.activeTab.table></table-list-pagination>");
$templateCache.put("app/affiliate/webhooks/partials/search.html","<table-list-search table=$ctrl.tabs.activeTab.table></table-list-search>");
$templateCache.put("app/affiliate/webhooks/partials/table.html","<md-button md-ink-ripple=false class=\"md-icon-button toggle-box\" ng-class=\"{\'enabled\': item.active, \'disabled\': !item.active, \'disabled\': item.build}\" ng-click=\"table.config.buttons.methods.update(item, $event)\"><span class=toggle-bar></span><span class=toggle-thumb-container><span class=toggle-thumb></span></span></md-button><md-button class=md-icon-button ng-click=table.config.buttons.methods.edit(item)><i class=\"fa fa-pencil-square-o\"></i></md-button>");
$templateCache.put("app/affiliate/webhooks/partials/url_constructor.html","<div class=url-constructor><label class=top-label><md-translate key=::translateKey shortcode=\"\'url_constructor.label\'\"></md-translate></label><div layout-gt-xs=row layout=column class=url-display><div flex-gt-xs=none flex-xs=100 class=request-method><form name=urlCtrl.requestMethodForm><md-input-container md-no-float class=md-block><md-select input-errors name=request_method ng-model=webhook.request_method ng-change=urlCtrl.change_webhook(0) placeholder=\"{{\'url_constructor.request_method\' | mdTranslate: translateKey}}\"><md-option ng-value=method ng-repeat=\"method in requestMethods\"><span ng-bind=\"method | uppercase\"></span></md-option></md-select><md-error-messages errors=urlCtrl.errors input-name=request_method></md-error-messages></md-input-container></form></div><div flex-gt-xs=grow flex-xs=100 class=url-output><form name=urlCtrl.uriForm><md-input-container md-no-float class=md-block><textarea input-errors name=uri ng-model=webhook.uri placeholder=\"{{\'url_constructor.url\' | mdTranslate: translateKey}}\" ng-change=urlCtrl.change_webhook()></textarea><md-error-messages errors=urlCtrl.errors input-name=uri></md-error-messages></md-input-container></form></div></div><div class=url-result><md-input-container md-no-float class=md-block><textarea ng-model=urlCtrl.url_result placeholder=\"{{\'url_constructor.result_url\' | mdTranslate: translateKey}}\" ng-readonly=true ng-disabled=true></textarea></md-input-container></div><form name=urlCtrl.keyForm><div class=url-parametrs-wrap><div class=url-parametrs><div class=parametrs-header><div class=row><div class=cell></div><div class=cell><md-translate key=::translateKey shortcode=\"\'url_constructor.table.header.key\'\"></md-translate></div><div class=cell><md-translate key=::translateKey shortcode=\"\'url_constructor.table.header.value\'\"></md-translate></div><div class=cell><md-translate key=::translateKey shortcode=\"\'url_constructor.table.header.description\'\"></md-translate></div><div class=cell></div></div></div><div class=parametrs-body><div ng-repeat=\"opts in urlCtrl.default_uri_options\" class=row><div class=cell><md-input-container class=md-block><md-checkbox ng-model=opts.active class=\"md-primary primary-checkbox\" ng-change=\"urlCtrl.update_uri_default_options(opts, 0)\" ng-disabled=allDisabled></md-checkbox></md-input-container></div><div class=cell><md-input-container md-no-float class=md-block><input type=text ng-model=opts.key ng-change=urlCtrl.update_uri_default_options(opts) placeholder=\"{{\'url_constructor.table.body.placeholder_key\' | mdTranslate: translateKey}}\" ng-disabled=allDisabled></md-input-container></div><div class=cell><md-input-container class=md-block><input type=text ng-value=opts.value ng-readonly=true></md-input-container></div><div class=cell><md-input-container class=md-block><textarea ng-readonly=true>{{opts.description | translate}}</textarea></md-input-container></div><div class=cell></div></div><div ng-repeat=\"opts in urlCtrl.custom_uri_options\" class=row><div class=cell><md-input-container class=md-block><md-checkbox ng-model=opts.active class=\"md-primary primary-checkbox\" ng-change=\"urlCtrl.update_uri_custom_options(opts, 0)\" ng-disabled=\"opts.disable || allDisabled\"></md-checkbox></md-input-container></div><div class=cell><md-input-container md-no-float class=md-block><input type=text name=\"{{opts.id ? (opts.id + \'\') : \'key\'}}\" ng-model=opts.key ng-change=urlCtrl.update_uri_custom_options(opts) placeholder=\"{{\'url_constructor.table.body.placeholder_key\' | mdTranslate: translateKey}}\" ng-disabled=\"opts.disable || allDisabled\"><div ng-messages=urlCtrl.keyForm.$error role=alert><div ng-message-exp=\"opts.id ? (opts.id + \'\') : \'key\'\"><div class=error-message ng-repeat=\"err in urlCtrl.error_key_message\"><translate>{{err}}</translate></div></div></div></md-input-container></div><div class=cell><md-input-container md-no-float class=md-block><input type=text ng-model=opts.value ng-change=urlCtrl.update_uri_custom_options(opts) placeholder=\"{{\'url_constructor.table.body.placeholder_value\' | mdTranslate: translateKey}}\" ng-disabled=\"opts.disable || allDisabled\"></md-input-container></div><div class=cell><md-input-container md-no-float class=md-block><textarea ng-model=opts.description ng-change=urlCtrl.update_uri_custom_options(opts) placeholder=\"{{\'url_constructor.table.body.placeholder_description\' | mdTranslate: translateKey}}\" ng-disabled=\"opts.disable || allDisabled\"></textarea></md-input-container></div><div class=cell><md-button class=md-icon-button ng-click=urlCtrl.remove_option(opts) ng-if=opts.id><img src=assets/images/cross.png></md-button></div></div></div></div></div></form></div>");
$templateCache.put("app/affiliate/webhooks/partials/webhooks.html","<ui-view><div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><span ng-if=webhooksCtrl.isAdmin><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'admin.webhooks.header\'\"></md-translate><span ng-bind=webhooksCtrl.affiliateInfo></span></span><span ng-if=!webhooksCtrl.isAdmin><md-translate key=::webhooksCtrl.translate_key shortcode=\"\'webhooks.header\'\"></md-translate></span></div><div flex=nogrow class=search-block><tabs-content tabs-name=webhooks view-name=search></tabs-content></div></div><div flex=100 class=\"tabs-wrap mt-30\"><tabs-list tabs-name=webhooks></tabs-list></div></div><div class=card-content><tabs-content tabs-name=webhooks view-name=content></tabs-content></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=webhooksCtrl.createWebhook($event)><md-translate key=::webhooksCtrl.translate_key shortcode=\"\'webhooks.add_webhook\'\"></md-translate></md-button><md-button ng-if=webhooksCtrl.isAdmin class=btn-transparent ng-click=webhooksCtrl.back()><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'admin.webhooks.back\'\"></md-translate></md-button></div><tabs-content tabs-name=webhooks view-name=pagination></tabs-content></div></div></md-card></div></ui-view>");
$templateCache.put("app/affiliate/webhooks/partials/webhooks_settings.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div class=card-title><span ng-if=settingsCtrl.isAdmin><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'admin.webhook_settings.header\'\"></md-translate><span ng-bind=webhooksCtrl.affiliateInfo></span></span><span ng-if=!settingsCtrl.isAdmin><md-translate key=::settingsCtrl.translate_key shortcode=\"\'webhook_settings.header\'\"></md-translate></span></div></div><md-card-content class=padding-content><div ng-show=settingsCtrl.show_content class=content-holder><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'webhook_settings.webhook_type\'\"></md-translate></label><input type=text ng-value=\"settingsCtrl.webhook.kind + \'.tab_name\' | mdTranslate: settingsCtrl.translate_key\" ng-readonly=true></md-input-container></div><url-constructor uri-options=settingsCtrl.uri_options webhook=settingsCtrl.webhook request-methods=settingsCtrl.request_methods translate-key=settingsCtrl.translate_key webhook-callback=settingsCtrl.update_webhook() options-callback=settingsCtrl.update_uri_options(option) remove-callback=settingsCtrl.remove_uri_option(option) all-disabled=settingsCtrl.disabled_all></url-constructor><div row-restrict max-width=450px><div class=checkboxes-wrapper><md-input-container class=\"md-block mb-10\"><md-checkbox ng-model=settingsCtrl.webhook.success_confirmation class=\"md-primary primary-checkbox\" ng-change=settingsCtrl.update_webhook() ng-disabled=settingsCtrl.disabled_all><md-translate key=::settingsCtrl.translate_key shortcode=\"\'webhook_settings.success_confirmation\'\"></md-translate></md-checkbox></md-input-container><md-input-container class=md-block><md-checkbox ng-model=settingsCtrl.webhook.active class=\"md-primary primary-checkbox\" ng-change=settingsCtrl.update_webhook() ng-disabled=settingsCtrl.disabled_all><md-translate key=::settingsCtrl.translate_key shortcode=\"\'webhook_settings.active\'\"></md-translate></md-checkbox></md-input-container></div></div><div ng-if=settingsCtrl.options_for_conditions class=\"conditions-list-holder mb-30\"><div><label class=top-label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'condition.label\'\"></md-translate></label><div ng-click=\"settingsCtrl.set_condition($event, condition)\" ng-repeat=\"condition in settingsCtrl.conditions track by $index\" class=condition-wrap><span ng-if=\"condition.obtained_result || condition.condition_for_comparison || condition.desired_value\" class=space-around><span ng-bind=condition.obtained_result></span><span ng-bind=condition.condition_for_comparison></span><span ng-bind=condition.desired_value></span></span><span ng-if=\"!condition.obtained_result &amp;&amp; !condition.condition_for_comparison &amp;&amp; !condition.desired_value\"><md-translate key=::settingsCtrl.translate_key shortcode=\"\'condition.set_condition\'\"></md-translate></span><md-button class=\"md-icon-button remove-condition-btn\" ng-click=\"settingsCtrl.removeCondition($event, condition)\" ng-if=\"settingsCtrl.conditions.length &gt; 1\"><img src=assets/images/cross.png></md-button></div><md-button class=\"btn-light md-button add-condition-btn\" ng-click=settingsCtrl.addCondition($event) ng-if=settingsCtrl.showAddConditionBtn() ng-disabled=settingsCtrl.disabled_all><i class=\"fa fa-plus\"></i><md-translate key=::settingsCtrl.translate_key shortcode=\"\'condition.add_condition_btn\'\"></md-translate></md-button></div></div><div row-restrict max-width=450px><div class=mb-30><label class=top-label><md-translate key=::settingsCtrl.translate_key shortcode=\"\'webhook_settings.checkboxes_label\'\"></md-translate></label><checkbox-list list=settingsCtrl.serial_ids field-name=value callback=settingsCtrl.save_trackers all-disabled=settingsCtrl.disabled_all></checkbox-list></div></div></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=btn-transparent ng-click=settingsCtrl.back()><md-translate key=::settingsCtrl.translate_key shortcode=\"\'webhook_settings.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/affiliate/webhooks_history/partials/table.html","<md-button class=md-icon-button ng-click=table.config.buttons.methods.showDetails(item)><i class=\"fa fa-eye\"></i></md-button>");
$templateCache.put("app/affiliate/webhooks_history/partials/webhooks_history.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::webhooksHistoryCtrl.translate_key shortcode=\"\'webhooks_history.header\'\"></md-translate></div><div class=search-block><table-list-search table=webhooksHistoryCtrl.table></table-list-search></div></div><div class=card-content><table-list table=webhooksHistoryCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=webhooksHistoryCtrl.downloadPermission class=\"md-raised md-primary btn-primary\" ng-click=webhooksHistoryCtrl.downloadReport($event)><md-translate key=::webhooksHistoryCtrl.translate_key shortcode=\"\'webhooks_history.download_report\'\"></md-translate></md-button></div><table-list-pagination table=webhooksHistoryCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/affiliate/webhooks_history/partials/webhooks_history_details.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::historyDetailsCtrl.translate_key shortcode=\"\'webhooks_history_details.header\'\"></md-translate></div><div class=search-block><table-list-search table=historyDetailsCtrl.table></table-list-search></div></div><div class=card-content><table-list table=historyDetailsCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=btn-transparent ng-click=historyDetailsCtrl.back()><md-translate key=::historyDetailsCtrl.translate_key shortcode=\"\'webhooks_history_details.back\'\"></md-translate></md-button></div><table-list-pagination table=historyDetailsCtrl.table></table-list-pagination></div></div></md-card></div>");
$templateCache.put("app/admin/partners_balances/partials/balance_adjustment.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::adjustmentCtrl.translate_key shortcode=\"\'balance_adjustment.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=adjustmentCtrl.balanceAdjustmentForm><md-input-container class=md-block><label><md-translate key=::adjustmentCtrl.translate_key shortcode=\"\'balance_adjustment.form.affiliate\'\"></md-translate></label><input type=text ng-value=adjustmentCtrl.affiliate ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::adjustmentCtrl.translate_key shortcode=\"\'balance_adjustment.form.current_balance\'\"></md-translate></label><input name=current_amount type=text ng-value=adjustmentCtrl.partnerBalance.current_balance ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::adjustmentCtrl.translate_key shortcode=\"\'balance_adjustment.form.balance_amount\'\"></md-translate></label><input input-errors name=amount type=number ng-model=adjustmentCtrl.partnerBalance.amount><md-error-messages errors=adjustmentCtrl.errors input-name=amount></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::adjustmentCtrl.translate_key shortcode=\"\'balance_adjustment.form.comment\'\"></md-translate></label><textarea input-errors name=comment ng-model=adjustmentCtrl.partnerBalance.comment></textarea><md-error-messages errors=adjustmentCtrl.errors input-name=comment></md-error-messages></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.affiliates_balances_edit\'\" class=\"md-raised md-primary btn-primary\" md-click=adjustmentCtrl.makeBalanceAdjustment($event)><md-translate key=::adjustmentCtrl.translate_key shortcode=\"\'balance_adjustment.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=adjustmentCtrl.back()><md-translate key=::adjustmentCtrl.translate_key shortcode=\"\'balance_adjustment.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/partners_balances/partials/partners_balances.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::balancesCtrl.translate_key shortcode=\"\'partners_balances.header\'\"></md-translate></div><div class=search-block><table-list-search table=balancesCtrl.table></table-list-search></div></div><div class=card-content><table-list table=balancesCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.affiliates_balances_download\'\" class=\"md-raised md-primary btn-primary\" ng-click=balancesCtrl.downloadReport($event)><md-translate key=::balancesCtrl.translate_key shortcode=\"\'partners_balances.download_report_button\'\"></md-translate></md-button></div><table-list-pagination table=balancesCtrl.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/partners_balances/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.affiliates_balances_edit\'\" class=md-icon-button ng-click=table.config.buttons.methods.balanceAdjustment(item)><i class=\"fa fa-pencil-square-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatecashoutscontroller.withdrawals_create\'\" class=md-icon-button ng-click=table.config.buttons.methods.goToPartnerBalance(item)><i class=\"fa fa-money\"></i></md-button>");
$templateCache.put("app/admin/partners/list/partials/change_manager_modal.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::partners.translate_key shortcode=\"\'choose_manager.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=md-dialog-content-body><form name=partners.changeManagerForm class=last-item-no-margin><md-input-container class=md-block><label><md-translate key=::partners.translate_key shortcode=\"\'choose_manager.choose_manager_label\'\"></md-translate></label><select-with-search list=partners.managersList ng-model=partners.managerId errors=partners.errors name=manager_id save-prop=id options=\"{prop_for_value: \'name\'}\" ng-required=true><span ng-bind=value.name></span></select-with-search></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=partners.cancel()><md-translate key=::partners.translate_key shortcode=\"\'choose_manager.cancel\'\"></md-translate></md-button><md-button class=md-primary md-click=partners.chooseManager()><md-translate key=::partners.translate_key shortcode=\"\'choose_manager.ok\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/partners/list/partials/partners.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::partners.translate_key shortcode=\"\'list_partners.header\'\"></md-translate></div><div class=search-block><table-list-search table=partners.table></table-list-search></div></div><div class=card-content><table-list table=partners.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.download_list_approved\'\" class=\"md-raised md-primary btn-primary\" ng-click=partners.downloadReport($event)><md-translate key=::partners.translate_key shortcode=\"\'list_partners.download_report\'\"></md-translate></md-button></div><table-list-pagination table=partners.table></table-list-pagination></div></div></md-card></div></ui-view>");
$templateCache.put("app/admin/partners/list/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.show\'\" class=md-icon-button ng-click=table.config.buttons.methods.view_partner(item.id)><i class=\"fa fa-address-card-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.supervision\'\" class=md-icon-button ng-click=table.config.buttons.methods.supervision(item.id)><i class=\"fa fa-eye\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.show\'\" class=md-icon-button ng-click=table.config.buttons.methods.view_partner_tracker(item.id)><i class=\"fa fa-handshake-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.show\'\" class=\"md-icon-button partner-webhooks\" ng-click=table.config.buttons.methods.partnerWebhooks(item.id)><i class=\"fa fa-window-restore\"></i></md-button><span has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.change_ban_status\'\" ng-if=\"table.doesColumnExist(\'status\')\"><md-button class=md-icon-button ng-click=\"table.config.buttons.methods.changeStatus(item, $event)\"><i class=fa ng-class=\"{\'fa-lock\': item.status === \'blocked\', \'fa-unlock-alt\': item.status === \'active\'}\"></i></md-button></span>");
$templateCache.put("app/admin/partners/profile/partials/buttons.html","<md-button class=\"md-raised md-primary btn-primary\" ng-if=parnterSetting.tabs.activeTab.submitFn md-click=parnterSetting.tabs.activeTab.submitFn()><md-translate key=::parnterSetting.translate_key shortcode=\"\'setting.save\'\"></md-translate></md-button>");
$templateCache.put("app/admin/partners/profile/partials/contact_information.html","<div row-restrict max-width=450px><form name=parnterSetting.contactInformationForm><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'contact_information.form.email\'\"></md-translate></label><input input-errors type=email name=email ng-model=parnterSetting.partner.email><md-error-messages errors=parnterSetting.errors input-name=email></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'contact_information.form.skype\'\"></md-translate></label><input input-errors type=text name=skype ng-model=parnterSetting.partner.skype><md-error-messages errors=parnterSetting.errors input-name=skype></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'contact_information.form.telegram\'\"></md-translate></label><input input-errors type=text name=telegram ng-model=parnterSetting.partner.telegram><md-error-messages errors=parnterSetting.errors input-name=telegram></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'contact_information.form.phone_number\'\"></md-translate></label><input input-errors type=tel name=phone_number ng-model=parnterSetting.partner.phone_number><md-error-messages errors=parnterSetting.errors input-name=phone_number></md-error-messages></md-input-container><md-input-container class=md-block><md-checkbox class=\"md-primary primary-checkbox md-align-top-left\" ng-model=parnterSetting.partner.agree_receive_emails><md-translate key=::parnterSetting.translate_key shortcode=\"\'contact_information.form.agree_receive_emails\'\"></md-translate></md-checkbox></md-input-container></form></div>");
$templateCache.put("app/admin/partners/profile/partials/main_data.html","<div row-restrict max-width=450px><form name=parnterSetting.mainDataForm><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.name\'\"></md-translate></label><input input-errors name=name type=text ng-model=parnterSetting.partner.name><md-error-messages errors=parnterSetting.errors input-name=name></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.surname\'\"></md-translate></label><input input-errors name=surname type=text ng-model=parnterSetting.partner.surname><md-error-messages errors=parnterSetting.errors input-name=surname></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.username\'\"></md-translate></label><input input-errors name=username type=text ng-model=parnterSetting.partner.username><md-error-messages errors=parnterSetting.errors input-name=username></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.birthday\'\"></md-translate></label><mod-datepicker ng-model=parnterSetting.partner.birthday errors=parnterSetting.errors name=birthday model-format=\"\'YYYY-MM-DD\'\"></mod-datepicker></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.site_url\'\"></md-translate></label><input input-errors name=site_url type=url ng-model=parnterSetting.partner.site_url><md-error-messages errors=parnterSetting.errors input-name=site_url></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.role\'\"></md-translate></label><select-with-search list=parnterSetting.roles_list ng-model=parnterSetting.partner.role_id errors=parnterSetting.errors name=role_id save-prop=id options=\"{prop_for_value: \'name\'}\"><span ng-bind=value.name></span></select-with-search></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.affiliate_type\'\"></md-translate></label><md-select input-errors name=affiliate_type ng-model=parnterSetting.partner.affiliate_type><md-option ng-value=\"\'\'\"></md-option><md-option ng-value=type ng-repeat=\"type in parnterSetting.affiliate_types\">{{type}}</md-option></md-select><md-error-messages errors=parnterSetting.errors input-name=affiliate_type></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.chief\'\"></md-translate></label><select-with-search list=parnterSetting.chiefs_list ng-model=parnterSetting.partner.chief_id errors=parnterSetting.errors name=chief_id save-prop=id options=\"{prop_for_value: \'name\'}\"><span ng-bind=value.name></span></select-with-search></md-input-container><md-input-container class=\"md-block md-input-has-value\" ng-if=parnterSetting.isStatusEnabled><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.status.header\'\"></md-translate></label><md-switch input-errors class=\"md-primary md-switch-input mb-none switch-banned\" name=banned ng-model=parnterSetting.partner.banned><div ng-if=parnterSetting.partner.banned><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.status.banned\'\"></md-translate></div><div ng-if=!parnterSetting.partner.banned><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.status.unbanned\'\"></md-translate></div></md-switch><div class=md-errors-spacer></div><md-error-messages errors=parnterSetting.errors input-name=banned></md-error-messages><div ng-show=parnterSetting.partner.ban_status_name class=signature><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.status.owner\'\" translate-values=\"{ ban_status_name: parnterSetting.partner.ban_status_name, ban_status_chaged_at: parnterSetting.partner.ban_status_chaged_at }\"></md-translate></div></md-input-container><md-input-container class=\"md-block md-input-has-value\" ng-if=parnterSetting.mayResetAuth><label class=md-switch-label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.mfa_enabled_label\'\"></md-translate></label><md-switch input-errors class=\"md-primary md-switch-input mb-none switch-banned\" name=mfa_enabled ng-model=parnterSetting.partner.mfa_enabled ng-disabled=!parnterSetting.twoFactorEnabled><div ng-if=parnterSetting.partner.mfa_enabled><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.mfa_enabled\'\"></md-translate></div><div ng-if=!parnterSetting.partner.mfa_enabled><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.mfa_disabled\'\"></md-translate></div></md-switch><div class=md-errors-spacer></div><md-error-messages errors=parnterSetting.errors input-name=mfa_enabled></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.about_affiliate\'\"></md-translate></label><textarea input-errors name=about_affiliate ng-model=parnterSetting.partner.about_affiliate></textarea><md-error-messages errors=parnterSetting.errors input-name=about_affiliate></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'main_data.form.admin_note\'\"></md-translate></label><textarea input-errors name=admin_note ng-model=parnterSetting.partner.admin_note></textarea><md-error-messages errors=parnterSetting.errors input-name=admin_note></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/admin/partners/profile/partials/manual_subaffiliate.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=parnterSetting.manualSubaffiliateForm><virtual-select list=parnterSetting.affiliates_list ng-model=parnterSetting.partner.affiliate_invitation_id errors=parnterSetting.errors name=affiliate_invitation_id save-prop=id show-prop=name options=\"{prop_for_value: \'name\'}\"><label><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'manual_subaffiliate.form.affiliate_invitation_id\'\"></md-translate></label><virtual-item-content><span ng-bind=item.name></span></virtual-item-content></virtual-select><md-input-container class=md-block><label><md-translate key=::parnterSetting.translate_key shortcode=\"\'manual_subaffiliate.form.date\'\"></md-translate></label><mod-datepicker ng-model=parnterSetting.partner.date errors=parnterSetting.errors name=date md-mode=month></mod-datepicker></md-input-container></form></div>");
$templateCache.put("app/admin/partners/profile/partials/payment_information.html","<form name=parnterSetting.paymentDetailsForm><payment-systems-details type=\"\'select\'\" name=parnterSetting.paymentDetailsName payment-systems=parnterSetting.paymentSystems countries-list=parnterSetting.countriesList current-system=parnterSetting.currentSystem default-payment-system-id=parnterSetting.partner.payment_method_id errors=parnterSetting.errors></payment-systems-details></form>");
$templateCache.put("app/admin/partners/profile/partials/profile.html","<div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::parnterSetting.translate_key shortcode=\"\'setting.header\'\"></md-translate></div></div><div flex=100 class=mt-30><tabs-list tabs-name=partner_profile></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=partner_profile view-name=content></tabs-content></md-card-content><div class=card-footer><div class=button-holder><tabs-content tabs-name=partner_profile view-name=buttons></tabs-content><md-button class=btn-transparent ng-click=parnterSetting.back()><md-translate key=::parnterSetting.translate_key shortcode=\"\'setting.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/partners/settings/partials/settings.html","<ui-view><div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=::settingsCtrl.translate_key shortcode=\"\'tracker_settings.header\'\"></md-translate></div><div flex=nogrow class=search-block><tabs-content tabs-name=partners_settings view-name=search></tabs-content></div></div><div flex=100 class=\"tabs-wrap mt-30\"><tabs-list tabs-name=partners_settings></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=partners_settings view-name=content></tabs-content></md-card-content><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><tabs-content tabs-name=partners_settings view-name=buttons></tabs-content><md-button class=btn-transparent ng-click=settingsCtrl.back()><md-translate key=::settingsCtrl.translate_key shortcode=\"\'tracker_settings.back\'\"></md-translate></md-button></div><tabs-content tabs-name=partners_settings view-name=pagination></tabs-content></div></div></md-card><tabs-content tabs-name=partners_settings view-name=history_changes></tabs-content></div></ui-view>");
$templateCache.put("app/admin/profile_settings/confirmation_email/partials/confirmation_email.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=profileConfirmEmail.confirmEmailForm><md-input-container class=md-block><label><md-translate key=::profileConfirmEmail.translate_key shortcode=\"\'confirmation_email.token\'\"></md-translate></label><input input-errors type=text name=confirmation_token ng-model=profileConfirmEmail.token><md-error-messages errors=profileConfirmEmail.errors input-name=confirmation_token></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/admin/profile_settings/email/partials/email.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=profileEmail.editEmailForm><md-input-container class=md-block><label><md-translate key=::profileEmail.translate_key shortcode=\"\'email.current_email\'\"></md-translate></label><input input-errors type=text name=email ng-model=profileEmail.user.email><md-error-messages errors=profileEmail.errors input-name=email></md-error-messages></md-input-container><md-input-container class=md-block ng-if=profileEmail.user.unconfirmed_email><label><md-translate key=::profileEmail.translate_key shortcode=\"\'email.unconfirmed_email\'\"></md-translate></label><input input-errors type=text name=unconfirmed_email ng-model=profileEmail.user.unconfirmed_email><md-error-messages errors=profileEmail.errors input-name=unconfirmed_email></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileEmail.translate_key shortcode=\"\'email.current_password\'\"></md-translate></label><input input-errors type=password name=current_password ng-model=profileEmail.user.current_password><md-error-messages errors=profileEmail.errors input-name=current_password></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/admin/profile_settings/main/partials/main.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=profileMain.editNameForm><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.name\'\"></md-translate></label><input input-errors type=text name=name ng-model=profileMain.user.name><md-error-messages errors=profileMain.errors input-name=name></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.skype\'\"></md-translate></label><input input-errors type=text name=skype ng-model=profileMain.user.skype><md-error-messages errors=profileMain.errors input-name=skype></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/admin/profile_settings/password/partials/password.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=profilePassword.editPasswordForm><md-input-container class=md-block><label><md-translate key=::profilePassword.translate_key shortcode=\"\'password.password\'\"></md-translate></label><input input-errors type=password name=password ng-model=profilePassword.user.password><md-error-messages errors=profilePassword.errors input-name=password></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profilePassword.translate_key shortcode=\"\'password.password_confirmation\'\"></md-translate></label><input input-errors type=password name=password_confirmation ng-model=profilePassword.user.password_confirmation><md-error-messages errors=profilePassword.errors input-name=password_confirmation></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profilePassword.translate_key shortcode=\"\'password.current_password\'\"></md-translate></label><input input-errors type=password name=current_password ng-model=profilePassword.user.current_password><md-error-messages errors=profilePassword.errors input-name=current_password></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/admin/profile_settings/two_factor_authentication/partials/two_factor_authentication.html","<div row-restrict max-width=450px><div style=\"padding: 16px; margin-bottom: 20px; background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; color: #856404; font-weight: 500; display: flex; align-items: center\" ng-if=!profileTwoFactorAuth.user.mfa_enabled><span style=\"color: #ffc107; font-size: 20px; margin-right: 8px; line-height: 1\">⚠</span><span><md-translate key=::profileTwoFactorAuth.translate_key shortcode=\"\'two_factor_authentication.mfa_required_notice\'\"></md-translate></span></div><form name=profileTwoFactorAuth.mfaAuthForm><md-input-container class=md-block ng-if=\"!profileTwoFactorAuth.user.mfa_enabled &amp;&amp; !profileTwoFactorAuth.user.showSecretKey\"><label><md-translate key=::profileTwoFactorAuth.translate_key shortcode=\"\'two_factor_authentication.current_password\'\"></md-translate></label><input input-errors type=password name=password ng-model=profileTwoFactorAuth.user.current_password required><md-error-messages errors=profileTwoFactorAuth.errors input-name=password></md-error-messages></md-input-container><md-input-container class=md-block ng-if=profileTwoFactorAuth.user.showSecretKey><label><md-translate key=::profileTwoFactorAuth.translate_key shortcode=\"\'two_factor_authentication.secret_value\'\"></md-translate></label><input type=text name=secret_value ng-value=profileTwoFactorAuth.user.secretValue ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=\"profileTwoFactorAuth.user.showSecretKey || profileTwoFactorAuth.user.mfa_enabled\"><label><md-translate key=::profileTwoFactorAuth.translate_key shortcode=\"profileTwoFactorAuth.user.mfa_enabled ? \'two_factor_authentication.enter_mfa_code_for_disable\' : \'two_factor_authentication.enter_mfa_code_for_enable\'\" watch-shortcode=true></md-translate></label><input input-errors type=text name=mfa_code ng-model=profileTwoFactorAuth.user.mfaCode required><md-error-messages errors=profileTwoFactorAuth.errors input-name=mfa_code></md-error-messages></md-input-container><div ng-if=profileTwoFactorAuth.user.showSecretKey><img ng-src={{profileTwoFactorAuth.user.qrUri}}></div></form></div>");
$templateCache.put("app/admin/settings/admin_fees/partials/admin_fees.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=feesCtrl.feesForm><md-input-container class=md-block><label><md-translate key=::feesCtrl.translate_key shortcode=\"\'admin_fees.count_from\'\"></md-translate></label><md-select input-errors md-select-label-translate name=count_from ng-model=feesCtrl.params.feeColumn><md-option ng-value=value ng-repeat=\"(key, value) in feesCtrl.columns\"><span ng-bind=key></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=feesCtrl.errors input-name=count_from></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::feesCtrl.translate_key shortcode=\"\'admin_fees.percent\'\"></md-translate></label><input input-errors type=number name=percent ng-model=feesCtrl.params.limit><md-error-messages errors=feesCtrl.errors input-name=percent></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::feesCtrl.translate_key shortcode=\"\'admin_fees.date\'\"></md-translate></label><mod-datepicker ng-model=feesCtrl.params.date name=date md-mode=month md-min-date=feesCtrl.startDate errors=feesCtrl.errors></mod-datepicker></md-input-container></form></div>");
$templateCache.put("app/admin/settings/admin_fees/partials/history_changes.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::history.translate_key shortcode=\"\'admin_fees.history_changes.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=history.historyCnahgeForm><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'admin_fees.history_changes.count_from\'\"></md-translate></label><md-select input-errors md-select-label-translate name=count_from ng-model=history.history_item.feeColumn><md-option ng-value=value ng-repeat=\"(key, value) in history.columns\"><span ng-bind=key></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=history.errors input-name=count_from></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'admin_fees.history_changes.percent\'\"></md-translate></label><input input-errors type=number name=percent ng-model=history.history_item.limit><md-error-messages errors=history.errors input-name=percent></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'admin_fees.history_changes.date\'\"></md-translate></label><mod-datepicker ng-model=history.history_item.date name=date md-mode=month md-min-date=history.startDate errors=history.errors></mod-datepicker></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=history.saveHistory()><md-translate key=::history.translate_key shortcode=\"\'admin_fees.history_changes.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=history.back()><md-translate key=::history.translate_key shortcode=\"\'admin_fees.history_changes.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/settings/affiliate_auto_approve/partials/affiliate_approve_settings.html","<div layout=row class=affiliate-approve-settings><div flex=none flex-sm=40 flex-xs=100 class=approve-wrap><div class=approve-admins-search><md-input-container class=\"md-block cross-btn\"><md-icon><i class=\"fa fa-search\"></i></md-icon><input type=text name=admin-search ng-model=$ctrl.query[$ctrl.queryField] autocomplete=off><span ng-if=$ctrl.query[$ctrl.queryField] ng-click=$ctrl.clearQuery() class=clear-search><img src=assets/images/cross.png></span></md-input-container></div><div class=approve-admins-list><div ng-repeat=\"admin in $ctrl.admins | filter: $ctrl.query as filteredList\" class=approve-admin-item><md-button layout=row class=approve-admin-btn ng-click=\"$ctrl.applyAdminSelection(admin, $event)\" ng-class=\"{\'current\': $ctrl.currentAdmin.id === admin.id}\"><span class=not-empty ng-if=!$ctrl.isEmptyAdmin(admin)></span><span ng-bind=admin[$ctrl.queryField]></span><span flex=none class=btn-clear ng-click=\"$ctrl.clearAdmin(admin, $event)\" ng-if=!$ctrl.isEmptyAdmin(admin)><img src=assets/images/cross.png></span></md-button></div><div ng-if=!filteredList.length class=not-found-admins><md-translate key=::$ctrl.translateKey shortcode=\"\'affiliate_auto_approve.admins_have_not_been_found\'\"></md-translate></div></div></div><div flex flex-sm=60 ng-if=$ctrl.isGtXs class=approve-langs-wrap><checkbox-list ng-if=$ctrl.currentAdmin list=$ctrl.languages field-name=value callback=$ctrl.selectLangs value-translate-namespace=$ctrl.langsNamespace></checkbox-list></div></div><div layout-wrap layout=row layout-xs=column class=find-lang-wrap><div flex=50 flex-xs=100 class=lang-select><div layout-wrap layout=row><md-input-container flex class=md-block><label><md-translate key=::$ctrl.translateKey shortcode=\"\'affiliate_auto_approve.select_language_for_searching_admin\'\"></md-translate></label><select-with-search list=$ctrl.langs ng-model=$ctrl.currentLang ng-change=$ctrl.changeLang() options=\"{translate_key: \'Languages\', shortcode: \'language.{{part}}\', search_in_translate: true}\"><md-translate key=\"\'Languages\'\" shortcode=\"\'language.\' + value\"></md-translate></select-with-search></md-input-container><md-button flex=none ng-if=$ctrl.currentLang class=md-icon-button ng-click=$ctrl.clearLangSelect()><img src=assets/images/cross.png></md-button></div></div><div flex=50 flex-xs=100 class=lang-select-result><div ng-if=\"!$ctrl.adminForLang &amp;&amp; $ctrl.currentLang\" class=not-found-admins><md-translate key=::$ctrl.translateKey shortcode=\"\'affiliate_auto_approve.admins_have_not_been_found\'\"></md-translate></div><md-button class=\"md-raised md-primary btn-primary\" ng-if=$ctrl.adminForLang ng-click=$ctrl.findAdminInList()><span ng-bind=$ctrl.adminForLang[$ctrl.queryField]></span></md-button></div></div>");
$templateCache.put("app/admin/settings/affiliate_auto_approve/partials/affiliate_auto_approve.html","<div row-restrict max-width=450px><form name=approveCtrl.autoApproveForm><md-input-container class=\"md-block switch-container md-input-focused\"><label><md-translate key=::approveCtrl.translate_key shortcode=\"\'affiliate_auto_approve.auto_accept_affiliate_request\'\"></md-translate></label><md-switch ng-model=approveCtrl.autoApprove class=\"md-primary toggle-permission switch-inside-input-container\"></md-switch><div class=switch-border-bottom></div><div class=errors-reserve></div></md-input-container><md-input-container flex class=md-block><label><md-translate key=::approveCtrl.translate_key shortcode=\"\'affiliate_auto_approve.select_admin_for_all_languages\'\"></md-translate></label><select-with-search list=approveCtrl.adminsList ng-model=approveCtrl.defaultApproveAdmin save-prop=id errors=approveCtrl.errors name=admin_id_for_all_locales options=\"{prop_for_value: \'value\'}\"><span ng-bind=value.value></span></select-with-search></md-input-container></form></div><div class=affiliate-approve-settings-wrap><affiliate-approve-settings model=approveCtrl.model admins=approveCtrl.adminsList langs=approveCtrl.langsList query-field=value></affiliate-approve-settings><div class=affiliate-approve-errors><div ng-repeat=\"err in approveCtrl.localizedAdminsErrors\" class=approve-errors-item><translate>{{err}}</translate><span class=remove-approve-error-btn ng-click=approveCtrl.removeError(err)><i class=\"fa fa-times\"></i></span></div></div></div>");
$templateCache.put("app/admin/settings/affiliate_auto_approve/partials/modal.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><span ng-bind=$ctrl.currentAdmin.value></span></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=$ctrl.closeMobilePopup()></md-button></span></div><md-dialog-content class=md-dialog-content><div flex class=filter-columns-tab-content><checkbox-list ng-if=$ctrl.currentAdmin list=$ctrl.languages field-name=value callback=$ctrl.selectLangs value-translate-namespace=$ctrl.langsNamespace></checkbox-list></div></md-dialog-content></md-dialog>");
$templateCache.put("app/admin/settings/affiliate_banner/partials/affiliate_banner.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=affBannerCtrl.bannerForm><input-file-area ng-model=affBannerCtrl.banner.image is-required=true options=affBannerCtrl.bannerInputOptions errors=affBannerCtrl.errors callback=\"affBannerCtrl.updateBanner(data, file)\"></input-file-area><md-input-container class=md-block><label><md-translate key=::affBannerCtrl.translate_key shortcode=\"\'affiliate_banner.link\'\"></md-translate></label><input input-errors type=text name=link ng-model=affBannerCtrl.banner.link><md-error-messages errors=affBannerCtrl.errors input-name=link></md-error-messages></md-input-container><md-input-container class=md-block><md-checkbox class=\"primary-checkbox md-primary\" ng-model=affBannerCtrl.banner.enabled><md-translate key=::affBannerCtrl.translate_key shortcode=\"\'affiliate_banner.enabled\'\"></md-translate></md-checkbox></md-input-container></form><div layout=row layout-align=\"center start\" layout-align-gt-xs=\"start start\"><md-button ng-disabled=!affBannerCtrl.canBePreviewed class=\"btn-transparent preview-banner-btn\" ng-click=affBannerCtrl.preview($event)><md-translate key=::affBannerCtrl.translate_key shortcode=\"\'affiliate_banner.preview_banner_btn\'\"></md-translate></md-button></div></div>");
$templateCache.put("app/admin/settings/bookkeeping/partials/bookkeeping.html","<div row-restrict max-width=450px class=last-item-no-margin translate-namespace=.{{bookkeeping.tab_name}}><form name=bookkeeping.mimimumAmountForm translate-namespace=.form><md-input-container class=md-block><label><md-translate key=bookkeeping.translate_key shortcode=\"\'bookkeeping.limit\'\"></md-translate></label><input input-errors type=number name=limit ng-model=bookkeeping.params.limit><md-error-messages errors=bookkeeping.errors input-name=limit></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=bookkeeping.translate_key shortcode=\"\'bookkeeping.date\'\"></md-translate></label><mod-datepicker ng-model=bookkeeping.params.date name=date md-mode=month errors=bookkeeping.errors></mod-datepicker></md-input-container></form></div>");
$templateCache.put("app/admin/settings/bookkeeping/partials/history_changes.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=history.translate_key shortcode=\"\'bookkeeping.history_changes.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=history.historyCnahgeForm translate-namespace=.form><md-input-container class=md-block><label><md-translate key=history.translate_key shortcode=\"\'bookkeeping.history_changes.limit\'\"></md-translate></label><input input-errors type=number name=limit ng-model=history.history_item.limit><md-error-messages errors=history.errors input-name=limit></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=history.translate_key shortcode=\"\'bookkeeping.history_changes.date\'\"></md-translate></label><mod-datepicker ng-model=history.history_item.date name=date md-mode=month errors=history.errors></mod-datepicker></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=history.save_history()><md-translate key=history.translate_key shortcode=\"\'bookkeeping.history_changes.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=history.back()><md-translate key=history.translate_key shortcode=\"\'bookkeeping.history_changes.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/settings/click_domains/partials/add_domain.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::addCtrl.translate_key shortcode=\"\'add_domain.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=addCtrl.domainForm><md-input-container class=md-block><label><md-translate key=::addCtrl.translate_key shortcode=\"\'add_domain.form.domain\'\"></md-translate></label><input input-errors type=text name=domain ng-model=addCtrl.domain><md-error-messages errors=addCtrl.errors input-name=domain></md-error-messages></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=addCtrl.save()><md-translate key=::addCtrl.translate_key shortcode=\"\'add_domain.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=addCtrl.back()><md-translate key=::addCtrl.translate_key shortcode=\"\'add_domain.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/settings/click_domains/partials/click_domains.html","<div layout-gt-xs=row layout=column layout-align-gt-xs=\"start start\" layout-align=\"start center\"><div row-restrict max-width=450px class=click-domains-wrap><form name=clickCtrl.saveForm><md-input-container ng-if=clickCtrl.saveDomainPerm class=md-block><label><md-translate key=::clickCtrl.translate_key shortcode=\"\'form.default_domain\'\"></md-translate></label><select-with-search list=clickCtrl.domainsList ng-model=clickCtrl.defaultDomainId errors=clickCtrl.errors name=click_domain save-prop=id options=\"{prop_for_value: \'domain\'}\" ng-required=true><span ng-bind=value.domain></span></select-with-search></md-input-container><md-input-container ng-if=!clickCtrl.saveDomainPerm class=md-block><label><md-translate key=::clickCtrl.translate_key shortcode=\"\'form.default_domain\'\"></md-translate></label><input type=text ng-value=clickCtrl.defaultDomainName ng-readonly=true></md-input-container></form></div><div class=add-domain-wrap><md-button ng-if=clickCtrl.saveDomainPerm class=btn-transparent md-click=clickCtrl.addDomain()><md-translate key=::clickCtrl.translate_key shortcode=\"\'click_domains.add_domain\'\"></md-translate></md-button></div></div>");
$templateCache.put("app/admin/settings/columns/partials/columns.html","<div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=columns.translate_key shortcode=\"\'columns.choose_settings\'\"></md-translate></label><md-select md-select-label-translate ng-model=columns.current_settings><md-option ng-value=type ng-repeat=\"type in columns.settings_types\"><md-translate key=columns.translate_key shortcode=\"\'columns.\' + type + \'_name\'\"></md-translate></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div class=settings-type-wrap><div layout=row layout-align=\"space-between start\" ng-if=\"columns.current_settings === \'structures_columns\'\" class=dnd-list-wrap><div flex ng-repeat=\"(listName, list) in columns.dnd_lists.structures_columns\" class=dnd-list><div class=list-name><md-translate key=columns.translate_key shortcode=\"\'structures_columns.\' + listName\"></md-translate></div><ul dnd-list=list dnd-drop=\"columns.dnd_lists.drop(list, item, index)\"><li ng-repeat=\"item in list\" dnd-draggable=item dnd-moved=\"list.splice($index, 1)\" dnd-effect-allowed=move dnd-selected=columns.set_selected(item) ng-class=\"{\'selected\': columns.dnd_lists.selected === item}\" dnd-dragend=columns.drag_end()><translate>{{::columns.columnsNamespace + item}}</translate></li></ul></div></div><div layout=row layout-align=\"space-between start\" ng-if=\"columns.current_settings === \'statistics_columns\'\" class=dnd-list-wrap><div flex=none class=dnd-list><div class=list-name><md-translate key=columns.translate_key shortcode=\"\'statistics_columns.players_statistics_columns\'\"></md-translate></div><ul dnd-list=columns.dnd_lists.statistics_columns dnd-drop=\"columns.dnd_lists.drop(columns.dnd_lists.statistics_columns, item, index)\" class=cf><li ng-repeat=\"item in columns.dnd_lists.statistics_columns\" dnd-draggable=item dnd-moved=\"columns.dnd_lists.statistics_columns.splice($index, 1)\" dnd-effect-allowed=move dnd-selected=columns.set_selected(item) ng-class=\"{\'selected\': columns.dnd_lists.selected === item}\" dnd-dragend=columns.drag_end()><translate>{{::columns.columnsNamespace + item}}</translate></li></ul></div></div></div>");
$templateCache.put("app/admin/settings/columns_for_tables/partials/columns_for_tables.html","<ui-view><div><md-translate key=::columnsCtrl.translate_key shortcode=\"\'columns_for_tables.tables\'\"></md-translate><tables-nav list=columnsCtrl.tablesMap active-table-key=columnsCtrl.tableKey></tables-nav></div></ui-view>");
$templateCache.put("app/admin/settings/columns_for_tables/partials/settings_table_columns.html","<div ng-bind=settingsCtrl.table.locale_key class=\"md-subhead mt-30\"></div><div layout=row layout-align=\"space-between start\" class=\"dnd-list-wrap mt-30\"><div flex ng-repeat=\"(listName, list) in settingsCtrl.dnd_lists.columns\" class=dnd-list><div class=list-name><md-translate key=::settingsCtrl.translate_key shortcode=\"\'columns_for_tables.columns_\' + listName\"></md-translate></div><ul dnd-list=list dnd-drop=\"settingsCtrl.dnd_lists.drop(list, item, index)\"><li ng-repeat=\"item in list\" dnd-draggable=item dnd-moved=\"list.splice($index, 1)\" dnd-dragstart=\"settingsCtrl.dnd_lists.itemControl(item, listName)\" dnd-effect-allowed=move dnd-selected=settingsCtrl.set_selected(item) ng-class=\"{\'selected\': settingsCtrl.dnd_lists.selected === item}\" dnd-dragend=settingsCtrl.drag_end(item)><translate>{{settingsCtrl.table.locale_key + \'.\' + item.name}}</translate></li></ul></div></div><div class=\"button-holder mt-30\"><md-button class=btn-transparent ng-click=settingsCtrl.back()><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings_table_columns.back\'\"></md-translate></md-button></div>");
$templateCache.put("app/admin/settings/columns_for_tables/partials/tables_nav.html","<div class=angular-tree><ol><li tables-nav-item ng-repeat=\"item in $ctrl.list\"></li></ol></div>");
$templateCache.put("app/admin/settings/columns_for_tables/partials/tables_nav_item.html","<div class=\"tree-node tree-node-content angular-tree-handle\" ng-class=\"{\'active\': !item.folder &amp;&amp; item.key === $ctrl.activeTableKey}\"><a class=\"btn btn-success btn-xs\" ng-click=$ctrl.toggle(item) ng-if=::item.folder><i class=fa ng-class=\"{\'fa-folder\': !item.open, \'fa-folder-open\': item.open}\"></i></a><span class=edit-table-btn ng-click=$ctrl.edit(item) ng-if=::!item.folder><i class=\"fa fa-pencil-square-o\"></i></span><label class=label><span ng-bind=::item.name></span></label></div><ol ng-show=item.open><li tables-nav-item ng-repeat=\"item in item.childs\"></li></ol>");
$templateCache.put("app/admin/settings/company/partials/company.html","<div row-restrict max-width=450px><form name=company.editCompanyForm autocomplete=off><md-input-container class=md-block><label><md-translate key=::company.translate_key shortcode=\"\'company.company_name\'\"></md-translate></label><input input-errors type=text name=company_name ng-model=company.company_fields.company_name><md-error-messages errors=company.errors input-name=company_name></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::company.translate_key shortcode=\"\'company.max_trackers\'\"></md-translate></label><input input-errors type=text name=max_trackers ng-model=company.company_fields.max_trackers><md-error-messages errors=company.errors input-name=max_trackers></md-error-messages></md-input-container><md-input-container ng-repeat=\"i in [].constructor(company.countOfCreativeDomains) track by $index\" class=md-block><label><md-translate key=::company.translate_key shortcode=\"::\'company.\' + company.getCreativeDomainName($index)\"></md-translate></label><input input-errors type=text name={{::company.getCreativeDomainName($index)}} ng-model=company.company_fields[company.getCreativeDomainName($index)]><md-error-messages errors=company.errors input-name={{::company.getCreativeDomainName($index)}}></md-error-messages></md-input-container><virtual-select list=company.serial_id_list ng-model=company.company_fields.deafult_serial_id save-prop=id show-prop=value errors=company.errors name=deafult_serial_id><label><md-translate key=\"\'AdminSettings\'\" shortcode=\"\'company.deafult_serial_id\'\"></md-translate></label><virtual-item-content><span ng-bind=item.value></span></virtual-item-content></virtual-select><virtual-select list=company.creatives_list ng-model=company.company_fields.deafult_creative_id save-prop=id show-prop=value errors=company.errors name=deafult_creative_id><label><md-translate key=\"\'AdminSettings\'\" shortcode=\"\'company.deafult_creative_id\'\"></md-translate></label><virtual-item-content><span ng-bind=item.value></span></virtual-item-content></virtual-select><virtual-select list=company.conditions_list ng-model=company.company_fields.current_default_condition_id save-prop=id show-prop=value errors=company.errors name=current_default_condition_id><label><md-translate key=\"\'AdminSettings\'\" shortcode=\"\'company.default_condition\'\"></md-translate></label><virtual-item-content><span ng-bind=item.value></span></virtual-item-content></virtual-select><virtual-select list=company.subaffiliate_conditions_list ng-model=company.company_fields.current_default_subaffiliate_condition_id save-prop=id show-prop=value errors=company.errors name=current_default_subaffiliate_condition_id><label><md-translate key=\"\'AdminSettings\'\" shortcode=\"\'company.default_subaffiliate_condition\'\"></md-translate></label><virtual-item-content><span ng-bind=item.value></span></virtual-item-content></virtual-select><md-input-container class=md-block><label><md-translate key=::company.translate_key shortcode=\"\'company.title\'\"></md-translate></label><input input-errors type=text name=title ng-model=company.company_fields.title><md-error-messages errors=company.errors input-name=title></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::company.translate_key shortcode=\"\'company.currency\'\"></md-translate></label><select-with-search list=company.list_currency ng-model=company.company_fields.currency errors=company.errors name=currency set-key-as-value=true><span ng-bind=value></span></select-with-search></md-input-container><md-input-container class=md-block><label><md-translate key=company.translate_key shortcode=\"\'company.header_color\'\"></md-translate></label><input color-picker color-picker-model=company.company_fields.header_color color-picker-output-format=\"\'hex\'\" color-picker-position=top value={{::company.company_fields.header_color}} ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=company.translate_key shortcode=\"\'company.buttons_color\'\"></md-translate></label><input color-picker color-picker-model=company.company_fields.buttons_color color-picker-output-format=\"\'hex\'\" color-picker-position=top value={{::company.company_fields.buttons_color}} ng-readonly=true></md-input-container><virtual-select list=company.defaultLocalesList ng-model=company.company_fields.default_locale errors=company.errors name=default_locale save-prop=id show-prop=value options=\"{translate_key: \'Languages\', shortcode: \'language.{{part}}\', search_in_translate: true, prop_for_value: \'value\', prop_for_shortcode: \'value\'}\"><label><md-translate key=\"\'AdminSettings\'\" shortcode=\"\'company.default_language\'\"></md-translate></label><virtual-item-content><span ng-if=item.value><md-translate key=\"\'Languages\'\" shortcode=\"\'language.\' + item.value\" watch-shortcode=true></md-translate></span></virtual-item-content></virtual-select><div><label class=top-label><md-translate key=::company.translate_key shortcode=\"\'company.project_languages\'\"></md-translate></label><checkbox-list list=company.allLocales field-name=value callback=company.saveProjectLanguages value-translate-namespace=\"\'common.languages.\'\"></checkbox-list><md-input-container class=\"md-block fake-input-error\"><input input-errors type=text name=interface_locales ng-model=company.company_fields.project_languages.interface_locales><md-error-messages errors=company.errors input-name=interface_locales></md-error-messages></md-input-container></div><div class=mt-20><label class=top-label><md-translate key=::company.translate_key shortcode=\"\'company.creative_languages\'\"></md-translate></label><checkbox-list list=company.allCreativeLocales field-name=value callback=company.saveCreativeLanguages value-translate-namespace=\"\'creative.list_locales.\'\"></checkbox-list><md-input-container class=\"md-block fake-input-error\"><input input-errors type=text name=creative_locales ng-model=company.company_fields.project_languages.creative_locales><md-error-messages errors=company.errors input-name=creative_locales></md-error-messages></md-input-container></div></form></div>");
$templateCache.put("app/admin/settings/emails/partials/emails.html","<div class=\"row last-item-no-margin\"><div row-restrict max-width=450px class=emails-list><md-input-container class=md-block><label><md-translate key=emails.translate_key shortcode=\"\'emails.language\'\"></md-translate></label><select-with-search list=emails.languages ng-model=emails.current_language set-key-as-value=true options=emails.selectLanguagesOptions ng-change=emails.choose_current_email()><md-translate key=\"\'Languages\'\" shortcode=\"\'language.\' + key\"></md-translate></select-with-search></md-input-container><md-input-container class=md-block><label><md-translate key=emails.translate_key shortcode=\"\'emails.emails_list\'\"></md-translate></label><select-with-search list=emails.emails_list ng-model=emails.choosed_email_name ng-change=emails.choose_current_email() set-key-as-value=true options=\"{translate_namespace: emails.translate_namespace, search_in_translate: true, substitute_key: true, find_in_key: false}\"><translate>{{options.translate_namespace + key}}</translate></select-with-search></md-input-container></div><div ng-if=emails.current_mailer class=email-settings-wrap><div class=md-subhead><md-translate key=emails.translate_key shortcode=\"\'emails.email_settings\'\"></md-translate></div><form name=emails.saveMailerForm><md-input-container row-restrict max-width=450px class=md-block><label><md-translate key=emails.translate_key shortcode=\"\'emails.subject\'\"></md-translate></label><input input-errors type=text name=subject ng-model=emails.current_mailer.subject><md-error-messages errors=emails.errors input-name=subject></md-error-messages></md-input-container><div class=sub-title><md-translate key=emails.translate_key shortcode=\"\'emails.body\'\"></md-translate></div><text-angular text-angular-event vm=emails name=body ta-toolbar=emails.custom_toolbar ng-model=emails.current_mailer.body ta-unsafe-sanitizer=true class=\"text-editor show-dropdown\"></text-angular><md-input-container class=\"md-block fake-input-error\"><input input-errors type=text name=body ng-model=emails.fake_body><md-error-messages errors=emails.errors input-name=body variables=emails.variables_for_error></md-error-messages></md-input-container><md-input-container class=md-block ng-if=emails.canBeDisabled()><md-checkbox ng-model=emails.current_mailer.enabled class=\"md-primary primary-checkbox\"><md-translate key=::emails.translate_key shortcode=\"\'emails.enable_sending_email\'\"></md-translate></md-checkbox></md-input-container><div ng-if=!emails.canBeDisabled() class=cannot-be-disabled><span class=icon-box><i class=\"fa fa-exclamation\"></i></span><md-translate key=::emails.translate_key shortcode=\"\'emails.email_cannot_be_disabled\'\"></md-translate></div></form></div></div>");
$templateCache.put("app/admin/settings/information/partials/information.html","<div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=information.translate_key shortcode=\"\'information.language\'\"></md-translate></label><select-with-search list=information.languages ng-model=information.currentLanguage name=language set-key-as-value=true errors=information.errors options=information.selectLanguagesOptions ng-change=information.getPageInfo()><md-translate key=\"\'Languages\'\" shortcode=\"\'language.\' + key\"></md-translate></select-with-search></md-input-container><md-input-container class=md-block><label><md-translate key=information.translate_key shortcode=\"\'information.settings_type\'\"></md-translate></label><select-with-search list=information.settingsTypes ng-model=information.settingsType options=information.selectPagesOptions ng-change=information.getPageInfo()><md-translate key=\"\'AdminSettings\'\" shortcode=\"\'information.settings_\' + value\"></md-translate></select-with-search></md-input-container></div><text-angular ng-model=information.editor_content.content class=text-editor></text-angular><span class=errors-reserve></span>");
$templateCache.put("app/admin/settings/main/partials/buttons.html","<md-button class=\"md-raised md-primary btn-primary\" ng-if=settings.tabs.activeTab.submitFn md-click=settings.tabs.activeTab.submitFn()><md-translate key=settings.translate_key shortcode=\"\'general_settings.save\'\"></md-translate></md-button>");
$templateCache.put("app/admin/settings/main/partials/history_changes_view.html","<history-changes history-changes=settings.tabs.activeTab.data.historyList options-change=settings.tabs.activeTab.data.optionsChange></history-changes>");
$templateCache.put("app/admin/settings/main/partials/settings.html","<ui-view><div class=view-content><md-card class=primary-card><div layout-wrap layout=row class=card-header><div flex=100 layout=row layout-align=\"space-between center\"><div flex=none class=card-title><md-translate key=settings.translate_key shortcode=\"\'general_settings.main_title\'\"></md-translate></div></div><div flex=100 class=mt-30><tabs-list tabs-name=project_settings></tabs-list></div></div><md-card-content class=padding-content><tabs-content tabs-name=project_settings view-name=content></tabs-content></md-card-content><div class=card-footer><div class=button-holder><tabs-content tabs-name=project_settings view-name=buttons></tabs-content></div></div></md-card><tabs-content tabs-name=project_settings view-name=history_changes></tabs-content><tabs-content has-permission permission permission-only=\"\'api2.admin.banktransfercountrygroupscontroller.show\'\" tabs-name=project_settings view-name=table></tabs-content></div></ui-view>");
$templateCache.put("app/admin/settings/payment_systems/partials/group_settings.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.header\'\"></md-translate></div></div><md-card-content class=padding-content><form name=groupSettingsCtrl.groupSettingsForm><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.group_name\'\"></md-translate></label><input input-errors required md-no-asterisk name=name type=text ng-model=groupSettingsCtrl.group.name><md-error-messages errors=groupSettingsCtrl.errors input-name=name></md-error-messages></md-input-container></div><div row-restrict max-width=550px><label class=top-label><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.countries_list\'\"></md-translate></label><checkbox-list list=groupSettingsCtrl.group.countries field-name=name callback=groupSettingsCtrl.changeCountriesCallback></checkbox-list><div ng-repeat=\"errorName in groupSettingsCtrl.countriesErrors\" class=countries-errors><div ng-repeat=\"errMessage in groupSettingsCtrl.errors.errors[errorName]\"><translate>{{errMessage}}</translate></div></div></div><div row-restrict max-width=800px class=group-settings-wrap><label class=top-label><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.configure_fields\'\"></md-translate></label><div layout-wrap layout=row class=group-settings><div flex=none class=fields-wrap><div class=fields-list><div ng-repeat=\"(key, value) in groupSettingsCtrl.group.bank_transfer_validation.validation_data | filterByObjectProperties\" class=field-item><md-button layout=row class=field-btn ng-click=\"groupSettingsCtrl.selectField(key, $event)\" ng-class=\"{\'current\': groupSettingsCtrl.currentField === key}\"><span class=not-empty ng-if=!groupSettingsCtrl.isEmptyField(value)></span><md-translate key=\"\'AffiliateBalance\'\" shortcode=\"\'payment_details_form.bank_transfer.\' + key\"></md-translate><span flex=none class=btn-clear ng-click=\"groupSettingsCtrl.clearField(key, $event)\" ng-if=!groupSettingsCtrl.isEmptyField(value)><img src=assets/images/cross.png></span></md-button></div></div></div><div flex class=validations-wrap ng-if=groupSettingsCtrl.isGtXs><div ng-if=groupSettingsCtrl.currentField><md-input-container class=md-block><md-checkbox class=\"md-primary primary-checkbox\" ng-model=groupSettingsCtrl.group.bank_transfer_validation.validation_data[groupSettingsCtrl.currentField].presence><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.required_field\'\"></md-translate></md-checkbox></md-input-container><md-input-container class=md-block><label><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.min_length\'\"></md-translate></label><input name=min type=number ng-model=groupSettingsCtrl.group.bank_transfer_validation.validation_data[groupSettingsCtrl.currentField].range.min></md-input-container><md-input-container class=md-block><label><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.max_length\'\"></md-translate></label><input name=max type=number ng-model=groupSettingsCtrl.group.bank_transfer_validation.validation_data[groupSettingsCtrl.currentField].range.max></md-input-container></div></div></div></div></form></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=groupSettingsCtrl.saveGroup()><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.save_button\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=groupSettingsCtrl.back()><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.back_button\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/settings/payment_systems/partials/list.html","<md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::countryGroupsCtrl.translate_key shortcode=\"\'payment_systems.country_groups_header\'\"></md-translate></div><div class=search-block><table-list-search table=countryGroupsCtrl.table></table-list-search></div></div><div class=card-content><table-list table=countryGroupsCtrl.table></table-list></div><div class=card-footer><div layout=row layout-align=\"space-between center\" class=pagination-wrap><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=countryGroupsCtrl.addNewGroup()><md-translate key=::countryGroupsCtrl.translate_key shortcode=\"\'payment_systems.add_new_country_group\'\"></md-translate></md-button></div><table-list-pagination table=countryGroupsCtrl.table></table-list-pagination></div></div></md-card>");
$templateCache.put("app/admin/settings/payment_systems/partials/modal.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=\"\'AffiliateBalance\'\" shortcode=\"\'payment_details_form.bank_transfer.\' + groupSettingsCtrl.currentField\"></md-translate></div><span flex=none><md-button class=\"md-icon-button close-btn\" ng-click=groupSettingsCtrl.closeMobilePopup()></md-button></span></div><md-dialog-content class=md-dialog-content><div flex class=filter-columns-tab-content><div class=validations-wrap><form><md-input-container class=md-block><md-checkbox class=\"md-primary primary-checkbox\" ng-model=groupSettingsCtrl.group.bank_transfer_validation.validation_data[groupSettingsCtrl.currentField].presence><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.required_field\'\"></md-translate></md-checkbox></md-input-container><md-input-container class=md-block><label><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.min_length\'\"></md-translate></label><input name=min type=number ng-model=groupSettingsCtrl.group.bank_transfer_validation.validation_data[groupSettingsCtrl.currentField].range.min></md-input-container><md-input-container class=md-block><label><md-translate key=::groupSettingsCtrl.translate_key shortcode=\"\'group_settings.max_length\'\"></md-translate></label><input name=max type=number ng-model=groupSettingsCtrl.group.bank_transfer_validation.validation_data[groupSettingsCtrl.currentField].range.max></md-input-container></form></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/admin/settings/payment_systems/partials/payment_systems.html","<div row-restrict max-width=550px><label class=top-label><md-translate key=paymentCtrl.translate_key shortcode=\"\'payment_systems.label\'\"></md-translate></label><checkbox-list list=paymentCtrl.paymentSystems field-name=value callback=paymentCtrl.savePaymentSystems disable-search=true all-disabled=!paymentCtrl.editPermission></checkbox-list></div>");
$templateCache.put("app/admin/settings/payment_systems/partials/table.html","<md-button has-permission permission permission-only=\"\'api2.admin.banktransfercountrygroupscontroller.edit\'\" ng-if=!item.default class=md-icon-button ng-click=table.config.buttons.methods.edit(item)><i class=\"fa fa-pencil-square-o\"></i></md-button><md-button has-permission permission permission-only=\"\'api2.admin.banktransfercountrygroupscontroller.edit\'\" ng-if=!item.default class=md-icon-button ng-click=\"table.config.buttons.methods.remove(item, $event)\"><i class=\"fa fa-trash-o\"></i></md-button>");
$templateCache.put("app/admin/settings/registration_fields/partials/registration_fields.html","<div row-restrict max-width=550px><label class=top-label><md-translate key=regFieldsCtrl.translate_key shortcode=\"\'registration_fields.label\'\"></md-translate></label><checkbox-list list=regFieldsCtrl.registration_fields field-name=value callback=regFieldsCtrl.save_fields value-translate-namespace=regFieldsCtrl.namespaceField></checkbox-list></div>");
$templateCache.put("app/admin/settings/upload_logo/partials/upload_logo.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=uploadCtrl.uploadLogo><input-file-area ng-model=uploadCtrl.logos.logo_mini options=uploadCtrl.logo_mini_options errors=uploadCtrl.errors callback=uploadCtrl.update_logo(data)></input-file-area><input-file-area ng-model=uploadCtrl.logos.logo options=uploadCtrl.logo_main_options errors=uploadCtrl.errors></input-file-area><input-file-area ng-model=uploadCtrl.logos.favicon options=uploadCtrl.favicon_options errors=uploadCtrl.errors callback=uploadCtrl.update_favicon(data)></input-file-area></form></div>");
$templateCache.put("app/admin/settings/view_all_statistics/partials/view_all_statistics.html","<div row-restrict max-width=550px><label class=top-label><md-translate key=viewStatsCtrl.translate_key shortcode=\"\'view_all_statistics.label\'\"></md-translate></label><checkbox-list list=viewStatsCtrl.adminsList field-name=value callback=viewStatsCtrl.save_fields></checkbox-list></div>");
$templateCache.put("app/components/reports/partials/stats_parts/checkbox_template.html","<checkbox-list list=statsData[stats.current_column.id] field-name=value callback=stats.callback class=no-border all-disabled=allDisabled></checkbox-list>");
$templateCache.put("app/components/reports/partials/stats_parts/compare_conditions_template.html","<div class=compare-wrap><!--First condition--><div class=compare-condition-wrap><div layout=row><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::translateKey shortcode=\"\'compare.condition_selector\'\"></md-translate></label><md-select md-select-label-translate ng-model=statsData.first_condition.first.mark ng-change=compare.callback() ng-disabled=allDisabled><md-option ng-value=item.mark ng-repeat=\"item in compare.compare_conditions\"><span md-translate key=::translateKey shortcode=\"\'compare\' + item.label\"></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::translateKey shortcode=\"\'compare.compare_value\'\"></md-translate></label><input type=number ng-model=statsData.first_condition.first.value ng-change=compare.callback() ng-disabled=allDisabled></md-input-container></div><div flex=none class=btn-clear-wrap><md-button class=\"md-icon-button clear-row-btn\" ng-disabled=allDisabled ng-click=compare.clear(statsData.first_condition.first) ng-if=\"clearBtn &amp;&amp; (statsData.first_condition.first.mark || statsData.first_condition.first.value)\"><img src=assets/images/cross.png></md-button></div></div><div layout=row><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::translateKey shortcode=\"\'compare.condition_selector\'\"></md-translate></label><md-select md-select-label-translate ng-model=statsData.first_condition.second.mark ng-change=compare.callback() ng-disabled=allDisabled><md-option ng-value=item.mark ng-repeat=\"item in compare.compare_conditions\"><span md-translate key=::translateKey shortcode=\"\'compare\' + item.label\"></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::translateKey shortcode=\"\'compare.compare_value\'\"></md-translate></label><input type=number ng-model=statsData.first_condition.second.value ng-change=compare.callback() ng-disabled=allDisabled></md-input-container></div><div flex=none class=btn-clear-wrap><md-button class=\"md-icon-button clear-row-btn\" ng-disabled=allDisabled ng-click=compare.clear(statsData.first_condition.second) ng-if=\"clearBtn &amp;&amp; (statsData.first_condition.second.mark || statsData.first_condition.second.value)\"><img src=assets/images/cross.png></md-button></div></div></div><!--Compare separator--><div layout=row ng-if=statsData.second_condition class=compare-separator><md-radio-group ng-model=statsData.compare_separator class=md-primary ng-change=compare.callback()><md-radio-button ng-repeat=\"item in compare.compare_separators\" ng-value=item.mark ng-disabled=allDisabled><span md-translate key=::translateKey shortcode=\"\'compare\' + item.label\"></span></md-radio-button></md-radio-group></div><!--Second condition--><div ng-if=statsData.second_condition class=compare-condition-wrap><div layout=row><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::translateKey shortcode=\"\'compare.condition_selector\'\"></md-translate></label><md-select md-select-label-translate ng-model=statsData.second_condition.first.mark ng-change=compare.callback() ng-disabled=allDisabled><md-option ng-value=item.mark ng-repeat=\"item in compare.compare_conditions\"><span md-translate key=::translateKey shortcode=\"\'compare\' + item.label\"></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::translateKey shortcode=\"\'compare.compare_value\'\"></md-translate></label><input type=number ng-model=statsData.second_condition.first.value ng-change=compare.callback() ng-disabled=allDisabled></md-input-container></div><div flex=none class=btn-clear-wrap><md-button class=\"md-icon-button clear-row-btn\" ng-disabled=allDisabled ng-click=compare.clear(statsData.second_condition.first) ng-if=\"clearBtn &amp;&amp; (statsData.second_condition.first.mark || statsData.second_condition.first.value)\"><img src=assets/images/cross.png></md-button></div></div><div layout=row><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::translateKey shortcode=\"\'compare.condition_selector\'\"></md-translate></label><md-select md-select-label-translate ng-model=statsData.second_condition.second.mark ng-change=compare.callback() ng-disabled=allDisabled><md-option ng-value=item.mark ng-repeat=\"item in compare.compare_conditions\"><span md-translate key=::translateKey shortcode=\"\'compare\' + item.label\"></span></md-option></md-select><span class=errors-reserve></span></md-input-container></div><div flex=50 class=compare-row><md-input-container class=md-block><label><md-translate key=::translateKey shortcode=\"\'compare.compare_value\'\"></md-translate></label><input type=number ng-model=statsData.second_condition.second.value ng-change=compare.callback() ng-disabled=allDisabled></md-input-container></div><div flex=none class=btn-clear-wrap><md-button class=\"md-icon-button clear-row-btn\" ng-disabled=allDisabled ng-click=compare.clear(statsData.second_condition.second) ng-if=\"clearBtn &amp;&amp; (statsData.second_condition.second.mark || statsData.second_condition.second.value)\"><img src=assets/images/cross.png></md-button></div></div></div><!--Buttons--><div layout=row><md-button ng-click=compare.add_condition() class=\"btn-set-params btn-light\" ng-if=!statsData.second_condition ng-disabled=allDisabled><i class=\"fa fa-plus\"></i><span md-translate key=::translateKey shortcode=\"\'compare.add_condition\'\"></span></md-button><md-button ng-click=compare.remove_condition() class=\"btn-set-params btn-light\" ng-if=statsData.second_condition ng-disabled=allDisabled><i class=\"fa fa-minus\"></i><span md-translate key=::translateKey shortcode=\"\'compare.remove_condition\'\"></span></md-button></div></div>");
$templateCache.put("app/components/reports/partials/stats_parts/compare_template.html","<stats-compare stats-data=statsData[stats.current_column.id] callback=stats.callback translate-key=::translateKey all-disabled=allDisabled clear-btn=true></stats-compare>");
$templateCache.put("app/components/reports/partials/stats_parts/date_template.html","<div class=\"set-custom-date stats-date\"><daterange-picker start=statsData[stats.current_column.id].start end=statsData[stats.current_column.id].end start-max=statsData[stats.current_column.id].end end-min=statsData[stats.current_column.id].start format=ll callback=stats.callback all-disabled=allDisabled clear-btn=true></daterange-picker></div>");
$templateCache.put("app/components/shared/affiliate_balance/partials/affiliate_balance.html","<div layout=row layout-align=\"start start\" class=affiliate-balance-wrap><balance-item amount=$ctrl.getBalance() currency=$ctrl.getCurrency() withdrawal-func=\"$ctrl.withdrawalFunc({data: data})\" get-balance-amount=$ctrl.getBalance() withdrawal-permission=$ctrl.withdrawalPermission></balance-item></div>");
$templateCache.put("app/components/shared/affiliate_balance/partials/balance_item.html","<md-card class=balance-item><md-card-content class=\"balance-card-content space-around\"><span ng-bind=$ctrl.currency class=\"item-currency font-light\"></span><span ng-bind=\"$ctrl.amount | number | numberSeparate: \' \'\" class=item-balance></span><div class=item-withdrawal><md-button has-permission permission permission-only=$ctrl.withdrawalPermission class=\"md-raised md-primary btn-primary\" ng-click=$ctrl.balanceWithdrawal()><md-translate key=\"\'AffiliateBalance\'\" shortcode=\"\'affiliate_balance.withdrawal_button\'\"></md-translate></md-button></div></md-card-content></md-card>");
$templateCache.put("app/components/shared/affiliate_balance/partials/header_balance.html","<div class=header-balance-stack><!--Total across all (non-retired) brands. True net -> can be negative (affiliate is informed).--><!--No click/linkage on the balance text (per Gabriel 2026-06-17 - not needed).--><div class=header-balance-line><span class=\"header-balance-label font-medium\"><md-translate key=\"\'AffiliateBalance\'\" shortcode=\"\'affiliate_balance.total_all_brands\'\"></md-translate></span><span ng-if=!$ctrl.isRecalculating() ng-class=\"{\'balance-negative\': $ctrl.getTotalEarned() &lt; 0}\" class=\"header-balance-amount font-bold\"><span ng-bind=$ctrl.getCurrency()></span><span ng-bind=\"$ctrl.getTotalEarned() | number | numberSeparate: \' \'\"></span></span><span ng-if=$ctrl.isRecalculating() class=header-balance-amount><md-translate key=\"\'AffiliateBalance\'\" shortcode=\"\'affiliate_balance.recalculating\'\"></md-translate></span></div><!--Selected brand: earned regardless of threshold (booked + below-minimum carryover).--><div class=header-balance-line><span class=\"header-balance-label font-medium\"><md-translate key=\"\'AffiliateBalance\'\" shortcode=\"\'affiliate_balance.brand_earned\'\"></md-translate></span><span ng-if=!$ctrl.isRecalculating() ng-class=\"{\'balance-negative\': $ctrl.getBrandEarned() &lt; 0}\" class=\"header-balance-amount font-bold\"><span ng-bind=$ctrl.getCurrency()></span><span ng-bind=\"$ctrl.getBrandEarned() | number | numberSeparate: \' \'\"></span></span><span ng-if=$ctrl.isRecalculating() class=header-balance-amount><md-translate key=\"\'AffiliateBalance\'\" shortcode=\"\'affiliate_balance.recalculating\'\"></md-translate></span></div><!--Notes removed per Ops (2026-06-18): header is a snapshot. Payable-at-minimum dropped (Gabriel);--><!--negative-balance note dropped (Eddie + Gabriel aligned) - the red figures (.balance-negative above)--><!--are enough to flag a negative, and affiliates know negatives offset against future earnings.--></div>");
$templateCache.put("app/components/shared/affiliate_balance/partials/payment_systems_details.html","<div><div ng-if=\"$ctrl.type === \'tabs\'\" class=\"tabs-wrap mt-30\"><!--Desktop tabs--><ul ng-if=$ctrl.isGtXs class=tabs-list><li ng-repeat=\"item in $ctrl.availableSystems\" ng-click=$ctrl.choosePaymentSystem(item) ng-class=\"{\'active\': item.type === $ctrl.selectedSystemType}\" class=tab-list-item><div ng-bind=item.type class=tab-item-name></div></li></ul><!--Mobile tabs--><div ng-cloak ng-if=\"!$ctrl.isGtXs &amp;&amp; $ctrl.availableSystems.length\" class=\"templates-tabs-list payment-systems-tabs\"><md-tabs md-stretch-tabs=never md-center-tabs=false><!--Empty tab for not trigering request until user click to other tab--><md-tab></md-tab><md-tab ng-repeat=\"item in $ctrl.availableSystems\" md-active=\"item.type === $ctrl.selectedSystemType\" ng-click=$ctrl.choosePaymentSystem(item)><div ng-bind=item.type class=tab-item-name></div></md-tab></md-tabs></div></div><div row-restrict max-width=450px ng-if=\"$ctrl.type === \'select\'\"><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'affiliate_balance.withdrawal.select_payment_system\'\"></md-translate></label><select-with-search list=$ctrl.availableSystems ng-model=$ctrl.selectedSystemType ng-change=$ctrl.changePaymentSystem() save-prop=type errors=$ctrl.errors name=current_system options=\"{prop_for_value: \'type\'}\" ng-required=true><span ng-bind=value.type></span></select-with-search></md-input-container></div><div ng-class=\"{\'type-tabs\': $ctrl.type === \'tabs\'}\" class=payment-system-details><div row-restrict max-width=450px><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'country_code\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'country_code\')\"></md-translate></label><select-with-search list=$ctrl.countriesList ng-model=$ctrl.currentSystem.country_code save-prop=country_code errors=$ctrl.errors name=country_code options=\"{prop_for_value: \'name\'}\" ng-required=true><span ng-bind=value.name></span></select-with-search></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'account_holders_name\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'account_holders_name\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'account_holders_name\')}}\" ng-model=$ctrl.currentSystem.account_holders_name ng-required=\"$ctrl.isRequired(\'account_holders_name\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'account_holders_name\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'branch_code\') &amp;&amp; !$ctrl.isCanadaBankCountry()\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'branch_code\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'branch_code\')}}\" ng-model=$ctrl.currentSystem.branch_code ng-required=\"$ctrl.isRequired(\'branch_code\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'branch_code\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'routing_number\') &amp;&amp; !$ctrl.isCanadaBankCountry()\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'routing_number\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'routing_number\')}}\" ng-model=$ctrl.currentSystem.routing_number ng-required=\"$ctrl.isRequired(\'routing_number\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'routing_number\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'bank_transit_code\') &amp;&amp; $ctrl.isCanadaBankCountry()\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'bank_transit_code\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'bank_transit_code\')}}\" ng-model=$ctrl.currentSystem.bank_transit_code ng-required=\"$ctrl.isRequired(\'bank_transit_code\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'bank_transit_code\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'institution_number\') &amp;&amp; $ctrl.isCanadaBankCountry()\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'institution_number\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'institution_number\')}}\" ng-model=$ctrl.currentSystem.institution_number ng-required=\"$ctrl.isRequired(\'institution_number\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'institution_number\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'bank_account_number\') &amp;&amp; $ctrl.isCanadaBankCountry()\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'bank_account_number\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'bank_account_number\')}}\" ng-model=$ctrl.currentSystem.bank_account_number ng-required=\"$ctrl.isRequired(\'bank_account_number\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'bank_account_number\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'username\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'username\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'username\')}}\" ng-model=$ctrl.currentSystem.username ng-required=\"$ctrl.isRequired(\'username\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'username\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'poker_nickname\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'poker_nickname\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'poker_nickname\')}}\" ng-model=$ctrl.currentSystem.poker_nickname ng-required=\"$ctrl.isRequired(\'poker_nickname\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'poker_nickname\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'email\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'email\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=email name=\"{{::$ctrl.fieldNameControl(\'email\')}}\" ng-model=$ctrl.currentSystem.email ng-required=\"$ctrl.isRequired(\'email\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'email\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'wallet\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'wallet\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'wallet\')}}\" ng-model=$ctrl.currentSystem.wallet ng-required=\"$ctrl.isRequired(\'wallet\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'wallet\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'card_number\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'card_number\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'card_number\')}}\" ng-model=$ctrl.currentSystem.card_number ng-required=\"$ctrl.isRequired(\'card_number\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'card_number\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'country\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'country\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk required md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'country\')}}\" ng-model=$ctrl.currentSystem.country ng-required=\"$ctrl.isRequired(\'country\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'country\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'address\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'address\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk required md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'address\')}}\" ng-model=$ctrl.currentSystem.address ng-required=\"$ctrl.isRequired(\'address\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'address\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'city\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'city\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk required md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'city\')}}\" ng-model=$ctrl.currentSystem.city ng-required=\"$ctrl.isRequired(\'city\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'city\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'company_name\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'company_name\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'company_name\')}}\" ng-model=$ctrl.currentSystem.company_name ng-required=\"$ctrl.isRequired(\'company_name\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'company_name\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'company_country\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'company_country\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'company_country\')}}\" ng-model=$ctrl.currentSystem.company_country ng-required=\"$ctrl.isRequired(\'company_country\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'company_country\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'company_city\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'company_city\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'company_city\')}}\" ng-model=$ctrl.currentSystem.company_city ng-required=\"$ctrl.isRequired(\'company_city\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'company_city\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'company_address\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'company_address\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'company_address\')}}\" ng-model=$ctrl.currentSystem.company_address ng-required=\"$ctrl.isRequired(\'company_address\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'company_address\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'company_postal\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'company_postal\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'company_postal\')}}\" ng-model=$ctrl.currentSystem.company_postal ng-required=\"$ctrl.isRequired(\'company_postal\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'company_postal\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'iban\') &amp;&amp; !$ctrl.isCanadaBankCountry()\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'iban\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'iban\')}}\" ng-model=$ctrl.currentSystem.iban ng-required=\"$ctrl.isRequired(\'iban\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'iban\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'bic\') &amp;&amp; !$ctrl.isCanadaBankCountry()\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'bic\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'bic\')}}\" ng-model=$ctrl.currentSystem.bic ng-required=\"$ctrl.isRequired(\'bic\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'bic\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'bank_name\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'bank_name\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'bank_name\')}}\" ng-model=$ctrl.currentSystem.bank_name ng-required=\"$ctrl.isRequired(\'bank_name\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'bank_name\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'bank_country\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'bank_country\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'bank_country\')}}\" ng-model=$ctrl.currentSystem.bank_country ng-required=\"$ctrl.isRequired(\'bank_country\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'bank_country\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'bank_address\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'bank_address\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'bank_address\')}}\" ng-model=$ctrl.currentSystem.bank_address ng-required=\"$ctrl.isRequired(\'bank_address\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'bank_address\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'bank_city\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'bank_city\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'bank_city\')}}\" ng-model=$ctrl.currentSystem.bank_city ng-required=\"$ctrl.isRequired(\'bank_city\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'bank_city\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'bank_postal\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'bank_postal\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'bank_postal\')}}\" ng-model=$ctrl.currentSystem.bank_postal ng-required=\"$ctrl.isRequired(\'bank_postal\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'bank_postal\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'swift\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'swift\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'swift\')}}\" ng-model=$ctrl.currentSystem.swift ng-required=\"$ctrl.isRequired(\'swift\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'swift\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.fieldControl(\'phone_number\')\"><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.fieldShortcodeControl(\'phone_number\')\" watch-shortcode=true></md-translate></label><input input-errors md-no-asterisk type=text name=\"{{::$ctrl.fieldNameControl(\'phone_number\')}}\" ng-model=$ctrl.currentSystem.phone_number ng-required=\"$ctrl.isRequired(\'phone_number\')\"><md-error-messages errors=$ctrl.errors input-name=\"{{::$ctrl.fieldNameControl(\'phone_number\')}}\"></md-error-messages></md-input-container><md-input-container class=md-block ng-if=\"$ctrl.defaultSystemCheckbox &amp;&amp; $ctrl.paymentSystemsList.length\"><md-checkbox class=\"md-primary primary-checkbox\" ng-checked=$ctrl.currentSystem.default ng-click=$ctrl.setUpDefaultSystem($event) ng-disabled=\"$ctrl.currentSystem.default &amp;&amp; $ctrl.defaultSystemType === $ctrl.selectedSystemType\"><md-translate key=::$ctrl.translate_key shortcode=\"\'affiliate_balance.withdrawal.default_payment_system\'\"></md-translate></md-checkbox></md-input-container></div></div></div>");
$templateCache.put("app/components/shared/download_reports/partials/create_report_toast.html","<md-toast class=\"custom-toast create-report-success\"><div layout=row layout-align=\"space-between center\" class=toast-content-holder><div class=toast-content><md-translate key=::$ctrl.translateKey shortcode=\"\'download_reports.create_report_success\'\"></md-translate><md-button class=\"md-primary link-to-download\" ng-click=$ctrl.moveToDownload()><md-translate key=\"\'Navigation\'\" shortcode=\"$ctrl.namespace + \'.export.download_csv\'\"></md-translate></md-button></div><md-button class=\"md-icon-button close-toast\" ng-click=$ctrl.hide()><i class=\"fa fa-times\"></i></md-button></div></md-toast>");
$templateCache.put("app/components/shared/download_reports/partials/download_reports.html","<md-dialog><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::downloadCtrl.translate_key shortcode=\"\'download_reports.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=md-dialog-content-body><form name=downloadCtrl.downloadReportForm class=last-item-no-margin><md-input-container class=md-block><label><md-translate key=::downloadCtrl.translate_key shortcode=\"\'download_reports.format_label\'\"></md-translate></label><md-select input-errors required md-no-asterisk md-select-label-translate name=format_file ng-model=downloadCtrl.reportInformation.format_file><md-option ng-value=format_file ng-repeat=\"format_file in downloadCtrl.downloadFormats\" ng-selected=\"$first &amp;&amp; downloadCtrl.downloadFormats.length &lt; 2\"><span ng-bind=format_file></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=downloadCtrl.errors input-name=format_file></md-error-messages></md-input-container><md-input-container class=md-block ng-if=downloadCtrl.downloadSeparators[downloadCtrl.reportInformation.format_file].length><label><md-translate key=::downloadCtrl.translate_key shortcode=\"\'download_reports.separator_label\'\"></md-translate></label><md-select input-errors md-select-label-translate name=separator ng-model=downloadCtrl.reportInformation.separator><md-option ng-value=separator ng-repeat=\"separator in downloadCtrl.downloadSeparators[downloadCtrl.reportInformation.format_file]\" ng-selected=\"$index === 0\"><span ng-bind=separator></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=downloadCtrl.errors input-name=separator></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=downloadCtrl.cancel()><md-translate key=::downloadCtrl.translate_key shortcode=\"\'download_reports.cancel\'\"></md-translate></md-button><md-button class=md-primary md-click=downloadCtrl.download() ng-disabled=downloadCtrl.downloadReportForm.$invalid><md-translate key=::downloadCtrl.translate_key shortcode=\"\'download_reports.ok\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/shared/information_plate/partials/anonym_plate.html","<div ng-bind-html=$ctrl.notify.body ng-if=$ctrl.notify ng-style=\"{background: $ctrl.notifyBg, color: $ctrl.notifyColor}\" class=\"notification-header text-editor cf\"></div>");
$templateCache.put("app/components/shared/information_plate/partials/information_plate.html","<md-menu md-position-mode=\"target-right target\" md-offset=\"0 40\" ng-if=$ctrl.canShowNotify()><md-button class=\"md-icon-button small-icon-btn notify-button\" ng-click=\"$ctrl.showNotify($event, $mdMenu)\" ng-class=\"{\'unread\': !$ctrl.isNotificationRead}\"><i hide show-gt-sm class=\"fa fa-bell-o sonar\"></i><i hide-gt-sm class=\"fa fa-bell sonar\"></i></md-button><md-menu-content width=6 class=notify-wrap ng-style=\"{background: $ctrl.notifyBg}\"><md-menu-item><div ng-if=$ctrl.notify ng-style=\"{color: $ctrl.notifyColor}\" class=notify-item-content><div ng-bind-html=$ctrl.notify.body class=text-editor></div></div><div ng-if=!$ctrl.notify layout=row layout-align=\"start center\" class=notify-item-content><div class=no-notify><md-translate key=\"\'Notification\'\" shortcode=\"\'notification.no_any_notification\'\"></md-translate></div></div></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/affiliate/profile_settings/confirmation_email/partials/confirmation_email.html","<div row-restrict max-width=450px><form name=profileConfirmEmail.confirmEmailForm><md-input-container class=md-block><label><md-translate key=::profileConfirmEmail.translate_key shortcode=\"\'confirmation_email.token\'\"></md-translate></label><input input-errors type=text name=confirmation_token ng-model=profileConfirmEmail.token><md-error-messages errors=profileConfirmEmail.errors input-name=confirmation_token></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/affiliate/profile_settings/main/partials/main.html","<div row-restrict max-width=450px><form name=profileMain.mainDataForm><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.name\'\"></md-translate></label><input input-errors type=text name=name ng-model=profileMain.user.name><md-error-messages errors=profileMain.errors input-name=name></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.surname\'\"></md-translate></label><input input-errors type=text name=surname ng-model=profileMain.user.surname><md-error-messages errors=profileMain.errors input-name=surname></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.username\'\"></md-translate></label><input input-errors type=text name=username ng-model=profileMain.user.username ng-readonly=true><md-error-messages errors=profileMain.errors input-name=username></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.skype\'\"></md-translate></label><input input-errors type=text name=skype ng-model=profileMain.user.skype><md-error-messages errors=profileMain.errors input-name=skype></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.telegram\'\"></md-translate></label><input input-errors type=text name=telegram ng-model=profileMain.user.telegram><md-error-messages errors=profileMain.errors input-name=telegram></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.birthday\'\"></md-translate></label><mod-datepicker name=birthday ng-model=profileMain.user.birthday errors=profileMain.errors></mod-datepicker></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.phone_number\'\"></md-translate></label><input input-errors type=tel name=phone_number ng-model=profileMain.user.phone_number><md-error-messages errors=profileMain.errors input-name=phone_number></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.site_url\'\"></md-translate></label><input input-errors type=text name=site_url ng-model=profileMain.user.site_url><md-error-messages errors=profileMain.errors input-name=site_url></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileMain.translate_key shortcode=\"\'main.about_affiliate\'\"></md-translate></label><textarea input-errors name=about_affiliate ng-model=profileMain.user.about_affiliate></textarea><md-error-messages errors=profileMain.errors input-name=about_affiliate></md-error-messages></md-input-container><md-input-container class=md-block><md-checkbox class=\"md-primary primary-checkbox md-align-top-left\" ng-model=profileMain.user.agree_receive_emails><md-translate key=::profileMain.translate_key shortcode=\"\'main.agree_receive_emails\'\"></md-translate></md-checkbox></md-input-container></form></div>");
$templateCache.put("app/affiliate/profile_settings/password/partials/password.html","<div row-restrict max-width=450px><form name=profilePassword.passwordChangeForm><md-input-container class=md-block><label><md-translate key=::profilePassword.translate_key shortcode=\"\'password.password\'\"></md-translate></label><input input-errors type=password name=password ng-model=profilePassword.user.password><md-error-messages errors=profilePassword.errors input-name=password></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profilePassword.translate_key shortcode=\"\'password.password_confirmation\'\"></md-translate></label><input input-errors type=password name=password_confirmation ng-model=profilePassword.user.password_confirmation><md-error-messages errors=profilePassword.errors input-name=password_confirmation></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profilePassword.translate_key shortcode=\"\'password.current_password\'\"></md-translate></label><input input-errors type=password name=current_password ng-model=profilePassword.user.current_password><md-error-messages errors=profilePassword.errors input-name=current_password></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/affiliate/profile_settings/payment_systems/partials/payment_systems.html","<form name=profilePaymentSystems.paymentDetailsForm><payment-systems-details type=\"\'select\'\" name=profilePaymentSystems.paymentDetailsName payment-systems=profilePaymentSystems.paymentSystems countries-list=profilePaymentSystems.countriesList current-system=profilePaymentSystems.currentSystem errors=profilePaymentSystems.errors></payment-systems-details></form>");
$templateCache.put("app/affiliate/profile_settings/two_factor_authentication/partials/two_factor_authentication.html","<div row-restrict max-width=450px><form name=profileTwoFactorAuth.mfaAuthForm><md-input-container class=md-block ng-if=\"!profileTwoFactorAuth.user.mfa_enabled &amp;&amp; !profileTwoFactorAuth.user.showSecretKey\"><label><md-translate key=::profileTwoFactorAuth.translate_key shortcode=\"\'two_factor_authentication.current_password\'\"></md-translate></label><input input-errors type=password name=password ng-model=profileTwoFactorAuth.user.current_password><md-error-messages errors=profileTwoFactorAuth.errors input-name=password></md-error-messages></md-input-container><md-input-container class=md-block ng-if=profileTwoFactorAuth.user.showSecretKey><label><md-translate key=::profileTwoFactorAuth.translate_key shortcode=\"\'two_factor_authentication.secret_value\'\"></md-translate></label><input type=text name=secret_value ng-value=profileTwoFactorAuth.user.secretValue ng-readonly=true></md-input-container><md-input-container class=md-block ng-if=\"profileTwoFactorAuth.user.showSecretKey || profileTwoFactorAuth.user.mfa_enabled\"><label><md-translate key=::profileTwoFactorAuth.translate_key shortcode=\"profileTwoFactorAuth.user.mfa_enabled ? \'two_factor_authentication.enter_mfa_code_for_disable\' : \'two_factor_authentication.enter_mfa_code_for_enable\'\" watch-shortcode=true></md-translate></label><input md-focus input-errors type=text name=mfa_code ng-model=profileTwoFactorAuth.user.mfaCode><md-error-messages errors=profileTwoFactorAuth.errors input-name=mfa_code></md-error-messages></md-input-container><div ng-if=profileTwoFactorAuth.user.showSecretKey><img ng-src={{profileTwoFactorAuth.user.qrUri}}></div></form></div>");
$templateCache.put("app/affiliate/profile_settings/email/partials/email.html","<div row-restrict max-width=450px><form name=profileEmail.emailChangeForm><md-input-container class=md-block><label><md-translate key=::profileEmail.translate_key shortcode=\"\'email.current_email\'\"></md-translate></label><input input-errors type=text name=email ng-model=profileEmail.user.email><md-error-messages errors=profileEmail.errors input-name=email></md-error-messages></md-input-container><md-input-container class=md-block ng-if=profileEmail.user.unconfirmed_email><label><md-translate key=::profileEmail.translate_key shortcode=\"\'email.unconfirmed_email\'\"></md-translate></label><input input-errors type=text name=unconfirmed_email ng-model=profileEmail.user.unconfirmed_email><md-error-messages errors=profileEmail.errors input-name=unconfirmed_email></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::profileEmail.translate_key shortcode=\"\'email.current_password\'\"></md-translate></label><input input-errors type=password name=current_password ng-model=profileEmail.user.current_password><md-error-messages errors=profileEmail.errors input-name=current_password></md-error-messages></md-input-container></form></div>");
$templateCache.put("app/admin/settings/notification_header/partials/notification_header.html","<div class=notification-header-holder><form name=notifyCtrl.notifyForm><div row-restrict max-width=450px><md-input-container class=md-block><label><md-translate key=::notifyCtrl.translate_key shortcode=\"\'notification_header.namespace\'\"></md-translate></label><md-select md-select-label-translate ng-model=notifyCtrl.userNamespace ng-change=notifyCtrl.changeNamespace()><md-option ng-repeat=\"item in notifyCtrl.namespaceList\" ng-value=item><md-translate key=::notifyCtrl.translate_key shortcode=\"\'notification_header.for_\' + item\"></md-translate></md-option></md-select><span class=errors-reserve></span></md-input-container><md-input-container class=md-block><label><md-translate key=::notifyCtrl.translate_key shortcode=\"\'notification_header.header_color\'\"></md-translate></label><input watch-color-value color-picker color-picker-model=notifyCtrl.notification.headerColor color-picker-position=bottom color-picker-output-format=\"\'hex\'\" value={{notifyCtrl.notification.headerColor}} ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::notifyCtrl.translate_key shortcode=\"\'notification_header.text_color\'\"></md-translate></label><input watch-color-value color-picker color-picker-model=notifyCtrl.notification.textColor color-picker-position=bottom color-picker-output-format=\"\'hex\'\" value={{notifyCtrl.notification.textColor}} ng-readonly=true></md-input-container><md-input-container class=md-block><label><md-translate key=::notifyCtrl.translate_key shortcode=\"\'notification_header.language\'\"></md-translate></label><select-with-search list=notifyCtrl.languages ng-model=notifyCtrl.currentLanguage set-key-as-value=true options=notifyCtrl.selectLanguagesOptions><md-translate key=\"\'Languages\'\" shortcode=\"\'language.\' + key\"></md-translate></select-with-search></md-input-container></div><div><div class=label-top><md-translate key=::notifyCtrl.translate_key shortcode=\"\'notification_header.text_content\'\"></md-translate></div><text-angular text-angular-event vm=notifyCtrl name=body ng-model=notifyCtrl.notifyContent[notifyCtrl.currentLanguage] ta-unsafe-sanitizer=true class=text-editor></text-angular><md-input-container class=\"md-block fake-input-error\"><input input-errors type=text name=body ng-model=notifyCtrl.fake_body><md-error-messages errors=notifyCtrl.errors input-name=body></md-error-messages></md-input-container></div><div><md-input-container class=md-block><md-checkbox class=\"primary-checkbox md-primary\" ng-model=notifyCtrl.notification.visible><md-translate key=::notifyCtrl.translate_key shortcode=\"\'notification_header.state\'\"></md-translate></md-checkbox></md-input-container></div></form></div>");
$templateCache.put("app/admin/partners/settings/fees/partials/buttons.html","<md-button class=\"md-raised md-primary btn-primary\" md-click=settingsCtrl.tabs.activeTab.submitFn()><md-translate key=::settingsCtrl.translate_key shortcode=\"\'tracker_settings.save\'\"></md-translate></md-button>");
$templateCache.put("app/admin/partners/settings/fees/partials/fees.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=feesCtrl.feesForm><md-input-container class=md-block><label><md-translate key=::feesCtrl.translate_key shortcode=\"\'settings_fees.count_from\'\"></md-translate></label><md-select input-errors md-select-label-translate name=count_from ng-model=feesCtrl.params.feeColumn><md-option ng-value=value ng-repeat=\"(key, value) in feesCtrl.columns\"><span ng-bind=key></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=feesCtrl.errors input-name=count_from></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::feesCtrl.translate_key shortcode=\"\'settings_fees.percent\'\"></md-translate></label><input input-errors type=number name=percent ng-model=feesCtrl.params.limit><md-error-messages errors=feesCtrl.errors input-name=percent></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::feesCtrl.translate_key shortcode=\"\'settings_fees.date\'\"></md-translate></label><mod-datepicker ng-model=feesCtrl.params.date name=date md-min-date=feesCtrl.startDate md-mode=month errors=feesCtrl.errors></mod-datepicker></md-input-container></form></div>");
$templateCache.put("app/admin/partners/settings/fees/partials/history_changes.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::history.translate_key shortcode=\"\'settings_fees.history_changes.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=history.historyCnahgeForm><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'settings_fees.history_changes.count_from\'\"></md-translate></label><md-select input-errors md-select-label-translate name=count_from ng-model=history.history_item.feeColumn><md-option ng-value=value ng-repeat=\"(key, value) in history.columns\"><span ng-bind=key></span></md-option></md-select><span class=errors-reserve></span><md-error-messages errors=history.errors input-name=count_from></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'settings_fees.history_changes.percent\'\"></md-translate></label><input input-errors type=number name=percent ng-model=history.history_item.limit><md-error-messages errors=history.errors input-name=percent></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'settings_fees.history_changes.date\'\"></md-translate></label><mod-datepicker ng-model=history.history_item.date name=date md-min-date=history.startDate md-mode=month errors=history.errors></mod-datepicker></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=history.saveHistory()><md-translate key=::history.translate_key shortcode=\"\'settings_fees.history_changes.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=history.back()><md-translate key=::history.translate_key shortcode=\"\'settings_fees.history_changes.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/partners/settings/fees/partials/history_changes_view.html","<history-changes history-changes=settingsCtrl.tabs.activeTab.data.historyList options-change=settingsCtrl.tabs.activeTab.data.optionsChange></history-changes>");
$templateCache.put("app/admin/partners/settings/main_data/partials/buttons.html","<md-button has-permission permission permission-only=\"\'api2.admin.affiliatescontroller.edit\'\" class=\"md-raised md-primary btn-primary\" md-click=settingsCtrl.tabs.activeTab.submitFn()><md-translate key=::settingsCtrl.translate_key shortcode=\"\'tracker_settings.save\'\"></md-translate></md-button>");
$templateCache.put("app/admin/partners/settings/main_data/partials/main_data.html","<div row-restrict max-width=450px class=last-item-no-margin><form name=mainDataCtrl.mainDataForm><md-input-container class=md-block><label><md-translate key=::mainDataCtrl.translate_key shortcode=\"\'settings_main_data.form.max_count_trackers\'\"></md-translate></label><input input-errors type=number name=max_count_trackers ng-model=mainDataCtrl.affiliate.max_count_trackers><md-error-messages errors=mainDataCtrl.errors input-name=max_count_trackers></md-error-messages></md-input-container><md-input-container class=md-block><label><md-translate key=::mainDataCtrl.translate_key shortcode=\"\'settings_main_data.form.current_count_tracker\'\"></md-translate></label><input type=text ng-value=mainDataCtrl.affiliate.trackers.length ng-readonly=true></md-input-container></form></div>");
$templateCache.put("app/admin/partners/settings/subaffiliate_condition/partials/buttons.html","<md-button class=\"md-raised md-primary btn-primary\" md-click=settingsCtrl.tabs.activeTab.submitFn()><md-translate key=::settingsCtrl.translate_key shortcode=\"\'tracker_settings.save\'\"></md-translate></md-button>");
$templateCache.put("app/admin/partners/settings/subaffiliate_condition/partials/history_changes.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::condition.translate_key shortcode=\"\'history_changes_subaffiliate_condition.edit.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px><form name=condition.historyCnahgeForm><virtual-select list=condition.conditions_list ng-model=condition.history_item.subaffiliate_condition_id save-prop=id show-prop=title errors=condition.errors name=subaffiliate_condition_id><label><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'history_changes_subaffiliate_condition.edit.form.subaffiliate_condition_id\'\"></md-translate></label><virtual-item-content><span ng-bind=item.title></span></virtual-item-content></virtual-select><md-input-container class=md-block><label><md-translate key=::condition.translate_key shortcode=\"\'history_changes_subaffiliate_condition.edit.form.date\'\"></md-translate></label><mod-datepicker ng-model=condition.history_item.date name=date md-mode=month errors=condition.errors></mod-datepicker></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=condition.save_history()><md-translate key=::condition.translate_key shortcode=\"\'history_changes_subaffiliate_condition.edit.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=condition.back()><md-translate key=::condition.translate_key shortcode=\"\'history_changes_subaffiliate_condition.edit.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/partners/settings/subaffiliate_condition/partials/history_changes_view.html","<history-changes history-changes=settingsCtrl.tabs.activeTab.data.historyList options-change=settingsCtrl.tabs.activeTab.data.optionsChange></history-changes>");
$templateCache.put("app/admin/partners/settings/subaffiliate_condition/partials/subaffiliate_condition.html","<div row-restrict max-width=450px><form name=conditionCtrl.conditionForm><virtual-select list=conditionCtrl.conditions_list ng-model=conditionCtrl.current_history_item.subaffiliate_condition_id save-prop=id show-prop=title errors=conditionCtrl.errors name=subaffiliate_condition_id><label><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'subaffiliate_condition.form.subaffiliate_condition_id\'\"></md-translate></label><virtual-item-content><span ng-bind=item.title></span></virtual-item-content></virtual-select><md-input-container class=md-block><label><md-translate key=::conditionCtrl.translate_key shortcode=\"\'subaffiliate_condition.form.date\'\"></md-translate></label><mod-datepicker ng-model=conditionCtrl.current_history_item.date name=date md-mode=month errors=conditionCtrl.errors></mod-datepicker></md-input-container></form></div>");
$templateCache.put("app/admin/partners/settings/trackers/partials/bulk_replacement_deals.html","<md-dialog class=content-with-select><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::$ctrl.translate_key shortcode=\"\'bulk_replacement_deals.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=md-dialog-content-body><div row-restrict max-width=450px class=last-item-no-margin><form name=$ctrl.saveForm><virtual-select list=$ctrl.allConditions ng-model=$ctrl.params.condition_id ng-required=true save-prop=id show-prop=title errors=$ctrl.errors name=condition_id options=\"{prop_for_value: \'title\'}\"><label><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'settings_trackers.form.condition\'\"></md-translate></label><virtual-item-content><span ng-bind=item.title></span></virtual-item-content></virtual-select><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"\'settings_trackers.form.date\'\"></md-translate></label><mod-datepicker ng-model=$ctrl.params.date is-required=true name=date md-mode=day md-min-date=$ctrl.boundaryDate format=$ctrl.format model-format=$ctrl.modelFormat errors=$ctrl.errors></mod-datepicker></md-input-container><p ng-if=$ctrl.selectedConditionIsCpa() style=\"color: #0D47A1; font-size: 12px; margin-top: 8px\"><em>CPA deals are automatically set to the 1st of the selected month.</em></p><p style=\"background-color: #E3F2FD; color: #0D47A1; padding: 12px; border-radius: 4px; font-size: 12px; margin-top: 16px\"><span style=\"font-weight: bold; margin-right: 6px\">ⓘ</span><em>Application is not allowed if it conflicts with an existing or upcoming deal.</em></p></form></div></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=$ctrl.closeModal()><md-translate key=::$ctrl.translate_key shortcode=\"\'bulk_replacement_deals.cancel\'\"></md-translate></md-button><md-button class=md-primary md-click=$ctrl.save() ng-disabled=$ctrl.saveForm.$invalid><md-translate key=::$ctrl.translate_key shortcode=\"\'bulk_replacement_deals.save\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/partners/settings/trackers/partials/buttons.html","<md-button class=\"md-raised md-primary btn-primary\" ng-click=settingsCtrl.tabs.activeTab.submitFn($event)><md-translate key=::settingsCtrl.translate_key shortcode=\"\'settings_trackers.button_add_tracker\'\"></md-translate></md-button>");
$templateCache.put("app/admin/partners/settings/trackers/partials/create_tracker.html","<md-dialog class=\"custom-dialog dialog-content\"><div class=dialog-custom-header layout=row layout-align=\"space-between start\"><div class=dialog-title><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.shortcodePart + \'.title\'\"></md-translate></div></div><md-dialog-content class=md-dialog-content><div class=\"md-dialog-content-body last-item-no-margin\"><form name=$ctrl.saveTrackerForm><md-input-container class=md-block><label><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.shortcodePart + \'.description\'\"></md-translate></label><textarea input-errors required md-no-asterisk ng-model=$ctrl.tracker.description name=description></textarea><md-error-messages errors=$ctrl.errors input-name=description></md-error-messages></md-input-container></form></div></md-dialog-content><md-dialog-actions layout=row class=button-holder><md-button class=md-primary ng-click=$ctrl.cancel()><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.shortcodePart + \'.button_cancel\'\"></md-translate></md-button><md-button class=md-primary md-click=$ctrl.saveTracker()><md-translate key=::$ctrl.translate_key shortcode=\"$ctrl.shortcodePart + \'.button_save\'\"></md-translate></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/admin/partners/settings/trackers/partials/history_changes.html","<div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::history.translate_key shortcode=\"\'history_changes_trackers.edit.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px class=last-item-no-margin><form name=history.historyCnahgeForm><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'history_changes_trackers.edit.form.tracker\'\"></md-translate></label><input type=text ng-model=history.history_item.serial_id ng-readonly=true></md-input-container><virtual-select list=history.conditions.all_condition ng-model=history.history_item.condition_id save-prop=id show-prop=title errors=history.errors name=condition_id options=\"{prop_for_value: \'title\'}\"><label><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'history_changes_trackers.edit.form.condition\'\"></md-translate></label><virtual-item-content><span ng-bind=item.title></span></virtual-item-content></virtual-select><md-input-container class=md-block><label><md-translate key=::history.translate_key shortcode=\"\'history_changes_trackers.edit.form.date\'\"></md-translate></label><mod-datepicker ng-model=history.history_item.date name=date md-mode=day md-min-date=trackerCtrl.minSelectDate format=\"\'DD.MM.YYYY\'\" model-format=\"\'DD.MM.YYYY\'\" errors=history.errors></mod-datepicker></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" ng-click=history.save_history()><md-translate key=::history.translate_key shortcode=\"\'history_changes_trackers.edit.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=history.back()><md-translate key=::history.translate_key shortcode=\"\'history_changes_trackers.edit.back\'\"></md-translate></md-button></div></div></md-card></div>");
$templateCache.put("app/admin/partners/settings/trackers/partials/history_changes_view.html","<history-changes history-changes=settingsCtrl.tabs.activeTab.data.historyList options-change=settingsCtrl.tabs.activeTab.data.optionsChange></history-changes>");
$templateCache.put("app/admin/partners/settings/trackers/partials/pagination.html","<table-list-pagination table=settingsCtrl.tabs.activeTab.table ng-if=settingsCtrl.tabs.activeTab.table></table-list-pagination>");
$templateCache.put("app/admin/partners/settings/trackers/partials/search.html","<table-list-search table=settingsCtrl.tabs.activeTab.table ng-if=settingsCtrl.tabs.activeTab.table></table-list-search>");
$templateCache.put("app/admin/partners/settings/trackers/partials/table.html","<md-button class=\"md-button md-primary btn-primary\" ng-click=table.config.buttons.methods.editCondition(item)><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'settings_trackers.edit_tracker_condition\'\"></md-translate></md-button><md-button class=md-icon-button ng-click=\"table.config.buttons.methods.editDescription(item, $event)\"><i class=\"fa fa-pencil-square-o\"></i></md-button>");
$templateCache.put("app/admin/partners/settings/trackers/partials/tracker_settings.html","<ui-view><div class=view-content><md-card class=primary-card><div layout=row layout-align=\"space-between center\" class=card-header><div class=card-title><md-translate key=::trackerCtrl.translate_key shortcode=\"\'tracker_settings.header\'\"></md-translate></div></div><md-card-content class=padding-content><div row-restrict max-width=450px ng-if=trackerCtrl.editPermit><form name=trackerCtrl.editTrackerForm><virtual-select list=trackerCtrl.conditions.all_condition ng-model=trackerCtrl.current_tracker.condition_id ng-required=true save-prop=id show-prop=title errors=trackerCtrl.errors name=condition_id options=\"{prop_for_value: \'title\'}\" ng-change=trackerCtrl.change(trackerCtrl.current_tracker)><label><md-translate key=\"\'AdminPartners\'\" shortcode=\"\'settings_trackers.form.condition\'\"></md-translate></label><virtual-item-content><span ng-bind=item.title></span></virtual-item-content></virtual-select><md-input-container class=md-block><label><md-translate key=::trackerCtrl.translate_key shortcode=\"\'settings_trackers.form.date\'\"></md-translate></label><mod-datepicker ng-model=trackerCtrl.current_tracker.date is-required=true name=date md-mode=day md-min-date=trackerCtrl.minSelectDate format=\"\'DD.MM.YYYY\'\" model-format=\"\'DD.MM.YYYY\'\" errors=trackerCtrl.errors></mod-datepicker></md-input-container></form></div></md-card-content><div class=card-footer><div class=button-holder><md-button class=\"md-raised md-primary btn-primary\" md-click=trackerCtrl.saveTracker() ng-if=trackerCtrl.editPermit><md-translate key=::trackerCtrl.translate_key shortcode=\"\'tracker_settings.save\'\"></md-translate></md-button><md-button class=btn-transparent ng-click=trackerCtrl.back()><md-translate key=::trackerCtrl.translate_key shortcode=\"\'tracker_settings.back\'\"></md-translate></md-button></div></div></md-card><history-changes history-changes=trackerCtrl.current_tracker.history_of_trackers_changes options-change=trackerCtrl.optionsChange></history-changes></div></ui-view>");
$templateCache.put("app/admin/partners/settings/trackers/partials/trackers_list.html","<div class=crutch><table-list table=trackersList.table></table-list></div>");}]);